/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.TCBReceiptApi = (function() {

    /**
     * Namespace TCBReceiptApi.
     * @exports TCBReceiptApi
     * @namespace
     */
    var TCBReceiptApi = {};

    TCBReceiptApi.Protobuf = (function() {

        /**
         * Namespace Protobuf.
         * @memberof TCBReceiptApi
         * @namespace
         */
        var Protobuf = {};

        Protobuf.Link = (function() {

            /**
             * Properties of a Link.
             * @memberof TCBReceiptApi.Protobuf
             * @interface ILink
             * @property {string|null} [name] Link name
             * @property {string|null} [src] Link src
             */

            /**
             * Constructs a new Link.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a Link.
             * @implements ILink
             * @constructor
             * @param {TCBReceiptApi.Protobuf.ILink=} [properties] Properties to set
             */
            function Link(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Link name.
             * @member {string} name
             * @memberof TCBReceiptApi.Protobuf.Link
             * @instance
             */
            Link.prototype.name = "";

            /**
             * Link src.
             * @member {string} src
             * @memberof TCBReceiptApi.Protobuf.Link
             * @instance
             */
            Link.prototype.src = "";

            /**
             * Creates a new Link instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.Link
             * @static
             * @param {TCBReceiptApi.Protobuf.ILink=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.Link} Link instance
             */
            Link.create = function create(properties) {
                return new Link(properties);
            };

            /**
             * Encodes the specified Link message. Does not implicitly {@link TCBReceiptApi.Protobuf.Link.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.Link
             * @static
             * @param {TCBReceiptApi.Protobuf.ILink} message Link message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Link.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                if (message.src != null && Object.hasOwnProperty.call(message, "src"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.src);
                return writer;
            };

            /**
             * Encodes the specified Link message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.Link.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.Link
             * @static
             * @param {TCBReceiptApi.Protobuf.ILink} message Link message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Link.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Link message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.Link
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.Link} Link
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Link.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.Link();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        message.src = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Link message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.Link
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.Link} Link
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Link.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Link message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.Link
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Link.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.src != null && message.hasOwnProperty("src"))
                    if (!$util.isString(message.src))
                        return "src: string expected";
                return null;
            };

            /**
             * Creates a Link message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.Link
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.Link} Link
             */
            Link.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.Link)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.Link();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.src != null)
                    message.src = String(object.src);
                return message;
            };

            /**
             * Creates a plain object from a Link message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.Link
             * @static
             * @param {TCBReceiptApi.Protobuf.Link} message Link
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Link.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.name = "";
                    object.src = "";
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.src != null && message.hasOwnProperty("src"))
                    object.src = message.src;
                return object;
            };

            /**
             * Converts this Link to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.Link
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Link.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Link;
        })();

        Protobuf.Attachment = (function() {

            /**
             * Properties of an Attachment.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAttachment
             * @property {number|null} [type] Attachment type
             * @property {string|null} [src] Attachment src
             * @property {string|null} [originName] Attachment originName
             * @property {string|null} [name] Attachment name
             * @property {Uint8Array|null} [file] Attachment file
             */

            /**
             * Constructs a new Attachment.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an Attachment.
             * @implements IAttachment
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAttachment=} [properties] Properties to set
             */
            function Attachment(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Attachment type.
             * @member {number} type
             * @memberof TCBReceiptApi.Protobuf.Attachment
             * @instance
             */
            Attachment.prototype.type = 0;

            /**
             * Attachment src.
             * @member {string} src
             * @memberof TCBReceiptApi.Protobuf.Attachment
             * @instance
             */
            Attachment.prototype.src = "";

            /**
             * Attachment originName.
             * @member {string} originName
             * @memberof TCBReceiptApi.Protobuf.Attachment
             * @instance
             */
            Attachment.prototype.originName = "";

            /**
             * Attachment name.
             * @member {string} name
             * @memberof TCBReceiptApi.Protobuf.Attachment
             * @instance
             */
            Attachment.prototype.name = "";

            /**
             * Attachment file.
             * @member {Uint8Array} file
             * @memberof TCBReceiptApi.Protobuf.Attachment
             * @instance
             */
            Attachment.prototype.file = $util.newBuffer([]);

            /**
             * Creates a new Attachment instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.Attachment
             * @static
             * @param {TCBReceiptApi.Protobuf.IAttachment=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.Attachment} Attachment instance
             */
            Attachment.create = function create(properties) {
                return new Attachment(properties);
            };

            /**
             * Encodes the specified Attachment message. Does not implicitly {@link TCBReceiptApi.Protobuf.Attachment.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.Attachment
             * @static
             * @param {TCBReceiptApi.Protobuf.IAttachment} message Attachment message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Attachment.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
                if (message.src != null && Object.hasOwnProperty.call(message, "src"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.src);
                if (message.originName != null && Object.hasOwnProperty.call(message, "originName"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.originName);
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.name);
                if (message.file != null && Object.hasOwnProperty.call(message, "file"))
                    writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.file);
                return writer;
            };

            /**
             * Encodes the specified Attachment message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.Attachment.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.Attachment
             * @static
             * @param {TCBReceiptApi.Protobuf.IAttachment} message Attachment message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Attachment.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Attachment message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.Attachment
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.Attachment} Attachment
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Attachment.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.Attachment();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.type = reader.int32();
                        break;
                    case 2:
                        message.src = reader.string();
                        break;
                    case 3:
                        message.originName = reader.string();
                        break;
                    case 4:
                        message.name = reader.string();
                        break;
                    case 5:
                        message.file = reader.bytes();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Attachment message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.Attachment
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.Attachment} Attachment
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Attachment.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Attachment message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.Attachment
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Attachment.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isInteger(message.type))
                        return "type: integer expected";
                if (message.src != null && message.hasOwnProperty("src"))
                    if (!$util.isString(message.src))
                        return "src: string expected";
                if (message.originName != null && message.hasOwnProperty("originName"))
                    if (!$util.isString(message.originName))
                        return "originName: string expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.file != null && message.hasOwnProperty("file"))
                    if (!(message.file && typeof message.file.length === "number" || $util.isString(message.file)))
                        return "file: buffer expected";
                return null;
            };

            /**
             * Creates an Attachment message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.Attachment
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.Attachment} Attachment
             */
            Attachment.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.Attachment)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.Attachment();
                if (object.type != null)
                    message.type = object.type | 0;
                if (object.src != null)
                    message.src = String(object.src);
                if (object.originName != null)
                    message.originName = String(object.originName);
                if (object.name != null)
                    message.name = String(object.name);
                if (object.file != null)
                    if (typeof object.file === "string")
                        $util.base64.decode(object.file, message.file = $util.newBuffer($util.base64.length(object.file)), 0);
                    else if (object.file.length)
                        message.file = object.file;
                return message;
            };

            /**
             * Creates a plain object from an Attachment message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.Attachment
             * @static
             * @param {TCBReceiptApi.Protobuf.Attachment} message Attachment
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Attachment.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.type = 0;
                    object.src = "";
                    object.originName = "";
                    object.name = "";
                    if (options.bytes === String)
                        object.file = "";
                    else {
                        object.file = [];
                        if (options.bytes !== Array)
                            object.file = $util.newBuffer(object.file);
                    }
                }
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.src != null && message.hasOwnProperty("src"))
                    object.src = message.src;
                if (message.originName != null && message.hasOwnProperty("originName"))
                    object.originName = message.originName;
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.file != null && message.hasOwnProperty("file"))
                    object.file = options.bytes === String ? $util.base64.encode(message.file, 0, message.file.length) : options.bytes === Array ? Array.prototype.slice.call(message.file) : message.file;
                return object;
            };

            /**
             * Converts this Attachment to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.Attachment
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Attachment.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Attachment;
        })();

        Protobuf.AttachmentMotify = (function() {

            /**
             * Properties of an AttachmentMotify.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAttachmentMotify
             * @property {Array.<TCBReceiptApi.Protobuf.IAttachment>|null} [add] AttachmentMotify add
             * @property {Array.<TCBReceiptApi.Protobuf.IAttachment>|null} ["delete"] AttachmentMotify delete
             */

            /**
             * Constructs a new AttachmentMotify.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AttachmentMotify.
             * @implements IAttachmentMotify
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAttachmentMotify=} [properties] Properties to set
             */
            function AttachmentMotify(properties) {
                this.add = [];
                this["delete"] = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AttachmentMotify add.
             * @member {Array.<TCBReceiptApi.Protobuf.IAttachment>} add
             * @memberof TCBReceiptApi.Protobuf.AttachmentMotify
             * @instance
             */
            AttachmentMotify.prototype.add = $util.emptyArray;

            /**
             * AttachmentMotify delete.
             * @member {Array.<TCBReceiptApi.Protobuf.IAttachment>} delete
             * @memberof TCBReceiptApi.Protobuf.AttachmentMotify
             * @instance
             */
            AttachmentMotify.prototype["delete"] = $util.emptyArray;

            /**
             * Creates a new AttachmentMotify instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AttachmentMotify
             * @static
             * @param {TCBReceiptApi.Protobuf.IAttachmentMotify=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AttachmentMotify} AttachmentMotify instance
             */
            AttachmentMotify.create = function create(properties) {
                return new AttachmentMotify(properties);
            };

            /**
             * Encodes the specified AttachmentMotify message. Does not implicitly {@link TCBReceiptApi.Protobuf.AttachmentMotify.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AttachmentMotify
             * @static
             * @param {TCBReceiptApi.Protobuf.IAttachmentMotify} message AttachmentMotify message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AttachmentMotify.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.add != null && message.add.length)
                    for (var i = 0; i < message.add.length; ++i)
                        $root.TCBReceiptApi.Protobuf.Attachment.encode(message.add[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message["delete"] != null && message["delete"].length)
                    for (var i = 0; i < message["delete"].length; ++i)
                        $root.TCBReceiptApi.Protobuf.Attachment.encode(message["delete"][i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified AttachmentMotify message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AttachmentMotify.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AttachmentMotify
             * @static
             * @param {TCBReceiptApi.Protobuf.IAttachmentMotify} message AttachmentMotify message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AttachmentMotify.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AttachmentMotify message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AttachmentMotify
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AttachmentMotify} AttachmentMotify
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AttachmentMotify.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AttachmentMotify();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.add && message.add.length))
                            message.add = [];
                        message.add.push($root.TCBReceiptApi.Protobuf.Attachment.decode(reader, reader.uint32()));
                        break;
                    case 2:
                        if (!(message["delete"] && message["delete"].length))
                            message["delete"] = [];
                        message["delete"].push($root.TCBReceiptApi.Protobuf.Attachment.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AttachmentMotify message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AttachmentMotify
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AttachmentMotify} AttachmentMotify
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AttachmentMotify.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AttachmentMotify message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AttachmentMotify
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AttachmentMotify.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.add != null && message.hasOwnProperty("add")) {
                    if (!Array.isArray(message.add))
                        return "add: array expected";
                    for (var i = 0; i < message.add.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.Attachment.verify(message.add[i]);
                        if (error)
                            return "add." + error;
                    }
                }
                if (message["delete"] != null && message.hasOwnProperty("delete")) {
                    if (!Array.isArray(message["delete"]))
                        return "delete: array expected";
                    for (var i = 0; i < message["delete"].length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.Attachment.verify(message["delete"][i]);
                        if (error)
                            return "delete." + error;
                    }
                }
                return null;
            };

            /**
             * Creates an AttachmentMotify message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AttachmentMotify
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AttachmentMotify} AttachmentMotify
             */
            AttachmentMotify.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AttachmentMotify)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AttachmentMotify();
                if (object.add) {
                    if (!Array.isArray(object.add))
                        throw TypeError(".TCBReceiptApi.Protobuf.AttachmentMotify.add: array expected");
                    message.add = [];
                    for (var i = 0; i < object.add.length; ++i) {
                        if (typeof object.add[i] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.AttachmentMotify.add: object expected");
                        message.add[i] = $root.TCBReceiptApi.Protobuf.Attachment.fromObject(object.add[i]);
                    }
                }
                if (object["delete"]) {
                    if (!Array.isArray(object["delete"]))
                        throw TypeError(".TCBReceiptApi.Protobuf.AttachmentMotify.delete: array expected");
                    message["delete"] = [];
                    for (var i = 0; i < object["delete"].length; ++i) {
                        if (typeof object["delete"][i] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.AttachmentMotify.delete: object expected");
                        message["delete"][i] = $root.TCBReceiptApi.Protobuf.Attachment.fromObject(object["delete"][i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from an AttachmentMotify message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AttachmentMotify
             * @static
             * @param {TCBReceiptApi.Protobuf.AttachmentMotify} message AttachmentMotify
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AttachmentMotify.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults) {
                    object.add = [];
                    object["delete"] = [];
                }
                if (message.add && message.add.length) {
                    object.add = [];
                    for (var j = 0; j < message.add.length; ++j)
                        object.add[j] = $root.TCBReceiptApi.Protobuf.Attachment.toObject(message.add[j], options);
                }
                if (message["delete"] && message["delete"].length) {
                    object["delete"] = [];
                    for (var j = 0; j < message["delete"].length; ++j)
                        object["delete"][j] = $root.TCBReceiptApi.Protobuf.Attachment.toObject(message["delete"][j], options);
                }
                return object;
            };

            /**
             * Converts this AttachmentMotify to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AttachmentMotify
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AttachmentMotify.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AttachmentMotify;
        })();

        Protobuf.AnnouncementMotify = (function() {

            /**
             * Properties of an AnnouncementMotify.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAnnouncementMotify
             * @property {number|null} [date] AnnouncementMotify date
             * @property {number|null} [name] AnnouncementMotify name
             * @property {number|null} [target] AnnouncementMotify target
             * @property {number|null} [content] AnnouncementMotify content
             * @property {number|null} [linkList] AnnouncementMotify linkList
             * @property {number|null} [attachmentList] AnnouncementMotify attachmentList
             * @property {number|null} [state] AnnouncementMotify state
             */

            /**
             * Constructs a new AnnouncementMotify.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AnnouncementMotify.
             * @implements IAnnouncementMotify
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAnnouncementMotify=} [properties] Properties to set
             */
            function AnnouncementMotify(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AnnouncementMotify date.
             * @member {number} date
             * @memberof TCBReceiptApi.Protobuf.AnnouncementMotify
             * @instance
             */
            AnnouncementMotify.prototype.date = 0;

            /**
             * AnnouncementMotify name.
             * @member {number} name
             * @memberof TCBReceiptApi.Protobuf.AnnouncementMotify
             * @instance
             */
            AnnouncementMotify.prototype.name = 0;

            /**
             * AnnouncementMotify target.
             * @member {number} target
             * @memberof TCBReceiptApi.Protobuf.AnnouncementMotify
             * @instance
             */
            AnnouncementMotify.prototype.target = 0;

            /**
             * AnnouncementMotify content.
             * @member {number} content
             * @memberof TCBReceiptApi.Protobuf.AnnouncementMotify
             * @instance
             */
            AnnouncementMotify.prototype.content = 0;

            /**
             * AnnouncementMotify linkList.
             * @member {number} linkList
             * @memberof TCBReceiptApi.Protobuf.AnnouncementMotify
             * @instance
             */
            AnnouncementMotify.prototype.linkList = 0;

            /**
             * AnnouncementMotify attachmentList.
             * @member {number} attachmentList
             * @memberof TCBReceiptApi.Protobuf.AnnouncementMotify
             * @instance
             */
            AnnouncementMotify.prototype.attachmentList = 0;

            /**
             * AnnouncementMotify state.
             * @member {number} state
             * @memberof TCBReceiptApi.Protobuf.AnnouncementMotify
             * @instance
             */
            AnnouncementMotify.prototype.state = 0;

            /**
             * Creates a new AnnouncementMotify instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AnnouncementMotify
             * @static
             * @param {TCBReceiptApi.Protobuf.IAnnouncementMotify=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AnnouncementMotify} AnnouncementMotify instance
             */
            AnnouncementMotify.create = function create(properties) {
                return new AnnouncementMotify(properties);
            };

            /**
             * Encodes the specified AnnouncementMotify message. Does not implicitly {@link TCBReceiptApi.Protobuf.AnnouncementMotify.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AnnouncementMotify
             * @static
             * @param {TCBReceiptApi.Protobuf.IAnnouncementMotify} message AnnouncementMotify message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AnnouncementMotify.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.date);
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.name);
                if (message.target != null && Object.hasOwnProperty.call(message, "target"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.target);
                if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.content);
                if (message.linkList != null && Object.hasOwnProperty.call(message, "linkList"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int32(message.linkList);
                if (message.attachmentList != null && Object.hasOwnProperty.call(message, "attachmentList"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int32(message.attachmentList);
                if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                    writer.uint32(/* id 7, wireType 0 =*/56).int32(message.state);
                return writer;
            };

            /**
             * Encodes the specified AnnouncementMotify message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AnnouncementMotify.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AnnouncementMotify
             * @static
             * @param {TCBReceiptApi.Protobuf.IAnnouncementMotify} message AnnouncementMotify message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AnnouncementMotify.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AnnouncementMotify message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AnnouncementMotify
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AnnouncementMotify} AnnouncementMotify
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AnnouncementMotify.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AnnouncementMotify();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.date = reader.int32();
                        break;
                    case 2:
                        message.name = reader.int32();
                        break;
                    case 3:
                        message.target = reader.int32();
                        break;
                    case 4:
                        message.content = reader.int32();
                        break;
                    case 5:
                        message.linkList = reader.int32();
                        break;
                    case 6:
                        message.attachmentList = reader.int32();
                        break;
                    case 7:
                        message.state = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AnnouncementMotify message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AnnouncementMotify
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AnnouncementMotify} AnnouncementMotify
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AnnouncementMotify.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AnnouncementMotify message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AnnouncementMotify
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AnnouncementMotify.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.date != null && message.hasOwnProperty("date"))
                    if (!$util.isInteger(message.date))
                        return "date: integer expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isInteger(message.name))
                        return "name: integer expected";
                if (message.target != null && message.hasOwnProperty("target"))
                    if (!$util.isInteger(message.target))
                        return "target: integer expected";
                if (message.content != null && message.hasOwnProperty("content"))
                    if (!$util.isInteger(message.content))
                        return "content: integer expected";
                if (message.linkList != null && message.hasOwnProperty("linkList"))
                    if (!$util.isInteger(message.linkList))
                        return "linkList: integer expected";
                if (message.attachmentList != null && message.hasOwnProperty("attachmentList"))
                    if (!$util.isInteger(message.attachmentList))
                        return "attachmentList: integer expected";
                if (message.state != null && message.hasOwnProperty("state"))
                    if (!$util.isInteger(message.state))
                        return "state: integer expected";
                return null;
            };

            /**
             * Creates an AnnouncementMotify message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AnnouncementMotify
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AnnouncementMotify} AnnouncementMotify
             */
            AnnouncementMotify.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AnnouncementMotify)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AnnouncementMotify();
                if (object.date != null)
                    message.date = object.date | 0;
                if (object.name != null)
                    message.name = object.name | 0;
                if (object.target != null)
                    message.target = object.target | 0;
                if (object.content != null)
                    message.content = object.content | 0;
                if (object.linkList != null)
                    message.linkList = object.linkList | 0;
                if (object.attachmentList != null)
                    message.attachmentList = object.attachmentList | 0;
                if (object.state != null)
                    message.state = object.state | 0;
                return message;
            };

            /**
             * Creates a plain object from an AnnouncementMotify message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AnnouncementMotify
             * @static
             * @param {TCBReceiptApi.Protobuf.AnnouncementMotify} message AnnouncementMotify
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AnnouncementMotify.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.date = 0;
                    object.name = 0;
                    object.target = 0;
                    object.content = 0;
                    object.linkList = 0;
                    object.attachmentList = 0;
                    object.state = 0;
                }
                if (message.date != null && message.hasOwnProperty("date"))
                    object.date = message.date;
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.target != null && message.hasOwnProperty("target"))
                    object.target = message.target;
                if (message.content != null && message.hasOwnProperty("content"))
                    object.content = message.content;
                if (message.linkList != null && message.hasOwnProperty("linkList"))
                    object.linkList = message.linkList;
                if (message.attachmentList != null && message.hasOwnProperty("attachmentList"))
                    object.attachmentList = message.attachmentList;
                if (message.state != null && message.hasOwnProperty("state"))
                    object.state = message.state;
                return object;
            };

            /**
             * Converts this AnnouncementMotify to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AnnouncementMotify
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AnnouncementMotify.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AnnouncementMotify;
        })();

        Protobuf.Announcement = (function() {

            /**
             * Properties of an Announcement.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAnnouncement
             * @property {number|null} [announcementTempId] Announcement announcementTempId
             * @property {number|null} [announcementId] Announcement announcementId
             * @property {number|null} [actionType] Announcement actionType
             * @property {string|null} [date] Announcement date
             * @property {string|null} [name] Announcement name
             * @property {number|null} [target] Announcement target
             * @property {string|null} [content] Announcement content
             * @property {Array.<TCBReceiptApi.Protobuf.ILink>|null} [linkList] Announcement linkList
             * @property {Array.<TCBReceiptApi.Protobuf.IAttachment>|null} [attachmentList] Announcement attachmentList
             * @property {number|null} [lastUpdateTime] Announcement lastUpdateTime
             * @property {string|null} [lastUpdateUser] Announcement lastUpdateUser
             * @property {number|null} [releaseState] Announcement releaseState
             * @property {number|null} [state] Announcement state
             * @property {string|null} [startDate] Announcement startDate
             * @property {string|null} [endDate] Announcement endDate
             * @property {string|null} [rejectReason] Announcement rejectReason
             * @property {TCBReceiptApi.Protobuf.IAttachmentMotify|null} [attachmentMotify] Announcement attachmentMotify
             * @property {TCBReceiptApi.Protobuf.IAnnouncementMotify|null} [motify] Announcement motify
             */

            /**
             * Constructs a new Announcement.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an Announcement.
             * @implements IAnnouncement
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAnnouncement=} [properties] Properties to set
             */
            function Announcement(properties) {
                this.linkList = [];
                this.attachmentList = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Announcement announcementTempId.
             * @member {number} announcementTempId
             * @memberof TCBReceiptApi.Protobuf.Announcement
             * @instance
             */
            Announcement.prototype.announcementTempId = 0;

            /**
             * Announcement announcementId.
             * @member {number} announcementId
             * @memberof TCBReceiptApi.Protobuf.Announcement
             * @instance
             */
            Announcement.prototype.announcementId = 0;

            /**
             * Announcement actionType.
             * @member {number} actionType
             * @memberof TCBReceiptApi.Protobuf.Announcement
             * @instance
             */
            Announcement.prototype.actionType = 0;

            /**
             * Announcement date.
             * @member {string} date
             * @memberof TCBReceiptApi.Protobuf.Announcement
             * @instance
             */
            Announcement.prototype.date = "";

            /**
             * Announcement name.
             * @member {string} name
             * @memberof TCBReceiptApi.Protobuf.Announcement
             * @instance
             */
            Announcement.prototype.name = "";

            /**
             * Announcement target.
             * @member {number} target
             * @memberof TCBReceiptApi.Protobuf.Announcement
             * @instance
             */
            Announcement.prototype.target = 0;

            /**
             * Announcement content.
             * @member {string} content
             * @memberof TCBReceiptApi.Protobuf.Announcement
             * @instance
             */
            Announcement.prototype.content = "";

            /**
             * Announcement linkList.
             * @member {Array.<TCBReceiptApi.Protobuf.ILink>} linkList
             * @memberof TCBReceiptApi.Protobuf.Announcement
             * @instance
             */
            Announcement.prototype.linkList = $util.emptyArray;

            /**
             * Announcement attachmentList.
             * @member {Array.<TCBReceiptApi.Protobuf.IAttachment>} attachmentList
             * @memberof TCBReceiptApi.Protobuf.Announcement
             * @instance
             */
            Announcement.prototype.attachmentList = $util.emptyArray;

            /**
             * Announcement lastUpdateTime.
             * @member {number} lastUpdateTime
             * @memberof TCBReceiptApi.Protobuf.Announcement
             * @instance
             */
            Announcement.prototype.lastUpdateTime = 0;

            /**
             * Announcement lastUpdateUser.
             * @member {string} lastUpdateUser
             * @memberof TCBReceiptApi.Protobuf.Announcement
             * @instance
             */
            Announcement.prototype.lastUpdateUser = "";

            /**
             * Announcement releaseState.
             * @member {number} releaseState
             * @memberof TCBReceiptApi.Protobuf.Announcement
             * @instance
             */
            Announcement.prototype.releaseState = 0;

            /**
             * Announcement state.
             * @member {number} state
             * @memberof TCBReceiptApi.Protobuf.Announcement
             * @instance
             */
            Announcement.prototype.state = 0;

            /**
             * Announcement startDate.
             * @member {string} startDate
             * @memberof TCBReceiptApi.Protobuf.Announcement
             * @instance
             */
            Announcement.prototype.startDate = "";

            /**
             * Announcement endDate.
             * @member {string} endDate
             * @memberof TCBReceiptApi.Protobuf.Announcement
             * @instance
             */
            Announcement.prototype.endDate = "";

            /**
             * Announcement rejectReason.
             * @member {string} rejectReason
             * @memberof TCBReceiptApi.Protobuf.Announcement
             * @instance
             */
            Announcement.prototype.rejectReason = "";

            /**
             * Announcement attachmentMotify.
             * @member {TCBReceiptApi.Protobuf.IAttachmentMotify|null|undefined} attachmentMotify
             * @memberof TCBReceiptApi.Protobuf.Announcement
             * @instance
             */
            Announcement.prototype.attachmentMotify = null;

            /**
             * Announcement motify.
             * @member {TCBReceiptApi.Protobuf.IAnnouncementMotify|null|undefined} motify
             * @memberof TCBReceiptApi.Protobuf.Announcement
             * @instance
             */
            Announcement.prototype.motify = null;

            /**
             * Creates a new Announcement instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.Announcement
             * @static
             * @param {TCBReceiptApi.Protobuf.IAnnouncement=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.Announcement} Announcement instance
             */
            Announcement.create = function create(properties) {
                return new Announcement(properties);
            };

            /**
             * Encodes the specified Announcement message. Does not implicitly {@link TCBReceiptApi.Protobuf.Announcement.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.Announcement
             * @static
             * @param {TCBReceiptApi.Protobuf.IAnnouncement} message Announcement message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Announcement.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.announcementTempId != null && Object.hasOwnProperty.call(message, "announcementTempId"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.announcementTempId);
                if (message.announcementId != null && Object.hasOwnProperty.call(message, "announcementId"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.announcementId);
                if (message.actionType != null && Object.hasOwnProperty.call(message, "actionType"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.actionType);
                if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.date);
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.name);
                if (message.target != null && Object.hasOwnProperty.call(message, "target"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int32(message.target);
                if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.content);
                if (message.linkList != null && message.linkList.length)
                    for (var i = 0; i < message.linkList.length; ++i)
                        $root.TCBReceiptApi.Protobuf.Link.encode(message.linkList[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                if (message.attachmentList != null && message.attachmentList.length)
                    for (var i = 0; i < message.attachmentList.length; ++i)
                        $root.TCBReceiptApi.Protobuf.Attachment.encode(message.attachmentList[i], writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    writer.uint32(/* id 10, wireType 0 =*/80).int32(message.lastUpdateTime);
                if (message.lastUpdateUser != null && Object.hasOwnProperty.call(message, "lastUpdateUser"))
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.lastUpdateUser);
                if (message.releaseState != null && Object.hasOwnProperty.call(message, "releaseState"))
                    writer.uint32(/* id 12, wireType 0 =*/96).int32(message.releaseState);
                if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                    writer.uint32(/* id 13, wireType 0 =*/104).int32(message.state);
                if (message.startDate != null && Object.hasOwnProperty.call(message, "startDate"))
                    writer.uint32(/* id 14, wireType 2 =*/114).string(message.startDate);
                if (message.endDate != null && Object.hasOwnProperty.call(message, "endDate"))
                    writer.uint32(/* id 15, wireType 2 =*/122).string(message.endDate);
                if (message.rejectReason != null && Object.hasOwnProperty.call(message, "rejectReason"))
                    writer.uint32(/* id 16, wireType 2 =*/130).string(message.rejectReason);
                if (message.attachmentMotify != null && Object.hasOwnProperty.call(message, "attachmentMotify"))
                    $root.TCBReceiptApi.Protobuf.AttachmentMotify.encode(message.attachmentMotify, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                if (message.motify != null && Object.hasOwnProperty.call(message, "motify"))
                    $root.TCBReceiptApi.Protobuf.AnnouncementMotify.encode(message.motify, writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Announcement message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.Announcement.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.Announcement
             * @static
             * @param {TCBReceiptApi.Protobuf.IAnnouncement} message Announcement message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Announcement.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Announcement message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.Announcement
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.Announcement} Announcement
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Announcement.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.Announcement();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.announcementTempId = reader.int32();
                        break;
                    case 2:
                        message.announcementId = reader.int32();
                        break;
                    case 3:
                        message.actionType = reader.int32();
                        break;
                    case 4:
                        message.date = reader.string();
                        break;
                    case 5:
                        message.name = reader.string();
                        break;
                    case 6:
                        message.target = reader.int32();
                        break;
                    case 7:
                        message.content = reader.string();
                        break;
                    case 8:
                        if (!(message.linkList && message.linkList.length))
                            message.linkList = [];
                        message.linkList.push($root.TCBReceiptApi.Protobuf.Link.decode(reader, reader.uint32()));
                        break;
                    case 9:
                        if (!(message.attachmentList && message.attachmentList.length))
                            message.attachmentList = [];
                        message.attachmentList.push($root.TCBReceiptApi.Protobuf.Attachment.decode(reader, reader.uint32()));
                        break;
                    case 10:
                        message.lastUpdateTime = reader.int32();
                        break;
                    case 11:
                        message.lastUpdateUser = reader.string();
                        break;
                    case 12:
                        message.releaseState = reader.int32();
                        break;
                    case 13:
                        message.state = reader.int32();
                        break;
                    case 14:
                        message.startDate = reader.string();
                        break;
                    case 15:
                        message.endDate = reader.string();
                        break;
                    case 16:
                        message.rejectReason = reader.string();
                        break;
                    case 17:
                        message.attachmentMotify = $root.TCBReceiptApi.Protobuf.AttachmentMotify.decode(reader, reader.uint32());
                        break;
                    case 18:
                        message.motify = $root.TCBReceiptApi.Protobuf.AnnouncementMotify.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Announcement message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.Announcement
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.Announcement} Announcement
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Announcement.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Announcement message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.Announcement
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Announcement.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.announcementTempId != null && message.hasOwnProperty("announcementTempId"))
                    if (!$util.isInteger(message.announcementTempId))
                        return "announcementTempId: integer expected";
                if (message.announcementId != null && message.hasOwnProperty("announcementId"))
                    if (!$util.isInteger(message.announcementId))
                        return "announcementId: integer expected";
                if (message.actionType != null && message.hasOwnProperty("actionType"))
                    if (!$util.isInteger(message.actionType))
                        return "actionType: integer expected";
                if (message.date != null && message.hasOwnProperty("date"))
                    if (!$util.isString(message.date))
                        return "date: string expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.target != null && message.hasOwnProperty("target"))
                    if (!$util.isInteger(message.target))
                        return "target: integer expected";
                if (message.content != null && message.hasOwnProperty("content"))
                    if (!$util.isString(message.content))
                        return "content: string expected";
                if (message.linkList != null && message.hasOwnProperty("linkList")) {
                    if (!Array.isArray(message.linkList))
                        return "linkList: array expected";
                    for (var i = 0; i < message.linkList.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.Link.verify(message.linkList[i]);
                        if (error)
                            return "linkList." + error;
                    }
                }
                if (message.attachmentList != null && message.hasOwnProperty("attachmentList")) {
                    if (!Array.isArray(message.attachmentList))
                        return "attachmentList: array expected";
                    for (var i = 0; i < message.attachmentList.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.Attachment.verify(message.attachmentList[i]);
                        if (error)
                            return "attachmentList." + error;
                    }
                }
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    if (!$util.isInteger(message.lastUpdateTime))
                        return "lastUpdateTime: integer expected";
                if (message.lastUpdateUser != null && message.hasOwnProperty("lastUpdateUser"))
                    if (!$util.isString(message.lastUpdateUser))
                        return "lastUpdateUser: string expected";
                if (message.releaseState != null && message.hasOwnProperty("releaseState"))
                    if (!$util.isInteger(message.releaseState))
                        return "releaseState: integer expected";
                if (message.state != null && message.hasOwnProperty("state"))
                    if (!$util.isInteger(message.state))
                        return "state: integer expected";
                if (message.startDate != null && message.hasOwnProperty("startDate"))
                    if (!$util.isString(message.startDate))
                        return "startDate: string expected";
                if (message.endDate != null && message.hasOwnProperty("endDate"))
                    if (!$util.isString(message.endDate))
                        return "endDate: string expected";
                if (message.rejectReason != null && message.hasOwnProperty("rejectReason"))
                    if (!$util.isString(message.rejectReason))
                        return "rejectReason: string expected";
                if (message.attachmentMotify != null && message.hasOwnProperty("attachmentMotify")) {
                    var error = $root.TCBReceiptApi.Protobuf.AttachmentMotify.verify(message.attachmentMotify);
                    if (error)
                        return "attachmentMotify." + error;
                }
                if (message.motify != null && message.hasOwnProperty("motify")) {
                    var error = $root.TCBReceiptApi.Protobuf.AnnouncementMotify.verify(message.motify);
                    if (error)
                        return "motify." + error;
                }
                return null;
            };

            /**
             * Creates an Announcement message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.Announcement
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.Announcement} Announcement
             */
            Announcement.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.Announcement)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.Announcement();
                if (object.announcementTempId != null)
                    message.announcementTempId = object.announcementTempId | 0;
                if (object.announcementId != null)
                    message.announcementId = object.announcementId | 0;
                if (object.actionType != null)
                    message.actionType = object.actionType | 0;
                if (object.date != null)
                    message.date = String(object.date);
                if (object.name != null)
                    message.name = String(object.name);
                if (object.target != null)
                    message.target = object.target | 0;
                if (object.content != null)
                    message.content = String(object.content);
                if (object.linkList) {
                    if (!Array.isArray(object.linkList))
                        throw TypeError(".TCBReceiptApi.Protobuf.Announcement.linkList: array expected");
                    message.linkList = [];
                    for (var i = 0; i < object.linkList.length; ++i) {
                        if (typeof object.linkList[i] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.Announcement.linkList: object expected");
                        message.linkList[i] = $root.TCBReceiptApi.Protobuf.Link.fromObject(object.linkList[i]);
                    }
                }
                if (object.attachmentList) {
                    if (!Array.isArray(object.attachmentList))
                        throw TypeError(".TCBReceiptApi.Protobuf.Announcement.attachmentList: array expected");
                    message.attachmentList = [];
                    for (var i = 0; i < object.attachmentList.length; ++i) {
                        if (typeof object.attachmentList[i] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.Announcement.attachmentList: object expected");
                        message.attachmentList[i] = $root.TCBReceiptApi.Protobuf.Attachment.fromObject(object.attachmentList[i]);
                    }
                }
                if (object.lastUpdateTime != null)
                    message.lastUpdateTime = object.lastUpdateTime | 0;
                if (object.lastUpdateUser != null)
                    message.lastUpdateUser = String(object.lastUpdateUser);
                if (object.releaseState != null)
                    message.releaseState = object.releaseState | 0;
                if (object.state != null)
                    message.state = object.state | 0;
                if (object.startDate != null)
                    message.startDate = String(object.startDate);
                if (object.endDate != null)
                    message.endDate = String(object.endDate);
                if (object.rejectReason != null)
                    message.rejectReason = String(object.rejectReason);
                if (object.attachmentMotify != null) {
                    if (typeof object.attachmentMotify !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.Announcement.attachmentMotify: object expected");
                    message.attachmentMotify = $root.TCBReceiptApi.Protobuf.AttachmentMotify.fromObject(object.attachmentMotify);
                }
                if (object.motify != null) {
                    if (typeof object.motify !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.Announcement.motify: object expected");
                    message.motify = $root.TCBReceiptApi.Protobuf.AnnouncementMotify.fromObject(object.motify);
                }
                return message;
            };

            /**
             * Creates a plain object from an Announcement message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.Announcement
             * @static
             * @param {TCBReceiptApi.Protobuf.Announcement} message Announcement
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Announcement.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults) {
                    object.linkList = [];
                    object.attachmentList = [];
                }
                if (options.defaults) {
                    object.announcementTempId = 0;
                    object.announcementId = 0;
                    object.actionType = 0;
                    object.date = "";
                    object.name = "";
                    object.target = 0;
                    object.content = "";
                    object.lastUpdateTime = 0;
                    object.lastUpdateUser = "";
                    object.releaseState = 0;
                    object.state = 0;
                    object.startDate = "";
                    object.endDate = "";
                    object.rejectReason = "";
                    object.attachmentMotify = null;
                    object.motify = null;
                }
                if (message.announcementTempId != null && message.hasOwnProperty("announcementTempId"))
                    object.announcementTempId = message.announcementTempId;
                if (message.announcementId != null && message.hasOwnProperty("announcementId"))
                    object.announcementId = message.announcementId;
                if (message.actionType != null && message.hasOwnProperty("actionType"))
                    object.actionType = message.actionType;
                if (message.date != null && message.hasOwnProperty("date"))
                    object.date = message.date;
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.target != null && message.hasOwnProperty("target"))
                    object.target = message.target;
                if (message.content != null && message.hasOwnProperty("content"))
                    object.content = message.content;
                if (message.linkList && message.linkList.length) {
                    object.linkList = [];
                    for (var j = 0; j < message.linkList.length; ++j)
                        object.linkList[j] = $root.TCBReceiptApi.Protobuf.Link.toObject(message.linkList[j], options);
                }
                if (message.attachmentList && message.attachmentList.length) {
                    object.attachmentList = [];
                    for (var j = 0; j < message.attachmentList.length; ++j)
                        object.attachmentList[j] = $root.TCBReceiptApi.Protobuf.Attachment.toObject(message.attachmentList[j], options);
                }
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    object.lastUpdateTime = message.lastUpdateTime;
                if (message.lastUpdateUser != null && message.hasOwnProperty("lastUpdateUser"))
                    object.lastUpdateUser = message.lastUpdateUser;
                if (message.releaseState != null && message.hasOwnProperty("releaseState"))
                    object.releaseState = message.releaseState;
                if (message.state != null && message.hasOwnProperty("state"))
                    object.state = message.state;
                if (message.startDate != null && message.hasOwnProperty("startDate"))
                    object.startDate = message.startDate;
                if (message.endDate != null && message.hasOwnProperty("endDate"))
                    object.endDate = message.endDate;
                if (message.rejectReason != null && message.hasOwnProperty("rejectReason"))
                    object.rejectReason = message.rejectReason;
                if (message.attachmentMotify != null && message.hasOwnProperty("attachmentMotify"))
                    object.attachmentMotify = $root.TCBReceiptApi.Protobuf.AttachmentMotify.toObject(message.attachmentMotify, options);
                if (message.motify != null && message.hasOwnProperty("motify"))
                    object.motify = $root.TCBReceiptApi.Protobuf.AnnouncementMotify.toObject(message.motify, options);
                return object;
            };

            /**
             * Converts this Announcement to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.Announcement
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Announcement.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Announcement;
        })();

        Protobuf.AnnouncementList = (function() {

            /**
             * Properties of an AnnouncementList.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAnnouncementList
             * @property {Array.<TCBReceiptApi.Protobuf.IAnnouncement>|null} [list] AnnouncementList list
             * @property {number|null} [total] AnnouncementList total
             */

            /**
             * Constructs a new AnnouncementList.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AnnouncementList.
             * @implements IAnnouncementList
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAnnouncementList=} [properties] Properties to set
             */
            function AnnouncementList(properties) {
                this.list = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AnnouncementList list.
             * @member {Array.<TCBReceiptApi.Protobuf.IAnnouncement>} list
             * @memberof TCBReceiptApi.Protobuf.AnnouncementList
             * @instance
             */
            AnnouncementList.prototype.list = $util.emptyArray;

            /**
             * AnnouncementList total.
             * @member {number} total
             * @memberof TCBReceiptApi.Protobuf.AnnouncementList
             * @instance
             */
            AnnouncementList.prototype.total = 0;

            /**
             * Creates a new AnnouncementList instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AnnouncementList
             * @static
             * @param {TCBReceiptApi.Protobuf.IAnnouncementList=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AnnouncementList} AnnouncementList instance
             */
            AnnouncementList.create = function create(properties) {
                return new AnnouncementList(properties);
            };

            /**
             * Encodes the specified AnnouncementList message. Does not implicitly {@link TCBReceiptApi.Protobuf.AnnouncementList.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AnnouncementList
             * @static
             * @param {TCBReceiptApi.Protobuf.IAnnouncementList} message AnnouncementList message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AnnouncementList.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.list != null && message.list.length)
                    for (var i = 0; i < message.list.length; ++i)
                        $root.TCBReceiptApi.Protobuf.Announcement.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.total);
                return writer;
            };

            /**
             * Encodes the specified AnnouncementList message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AnnouncementList.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AnnouncementList
             * @static
             * @param {TCBReceiptApi.Protobuf.IAnnouncementList} message AnnouncementList message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AnnouncementList.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AnnouncementList message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AnnouncementList
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AnnouncementList} AnnouncementList
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AnnouncementList.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AnnouncementList();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.TCBReceiptApi.Protobuf.Announcement.decode(reader, reader.uint32()));
                        break;
                    case 2:
                        message.total = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AnnouncementList message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AnnouncementList
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AnnouncementList} AnnouncementList
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AnnouncementList.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AnnouncementList message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AnnouncementList
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AnnouncementList.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.list != null && message.hasOwnProperty("list")) {
                    if (!Array.isArray(message.list))
                        return "list: array expected";
                    for (var i = 0; i < message.list.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.Announcement.verify(message.list[i]);
                        if (error)
                            return "list." + error;
                    }
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    if (!$util.isInteger(message.total))
                        return "total: integer expected";
                return null;
            };

            /**
             * Creates an AnnouncementList message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AnnouncementList
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AnnouncementList} AnnouncementList
             */
            AnnouncementList.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AnnouncementList)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AnnouncementList();
                if (object.list) {
                    if (!Array.isArray(object.list))
                        throw TypeError(".TCBReceiptApi.Protobuf.AnnouncementList.list: array expected");
                    message.list = [];
                    for (var i = 0; i < object.list.length; ++i) {
                        if (typeof object.list[i] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.AnnouncementList.list: object expected");
                        message.list[i] = $root.TCBReceiptApi.Protobuf.Announcement.fromObject(object.list[i]);
                    }
                }
                if (object.total != null)
                    message.total = object.total | 0;
                return message;
            };

            /**
             * Creates a plain object from an AnnouncementList message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AnnouncementList
             * @static
             * @param {TCBReceiptApi.Protobuf.AnnouncementList} message AnnouncementList
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AnnouncementList.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.list = [];
                if (options.defaults)
                    object.total = 0;
                if (message.list && message.list.length) {
                    object.list = [];
                    for (var j = 0; j < message.list.length; ++j)
                        object.list[j] = $root.TCBReceiptApi.Protobuf.Announcement.toObject(message.list[j], options);
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    object.total = message.total;
                return object;
            };

            /**
             * Converts this AnnouncementList to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AnnouncementList
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AnnouncementList.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AnnouncementList;
        })();

        Protobuf.AnnouncementQuery = (function() {

            /**
             * Properties of an AnnouncementQuery.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAnnouncementQuery
             * @property {number|null} [releaseState] AnnouncementQuery releaseState
             * @property {number|null} [state] AnnouncementQuery state
             * @property {number|null} [target] AnnouncementQuery target
             * @property {string|null} [name] AnnouncementQuery name
             * @property {string|null} [dateStart] AnnouncementQuery dateStart
             * @property {string|null} [dateEnd] AnnouncementQuery dateEnd
             * @property {TCBReceiptApi.Protobuf.IPagination|null} [pagination] AnnouncementQuery pagination
             */

            /**
             * Constructs a new AnnouncementQuery.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AnnouncementQuery.
             * @implements IAnnouncementQuery
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAnnouncementQuery=} [properties] Properties to set
             */
            function AnnouncementQuery(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AnnouncementQuery releaseState.
             * @member {number} releaseState
             * @memberof TCBReceiptApi.Protobuf.AnnouncementQuery
             * @instance
             */
            AnnouncementQuery.prototype.releaseState = 0;

            /**
             * AnnouncementQuery state.
             * @member {number} state
             * @memberof TCBReceiptApi.Protobuf.AnnouncementQuery
             * @instance
             */
            AnnouncementQuery.prototype.state = 0;

            /**
             * AnnouncementQuery target.
             * @member {number} target
             * @memberof TCBReceiptApi.Protobuf.AnnouncementQuery
             * @instance
             */
            AnnouncementQuery.prototype.target = 0;

            /**
             * AnnouncementQuery name.
             * @member {string} name
             * @memberof TCBReceiptApi.Protobuf.AnnouncementQuery
             * @instance
             */
            AnnouncementQuery.prototype.name = "";

            /**
             * AnnouncementQuery dateStart.
             * @member {string} dateStart
             * @memberof TCBReceiptApi.Protobuf.AnnouncementQuery
             * @instance
             */
            AnnouncementQuery.prototype.dateStart = "";

            /**
             * AnnouncementQuery dateEnd.
             * @member {string} dateEnd
             * @memberof TCBReceiptApi.Protobuf.AnnouncementQuery
             * @instance
             */
            AnnouncementQuery.prototype.dateEnd = "";

            /**
             * AnnouncementQuery pagination.
             * @member {TCBReceiptApi.Protobuf.IPagination|null|undefined} pagination
             * @memberof TCBReceiptApi.Protobuf.AnnouncementQuery
             * @instance
             */
            AnnouncementQuery.prototype.pagination = null;

            /**
             * Creates a new AnnouncementQuery instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AnnouncementQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.IAnnouncementQuery=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AnnouncementQuery} AnnouncementQuery instance
             */
            AnnouncementQuery.create = function create(properties) {
                return new AnnouncementQuery(properties);
            };

            /**
             * Encodes the specified AnnouncementQuery message. Does not implicitly {@link TCBReceiptApi.Protobuf.AnnouncementQuery.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AnnouncementQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.IAnnouncementQuery} message AnnouncementQuery message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AnnouncementQuery.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.releaseState != null && Object.hasOwnProperty.call(message, "releaseState"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.releaseState);
                if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.state);
                if (message.target != null && Object.hasOwnProperty.call(message, "target"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.target);
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.name);
                if (message.dateStart != null && Object.hasOwnProperty.call(message, "dateStart"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.dateStart);
                if (message.dateEnd != null && Object.hasOwnProperty.call(message, "dateEnd"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.dateEnd);
                if (message.pagination != null && Object.hasOwnProperty.call(message, "pagination"))
                    $root.TCBReceiptApi.Protobuf.Pagination.encode(message.pagination, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified AnnouncementQuery message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AnnouncementQuery.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AnnouncementQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.IAnnouncementQuery} message AnnouncementQuery message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AnnouncementQuery.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AnnouncementQuery message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AnnouncementQuery
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AnnouncementQuery} AnnouncementQuery
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AnnouncementQuery.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AnnouncementQuery();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.releaseState = reader.int32();
                        break;
                    case 2:
                        message.state = reader.int32();
                        break;
                    case 3:
                        message.target = reader.int32();
                        break;
                    case 4:
                        message.name = reader.string();
                        break;
                    case 5:
                        message.dateStart = reader.string();
                        break;
                    case 6:
                        message.dateEnd = reader.string();
                        break;
                    case 7:
                        message.pagination = $root.TCBReceiptApi.Protobuf.Pagination.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AnnouncementQuery message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AnnouncementQuery
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AnnouncementQuery} AnnouncementQuery
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AnnouncementQuery.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AnnouncementQuery message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AnnouncementQuery
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AnnouncementQuery.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.releaseState != null && message.hasOwnProperty("releaseState"))
                    if (!$util.isInteger(message.releaseState))
                        return "releaseState: integer expected";
                if (message.state != null && message.hasOwnProperty("state"))
                    if (!$util.isInteger(message.state))
                        return "state: integer expected";
                if (message.target != null && message.hasOwnProperty("target"))
                    if (!$util.isInteger(message.target))
                        return "target: integer expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.dateStart != null && message.hasOwnProperty("dateStart"))
                    if (!$util.isString(message.dateStart))
                        return "dateStart: string expected";
                if (message.dateEnd != null && message.hasOwnProperty("dateEnd"))
                    if (!$util.isString(message.dateEnd))
                        return "dateEnd: string expected";
                if (message.pagination != null && message.hasOwnProperty("pagination")) {
                    var error = $root.TCBReceiptApi.Protobuf.Pagination.verify(message.pagination);
                    if (error)
                        return "pagination." + error;
                }
                return null;
            };

            /**
             * Creates an AnnouncementQuery message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AnnouncementQuery
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AnnouncementQuery} AnnouncementQuery
             */
            AnnouncementQuery.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AnnouncementQuery)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AnnouncementQuery();
                if (object.releaseState != null)
                    message.releaseState = object.releaseState | 0;
                if (object.state != null)
                    message.state = object.state | 0;
                if (object.target != null)
                    message.target = object.target | 0;
                if (object.name != null)
                    message.name = String(object.name);
                if (object.dateStart != null)
                    message.dateStart = String(object.dateStart);
                if (object.dateEnd != null)
                    message.dateEnd = String(object.dateEnd);
                if (object.pagination != null) {
                    if (typeof object.pagination !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.AnnouncementQuery.pagination: object expected");
                    message.pagination = $root.TCBReceiptApi.Protobuf.Pagination.fromObject(object.pagination);
                }
                return message;
            };

            /**
             * Creates a plain object from an AnnouncementQuery message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AnnouncementQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.AnnouncementQuery} message AnnouncementQuery
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AnnouncementQuery.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.releaseState = 0;
                    object.state = 0;
                    object.target = 0;
                    object.name = "";
                    object.dateStart = "";
                    object.dateEnd = "";
                    object.pagination = null;
                }
                if (message.releaseState != null && message.hasOwnProperty("releaseState"))
                    object.releaseState = message.releaseState;
                if (message.state != null && message.hasOwnProperty("state"))
                    object.state = message.state;
                if (message.target != null && message.hasOwnProperty("target"))
                    object.target = message.target;
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.dateStart != null && message.hasOwnProperty("dateStart"))
                    object.dateStart = message.dateStart;
                if (message.dateEnd != null && message.hasOwnProperty("dateEnd"))
                    object.dateEnd = message.dateEnd;
                if (message.pagination != null && message.hasOwnProperty("pagination"))
                    object.pagination = $root.TCBReceiptApi.Protobuf.Pagination.toObject(message.pagination, options);
                return object;
            };

            /**
             * Converts this AnnouncementQuery to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AnnouncementQuery
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AnnouncementQuery.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AnnouncementQuery;
        })();

        Protobuf.AnnouncementFile = (function() {

            /**
             * Properties of an AnnouncementFile.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAnnouncementFile
             * @property {string|null} [dataType] AnnouncementFile dataType
             * @property {string|null} [id] AnnouncementFile id
             * @property {string|null} [name] AnnouncementFile name
             */

            /**
             * Constructs a new AnnouncementFile.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AnnouncementFile.
             * @implements IAnnouncementFile
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAnnouncementFile=} [properties] Properties to set
             */
            function AnnouncementFile(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AnnouncementFile dataType.
             * @member {string} dataType
             * @memberof TCBReceiptApi.Protobuf.AnnouncementFile
             * @instance
             */
            AnnouncementFile.prototype.dataType = "";

            /**
             * AnnouncementFile id.
             * @member {string} id
             * @memberof TCBReceiptApi.Protobuf.AnnouncementFile
             * @instance
             */
            AnnouncementFile.prototype.id = "";

            /**
             * AnnouncementFile name.
             * @member {string} name
             * @memberof TCBReceiptApi.Protobuf.AnnouncementFile
             * @instance
             */
            AnnouncementFile.prototype.name = "";

            /**
             * Creates a new AnnouncementFile instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AnnouncementFile
             * @static
             * @param {TCBReceiptApi.Protobuf.IAnnouncementFile=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AnnouncementFile} AnnouncementFile instance
             */
            AnnouncementFile.create = function create(properties) {
                return new AnnouncementFile(properties);
            };

            /**
             * Encodes the specified AnnouncementFile message. Does not implicitly {@link TCBReceiptApi.Protobuf.AnnouncementFile.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AnnouncementFile
             * @static
             * @param {TCBReceiptApi.Protobuf.IAnnouncementFile} message AnnouncementFile message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AnnouncementFile.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.dataType != null && Object.hasOwnProperty.call(message, "dataType"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.dataType);
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.id);
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
                return writer;
            };

            /**
             * Encodes the specified AnnouncementFile message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AnnouncementFile.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AnnouncementFile
             * @static
             * @param {TCBReceiptApi.Protobuf.IAnnouncementFile} message AnnouncementFile message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AnnouncementFile.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AnnouncementFile message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AnnouncementFile
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AnnouncementFile} AnnouncementFile
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AnnouncementFile.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AnnouncementFile();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.dataType = reader.string();
                        break;
                    case 2:
                        message.id = reader.string();
                        break;
                    case 3:
                        message.name = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AnnouncementFile message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AnnouncementFile
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AnnouncementFile} AnnouncementFile
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AnnouncementFile.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AnnouncementFile message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AnnouncementFile
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AnnouncementFile.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.dataType != null && message.hasOwnProperty("dataType"))
                    if (!$util.isString(message.dataType))
                        return "dataType: string expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isString(message.id))
                        return "id: string expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                return null;
            };

            /**
             * Creates an AnnouncementFile message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AnnouncementFile
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AnnouncementFile} AnnouncementFile
             */
            AnnouncementFile.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AnnouncementFile)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AnnouncementFile();
                if (object.dataType != null)
                    message.dataType = String(object.dataType);
                if (object.id != null)
                    message.id = String(object.id);
                if (object.name != null)
                    message.name = String(object.name);
                return message;
            };

            /**
             * Creates a plain object from an AnnouncementFile message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AnnouncementFile
             * @static
             * @param {TCBReceiptApi.Protobuf.AnnouncementFile} message AnnouncementFile
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AnnouncementFile.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.dataType = "";
                    object.id = "";
                    object.name = "";
                }
                if (message.dataType != null && message.hasOwnProperty("dataType"))
                    object.dataType = message.dataType;
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                return object;
            };

            /**
             * Converts this AnnouncementFile to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AnnouncementFile
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AnnouncementFile.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AnnouncementFile;
        })();

        Protobuf.Pagination = (function() {

            /**
             * Properties of a Pagination.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IPagination
             * @property {number|null} [limit] Pagination limit
             * @property {number|null} [offset] Pagination offset
             */

            /**
             * Constructs a new Pagination.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a Pagination.
             * @implements IPagination
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IPagination=} [properties] Properties to set
             */
            function Pagination(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Pagination limit.
             * @member {number} limit
             * @memberof TCBReceiptApi.Protobuf.Pagination
             * @instance
             */
            Pagination.prototype.limit = 0;

            /**
             * Pagination offset.
             * @member {number} offset
             * @memberof TCBReceiptApi.Protobuf.Pagination
             * @instance
             */
            Pagination.prototype.offset = 0;

            /**
             * Creates a new Pagination instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.Pagination
             * @static
             * @param {TCBReceiptApi.Protobuf.IPagination=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.Pagination} Pagination instance
             */
            Pagination.create = function create(properties) {
                return new Pagination(properties);
            };

            /**
             * Encodes the specified Pagination message. Does not implicitly {@link TCBReceiptApi.Protobuf.Pagination.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.Pagination
             * @static
             * @param {TCBReceiptApi.Protobuf.IPagination} message Pagination message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Pagination.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.limit != null && Object.hasOwnProperty.call(message, "limit"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.limit);
                if (message.offset != null && Object.hasOwnProperty.call(message, "offset"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.offset);
                return writer;
            };

            /**
             * Encodes the specified Pagination message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.Pagination.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.Pagination
             * @static
             * @param {TCBReceiptApi.Protobuf.IPagination} message Pagination message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Pagination.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Pagination message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.Pagination
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.Pagination} Pagination
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Pagination.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.Pagination();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.limit = reader.int32();
                        break;
                    case 2:
                        message.offset = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Pagination message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.Pagination
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.Pagination} Pagination
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Pagination.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Pagination message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.Pagination
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Pagination.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.limit != null && message.hasOwnProperty("limit"))
                    if (!$util.isInteger(message.limit))
                        return "limit: integer expected";
                if (message.offset != null && message.hasOwnProperty("offset"))
                    if (!$util.isInteger(message.offset))
                        return "offset: integer expected";
                return null;
            };

            /**
             * Creates a Pagination message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.Pagination
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.Pagination} Pagination
             */
            Pagination.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.Pagination)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.Pagination();
                if (object.limit != null)
                    message.limit = object.limit | 0;
                if (object.offset != null)
                    message.offset = object.offset | 0;
                return message;
            };

            /**
             * Creates a plain object from a Pagination message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.Pagination
             * @static
             * @param {TCBReceiptApi.Protobuf.Pagination} message Pagination
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Pagination.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.limit = 0;
                    object.offset = 0;
                }
                if (message.limit != null && message.hasOwnProperty("limit"))
                    object.limit = message.limit;
                if (message.offset != null && message.hasOwnProperty("offset"))
                    object.offset = message.offset;
                return object;
            };

            /**
             * Converts this Pagination to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.Pagination
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Pagination.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Pagination;
        })();

        Protobuf.AppropriationInfoCredit = (function() {

            /**
             * Properties of an AppropriationInfoCredit.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationInfoCredit
             * @property {number|null} [appropriationId] AppropriationInfoCredit appropriationId
             * @property {string|null} [storeCode] AppropriationInfoCredit storeCode
             * @property {string|null} [terminalNo] AppropriationInfoCredit terminalNo
             * @property {string|null} [date] AppropriationInfoCredit date
             * @property {string|null} [submitDate] AppropriationInfoCredit submitDate
             * @property {string|null} [batchNo] AppropriationInfoCredit batchNo
             * @property {string|null} [transDate] AppropriationInfoCredit transDate
             * @property {string|null} [transTime] AppropriationInfoCredit transTime
             * @property {number|null} [code] AppropriationInfoCredit code
             * @property {string|null} [codeOrigin] AppropriationInfoCredit codeOrigin
             * @property {number|null} [settleCode] AppropriationInfoCredit settleCode
             * @property {string|null} [authCode] AppropriationInfoCredit authCode
             * @property {number|null} [amount] AppropriationInfoCredit amount
             * @property {string|null} [cardNo] AppropriationInfoCredit cardNo
             * @property {number|null} [cardType] AppropriationInfoCredit cardType
             * @property {string|null} [cardTypeOrigin] AppropriationInfoCredit cardTypeOrigin
             * @property {string|null} [orderNo] AppropriationInfoCredit orderNo
             * @property {number|null} [isCreditCard] AppropriationInfoCredit isCreditCard
             * @property {string|null} [issuer] AppropriationInfoCredit issuer
             * @property {number|null} [payFlag] AppropriationInfoCredit payFlag
             * @property {string|null} [payFlagOrigin] AppropriationInfoCredit payFlagOrigin
             * @property {number|null} [installCode] AppropriationInfoCredit installCode
             * @property {string|null} [installCodeOrigin] AppropriationInfoCredit installCodeOrigin
             * @property {number|null} [installTimes] AppropriationInfoCredit installTimes
             * @property {number|null} [installAverageAmount] AppropriationInfoCredit installAverageAmount
             * @property {string|null} [stan] AppropriationInfoCredit stan
             * @property {number|null} [feeFlag] AppropriationInfoCredit feeFlag
             * @property {string|null} [feeFlagOrigin] AppropriationInfoCredit feeFlagOrigin
             * @property {number|null} [charge] AppropriationInfoCredit charge
             * @property {number|null} [isOurBank] AppropriationInfoCredit isOurBank
             * @property {number|null} [taiwanPayQrFlag] AppropriationInfoCredit taiwanPayQrFlag
             * @property {number|null} [infoType] AppropriationInfoCredit infoType
             * @property {string|null} [storeCodeMapping] AppropriationInfoCredit storeCodeMapping
             * @property {number|null} [type] AppropriationInfoCredit type
             * @property {string|null} [subStoreCode] AppropriationInfoCredit subStoreCode
             * @property {string|null} [stanOrigin] AppropriationInfoCredit stanOrigin
             * @property {string|null} [tpan] AppropriationInfoCredit tpan
             * @property {number|null} [installRate] AppropriationInfoCredit installRate
             * @property {string|null} [issuerOrigin] AppropriationInfoCredit issuerOrigin
             */

            /**
             * Constructs a new AppropriationInfoCredit.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationInfoCredit.
             * @implements IAppropriationInfoCredit
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationInfoCredit=} [properties] Properties to set
             */
            function AppropriationInfoCredit(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationInfoCredit appropriationId.
             * @member {number} appropriationId
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.appropriationId = 0;

            /**
             * AppropriationInfoCredit storeCode.
             * @member {string} storeCode
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.storeCode = "";

            /**
             * AppropriationInfoCredit terminalNo.
             * @member {string} terminalNo
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.terminalNo = "";

            /**
             * AppropriationInfoCredit date.
             * @member {string} date
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.date = "";

            /**
             * AppropriationInfoCredit submitDate.
             * @member {string} submitDate
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.submitDate = "";

            /**
             * AppropriationInfoCredit batchNo.
             * @member {string} batchNo
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.batchNo = "";

            /**
             * AppropriationInfoCredit transDate.
             * @member {string} transDate
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.transDate = "";

            /**
             * AppropriationInfoCredit transTime.
             * @member {string} transTime
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.transTime = "";

            /**
             * AppropriationInfoCredit code.
             * @member {number} code
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.code = 0;

            /**
             * AppropriationInfoCredit codeOrigin.
             * @member {string} codeOrigin
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.codeOrigin = "";

            /**
             * AppropriationInfoCredit settleCode.
             * @member {number} settleCode
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.settleCode = 0;

            /**
             * AppropriationInfoCredit authCode.
             * @member {string} authCode
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.authCode = "";

            /**
             * AppropriationInfoCredit amount.
             * @member {number} amount
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.amount = 0;

            /**
             * AppropriationInfoCredit cardNo.
             * @member {string} cardNo
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.cardNo = "";

            /**
             * AppropriationInfoCredit cardType.
             * @member {number} cardType
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.cardType = 0;

            /**
             * AppropriationInfoCredit cardTypeOrigin.
             * @member {string} cardTypeOrigin
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.cardTypeOrigin = "";

            /**
             * AppropriationInfoCredit orderNo.
             * @member {string} orderNo
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.orderNo = "";

            /**
             * AppropriationInfoCredit isCreditCard.
             * @member {number} isCreditCard
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.isCreditCard = 0;

            /**
             * AppropriationInfoCredit issuer.
             * @member {string} issuer
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.issuer = "";

            /**
             * AppropriationInfoCredit payFlag.
             * @member {number} payFlag
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.payFlag = 0;

            /**
             * AppropriationInfoCredit payFlagOrigin.
             * @member {string} payFlagOrigin
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.payFlagOrigin = "";

            /**
             * AppropriationInfoCredit installCode.
             * @member {number} installCode
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.installCode = 0;

            /**
             * AppropriationInfoCredit installCodeOrigin.
             * @member {string} installCodeOrigin
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.installCodeOrigin = "";

            /**
             * AppropriationInfoCredit installTimes.
             * @member {number} installTimes
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.installTimes = 0;

            /**
             * AppropriationInfoCredit installAverageAmount.
             * @member {number} installAverageAmount
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.installAverageAmount = 0;

            /**
             * AppropriationInfoCredit stan.
             * @member {string} stan
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.stan = "";

            /**
             * AppropriationInfoCredit feeFlag.
             * @member {number} feeFlag
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.feeFlag = 0;

            /**
             * AppropriationInfoCredit feeFlagOrigin.
             * @member {string} feeFlagOrigin
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.feeFlagOrigin = "";

            /**
             * AppropriationInfoCredit charge.
             * @member {number} charge
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.charge = 0;

            /**
             * AppropriationInfoCredit isOurBank.
             * @member {number} isOurBank
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.isOurBank = 0;

            /**
             * AppropriationInfoCredit taiwanPayQrFlag.
             * @member {number} taiwanPayQrFlag
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.taiwanPayQrFlag = 0;

            /**
             * AppropriationInfoCredit infoType.
             * @member {number} infoType
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.infoType = 0;

            /**
             * AppropriationInfoCredit storeCodeMapping.
             * @member {string} storeCodeMapping
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.storeCodeMapping = "";

            /**
             * AppropriationInfoCredit type.
             * @member {number} type
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.type = 0;

            /**
             * AppropriationInfoCredit subStoreCode.
             * @member {string} subStoreCode
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.subStoreCode = "";

            /**
             * AppropriationInfoCredit stanOrigin.
             * @member {string} stanOrigin
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.stanOrigin = "";

            /**
             * AppropriationInfoCredit tpan.
             * @member {string} tpan
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.tpan = "";

            /**
             * AppropriationInfoCredit installRate.
             * @member {number} installRate
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.installRate = 0;

            /**
             * AppropriationInfoCredit issuerOrigin.
             * @member {string} issuerOrigin
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             */
            AppropriationInfoCredit.prototype.issuerOrigin = "";

            /**
             * Creates a new AppropriationInfoCredit instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationInfoCredit=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationInfoCredit} AppropriationInfoCredit instance
             */
            AppropriationInfoCredit.create = function create(properties) {
                return new AppropriationInfoCredit(properties);
            };

            /**
             * Encodes the specified AppropriationInfoCredit message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationInfoCredit.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationInfoCredit} message AppropriationInfoCredit message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationInfoCredit.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.appropriationId != null && Object.hasOwnProperty.call(message, "appropriationId"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.appropriationId);
                if (message.storeCode != null && Object.hasOwnProperty.call(message, "storeCode"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.storeCode);
                if (message.terminalNo != null && Object.hasOwnProperty.call(message, "terminalNo"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.terminalNo);
                if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.date);
                if (message.submitDate != null && Object.hasOwnProperty.call(message, "submitDate"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.submitDate);
                if (message.batchNo != null && Object.hasOwnProperty.call(message, "batchNo"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.batchNo);
                if (message.transDate != null && Object.hasOwnProperty.call(message, "transDate"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.transDate);
                if (message.transTime != null && Object.hasOwnProperty.call(message, "transTime"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.transTime);
                if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                    writer.uint32(/* id 9, wireType 0 =*/72).int32(message.code);
                if (message.codeOrigin != null && Object.hasOwnProperty.call(message, "codeOrigin"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.codeOrigin);
                if (message.settleCode != null && Object.hasOwnProperty.call(message, "settleCode"))
                    writer.uint32(/* id 11, wireType 0 =*/88).int32(message.settleCode);
                if (message.authCode != null && Object.hasOwnProperty.call(message, "authCode"))
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.authCode);
                if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                    writer.uint32(/* id 13, wireType 1 =*/105).double(message.amount);
                if (message.cardNo != null && Object.hasOwnProperty.call(message, "cardNo"))
                    writer.uint32(/* id 14, wireType 2 =*/114).string(message.cardNo);
                if (message.cardType != null && Object.hasOwnProperty.call(message, "cardType"))
                    writer.uint32(/* id 15, wireType 0 =*/120).int32(message.cardType);
                if (message.cardTypeOrigin != null && Object.hasOwnProperty.call(message, "cardTypeOrigin"))
                    writer.uint32(/* id 16, wireType 2 =*/130).string(message.cardTypeOrigin);
                if (message.orderNo != null && Object.hasOwnProperty.call(message, "orderNo"))
                    writer.uint32(/* id 17, wireType 2 =*/138).string(message.orderNo);
                if (message.isCreditCard != null && Object.hasOwnProperty.call(message, "isCreditCard"))
                    writer.uint32(/* id 18, wireType 0 =*/144).int32(message.isCreditCard);
                if (message.issuer != null && Object.hasOwnProperty.call(message, "issuer"))
                    writer.uint32(/* id 19, wireType 2 =*/154).string(message.issuer);
                if (message.payFlag != null && Object.hasOwnProperty.call(message, "payFlag"))
                    writer.uint32(/* id 20, wireType 0 =*/160).int32(message.payFlag);
                if (message.payFlagOrigin != null && Object.hasOwnProperty.call(message, "payFlagOrigin"))
                    writer.uint32(/* id 21, wireType 2 =*/170).string(message.payFlagOrigin);
                if (message.installCode != null && Object.hasOwnProperty.call(message, "installCode"))
                    writer.uint32(/* id 22, wireType 0 =*/176).int32(message.installCode);
                if (message.installCodeOrigin != null && Object.hasOwnProperty.call(message, "installCodeOrigin"))
                    writer.uint32(/* id 23, wireType 2 =*/186).string(message.installCodeOrigin);
                if (message.installTimes != null && Object.hasOwnProperty.call(message, "installTimes"))
                    writer.uint32(/* id 24, wireType 0 =*/192).int32(message.installTimes);
                if (message.installAverageAmount != null && Object.hasOwnProperty.call(message, "installAverageAmount"))
                    writer.uint32(/* id 25, wireType 1 =*/201).double(message.installAverageAmount);
                if (message.stan != null && Object.hasOwnProperty.call(message, "stan"))
                    writer.uint32(/* id 26, wireType 2 =*/210).string(message.stan);
                if (message.feeFlag != null && Object.hasOwnProperty.call(message, "feeFlag"))
                    writer.uint32(/* id 27, wireType 0 =*/216).int32(message.feeFlag);
                if (message.feeFlagOrigin != null && Object.hasOwnProperty.call(message, "feeFlagOrigin"))
                    writer.uint32(/* id 28, wireType 2 =*/226).string(message.feeFlagOrigin);
                if (message.charge != null && Object.hasOwnProperty.call(message, "charge"))
                    writer.uint32(/* id 29, wireType 1 =*/233).double(message.charge);
                if (message.isOurBank != null && Object.hasOwnProperty.call(message, "isOurBank"))
                    writer.uint32(/* id 30, wireType 0 =*/240).int32(message.isOurBank);
                if (message.taiwanPayQrFlag != null && Object.hasOwnProperty.call(message, "taiwanPayQrFlag"))
                    writer.uint32(/* id 31, wireType 0 =*/248).int32(message.taiwanPayQrFlag);
                if (message.infoType != null && Object.hasOwnProperty.call(message, "infoType"))
                    writer.uint32(/* id 32, wireType 0 =*/256).int32(message.infoType);
                if (message.storeCodeMapping != null && Object.hasOwnProperty.call(message, "storeCodeMapping"))
                    writer.uint32(/* id 33, wireType 2 =*/266).string(message.storeCodeMapping);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 34, wireType 0 =*/272).int32(message.type);
                if (message.subStoreCode != null && Object.hasOwnProperty.call(message, "subStoreCode"))
                    writer.uint32(/* id 35, wireType 2 =*/282).string(message.subStoreCode);
                if (message.stanOrigin != null && Object.hasOwnProperty.call(message, "stanOrigin"))
                    writer.uint32(/* id 36, wireType 2 =*/290).string(message.stanOrigin);
                if (message.tpan != null && Object.hasOwnProperty.call(message, "tpan"))
                    writer.uint32(/* id 37, wireType 2 =*/298).string(message.tpan);
                if (message.installRate != null && Object.hasOwnProperty.call(message, "installRate"))
                    writer.uint32(/* id 38, wireType 1 =*/305).double(message.installRate);
                if (message.issuerOrigin != null && Object.hasOwnProperty.call(message, "issuerOrigin"))
                    writer.uint32(/* id 39, wireType 2 =*/314).string(message.issuerOrigin);
                return writer;
            };

            /**
             * Encodes the specified AppropriationInfoCredit message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationInfoCredit.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationInfoCredit} message AppropriationInfoCredit message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationInfoCredit.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationInfoCredit message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationInfoCredit} AppropriationInfoCredit
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationInfoCredit.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationInfoCredit();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.appropriationId = reader.int32();
                        break;
                    case 2:
                        message.storeCode = reader.string();
                        break;
                    case 3:
                        message.terminalNo = reader.string();
                        break;
                    case 4:
                        message.date = reader.string();
                        break;
                    case 5:
                        message.submitDate = reader.string();
                        break;
                    case 6:
                        message.batchNo = reader.string();
                        break;
                    case 7:
                        message.transDate = reader.string();
                        break;
                    case 8:
                        message.transTime = reader.string();
                        break;
                    case 9:
                        message.code = reader.int32();
                        break;
                    case 10:
                        message.codeOrigin = reader.string();
                        break;
                    case 11:
                        message.settleCode = reader.int32();
                        break;
                    case 12:
                        message.authCode = reader.string();
                        break;
                    case 13:
                        message.amount = reader.double();
                        break;
                    case 14:
                        message.cardNo = reader.string();
                        break;
                    case 15:
                        message.cardType = reader.int32();
                        break;
                    case 16:
                        message.cardTypeOrigin = reader.string();
                        break;
                    case 17:
                        message.orderNo = reader.string();
                        break;
                    case 18:
                        message.isCreditCard = reader.int32();
                        break;
                    case 19:
                        message.issuer = reader.string();
                        break;
                    case 20:
                        message.payFlag = reader.int32();
                        break;
                    case 21:
                        message.payFlagOrigin = reader.string();
                        break;
                    case 22:
                        message.installCode = reader.int32();
                        break;
                    case 23:
                        message.installCodeOrigin = reader.string();
                        break;
                    case 24:
                        message.installTimes = reader.int32();
                        break;
                    case 25:
                        message.installAverageAmount = reader.double();
                        break;
                    case 26:
                        message.stan = reader.string();
                        break;
                    case 27:
                        message.feeFlag = reader.int32();
                        break;
                    case 28:
                        message.feeFlagOrigin = reader.string();
                        break;
                    case 29:
                        message.charge = reader.double();
                        break;
                    case 30:
                        message.isOurBank = reader.int32();
                        break;
                    case 31:
                        message.taiwanPayQrFlag = reader.int32();
                        break;
                    case 32:
                        message.infoType = reader.int32();
                        break;
                    case 33:
                        message.storeCodeMapping = reader.string();
                        break;
                    case 34:
                        message.type = reader.int32();
                        break;
                    case 35:
                        message.subStoreCode = reader.string();
                        break;
                    case 36:
                        message.stanOrigin = reader.string();
                        break;
                    case 37:
                        message.tpan = reader.string();
                        break;
                    case 38:
                        message.installRate = reader.double();
                        break;
                    case 39:
                        message.issuerOrigin = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationInfoCredit message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationInfoCredit} AppropriationInfoCredit
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationInfoCredit.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationInfoCredit message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationInfoCredit.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.appropriationId != null && message.hasOwnProperty("appropriationId"))
                    if (!$util.isInteger(message.appropriationId))
                        return "appropriationId: integer expected";
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    if (!$util.isString(message.storeCode))
                        return "storeCode: string expected";
                if (message.terminalNo != null && message.hasOwnProperty("terminalNo"))
                    if (!$util.isString(message.terminalNo))
                        return "terminalNo: string expected";
                if (message.date != null && message.hasOwnProperty("date"))
                    if (!$util.isString(message.date))
                        return "date: string expected";
                if (message.submitDate != null && message.hasOwnProperty("submitDate"))
                    if (!$util.isString(message.submitDate))
                        return "submitDate: string expected";
                if (message.batchNo != null && message.hasOwnProperty("batchNo"))
                    if (!$util.isString(message.batchNo))
                        return "batchNo: string expected";
                if (message.transDate != null && message.hasOwnProperty("transDate"))
                    if (!$util.isString(message.transDate))
                        return "transDate: string expected";
                if (message.transTime != null && message.hasOwnProperty("transTime"))
                    if (!$util.isString(message.transTime))
                        return "transTime: string expected";
                if (message.code != null && message.hasOwnProperty("code"))
                    if (!$util.isInteger(message.code))
                        return "code: integer expected";
                if (message.codeOrigin != null && message.hasOwnProperty("codeOrigin"))
                    if (!$util.isString(message.codeOrigin))
                        return "codeOrigin: string expected";
                if (message.settleCode != null && message.hasOwnProperty("settleCode"))
                    if (!$util.isInteger(message.settleCode))
                        return "settleCode: integer expected";
                if (message.authCode != null && message.hasOwnProperty("authCode"))
                    if (!$util.isString(message.authCode))
                        return "authCode: string expected";
                if (message.amount != null && message.hasOwnProperty("amount"))
                    if (typeof message.amount !== "number")
                        return "amount: number expected";
                if (message.cardNo != null && message.hasOwnProperty("cardNo"))
                    if (!$util.isString(message.cardNo))
                        return "cardNo: string expected";
                if (message.cardType != null && message.hasOwnProperty("cardType"))
                    if (!$util.isInteger(message.cardType))
                        return "cardType: integer expected";
                if (message.cardTypeOrigin != null && message.hasOwnProperty("cardTypeOrigin"))
                    if (!$util.isString(message.cardTypeOrigin))
                        return "cardTypeOrigin: string expected";
                if (message.orderNo != null && message.hasOwnProperty("orderNo"))
                    if (!$util.isString(message.orderNo))
                        return "orderNo: string expected";
                if (message.isCreditCard != null && message.hasOwnProperty("isCreditCard"))
                    if (!$util.isInteger(message.isCreditCard))
                        return "isCreditCard: integer expected";
                if (message.issuer != null && message.hasOwnProperty("issuer"))
                    if (!$util.isString(message.issuer))
                        return "issuer: string expected";
                if (message.payFlag != null && message.hasOwnProperty("payFlag"))
                    if (!$util.isInteger(message.payFlag))
                        return "payFlag: integer expected";
                if (message.payFlagOrigin != null && message.hasOwnProperty("payFlagOrigin"))
                    if (!$util.isString(message.payFlagOrigin))
                        return "payFlagOrigin: string expected";
                if (message.installCode != null && message.hasOwnProperty("installCode"))
                    if (!$util.isInteger(message.installCode))
                        return "installCode: integer expected";
                if (message.installCodeOrigin != null && message.hasOwnProperty("installCodeOrigin"))
                    if (!$util.isString(message.installCodeOrigin))
                        return "installCodeOrigin: string expected";
                if (message.installTimes != null && message.hasOwnProperty("installTimes"))
                    if (!$util.isInteger(message.installTimes))
                        return "installTimes: integer expected";
                if (message.installAverageAmount != null && message.hasOwnProperty("installAverageAmount"))
                    if (typeof message.installAverageAmount !== "number")
                        return "installAverageAmount: number expected";
                if (message.stan != null && message.hasOwnProperty("stan"))
                    if (!$util.isString(message.stan))
                        return "stan: string expected";
                if (message.feeFlag != null && message.hasOwnProperty("feeFlag"))
                    if (!$util.isInteger(message.feeFlag))
                        return "feeFlag: integer expected";
                if (message.feeFlagOrigin != null && message.hasOwnProperty("feeFlagOrigin"))
                    if (!$util.isString(message.feeFlagOrigin))
                        return "feeFlagOrigin: string expected";
                if (message.charge != null && message.hasOwnProperty("charge"))
                    if (typeof message.charge !== "number")
                        return "charge: number expected";
                if (message.isOurBank != null && message.hasOwnProperty("isOurBank"))
                    if (!$util.isInteger(message.isOurBank))
                        return "isOurBank: integer expected";
                if (message.taiwanPayQrFlag != null && message.hasOwnProperty("taiwanPayQrFlag"))
                    if (!$util.isInteger(message.taiwanPayQrFlag))
                        return "taiwanPayQrFlag: integer expected";
                if (message.infoType != null && message.hasOwnProperty("infoType"))
                    if (!$util.isInteger(message.infoType))
                        return "infoType: integer expected";
                if (message.storeCodeMapping != null && message.hasOwnProperty("storeCodeMapping"))
                    if (!$util.isString(message.storeCodeMapping))
                        return "storeCodeMapping: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isInteger(message.type))
                        return "type: integer expected";
                if (message.subStoreCode != null && message.hasOwnProperty("subStoreCode"))
                    if (!$util.isString(message.subStoreCode))
                        return "subStoreCode: string expected";
                if (message.stanOrigin != null && message.hasOwnProperty("stanOrigin"))
                    if (!$util.isString(message.stanOrigin))
                        return "stanOrigin: string expected";
                if (message.tpan != null && message.hasOwnProperty("tpan"))
                    if (!$util.isString(message.tpan))
                        return "tpan: string expected";
                if (message.installRate != null && message.hasOwnProperty("installRate"))
                    if (typeof message.installRate !== "number")
                        return "installRate: number expected";
                if (message.issuerOrigin != null && message.hasOwnProperty("issuerOrigin"))
                    if (!$util.isString(message.issuerOrigin))
                        return "issuerOrigin: string expected";
                return null;
            };

            /**
             * Creates an AppropriationInfoCredit message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationInfoCredit} AppropriationInfoCredit
             */
            AppropriationInfoCredit.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationInfoCredit)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationInfoCredit();
                if (object.appropriationId != null)
                    message.appropriationId = object.appropriationId | 0;
                if (object.storeCode != null)
                    message.storeCode = String(object.storeCode);
                if (object.terminalNo != null)
                    message.terminalNo = String(object.terminalNo);
                if (object.date != null)
                    message.date = String(object.date);
                if (object.submitDate != null)
                    message.submitDate = String(object.submitDate);
                if (object.batchNo != null)
                    message.batchNo = String(object.batchNo);
                if (object.transDate != null)
                    message.transDate = String(object.transDate);
                if (object.transTime != null)
                    message.transTime = String(object.transTime);
                if (object.code != null)
                    message.code = object.code | 0;
                if (object.codeOrigin != null)
                    message.codeOrigin = String(object.codeOrigin);
                if (object.settleCode != null)
                    message.settleCode = object.settleCode | 0;
                if (object.authCode != null)
                    message.authCode = String(object.authCode);
                if (object.amount != null)
                    message.amount = Number(object.amount);
                if (object.cardNo != null)
                    message.cardNo = String(object.cardNo);
                if (object.cardType != null)
                    message.cardType = object.cardType | 0;
                if (object.cardTypeOrigin != null)
                    message.cardTypeOrigin = String(object.cardTypeOrigin);
                if (object.orderNo != null)
                    message.orderNo = String(object.orderNo);
                if (object.isCreditCard != null)
                    message.isCreditCard = object.isCreditCard | 0;
                if (object.issuer != null)
                    message.issuer = String(object.issuer);
                if (object.payFlag != null)
                    message.payFlag = object.payFlag | 0;
                if (object.payFlagOrigin != null)
                    message.payFlagOrigin = String(object.payFlagOrigin);
                if (object.installCode != null)
                    message.installCode = object.installCode | 0;
                if (object.installCodeOrigin != null)
                    message.installCodeOrigin = String(object.installCodeOrigin);
                if (object.installTimes != null)
                    message.installTimes = object.installTimes | 0;
                if (object.installAverageAmount != null)
                    message.installAverageAmount = Number(object.installAverageAmount);
                if (object.stan != null)
                    message.stan = String(object.stan);
                if (object.feeFlag != null)
                    message.feeFlag = object.feeFlag | 0;
                if (object.feeFlagOrigin != null)
                    message.feeFlagOrigin = String(object.feeFlagOrigin);
                if (object.charge != null)
                    message.charge = Number(object.charge);
                if (object.isOurBank != null)
                    message.isOurBank = object.isOurBank | 0;
                if (object.taiwanPayQrFlag != null)
                    message.taiwanPayQrFlag = object.taiwanPayQrFlag | 0;
                if (object.infoType != null)
                    message.infoType = object.infoType | 0;
                if (object.storeCodeMapping != null)
                    message.storeCodeMapping = String(object.storeCodeMapping);
                if (object.type != null)
                    message.type = object.type | 0;
                if (object.subStoreCode != null)
                    message.subStoreCode = String(object.subStoreCode);
                if (object.stanOrigin != null)
                    message.stanOrigin = String(object.stanOrigin);
                if (object.tpan != null)
                    message.tpan = String(object.tpan);
                if (object.installRate != null)
                    message.installRate = Number(object.installRate);
                if (object.issuerOrigin != null)
                    message.issuerOrigin = String(object.issuerOrigin);
                return message;
            };

            /**
             * Creates a plain object from an AppropriationInfoCredit message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationInfoCredit} message AppropriationInfoCredit
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationInfoCredit.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.appropriationId = 0;
                    object.storeCode = "";
                    object.terminalNo = "";
                    object.date = "";
                    object.submitDate = "";
                    object.batchNo = "";
                    object.transDate = "";
                    object.transTime = "";
                    object.code = 0;
                    object.codeOrigin = "";
                    object.settleCode = 0;
                    object.authCode = "";
                    object.amount = 0;
                    object.cardNo = "";
                    object.cardType = 0;
                    object.cardTypeOrigin = "";
                    object.orderNo = "";
                    object.isCreditCard = 0;
                    object.issuer = "";
                    object.payFlag = 0;
                    object.payFlagOrigin = "";
                    object.installCode = 0;
                    object.installCodeOrigin = "";
                    object.installTimes = 0;
                    object.installAverageAmount = 0;
                    object.stan = "";
                    object.feeFlag = 0;
                    object.feeFlagOrigin = "";
                    object.charge = 0;
                    object.isOurBank = 0;
                    object.taiwanPayQrFlag = 0;
                    object.infoType = 0;
                    object.storeCodeMapping = "";
                    object.type = 0;
                    object.subStoreCode = "";
                    object.stanOrigin = "";
                    object.tpan = "";
                    object.installRate = 0;
                    object.issuerOrigin = "";
                }
                if (message.appropriationId != null && message.hasOwnProperty("appropriationId"))
                    object.appropriationId = message.appropriationId;
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    object.storeCode = message.storeCode;
                if (message.terminalNo != null && message.hasOwnProperty("terminalNo"))
                    object.terminalNo = message.terminalNo;
                if (message.date != null && message.hasOwnProperty("date"))
                    object.date = message.date;
                if (message.submitDate != null && message.hasOwnProperty("submitDate"))
                    object.submitDate = message.submitDate;
                if (message.batchNo != null && message.hasOwnProperty("batchNo"))
                    object.batchNo = message.batchNo;
                if (message.transDate != null && message.hasOwnProperty("transDate"))
                    object.transDate = message.transDate;
                if (message.transTime != null && message.hasOwnProperty("transTime"))
                    object.transTime = message.transTime;
                if (message.code != null && message.hasOwnProperty("code"))
                    object.code = message.code;
                if (message.codeOrigin != null && message.hasOwnProperty("codeOrigin"))
                    object.codeOrigin = message.codeOrigin;
                if (message.settleCode != null && message.hasOwnProperty("settleCode"))
                    object.settleCode = message.settleCode;
                if (message.authCode != null && message.hasOwnProperty("authCode"))
                    object.authCode = message.authCode;
                if (message.amount != null && message.hasOwnProperty("amount"))
                    object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
                if (message.cardNo != null && message.hasOwnProperty("cardNo"))
                    object.cardNo = message.cardNo;
                if (message.cardType != null && message.hasOwnProperty("cardType"))
                    object.cardType = message.cardType;
                if (message.cardTypeOrigin != null && message.hasOwnProperty("cardTypeOrigin"))
                    object.cardTypeOrigin = message.cardTypeOrigin;
                if (message.orderNo != null && message.hasOwnProperty("orderNo"))
                    object.orderNo = message.orderNo;
                if (message.isCreditCard != null && message.hasOwnProperty("isCreditCard"))
                    object.isCreditCard = message.isCreditCard;
                if (message.issuer != null && message.hasOwnProperty("issuer"))
                    object.issuer = message.issuer;
                if (message.payFlag != null && message.hasOwnProperty("payFlag"))
                    object.payFlag = message.payFlag;
                if (message.payFlagOrigin != null && message.hasOwnProperty("payFlagOrigin"))
                    object.payFlagOrigin = message.payFlagOrigin;
                if (message.installCode != null && message.hasOwnProperty("installCode"))
                    object.installCode = message.installCode;
                if (message.installCodeOrigin != null && message.hasOwnProperty("installCodeOrigin"))
                    object.installCodeOrigin = message.installCodeOrigin;
                if (message.installTimes != null && message.hasOwnProperty("installTimes"))
                    object.installTimes = message.installTimes;
                if (message.installAverageAmount != null && message.hasOwnProperty("installAverageAmount"))
                    object.installAverageAmount = options.json && !isFinite(message.installAverageAmount) ? String(message.installAverageAmount) : message.installAverageAmount;
                if (message.stan != null && message.hasOwnProperty("stan"))
                    object.stan = message.stan;
                if (message.feeFlag != null && message.hasOwnProperty("feeFlag"))
                    object.feeFlag = message.feeFlag;
                if (message.feeFlagOrigin != null && message.hasOwnProperty("feeFlagOrigin"))
                    object.feeFlagOrigin = message.feeFlagOrigin;
                if (message.charge != null && message.hasOwnProperty("charge"))
                    object.charge = options.json && !isFinite(message.charge) ? String(message.charge) : message.charge;
                if (message.isOurBank != null && message.hasOwnProperty("isOurBank"))
                    object.isOurBank = message.isOurBank;
                if (message.taiwanPayQrFlag != null && message.hasOwnProperty("taiwanPayQrFlag"))
                    object.taiwanPayQrFlag = message.taiwanPayQrFlag;
                if (message.infoType != null && message.hasOwnProperty("infoType"))
                    object.infoType = message.infoType;
                if (message.storeCodeMapping != null && message.hasOwnProperty("storeCodeMapping"))
                    object.storeCodeMapping = message.storeCodeMapping;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.subStoreCode != null && message.hasOwnProperty("subStoreCode"))
                    object.subStoreCode = message.subStoreCode;
                if (message.stanOrigin != null && message.hasOwnProperty("stanOrigin"))
                    object.stanOrigin = message.stanOrigin;
                if (message.tpan != null && message.hasOwnProperty("tpan"))
                    object.tpan = message.tpan;
                if (message.installRate != null && message.hasOwnProperty("installRate"))
                    object.installRate = options.json && !isFinite(message.installRate) ? String(message.installRate) : message.installRate;
                if (message.issuerOrigin != null && message.hasOwnProperty("issuerOrigin"))
                    object.issuerOrigin = message.issuerOrigin;
                return object;
            };

            /**
             * Converts this AppropriationInfoCredit to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoCredit
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationInfoCredit.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationInfoCredit;
        })();

        Protobuf.AppropriationCredit = (function() {

            /**
             * Properties of an AppropriationCredit.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationCredit
             * @property {Array.<TCBReceiptApi.Protobuf.IAppropriationInfoCredit>|null} [list] AppropriationCredit list
             */

            /**
             * Constructs a new AppropriationCredit.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationCredit.
             * @implements IAppropriationCredit
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationCredit=} [properties] Properties to set
             */
            function AppropriationCredit(properties) {
                this.list = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationCredit list.
             * @member {Array.<TCBReceiptApi.Protobuf.IAppropriationInfoCredit>} list
             * @memberof TCBReceiptApi.Protobuf.AppropriationCredit
             * @instance
             */
            AppropriationCredit.prototype.list = $util.emptyArray;

            /**
             * Creates a new AppropriationCredit instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationCredit
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationCredit=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationCredit} AppropriationCredit instance
             */
            AppropriationCredit.create = function create(properties) {
                return new AppropriationCredit(properties);
            };

            /**
             * Encodes the specified AppropriationCredit message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationCredit.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationCredit
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationCredit} message AppropriationCredit message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationCredit.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.list != null && message.list.length)
                    for (var i = 0; i < message.list.length; ++i)
                        $root.TCBReceiptApi.Protobuf.AppropriationInfoCredit.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified AppropriationCredit message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationCredit.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationCredit
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationCredit} message AppropriationCredit message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationCredit.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationCredit message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationCredit
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationCredit} AppropriationCredit
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationCredit.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationCredit();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.TCBReceiptApi.Protobuf.AppropriationInfoCredit.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationCredit message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationCredit
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationCredit} AppropriationCredit
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationCredit.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationCredit message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationCredit
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationCredit.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.list != null && message.hasOwnProperty("list")) {
                    if (!Array.isArray(message.list))
                        return "list: array expected";
                    for (var i = 0; i < message.list.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.AppropriationInfoCredit.verify(message.list[i]);
                        if (error)
                            return "list." + error;
                    }
                }
                return null;
            };

            /**
             * Creates an AppropriationCredit message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationCredit
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationCredit} AppropriationCredit
             */
            AppropriationCredit.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationCredit)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationCredit();
                if (object.list) {
                    if (!Array.isArray(object.list))
                        throw TypeError(".TCBReceiptApi.Protobuf.AppropriationCredit.list: array expected");
                    message.list = [];
                    for (var i = 0; i < object.list.length; ++i) {
                        if (typeof object.list[i] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.AppropriationCredit.list: object expected");
                        message.list[i] = $root.TCBReceiptApi.Protobuf.AppropriationInfoCredit.fromObject(object.list[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from an AppropriationCredit message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationCredit
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationCredit} message AppropriationCredit
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationCredit.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.list = [];
                if (message.list && message.list.length) {
                    object.list = [];
                    for (var j = 0; j < message.list.length; ++j)
                        object.list[j] = $root.TCBReceiptApi.Protobuf.AppropriationInfoCredit.toObject(message.list[j], options);
                }
                return object;
            };

            /**
             * Converts this AppropriationCredit to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationCredit
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationCredit.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationCredit;
        })();

        Protobuf.AppropriationCreditBatchNoMap = (function() {

            /**
             * Properties of an AppropriationCreditBatchNoMap.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationCreditBatchNoMap
             * @property {Object.<string,TCBReceiptApi.Protobuf.IAppropriationCredit>|null} [byBatchNo] AppropriationCreditBatchNoMap byBatchNo
             */

            /**
             * Constructs a new AppropriationCreditBatchNoMap.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationCreditBatchNoMap.
             * @implements IAppropriationCreditBatchNoMap
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationCreditBatchNoMap=} [properties] Properties to set
             */
            function AppropriationCreditBatchNoMap(properties) {
                this.byBatchNo = {};
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationCreditBatchNoMap byBatchNo.
             * @member {Object.<string,TCBReceiptApi.Protobuf.IAppropriationCredit>} byBatchNo
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditBatchNoMap
             * @instance
             */
            AppropriationCreditBatchNoMap.prototype.byBatchNo = $util.emptyObject;

            /**
             * Creates a new AppropriationCreditBatchNoMap instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditBatchNoMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationCreditBatchNoMap=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationCreditBatchNoMap} AppropriationCreditBatchNoMap instance
             */
            AppropriationCreditBatchNoMap.create = function create(properties) {
                return new AppropriationCreditBatchNoMap(properties);
            };

            /**
             * Encodes the specified AppropriationCreditBatchNoMap message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationCreditBatchNoMap.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditBatchNoMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationCreditBatchNoMap} message AppropriationCreditBatchNoMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationCreditBatchNoMap.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.byBatchNo != null && Object.hasOwnProperty.call(message, "byBatchNo"))
                    for (var keys = Object.keys(message.byBatchNo), i = 0; i < keys.length; ++i) {
                        writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                        $root.TCBReceiptApi.Protobuf.AppropriationCredit.encode(message.byBatchNo[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                    }
                return writer;
            };

            /**
             * Encodes the specified AppropriationCreditBatchNoMap message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationCreditBatchNoMap.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditBatchNoMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationCreditBatchNoMap} message AppropriationCreditBatchNoMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationCreditBatchNoMap.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationCreditBatchNoMap message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditBatchNoMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationCreditBatchNoMap} AppropriationCreditBatchNoMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationCreditBatchNoMap.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationCreditBatchNoMap(), key, value;
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (message.byBatchNo === $util.emptyObject)
                            message.byBatchNo = {};
                        var end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = null;
                        while (reader.pos < end2) {
                            var tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = $root.TCBReceiptApi.Protobuf.AppropriationCredit.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.byBatchNo[key] = value;
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationCreditBatchNoMap message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditBatchNoMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationCreditBatchNoMap} AppropriationCreditBatchNoMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationCreditBatchNoMap.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationCreditBatchNoMap message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditBatchNoMap
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationCreditBatchNoMap.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.byBatchNo != null && message.hasOwnProperty("byBatchNo")) {
                    if (!$util.isObject(message.byBatchNo))
                        return "byBatchNo: object expected";
                    var key = Object.keys(message.byBatchNo);
                    for (var i = 0; i < key.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.AppropriationCredit.verify(message.byBatchNo[key[i]]);
                        if (error)
                            return "byBatchNo." + error;
                    }
                }
                return null;
            };

            /**
             * Creates an AppropriationCreditBatchNoMap message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditBatchNoMap
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationCreditBatchNoMap} AppropriationCreditBatchNoMap
             */
            AppropriationCreditBatchNoMap.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationCreditBatchNoMap)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationCreditBatchNoMap();
                if (object.byBatchNo) {
                    if (typeof object.byBatchNo !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.AppropriationCreditBatchNoMap.byBatchNo: object expected");
                    message.byBatchNo = {};
                    for (var keys = Object.keys(object.byBatchNo), i = 0; i < keys.length; ++i) {
                        if (typeof object.byBatchNo[keys[i]] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.AppropriationCreditBatchNoMap.byBatchNo: object expected");
                        message.byBatchNo[keys[i]] = $root.TCBReceiptApi.Protobuf.AppropriationCredit.fromObject(object.byBatchNo[keys[i]]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from an AppropriationCreditBatchNoMap message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditBatchNoMap
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationCreditBatchNoMap} message AppropriationCreditBatchNoMap
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationCreditBatchNoMap.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.objects || options.defaults)
                    object.byBatchNo = {};
                var keys2;
                if (message.byBatchNo && (keys2 = Object.keys(message.byBatchNo)).length) {
                    object.byBatchNo = {};
                    for (var j = 0; j < keys2.length; ++j)
                        object.byBatchNo[keys2[j]] = $root.TCBReceiptApi.Protobuf.AppropriationCredit.toObject(message.byBatchNo[keys2[j]], options);
                }
                return object;
            };

            /**
             * Converts this AppropriationCreditBatchNoMap to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditBatchNoMap
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationCreditBatchNoMap.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationCreditBatchNoMap;
        })();

        Protobuf.AppropriationCreditSecondMap = (function() {

            /**
             * Properties of an AppropriationCreditSecondMap.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationCreditSecondMap
             * @property {Object.<string,TCBReceiptApi.Protobuf.IAppropriationCreditBatchNoMap>|null} [bySecondColumn] AppropriationCreditSecondMap bySecondColumn
             */

            /**
             * Constructs a new AppropriationCreditSecondMap.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationCreditSecondMap.
             * @implements IAppropriationCreditSecondMap
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationCreditSecondMap=} [properties] Properties to set
             */
            function AppropriationCreditSecondMap(properties) {
                this.bySecondColumn = {};
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationCreditSecondMap bySecondColumn.
             * @member {Object.<string,TCBReceiptApi.Protobuf.IAppropriationCreditBatchNoMap>} bySecondColumn
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditSecondMap
             * @instance
             */
            AppropriationCreditSecondMap.prototype.bySecondColumn = $util.emptyObject;

            /**
             * Creates a new AppropriationCreditSecondMap instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditSecondMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationCreditSecondMap=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationCreditSecondMap} AppropriationCreditSecondMap instance
             */
            AppropriationCreditSecondMap.create = function create(properties) {
                return new AppropriationCreditSecondMap(properties);
            };

            /**
             * Encodes the specified AppropriationCreditSecondMap message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationCreditSecondMap.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditSecondMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationCreditSecondMap} message AppropriationCreditSecondMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationCreditSecondMap.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.bySecondColumn != null && Object.hasOwnProperty.call(message, "bySecondColumn"))
                    for (var keys = Object.keys(message.bySecondColumn), i = 0; i < keys.length; ++i) {
                        writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                        $root.TCBReceiptApi.Protobuf.AppropriationCreditBatchNoMap.encode(message.bySecondColumn[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                    }
                return writer;
            };

            /**
             * Encodes the specified AppropriationCreditSecondMap message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationCreditSecondMap.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditSecondMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationCreditSecondMap} message AppropriationCreditSecondMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationCreditSecondMap.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationCreditSecondMap message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditSecondMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationCreditSecondMap} AppropriationCreditSecondMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationCreditSecondMap.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationCreditSecondMap(), key, value;
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (message.bySecondColumn === $util.emptyObject)
                            message.bySecondColumn = {};
                        var end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = null;
                        while (reader.pos < end2) {
                            var tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = $root.TCBReceiptApi.Protobuf.AppropriationCreditBatchNoMap.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.bySecondColumn[key] = value;
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationCreditSecondMap message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditSecondMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationCreditSecondMap} AppropriationCreditSecondMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationCreditSecondMap.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationCreditSecondMap message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditSecondMap
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationCreditSecondMap.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.bySecondColumn != null && message.hasOwnProperty("bySecondColumn")) {
                    if (!$util.isObject(message.bySecondColumn))
                        return "bySecondColumn: object expected";
                    var key = Object.keys(message.bySecondColumn);
                    for (var i = 0; i < key.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.AppropriationCreditBatchNoMap.verify(message.bySecondColumn[key[i]]);
                        if (error)
                            return "bySecondColumn." + error;
                    }
                }
                return null;
            };

            /**
             * Creates an AppropriationCreditSecondMap message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditSecondMap
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationCreditSecondMap} AppropriationCreditSecondMap
             */
            AppropriationCreditSecondMap.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationCreditSecondMap)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationCreditSecondMap();
                if (object.bySecondColumn) {
                    if (typeof object.bySecondColumn !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.AppropriationCreditSecondMap.bySecondColumn: object expected");
                    message.bySecondColumn = {};
                    for (var keys = Object.keys(object.bySecondColumn), i = 0; i < keys.length; ++i) {
                        if (typeof object.bySecondColumn[keys[i]] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.AppropriationCreditSecondMap.bySecondColumn: object expected");
                        message.bySecondColumn[keys[i]] = $root.TCBReceiptApi.Protobuf.AppropriationCreditBatchNoMap.fromObject(object.bySecondColumn[keys[i]]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from an AppropriationCreditSecondMap message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditSecondMap
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationCreditSecondMap} message AppropriationCreditSecondMap
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationCreditSecondMap.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.objects || options.defaults)
                    object.bySecondColumn = {};
                var keys2;
                if (message.bySecondColumn && (keys2 = Object.keys(message.bySecondColumn)).length) {
                    object.bySecondColumn = {};
                    for (var j = 0; j < keys2.length; ++j)
                        object.bySecondColumn[keys2[j]] = $root.TCBReceiptApi.Protobuf.AppropriationCreditBatchNoMap.toObject(message.bySecondColumn[keys2[j]], options);
                }
                return object;
            };

            /**
             * Converts this AppropriationCreditSecondMap to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditSecondMap
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationCreditSecondMap.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationCreditSecondMap;
        })();

        Protobuf.AppropriationCreditFirstMap = (function() {

            /**
             * Properties of an AppropriationCreditFirstMap.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationCreditFirstMap
             * @property {Object.<string,TCBReceiptApi.Protobuf.IAppropriationCreditSecondMap>|null} [byFirstColumn] AppropriationCreditFirstMap byFirstColumn
             */

            /**
             * Constructs a new AppropriationCreditFirstMap.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationCreditFirstMap.
             * @implements IAppropriationCreditFirstMap
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationCreditFirstMap=} [properties] Properties to set
             */
            function AppropriationCreditFirstMap(properties) {
                this.byFirstColumn = {};
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationCreditFirstMap byFirstColumn.
             * @member {Object.<string,TCBReceiptApi.Protobuf.IAppropriationCreditSecondMap>} byFirstColumn
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditFirstMap
             * @instance
             */
            AppropriationCreditFirstMap.prototype.byFirstColumn = $util.emptyObject;

            /**
             * Creates a new AppropriationCreditFirstMap instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditFirstMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationCreditFirstMap=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationCreditFirstMap} AppropriationCreditFirstMap instance
             */
            AppropriationCreditFirstMap.create = function create(properties) {
                return new AppropriationCreditFirstMap(properties);
            };

            /**
             * Encodes the specified AppropriationCreditFirstMap message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationCreditFirstMap.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditFirstMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationCreditFirstMap} message AppropriationCreditFirstMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationCreditFirstMap.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.byFirstColumn != null && Object.hasOwnProperty.call(message, "byFirstColumn"))
                    for (var keys = Object.keys(message.byFirstColumn), i = 0; i < keys.length; ++i) {
                        writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                        $root.TCBReceiptApi.Protobuf.AppropriationCreditSecondMap.encode(message.byFirstColumn[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                    }
                return writer;
            };

            /**
             * Encodes the specified AppropriationCreditFirstMap message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationCreditFirstMap.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditFirstMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationCreditFirstMap} message AppropriationCreditFirstMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationCreditFirstMap.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationCreditFirstMap message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditFirstMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationCreditFirstMap} AppropriationCreditFirstMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationCreditFirstMap.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationCreditFirstMap(), key, value;
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (message.byFirstColumn === $util.emptyObject)
                            message.byFirstColumn = {};
                        var end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = null;
                        while (reader.pos < end2) {
                            var tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = $root.TCBReceiptApi.Protobuf.AppropriationCreditSecondMap.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.byFirstColumn[key] = value;
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationCreditFirstMap message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditFirstMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationCreditFirstMap} AppropriationCreditFirstMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationCreditFirstMap.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationCreditFirstMap message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditFirstMap
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationCreditFirstMap.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.byFirstColumn != null && message.hasOwnProperty("byFirstColumn")) {
                    if (!$util.isObject(message.byFirstColumn))
                        return "byFirstColumn: object expected";
                    var key = Object.keys(message.byFirstColumn);
                    for (var i = 0; i < key.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.AppropriationCreditSecondMap.verify(message.byFirstColumn[key[i]]);
                        if (error)
                            return "byFirstColumn." + error;
                    }
                }
                return null;
            };

            /**
             * Creates an AppropriationCreditFirstMap message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditFirstMap
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationCreditFirstMap} AppropriationCreditFirstMap
             */
            AppropriationCreditFirstMap.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationCreditFirstMap)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationCreditFirstMap();
                if (object.byFirstColumn) {
                    if (typeof object.byFirstColumn !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.AppropriationCreditFirstMap.byFirstColumn: object expected");
                    message.byFirstColumn = {};
                    for (var keys = Object.keys(object.byFirstColumn), i = 0; i < keys.length; ++i) {
                        if (typeof object.byFirstColumn[keys[i]] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.AppropriationCreditFirstMap.byFirstColumn: object expected");
                        message.byFirstColumn[keys[i]] = $root.TCBReceiptApi.Protobuf.AppropriationCreditSecondMap.fromObject(object.byFirstColumn[keys[i]]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from an AppropriationCreditFirstMap message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditFirstMap
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationCreditFirstMap} message AppropriationCreditFirstMap
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationCreditFirstMap.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.objects || options.defaults)
                    object.byFirstColumn = {};
                var keys2;
                if (message.byFirstColumn && (keys2 = Object.keys(message.byFirstColumn)).length) {
                    object.byFirstColumn = {};
                    for (var j = 0; j < keys2.length; ++j)
                        object.byFirstColumn[keys2[j]] = $root.TCBReceiptApi.Protobuf.AppropriationCreditSecondMap.toObject(message.byFirstColumn[keys2[j]], options);
                }
                return object;
            };

            /**
             * Converts this AppropriationCreditFirstMap to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditFirstMap
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationCreditFirstMap.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationCreditFirstMap;
        })();

        Protobuf.AppropriationCreditTotal = (function() {

            /**
             * Properties of an AppropriationCreditTotal.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationCreditTotal
             * @property {number|null} [count] AppropriationCreditTotal count
             * @property {number|null} [total] AppropriationCreditTotal total
             */

            /**
             * Constructs a new AppropriationCreditTotal.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationCreditTotal.
             * @implements IAppropriationCreditTotal
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationCreditTotal=} [properties] Properties to set
             */
            function AppropriationCreditTotal(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationCreditTotal count.
             * @member {number} count
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditTotal
             * @instance
             */
            AppropriationCreditTotal.prototype.count = 0;

            /**
             * AppropriationCreditTotal total.
             * @member {number} total
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditTotal
             * @instance
             */
            AppropriationCreditTotal.prototype.total = 0;

            /**
             * Creates a new AppropriationCreditTotal instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationCreditTotal=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationCreditTotal} AppropriationCreditTotal instance
             */
            AppropriationCreditTotal.create = function create(properties) {
                return new AppropriationCreditTotal(properties);
            };

            /**
             * Encodes the specified AppropriationCreditTotal message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationCreditTotal.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationCreditTotal} message AppropriationCreditTotal message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationCreditTotal.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.count != null && Object.hasOwnProperty.call(message, "count"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.count);
                if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                    writer.uint32(/* id 2, wireType 1 =*/17).double(message.total);
                return writer;
            };

            /**
             * Encodes the specified AppropriationCreditTotal message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationCreditTotal.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationCreditTotal} message AppropriationCreditTotal message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationCreditTotal.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationCreditTotal message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditTotal
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationCreditTotal} AppropriationCreditTotal
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationCreditTotal.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationCreditTotal();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.count = reader.int32();
                        break;
                    case 2:
                        message.total = reader.double();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationCreditTotal message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditTotal
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationCreditTotal} AppropriationCreditTotal
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationCreditTotal.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationCreditTotal message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditTotal
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationCreditTotal.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.count != null && message.hasOwnProperty("count"))
                    if (!$util.isInteger(message.count))
                        return "count: integer expected";
                if (message.total != null && message.hasOwnProperty("total"))
                    if (typeof message.total !== "number")
                        return "total: number expected";
                return null;
            };

            /**
             * Creates an AppropriationCreditTotal message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditTotal
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationCreditTotal} AppropriationCreditTotal
             */
            AppropriationCreditTotal.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationCreditTotal)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationCreditTotal();
                if (object.count != null)
                    message.count = object.count | 0;
                if (object.total != null)
                    message.total = Number(object.total);
                return message;
            };

            /**
             * Creates a plain object from an AppropriationCreditTotal message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationCreditTotal} message AppropriationCreditTotal
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationCreditTotal.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.count = 0;
                    object.total = 0;
                }
                if (message.count != null && message.hasOwnProperty("count"))
                    object.count = message.count;
                if (message.total != null && message.hasOwnProperty("total"))
                    object.total = options.json && !isFinite(message.total) ? String(message.total) : message.total;
                return object;
            };

            /**
             * Converts this AppropriationCreditTotal to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditTotal
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationCreditTotal.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationCreditTotal;
        })();

        Protobuf.AppropriationInfoAlipay = (function() {

            /**
             * Properties of an AppropriationInfoAlipay.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationInfoAlipay
             * @property {number|null} [appropriationAlipayId] AppropriationInfoAlipay appropriationAlipayId
             * @property {string|null} [storeCode] AppropriationInfoAlipay storeCode
             * @property {string|null} [date] AppropriationInfoAlipay date
             * @property {string|null} [submitDate] AppropriationInfoAlipay submitDate
             * @property {string|null} [transDate] AppropriationInfoAlipay transDate
             * @property {string|null} [transTime] AppropriationInfoAlipay transTime
             * @property {number|null} [code] AppropriationInfoAlipay code
             * @property {string|null} [codeOrigin] AppropriationInfoAlipay codeOrigin
             * @property {number|null} [abroadAmount] AppropriationInfoAlipay abroadAmount
             * @property {number|null} [amount] AppropriationInfoAlipay amount
             * @property {number|null} [storeCharge] AppropriationInfoAlipay storeCharge
             * @property {number|null} [consumerCharge] AppropriationInfoAlipay consumerCharge
             * @property {string|null} [orderNo] AppropriationInfoAlipay orderNo
             * @property {number|null} [infoType] AppropriationInfoAlipay infoType
             * @property {string|null} [storeCodeMapping] AppropriationInfoAlipay storeCodeMapping
             */

            /**
             * Constructs a new AppropriationInfoAlipay.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationInfoAlipay.
             * @implements IAppropriationInfoAlipay
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationInfoAlipay=} [properties] Properties to set
             */
            function AppropriationInfoAlipay(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationInfoAlipay appropriationAlipayId.
             * @member {number} appropriationAlipayId
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoAlipay
             * @instance
             */
            AppropriationInfoAlipay.prototype.appropriationAlipayId = 0;

            /**
             * AppropriationInfoAlipay storeCode.
             * @member {string} storeCode
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoAlipay
             * @instance
             */
            AppropriationInfoAlipay.prototype.storeCode = "";

            /**
             * AppropriationInfoAlipay date.
             * @member {string} date
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoAlipay
             * @instance
             */
            AppropriationInfoAlipay.prototype.date = "";

            /**
             * AppropriationInfoAlipay submitDate.
             * @member {string} submitDate
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoAlipay
             * @instance
             */
            AppropriationInfoAlipay.prototype.submitDate = "";

            /**
             * AppropriationInfoAlipay transDate.
             * @member {string} transDate
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoAlipay
             * @instance
             */
            AppropriationInfoAlipay.prototype.transDate = "";

            /**
             * AppropriationInfoAlipay transTime.
             * @member {string} transTime
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoAlipay
             * @instance
             */
            AppropriationInfoAlipay.prototype.transTime = "";

            /**
             * AppropriationInfoAlipay code.
             * @member {number} code
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoAlipay
             * @instance
             */
            AppropriationInfoAlipay.prototype.code = 0;

            /**
             * AppropriationInfoAlipay codeOrigin.
             * @member {string} codeOrigin
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoAlipay
             * @instance
             */
            AppropriationInfoAlipay.prototype.codeOrigin = "";

            /**
             * AppropriationInfoAlipay abroadAmount.
             * @member {number} abroadAmount
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoAlipay
             * @instance
             */
            AppropriationInfoAlipay.prototype.abroadAmount = 0;

            /**
             * AppropriationInfoAlipay amount.
             * @member {number} amount
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoAlipay
             * @instance
             */
            AppropriationInfoAlipay.prototype.amount = 0;

            /**
             * AppropriationInfoAlipay storeCharge.
             * @member {number} storeCharge
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoAlipay
             * @instance
             */
            AppropriationInfoAlipay.prototype.storeCharge = 0;

            /**
             * AppropriationInfoAlipay consumerCharge.
             * @member {number} consumerCharge
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoAlipay
             * @instance
             */
            AppropriationInfoAlipay.prototype.consumerCharge = 0;

            /**
             * AppropriationInfoAlipay orderNo.
             * @member {string} orderNo
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoAlipay
             * @instance
             */
            AppropriationInfoAlipay.prototype.orderNo = "";

            /**
             * AppropriationInfoAlipay infoType.
             * @member {number} infoType
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoAlipay
             * @instance
             */
            AppropriationInfoAlipay.prototype.infoType = 0;

            /**
             * AppropriationInfoAlipay storeCodeMapping.
             * @member {string} storeCodeMapping
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoAlipay
             * @instance
             */
            AppropriationInfoAlipay.prototype.storeCodeMapping = "";

            /**
             * Creates a new AppropriationInfoAlipay instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoAlipay
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationInfoAlipay=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationInfoAlipay} AppropriationInfoAlipay instance
             */
            AppropriationInfoAlipay.create = function create(properties) {
                return new AppropriationInfoAlipay(properties);
            };

            /**
             * Encodes the specified AppropriationInfoAlipay message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationInfoAlipay.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoAlipay
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationInfoAlipay} message AppropriationInfoAlipay message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationInfoAlipay.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.appropriationAlipayId != null && Object.hasOwnProperty.call(message, "appropriationAlipayId"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.appropriationAlipayId);
                if (message.storeCode != null && Object.hasOwnProperty.call(message, "storeCode"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.storeCode);
                if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.date);
                if (message.submitDate != null && Object.hasOwnProperty.call(message, "submitDate"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.submitDate);
                if (message.transDate != null && Object.hasOwnProperty.call(message, "transDate"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.transDate);
                if (message.transTime != null && Object.hasOwnProperty.call(message, "transTime"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.transTime);
                if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                    writer.uint32(/* id 7, wireType 0 =*/56).int32(message.code);
                if (message.codeOrigin != null && Object.hasOwnProperty.call(message, "codeOrigin"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.codeOrigin);
                if (message.abroadAmount != null && Object.hasOwnProperty.call(message, "abroadAmount"))
                    writer.uint32(/* id 9, wireType 1 =*/73).double(message.abroadAmount);
                if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                    writer.uint32(/* id 10, wireType 1 =*/81).double(message.amount);
                if (message.storeCharge != null && Object.hasOwnProperty.call(message, "storeCharge"))
                    writer.uint32(/* id 11, wireType 1 =*/89).double(message.storeCharge);
                if (message.consumerCharge != null && Object.hasOwnProperty.call(message, "consumerCharge"))
                    writer.uint32(/* id 12, wireType 1 =*/97).double(message.consumerCharge);
                if (message.orderNo != null && Object.hasOwnProperty.call(message, "orderNo"))
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.orderNo);
                if (message.infoType != null && Object.hasOwnProperty.call(message, "infoType"))
                    writer.uint32(/* id 14, wireType 0 =*/112).int32(message.infoType);
                if (message.storeCodeMapping != null && Object.hasOwnProperty.call(message, "storeCodeMapping"))
                    writer.uint32(/* id 15, wireType 2 =*/122).string(message.storeCodeMapping);
                return writer;
            };

            /**
             * Encodes the specified AppropriationInfoAlipay message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationInfoAlipay.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoAlipay
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationInfoAlipay} message AppropriationInfoAlipay message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationInfoAlipay.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationInfoAlipay message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoAlipay
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationInfoAlipay} AppropriationInfoAlipay
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationInfoAlipay.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationInfoAlipay();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.appropriationAlipayId = reader.int32();
                        break;
                    case 2:
                        message.storeCode = reader.string();
                        break;
                    case 3:
                        message.date = reader.string();
                        break;
                    case 4:
                        message.submitDate = reader.string();
                        break;
                    case 5:
                        message.transDate = reader.string();
                        break;
                    case 6:
                        message.transTime = reader.string();
                        break;
                    case 7:
                        message.code = reader.int32();
                        break;
                    case 8:
                        message.codeOrigin = reader.string();
                        break;
                    case 9:
                        message.abroadAmount = reader.double();
                        break;
                    case 10:
                        message.amount = reader.double();
                        break;
                    case 11:
                        message.storeCharge = reader.double();
                        break;
                    case 12:
                        message.consumerCharge = reader.double();
                        break;
                    case 13:
                        message.orderNo = reader.string();
                        break;
                    case 14:
                        message.infoType = reader.int32();
                        break;
                    case 15:
                        message.storeCodeMapping = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationInfoAlipay message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoAlipay
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationInfoAlipay} AppropriationInfoAlipay
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationInfoAlipay.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationInfoAlipay message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoAlipay
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationInfoAlipay.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.appropriationAlipayId != null && message.hasOwnProperty("appropriationAlipayId"))
                    if (!$util.isInteger(message.appropriationAlipayId))
                        return "appropriationAlipayId: integer expected";
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    if (!$util.isString(message.storeCode))
                        return "storeCode: string expected";
                if (message.date != null && message.hasOwnProperty("date"))
                    if (!$util.isString(message.date))
                        return "date: string expected";
                if (message.submitDate != null && message.hasOwnProperty("submitDate"))
                    if (!$util.isString(message.submitDate))
                        return "submitDate: string expected";
                if (message.transDate != null && message.hasOwnProperty("transDate"))
                    if (!$util.isString(message.transDate))
                        return "transDate: string expected";
                if (message.transTime != null && message.hasOwnProperty("transTime"))
                    if (!$util.isString(message.transTime))
                        return "transTime: string expected";
                if (message.code != null && message.hasOwnProperty("code"))
                    if (!$util.isInteger(message.code))
                        return "code: integer expected";
                if (message.codeOrigin != null && message.hasOwnProperty("codeOrigin"))
                    if (!$util.isString(message.codeOrigin))
                        return "codeOrigin: string expected";
                if (message.abroadAmount != null && message.hasOwnProperty("abroadAmount"))
                    if (typeof message.abroadAmount !== "number")
                        return "abroadAmount: number expected";
                if (message.amount != null && message.hasOwnProperty("amount"))
                    if (typeof message.amount !== "number")
                        return "amount: number expected";
                if (message.storeCharge != null && message.hasOwnProperty("storeCharge"))
                    if (typeof message.storeCharge !== "number")
                        return "storeCharge: number expected";
                if (message.consumerCharge != null && message.hasOwnProperty("consumerCharge"))
                    if (typeof message.consumerCharge !== "number")
                        return "consumerCharge: number expected";
                if (message.orderNo != null && message.hasOwnProperty("orderNo"))
                    if (!$util.isString(message.orderNo))
                        return "orderNo: string expected";
                if (message.infoType != null && message.hasOwnProperty("infoType"))
                    if (!$util.isInteger(message.infoType))
                        return "infoType: integer expected";
                if (message.storeCodeMapping != null && message.hasOwnProperty("storeCodeMapping"))
                    if (!$util.isString(message.storeCodeMapping))
                        return "storeCodeMapping: string expected";
                return null;
            };

            /**
             * Creates an AppropriationInfoAlipay message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoAlipay
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationInfoAlipay} AppropriationInfoAlipay
             */
            AppropriationInfoAlipay.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationInfoAlipay)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationInfoAlipay();
                if (object.appropriationAlipayId != null)
                    message.appropriationAlipayId = object.appropriationAlipayId | 0;
                if (object.storeCode != null)
                    message.storeCode = String(object.storeCode);
                if (object.date != null)
                    message.date = String(object.date);
                if (object.submitDate != null)
                    message.submitDate = String(object.submitDate);
                if (object.transDate != null)
                    message.transDate = String(object.transDate);
                if (object.transTime != null)
                    message.transTime = String(object.transTime);
                if (object.code != null)
                    message.code = object.code | 0;
                if (object.codeOrigin != null)
                    message.codeOrigin = String(object.codeOrigin);
                if (object.abroadAmount != null)
                    message.abroadAmount = Number(object.abroadAmount);
                if (object.amount != null)
                    message.amount = Number(object.amount);
                if (object.storeCharge != null)
                    message.storeCharge = Number(object.storeCharge);
                if (object.consumerCharge != null)
                    message.consumerCharge = Number(object.consumerCharge);
                if (object.orderNo != null)
                    message.orderNo = String(object.orderNo);
                if (object.infoType != null)
                    message.infoType = object.infoType | 0;
                if (object.storeCodeMapping != null)
                    message.storeCodeMapping = String(object.storeCodeMapping);
                return message;
            };

            /**
             * Creates a plain object from an AppropriationInfoAlipay message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoAlipay
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationInfoAlipay} message AppropriationInfoAlipay
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationInfoAlipay.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.appropriationAlipayId = 0;
                    object.storeCode = "";
                    object.date = "";
                    object.submitDate = "";
                    object.transDate = "";
                    object.transTime = "";
                    object.code = 0;
                    object.codeOrigin = "";
                    object.abroadAmount = 0;
                    object.amount = 0;
                    object.storeCharge = 0;
                    object.consumerCharge = 0;
                    object.orderNo = "";
                    object.infoType = 0;
                    object.storeCodeMapping = "";
                }
                if (message.appropriationAlipayId != null && message.hasOwnProperty("appropriationAlipayId"))
                    object.appropriationAlipayId = message.appropriationAlipayId;
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    object.storeCode = message.storeCode;
                if (message.date != null && message.hasOwnProperty("date"))
                    object.date = message.date;
                if (message.submitDate != null && message.hasOwnProperty("submitDate"))
                    object.submitDate = message.submitDate;
                if (message.transDate != null && message.hasOwnProperty("transDate"))
                    object.transDate = message.transDate;
                if (message.transTime != null && message.hasOwnProperty("transTime"))
                    object.transTime = message.transTime;
                if (message.code != null && message.hasOwnProperty("code"))
                    object.code = message.code;
                if (message.codeOrigin != null && message.hasOwnProperty("codeOrigin"))
                    object.codeOrigin = message.codeOrigin;
                if (message.abroadAmount != null && message.hasOwnProperty("abroadAmount"))
                    object.abroadAmount = options.json && !isFinite(message.abroadAmount) ? String(message.abroadAmount) : message.abroadAmount;
                if (message.amount != null && message.hasOwnProperty("amount"))
                    object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
                if (message.storeCharge != null && message.hasOwnProperty("storeCharge"))
                    object.storeCharge = options.json && !isFinite(message.storeCharge) ? String(message.storeCharge) : message.storeCharge;
                if (message.consumerCharge != null && message.hasOwnProperty("consumerCharge"))
                    object.consumerCharge = options.json && !isFinite(message.consumerCharge) ? String(message.consumerCharge) : message.consumerCharge;
                if (message.orderNo != null && message.hasOwnProperty("orderNo"))
                    object.orderNo = message.orderNo;
                if (message.infoType != null && message.hasOwnProperty("infoType"))
                    object.infoType = message.infoType;
                if (message.storeCodeMapping != null && message.hasOwnProperty("storeCodeMapping"))
                    object.storeCodeMapping = message.storeCodeMapping;
                return object;
            };

            /**
             * Converts this AppropriationInfoAlipay to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoAlipay
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationInfoAlipay.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationInfoAlipay;
        })();

        Protobuf.AppropriationAlipay = (function() {

            /**
             * Properties of an AppropriationAlipay.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationAlipay
             * @property {Array.<TCBReceiptApi.Protobuf.IAppropriationInfoAlipay>|null} [list] AppropriationAlipay list
             */

            /**
             * Constructs a new AppropriationAlipay.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationAlipay.
             * @implements IAppropriationAlipay
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationAlipay=} [properties] Properties to set
             */
            function AppropriationAlipay(properties) {
                this.list = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationAlipay list.
             * @member {Array.<TCBReceiptApi.Protobuf.IAppropriationInfoAlipay>} list
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipay
             * @instance
             */
            AppropriationAlipay.prototype.list = $util.emptyArray;

            /**
             * Creates a new AppropriationAlipay instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipay
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationAlipay=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationAlipay} AppropriationAlipay instance
             */
            AppropriationAlipay.create = function create(properties) {
                return new AppropriationAlipay(properties);
            };

            /**
             * Encodes the specified AppropriationAlipay message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationAlipay.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipay
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationAlipay} message AppropriationAlipay message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationAlipay.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.list != null && message.list.length)
                    for (var i = 0; i < message.list.length; ++i)
                        $root.TCBReceiptApi.Protobuf.AppropriationInfoAlipay.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified AppropriationAlipay message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationAlipay.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipay
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationAlipay} message AppropriationAlipay message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationAlipay.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationAlipay message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipay
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationAlipay} AppropriationAlipay
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationAlipay.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationAlipay();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.TCBReceiptApi.Protobuf.AppropriationInfoAlipay.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationAlipay message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipay
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationAlipay} AppropriationAlipay
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationAlipay.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationAlipay message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipay
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationAlipay.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.list != null && message.hasOwnProperty("list")) {
                    if (!Array.isArray(message.list))
                        return "list: array expected";
                    for (var i = 0; i < message.list.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.AppropriationInfoAlipay.verify(message.list[i]);
                        if (error)
                            return "list." + error;
                    }
                }
                return null;
            };

            /**
             * Creates an AppropriationAlipay message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipay
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationAlipay} AppropriationAlipay
             */
            AppropriationAlipay.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationAlipay)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationAlipay();
                if (object.list) {
                    if (!Array.isArray(object.list))
                        throw TypeError(".TCBReceiptApi.Protobuf.AppropriationAlipay.list: array expected");
                    message.list = [];
                    for (var i = 0; i < object.list.length; ++i) {
                        if (typeof object.list[i] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.AppropriationAlipay.list: object expected");
                        message.list[i] = $root.TCBReceiptApi.Protobuf.AppropriationInfoAlipay.fromObject(object.list[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from an AppropriationAlipay message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipay
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationAlipay} message AppropriationAlipay
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationAlipay.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.list = [];
                if (message.list && message.list.length) {
                    object.list = [];
                    for (var j = 0; j < message.list.length; ++j)
                        object.list[j] = $root.TCBReceiptApi.Protobuf.AppropriationInfoAlipay.toObject(message.list[j], options);
                }
                return object;
            };

            /**
             * Converts this AppropriationAlipay to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipay
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationAlipay.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationAlipay;
        })();

        Protobuf.AppropriationAlipayDateMap = (function() {

            /**
             * Properties of an AppropriationAlipayDateMap.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationAlipayDateMap
             * @property {Object.<string,TCBReceiptApi.Protobuf.IAppropriationAlipay>|null} [byDate] AppropriationAlipayDateMap byDate
             */

            /**
             * Constructs a new AppropriationAlipayDateMap.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationAlipayDateMap.
             * @implements IAppropriationAlipayDateMap
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationAlipayDateMap=} [properties] Properties to set
             */
            function AppropriationAlipayDateMap(properties) {
                this.byDate = {};
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationAlipayDateMap byDate.
             * @member {Object.<string,TCBReceiptApi.Protobuf.IAppropriationAlipay>} byDate
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayDateMap
             * @instance
             */
            AppropriationAlipayDateMap.prototype.byDate = $util.emptyObject;

            /**
             * Creates a new AppropriationAlipayDateMap instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayDateMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationAlipayDateMap=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationAlipayDateMap} AppropriationAlipayDateMap instance
             */
            AppropriationAlipayDateMap.create = function create(properties) {
                return new AppropriationAlipayDateMap(properties);
            };

            /**
             * Encodes the specified AppropriationAlipayDateMap message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationAlipayDateMap.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayDateMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationAlipayDateMap} message AppropriationAlipayDateMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationAlipayDateMap.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.byDate != null && Object.hasOwnProperty.call(message, "byDate"))
                    for (var keys = Object.keys(message.byDate), i = 0; i < keys.length; ++i) {
                        writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                        $root.TCBReceiptApi.Protobuf.AppropriationAlipay.encode(message.byDate[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                    }
                return writer;
            };

            /**
             * Encodes the specified AppropriationAlipayDateMap message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationAlipayDateMap.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayDateMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationAlipayDateMap} message AppropriationAlipayDateMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationAlipayDateMap.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationAlipayDateMap message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayDateMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationAlipayDateMap} AppropriationAlipayDateMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationAlipayDateMap.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationAlipayDateMap(), key, value;
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (message.byDate === $util.emptyObject)
                            message.byDate = {};
                        var end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = null;
                        while (reader.pos < end2) {
                            var tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = $root.TCBReceiptApi.Protobuf.AppropriationAlipay.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.byDate[key] = value;
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationAlipayDateMap message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayDateMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationAlipayDateMap} AppropriationAlipayDateMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationAlipayDateMap.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationAlipayDateMap message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayDateMap
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationAlipayDateMap.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.byDate != null && message.hasOwnProperty("byDate")) {
                    if (!$util.isObject(message.byDate))
                        return "byDate: object expected";
                    var key = Object.keys(message.byDate);
                    for (var i = 0; i < key.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.AppropriationAlipay.verify(message.byDate[key[i]]);
                        if (error)
                            return "byDate." + error;
                    }
                }
                return null;
            };

            /**
             * Creates an AppropriationAlipayDateMap message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayDateMap
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationAlipayDateMap} AppropriationAlipayDateMap
             */
            AppropriationAlipayDateMap.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationAlipayDateMap)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationAlipayDateMap();
                if (object.byDate) {
                    if (typeof object.byDate !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.AppropriationAlipayDateMap.byDate: object expected");
                    message.byDate = {};
                    for (var keys = Object.keys(object.byDate), i = 0; i < keys.length; ++i) {
                        if (typeof object.byDate[keys[i]] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.AppropriationAlipayDateMap.byDate: object expected");
                        message.byDate[keys[i]] = $root.TCBReceiptApi.Protobuf.AppropriationAlipay.fromObject(object.byDate[keys[i]]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from an AppropriationAlipayDateMap message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayDateMap
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationAlipayDateMap} message AppropriationAlipayDateMap
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationAlipayDateMap.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.objects || options.defaults)
                    object.byDate = {};
                var keys2;
                if (message.byDate && (keys2 = Object.keys(message.byDate)).length) {
                    object.byDate = {};
                    for (var j = 0; j < keys2.length; ++j)
                        object.byDate[keys2[j]] = $root.TCBReceiptApi.Protobuf.AppropriationAlipay.toObject(message.byDate[keys2[j]], options);
                }
                return object;
            };

            /**
             * Converts this AppropriationAlipayDateMap to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayDateMap
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationAlipayDateMap.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationAlipayDateMap;
        })();

        Protobuf.AppropriationAlipayTotal = (function() {

            /**
             * Properties of an AppropriationAlipayTotal.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationAlipayTotal
             * @property {number|null} [count] AppropriationAlipayTotal count
             * @property {number|null} [total] AppropriationAlipayTotal total
             */

            /**
             * Constructs a new AppropriationAlipayTotal.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationAlipayTotal.
             * @implements IAppropriationAlipayTotal
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationAlipayTotal=} [properties] Properties to set
             */
            function AppropriationAlipayTotal(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationAlipayTotal count.
             * @member {number} count
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayTotal
             * @instance
             */
            AppropriationAlipayTotal.prototype.count = 0;

            /**
             * AppropriationAlipayTotal total.
             * @member {number} total
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayTotal
             * @instance
             */
            AppropriationAlipayTotal.prototype.total = 0;

            /**
             * Creates a new AppropriationAlipayTotal instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationAlipayTotal=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationAlipayTotal} AppropriationAlipayTotal instance
             */
            AppropriationAlipayTotal.create = function create(properties) {
                return new AppropriationAlipayTotal(properties);
            };

            /**
             * Encodes the specified AppropriationAlipayTotal message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationAlipayTotal.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationAlipayTotal} message AppropriationAlipayTotal message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationAlipayTotal.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.count != null && Object.hasOwnProperty.call(message, "count"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.count);
                if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                    writer.uint32(/* id 2, wireType 1 =*/17).double(message.total);
                return writer;
            };

            /**
             * Encodes the specified AppropriationAlipayTotal message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationAlipayTotal.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationAlipayTotal} message AppropriationAlipayTotal message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationAlipayTotal.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationAlipayTotal message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayTotal
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationAlipayTotal} AppropriationAlipayTotal
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationAlipayTotal.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationAlipayTotal();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.count = reader.int32();
                        break;
                    case 2:
                        message.total = reader.double();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationAlipayTotal message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayTotal
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationAlipayTotal} AppropriationAlipayTotal
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationAlipayTotal.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationAlipayTotal message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayTotal
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationAlipayTotal.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.count != null && message.hasOwnProperty("count"))
                    if (!$util.isInteger(message.count))
                        return "count: integer expected";
                if (message.total != null && message.hasOwnProperty("total"))
                    if (typeof message.total !== "number")
                        return "total: number expected";
                return null;
            };

            /**
             * Creates an AppropriationAlipayTotal message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayTotal
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationAlipayTotal} AppropriationAlipayTotal
             */
            AppropriationAlipayTotal.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationAlipayTotal)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationAlipayTotal();
                if (object.count != null)
                    message.count = object.count | 0;
                if (object.total != null)
                    message.total = Number(object.total);
                return message;
            };

            /**
             * Creates a plain object from an AppropriationAlipayTotal message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationAlipayTotal} message AppropriationAlipayTotal
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationAlipayTotal.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.count = 0;
                    object.total = 0;
                }
                if (message.count != null && message.hasOwnProperty("count"))
                    object.count = message.count;
                if (message.total != null && message.hasOwnProperty("total"))
                    object.total = options.json && !isFinite(message.total) ? String(message.total) : message.total;
                return object;
            };

            /**
             * Converts this AppropriationAlipayTotal to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayTotal
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationAlipayTotal.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationAlipayTotal;
        })();

        Protobuf.AppropriationInfoMotify = (function() {

            /**
             * Properties of an AppropriationInfoMotify.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationInfoMotify
             * @property {number|null} [appropriationMotifyId] AppropriationInfoMotify appropriationMotifyId
             * @property {string|null} [storeCode] AppropriationInfoMotify storeCode
             * @property {string|null} [date] AppropriationInfoMotify date
             * @property {string|null} [reimbursementDate] AppropriationInfoMotify reimbursementDate
             * @property {string|null} [batchNo] AppropriationInfoMotify batchNo
             * @property {number|null} [motifyAmount] AppropriationInfoMotify motifyAmount
             * @property {number|null} [motifyCharge] AppropriationInfoMotify motifyCharge
             * @property {string|null} [description] AppropriationInfoMotify description
             * @property {number|null} [infoType] AppropriationInfoMotify infoType
             * @property {string|null} [storeCodeMapping] AppropriationInfoMotify storeCodeMapping
             */

            /**
             * Constructs a new AppropriationInfoMotify.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationInfoMotify.
             * @implements IAppropriationInfoMotify
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationInfoMotify=} [properties] Properties to set
             */
            function AppropriationInfoMotify(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationInfoMotify appropriationMotifyId.
             * @member {number} appropriationMotifyId
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoMotify
             * @instance
             */
            AppropriationInfoMotify.prototype.appropriationMotifyId = 0;

            /**
             * AppropriationInfoMotify storeCode.
             * @member {string} storeCode
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoMotify
             * @instance
             */
            AppropriationInfoMotify.prototype.storeCode = "";

            /**
             * AppropriationInfoMotify date.
             * @member {string} date
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoMotify
             * @instance
             */
            AppropriationInfoMotify.prototype.date = "";

            /**
             * AppropriationInfoMotify reimbursementDate.
             * @member {string} reimbursementDate
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoMotify
             * @instance
             */
            AppropriationInfoMotify.prototype.reimbursementDate = "";

            /**
             * AppropriationInfoMotify batchNo.
             * @member {string} batchNo
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoMotify
             * @instance
             */
            AppropriationInfoMotify.prototype.batchNo = "";

            /**
             * AppropriationInfoMotify motifyAmount.
             * @member {number} motifyAmount
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoMotify
             * @instance
             */
            AppropriationInfoMotify.prototype.motifyAmount = 0;

            /**
             * AppropriationInfoMotify motifyCharge.
             * @member {number} motifyCharge
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoMotify
             * @instance
             */
            AppropriationInfoMotify.prototype.motifyCharge = 0;

            /**
             * AppropriationInfoMotify description.
             * @member {string} description
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoMotify
             * @instance
             */
            AppropriationInfoMotify.prototype.description = "";

            /**
             * AppropriationInfoMotify infoType.
             * @member {number} infoType
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoMotify
             * @instance
             */
            AppropriationInfoMotify.prototype.infoType = 0;

            /**
             * AppropriationInfoMotify storeCodeMapping.
             * @member {string} storeCodeMapping
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoMotify
             * @instance
             */
            AppropriationInfoMotify.prototype.storeCodeMapping = "";

            /**
             * Creates a new AppropriationInfoMotify instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoMotify
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationInfoMotify=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationInfoMotify} AppropriationInfoMotify instance
             */
            AppropriationInfoMotify.create = function create(properties) {
                return new AppropriationInfoMotify(properties);
            };

            /**
             * Encodes the specified AppropriationInfoMotify message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationInfoMotify.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoMotify
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationInfoMotify} message AppropriationInfoMotify message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationInfoMotify.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.appropriationMotifyId != null && Object.hasOwnProperty.call(message, "appropriationMotifyId"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.appropriationMotifyId);
                if (message.storeCode != null && Object.hasOwnProperty.call(message, "storeCode"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.storeCode);
                if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.date);
                if (message.reimbursementDate != null && Object.hasOwnProperty.call(message, "reimbursementDate"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.reimbursementDate);
                if (message.batchNo != null && Object.hasOwnProperty.call(message, "batchNo"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.batchNo);
                if (message.motifyAmount != null && Object.hasOwnProperty.call(message, "motifyAmount"))
                    writer.uint32(/* id 6, wireType 1 =*/49).double(message.motifyAmount);
                if (message.motifyCharge != null && Object.hasOwnProperty.call(message, "motifyCharge"))
                    writer.uint32(/* id 7, wireType 1 =*/57).double(message.motifyCharge);
                if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.description);
                if (message.infoType != null && Object.hasOwnProperty.call(message, "infoType"))
                    writer.uint32(/* id 9, wireType 0 =*/72).int32(message.infoType);
                if (message.storeCodeMapping != null && Object.hasOwnProperty.call(message, "storeCodeMapping"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.storeCodeMapping);
                return writer;
            };

            /**
             * Encodes the specified AppropriationInfoMotify message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationInfoMotify.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoMotify
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationInfoMotify} message AppropriationInfoMotify message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationInfoMotify.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationInfoMotify message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoMotify
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationInfoMotify} AppropriationInfoMotify
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationInfoMotify.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationInfoMotify();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.appropriationMotifyId = reader.int32();
                        break;
                    case 2:
                        message.storeCode = reader.string();
                        break;
                    case 3:
                        message.date = reader.string();
                        break;
                    case 4:
                        message.reimbursementDate = reader.string();
                        break;
                    case 5:
                        message.batchNo = reader.string();
                        break;
                    case 6:
                        message.motifyAmount = reader.double();
                        break;
                    case 7:
                        message.motifyCharge = reader.double();
                        break;
                    case 8:
                        message.description = reader.string();
                        break;
                    case 9:
                        message.infoType = reader.int32();
                        break;
                    case 10:
                        message.storeCodeMapping = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationInfoMotify message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoMotify
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationInfoMotify} AppropriationInfoMotify
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationInfoMotify.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationInfoMotify message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoMotify
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationInfoMotify.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.appropriationMotifyId != null && message.hasOwnProperty("appropriationMotifyId"))
                    if (!$util.isInteger(message.appropriationMotifyId))
                        return "appropriationMotifyId: integer expected";
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    if (!$util.isString(message.storeCode))
                        return "storeCode: string expected";
                if (message.date != null && message.hasOwnProperty("date"))
                    if (!$util.isString(message.date))
                        return "date: string expected";
                if (message.reimbursementDate != null && message.hasOwnProperty("reimbursementDate"))
                    if (!$util.isString(message.reimbursementDate))
                        return "reimbursementDate: string expected";
                if (message.batchNo != null && message.hasOwnProperty("batchNo"))
                    if (!$util.isString(message.batchNo))
                        return "batchNo: string expected";
                if (message.motifyAmount != null && message.hasOwnProperty("motifyAmount"))
                    if (typeof message.motifyAmount !== "number")
                        return "motifyAmount: number expected";
                if (message.motifyCharge != null && message.hasOwnProperty("motifyCharge"))
                    if (typeof message.motifyCharge !== "number")
                        return "motifyCharge: number expected";
                if (message.description != null && message.hasOwnProperty("description"))
                    if (!$util.isString(message.description))
                        return "description: string expected";
                if (message.infoType != null && message.hasOwnProperty("infoType"))
                    if (!$util.isInteger(message.infoType))
                        return "infoType: integer expected";
                if (message.storeCodeMapping != null && message.hasOwnProperty("storeCodeMapping"))
                    if (!$util.isString(message.storeCodeMapping))
                        return "storeCodeMapping: string expected";
                return null;
            };

            /**
             * Creates an AppropriationInfoMotify message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoMotify
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationInfoMotify} AppropriationInfoMotify
             */
            AppropriationInfoMotify.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationInfoMotify)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationInfoMotify();
                if (object.appropriationMotifyId != null)
                    message.appropriationMotifyId = object.appropriationMotifyId | 0;
                if (object.storeCode != null)
                    message.storeCode = String(object.storeCode);
                if (object.date != null)
                    message.date = String(object.date);
                if (object.reimbursementDate != null)
                    message.reimbursementDate = String(object.reimbursementDate);
                if (object.batchNo != null)
                    message.batchNo = String(object.batchNo);
                if (object.motifyAmount != null)
                    message.motifyAmount = Number(object.motifyAmount);
                if (object.motifyCharge != null)
                    message.motifyCharge = Number(object.motifyCharge);
                if (object.description != null)
                    message.description = String(object.description);
                if (object.infoType != null)
                    message.infoType = object.infoType | 0;
                if (object.storeCodeMapping != null)
                    message.storeCodeMapping = String(object.storeCodeMapping);
                return message;
            };

            /**
             * Creates a plain object from an AppropriationInfoMotify message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoMotify
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationInfoMotify} message AppropriationInfoMotify
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationInfoMotify.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.appropriationMotifyId = 0;
                    object.storeCode = "";
                    object.date = "";
                    object.reimbursementDate = "";
                    object.batchNo = "";
                    object.motifyAmount = 0;
                    object.motifyCharge = 0;
                    object.description = "";
                    object.infoType = 0;
                    object.storeCodeMapping = "";
                }
                if (message.appropriationMotifyId != null && message.hasOwnProperty("appropriationMotifyId"))
                    object.appropriationMotifyId = message.appropriationMotifyId;
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    object.storeCode = message.storeCode;
                if (message.date != null && message.hasOwnProperty("date"))
                    object.date = message.date;
                if (message.reimbursementDate != null && message.hasOwnProperty("reimbursementDate"))
                    object.reimbursementDate = message.reimbursementDate;
                if (message.batchNo != null && message.hasOwnProperty("batchNo"))
                    object.batchNo = message.batchNo;
                if (message.motifyAmount != null && message.hasOwnProperty("motifyAmount"))
                    object.motifyAmount = options.json && !isFinite(message.motifyAmount) ? String(message.motifyAmount) : message.motifyAmount;
                if (message.motifyCharge != null && message.hasOwnProperty("motifyCharge"))
                    object.motifyCharge = options.json && !isFinite(message.motifyCharge) ? String(message.motifyCharge) : message.motifyCharge;
                if (message.description != null && message.hasOwnProperty("description"))
                    object.description = message.description;
                if (message.infoType != null && message.hasOwnProperty("infoType"))
                    object.infoType = message.infoType;
                if (message.storeCodeMapping != null && message.hasOwnProperty("storeCodeMapping"))
                    object.storeCodeMapping = message.storeCodeMapping;
                return object;
            };

            /**
             * Converts this AppropriationInfoMotify to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoMotify
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationInfoMotify.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationInfoMotify;
        })();

        Protobuf.AppropriationMotify = (function() {

            /**
             * Properties of an AppropriationMotify.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationMotify
             * @property {Array.<TCBReceiptApi.Protobuf.IAppropriationInfoMotify>|null} [list] AppropriationMotify list
             */

            /**
             * Constructs a new AppropriationMotify.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationMotify.
             * @implements IAppropriationMotify
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationMotify=} [properties] Properties to set
             */
            function AppropriationMotify(properties) {
                this.list = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationMotify list.
             * @member {Array.<TCBReceiptApi.Protobuf.IAppropriationInfoMotify>} list
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotify
             * @instance
             */
            AppropriationMotify.prototype.list = $util.emptyArray;

            /**
             * Creates a new AppropriationMotify instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotify
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationMotify=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationMotify} AppropriationMotify instance
             */
            AppropriationMotify.create = function create(properties) {
                return new AppropriationMotify(properties);
            };

            /**
             * Encodes the specified AppropriationMotify message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationMotify.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotify
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationMotify} message AppropriationMotify message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationMotify.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.list != null && message.list.length)
                    for (var i = 0; i < message.list.length; ++i)
                        $root.TCBReceiptApi.Protobuf.AppropriationInfoMotify.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified AppropriationMotify message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationMotify.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotify
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationMotify} message AppropriationMotify message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationMotify.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationMotify message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotify
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationMotify} AppropriationMotify
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationMotify.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationMotify();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.TCBReceiptApi.Protobuf.AppropriationInfoMotify.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationMotify message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotify
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationMotify} AppropriationMotify
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationMotify.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationMotify message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotify
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationMotify.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.list != null && message.hasOwnProperty("list")) {
                    if (!Array.isArray(message.list))
                        return "list: array expected";
                    for (var i = 0; i < message.list.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.AppropriationInfoMotify.verify(message.list[i]);
                        if (error)
                            return "list." + error;
                    }
                }
                return null;
            };

            /**
             * Creates an AppropriationMotify message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotify
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationMotify} AppropriationMotify
             */
            AppropriationMotify.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationMotify)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationMotify();
                if (object.list) {
                    if (!Array.isArray(object.list))
                        throw TypeError(".TCBReceiptApi.Protobuf.AppropriationMotify.list: array expected");
                    message.list = [];
                    for (var i = 0; i < object.list.length; ++i) {
                        if (typeof object.list[i] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.AppropriationMotify.list: object expected");
                        message.list[i] = $root.TCBReceiptApi.Protobuf.AppropriationInfoMotify.fromObject(object.list[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from an AppropriationMotify message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotify
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationMotify} message AppropriationMotify
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationMotify.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.list = [];
                if (message.list && message.list.length) {
                    object.list = [];
                    for (var j = 0; j < message.list.length; ++j)
                        object.list[j] = $root.TCBReceiptApi.Protobuf.AppropriationInfoMotify.toObject(message.list[j], options);
                }
                return object;
            };

            /**
             * Converts this AppropriationMotify to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotify
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationMotify.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationMotify;
        })();

        Protobuf.AppropriationMotifyDateMap = (function() {

            /**
             * Properties of an AppropriationMotifyDateMap.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationMotifyDateMap
             * @property {Object.<string,TCBReceiptApi.Protobuf.IAppropriationMotify>|null} [byDate] AppropriationMotifyDateMap byDate
             */

            /**
             * Constructs a new AppropriationMotifyDateMap.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationMotifyDateMap.
             * @implements IAppropriationMotifyDateMap
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationMotifyDateMap=} [properties] Properties to set
             */
            function AppropriationMotifyDateMap(properties) {
                this.byDate = {};
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationMotifyDateMap byDate.
             * @member {Object.<string,TCBReceiptApi.Protobuf.IAppropriationMotify>} byDate
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyDateMap
             * @instance
             */
            AppropriationMotifyDateMap.prototype.byDate = $util.emptyObject;

            /**
             * Creates a new AppropriationMotifyDateMap instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyDateMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationMotifyDateMap=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationMotifyDateMap} AppropriationMotifyDateMap instance
             */
            AppropriationMotifyDateMap.create = function create(properties) {
                return new AppropriationMotifyDateMap(properties);
            };

            /**
             * Encodes the specified AppropriationMotifyDateMap message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationMotifyDateMap.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyDateMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationMotifyDateMap} message AppropriationMotifyDateMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationMotifyDateMap.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.byDate != null && Object.hasOwnProperty.call(message, "byDate"))
                    for (var keys = Object.keys(message.byDate), i = 0; i < keys.length; ++i) {
                        writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                        $root.TCBReceiptApi.Protobuf.AppropriationMotify.encode(message.byDate[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                    }
                return writer;
            };

            /**
             * Encodes the specified AppropriationMotifyDateMap message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationMotifyDateMap.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyDateMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationMotifyDateMap} message AppropriationMotifyDateMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationMotifyDateMap.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationMotifyDateMap message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyDateMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationMotifyDateMap} AppropriationMotifyDateMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationMotifyDateMap.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationMotifyDateMap(), key, value;
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (message.byDate === $util.emptyObject)
                            message.byDate = {};
                        var end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = null;
                        while (reader.pos < end2) {
                            var tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = $root.TCBReceiptApi.Protobuf.AppropriationMotify.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.byDate[key] = value;
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationMotifyDateMap message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyDateMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationMotifyDateMap} AppropriationMotifyDateMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationMotifyDateMap.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationMotifyDateMap message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyDateMap
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationMotifyDateMap.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.byDate != null && message.hasOwnProperty("byDate")) {
                    if (!$util.isObject(message.byDate))
                        return "byDate: object expected";
                    var key = Object.keys(message.byDate);
                    for (var i = 0; i < key.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.AppropriationMotify.verify(message.byDate[key[i]]);
                        if (error)
                            return "byDate." + error;
                    }
                }
                return null;
            };

            /**
             * Creates an AppropriationMotifyDateMap message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyDateMap
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationMotifyDateMap} AppropriationMotifyDateMap
             */
            AppropriationMotifyDateMap.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationMotifyDateMap)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationMotifyDateMap();
                if (object.byDate) {
                    if (typeof object.byDate !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.AppropriationMotifyDateMap.byDate: object expected");
                    message.byDate = {};
                    for (var keys = Object.keys(object.byDate), i = 0; i < keys.length; ++i) {
                        if (typeof object.byDate[keys[i]] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.AppropriationMotifyDateMap.byDate: object expected");
                        message.byDate[keys[i]] = $root.TCBReceiptApi.Protobuf.AppropriationMotify.fromObject(object.byDate[keys[i]]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from an AppropriationMotifyDateMap message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyDateMap
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationMotifyDateMap} message AppropriationMotifyDateMap
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationMotifyDateMap.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.objects || options.defaults)
                    object.byDate = {};
                var keys2;
                if (message.byDate && (keys2 = Object.keys(message.byDate)).length) {
                    object.byDate = {};
                    for (var j = 0; j < keys2.length; ++j)
                        object.byDate[keys2[j]] = $root.TCBReceiptApi.Protobuf.AppropriationMotify.toObject(message.byDate[keys2[j]], options);
                }
                return object;
            };

            /**
             * Converts this AppropriationMotifyDateMap to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyDateMap
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationMotifyDateMap.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationMotifyDateMap;
        })();

        Protobuf.AppropriationMotifyTotal = (function() {

            /**
             * Properties of an AppropriationMotifyTotal.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationMotifyTotal
             * @property {number|null} [count] AppropriationMotifyTotal count
             * @property {number|null} [total] AppropriationMotifyTotal total
             */

            /**
             * Constructs a new AppropriationMotifyTotal.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationMotifyTotal.
             * @implements IAppropriationMotifyTotal
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationMotifyTotal=} [properties] Properties to set
             */
            function AppropriationMotifyTotal(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationMotifyTotal count.
             * @member {number} count
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyTotal
             * @instance
             */
            AppropriationMotifyTotal.prototype.count = 0;

            /**
             * AppropriationMotifyTotal total.
             * @member {number} total
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyTotal
             * @instance
             */
            AppropriationMotifyTotal.prototype.total = 0;

            /**
             * Creates a new AppropriationMotifyTotal instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationMotifyTotal=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationMotifyTotal} AppropriationMotifyTotal instance
             */
            AppropriationMotifyTotal.create = function create(properties) {
                return new AppropriationMotifyTotal(properties);
            };

            /**
             * Encodes the specified AppropriationMotifyTotal message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationMotifyTotal.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationMotifyTotal} message AppropriationMotifyTotal message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationMotifyTotal.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.count != null && Object.hasOwnProperty.call(message, "count"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.count);
                if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                    writer.uint32(/* id 2, wireType 1 =*/17).double(message.total);
                return writer;
            };

            /**
             * Encodes the specified AppropriationMotifyTotal message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationMotifyTotal.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationMotifyTotal} message AppropriationMotifyTotal message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationMotifyTotal.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationMotifyTotal message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyTotal
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationMotifyTotal} AppropriationMotifyTotal
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationMotifyTotal.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationMotifyTotal();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.count = reader.int32();
                        break;
                    case 2:
                        message.total = reader.double();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationMotifyTotal message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyTotal
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationMotifyTotal} AppropriationMotifyTotal
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationMotifyTotal.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationMotifyTotal message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyTotal
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationMotifyTotal.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.count != null && message.hasOwnProperty("count"))
                    if (!$util.isInteger(message.count))
                        return "count: integer expected";
                if (message.total != null && message.hasOwnProperty("total"))
                    if (typeof message.total !== "number")
                        return "total: number expected";
                return null;
            };

            /**
             * Creates an AppropriationMotifyTotal message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyTotal
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationMotifyTotal} AppropriationMotifyTotal
             */
            AppropriationMotifyTotal.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationMotifyTotal)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationMotifyTotal();
                if (object.count != null)
                    message.count = object.count | 0;
                if (object.total != null)
                    message.total = Number(object.total);
                return message;
            };

            /**
             * Creates a plain object from an AppropriationMotifyTotal message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationMotifyTotal} message AppropriationMotifyTotal
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationMotifyTotal.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.count = 0;
                    object.total = 0;
                }
                if (message.count != null && message.hasOwnProperty("count"))
                    object.count = message.count;
                if (message.total != null && message.hasOwnProperty("total"))
                    object.total = options.json && !isFinite(message.total) ? String(message.total) : message.total;
                return object;
            };

            /**
             * Converts this AppropriationMotifyTotal to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyTotal
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationMotifyTotal.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationMotifyTotal;
        })();

        Protobuf.Appropriation = (function() {

            /**
             * Properties of an Appropriation.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriation
             * @property {TCBReceiptApi.Protobuf.IAppropriationCreditFirstMap|null} [card] Appropriation card
             * @property {TCBReceiptApi.Protobuf.IAppropriationAlipayDateMap|null} [alipay] Appropriation alipay
             * @property {TCBReceiptApi.Protobuf.IAppropriationMotifyDateMap|null} [motify] Appropriation motify
             * @property {TCBReceiptApi.Protobuf.IAppropriationCreditFirstMap|null} [cardByType] Appropriation cardByType
             */

            /**
             * Constructs a new Appropriation.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an Appropriation.
             * @implements IAppropriation
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriation=} [properties] Properties to set
             */
            function Appropriation(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Appropriation card.
             * @member {TCBReceiptApi.Protobuf.IAppropriationCreditFirstMap|null|undefined} card
             * @memberof TCBReceiptApi.Protobuf.Appropriation
             * @instance
             */
            Appropriation.prototype.card = null;

            /**
             * Appropriation alipay.
             * @member {TCBReceiptApi.Protobuf.IAppropriationAlipayDateMap|null|undefined} alipay
             * @memberof TCBReceiptApi.Protobuf.Appropriation
             * @instance
             */
            Appropriation.prototype.alipay = null;

            /**
             * Appropriation motify.
             * @member {TCBReceiptApi.Protobuf.IAppropriationMotifyDateMap|null|undefined} motify
             * @memberof TCBReceiptApi.Protobuf.Appropriation
             * @instance
             */
            Appropriation.prototype.motify = null;

            /**
             * Appropriation cardByType.
             * @member {TCBReceiptApi.Protobuf.IAppropriationCreditFirstMap|null|undefined} cardByType
             * @memberof TCBReceiptApi.Protobuf.Appropriation
             * @instance
             */
            Appropriation.prototype.cardByType = null;

            /**
             * Creates a new Appropriation instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.Appropriation
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriation=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.Appropriation} Appropriation instance
             */
            Appropriation.create = function create(properties) {
                return new Appropriation(properties);
            };

            /**
             * Encodes the specified Appropriation message. Does not implicitly {@link TCBReceiptApi.Protobuf.Appropriation.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.Appropriation
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriation} message Appropriation message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Appropriation.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.card != null && Object.hasOwnProperty.call(message, "card"))
                    $root.TCBReceiptApi.Protobuf.AppropriationCreditFirstMap.encode(message.card, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.alipay != null && Object.hasOwnProperty.call(message, "alipay"))
                    $root.TCBReceiptApi.Protobuf.AppropriationAlipayDateMap.encode(message.alipay, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.motify != null && Object.hasOwnProperty.call(message, "motify"))
                    $root.TCBReceiptApi.Protobuf.AppropriationMotifyDateMap.encode(message.motify, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.cardByType != null && Object.hasOwnProperty.call(message, "cardByType"))
                    $root.TCBReceiptApi.Protobuf.AppropriationCreditFirstMap.encode(message.cardByType, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Appropriation message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.Appropriation.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.Appropriation
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriation} message Appropriation message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Appropriation.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Appropriation message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.Appropriation
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.Appropriation} Appropriation
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Appropriation.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.Appropriation();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.card = $root.TCBReceiptApi.Protobuf.AppropriationCreditFirstMap.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.alipay = $root.TCBReceiptApi.Protobuf.AppropriationAlipayDateMap.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.motify = $root.TCBReceiptApi.Protobuf.AppropriationMotifyDateMap.decode(reader, reader.uint32());
                        break;
                    case 4:
                        message.cardByType = $root.TCBReceiptApi.Protobuf.AppropriationCreditFirstMap.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Appropriation message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.Appropriation
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.Appropriation} Appropriation
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Appropriation.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Appropriation message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.Appropriation
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Appropriation.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.card != null && message.hasOwnProperty("card")) {
                    var error = $root.TCBReceiptApi.Protobuf.AppropriationCreditFirstMap.verify(message.card);
                    if (error)
                        return "card." + error;
                }
                if (message.alipay != null && message.hasOwnProperty("alipay")) {
                    var error = $root.TCBReceiptApi.Protobuf.AppropriationAlipayDateMap.verify(message.alipay);
                    if (error)
                        return "alipay." + error;
                }
                if (message.motify != null && message.hasOwnProperty("motify")) {
                    var error = $root.TCBReceiptApi.Protobuf.AppropriationMotifyDateMap.verify(message.motify);
                    if (error)
                        return "motify." + error;
                }
                if (message.cardByType != null && message.hasOwnProperty("cardByType")) {
                    var error = $root.TCBReceiptApi.Protobuf.AppropriationCreditFirstMap.verify(message.cardByType);
                    if (error)
                        return "cardByType." + error;
                }
                return null;
            };

            /**
             * Creates an Appropriation message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.Appropriation
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.Appropriation} Appropriation
             */
            Appropriation.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.Appropriation)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.Appropriation();
                if (object.card != null) {
                    if (typeof object.card !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.Appropriation.card: object expected");
                    message.card = $root.TCBReceiptApi.Protobuf.AppropriationCreditFirstMap.fromObject(object.card);
                }
                if (object.alipay != null) {
                    if (typeof object.alipay !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.Appropriation.alipay: object expected");
                    message.alipay = $root.TCBReceiptApi.Protobuf.AppropriationAlipayDateMap.fromObject(object.alipay);
                }
                if (object.motify != null) {
                    if (typeof object.motify !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.Appropriation.motify: object expected");
                    message.motify = $root.TCBReceiptApi.Protobuf.AppropriationMotifyDateMap.fromObject(object.motify);
                }
                if (object.cardByType != null) {
                    if (typeof object.cardByType !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.Appropriation.cardByType: object expected");
                    message.cardByType = $root.TCBReceiptApi.Protobuf.AppropriationCreditFirstMap.fromObject(object.cardByType);
                }
                return message;
            };

            /**
             * Creates a plain object from an Appropriation message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.Appropriation
             * @static
             * @param {TCBReceiptApi.Protobuf.Appropriation} message Appropriation
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Appropriation.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.card = null;
                    object.alipay = null;
                    object.motify = null;
                    object.cardByType = null;
                }
                if (message.card != null && message.hasOwnProperty("card"))
                    object.card = $root.TCBReceiptApi.Protobuf.AppropriationCreditFirstMap.toObject(message.card, options);
                if (message.alipay != null && message.hasOwnProperty("alipay"))
                    object.alipay = $root.TCBReceiptApi.Protobuf.AppropriationAlipayDateMap.toObject(message.alipay, options);
                if (message.motify != null && message.hasOwnProperty("motify"))
                    object.motify = $root.TCBReceiptApi.Protobuf.AppropriationMotifyDateMap.toObject(message.motify, options);
                if (message.cardByType != null && message.hasOwnProperty("cardByType"))
                    object.cardByType = $root.TCBReceiptApi.Protobuf.AppropriationCreditFirstMap.toObject(message.cardByType, options);
                return object;
            };

            /**
             * Converts this Appropriation to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.Appropriation
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Appropriation.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Appropriation;
        })();

        Protobuf.AppropriationMap = (function() {

            /**
             * Properties of an AppropriationMap.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationMap
             * @property {Object.<string,TCBReceiptApi.Protobuf.IAppropriation>|null} [map] AppropriationMap map
             */

            /**
             * Constructs a new AppropriationMap.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationMap.
             * @implements IAppropriationMap
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationMap=} [properties] Properties to set
             */
            function AppropriationMap(properties) {
                this.map = {};
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationMap map.
             * @member {Object.<string,TCBReceiptApi.Protobuf.IAppropriation>} map
             * @memberof TCBReceiptApi.Protobuf.AppropriationMap
             * @instance
             */
            AppropriationMap.prototype.map = $util.emptyObject;

            /**
             * Creates a new AppropriationMap instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationMap=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationMap} AppropriationMap instance
             */
            AppropriationMap.create = function create(properties) {
                return new AppropriationMap(properties);
            };

            /**
             * Encodes the specified AppropriationMap message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationMap.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationMap} message AppropriationMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationMap.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.map != null && Object.hasOwnProperty.call(message, "map"))
                    for (var keys = Object.keys(message.map), i = 0; i < keys.length; ++i) {
                        writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                        $root.TCBReceiptApi.Protobuf.Appropriation.encode(message.map[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                    }
                return writer;
            };

            /**
             * Encodes the specified AppropriationMap message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationMap.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationMap} message AppropriationMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationMap.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationMap message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationMap} AppropriationMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationMap.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationMap(), key, value;
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (message.map === $util.emptyObject)
                            message.map = {};
                        var end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = null;
                        while (reader.pos < end2) {
                            var tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = $root.TCBReceiptApi.Protobuf.Appropriation.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.map[key] = value;
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationMap message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationMap} AppropriationMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationMap.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationMap message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationMap
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationMap.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.map != null && message.hasOwnProperty("map")) {
                    if (!$util.isObject(message.map))
                        return "map: object expected";
                    var key = Object.keys(message.map);
                    for (var i = 0; i < key.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.Appropriation.verify(message.map[key[i]]);
                        if (error)
                            return "map." + error;
                    }
                }
                return null;
            };

            /**
             * Creates an AppropriationMap message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationMap
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationMap} AppropriationMap
             */
            AppropriationMap.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationMap)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationMap();
                if (object.map) {
                    if (typeof object.map !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.AppropriationMap.map: object expected");
                    message.map = {};
                    for (var keys = Object.keys(object.map), i = 0; i < keys.length; ++i) {
                        if (typeof object.map[keys[i]] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.AppropriationMap.map: object expected");
                        message.map[keys[i]] = $root.TCBReceiptApi.Protobuf.Appropriation.fromObject(object.map[keys[i]]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from an AppropriationMap message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationMap
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationMap} message AppropriationMap
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationMap.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.objects || options.defaults)
                    object.map = {};
                var keys2;
                if (message.map && (keys2 = Object.keys(message.map)).length) {
                    object.map = {};
                    for (var j = 0; j < keys2.length; ++j)
                        object.map[keys2[j]] = $root.TCBReceiptApi.Protobuf.Appropriation.toObject(message.map[keys2[j]], options);
                }
                return object;
            };

            /**
             * Converts this AppropriationMap to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationMap
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationMap.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationMap;
        })();

        Protobuf.AppropriationTotal = (function() {

            /**
             * Properties of an AppropriationTotal.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationTotal
             * @property {TCBReceiptApi.Protobuf.IAppropriationCreditTotal|null} [card] AppropriationTotal card
             * @property {TCBReceiptApi.Protobuf.IAppropriationAlipayTotal|null} [alipay] AppropriationTotal alipay
             * @property {TCBReceiptApi.Protobuf.IAppropriationMotifyTotal|null} [motify] AppropriationTotal motify
             */

            /**
             * Constructs a new AppropriationTotal.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationTotal.
             * @implements IAppropriationTotal
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationTotal=} [properties] Properties to set
             */
            function AppropriationTotal(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationTotal card.
             * @member {TCBReceiptApi.Protobuf.IAppropriationCreditTotal|null|undefined} card
             * @memberof TCBReceiptApi.Protobuf.AppropriationTotal
             * @instance
             */
            AppropriationTotal.prototype.card = null;

            /**
             * AppropriationTotal alipay.
             * @member {TCBReceiptApi.Protobuf.IAppropriationAlipayTotal|null|undefined} alipay
             * @memberof TCBReceiptApi.Protobuf.AppropriationTotal
             * @instance
             */
            AppropriationTotal.prototype.alipay = null;

            /**
             * AppropriationTotal motify.
             * @member {TCBReceiptApi.Protobuf.IAppropriationMotifyTotal|null|undefined} motify
             * @memberof TCBReceiptApi.Protobuf.AppropriationTotal
             * @instance
             */
            AppropriationTotal.prototype.motify = null;

            /**
             * Creates a new AppropriationTotal instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationTotal=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationTotal} AppropriationTotal instance
             */
            AppropriationTotal.create = function create(properties) {
                return new AppropriationTotal(properties);
            };

            /**
             * Encodes the specified AppropriationTotal message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationTotal.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationTotal} message AppropriationTotal message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationTotal.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.card != null && Object.hasOwnProperty.call(message, "card"))
                    $root.TCBReceiptApi.Protobuf.AppropriationCreditTotal.encode(message.card, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.alipay != null && Object.hasOwnProperty.call(message, "alipay"))
                    $root.TCBReceiptApi.Protobuf.AppropriationAlipayTotal.encode(message.alipay, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.motify != null && Object.hasOwnProperty.call(message, "motify"))
                    $root.TCBReceiptApi.Protobuf.AppropriationMotifyTotal.encode(message.motify, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified AppropriationTotal message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationTotal.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationTotal} message AppropriationTotal message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationTotal.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationTotal message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationTotal
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationTotal} AppropriationTotal
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationTotal.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationTotal();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.card = $root.TCBReceiptApi.Protobuf.AppropriationCreditTotal.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.alipay = $root.TCBReceiptApi.Protobuf.AppropriationAlipayTotal.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.motify = $root.TCBReceiptApi.Protobuf.AppropriationMotifyTotal.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationTotal message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationTotal
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationTotal} AppropriationTotal
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationTotal.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationTotal message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationTotal
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationTotal.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.card != null && message.hasOwnProperty("card")) {
                    var error = $root.TCBReceiptApi.Protobuf.AppropriationCreditTotal.verify(message.card);
                    if (error)
                        return "card." + error;
                }
                if (message.alipay != null && message.hasOwnProperty("alipay")) {
                    var error = $root.TCBReceiptApi.Protobuf.AppropriationAlipayTotal.verify(message.alipay);
                    if (error)
                        return "alipay." + error;
                }
                if (message.motify != null && message.hasOwnProperty("motify")) {
                    var error = $root.TCBReceiptApi.Protobuf.AppropriationMotifyTotal.verify(message.motify);
                    if (error)
                        return "motify." + error;
                }
                return null;
            };

            /**
             * Creates an AppropriationTotal message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationTotal
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationTotal} AppropriationTotal
             */
            AppropriationTotal.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationTotal)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationTotal();
                if (object.card != null) {
                    if (typeof object.card !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.AppropriationTotal.card: object expected");
                    message.card = $root.TCBReceiptApi.Protobuf.AppropriationCreditTotal.fromObject(object.card);
                }
                if (object.alipay != null) {
                    if (typeof object.alipay !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.AppropriationTotal.alipay: object expected");
                    message.alipay = $root.TCBReceiptApi.Protobuf.AppropriationAlipayTotal.fromObject(object.alipay);
                }
                if (object.motify != null) {
                    if (typeof object.motify !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.AppropriationTotal.motify: object expected");
                    message.motify = $root.TCBReceiptApi.Protobuf.AppropriationMotifyTotal.fromObject(object.motify);
                }
                return message;
            };

            /**
             * Creates a plain object from an AppropriationTotal message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationTotal} message AppropriationTotal
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationTotal.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.card = null;
                    object.alipay = null;
                    object.motify = null;
                }
                if (message.card != null && message.hasOwnProperty("card"))
                    object.card = $root.TCBReceiptApi.Protobuf.AppropriationCreditTotal.toObject(message.card, options);
                if (message.alipay != null && message.hasOwnProperty("alipay"))
                    object.alipay = $root.TCBReceiptApi.Protobuf.AppropriationAlipayTotal.toObject(message.alipay, options);
                if (message.motify != null && message.hasOwnProperty("motify"))
                    object.motify = $root.TCBReceiptApi.Protobuf.AppropriationMotifyTotal.toObject(message.motify, options);
                return object;
            };

            /**
             * Converts this AppropriationTotal to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationTotal
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationTotal.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationTotal;
        })();

        Protobuf.AppropriationInfoSummary = (function() {

            /**
             * Properties of an AppropriationInfoSummary.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationInfoSummary
             * @property {number|null} [appropriationSummaryId] AppropriationInfoSummary appropriationSummaryId
             * @property {string|null} [storeCode] AppropriationInfoSummary storeCode
             * @property {string|null} [terminalNo] AppropriationInfoSummary terminalNo
             * @property {string|null} [date] AppropriationInfoSummary date
             * @property {string|null} [submitDate] AppropriationInfoSummary submitDate
             * @property {number|null} [totalCount] AppropriationInfoSummary totalCount
             * @property {number|null} [totalAmount] AppropriationInfoSummary totalAmount
             * @property {number|null} [salesCount] AppropriationInfoSummary salesCount
             * @property {number|null} [salesAmount] AppropriationInfoSummary salesAmount
             * @property {number|null} [returnCount] AppropriationInfoSummary returnCount
             * @property {number|null} [returnAmount] AppropriationInfoSummary returnAmount
             * @property {number|null} [charge] AppropriationInfoSummary charge
             * @property {number|null} [ifr] AppropriationInfoSummary ifr
             * @property {number|null} [motifyAmount] AppropriationInfoSummary motifyAmount
             * @property {number|null} [motifyCharge] AppropriationInfoSummary motifyCharge
             * @property {number|null} [installRate] AppropriationInfoSummary installRate
             * @property {number|null} [chargeRate] AppropriationInfoSummary chargeRate
             * @property {number|null} [netAmount] AppropriationInfoSummary netAmount
             * @property {number|null} [infoType] AppropriationInfoSummary infoType
             * @property {number|null} [typeFlag] AppropriationInfoSummary typeFlag
             * @property {string|null} [typeFlagOrigin] AppropriationInfoSummary typeFlagOrigin
             * @property {string|null} [storeCodeMapping] AppropriationInfoSummary storeCodeMapping
             */

            /**
             * Constructs a new AppropriationInfoSummary.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationInfoSummary.
             * @implements IAppropriationInfoSummary
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationInfoSummary=} [properties] Properties to set
             */
            function AppropriationInfoSummary(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationInfoSummary appropriationSummaryId.
             * @member {number} appropriationSummaryId
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummary
             * @instance
             */
            AppropriationInfoSummary.prototype.appropriationSummaryId = 0;

            /**
             * AppropriationInfoSummary storeCode.
             * @member {string} storeCode
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummary
             * @instance
             */
            AppropriationInfoSummary.prototype.storeCode = "";

            /**
             * AppropriationInfoSummary terminalNo.
             * @member {string} terminalNo
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummary
             * @instance
             */
            AppropriationInfoSummary.prototype.terminalNo = "";

            /**
             * AppropriationInfoSummary date.
             * @member {string} date
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummary
             * @instance
             */
            AppropriationInfoSummary.prototype.date = "";

            /**
             * AppropriationInfoSummary submitDate.
             * @member {string} submitDate
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummary
             * @instance
             */
            AppropriationInfoSummary.prototype.submitDate = "";

            /**
             * AppropriationInfoSummary totalCount.
             * @member {number} totalCount
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummary
             * @instance
             */
            AppropriationInfoSummary.prototype.totalCount = 0;

            /**
             * AppropriationInfoSummary totalAmount.
             * @member {number} totalAmount
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummary
             * @instance
             */
            AppropriationInfoSummary.prototype.totalAmount = 0;

            /**
             * AppropriationInfoSummary salesCount.
             * @member {number} salesCount
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummary
             * @instance
             */
            AppropriationInfoSummary.prototype.salesCount = 0;

            /**
             * AppropriationInfoSummary salesAmount.
             * @member {number} salesAmount
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummary
             * @instance
             */
            AppropriationInfoSummary.prototype.salesAmount = 0;

            /**
             * AppropriationInfoSummary returnCount.
             * @member {number} returnCount
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummary
             * @instance
             */
            AppropriationInfoSummary.prototype.returnCount = 0;

            /**
             * AppropriationInfoSummary returnAmount.
             * @member {number} returnAmount
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummary
             * @instance
             */
            AppropriationInfoSummary.prototype.returnAmount = 0;

            /**
             * AppropriationInfoSummary charge.
             * @member {number} charge
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummary
             * @instance
             */
            AppropriationInfoSummary.prototype.charge = 0;

            /**
             * AppropriationInfoSummary ifr.
             * @member {number} ifr
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummary
             * @instance
             */
            AppropriationInfoSummary.prototype.ifr = 0;

            /**
             * AppropriationInfoSummary motifyAmount.
             * @member {number} motifyAmount
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummary
             * @instance
             */
            AppropriationInfoSummary.prototype.motifyAmount = 0;

            /**
             * AppropriationInfoSummary motifyCharge.
             * @member {number} motifyCharge
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummary
             * @instance
             */
            AppropriationInfoSummary.prototype.motifyCharge = 0;

            /**
             * AppropriationInfoSummary installRate.
             * @member {number} installRate
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummary
             * @instance
             */
            AppropriationInfoSummary.prototype.installRate = 0;

            /**
             * AppropriationInfoSummary chargeRate.
             * @member {number} chargeRate
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummary
             * @instance
             */
            AppropriationInfoSummary.prototype.chargeRate = 0;

            /**
             * AppropriationInfoSummary netAmount.
             * @member {number} netAmount
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummary
             * @instance
             */
            AppropriationInfoSummary.prototype.netAmount = 0;

            /**
             * AppropriationInfoSummary infoType.
             * @member {number} infoType
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummary
             * @instance
             */
            AppropriationInfoSummary.prototype.infoType = 0;

            /**
             * AppropriationInfoSummary typeFlag.
             * @member {number} typeFlag
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummary
             * @instance
             */
            AppropriationInfoSummary.prototype.typeFlag = 0;

            /**
             * AppropriationInfoSummary typeFlagOrigin.
             * @member {string} typeFlagOrigin
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummary
             * @instance
             */
            AppropriationInfoSummary.prototype.typeFlagOrigin = "";

            /**
             * AppropriationInfoSummary storeCodeMapping.
             * @member {string} storeCodeMapping
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummary
             * @instance
             */
            AppropriationInfoSummary.prototype.storeCodeMapping = "";

            /**
             * Creates a new AppropriationInfoSummary instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummary
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationInfoSummary=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationInfoSummary} AppropriationInfoSummary instance
             */
            AppropriationInfoSummary.create = function create(properties) {
                return new AppropriationInfoSummary(properties);
            };

            /**
             * Encodes the specified AppropriationInfoSummary message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationInfoSummary.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummary
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationInfoSummary} message AppropriationInfoSummary message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationInfoSummary.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.appropriationSummaryId != null && Object.hasOwnProperty.call(message, "appropriationSummaryId"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.appropriationSummaryId);
                if (message.storeCode != null && Object.hasOwnProperty.call(message, "storeCode"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.storeCode);
                if (message.terminalNo != null && Object.hasOwnProperty.call(message, "terminalNo"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.terminalNo);
                if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.date);
                if (message.submitDate != null && Object.hasOwnProperty.call(message, "submitDate"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.submitDate);
                if (message.totalCount != null && Object.hasOwnProperty.call(message, "totalCount"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int32(message.totalCount);
                if (message.totalAmount != null && Object.hasOwnProperty.call(message, "totalAmount"))
                    writer.uint32(/* id 7, wireType 1 =*/57).double(message.totalAmount);
                if (message.salesCount != null && Object.hasOwnProperty.call(message, "salesCount"))
                    writer.uint32(/* id 8, wireType 0 =*/64).int32(message.salesCount);
                if (message.salesAmount != null && Object.hasOwnProperty.call(message, "salesAmount"))
                    writer.uint32(/* id 9, wireType 1 =*/73).double(message.salesAmount);
                if (message.returnCount != null && Object.hasOwnProperty.call(message, "returnCount"))
                    writer.uint32(/* id 10, wireType 0 =*/80).int32(message.returnCount);
                if (message.returnAmount != null && Object.hasOwnProperty.call(message, "returnAmount"))
                    writer.uint32(/* id 11, wireType 1 =*/89).double(message.returnAmount);
                if (message.charge != null && Object.hasOwnProperty.call(message, "charge"))
                    writer.uint32(/* id 12, wireType 1 =*/97).double(message.charge);
                if (message.ifr != null && Object.hasOwnProperty.call(message, "ifr"))
                    writer.uint32(/* id 13, wireType 0 =*/104).int32(message.ifr);
                if (message.motifyAmount != null && Object.hasOwnProperty.call(message, "motifyAmount"))
                    writer.uint32(/* id 14, wireType 1 =*/113).double(message.motifyAmount);
                if (message.motifyCharge != null && Object.hasOwnProperty.call(message, "motifyCharge"))
                    writer.uint32(/* id 15, wireType 1 =*/121).double(message.motifyCharge);
                if (message.installRate != null && Object.hasOwnProperty.call(message, "installRate"))
                    writer.uint32(/* id 16, wireType 1 =*/129).double(message.installRate);
                if (message.chargeRate != null && Object.hasOwnProperty.call(message, "chargeRate"))
                    writer.uint32(/* id 17, wireType 0 =*/136).int32(message.chargeRate);
                if (message.netAmount != null && Object.hasOwnProperty.call(message, "netAmount"))
                    writer.uint32(/* id 18, wireType 1 =*/145).double(message.netAmount);
                if (message.infoType != null && Object.hasOwnProperty.call(message, "infoType"))
                    writer.uint32(/* id 19, wireType 0 =*/152).int32(message.infoType);
                if (message.typeFlag != null && Object.hasOwnProperty.call(message, "typeFlag"))
                    writer.uint32(/* id 20, wireType 0 =*/160).int32(message.typeFlag);
                if (message.typeFlagOrigin != null && Object.hasOwnProperty.call(message, "typeFlagOrigin"))
                    writer.uint32(/* id 21, wireType 2 =*/170).string(message.typeFlagOrigin);
                if (message.storeCodeMapping != null && Object.hasOwnProperty.call(message, "storeCodeMapping"))
                    writer.uint32(/* id 22, wireType 2 =*/178).string(message.storeCodeMapping);
                return writer;
            };

            /**
             * Encodes the specified AppropriationInfoSummary message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationInfoSummary.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummary
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationInfoSummary} message AppropriationInfoSummary message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationInfoSummary.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationInfoSummary message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummary
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationInfoSummary} AppropriationInfoSummary
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationInfoSummary.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationInfoSummary();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.appropriationSummaryId = reader.int32();
                        break;
                    case 2:
                        message.storeCode = reader.string();
                        break;
                    case 3:
                        message.terminalNo = reader.string();
                        break;
                    case 4:
                        message.date = reader.string();
                        break;
                    case 5:
                        message.submitDate = reader.string();
                        break;
                    case 6:
                        message.totalCount = reader.int32();
                        break;
                    case 7:
                        message.totalAmount = reader.double();
                        break;
                    case 8:
                        message.salesCount = reader.int32();
                        break;
                    case 9:
                        message.salesAmount = reader.double();
                        break;
                    case 10:
                        message.returnCount = reader.int32();
                        break;
                    case 11:
                        message.returnAmount = reader.double();
                        break;
                    case 12:
                        message.charge = reader.double();
                        break;
                    case 13:
                        message.ifr = reader.int32();
                        break;
                    case 14:
                        message.motifyAmount = reader.double();
                        break;
                    case 15:
                        message.motifyCharge = reader.double();
                        break;
                    case 16:
                        message.installRate = reader.double();
                        break;
                    case 17:
                        message.chargeRate = reader.int32();
                        break;
                    case 18:
                        message.netAmount = reader.double();
                        break;
                    case 19:
                        message.infoType = reader.int32();
                        break;
                    case 20:
                        message.typeFlag = reader.int32();
                        break;
                    case 21:
                        message.typeFlagOrigin = reader.string();
                        break;
                    case 22:
                        message.storeCodeMapping = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationInfoSummary message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummary
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationInfoSummary} AppropriationInfoSummary
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationInfoSummary.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationInfoSummary message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummary
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationInfoSummary.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.appropriationSummaryId != null && message.hasOwnProperty("appropriationSummaryId"))
                    if (!$util.isInteger(message.appropriationSummaryId))
                        return "appropriationSummaryId: integer expected";
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    if (!$util.isString(message.storeCode))
                        return "storeCode: string expected";
                if (message.terminalNo != null && message.hasOwnProperty("terminalNo"))
                    if (!$util.isString(message.terminalNo))
                        return "terminalNo: string expected";
                if (message.date != null && message.hasOwnProperty("date"))
                    if (!$util.isString(message.date))
                        return "date: string expected";
                if (message.submitDate != null && message.hasOwnProperty("submitDate"))
                    if (!$util.isString(message.submitDate))
                        return "submitDate: string expected";
                if (message.totalCount != null && message.hasOwnProperty("totalCount"))
                    if (!$util.isInteger(message.totalCount))
                        return "totalCount: integer expected";
                if (message.totalAmount != null && message.hasOwnProperty("totalAmount"))
                    if (typeof message.totalAmount !== "number")
                        return "totalAmount: number expected";
                if (message.salesCount != null && message.hasOwnProperty("salesCount"))
                    if (!$util.isInteger(message.salesCount))
                        return "salesCount: integer expected";
                if (message.salesAmount != null && message.hasOwnProperty("salesAmount"))
                    if (typeof message.salesAmount !== "number")
                        return "salesAmount: number expected";
                if (message.returnCount != null && message.hasOwnProperty("returnCount"))
                    if (!$util.isInteger(message.returnCount))
                        return "returnCount: integer expected";
                if (message.returnAmount != null && message.hasOwnProperty("returnAmount"))
                    if (typeof message.returnAmount !== "number")
                        return "returnAmount: number expected";
                if (message.charge != null && message.hasOwnProperty("charge"))
                    if (typeof message.charge !== "number")
                        return "charge: number expected";
                if (message.ifr != null && message.hasOwnProperty("ifr"))
                    if (!$util.isInteger(message.ifr))
                        return "ifr: integer expected";
                if (message.motifyAmount != null && message.hasOwnProperty("motifyAmount"))
                    if (typeof message.motifyAmount !== "number")
                        return "motifyAmount: number expected";
                if (message.motifyCharge != null && message.hasOwnProperty("motifyCharge"))
                    if (typeof message.motifyCharge !== "number")
                        return "motifyCharge: number expected";
                if (message.installRate != null && message.hasOwnProperty("installRate"))
                    if (typeof message.installRate !== "number")
                        return "installRate: number expected";
                if (message.chargeRate != null && message.hasOwnProperty("chargeRate"))
                    if (!$util.isInteger(message.chargeRate))
                        return "chargeRate: integer expected";
                if (message.netAmount != null && message.hasOwnProperty("netAmount"))
                    if (typeof message.netAmount !== "number")
                        return "netAmount: number expected";
                if (message.infoType != null && message.hasOwnProperty("infoType"))
                    if (!$util.isInteger(message.infoType))
                        return "infoType: integer expected";
                if (message.typeFlag != null && message.hasOwnProperty("typeFlag"))
                    if (!$util.isInteger(message.typeFlag))
                        return "typeFlag: integer expected";
                if (message.typeFlagOrigin != null && message.hasOwnProperty("typeFlagOrigin"))
                    if (!$util.isString(message.typeFlagOrigin))
                        return "typeFlagOrigin: string expected";
                if (message.storeCodeMapping != null && message.hasOwnProperty("storeCodeMapping"))
                    if (!$util.isString(message.storeCodeMapping))
                        return "storeCodeMapping: string expected";
                return null;
            };

            /**
             * Creates an AppropriationInfoSummary message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummary
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationInfoSummary} AppropriationInfoSummary
             */
            AppropriationInfoSummary.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationInfoSummary)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationInfoSummary();
                if (object.appropriationSummaryId != null)
                    message.appropriationSummaryId = object.appropriationSummaryId | 0;
                if (object.storeCode != null)
                    message.storeCode = String(object.storeCode);
                if (object.terminalNo != null)
                    message.terminalNo = String(object.terminalNo);
                if (object.date != null)
                    message.date = String(object.date);
                if (object.submitDate != null)
                    message.submitDate = String(object.submitDate);
                if (object.totalCount != null)
                    message.totalCount = object.totalCount | 0;
                if (object.totalAmount != null)
                    message.totalAmount = Number(object.totalAmount);
                if (object.salesCount != null)
                    message.salesCount = object.salesCount | 0;
                if (object.salesAmount != null)
                    message.salesAmount = Number(object.salesAmount);
                if (object.returnCount != null)
                    message.returnCount = object.returnCount | 0;
                if (object.returnAmount != null)
                    message.returnAmount = Number(object.returnAmount);
                if (object.charge != null)
                    message.charge = Number(object.charge);
                if (object.ifr != null)
                    message.ifr = object.ifr | 0;
                if (object.motifyAmount != null)
                    message.motifyAmount = Number(object.motifyAmount);
                if (object.motifyCharge != null)
                    message.motifyCharge = Number(object.motifyCharge);
                if (object.installRate != null)
                    message.installRate = Number(object.installRate);
                if (object.chargeRate != null)
                    message.chargeRate = object.chargeRate | 0;
                if (object.netAmount != null)
                    message.netAmount = Number(object.netAmount);
                if (object.infoType != null)
                    message.infoType = object.infoType | 0;
                if (object.typeFlag != null)
                    message.typeFlag = object.typeFlag | 0;
                if (object.typeFlagOrigin != null)
                    message.typeFlagOrigin = String(object.typeFlagOrigin);
                if (object.storeCodeMapping != null)
                    message.storeCodeMapping = String(object.storeCodeMapping);
                return message;
            };

            /**
             * Creates a plain object from an AppropriationInfoSummary message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummary
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationInfoSummary} message AppropriationInfoSummary
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationInfoSummary.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.appropriationSummaryId = 0;
                    object.storeCode = "";
                    object.terminalNo = "";
                    object.date = "";
                    object.submitDate = "";
                    object.totalCount = 0;
                    object.totalAmount = 0;
                    object.salesCount = 0;
                    object.salesAmount = 0;
                    object.returnCount = 0;
                    object.returnAmount = 0;
                    object.charge = 0;
                    object.ifr = 0;
                    object.motifyAmount = 0;
                    object.motifyCharge = 0;
                    object.installRate = 0;
                    object.chargeRate = 0;
                    object.netAmount = 0;
                    object.infoType = 0;
                    object.typeFlag = 0;
                    object.typeFlagOrigin = "";
                    object.storeCodeMapping = "";
                }
                if (message.appropriationSummaryId != null && message.hasOwnProperty("appropriationSummaryId"))
                    object.appropriationSummaryId = message.appropriationSummaryId;
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    object.storeCode = message.storeCode;
                if (message.terminalNo != null && message.hasOwnProperty("terminalNo"))
                    object.terminalNo = message.terminalNo;
                if (message.date != null && message.hasOwnProperty("date"))
                    object.date = message.date;
                if (message.submitDate != null && message.hasOwnProperty("submitDate"))
                    object.submitDate = message.submitDate;
                if (message.totalCount != null && message.hasOwnProperty("totalCount"))
                    object.totalCount = message.totalCount;
                if (message.totalAmount != null && message.hasOwnProperty("totalAmount"))
                    object.totalAmount = options.json && !isFinite(message.totalAmount) ? String(message.totalAmount) : message.totalAmount;
                if (message.salesCount != null && message.hasOwnProperty("salesCount"))
                    object.salesCount = message.salesCount;
                if (message.salesAmount != null && message.hasOwnProperty("salesAmount"))
                    object.salesAmount = options.json && !isFinite(message.salesAmount) ? String(message.salesAmount) : message.salesAmount;
                if (message.returnCount != null && message.hasOwnProperty("returnCount"))
                    object.returnCount = message.returnCount;
                if (message.returnAmount != null && message.hasOwnProperty("returnAmount"))
                    object.returnAmount = options.json && !isFinite(message.returnAmount) ? String(message.returnAmount) : message.returnAmount;
                if (message.charge != null && message.hasOwnProperty("charge"))
                    object.charge = options.json && !isFinite(message.charge) ? String(message.charge) : message.charge;
                if (message.ifr != null && message.hasOwnProperty("ifr"))
                    object.ifr = message.ifr;
                if (message.motifyAmount != null && message.hasOwnProperty("motifyAmount"))
                    object.motifyAmount = options.json && !isFinite(message.motifyAmount) ? String(message.motifyAmount) : message.motifyAmount;
                if (message.motifyCharge != null && message.hasOwnProperty("motifyCharge"))
                    object.motifyCharge = options.json && !isFinite(message.motifyCharge) ? String(message.motifyCharge) : message.motifyCharge;
                if (message.installRate != null && message.hasOwnProperty("installRate"))
                    object.installRate = options.json && !isFinite(message.installRate) ? String(message.installRate) : message.installRate;
                if (message.chargeRate != null && message.hasOwnProperty("chargeRate"))
                    object.chargeRate = message.chargeRate;
                if (message.netAmount != null && message.hasOwnProperty("netAmount"))
                    object.netAmount = options.json && !isFinite(message.netAmount) ? String(message.netAmount) : message.netAmount;
                if (message.infoType != null && message.hasOwnProperty("infoType"))
                    object.infoType = message.infoType;
                if (message.typeFlag != null && message.hasOwnProperty("typeFlag"))
                    object.typeFlag = message.typeFlag;
                if (message.typeFlagOrigin != null && message.hasOwnProperty("typeFlagOrigin"))
                    object.typeFlagOrigin = message.typeFlagOrigin;
                if (message.storeCodeMapping != null && message.hasOwnProperty("storeCodeMapping"))
                    object.storeCodeMapping = message.storeCodeMapping;
                return object;
            };

            /**
             * Converts this AppropriationInfoSummary to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummary
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationInfoSummary.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationInfoSummary;
        })();

        Protobuf.AppropriationSummary = (function() {

            /**
             * Properties of an AppropriationSummary.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationSummary
             * @property {Array.<TCBReceiptApi.Protobuf.IAppropriationInfoSummary>|null} [list] AppropriationSummary list
             */

            /**
             * Constructs a new AppropriationSummary.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationSummary.
             * @implements IAppropriationSummary
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummary=} [properties] Properties to set
             */
            function AppropriationSummary(properties) {
                this.list = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationSummary list.
             * @member {Array.<TCBReceiptApi.Protobuf.IAppropriationInfoSummary>} list
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummary
             * @instance
             */
            AppropriationSummary.prototype.list = $util.emptyArray;

            /**
             * Creates a new AppropriationSummary instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummary
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummary=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummary} AppropriationSummary instance
             */
            AppropriationSummary.create = function create(properties) {
                return new AppropriationSummary(properties);
            };

            /**
             * Encodes the specified AppropriationSummary message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationSummary.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummary
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummary} message AppropriationSummary message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationSummary.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.list != null && message.list.length)
                    for (var i = 0; i < message.list.length; ++i)
                        $root.TCBReceiptApi.Protobuf.AppropriationInfoSummary.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified AppropriationSummary message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationSummary.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummary
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummary} message AppropriationSummary message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationSummary.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationSummary message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummary
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummary} AppropriationSummary
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationSummary.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationSummary();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.TCBReceiptApi.Protobuf.AppropriationInfoSummary.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationSummary message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummary
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummary} AppropriationSummary
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationSummary.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationSummary message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummary
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationSummary.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.list != null && message.hasOwnProperty("list")) {
                    if (!Array.isArray(message.list))
                        return "list: array expected";
                    for (var i = 0; i < message.list.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.AppropriationInfoSummary.verify(message.list[i]);
                        if (error)
                            return "list." + error;
                    }
                }
                return null;
            };

            /**
             * Creates an AppropriationSummary message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummary
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummary} AppropriationSummary
             */
            AppropriationSummary.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationSummary)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationSummary();
                if (object.list) {
                    if (!Array.isArray(object.list))
                        throw TypeError(".TCBReceiptApi.Protobuf.AppropriationSummary.list: array expected");
                    message.list = [];
                    for (var i = 0; i < object.list.length; ++i) {
                        if (typeof object.list[i] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.AppropriationSummary.list: object expected");
                        message.list[i] = $root.TCBReceiptApi.Protobuf.AppropriationInfoSummary.fromObject(object.list[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from an AppropriationSummary message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummary
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationSummary} message AppropriationSummary
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationSummary.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.list = [];
                if (message.list && message.list.length) {
                    object.list = [];
                    for (var j = 0; j < message.list.length; ++j)
                        object.list[j] = $root.TCBReceiptApi.Protobuf.AppropriationInfoSummary.toObject(message.list[j], options);
                }
                return object;
            };

            /**
             * Converts this AppropriationSummary to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummary
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationSummary.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationSummary;
        })();

        Protobuf.AppropriationSummaryTypeFlagMap = (function() {

            /**
             * Properties of an AppropriationSummaryTypeFlagMap.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationSummaryTypeFlagMap
             * @property {Object.<string,TCBReceiptApi.Protobuf.IAppropriationSummary>|null} [byTypeFlag] AppropriationSummaryTypeFlagMap byTypeFlag
             */

            /**
             * Constructs a new AppropriationSummaryTypeFlagMap.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationSummaryTypeFlagMap.
             * @implements IAppropriationSummaryTypeFlagMap
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryTypeFlagMap=} [properties] Properties to set
             */
            function AppropriationSummaryTypeFlagMap(properties) {
                this.byTypeFlag = {};
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationSummaryTypeFlagMap byTypeFlag.
             * @member {Object.<string,TCBReceiptApi.Protobuf.IAppropriationSummary>} byTypeFlag
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryTypeFlagMap
             * @instance
             */
            AppropriationSummaryTypeFlagMap.prototype.byTypeFlag = $util.emptyObject;

            /**
             * Creates a new AppropriationSummaryTypeFlagMap instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryTypeFlagMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryTypeFlagMap=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryTypeFlagMap} AppropriationSummaryTypeFlagMap instance
             */
            AppropriationSummaryTypeFlagMap.create = function create(properties) {
                return new AppropriationSummaryTypeFlagMap(properties);
            };

            /**
             * Encodes the specified AppropriationSummaryTypeFlagMap message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationSummaryTypeFlagMap.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryTypeFlagMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryTypeFlagMap} message AppropriationSummaryTypeFlagMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationSummaryTypeFlagMap.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.byTypeFlag != null && Object.hasOwnProperty.call(message, "byTypeFlag"))
                    for (var keys = Object.keys(message.byTypeFlag), i = 0; i < keys.length; ++i) {
                        writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 0 =*/8).int32(keys[i]);
                        $root.TCBReceiptApi.Protobuf.AppropriationSummary.encode(message.byTypeFlag[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                    }
                return writer;
            };

            /**
             * Encodes the specified AppropriationSummaryTypeFlagMap message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationSummaryTypeFlagMap.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryTypeFlagMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryTypeFlagMap} message AppropriationSummaryTypeFlagMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationSummaryTypeFlagMap.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationSummaryTypeFlagMap message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryTypeFlagMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryTypeFlagMap} AppropriationSummaryTypeFlagMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationSummaryTypeFlagMap.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationSummaryTypeFlagMap(), key, value;
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (message.byTypeFlag === $util.emptyObject)
                            message.byTypeFlag = {};
                        var end2 = reader.uint32() + reader.pos;
                        key = 0;
                        value = null;
                        while (reader.pos < end2) {
                            var tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.int32();
                                break;
                            case 2:
                                value = $root.TCBReceiptApi.Protobuf.AppropriationSummary.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.byTypeFlag[key] = value;
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationSummaryTypeFlagMap message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryTypeFlagMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryTypeFlagMap} AppropriationSummaryTypeFlagMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationSummaryTypeFlagMap.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationSummaryTypeFlagMap message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryTypeFlagMap
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationSummaryTypeFlagMap.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.byTypeFlag != null && message.hasOwnProperty("byTypeFlag")) {
                    if (!$util.isObject(message.byTypeFlag))
                        return "byTypeFlag: object expected";
                    var key = Object.keys(message.byTypeFlag);
                    for (var i = 0; i < key.length; ++i) {
                        if (!$util.key32Re.test(key[i]))
                            return "byTypeFlag: integer key{k:int32} expected";
                        {
                            var error = $root.TCBReceiptApi.Protobuf.AppropriationSummary.verify(message.byTypeFlag[key[i]]);
                            if (error)
                                return "byTypeFlag." + error;
                        }
                    }
                }
                return null;
            };

            /**
             * Creates an AppropriationSummaryTypeFlagMap message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryTypeFlagMap
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryTypeFlagMap} AppropriationSummaryTypeFlagMap
             */
            AppropriationSummaryTypeFlagMap.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationSummaryTypeFlagMap)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationSummaryTypeFlagMap();
                if (object.byTypeFlag) {
                    if (typeof object.byTypeFlag !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.AppropriationSummaryTypeFlagMap.byTypeFlag: object expected");
                    message.byTypeFlag = {};
                    for (var keys = Object.keys(object.byTypeFlag), i = 0; i < keys.length; ++i) {
                        if (typeof object.byTypeFlag[keys[i]] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.AppropriationSummaryTypeFlagMap.byTypeFlag: object expected");
                        message.byTypeFlag[keys[i]] = $root.TCBReceiptApi.Protobuf.AppropriationSummary.fromObject(object.byTypeFlag[keys[i]]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from an AppropriationSummaryTypeFlagMap message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryTypeFlagMap
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationSummaryTypeFlagMap} message AppropriationSummaryTypeFlagMap
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationSummaryTypeFlagMap.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.objects || options.defaults)
                    object.byTypeFlag = {};
                var keys2;
                if (message.byTypeFlag && (keys2 = Object.keys(message.byTypeFlag)).length) {
                    object.byTypeFlag = {};
                    for (var j = 0; j < keys2.length; ++j)
                        object.byTypeFlag[keys2[j]] = $root.TCBReceiptApi.Protobuf.AppropriationSummary.toObject(message.byTypeFlag[keys2[j]], options);
                }
                return object;
            };

            /**
             * Converts this AppropriationSummaryTypeFlagMap to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryTypeFlagMap
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationSummaryTypeFlagMap.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationSummaryTypeFlagMap;
        })();

        Protobuf.AppropriationSummaryDateMap = (function() {

            /**
             * Properties of an AppropriationSummaryDateMap.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationSummaryDateMap
             * @property {Object.<string,TCBReceiptApi.Protobuf.IAppropriationSummaryTypeFlagMap>|null} [byDate] AppropriationSummaryDateMap byDate
             */

            /**
             * Constructs a new AppropriationSummaryDateMap.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationSummaryDateMap.
             * @implements IAppropriationSummaryDateMap
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryDateMap=} [properties] Properties to set
             */
            function AppropriationSummaryDateMap(properties) {
                this.byDate = {};
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationSummaryDateMap byDate.
             * @member {Object.<string,TCBReceiptApi.Protobuf.IAppropriationSummaryTypeFlagMap>} byDate
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryDateMap
             * @instance
             */
            AppropriationSummaryDateMap.prototype.byDate = $util.emptyObject;

            /**
             * Creates a new AppropriationSummaryDateMap instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryDateMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryDateMap=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryDateMap} AppropriationSummaryDateMap instance
             */
            AppropriationSummaryDateMap.create = function create(properties) {
                return new AppropriationSummaryDateMap(properties);
            };

            /**
             * Encodes the specified AppropriationSummaryDateMap message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationSummaryDateMap.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryDateMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryDateMap} message AppropriationSummaryDateMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationSummaryDateMap.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.byDate != null && Object.hasOwnProperty.call(message, "byDate"))
                    for (var keys = Object.keys(message.byDate), i = 0; i < keys.length; ++i) {
                        writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                        $root.TCBReceiptApi.Protobuf.AppropriationSummaryTypeFlagMap.encode(message.byDate[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                    }
                return writer;
            };

            /**
             * Encodes the specified AppropriationSummaryDateMap message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationSummaryDateMap.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryDateMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryDateMap} message AppropriationSummaryDateMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationSummaryDateMap.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationSummaryDateMap message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryDateMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryDateMap} AppropriationSummaryDateMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationSummaryDateMap.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationSummaryDateMap(), key, value;
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (message.byDate === $util.emptyObject)
                            message.byDate = {};
                        var end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = null;
                        while (reader.pos < end2) {
                            var tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = $root.TCBReceiptApi.Protobuf.AppropriationSummaryTypeFlagMap.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.byDate[key] = value;
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationSummaryDateMap message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryDateMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryDateMap} AppropriationSummaryDateMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationSummaryDateMap.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationSummaryDateMap message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryDateMap
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationSummaryDateMap.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.byDate != null && message.hasOwnProperty("byDate")) {
                    if (!$util.isObject(message.byDate))
                        return "byDate: object expected";
                    var key = Object.keys(message.byDate);
                    for (var i = 0; i < key.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.AppropriationSummaryTypeFlagMap.verify(message.byDate[key[i]]);
                        if (error)
                            return "byDate." + error;
                    }
                }
                return null;
            };

            /**
             * Creates an AppropriationSummaryDateMap message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryDateMap
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryDateMap} AppropriationSummaryDateMap
             */
            AppropriationSummaryDateMap.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationSummaryDateMap)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationSummaryDateMap();
                if (object.byDate) {
                    if (typeof object.byDate !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.AppropriationSummaryDateMap.byDate: object expected");
                    message.byDate = {};
                    for (var keys = Object.keys(object.byDate), i = 0; i < keys.length; ++i) {
                        if (typeof object.byDate[keys[i]] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.AppropriationSummaryDateMap.byDate: object expected");
                        message.byDate[keys[i]] = $root.TCBReceiptApi.Protobuf.AppropriationSummaryTypeFlagMap.fromObject(object.byDate[keys[i]]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from an AppropriationSummaryDateMap message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryDateMap
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationSummaryDateMap} message AppropriationSummaryDateMap
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationSummaryDateMap.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.objects || options.defaults)
                    object.byDate = {};
                var keys2;
                if (message.byDate && (keys2 = Object.keys(message.byDate)).length) {
                    object.byDate = {};
                    for (var j = 0; j < keys2.length; ++j)
                        object.byDate[keys2[j]] = $root.TCBReceiptApi.Protobuf.AppropriationSummaryTypeFlagMap.toObject(message.byDate[keys2[j]], options);
                }
                return object;
            };

            /**
             * Converts this AppropriationSummaryDateMap to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryDateMap
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationSummaryDateMap.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationSummaryDateMap;
        })();

        Protobuf.AppropriationSummaryTerminalNoMap = (function() {

            /**
             * Properties of an AppropriationSummaryTerminalNoMap.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationSummaryTerminalNoMap
             * @property {Object.<string,TCBReceiptApi.Protobuf.IAppropriationSummaryDateMap>|null} [byTerminalNo] AppropriationSummaryTerminalNoMap byTerminalNo
             */

            /**
             * Constructs a new AppropriationSummaryTerminalNoMap.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationSummaryTerminalNoMap.
             * @implements IAppropriationSummaryTerminalNoMap
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryTerminalNoMap=} [properties] Properties to set
             */
            function AppropriationSummaryTerminalNoMap(properties) {
                this.byTerminalNo = {};
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationSummaryTerminalNoMap byTerminalNo.
             * @member {Object.<string,TCBReceiptApi.Protobuf.IAppropriationSummaryDateMap>} byTerminalNo
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryTerminalNoMap
             * @instance
             */
            AppropriationSummaryTerminalNoMap.prototype.byTerminalNo = $util.emptyObject;

            /**
             * Creates a new AppropriationSummaryTerminalNoMap instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryTerminalNoMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryTerminalNoMap=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryTerminalNoMap} AppropriationSummaryTerminalNoMap instance
             */
            AppropriationSummaryTerminalNoMap.create = function create(properties) {
                return new AppropriationSummaryTerminalNoMap(properties);
            };

            /**
             * Encodes the specified AppropriationSummaryTerminalNoMap message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationSummaryTerminalNoMap.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryTerminalNoMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryTerminalNoMap} message AppropriationSummaryTerminalNoMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationSummaryTerminalNoMap.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.byTerminalNo != null && Object.hasOwnProperty.call(message, "byTerminalNo"))
                    for (var keys = Object.keys(message.byTerminalNo), i = 0; i < keys.length; ++i) {
                        writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                        $root.TCBReceiptApi.Protobuf.AppropriationSummaryDateMap.encode(message.byTerminalNo[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                    }
                return writer;
            };

            /**
             * Encodes the specified AppropriationSummaryTerminalNoMap message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationSummaryTerminalNoMap.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryTerminalNoMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryTerminalNoMap} message AppropriationSummaryTerminalNoMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationSummaryTerminalNoMap.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationSummaryTerminalNoMap message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryTerminalNoMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryTerminalNoMap} AppropriationSummaryTerminalNoMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationSummaryTerminalNoMap.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationSummaryTerminalNoMap(), key, value;
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (message.byTerminalNo === $util.emptyObject)
                            message.byTerminalNo = {};
                        var end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = null;
                        while (reader.pos < end2) {
                            var tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = $root.TCBReceiptApi.Protobuf.AppropriationSummaryDateMap.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.byTerminalNo[key] = value;
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationSummaryTerminalNoMap message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryTerminalNoMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryTerminalNoMap} AppropriationSummaryTerminalNoMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationSummaryTerminalNoMap.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationSummaryTerminalNoMap message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryTerminalNoMap
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationSummaryTerminalNoMap.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.byTerminalNo != null && message.hasOwnProperty("byTerminalNo")) {
                    if (!$util.isObject(message.byTerminalNo))
                        return "byTerminalNo: object expected";
                    var key = Object.keys(message.byTerminalNo);
                    for (var i = 0; i < key.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.AppropriationSummaryDateMap.verify(message.byTerminalNo[key[i]]);
                        if (error)
                            return "byTerminalNo." + error;
                    }
                }
                return null;
            };

            /**
             * Creates an AppropriationSummaryTerminalNoMap message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryTerminalNoMap
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryTerminalNoMap} AppropriationSummaryTerminalNoMap
             */
            AppropriationSummaryTerminalNoMap.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationSummaryTerminalNoMap)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationSummaryTerminalNoMap();
                if (object.byTerminalNo) {
                    if (typeof object.byTerminalNo !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.AppropriationSummaryTerminalNoMap.byTerminalNo: object expected");
                    message.byTerminalNo = {};
                    for (var keys = Object.keys(object.byTerminalNo), i = 0; i < keys.length; ++i) {
                        if (typeof object.byTerminalNo[keys[i]] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.AppropriationSummaryTerminalNoMap.byTerminalNo: object expected");
                        message.byTerminalNo[keys[i]] = $root.TCBReceiptApi.Protobuf.AppropriationSummaryDateMap.fromObject(object.byTerminalNo[keys[i]]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from an AppropriationSummaryTerminalNoMap message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryTerminalNoMap
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationSummaryTerminalNoMap} message AppropriationSummaryTerminalNoMap
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationSummaryTerminalNoMap.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.objects || options.defaults)
                    object.byTerminalNo = {};
                var keys2;
                if (message.byTerminalNo && (keys2 = Object.keys(message.byTerminalNo)).length) {
                    object.byTerminalNo = {};
                    for (var j = 0; j < keys2.length; ++j)
                        object.byTerminalNo[keys2[j]] = $root.TCBReceiptApi.Protobuf.AppropriationSummaryDateMap.toObject(message.byTerminalNo[keys2[j]], options);
                }
                return object;
            };

            /**
             * Converts this AppropriationSummaryTerminalNoMap to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryTerminalNoMap
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationSummaryTerminalNoMap.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationSummaryTerminalNoMap;
        })();

        Protobuf.AppropriationSummaryMap = (function() {

            /**
             * Properties of an AppropriationSummaryMap.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationSummaryMap
             * @property {Object.<string,TCBReceiptApi.Protobuf.IAppropriationSummaryTerminalNoMap>|null} [map] AppropriationSummaryMap map
             */

            /**
             * Constructs a new AppropriationSummaryMap.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationSummaryMap.
             * @implements IAppropriationSummaryMap
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryMap=} [properties] Properties to set
             */
            function AppropriationSummaryMap(properties) {
                this.map = {};
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationSummaryMap map.
             * @member {Object.<string,TCBReceiptApi.Protobuf.IAppropriationSummaryTerminalNoMap>} map
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryMap
             * @instance
             */
            AppropriationSummaryMap.prototype.map = $util.emptyObject;

            /**
             * Creates a new AppropriationSummaryMap instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryMap=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryMap} AppropriationSummaryMap instance
             */
            AppropriationSummaryMap.create = function create(properties) {
                return new AppropriationSummaryMap(properties);
            };

            /**
             * Encodes the specified AppropriationSummaryMap message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationSummaryMap.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryMap} message AppropriationSummaryMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationSummaryMap.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.map != null && Object.hasOwnProperty.call(message, "map"))
                    for (var keys = Object.keys(message.map), i = 0; i < keys.length; ++i) {
                        writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                        $root.TCBReceiptApi.Protobuf.AppropriationSummaryTerminalNoMap.encode(message.map[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                    }
                return writer;
            };

            /**
             * Encodes the specified AppropriationSummaryMap message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationSummaryMap.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryMap} message AppropriationSummaryMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationSummaryMap.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationSummaryMap message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryMap} AppropriationSummaryMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationSummaryMap.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationSummaryMap(), key, value;
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (message.map === $util.emptyObject)
                            message.map = {};
                        var end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = null;
                        while (reader.pos < end2) {
                            var tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = $root.TCBReceiptApi.Protobuf.AppropriationSummaryTerminalNoMap.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.map[key] = value;
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationSummaryMap message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryMap} AppropriationSummaryMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationSummaryMap.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationSummaryMap message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryMap
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationSummaryMap.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.map != null && message.hasOwnProperty("map")) {
                    if (!$util.isObject(message.map))
                        return "map: object expected";
                    var key = Object.keys(message.map);
                    for (var i = 0; i < key.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.AppropriationSummaryTerminalNoMap.verify(message.map[key[i]]);
                        if (error)
                            return "map." + error;
                    }
                }
                return null;
            };

            /**
             * Creates an AppropriationSummaryMap message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryMap
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryMap} AppropriationSummaryMap
             */
            AppropriationSummaryMap.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationSummaryMap)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationSummaryMap();
                if (object.map) {
                    if (typeof object.map !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.AppropriationSummaryMap.map: object expected");
                    message.map = {};
                    for (var keys = Object.keys(object.map), i = 0; i < keys.length; ++i) {
                        if (typeof object.map[keys[i]] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.AppropriationSummaryMap.map: object expected");
                        message.map[keys[i]] = $root.TCBReceiptApi.Protobuf.AppropriationSummaryTerminalNoMap.fromObject(object.map[keys[i]]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from an AppropriationSummaryMap message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryMap
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationSummaryMap} message AppropriationSummaryMap
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationSummaryMap.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.objects || options.defaults)
                    object.map = {};
                var keys2;
                if (message.map && (keys2 = Object.keys(message.map)).length) {
                    object.map = {};
                    for (var j = 0; j < keys2.length; ++j)
                        object.map[keys2[j]] = $root.TCBReceiptApi.Protobuf.AppropriationSummaryTerminalNoMap.toObject(message.map[keys2[j]], options);
                }
                return object;
            };

            /**
             * Converts this AppropriationSummaryMap to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryMap
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationSummaryMap.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationSummaryMap;
        })();

        Protobuf.AppropriationSummaryTotal = (function() {

            /**
             * Properties of an AppropriationSummaryTotal.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationSummaryTotal
             * @property {number|null} [count] AppropriationSummaryTotal count
             * @property {number|null} [total] AppropriationSummaryTotal total
             */

            /**
             * Constructs a new AppropriationSummaryTotal.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationSummaryTotal.
             * @implements IAppropriationSummaryTotal
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryTotal=} [properties] Properties to set
             */
            function AppropriationSummaryTotal(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationSummaryTotal count.
             * @member {number} count
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryTotal
             * @instance
             */
            AppropriationSummaryTotal.prototype.count = 0;

            /**
             * AppropriationSummaryTotal total.
             * @member {number} total
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryTotal
             * @instance
             */
            AppropriationSummaryTotal.prototype.total = 0;

            /**
             * Creates a new AppropriationSummaryTotal instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryTotal=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryTotal} AppropriationSummaryTotal instance
             */
            AppropriationSummaryTotal.create = function create(properties) {
                return new AppropriationSummaryTotal(properties);
            };

            /**
             * Encodes the specified AppropriationSummaryTotal message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationSummaryTotal.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryTotal} message AppropriationSummaryTotal message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationSummaryTotal.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.count != null && Object.hasOwnProperty.call(message, "count"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.count);
                if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                    writer.uint32(/* id 2, wireType 1 =*/17).double(message.total);
                return writer;
            };

            /**
             * Encodes the specified AppropriationSummaryTotal message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationSummaryTotal.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryTotal} message AppropriationSummaryTotal message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationSummaryTotal.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationSummaryTotal message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryTotal
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryTotal} AppropriationSummaryTotal
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationSummaryTotal.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationSummaryTotal();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.count = reader.int32();
                        break;
                    case 2:
                        message.total = reader.double();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationSummaryTotal message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryTotal
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryTotal} AppropriationSummaryTotal
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationSummaryTotal.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationSummaryTotal message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryTotal
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationSummaryTotal.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.count != null && message.hasOwnProperty("count"))
                    if (!$util.isInteger(message.count))
                        return "count: integer expected";
                if (message.total != null && message.hasOwnProperty("total"))
                    if (typeof message.total !== "number")
                        return "total: number expected";
                return null;
            };

            /**
             * Creates an AppropriationSummaryTotal message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryTotal
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryTotal} AppropriationSummaryTotal
             */
            AppropriationSummaryTotal.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationSummaryTotal)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationSummaryTotal();
                if (object.count != null)
                    message.count = object.count | 0;
                if (object.total != null)
                    message.total = Number(object.total);
                return message;
            };

            /**
             * Creates a plain object from an AppropriationSummaryTotal message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationSummaryTotal} message AppropriationSummaryTotal
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationSummaryTotal.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.count = 0;
                    object.total = 0;
                }
                if (message.count != null && message.hasOwnProperty("count"))
                    object.count = message.count;
                if (message.total != null && message.hasOwnProperty("total"))
                    object.total = options.json && !isFinite(message.total) ? String(message.total) : message.total;
                return object;
            };

            /**
             * Converts this AppropriationSummaryTotal to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryTotal
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationSummaryTotal.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationSummaryTotal;
        })();

        Protobuf.AppropriationInfoSummaryByCardType = (function() {

            /**
             * Properties of an AppropriationInfoSummaryByCardType.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationInfoSummaryByCardType
             * @property {number|null} [ourBankCount] AppropriationInfoSummaryByCardType ourBankCount
             * @property {number|null} [ourBankAmount] AppropriationInfoSummaryByCardType ourBankAmount
             * @property {number|null} [notOurBankCount] AppropriationInfoSummaryByCardType notOurBankCount
             * @property {number|null} [notOurBankAmount] AppropriationInfoSummaryByCardType notOurBankAmount
             * @property {number|null} [totalCount] AppropriationInfoSummaryByCardType totalCount
             * @property {number|null} [totalAmount] AppropriationInfoSummaryByCardType totalAmount
             */

            /**
             * Constructs a new AppropriationInfoSummaryByCardType.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationInfoSummaryByCardType.
             * @implements IAppropriationInfoSummaryByCardType
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationInfoSummaryByCardType=} [properties] Properties to set
             */
            function AppropriationInfoSummaryByCardType(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationInfoSummaryByCardType ourBankCount.
             * @member {number} ourBankCount
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType
             * @instance
             */
            AppropriationInfoSummaryByCardType.prototype.ourBankCount = 0;

            /**
             * AppropriationInfoSummaryByCardType ourBankAmount.
             * @member {number} ourBankAmount
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType
             * @instance
             */
            AppropriationInfoSummaryByCardType.prototype.ourBankAmount = 0;

            /**
             * AppropriationInfoSummaryByCardType notOurBankCount.
             * @member {number} notOurBankCount
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType
             * @instance
             */
            AppropriationInfoSummaryByCardType.prototype.notOurBankCount = 0;

            /**
             * AppropriationInfoSummaryByCardType notOurBankAmount.
             * @member {number} notOurBankAmount
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType
             * @instance
             */
            AppropriationInfoSummaryByCardType.prototype.notOurBankAmount = 0;

            /**
             * AppropriationInfoSummaryByCardType totalCount.
             * @member {number} totalCount
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType
             * @instance
             */
            AppropriationInfoSummaryByCardType.prototype.totalCount = 0;

            /**
             * AppropriationInfoSummaryByCardType totalAmount.
             * @member {number} totalAmount
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType
             * @instance
             */
            AppropriationInfoSummaryByCardType.prototype.totalAmount = 0;

            /**
             * Creates a new AppropriationInfoSummaryByCardType instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationInfoSummaryByCardType=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType} AppropriationInfoSummaryByCardType instance
             */
            AppropriationInfoSummaryByCardType.create = function create(properties) {
                return new AppropriationInfoSummaryByCardType(properties);
            };

            /**
             * Encodes the specified AppropriationInfoSummaryByCardType message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationInfoSummaryByCardType} message AppropriationInfoSummaryByCardType message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationInfoSummaryByCardType.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.ourBankCount != null && Object.hasOwnProperty.call(message, "ourBankCount"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.ourBankCount);
                if (message.ourBankAmount != null && Object.hasOwnProperty.call(message, "ourBankAmount"))
                    writer.uint32(/* id 2, wireType 1 =*/17).double(message.ourBankAmount);
                if (message.notOurBankCount != null && Object.hasOwnProperty.call(message, "notOurBankCount"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.notOurBankCount);
                if (message.notOurBankAmount != null && Object.hasOwnProperty.call(message, "notOurBankAmount"))
                    writer.uint32(/* id 4, wireType 1 =*/33).double(message.notOurBankAmount);
                if (message.totalCount != null && Object.hasOwnProperty.call(message, "totalCount"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int32(message.totalCount);
                if (message.totalAmount != null && Object.hasOwnProperty.call(message, "totalAmount"))
                    writer.uint32(/* id 6, wireType 1 =*/49).double(message.totalAmount);
                return writer;
            };

            /**
             * Encodes the specified AppropriationInfoSummaryByCardType message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationInfoSummaryByCardType} message AppropriationInfoSummaryByCardType message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationInfoSummaryByCardType.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationInfoSummaryByCardType message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType} AppropriationInfoSummaryByCardType
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationInfoSummaryByCardType.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.ourBankCount = reader.int32();
                        break;
                    case 2:
                        message.ourBankAmount = reader.double();
                        break;
                    case 3:
                        message.notOurBankCount = reader.int32();
                        break;
                    case 4:
                        message.notOurBankAmount = reader.double();
                        break;
                    case 5:
                        message.totalCount = reader.int32();
                        break;
                    case 6:
                        message.totalAmount = reader.double();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationInfoSummaryByCardType message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType} AppropriationInfoSummaryByCardType
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationInfoSummaryByCardType.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationInfoSummaryByCardType message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationInfoSummaryByCardType.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.ourBankCount != null && message.hasOwnProperty("ourBankCount"))
                    if (!$util.isInteger(message.ourBankCount))
                        return "ourBankCount: integer expected";
                if (message.ourBankAmount != null && message.hasOwnProperty("ourBankAmount"))
                    if (typeof message.ourBankAmount !== "number")
                        return "ourBankAmount: number expected";
                if (message.notOurBankCount != null && message.hasOwnProperty("notOurBankCount"))
                    if (!$util.isInteger(message.notOurBankCount))
                        return "notOurBankCount: integer expected";
                if (message.notOurBankAmount != null && message.hasOwnProperty("notOurBankAmount"))
                    if (typeof message.notOurBankAmount !== "number")
                        return "notOurBankAmount: number expected";
                if (message.totalCount != null && message.hasOwnProperty("totalCount"))
                    if (!$util.isInteger(message.totalCount))
                        return "totalCount: integer expected";
                if (message.totalAmount != null && message.hasOwnProperty("totalAmount"))
                    if (typeof message.totalAmount !== "number")
                        return "totalAmount: number expected";
                return null;
            };

            /**
             * Creates an AppropriationInfoSummaryByCardType message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType} AppropriationInfoSummaryByCardType
             */
            AppropriationInfoSummaryByCardType.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType();
                if (object.ourBankCount != null)
                    message.ourBankCount = object.ourBankCount | 0;
                if (object.ourBankAmount != null)
                    message.ourBankAmount = Number(object.ourBankAmount);
                if (object.notOurBankCount != null)
                    message.notOurBankCount = object.notOurBankCount | 0;
                if (object.notOurBankAmount != null)
                    message.notOurBankAmount = Number(object.notOurBankAmount);
                if (object.totalCount != null)
                    message.totalCount = object.totalCount | 0;
                if (object.totalAmount != null)
                    message.totalAmount = Number(object.totalAmount);
                return message;
            };

            /**
             * Creates a plain object from an AppropriationInfoSummaryByCardType message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType} message AppropriationInfoSummaryByCardType
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationInfoSummaryByCardType.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.ourBankCount = 0;
                    object.ourBankAmount = 0;
                    object.notOurBankCount = 0;
                    object.notOurBankAmount = 0;
                    object.totalCount = 0;
                    object.totalAmount = 0;
                }
                if (message.ourBankCount != null && message.hasOwnProperty("ourBankCount"))
                    object.ourBankCount = message.ourBankCount;
                if (message.ourBankAmount != null && message.hasOwnProperty("ourBankAmount"))
                    object.ourBankAmount = options.json && !isFinite(message.ourBankAmount) ? String(message.ourBankAmount) : message.ourBankAmount;
                if (message.notOurBankCount != null && message.hasOwnProperty("notOurBankCount"))
                    object.notOurBankCount = message.notOurBankCount;
                if (message.notOurBankAmount != null && message.hasOwnProperty("notOurBankAmount"))
                    object.notOurBankAmount = options.json && !isFinite(message.notOurBankAmount) ? String(message.notOurBankAmount) : message.notOurBankAmount;
                if (message.totalCount != null && message.hasOwnProperty("totalCount"))
                    object.totalCount = message.totalCount;
                if (message.totalAmount != null && message.hasOwnProperty("totalAmount"))
                    object.totalAmount = options.json && !isFinite(message.totalAmount) ? String(message.totalAmount) : message.totalAmount;
                return object;
            };

            /**
             * Converts this AppropriationInfoSummaryByCardType to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationInfoSummaryByCardType.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationInfoSummaryByCardType;
        })();

        Protobuf.AppropriationSummaryByCardType = (function() {

            /**
             * Properties of an AppropriationSummaryByCardType.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationSummaryByCardType
             * @property {TCBReceiptApi.Protobuf.IAppropriationInfoSummaryByCardType|null} [visa] AppropriationSummaryByCardType visa
             * @property {TCBReceiptApi.Protobuf.IAppropriationInfoSummaryByCardType|null} [mc] AppropriationSummaryByCardType mc
             * @property {TCBReceiptApi.Protobuf.IAppropriationInfoSummaryByCardType|null} [jcb] AppropriationSummaryByCardType jcb
             * @property {TCBReceiptApi.Protobuf.IAppropriationInfoSummaryByCardType|null} [cup] AppropriationSummaryByCardType cup
             * @property {TCBReceiptApi.Protobuf.IAppropriationInfoSummaryByCardType|null} [fisc] AppropriationSummaryByCardType fisc
             * @property {TCBReceiptApi.Protobuf.IAppropriationInfoSummaryByCardType|null} [motify] AppropriationSummaryByCardType motify
             */

            /**
             * Constructs a new AppropriationSummaryByCardType.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationSummaryByCardType.
             * @implements IAppropriationSummaryByCardType
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryByCardType=} [properties] Properties to set
             */
            function AppropriationSummaryByCardType(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationSummaryByCardType visa.
             * @member {TCBReceiptApi.Protobuf.IAppropriationInfoSummaryByCardType|null|undefined} visa
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardType
             * @instance
             */
            AppropriationSummaryByCardType.prototype.visa = null;

            /**
             * AppropriationSummaryByCardType mc.
             * @member {TCBReceiptApi.Protobuf.IAppropriationInfoSummaryByCardType|null|undefined} mc
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardType
             * @instance
             */
            AppropriationSummaryByCardType.prototype.mc = null;

            /**
             * AppropriationSummaryByCardType jcb.
             * @member {TCBReceiptApi.Protobuf.IAppropriationInfoSummaryByCardType|null|undefined} jcb
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardType
             * @instance
             */
            AppropriationSummaryByCardType.prototype.jcb = null;

            /**
             * AppropriationSummaryByCardType cup.
             * @member {TCBReceiptApi.Protobuf.IAppropriationInfoSummaryByCardType|null|undefined} cup
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardType
             * @instance
             */
            AppropriationSummaryByCardType.prototype.cup = null;

            /**
             * AppropriationSummaryByCardType fisc.
             * @member {TCBReceiptApi.Protobuf.IAppropriationInfoSummaryByCardType|null|undefined} fisc
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardType
             * @instance
             */
            AppropriationSummaryByCardType.prototype.fisc = null;

            /**
             * AppropriationSummaryByCardType motify.
             * @member {TCBReceiptApi.Protobuf.IAppropriationInfoSummaryByCardType|null|undefined} motify
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardType
             * @instance
             */
            AppropriationSummaryByCardType.prototype.motify = null;

            /**
             * Creates a new AppropriationSummaryByCardType instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardType
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryByCardType=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryByCardType} AppropriationSummaryByCardType instance
             */
            AppropriationSummaryByCardType.create = function create(properties) {
                return new AppropriationSummaryByCardType(properties);
            };

            /**
             * Encodes the specified AppropriationSummaryByCardType message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationSummaryByCardType.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardType
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryByCardType} message AppropriationSummaryByCardType message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationSummaryByCardType.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.visa != null && Object.hasOwnProperty.call(message, "visa"))
                    $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.encode(message.visa, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.mc != null && Object.hasOwnProperty.call(message, "mc"))
                    $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.encode(message.mc, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.jcb != null && Object.hasOwnProperty.call(message, "jcb"))
                    $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.encode(message.jcb, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.cup != null && Object.hasOwnProperty.call(message, "cup"))
                    $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.encode(message.cup, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.fisc != null && Object.hasOwnProperty.call(message, "fisc"))
                    $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.encode(message.fisc, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.motify != null && Object.hasOwnProperty.call(message, "motify"))
                    $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.encode(message.motify, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified AppropriationSummaryByCardType message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationSummaryByCardType.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardType
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryByCardType} message AppropriationSummaryByCardType message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationSummaryByCardType.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationSummaryByCardType message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardType
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryByCardType} AppropriationSummaryByCardType
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationSummaryByCardType.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationSummaryByCardType();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.visa = $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.mc = $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.jcb = $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.decode(reader, reader.uint32());
                        break;
                    case 4:
                        message.cup = $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.decode(reader, reader.uint32());
                        break;
                    case 5:
                        message.fisc = $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.decode(reader, reader.uint32());
                        break;
                    case 6:
                        message.motify = $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationSummaryByCardType message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardType
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryByCardType} AppropriationSummaryByCardType
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationSummaryByCardType.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationSummaryByCardType message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardType
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationSummaryByCardType.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.visa != null && message.hasOwnProperty("visa")) {
                    var error = $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.verify(message.visa);
                    if (error)
                        return "visa." + error;
                }
                if (message.mc != null && message.hasOwnProperty("mc")) {
                    var error = $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.verify(message.mc);
                    if (error)
                        return "mc." + error;
                }
                if (message.jcb != null && message.hasOwnProperty("jcb")) {
                    var error = $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.verify(message.jcb);
                    if (error)
                        return "jcb." + error;
                }
                if (message.cup != null && message.hasOwnProperty("cup")) {
                    var error = $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.verify(message.cup);
                    if (error)
                        return "cup." + error;
                }
                if (message.fisc != null && message.hasOwnProperty("fisc")) {
                    var error = $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.verify(message.fisc);
                    if (error)
                        return "fisc." + error;
                }
                if (message.motify != null && message.hasOwnProperty("motify")) {
                    var error = $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.verify(message.motify);
                    if (error)
                        return "motify." + error;
                }
                return null;
            };

            /**
             * Creates an AppropriationSummaryByCardType message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardType
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryByCardType} AppropriationSummaryByCardType
             */
            AppropriationSummaryByCardType.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationSummaryByCardType)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationSummaryByCardType();
                if (object.visa != null) {
                    if (typeof object.visa !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.AppropriationSummaryByCardType.visa: object expected");
                    message.visa = $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.fromObject(object.visa);
                }
                if (object.mc != null) {
                    if (typeof object.mc !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.AppropriationSummaryByCardType.mc: object expected");
                    message.mc = $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.fromObject(object.mc);
                }
                if (object.jcb != null) {
                    if (typeof object.jcb !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.AppropriationSummaryByCardType.jcb: object expected");
                    message.jcb = $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.fromObject(object.jcb);
                }
                if (object.cup != null) {
                    if (typeof object.cup !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.AppropriationSummaryByCardType.cup: object expected");
                    message.cup = $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.fromObject(object.cup);
                }
                if (object.fisc != null) {
                    if (typeof object.fisc !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.AppropriationSummaryByCardType.fisc: object expected");
                    message.fisc = $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.fromObject(object.fisc);
                }
                if (object.motify != null) {
                    if (typeof object.motify !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.AppropriationSummaryByCardType.motify: object expected");
                    message.motify = $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.fromObject(object.motify);
                }
                return message;
            };

            /**
             * Creates a plain object from an AppropriationSummaryByCardType message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardType
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationSummaryByCardType} message AppropriationSummaryByCardType
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationSummaryByCardType.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.visa = null;
                    object.mc = null;
                    object.jcb = null;
                    object.cup = null;
                    object.fisc = null;
                    object.motify = null;
                }
                if (message.visa != null && message.hasOwnProperty("visa"))
                    object.visa = $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.toObject(message.visa, options);
                if (message.mc != null && message.hasOwnProperty("mc"))
                    object.mc = $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.toObject(message.mc, options);
                if (message.jcb != null && message.hasOwnProperty("jcb"))
                    object.jcb = $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.toObject(message.jcb, options);
                if (message.cup != null && message.hasOwnProperty("cup"))
                    object.cup = $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.toObject(message.cup, options);
                if (message.fisc != null && message.hasOwnProperty("fisc"))
                    object.fisc = $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.toObject(message.fisc, options);
                if (message.motify != null && message.hasOwnProperty("motify"))
                    object.motify = $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByCardType.toObject(message.motify, options);
                return object;
            };

            /**
             * Converts this AppropriationSummaryByCardType to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardType
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationSummaryByCardType.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationSummaryByCardType;
        })();

        Protobuf.AppropriationInfoSummaryByIssuer = (function() {

            /**
             * Properties of an AppropriationInfoSummaryByIssuer.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationInfoSummaryByIssuer
             * @property {number|null} [isCreditCard] AppropriationInfoSummaryByIssuer isCreditCard
             * @property {string|null} [issuer] AppropriationInfoSummaryByIssuer issuer
             * @property {string|null} [issuerName] AppropriationInfoSummaryByIssuer issuerName
             * @property {number|null} [count] AppropriationInfoSummaryByIssuer count
             * @property {number|null} [amount] AppropriationInfoSummaryByIssuer amount
             */

            /**
             * Constructs a new AppropriationInfoSummaryByIssuer.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationInfoSummaryByIssuer.
             * @implements IAppropriationInfoSummaryByIssuer
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationInfoSummaryByIssuer=} [properties] Properties to set
             */
            function AppropriationInfoSummaryByIssuer(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationInfoSummaryByIssuer isCreditCard.
             * @member {number} isCreditCard
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummaryByIssuer
             * @instance
             */
            AppropriationInfoSummaryByIssuer.prototype.isCreditCard = 0;

            /**
             * AppropriationInfoSummaryByIssuer issuer.
             * @member {string} issuer
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummaryByIssuer
             * @instance
             */
            AppropriationInfoSummaryByIssuer.prototype.issuer = "";

            /**
             * AppropriationInfoSummaryByIssuer issuerName.
             * @member {string} issuerName
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummaryByIssuer
             * @instance
             */
            AppropriationInfoSummaryByIssuer.prototype.issuerName = "";

            /**
             * AppropriationInfoSummaryByIssuer count.
             * @member {number} count
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummaryByIssuer
             * @instance
             */
            AppropriationInfoSummaryByIssuer.prototype.count = 0;

            /**
             * AppropriationInfoSummaryByIssuer amount.
             * @member {number} amount
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummaryByIssuer
             * @instance
             */
            AppropriationInfoSummaryByIssuer.prototype.amount = 0;

            /**
             * Creates a new AppropriationInfoSummaryByIssuer instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummaryByIssuer
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationInfoSummaryByIssuer=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationInfoSummaryByIssuer} AppropriationInfoSummaryByIssuer instance
             */
            AppropriationInfoSummaryByIssuer.create = function create(properties) {
                return new AppropriationInfoSummaryByIssuer(properties);
            };

            /**
             * Encodes the specified AppropriationInfoSummaryByIssuer message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationInfoSummaryByIssuer.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummaryByIssuer
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationInfoSummaryByIssuer} message AppropriationInfoSummaryByIssuer message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationInfoSummaryByIssuer.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.isCreditCard != null && Object.hasOwnProperty.call(message, "isCreditCard"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.isCreditCard);
                if (message.issuer != null && Object.hasOwnProperty.call(message, "issuer"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.issuer);
                if (message.issuerName != null && Object.hasOwnProperty.call(message, "issuerName"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.issuerName);
                if (message.count != null && Object.hasOwnProperty.call(message, "count"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.count);
                if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                    writer.uint32(/* id 5, wireType 1 =*/41).double(message.amount);
                return writer;
            };

            /**
             * Encodes the specified AppropriationInfoSummaryByIssuer message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationInfoSummaryByIssuer.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummaryByIssuer
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationInfoSummaryByIssuer} message AppropriationInfoSummaryByIssuer message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationInfoSummaryByIssuer.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationInfoSummaryByIssuer message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummaryByIssuer
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationInfoSummaryByIssuer} AppropriationInfoSummaryByIssuer
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationInfoSummaryByIssuer.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByIssuer();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.isCreditCard = reader.int32();
                        break;
                    case 2:
                        message.issuer = reader.string();
                        break;
                    case 3:
                        message.issuerName = reader.string();
                        break;
                    case 4:
                        message.count = reader.int32();
                        break;
                    case 5:
                        message.amount = reader.double();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationInfoSummaryByIssuer message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummaryByIssuer
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationInfoSummaryByIssuer} AppropriationInfoSummaryByIssuer
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationInfoSummaryByIssuer.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationInfoSummaryByIssuer message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummaryByIssuer
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationInfoSummaryByIssuer.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.isCreditCard != null && message.hasOwnProperty("isCreditCard"))
                    if (!$util.isInteger(message.isCreditCard))
                        return "isCreditCard: integer expected";
                if (message.issuer != null && message.hasOwnProperty("issuer"))
                    if (!$util.isString(message.issuer))
                        return "issuer: string expected";
                if (message.issuerName != null && message.hasOwnProperty("issuerName"))
                    if (!$util.isString(message.issuerName))
                        return "issuerName: string expected";
                if (message.count != null && message.hasOwnProperty("count"))
                    if (!$util.isInteger(message.count))
                        return "count: integer expected";
                if (message.amount != null && message.hasOwnProperty("amount"))
                    if (typeof message.amount !== "number")
                        return "amount: number expected";
                return null;
            };

            /**
             * Creates an AppropriationInfoSummaryByIssuer message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummaryByIssuer
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationInfoSummaryByIssuer} AppropriationInfoSummaryByIssuer
             */
            AppropriationInfoSummaryByIssuer.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByIssuer)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByIssuer();
                if (object.isCreditCard != null)
                    message.isCreditCard = object.isCreditCard | 0;
                if (object.issuer != null)
                    message.issuer = String(object.issuer);
                if (object.issuerName != null)
                    message.issuerName = String(object.issuerName);
                if (object.count != null)
                    message.count = object.count | 0;
                if (object.amount != null)
                    message.amount = Number(object.amount);
                return message;
            };

            /**
             * Creates a plain object from an AppropriationInfoSummaryByIssuer message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummaryByIssuer
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationInfoSummaryByIssuer} message AppropriationInfoSummaryByIssuer
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationInfoSummaryByIssuer.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.isCreditCard = 0;
                    object.issuer = "";
                    object.issuerName = "";
                    object.count = 0;
                    object.amount = 0;
                }
                if (message.isCreditCard != null && message.hasOwnProperty("isCreditCard"))
                    object.isCreditCard = message.isCreditCard;
                if (message.issuer != null && message.hasOwnProperty("issuer"))
                    object.issuer = message.issuer;
                if (message.issuerName != null && message.hasOwnProperty("issuerName"))
                    object.issuerName = message.issuerName;
                if (message.count != null && message.hasOwnProperty("count"))
                    object.count = message.count;
                if (message.amount != null && message.hasOwnProperty("amount"))
                    object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
                return object;
            };

            /**
             * Converts this AppropriationInfoSummaryByIssuer to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationInfoSummaryByIssuer
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationInfoSummaryByIssuer.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationInfoSummaryByIssuer;
        })();

        Protobuf.AppropriationSummaryByIssuer = (function() {

            /**
             * Properties of an AppropriationSummaryByIssuer.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationSummaryByIssuer
             * @property {Array.<TCBReceiptApi.Protobuf.IAppropriationInfoSummaryByIssuer>|null} [list] AppropriationSummaryByIssuer list
             */

            /**
             * Constructs a new AppropriationSummaryByIssuer.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationSummaryByIssuer.
             * @implements IAppropriationSummaryByIssuer
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryByIssuer=} [properties] Properties to set
             */
            function AppropriationSummaryByIssuer(properties) {
                this.list = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationSummaryByIssuer list.
             * @member {Array.<TCBReceiptApi.Protobuf.IAppropriationInfoSummaryByIssuer>} list
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer
             * @instance
             */
            AppropriationSummaryByIssuer.prototype.list = $util.emptyArray;

            /**
             * Creates a new AppropriationSummaryByIssuer instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryByIssuer=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer} AppropriationSummaryByIssuer instance
             */
            AppropriationSummaryByIssuer.create = function create(properties) {
                return new AppropriationSummaryByIssuer(properties);
            };

            /**
             * Encodes the specified AppropriationSummaryByIssuer message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryByIssuer} message AppropriationSummaryByIssuer message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationSummaryByIssuer.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.list != null && message.list.length)
                    for (var i = 0; i < message.list.length; ++i)
                        $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByIssuer.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified AppropriationSummaryByIssuer message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryByIssuer} message AppropriationSummaryByIssuer message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationSummaryByIssuer.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationSummaryByIssuer message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer} AppropriationSummaryByIssuer
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationSummaryByIssuer.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByIssuer.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationSummaryByIssuer message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer} AppropriationSummaryByIssuer
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationSummaryByIssuer.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationSummaryByIssuer message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationSummaryByIssuer.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.list != null && message.hasOwnProperty("list")) {
                    if (!Array.isArray(message.list))
                        return "list: array expected";
                    for (var i = 0; i < message.list.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByIssuer.verify(message.list[i]);
                        if (error)
                            return "list." + error;
                    }
                }
                return null;
            };

            /**
             * Creates an AppropriationSummaryByIssuer message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer} AppropriationSummaryByIssuer
             */
            AppropriationSummaryByIssuer.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer();
                if (object.list) {
                    if (!Array.isArray(object.list))
                        throw TypeError(".TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer.list: array expected");
                    message.list = [];
                    for (var i = 0; i < object.list.length; ++i) {
                        if (typeof object.list[i] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer.list: object expected");
                        message.list[i] = $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByIssuer.fromObject(object.list[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from an AppropriationSummaryByIssuer message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer} message AppropriationSummaryByIssuer
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationSummaryByIssuer.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.list = [];
                if (message.list && message.list.length) {
                    object.list = [];
                    for (var j = 0; j < message.list.length; ++j)
                        object.list[j] = $root.TCBReceiptApi.Protobuf.AppropriationInfoSummaryByIssuer.toObject(message.list[j], options);
                }
                return object;
            };

            /**
             * Converts this AppropriationSummaryByIssuer to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationSummaryByIssuer.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationSummaryByIssuer;
        })();

        Protobuf.AppropriationSummaryByCardTypeCollection = (function() {

            /**
             * Properties of an AppropriationSummaryByCardTypeCollection.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationSummaryByCardTypeCollection
             * @property {TCBReceiptApi.Protobuf.IAppropriationSummaryByCardType|null} [cardType] AppropriationSummaryByCardTypeCollection cardType
             * @property {TCBReceiptApi.Protobuf.IAppropriationSummaryByIssuer|null} [creditCard] AppropriationSummaryByCardTypeCollection creditCard
             * @property {TCBReceiptApi.Protobuf.IAppropriationSummaryByIssuer|null} [debitCard] AppropriationSummaryByCardTypeCollection debitCard
             */

            /**
             * Constructs a new AppropriationSummaryByCardTypeCollection.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationSummaryByCardTypeCollection.
             * @implements IAppropriationSummaryByCardTypeCollection
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryByCardTypeCollection=} [properties] Properties to set
             */
            function AppropriationSummaryByCardTypeCollection(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationSummaryByCardTypeCollection cardType.
             * @member {TCBReceiptApi.Protobuf.IAppropriationSummaryByCardType|null|undefined} cardType
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection
             * @instance
             */
            AppropriationSummaryByCardTypeCollection.prototype.cardType = null;

            /**
             * AppropriationSummaryByCardTypeCollection creditCard.
             * @member {TCBReceiptApi.Protobuf.IAppropriationSummaryByIssuer|null|undefined} creditCard
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection
             * @instance
             */
            AppropriationSummaryByCardTypeCollection.prototype.creditCard = null;

            /**
             * AppropriationSummaryByCardTypeCollection debitCard.
             * @member {TCBReceiptApi.Protobuf.IAppropriationSummaryByIssuer|null|undefined} debitCard
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection
             * @instance
             */
            AppropriationSummaryByCardTypeCollection.prototype.debitCard = null;

            /**
             * Creates a new AppropriationSummaryByCardTypeCollection instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryByCardTypeCollection=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection} AppropriationSummaryByCardTypeCollection instance
             */
            AppropriationSummaryByCardTypeCollection.create = function create(properties) {
                return new AppropriationSummaryByCardTypeCollection(properties);
            };

            /**
             * Encodes the specified AppropriationSummaryByCardTypeCollection message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryByCardTypeCollection} message AppropriationSummaryByCardTypeCollection message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationSummaryByCardTypeCollection.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.cardType != null && Object.hasOwnProperty.call(message, "cardType"))
                    $root.TCBReceiptApi.Protobuf.AppropriationSummaryByCardType.encode(message.cardType, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.creditCard != null && Object.hasOwnProperty.call(message, "creditCard"))
                    $root.TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer.encode(message.creditCard, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.debitCard != null && Object.hasOwnProperty.call(message, "debitCard"))
                    $root.TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer.encode(message.debitCard, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified AppropriationSummaryByCardTypeCollection message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryByCardTypeCollection} message AppropriationSummaryByCardTypeCollection message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationSummaryByCardTypeCollection.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationSummaryByCardTypeCollection message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection} AppropriationSummaryByCardTypeCollection
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationSummaryByCardTypeCollection.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.cardType = $root.TCBReceiptApi.Protobuf.AppropriationSummaryByCardType.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.creditCard = $root.TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.debitCard = $root.TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationSummaryByCardTypeCollection message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection} AppropriationSummaryByCardTypeCollection
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationSummaryByCardTypeCollection.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationSummaryByCardTypeCollection message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationSummaryByCardTypeCollection.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.cardType != null && message.hasOwnProperty("cardType")) {
                    var error = $root.TCBReceiptApi.Protobuf.AppropriationSummaryByCardType.verify(message.cardType);
                    if (error)
                        return "cardType." + error;
                }
                if (message.creditCard != null && message.hasOwnProperty("creditCard")) {
                    var error = $root.TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer.verify(message.creditCard);
                    if (error)
                        return "creditCard." + error;
                }
                if (message.debitCard != null && message.hasOwnProperty("debitCard")) {
                    var error = $root.TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer.verify(message.debitCard);
                    if (error)
                        return "debitCard." + error;
                }
                return null;
            };

            /**
             * Creates an AppropriationSummaryByCardTypeCollection message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection} AppropriationSummaryByCardTypeCollection
             */
            AppropriationSummaryByCardTypeCollection.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection();
                if (object.cardType != null) {
                    if (typeof object.cardType !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection.cardType: object expected");
                    message.cardType = $root.TCBReceiptApi.Protobuf.AppropriationSummaryByCardType.fromObject(object.cardType);
                }
                if (object.creditCard != null) {
                    if (typeof object.creditCard !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection.creditCard: object expected");
                    message.creditCard = $root.TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer.fromObject(object.creditCard);
                }
                if (object.debitCard != null) {
                    if (typeof object.debitCard !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection.debitCard: object expected");
                    message.debitCard = $root.TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer.fromObject(object.debitCard);
                }
                return message;
            };

            /**
             * Creates a plain object from an AppropriationSummaryByCardTypeCollection message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection} message AppropriationSummaryByCardTypeCollection
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationSummaryByCardTypeCollection.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.cardType = null;
                    object.creditCard = null;
                    object.debitCard = null;
                }
                if (message.cardType != null && message.hasOwnProperty("cardType"))
                    object.cardType = $root.TCBReceiptApi.Protobuf.AppropriationSummaryByCardType.toObject(message.cardType, options);
                if (message.creditCard != null && message.hasOwnProperty("creditCard"))
                    object.creditCard = $root.TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer.toObject(message.creditCard, options);
                if (message.debitCard != null && message.hasOwnProperty("debitCard"))
                    object.debitCard = $root.TCBReceiptApi.Protobuf.AppropriationSummaryByIssuer.toObject(message.debitCard, options);
                return object;
            };

            /**
             * Converts this AppropriationSummaryByCardTypeCollection to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationSummaryByCardTypeCollection.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationSummaryByCardTypeCollection;
        })();

        Protobuf.AppropriationSummaryByCardTypeCollectionMap = (function() {

            /**
             * Properties of an AppropriationSummaryByCardTypeCollectionMap.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationSummaryByCardTypeCollectionMap
             * @property {Object.<string,TCBReceiptApi.Protobuf.IAppropriationSummaryByCardTypeCollection>|null} [map] AppropriationSummaryByCardTypeCollectionMap map
             */

            /**
             * Constructs a new AppropriationSummaryByCardTypeCollectionMap.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationSummaryByCardTypeCollectionMap.
             * @implements IAppropriationSummaryByCardTypeCollectionMap
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryByCardTypeCollectionMap=} [properties] Properties to set
             */
            function AppropriationSummaryByCardTypeCollectionMap(properties) {
                this.map = {};
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationSummaryByCardTypeCollectionMap map.
             * @member {Object.<string,TCBReceiptApi.Protobuf.IAppropriationSummaryByCardTypeCollection>} map
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollectionMap
             * @instance
             */
            AppropriationSummaryByCardTypeCollectionMap.prototype.map = $util.emptyObject;

            /**
             * Creates a new AppropriationSummaryByCardTypeCollectionMap instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollectionMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryByCardTypeCollectionMap=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollectionMap} AppropriationSummaryByCardTypeCollectionMap instance
             */
            AppropriationSummaryByCardTypeCollectionMap.create = function create(properties) {
                return new AppropriationSummaryByCardTypeCollectionMap(properties);
            };

            /**
             * Encodes the specified AppropriationSummaryByCardTypeCollectionMap message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollectionMap.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollectionMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryByCardTypeCollectionMap} message AppropriationSummaryByCardTypeCollectionMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationSummaryByCardTypeCollectionMap.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.map != null && Object.hasOwnProperty.call(message, "map"))
                    for (var keys = Object.keys(message.map), i = 0; i < keys.length; ++i) {
                        writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                        $root.TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection.encode(message.map[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                    }
                return writer;
            };

            /**
             * Encodes the specified AppropriationSummaryByCardTypeCollectionMap message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollectionMap.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollectionMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryByCardTypeCollectionMap} message AppropriationSummaryByCardTypeCollectionMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationSummaryByCardTypeCollectionMap.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationSummaryByCardTypeCollectionMap message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollectionMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollectionMap} AppropriationSummaryByCardTypeCollectionMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationSummaryByCardTypeCollectionMap.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollectionMap(), key, value;
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (message.map === $util.emptyObject)
                            message.map = {};
                        var end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = null;
                        while (reader.pos < end2) {
                            var tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = $root.TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.map[key] = value;
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationSummaryByCardTypeCollectionMap message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollectionMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollectionMap} AppropriationSummaryByCardTypeCollectionMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationSummaryByCardTypeCollectionMap.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationSummaryByCardTypeCollectionMap message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollectionMap
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationSummaryByCardTypeCollectionMap.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.map != null && message.hasOwnProperty("map")) {
                    if (!$util.isObject(message.map))
                        return "map: object expected";
                    var key = Object.keys(message.map);
                    for (var i = 0; i < key.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection.verify(message.map[key[i]]);
                        if (error)
                            return "map." + error;
                    }
                }
                return null;
            };

            /**
             * Creates an AppropriationSummaryByCardTypeCollectionMap message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollectionMap
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollectionMap} AppropriationSummaryByCardTypeCollectionMap
             */
            AppropriationSummaryByCardTypeCollectionMap.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollectionMap)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollectionMap();
                if (object.map) {
                    if (typeof object.map !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollectionMap.map: object expected");
                    message.map = {};
                    for (var keys = Object.keys(object.map), i = 0; i < keys.length; ++i) {
                        if (typeof object.map[keys[i]] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollectionMap.map: object expected");
                        message.map[keys[i]] = $root.TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection.fromObject(object.map[keys[i]]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from an AppropriationSummaryByCardTypeCollectionMap message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollectionMap
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollectionMap} message AppropriationSummaryByCardTypeCollectionMap
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationSummaryByCardTypeCollectionMap.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.objects || options.defaults)
                    object.map = {};
                var keys2;
                if (message.map && (keys2 = Object.keys(message.map)).length) {
                    object.map = {};
                    for (var j = 0; j < keys2.length; ++j)
                        object.map[keys2[j]] = $root.TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection.toObject(message.map[keys2[j]], options);
                }
                return object;
            };

            /**
             * Converts this AppropriationSummaryByCardTypeCollectionMap to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollectionMap
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationSummaryByCardTypeCollectionMap.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationSummaryByCardTypeCollectionMap;
        })();

        Protobuf.AppropriationSummaryByCardTypeTotal = (function() {

            /**
             * Properties of an AppropriationSummaryByCardTypeTotal.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationSummaryByCardTypeTotal
             * @property {number|null} [count] AppropriationSummaryByCardTypeTotal count
             * @property {number|null} [total] AppropriationSummaryByCardTypeTotal total
             */

            /**
             * Constructs a new AppropriationSummaryByCardTypeTotal.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationSummaryByCardTypeTotal.
             * @implements IAppropriationSummaryByCardTypeTotal
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryByCardTypeTotal=} [properties] Properties to set
             */
            function AppropriationSummaryByCardTypeTotal(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationSummaryByCardTypeTotal count.
             * @member {number} count
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeTotal
             * @instance
             */
            AppropriationSummaryByCardTypeTotal.prototype.count = 0;

            /**
             * AppropriationSummaryByCardTypeTotal total.
             * @member {number} total
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeTotal
             * @instance
             */
            AppropriationSummaryByCardTypeTotal.prototype.total = 0;

            /**
             * Creates a new AppropriationSummaryByCardTypeTotal instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryByCardTypeTotal=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeTotal} AppropriationSummaryByCardTypeTotal instance
             */
            AppropriationSummaryByCardTypeTotal.create = function create(properties) {
                return new AppropriationSummaryByCardTypeTotal(properties);
            };

            /**
             * Encodes the specified AppropriationSummaryByCardTypeTotal message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeTotal.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryByCardTypeTotal} message AppropriationSummaryByCardTypeTotal message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationSummaryByCardTypeTotal.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.count != null && Object.hasOwnProperty.call(message, "count"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.count);
                if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                    writer.uint32(/* id 2, wireType 1 =*/17).double(message.total);
                return writer;
            };

            /**
             * Encodes the specified AppropriationSummaryByCardTypeTotal message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeTotal.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryByCardTypeTotal} message AppropriationSummaryByCardTypeTotal message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationSummaryByCardTypeTotal.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationSummaryByCardTypeTotal message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeTotal
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeTotal} AppropriationSummaryByCardTypeTotal
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationSummaryByCardTypeTotal.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeTotal();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.count = reader.int32();
                        break;
                    case 2:
                        message.total = reader.double();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationSummaryByCardTypeTotal message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeTotal
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeTotal} AppropriationSummaryByCardTypeTotal
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationSummaryByCardTypeTotal.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationSummaryByCardTypeTotal message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeTotal
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationSummaryByCardTypeTotal.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.count != null && message.hasOwnProperty("count"))
                    if (!$util.isInteger(message.count))
                        return "count: integer expected";
                if (message.total != null && message.hasOwnProperty("total"))
                    if (typeof message.total !== "number")
                        return "total: number expected";
                return null;
            };

            /**
             * Creates an AppropriationSummaryByCardTypeTotal message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeTotal
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeTotal} AppropriationSummaryByCardTypeTotal
             */
            AppropriationSummaryByCardTypeTotal.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeTotal)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeTotal();
                if (object.count != null)
                    message.count = object.count | 0;
                if (object.total != null)
                    message.total = Number(object.total);
                return message;
            };

            /**
             * Creates a plain object from an AppropriationSummaryByCardTypeTotal message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeTotal} message AppropriationSummaryByCardTypeTotal
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationSummaryByCardTypeTotal.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.count = 0;
                    object.total = 0;
                }
                if (message.count != null && message.hasOwnProperty("count"))
                    object.count = message.count;
                if (message.total != null && message.hasOwnProperty("total"))
                    object.total = options.json && !isFinite(message.total) ? String(message.total) : message.total;
                return object;
            };

            /**
             * Converts this AppropriationSummaryByCardTypeTotal to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeTotal
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationSummaryByCardTypeTotal.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationSummaryByCardTypeTotal;
        })();

        Protobuf.AppropriationQuery = (function() {

            /**
             * Properties of an AppropriationQuery.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationQuery
             * @property {Array.<string>|null} [storeList] AppropriationQuery storeList
             * @property {string|null} [tidNumber] AppropriationQuery tidNumber
             * @property {string|null} [authCode] AppropriationQuery authCode
             * @property {string|null} [cardNo] AppropriationQuery cardNo
             * @property {string|null} [cardType] AppropriationQuery cardType
             * @property {number|null} [type] AppropriationQuery type
             * @property {number|null} [flag] AppropriationQuery flag
             * @property {string|null} [orderNo] AppropriationQuery orderNo
             * @property {number|null} [dateType] AppropriationQuery dateType
             * @property {string|null} [dateStart] AppropriationQuery dateStart
             * @property {string|null} [dateEnd] AppropriationQuery dateEnd
             * @property {string|null} [terminalNoStart] AppropriationQuery terminalNoStart
             * @property {string|null} [terminalNoEnd] AppropriationQuery terminalNoEnd
             * @property {string|null} [specificStore] AppropriationQuery specificStore
             */

            /**
             * Constructs a new AppropriationQuery.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationQuery.
             * @implements IAppropriationQuery
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationQuery=} [properties] Properties to set
             */
            function AppropriationQuery(properties) {
                this.storeList = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationQuery storeList.
             * @member {Array.<string>} storeList
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuery
             * @instance
             */
            AppropriationQuery.prototype.storeList = $util.emptyArray;

            /**
             * AppropriationQuery tidNumber.
             * @member {string} tidNumber
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuery
             * @instance
             */
            AppropriationQuery.prototype.tidNumber = "";

            /**
             * AppropriationQuery authCode.
             * @member {string} authCode
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuery
             * @instance
             */
            AppropriationQuery.prototype.authCode = "";

            /**
             * AppropriationQuery cardNo.
             * @member {string} cardNo
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuery
             * @instance
             */
            AppropriationQuery.prototype.cardNo = "";

            /**
             * AppropriationQuery cardType.
             * @member {string} cardType
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuery
             * @instance
             */
            AppropriationQuery.prototype.cardType = "";

            /**
             * AppropriationQuery type.
             * @member {number} type
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuery
             * @instance
             */
            AppropriationQuery.prototype.type = 0;

            /**
             * AppropriationQuery flag.
             * @member {number} flag
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuery
             * @instance
             */
            AppropriationQuery.prototype.flag = 0;

            /**
             * AppropriationQuery orderNo.
             * @member {string} orderNo
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuery
             * @instance
             */
            AppropriationQuery.prototype.orderNo = "";

            /**
             * AppropriationQuery dateType.
             * @member {number} dateType
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuery
             * @instance
             */
            AppropriationQuery.prototype.dateType = 0;

            /**
             * AppropriationQuery dateStart.
             * @member {string} dateStart
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuery
             * @instance
             */
            AppropriationQuery.prototype.dateStart = "";

            /**
             * AppropriationQuery dateEnd.
             * @member {string} dateEnd
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuery
             * @instance
             */
            AppropriationQuery.prototype.dateEnd = "";

            /**
             * AppropriationQuery terminalNoStart.
             * @member {string} terminalNoStart
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuery
             * @instance
             */
            AppropriationQuery.prototype.terminalNoStart = "";

            /**
             * AppropriationQuery terminalNoEnd.
             * @member {string} terminalNoEnd
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuery
             * @instance
             */
            AppropriationQuery.prototype.terminalNoEnd = "";

            /**
             * AppropriationQuery specificStore.
             * @member {string} specificStore
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuery
             * @instance
             */
            AppropriationQuery.prototype.specificStore = "";

            /**
             * Creates a new AppropriationQuery instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationQuery=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationQuery} AppropriationQuery instance
             */
            AppropriationQuery.create = function create(properties) {
                return new AppropriationQuery(properties);
            };

            /**
             * Encodes the specified AppropriationQuery message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationQuery.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationQuery} message AppropriationQuery message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationQuery.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.storeList != null && message.storeList.length)
                    for (var i = 0; i < message.storeList.length; ++i)
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.storeList[i]);
                if (message.tidNumber != null && Object.hasOwnProperty.call(message, "tidNumber"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.tidNumber);
                if (message.authCode != null && Object.hasOwnProperty.call(message, "authCode"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.authCode);
                if (message.cardNo != null && Object.hasOwnProperty.call(message, "cardNo"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.cardNo);
                if (message.cardType != null && Object.hasOwnProperty.call(message, "cardType"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.cardType);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int32(message.type);
                if (message.flag != null && Object.hasOwnProperty.call(message, "flag"))
                    writer.uint32(/* id 7, wireType 0 =*/56).int32(message.flag);
                if (message.orderNo != null && Object.hasOwnProperty.call(message, "orderNo"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.orderNo);
                if (message.dateType != null && Object.hasOwnProperty.call(message, "dateType"))
                    writer.uint32(/* id 9, wireType 0 =*/72).int32(message.dateType);
                if (message.dateStart != null && Object.hasOwnProperty.call(message, "dateStart"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.dateStart);
                if (message.dateEnd != null && Object.hasOwnProperty.call(message, "dateEnd"))
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.dateEnd);
                if (message.terminalNoStart != null && Object.hasOwnProperty.call(message, "terminalNoStart"))
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.terminalNoStart);
                if (message.terminalNoEnd != null && Object.hasOwnProperty.call(message, "terminalNoEnd"))
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.terminalNoEnd);
                if (message.specificStore != null && Object.hasOwnProperty.call(message, "specificStore"))
                    writer.uint32(/* id 14, wireType 2 =*/114).string(message.specificStore);
                return writer;
            };

            /**
             * Encodes the specified AppropriationQuery message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationQuery.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationQuery} message AppropriationQuery message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationQuery.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationQuery message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuery
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationQuery} AppropriationQuery
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationQuery.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationQuery();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.storeList && message.storeList.length))
                            message.storeList = [];
                        message.storeList.push(reader.string());
                        break;
                    case 2:
                        message.tidNumber = reader.string();
                        break;
                    case 3:
                        message.authCode = reader.string();
                        break;
                    case 4:
                        message.cardNo = reader.string();
                        break;
                    case 5:
                        message.cardType = reader.string();
                        break;
                    case 6:
                        message.type = reader.int32();
                        break;
                    case 7:
                        message.flag = reader.int32();
                        break;
                    case 8:
                        message.orderNo = reader.string();
                        break;
                    case 9:
                        message.dateType = reader.int32();
                        break;
                    case 10:
                        message.dateStart = reader.string();
                        break;
                    case 11:
                        message.dateEnd = reader.string();
                        break;
                    case 12:
                        message.terminalNoStart = reader.string();
                        break;
                    case 13:
                        message.terminalNoEnd = reader.string();
                        break;
                    case 14:
                        message.specificStore = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationQuery message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuery
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationQuery} AppropriationQuery
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationQuery.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationQuery message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuery
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationQuery.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.storeList != null && message.hasOwnProperty("storeList")) {
                    if (!Array.isArray(message.storeList))
                        return "storeList: array expected";
                    for (var i = 0; i < message.storeList.length; ++i)
                        if (!$util.isString(message.storeList[i]))
                            return "storeList: string[] expected";
                }
                if (message.tidNumber != null && message.hasOwnProperty("tidNumber"))
                    if (!$util.isString(message.tidNumber))
                        return "tidNumber: string expected";
                if (message.authCode != null && message.hasOwnProperty("authCode"))
                    if (!$util.isString(message.authCode))
                        return "authCode: string expected";
                if (message.cardNo != null && message.hasOwnProperty("cardNo"))
                    if (!$util.isString(message.cardNo))
                        return "cardNo: string expected";
                if (message.cardType != null && message.hasOwnProperty("cardType"))
                    if (!$util.isString(message.cardType))
                        return "cardType: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isInteger(message.type))
                        return "type: integer expected";
                if (message.flag != null && message.hasOwnProperty("flag"))
                    if (!$util.isInteger(message.flag))
                        return "flag: integer expected";
                if (message.orderNo != null && message.hasOwnProperty("orderNo"))
                    if (!$util.isString(message.orderNo))
                        return "orderNo: string expected";
                if (message.dateType != null && message.hasOwnProperty("dateType"))
                    if (!$util.isInteger(message.dateType))
                        return "dateType: integer expected";
                if (message.dateStart != null && message.hasOwnProperty("dateStart"))
                    if (!$util.isString(message.dateStart))
                        return "dateStart: string expected";
                if (message.dateEnd != null && message.hasOwnProperty("dateEnd"))
                    if (!$util.isString(message.dateEnd))
                        return "dateEnd: string expected";
                if (message.terminalNoStart != null && message.hasOwnProperty("terminalNoStart"))
                    if (!$util.isString(message.terminalNoStart))
                        return "terminalNoStart: string expected";
                if (message.terminalNoEnd != null && message.hasOwnProperty("terminalNoEnd"))
                    if (!$util.isString(message.terminalNoEnd))
                        return "terminalNoEnd: string expected";
                if (message.specificStore != null && message.hasOwnProperty("specificStore"))
                    if (!$util.isString(message.specificStore))
                        return "specificStore: string expected";
                return null;
            };

            /**
             * Creates an AppropriationQuery message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuery
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationQuery} AppropriationQuery
             */
            AppropriationQuery.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationQuery)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationQuery();
                if (object.storeList) {
                    if (!Array.isArray(object.storeList))
                        throw TypeError(".TCBReceiptApi.Protobuf.AppropriationQuery.storeList: array expected");
                    message.storeList = [];
                    for (var i = 0; i < object.storeList.length; ++i)
                        message.storeList[i] = String(object.storeList[i]);
                }
                if (object.tidNumber != null)
                    message.tidNumber = String(object.tidNumber);
                if (object.authCode != null)
                    message.authCode = String(object.authCode);
                if (object.cardNo != null)
                    message.cardNo = String(object.cardNo);
                if (object.cardType != null)
                    message.cardType = String(object.cardType);
                if (object.type != null)
                    message.type = object.type | 0;
                if (object.flag != null)
                    message.flag = object.flag | 0;
                if (object.orderNo != null)
                    message.orderNo = String(object.orderNo);
                if (object.dateType != null)
                    message.dateType = object.dateType | 0;
                if (object.dateStart != null)
                    message.dateStart = String(object.dateStart);
                if (object.dateEnd != null)
                    message.dateEnd = String(object.dateEnd);
                if (object.terminalNoStart != null)
                    message.terminalNoStart = String(object.terminalNoStart);
                if (object.terminalNoEnd != null)
                    message.terminalNoEnd = String(object.terminalNoEnd);
                if (object.specificStore != null)
                    message.specificStore = String(object.specificStore);
                return message;
            };

            /**
             * Creates a plain object from an AppropriationQuery message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationQuery} message AppropriationQuery
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationQuery.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.storeList = [];
                if (options.defaults) {
                    object.tidNumber = "";
                    object.authCode = "";
                    object.cardNo = "";
                    object.cardType = "";
                    object.type = 0;
                    object.flag = 0;
                    object.orderNo = "";
                    object.dateType = 0;
                    object.dateStart = "";
                    object.dateEnd = "";
                    object.terminalNoStart = "";
                    object.terminalNoEnd = "";
                    object.specificStore = "";
                }
                if (message.storeList && message.storeList.length) {
                    object.storeList = [];
                    for (var j = 0; j < message.storeList.length; ++j)
                        object.storeList[j] = message.storeList[j];
                }
                if (message.tidNumber != null && message.hasOwnProperty("tidNumber"))
                    object.tidNumber = message.tidNumber;
                if (message.authCode != null && message.hasOwnProperty("authCode"))
                    object.authCode = message.authCode;
                if (message.cardNo != null && message.hasOwnProperty("cardNo"))
                    object.cardNo = message.cardNo;
                if (message.cardType != null && message.hasOwnProperty("cardType"))
                    object.cardType = message.cardType;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.flag != null && message.hasOwnProperty("flag"))
                    object.flag = message.flag;
                if (message.orderNo != null && message.hasOwnProperty("orderNo"))
                    object.orderNo = message.orderNo;
                if (message.dateType != null && message.hasOwnProperty("dateType"))
                    object.dateType = message.dateType;
                if (message.dateStart != null && message.hasOwnProperty("dateStart"))
                    object.dateStart = message.dateStart;
                if (message.dateEnd != null && message.hasOwnProperty("dateEnd"))
                    object.dateEnd = message.dateEnd;
                if (message.terminalNoStart != null && message.hasOwnProperty("terminalNoStart"))
                    object.terminalNoStart = message.terminalNoStart;
                if (message.terminalNoEnd != null && message.hasOwnProperty("terminalNoEnd"))
                    object.terminalNoEnd = message.terminalNoEnd;
                if (message.specificStore != null && message.hasOwnProperty("specificStore"))
                    object.specificStore = message.specificStore;
                return object;
            };

            /**
             * Converts this AppropriationQuery to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuery
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationQuery.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationQuery;
        })();

        Protobuf.AppropriationQuerySpecificStore = (function() {

            /**
             * Properties of an AppropriationQuerySpecificStore.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationQuerySpecificStore
             * @property {string|null} [specificStore] AppropriationQuerySpecificStore specificStore
             * @property {string|null} [authCode] AppropriationQuerySpecificStore authCode
             * @property {string|null} [cardNo] AppropriationQuerySpecificStore cardNo
             * @property {string|null} [cardType] AppropriationQuerySpecificStore cardType
             * @property {number|null} [type] AppropriationQuerySpecificStore type
             * @property {number|null} [flag] AppropriationQuerySpecificStore flag
             * @property {string|null} [orderNo] AppropriationQuerySpecificStore orderNo
             * @property {string|null} [terminalNoStart] AppropriationQuerySpecificStore terminalNoStart
             * @property {string|null} [terminalNoEnd] AppropriationQuerySpecificStore terminalNoEnd
             * @property {string|null} [submitDateStart] AppropriationQuerySpecificStore submitDateStart
             * @property {string|null} [submitDateEnd] AppropriationQuerySpecificStore submitDateEnd
             * @property {string|null} [transDateStart] AppropriationQuerySpecificStore transDateStart
             * @property {string|null} [transDateEnd] AppropriationQuerySpecificStore transDateEnd
             * @property {string|null} [dateStart] AppropriationQuerySpecificStore dateStart
             * @property {string|null} [dateEnd] AppropriationQuerySpecificStore dateEnd
             */

            /**
             * Constructs a new AppropriationQuerySpecificStore.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationQuerySpecificStore.
             * @implements IAppropriationQuerySpecificStore
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationQuerySpecificStore=} [properties] Properties to set
             */
            function AppropriationQuerySpecificStore(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationQuerySpecificStore specificStore.
             * @member {string} specificStore
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore
             * @instance
             */
            AppropriationQuerySpecificStore.prototype.specificStore = "";

            /**
             * AppropriationQuerySpecificStore authCode.
             * @member {string} authCode
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore
             * @instance
             */
            AppropriationQuerySpecificStore.prototype.authCode = "";

            /**
             * AppropriationQuerySpecificStore cardNo.
             * @member {string} cardNo
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore
             * @instance
             */
            AppropriationQuerySpecificStore.prototype.cardNo = "";

            /**
             * AppropriationQuerySpecificStore cardType.
             * @member {string} cardType
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore
             * @instance
             */
            AppropriationQuerySpecificStore.prototype.cardType = "";

            /**
             * AppropriationQuerySpecificStore type.
             * @member {number} type
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore
             * @instance
             */
            AppropriationQuerySpecificStore.prototype.type = 0;

            /**
             * AppropriationQuerySpecificStore flag.
             * @member {number} flag
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore
             * @instance
             */
            AppropriationQuerySpecificStore.prototype.flag = 0;

            /**
             * AppropriationQuerySpecificStore orderNo.
             * @member {string} orderNo
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore
             * @instance
             */
            AppropriationQuerySpecificStore.prototype.orderNo = "";

            /**
             * AppropriationQuerySpecificStore terminalNoStart.
             * @member {string} terminalNoStart
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore
             * @instance
             */
            AppropriationQuerySpecificStore.prototype.terminalNoStart = "";

            /**
             * AppropriationQuerySpecificStore terminalNoEnd.
             * @member {string} terminalNoEnd
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore
             * @instance
             */
            AppropriationQuerySpecificStore.prototype.terminalNoEnd = "";

            /**
             * AppropriationQuerySpecificStore submitDateStart.
             * @member {string} submitDateStart
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore
             * @instance
             */
            AppropriationQuerySpecificStore.prototype.submitDateStart = "";

            /**
             * AppropriationQuerySpecificStore submitDateEnd.
             * @member {string} submitDateEnd
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore
             * @instance
             */
            AppropriationQuerySpecificStore.prototype.submitDateEnd = "";

            /**
             * AppropriationQuerySpecificStore transDateStart.
             * @member {string} transDateStart
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore
             * @instance
             */
            AppropriationQuerySpecificStore.prototype.transDateStart = "";

            /**
             * AppropriationQuerySpecificStore transDateEnd.
             * @member {string} transDateEnd
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore
             * @instance
             */
            AppropriationQuerySpecificStore.prototype.transDateEnd = "";

            /**
             * AppropriationQuerySpecificStore dateStart.
             * @member {string} dateStart
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore
             * @instance
             */
            AppropriationQuerySpecificStore.prototype.dateStart = "";

            /**
             * AppropriationQuerySpecificStore dateEnd.
             * @member {string} dateEnd
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore
             * @instance
             */
            AppropriationQuerySpecificStore.prototype.dateEnd = "";

            /**
             * Creates a new AppropriationQuerySpecificStore instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationQuerySpecificStore=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore} AppropriationQuerySpecificStore instance
             */
            AppropriationQuerySpecificStore.create = function create(properties) {
                return new AppropriationQuerySpecificStore(properties);
            };

            /**
             * Encodes the specified AppropriationQuerySpecificStore message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationQuerySpecificStore} message AppropriationQuerySpecificStore message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationQuerySpecificStore.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.specificStore != null && Object.hasOwnProperty.call(message, "specificStore"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.specificStore);
                if (message.authCode != null && Object.hasOwnProperty.call(message, "authCode"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.authCode);
                if (message.cardNo != null && Object.hasOwnProperty.call(message, "cardNo"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.cardNo);
                if (message.cardType != null && Object.hasOwnProperty.call(message, "cardType"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.cardType);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int32(message.type);
                if (message.flag != null && Object.hasOwnProperty.call(message, "flag"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int32(message.flag);
                if (message.orderNo != null && Object.hasOwnProperty.call(message, "orderNo"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.orderNo);
                if (message.terminalNoStart != null && Object.hasOwnProperty.call(message, "terminalNoStart"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.terminalNoStart);
                if (message.terminalNoEnd != null && Object.hasOwnProperty.call(message, "terminalNoEnd"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.terminalNoEnd);
                if (message.submitDateStart != null && Object.hasOwnProperty.call(message, "submitDateStart"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.submitDateStart);
                if (message.submitDateEnd != null && Object.hasOwnProperty.call(message, "submitDateEnd"))
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.submitDateEnd);
                if (message.transDateStart != null && Object.hasOwnProperty.call(message, "transDateStart"))
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.transDateStart);
                if (message.transDateEnd != null && Object.hasOwnProperty.call(message, "transDateEnd"))
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.transDateEnd);
                if (message.dateStart != null && Object.hasOwnProperty.call(message, "dateStart"))
                    writer.uint32(/* id 14, wireType 2 =*/114).string(message.dateStart);
                if (message.dateEnd != null && Object.hasOwnProperty.call(message, "dateEnd"))
                    writer.uint32(/* id 15, wireType 2 =*/122).string(message.dateEnd);
                return writer;
            };

            /**
             * Encodes the specified AppropriationQuerySpecificStore message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationQuerySpecificStore} message AppropriationQuerySpecificStore message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationQuerySpecificStore.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationQuerySpecificStore message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore} AppropriationQuerySpecificStore
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationQuerySpecificStore.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.specificStore = reader.string();
                        break;
                    case 2:
                        message.authCode = reader.string();
                        break;
                    case 3:
                        message.cardNo = reader.string();
                        break;
                    case 4:
                        message.cardType = reader.string();
                        break;
                    case 5:
                        message.type = reader.int32();
                        break;
                    case 6:
                        message.flag = reader.int32();
                        break;
                    case 7:
                        message.orderNo = reader.string();
                        break;
                    case 8:
                        message.terminalNoStart = reader.string();
                        break;
                    case 9:
                        message.terminalNoEnd = reader.string();
                        break;
                    case 10:
                        message.submitDateStart = reader.string();
                        break;
                    case 11:
                        message.submitDateEnd = reader.string();
                        break;
                    case 12:
                        message.transDateStart = reader.string();
                        break;
                    case 13:
                        message.transDateEnd = reader.string();
                        break;
                    case 14:
                        message.dateStart = reader.string();
                        break;
                    case 15:
                        message.dateEnd = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationQuerySpecificStore message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore} AppropriationQuerySpecificStore
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationQuerySpecificStore.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationQuerySpecificStore message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationQuerySpecificStore.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.specificStore != null && message.hasOwnProperty("specificStore"))
                    if (!$util.isString(message.specificStore))
                        return "specificStore: string expected";
                if (message.authCode != null && message.hasOwnProperty("authCode"))
                    if (!$util.isString(message.authCode))
                        return "authCode: string expected";
                if (message.cardNo != null && message.hasOwnProperty("cardNo"))
                    if (!$util.isString(message.cardNo))
                        return "cardNo: string expected";
                if (message.cardType != null && message.hasOwnProperty("cardType"))
                    if (!$util.isString(message.cardType))
                        return "cardType: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isInteger(message.type))
                        return "type: integer expected";
                if (message.flag != null && message.hasOwnProperty("flag"))
                    if (!$util.isInteger(message.flag))
                        return "flag: integer expected";
                if (message.orderNo != null && message.hasOwnProperty("orderNo"))
                    if (!$util.isString(message.orderNo))
                        return "orderNo: string expected";
                if (message.terminalNoStart != null && message.hasOwnProperty("terminalNoStart"))
                    if (!$util.isString(message.terminalNoStart))
                        return "terminalNoStart: string expected";
                if (message.terminalNoEnd != null && message.hasOwnProperty("terminalNoEnd"))
                    if (!$util.isString(message.terminalNoEnd))
                        return "terminalNoEnd: string expected";
                if (message.submitDateStart != null && message.hasOwnProperty("submitDateStart"))
                    if (!$util.isString(message.submitDateStart))
                        return "submitDateStart: string expected";
                if (message.submitDateEnd != null && message.hasOwnProperty("submitDateEnd"))
                    if (!$util.isString(message.submitDateEnd))
                        return "submitDateEnd: string expected";
                if (message.transDateStart != null && message.hasOwnProperty("transDateStart"))
                    if (!$util.isString(message.transDateStart))
                        return "transDateStart: string expected";
                if (message.transDateEnd != null && message.hasOwnProperty("transDateEnd"))
                    if (!$util.isString(message.transDateEnd))
                        return "transDateEnd: string expected";
                if (message.dateStart != null && message.hasOwnProperty("dateStart"))
                    if (!$util.isString(message.dateStart))
                        return "dateStart: string expected";
                if (message.dateEnd != null && message.hasOwnProperty("dateEnd"))
                    if (!$util.isString(message.dateEnd))
                        return "dateEnd: string expected";
                return null;
            };

            /**
             * Creates an AppropriationQuerySpecificStore message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore} AppropriationQuerySpecificStore
             */
            AppropriationQuerySpecificStore.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore();
                if (object.specificStore != null)
                    message.specificStore = String(object.specificStore);
                if (object.authCode != null)
                    message.authCode = String(object.authCode);
                if (object.cardNo != null)
                    message.cardNo = String(object.cardNo);
                if (object.cardType != null)
                    message.cardType = String(object.cardType);
                if (object.type != null)
                    message.type = object.type | 0;
                if (object.flag != null)
                    message.flag = object.flag | 0;
                if (object.orderNo != null)
                    message.orderNo = String(object.orderNo);
                if (object.terminalNoStart != null)
                    message.terminalNoStart = String(object.terminalNoStart);
                if (object.terminalNoEnd != null)
                    message.terminalNoEnd = String(object.terminalNoEnd);
                if (object.submitDateStart != null)
                    message.submitDateStart = String(object.submitDateStart);
                if (object.submitDateEnd != null)
                    message.submitDateEnd = String(object.submitDateEnd);
                if (object.transDateStart != null)
                    message.transDateStart = String(object.transDateStart);
                if (object.transDateEnd != null)
                    message.transDateEnd = String(object.transDateEnd);
                if (object.dateStart != null)
                    message.dateStart = String(object.dateStart);
                if (object.dateEnd != null)
                    message.dateEnd = String(object.dateEnd);
                return message;
            };

            /**
             * Creates a plain object from an AppropriationQuerySpecificStore message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore} message AppropriationQuerySpecificStore
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationQuerySpecificStore.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.specificStore = "";
                    object.authCode = "";
                    object.cardNo = "";
                    object.cardType = "";
                    object.type = 0;
                    object.flag = 0;
                    object.orderNo = "";
                    object.terminalNoStart = "";
                    object.terminalNoEnd = "";
                    object.submitDateStart = "";
                    object.submitDateEnd = "";
                    object.transDateStart = "";
                    object.transDateEnd = "";
                    object.dateStart = "";
                    object.dateEnd = "";
                }
                if (message.specificStore != null && message.hasOwnProperty("specificStore"))
                    object.specificStore = message.specificStore;
                if (message.authCode != null && message.hasOwnProperty("authCode"))
                    object.authCode = message.authCode;
                if (message.cardNo != null && message.hasOwnProperty("cardNo"))
                    object.cardNo = message.cardNo;
                if (message.cardType != null && message.hasOwnProperty("cardType"))
                    object.cardType = message.cardType;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.flag != null && message.hasOwnProperty("flag"))
                    object.flag = message.flag;
                if (message.orderNo != null && message.hasOwnProperty("orderNo"))
                    object.orderNo = message.orderNo;
                if (message.terminalNoStart != null && message.hasOwnProperty("terminalNoStart"))
                    object.terminalNoStart = message.terminalNoStart;
                if (message.terminalNoEnd != null && message.hasOwnProperty("terminalNoEnd"))
                    object.terminalNoEnd = message.terminalNoEnd;
                if (message.submitDateStart != null && message.hasOwnProperty("submitDateStart"))
                    object.submitDateStart = message.submitDateStart;
                if (message.submitDateEnd != null && message.hasOwnProperty("submitDateEnd"))
                    object.submitDateEnd = message.submitDateEnd;
                if (message.transDateStart != null && message.hasOwnProperty("transDateStart"))
                    object.transDateStart = message.transDateStart;
                if (message.transDateEnd != null && message.hasOwnProperty("transDateEnd"))
                    object.transDateEnd = message.transDateEnd;
                if (message.dateStart != null && message.hasOwnProperty("dateStart"))
                    object.dateStart = message.dateStart;
                if (message.dateEnd != null && message.hasOwnProperty("dateEnd"))
                    object.dateEnd = message.dateEnd;
                return object;
            };

            /**
             * Converts this AppropriationQuerySpecificStore to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationQuerySpecificStore
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationQuerySpecificStore.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationQuerySpecificStore;
        })();

        Protobuf.AppropriationCreditExport = (function() {

            /**
             * Properties of an AppropriationCreditExport.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationCreditExport
             * @property {string|null} [storeCode] AppropriationCreditExport storeCode
             * @property {string|null} [registerName] AppropriationCreditExport registerName
             * @property {string|null} [terminalNo] AppropriationCreditExport terminalNo
             * @property {string|null} [date] AppropriationCreditExport date
             * @property {string|null} [submitDate] AppropriationCreditExport submitDate
             * @property {string|null} [batchNo] AppropriationCreditExport batchNo
             * @property {string|null} [transDate] AppropriationCreditExport transDate
             * @property {string|null} [transTime] AppropriationCreditExport transTime
             * @property {string|null} [code] AppropriationCreditExport code
             * @property {string|null} [authCode] AppropriationCreditExport authCode
             * @property {string|null} [amount] AppropriationCreditExport amount
             * @property {string|null} [cardNo] AppropriationCreditExport cardNo
             * @property {string|null} [cardType] AppropriationCreditExport cardType
             * @property {string|null} [orderNo] AppropriationCreditExport orderNo
             * @property {string|null} [issuer] AppropriationCreditExport issuer
             * @property {string|null} [installCode] AppropriationCreditExport installCode
             * @property {string|null} [installTimes] AppropriationCreditExport installTimes
             * @property {string|null} [settleCode] AppropriationCreditExport settleCode
             * @property {string|null} [qrFlag] AppropriationCreditExport qrFlag
             * @property {string|null} [stan] AppropriationCreditExport stan
             * @property {string|null} [quotaFlag] AppropriationCreditExport quotaFlag
             * @property {string|null} [charge] AppropriationCreditExport charge
             */

            /**
             * Constructs a new AppropriationCreditExport.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationCreditExport.
             * @implements IAppropriationCreditExport
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationCreditExport=} [properties] Properties to set
             */
            function AppropriationCreditExport(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationCreditExport storeCode.
             * @member {string} storeCode
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditExport
             * @instance
             */
            AppropriationCreditExport.prototype.storeCode = "";

            /**
             * AppropriationCreditExport registerName.
             * @member {string} registerName
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditExport
             * @instance
             */
            AppropriationCreditExport.prototype.registerName = "";

            /**
             * AppropriationCreditExport terminalNo.
             * @member {string} terminalNo
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditExport
             * @instance
             */
            AppropriationCreditExport.prototype.terminalNo = "";

            /**
             * AppropriationCreditExport date.
             * @member {string} date
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditExport
             * @instance
             */
            AppropriationCreditExport.prototype.date = "";

            /**
             * AppropriationCreditExport submitDate.
             * @member {string} submitDate
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditExport
             * @instance
             */
            AppropriationCreditExport.prototype.submitDate = "";

            /**
             * AppropriationCreditExport batchNo.
             * @member {string} batchNo
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditExport
             * @instance
             */
            AppropriationCreditExport.prototype.batchNo = "";

            /**
             * AppropriationCreditExport transDate.
             * @member {string} transDate
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditExport
             * @instance
             */
            AppropriationCreditExport.prototype.transDate = "";

            /**
             * AppropriationCreditExport transTime.
             * @member {string} transTime
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditExport
             * @instance
             */
            AppropriationCreditExport.prototype.transTime = "";

            /**
             * AppropriationCreditExport code.
             * @member {string} code
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditExport
             * @instance
             */
            AppropriationCreditExport.prototype.code = "";

            /**
             * AppropriationCreditExport authCode.
             * @member {string} authCode
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditExport
             * @instance
             */
            AppropriationCreditExport.prototype.authCode = "";

            /**
             * AppropriationCreditExport amount.
             * @member {string} amount
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditExport
             * @instance
             */
            AppropriationCreditExport.prototype.amount = "";

            /**
             * AppropriationCreditExport cardNo.
             * @member {string} cardNo
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditExport
             * @instance
             */
            AppropriationCreditExport.prototype.cardNo = "";

            /**
             * AppropriationCreditExport cardType.
             * @member {string} cardType
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditExport
             * @instance
             */
            AppropriationCreditExport.prototype.cardType = "";

            /**
             * AppropriationCreditExport orderNo.
             * @member {string} orderNo
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditExport
             * @instance
             */
            AppropriationCreditExport.prototype.orderNo = "";

            /**
             * AppropriationCreditExport issuer.
             * @member {string} issuer
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditExport
             * @instance
             */
            AppropriationCreditExport.prototype.issuer = "";

            /**
             * AppropriationCreditExport installCode.
             * @member {string} installCode
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditExport
             * @instance
             */
            AppropriationCreditExport.prototype.installCode = "";

            /**
             * AppropriationCreditExport installTimes.
             * @member {string} installTimes
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditExport
             * @instance
             */
            AppropriationCreditExport.prototype.installTimes = "";

            /**
             * AppropriationCreditExport settleCode.
             * @member {string} settleCode
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditExport
             * @instance
             */
            AppropriationCreditExport.prototype.settleCode = "";

            /**
             * AppropriationCreditExport qrFlag.
             * @member {string} qrFlag
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditExport
             * @instance
             */
            AppropriationCreditExport.prototype.qrFlag = "";

            /**
             * AppropriationCreditExport stan.
             * @member {string} stan
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditExport
             * @instance
             */
            AppropriationCreditExport.prototype.stan = "";

            /**
             * AppropriationCreditExport quotaFlag.
             * @member {string} quotaFlag
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditExport
             * @instance
             */
            AppropriationCreditExport.prototype.quotaFlag = "";

            /**
             * AppropriationCreditExport charge.
             * @member {string} charge
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditExport
             * @instance
             */
            AppropriationCreditExport.prototype.charge = "";

            /**
             * Creates a new AppropriationCreditExport instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationCreditExport=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationCreditExport} AppropriationCreditExport instance
             */
            AppropriationCreditExport.create = function create(properties) {
                return new AppropriationCreditExport(properties);
            };

            /**
             * Encodes the specified AppropriationCreditExport message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationCreditExport.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationCreditExport} message AppropriationCreditExport message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationCreditExport.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.storeCode != null && Object.hasOwnProperty.call(message, "storeCode"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.storeCode);
                if (message.registerName != null && Object.hasOwnProperty.call(message, "registerName"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.registerName);
                if (message.terminalNo != null && Object.hasOwnProperty.call(message, "terminalNo"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.terminalNo);
                if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.date);
                if (message.submitDate != null && Object.hasOwnProperty.call(message, "submitDate"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.submitDate);
                if (message.batchNo != null && Object.hasOwnProperty.call(message, "batchNo"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.batchNo);
                if (message.transDate != null && Object.hasOwnProperty.call(message, "transDate"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.transDate);
                if (message.transTime != null && Object.hasOwnProperty.call(message, "transTime"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.transTime);
                if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.code);
                if (message.authCode != null && Object.hasOwnProperty.call(message, "authCode"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.authCode);
                if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.amount);
                if (message.cardNo != null && Object.hasOwnProperty.call(message, "cardNo"))
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.cardNo);
                if (message.cardType != null && Object.hasOwnProperty.call(message, "cardType"))
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.cardType);
                if (message.orderNo != null && Object.hasOwnProperty.call(message, "orderNo"))
                    writer.uint32(/* id 14, wireType 2 =*/114).string(message.orderNo);
                if (message.issuer != null && Object.hasOwnProperty.call(message, "issuer"))
                    writer.uint32(/* id 15, wireType 2 =*/122).string(message.issuer);
                if (message.installCode != null && Object.hasOwnProperty.call(message, "installCode"))
                    writer.uint32(/* id 16, wireType 2 =*/130).string(message.installCode);
                if (message.installTimes != null && Object.hasOwnProperty.call(message, "installTimes"))
                    writer.uint32(/* id 17, wireType 2 =*/138).string(message.installTimes);
                if (message.settleCode != null && Object.hasOwnProperty.call(message, "settleCode"))
                    writer.uint32(/* id 18, wireType 2 =*/146).string(message.settleCode);
                if (message.qrFlag != null && Object.hasOwnProperty.call(message, "qrFlag"))
                    writer.uint32(/* id 19, wireType 2 =*/154).string(message.qrFlag);
                if (message.stan != null && Object.hasOwnProperty.call(message, "stan"))
                    writer.uint32(/* id 20, wireType 2 =*/162).string(message.stan);
                if (message.quotaFlag != null && Object.hasOwnProperty.call(message, "quotaFlag"))
                    writer.uint32(/* id 21, wireType 2 =*/170).string(message.quotaFlag);
                if (message.charge != null && Object.hasOwnProperty.call(message, "charge"))
                    writer.uint32(/* id 22, wireType 2 =*/178).string(message.charge);
                return writer;
            };

            /**
             * Encodes the specified AppropriationCreditExport message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationCreditExport.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationCreditExport} message AppropriationCreditExport message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationCreditExport.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationCreditExport message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditExport
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationCreditExport} AppropriationCreditExport
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationCreditExport.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationCreditExport();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.storeCode = reader.string();
                        break;
                    case 2:
                        message.registerName = reader.string();
                        break;
                    case 3:
                        message.terminalNo = reader.string();
                        break;
                    case 4:
                        message.date = reader.string();
                        break;
                    case 5:
                        message.submitDate = reader.string();
                        break;
                    case 6:
                        message.batchNo = reader.string();
                        break;
                    case 7:
                        message.transDate = reader.string();
                        break;
                    case 8:
                        message.transTime = reader.string();
                        break;
                    case 9:
                        message.code = reader.string();
                        break;
                    case 10:
                        message.authCode = reader.string();
                        break;
                    case 11:
                        message.amount = reader.string();
                        break;
                    case 12:
                        message.cardNo = reader.string();
                        break;
                    case 13:
                        message.cardType = reader.string();
                        break;
                    case 14:
                        message.orderNo = reader.string();
                        break;
                    case 15:
                        message.issuer = reader.string();
                        break;
                    case 16:
                        message.installCode = reader.string();
                        break;
                    case 17:
                        message.installTimes = reader.string();
                        break;
                    case 18:
                        message.settleCode = reader.string();
                        break;
                    case 19:
                        message.qrFlag = reader.string();
                        break;
                    case 20:
                        message.stan = reader.string();
                        break;
                    case 21:
                        message.quotaFlag = reader.string();
                        break;
                    case 22:
                        message.charge = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationCreditExport message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditExport
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationCreditExport} AppropriationCreditExport
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationCreditExport.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationCreditExport message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditExport
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationCreditExport.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    if (!$util.isString(message.storeCode))
                        return "storeCode: string expected";
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    if (!$util.isString(message.registerName))
                        return "registerName: string expected";
                if (message.terminalNo != null && message.hasOwnProperty("terminalNo"))
                    if (!$util.isString(message.terminalNo))
                        return "terminalNo: string expected";
                if (message.date != null && message.hasOwnProperty("date"))
                    if (!$util.isString(message.date))
                        return "date: string expected";
                if (message.submitDate != null && message.hasOwnProperty("submitDate"))
                    if (!$util.isString(message.submitDate))
                        return "submitDate: string expected";
                if (message.batchNo != null && message.hasOwnProperty("batchNo"))
                    if (!$util.isString(message.batchNo))
                        return "batchNo: string expected";
                if (message.transDate != null && message.hasOwnProperty("transDate"))
                    if (!$util.isString(message.transDate))
                        return "transDate: string expected";
                if (message.transTime != null && message.hasOwnProperty("transTime"))
                    if (!$util.isString(message.transTime))
                        return "transTime: string expected";
                if (message.code != null && message.hasOwnProperty("code"))
                    if (!$util.isString(message.code))
                        return "code: string expected";
                if (message.authCode != null && message.hasOwnProperty("authCode"))
                    if (!$util.isString(message.authCode))
                        return "authCode: string expected";
                if (message.amount != null && message.hasOwnProperty("amount"))
                    if (!$util.isString(message.amount))
                        return "amount: string expected";
                if (message.cardNo != null && message.hasOwnProperty("cardNo"))
                    if (!$util.isString(message.cardNo))
                        return "cardNo: string expected";
                if (message.cardType != null && message.hasOwnProperty("cardType"))
                    if (!$util.isString(message.cardType))
                        return "cardType: string expected";
                if (message.orderNo != null && message.hasOwnProperty("orderNo"))
                    if (!$util.isString(message.orderNo))
                        return "orderNo: string expected";
                if (message.issuer != null && message.hasOwnProperty("issuer"))
                    if (!$util.isString(message.issuer))
                        return "issuer: string expected";
                if (message.installCode != null && message.hasOwnProperty("installCode"))
                    if (!$util.isString(message.installCode))
                        return "installCode: string expected";
                if (message.installTimes != null && message.hasOwnProperty("installTimes"))
                    if (!$util.isString(message.installTimes))
                        return "installTimes: string expected";
                if (message.settleCode != null && message.hasOwnProperty("settleCode"))
                    if (!$util.isString(message.settleCode))
                        return "settleCode: string expected";
                if (message.qrFlag != null && message.hasOwnProperty("qrFlag"))
                    if (!$util.isString(message.qrFlag))
                        return "qrFlag: string expected";
                if (message.stan != null && message.hasOwnProperty("stan"))
                    if (!$util.isString(message.stan))
                        return "stan: string expected";
                if (message.quotaFlag != null && message.hasOwnProperty("quotaFlag"))
                    if (!$util.isString(message.quotaFlag))
                        return "quotaFlag: string expected";
                if (message.charge != null && message.hasOwnProperty("charge"))
                    if (!$util.isString(message.charge))
                        return "charge: string expected";
                return null;
            };

            /**
             * Creates an AppropriationCreditExport message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditExport
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationCreditExport} AppropriationCreditExport
             */
            AppropriationCreditExport.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationCreditExport)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationCreditExport();
                if (object.storeCode != null)
                    message.storeCode = String(object.storeCode);
                if (object.registerName != null)
                    message.registerName = String(object.registerName);
                if (object.terminalNo != null)
                    message.terminalNo = String(object.terminalNo);
                if (object.date != null)
                    message.date = String(object.date);
                if (object.submitDate != null)
                    message.submitDate = String(object.submitDate);
                if (object.batchNo != null)
                    message.batchNo = String(object.batchNo);
                if (object.transDate != null)
                    message.transDate = String(object.transDate);
                if (object.transTime != null)
                    message.transTime = String(object.transTime);
                if (object.code != null)
                    message.code = String(object.code);
                if (object.authCode != null)
                    message.authCode = String(object.authCode);
                if (object.amount != null)
                    message.amount = String(object.amount);
                if (object.cardNo != null)
                    message.cardNo = String(object.cardNo);
                if (object.cardType != null)
                    message.cardType = String(object.cardType);
                if (object.orderNo != null)
                    message.orderNo = String(object.orderNo);
                if (object.issuer != null)
                    message.issuer = String(object.issuer);
                if (object.installCode != null)
                    message.installCode = String(object.installCode);
                if (object.installTimes != null)
                    message.installTimes = String(object.installTimes);
                if (object.settleCode != null)
                    message.settleCode = String(object.settleCode);
                if (object.qrFlag != null)
                    message.qrFlag = String(object.qrFlag);
                if (object.stan != null)
                    message.stan = String(object.stan);
                if (object.quotaFlag != null)
                    message.quotaFlag = String(object.quotaFlag);
                if (object.charge != null)
                    message.charge = String(object.charge);
                return message;
            };

            /**
             * Creates a plain object from an AppropriationCreditExport message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditExport
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationCreditExport} message AppropriationCreditExport
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationCreditExport.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.storeCode = "";
                    object.registerName = "";
                    object.terminalNo = "";
                    object.date = "";
                    object.submitDate = "";
                    object.batchNo = "";
                    object.transDate = "";
                    object.transTime = "";
                    object.code = "";
                    object.authCode = "";
                    object.amount = "";
                    object.cardNo = "";
                    object.cardType = "";
                    object.orderNo = "";
                    object.issuer = "";
                    object.installCode = "";
                    object.installTimes = "";
                    object.settleCode = "";
                    object.qrFlag = "";
                    object.stan = "";
                    object.quotaFlag = "";
                    object.charge = "";
                }
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    object.storeCode = message.storeCode;
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    object.registerName = message.registerName;
                if (message.terminalNo != null && message.hasOwnProperty("terminalNo"))
                    object.terminalNo = message.terminalNo;
                if (message.date != null && message.hasOwnProperty("date"))
                    object.date = message.date;
                if (message.submitDate != null && message.hasOwnProperty("submitDate"))
                    object.submitDate = message.submitDate;
                if (message.batchNo != null && message.hasOwnProperty("batchNo"))
                    object.batchNo = message.batchNo;
                if (message.transDate != null && message.hasOwnProperty("transDate"))
                    object.transDate = message.transDate;
                if (message.transTime != null && message.hasOwnProperty("transTime"))
                    object.transTime = message.transTime;
                if (message.code != null && message.hasOwnProperty("code"))
                    object.code = message.code;
                if (message.authCode != null && message.hasOwnProperty("authCode"))
                    object.authCode = message.authCode;
                if (message.amount != null && message.hasOwnProperty("amount"))
                    object.amount = message.amount;
                if (message.cardNo != null && message.hasOwnProperty("cardNo"))
                    object.cardNo = message.cardNo;
                if (message.cardType != null && message.hasOwnProperty("cardType"))
                    object.cardType = message.cardType;
                if (message.orderNo != null && message.hasOwnProperty("orderNo"))
                    object.orderNo = message.orderNo;
                if (message.issuer != null && message.hasOwnProperty("issuer"))
                    object.issuer = message.issuer;
                if (message.installCode != null && message.hasOwnProperty("installCode"))
                    object.installCode = message.installCode;
                if (message.installTimes != null && message.hasOwnProperty("installTimes"))
                    object.installTimes = message.installTimes;
                if (message.settleCode != null && message.hasOwnProperty("settleCode"))
                    object.settleCode = message.settleCode;
                if (message.qrFlag != null && message.hasOwnProperty("qrFlag"))
                    object.qrFlag = message.qrFlag;
                if (message.stan != null && message.hasOwnProperty("stan"))
                    object.stan = message.stan;
                if (message.quotaFlag != null && message.hasOwnProperty("quotaFlag"))
                    object.quotaFlag = message.quotaFlag;
                if (message.charge != null && message.hasOwnProperty("charge"))
                    object.charge = message.charge;
                return object;
            };

            /**
             * Converts this AppropriationCreditExport to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationCreditExport
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationCreditExport.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationCreditExport;
        })();

        Protobuf.AppropriationAlipayExport = (function() {

            /**
             * Properties of an AppropriationAlipayExport.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationAlipayExport
             * @property {string|null} [storeCode] AppropriationAlipayExport storeCode
             * @property {string|null} [registerName] AppropriationAlipayExport registerName
             * @property {string|null} [date] AppropriationAlipayExport date
             * @property {string|null} [submitDate] AppropriationAlipayExport submitDate
             * @property {string|null} [transDate] AppropriationAlipayExport transDate
             * @property {string|null} [transTime] AppropriationAlipayExport transTime
             * @property {string|null} [code] AppropriationAlipayExport code
             * @property {string|null} [abroadAmount] AppropriationAlipayExport abroadAmount
             * @property {string|null} [amount] AppropriationAlipayExport amount
             * @property {string|null} [storeCharge] AppropriationAlipayExport storeCharge
             * @property {string|null} [consumerCharge] AppropriationAlipayExport consumerCharge
             * @property {string|null} [orderNo] AppropriationAlipayExport orderNo
             */

            /**
             * Constructs a new AppropriationAlipayExport.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationAlipayExport.
             * @implements IAppropriationAlipayExport
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationAlipayExport=} [properties] Properties to set
             */
            function AppropriationAlipayExport(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationAlipayExport storeCode.
             * @member {string} storeCode
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayExport
             * @instance
             */
            AppropriationAlipayExport.prototype.storeCode = "";

            /**
             * AppropriationAlipayExport registerName.
             * @member {string} registerName
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayExport
             * @instance
             */
            AppropriationAlipayExport.prototype.registerName = "";

            /**
             * AppropriationAlipayExport date.
             * @member {string} date
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayExport
             * @instance
             */
            AppropriationAlipayExport.prototype.date = "";

            /**
             * AppropriationAlipayExport submitDate.
             * @member {string} submitDate
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayExport
             * @instance
             */
            AppropriationAlipayExport.prototype.submitDate = "";

            /**
             * AppropriationAlipayExport transDate.
             * @member {string} transDate
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayExport
             * @instance
             */
            AppropriationAlipayExport.prototype.transDate = "";

            /**
             * AppropriationAlipayExport transTime.
             * @member {string} transTime
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayExport
             * @instance
             */
            AppropriationAlipayExport.prototype.transTime = "";

            /**
             * AppropriationAlipayExport code.
             * @member {string} code
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayExport
             * @instance
             */
            AppropriationAlipayExport.prototype.code = "";

            /**
             * AppropriationAlipayExport abroadAmount.
             * @member {string} abroadAmount
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayExport
             * @instance
             */
            AppropriationAlipayExport.prototype.abroadAmount = "";

            /**
             * AppropriationAlipayExport amount.
             * @member {string} amount
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayExport
             * @instance
             */
            AppropriationAlipayExport.prototype.amount = "";

            /**
             * AppropriationAlipayExport storeCharge.
             * @member {string} storeCharge
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayExport
             * @instance
             */
            AppropriationAlipayExport.prototype.storeCharge = "";

            /**
             * AppropriationAlipayExport consumerCharge.
             * @member {string} consumerCharge
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayExport
             * @instance
             */
            AppropriationAlipayExport.prototype.consumerCharge = "";

            /**
             * AppropriationAlipayExport orderNo.
             * @member {string} orderNo
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayExport
             * @instance
             */
            AppropriationAlipayExport.prototype.orderNo = "";

            /**
             * Creates a new AppropriationAlipayExport instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationAlipayExport=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationAlipayExport} AppropriationAlipayExport instance
             */
            AppropriationAlipayExport.create = function create(properties) {
                return new AppropriationAlipayExport(properties);
            };

            /**
             * Encodes the specified AppropriationAlipayExport message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationAlipayExport.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationAlipayExport} message AppropriationAlipayExport message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationAlipayExport.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.storeCode != null && Object.hasOwnProperty.call(message, "storeCode"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.storeCode);
                if (message.registerName != null && Object.hasOwnProperty.call(message, "registerName"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.registerName);
                if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.date);
                if (message.submitDate != null && Object.hasOwnProperty.call(message, "submitDate"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.submitDate);
                if (message.transDate != null && Object.hasOwnProperty.call(message, "transDate"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.transDate);
                if (message.transTime != null && Object.hasOwnProperty.call(message, "transTime"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.transTime);
                if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.code);
                if (message.abroadAmount != null && Object.hasOwnProperty.call(message, "abroadAmount"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.abroadAmount);
                if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.amount);
                if (message.storeCharge != null && Object.hasOwnProperty.call(message, "storeCharge"))
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.storeCharge);
                if (message.consumerCharge != null && Object.hasOwnProperty.call(message, "consumerCharge"))
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.consumerCharge);
                if (message.orderNo != null && Object.hasOwnProperty.call(message, "orderNo"))
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.orderNo);
                return writer;
            };

            /**
             * Encodes the specified AppropriationAlipayExport message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationAlipayExport.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationAlipayExport} message AppropriationAlipayExport message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationAlipayExport.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationAlipayExport message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayExport
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationAlipayExport} AppropriationAlipayExport
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationAlipayExport.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationAlipayExport();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.storeCode = reader.string();
                        break;
                    case 2:
                        message.registerName = reader.string();
                        break;
                    case 3:
                        message.date = reader.string();
                        break;
                    case 4:
                        message.submitDate = reader.string();
                        break;
                    case 5:
                        message.transDate = reader.string();
                        break;
                    case 6:
                        message.transTime = reader.string();
                        break;
                    case 7:
                        message.code = reader.string();
                        break;
                    case 9:
                        message.abroadAmount = reader.string();
                        break;
                    case 10:
                        message.amount = reader.string();
                        break;
                    case 11:
                        message.storeCharge = reader.string();
                        break;
                    case 12:
                        message.consumerCharge = reader.string();
                        break;
                    case 13:
                        message.orderNo = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationAlipayExport message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayExport
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationAlipayExport} AppropriationAlipayExport
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationAlipayExport.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationAlipayExport message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayExport
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationAlipayExport.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    if (!$util.isString(message.storeCode))
                        return "storeCode: string expected";
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    if (!$util.isString(message.registerName))
                        return "registerName: string expected";
                if (message.date != null && message.hasOwnProperty("date"))
                    if (!$util.isString(message.date))
                        return "date: string expected";
                if (message.submitDate != null && message.hasOwnProperty("submitDate"))
                    if (!$util.isString(message.submitDate))
                        return "submitDate: string expected";
                if (message.transDate != null && message.hasOwnProperty("transDate"))
                    if (!$util.isString(message.transDate))
                        return "transDate: string expected";
                if (message.transTime != null && message.hasOwnProperty("transTime"))
                    if (!$util.isString(message.transTime))
                        return "transTime: string expected";
                if (message.code != null && message.hasOwnProperty("code"))
                    if (!$util.isString(message.code))
                        return "code: string expected";
                if (message.abroadAmount != null && message.hasOwnProperty("abroadAmount"))
                    if (!$util.isString(message.abroadAmount))
                        return "abroadAmount: string expected";
                if (message.amount != null && message.hasOwnProperty("amount"))
                    if (!$util.isString(message.amount))
                        return "amount: string expected";
                if (message.storeCharge != null && message.hasOwnProperty("storeCharge"))
                    if (!$util.isString(message.storeCharge))
                        return "storeCharge: string expected";
                if (message.consumerCharge != null && message.hasOwnProperty("consumerCharge"))
                    if (!$util.isString(message.consumerCharge))
                        return "consumerCharge: string expected";
                if (message.orderNo != null && message.hasOwnProperty("orderNo"))
                    if (!$util.isString(message.orderNo))
                        return "orderNo: string expected";
                return null;
            };

            /**
             * Creates an AppropriationAlipayExport message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayExport
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationAlipayExport} AppropriationAlipayExport
             */
            AppropriationAlipayExport.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationAlipayExport)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationAlipayExport();
                if (object.storeCode != null)
                    message.storeCode = String(object.storeCode);
                if (object.registerName != null)
                    message.registerName = String(object.registerName);
                if (object.date != null)
                    message.date = String(object.date);
                if (object.submitDate != null)
                    message.submitDate = String(object.submitDate);
                if (object.transDate != null)
                    message.transDate = String(object.transDate);
                if (object.transTime != null)
                    message.transTime = String(object.transTime);
                if (object.code != null)
                    message.code = String(object.code);
                if (object.abroadAmount != null)
                    message.abroadAmount = String(object.abroadAmount);
                if (object.amount != null)
                    message.amount = String(object.amount);
                if (object.storeCharge != null)
                    message.storeCharge = String(object.storeCharge);
                if (object.consumerCharge != null)
                    message.consumerCharge = String(object.consumerCharge);
                if (object.orderNo != null)
                    message.orderNo = String(object.orderNo);
                return message;
            };

            /**
             * Creates a plain object from an AppropriationAlipayExport message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayExport
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationAlipayExport} message AppropriationAlipayExport
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationAlipayExport.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.storeCode = "";
                    object.registerName = "";
                    object.date = "";
                    object.submitDate = "";
                    object.transDate = "";
                    object.transTime = "";
                    object.code = "";
                    object.abroadAmount = "";
                    object.amount = "";
                    object.storeCharge = "";
                    object.consumerCharge = "";
                    object.orderNo = "";
                }
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    object.storeCode = message.storeCode;
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    object.registerName = message.registerName;
                if (message.date != null && message.hasOwnProperty("date"))
                    object.date = message.date;
                if (message.submitDate != null && message.hasOwnProperty("submitDate"))
                    object.submitDate = message.submitDate;
                if (message.transDate != null && message.hasOwnProperty("transDate"))
                    object.transDate = message.transDate;
                if (message.transTime != null && message.hasOwnProperty("transTime"))
                    object.transTime = message.transTime;
                if (message.code != null && message.hasOwnProperty("code"))
                    object.code = message.code;
                if (message.abroadAmount != null && message.hasOwnProperty("abroadAmount"))
                    object.abroadAmount = message.abroadAmount;
                if (message.amount != null && message.hasOwnProperty("amount"))
                    object.amount = message.amount;
                if (message.storeCharge != null && message.hasOwnProperty("storeCharge"))
                    object.storeCharge = message.storeCharge;
                if (message.consumerCharge != null && message.hasOwnProperty("consumerCharge"))
                    object.consumerCharge = message.consumerCharge;
                if (message.orderNo != null && message.hasOwnProperty("orderNo"))
                    object.orderNo = message.orderNo;
                return object;
            };

            /**
             * Converts this AppropriationAlipayExport to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationAlipayExport
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationAlipayExport.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationAlipayExport;
        })();

        Protobuf.AppropriationMotifyExport = (function() {

            /**
             * Properties of an AppropriationMotifyExport.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationMotifyExport
             * @property {string|null} [storeCode] AppropriationMotifyExport storeCode
             * @property {string|null} [registerName] AppropriationMotifyExport registerName
             * @property {string|null} [date] AppropriationMotifyExport date
             * @property {string|null} [reimbursementDate] AppropriationMotifyExport reimbursementDate
             * @property {string|null} [batchNo] AppropriationMotifyExport batchNo
             * @property {string|null} [motifyAmount] AppropriationMotifyExport motifyAmount
             * @property {string|null} [motifyCharge] AppropriationMotifyExport motifyCharge
             * @property {string|null} [description] AppropriationMotifyExport description
             */

            /**
             * Constructs a new AppropriationMotifyExport.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationMotifyExport.
             * @implements IAppropriationMotifyExport
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationMotifyExport=} [properties] Properties to set
             */
            function AppropriationMotifyExport(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationMotifyExport storeCode.
             * @member {string} storeCode
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyExport
             * @instance
             */
            AppropriationMotifyExport.prototype.storeCode = "";

            /**
             * AppropriationMotifyExport registerName.
             * @member {string} registerName
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyExport
             * @instance
             */
            AppropriationMotifyExport.prototype.registerName = "";

            /**
             * AppropriationMotifyExport date.
             * @member {string} date
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyExport
             * @instance
             */
            AppropriationMotifyExport.prototype.date = "";

            /**
             * AppropriationMotifyExport reimbursementDate.
             * @member {string} reimbursementDate
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyExport
             * @instance
             */
            AppropriationMotifyExport.prototype.reimbursementDate = "";

            /**
             * AppropriationMotifyExport batchNo.
             * @member {string} batchNo
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyExport
             * @instance
             */
            AppropriationMotifyExport.prototype.batchNo = "";

            /**
             * AppropriationMotifyExport motifyAmount.
             * @member {string} motifyAmount
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyExport
             * @instance
             */
            AppropriationMotifyExport.prototype.motifyAmount = "";

            /**
             * AppropriationMotifyExport motifyCharge.
             * @member {string} motifyCharge
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyExport
             * @instance
             */
            AppropriationMotifyExport.prototype.motifyCharge = "";

            /**
             * AppropriationMotifyExport description.
             * @member {string} description
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyExport
             * @instance
             */
            AppropriationMotifyExport.prototype.description = "";

            /**
             * Creates a new AppropriationMotifyExport instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationMotifyExport=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationMotifyExport} AppropriationMotifyExport instance
             */
            AppropriationMotifyExport.create = function create(properties) {
                return new AppropriationMotifyExport(properties);
            };

            /**
             * Encodes the specified AppropriationMotifyExport message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationMotifyExport.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationMotifyExport} message AppropriationMotifyExport message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationMotifyExport.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.storeCode != null && Object.hasOwnProperty.call(message, "storeCode"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.storeCode);
                if (message.registerName != null && Object.hasOwnProperty.call(message, "registerName"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.registerName);
                if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.date);
                if (message.reimbursementDate != null && Object.hasOwnProperty.call(message, "reimbursementDate"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.reimbursementDate);
                if (message.batchNo != null && Object.hasOwnProperty.call(message, "batchNo"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.batchNo);
                if (message.motifyAmount != null && Object.hasOwnProperty.call(message, "motifyAmount"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.motifyAmount);
                if (message.motifyCharge != null && Object.hasOwnProperty.call(message, "motifyCharge"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.motifyCharge);
                if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.description);
                return writer;
            };

            /**
             * Encodes the specified AppropriationMotifyExport message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationMotifyExport.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationMotifyExport} message AppropriationMotifyExport message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationMotifyExport.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationMotifyExport message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyExport
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationMotifyExport} AppropriationMotifyExport
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationMotifyExport.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationMotifyExport();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.storeCode = reader.string();
                        break;
                    case 2:
                        message.registerName = reader.string();
                        break;
                    case 3:
                        message.date = reader.string();
                        break;
                    case 4:
                        message.reimbursementDate = reader.string();
                        break;
                    case 5:
                        message.batchNo = reader.string();
                        break;
                    case 6:
                        message.motifyAmount = reader.string();
                        break;
                    case 7:
                        message.motifyCharge = reader.string();
                        break;
                    case 8:
                        message.description = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationMotifyExport message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyExport
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationMotifyExport} AppropriationMotifyExport
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationMotifyExport.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationMotifyExport message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyExport
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationMotifyExport.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    if (!$util.isString(message.storeCode))
                        return "storeCode: string expected";
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    if (!$util.isString(message.registerName))
                        return "registerName: string expected";
                if (message.date != null && message.hasOwnProperty("date"))
                    if (!$util.isString(message.date))
                        return "date: string expected";
                if (message.reimbursementDate != null && message.hasOwnProperty("reimbursementDate"))
                    if (!$util.isString(message.reimbursementDate))
                        return "reimbursementDate: string expected";
                if (message.batchNo != null && message.hasOwnProperty("batchNo"))
                    if (!$util.isString(message.batchNo))
                        return "batchNo: string expected";
                if (message.motifyAmount != null && message.hasOwnProperty("motifyAmount"))
                    if (!$util.isString(message.motifyAmount))
                        return "motifyAmount: string expected";
                if (message.motifyCharge != null && message.hasOwnProperty("motifyCharge"))
                    if (!$util.isString(message.motifyCharge))
                        return "motifyCharge: string expected";
                if (message.description != null && message.hasOwnProperty("description"))
                    if (!$util.isString(message.description))
                        return "description: string expected";
                return null;
            };

            /**
             * Creates an AppropriationMotifyExport message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyExport
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationMotifyExport} AppropriationMotifyExport
             */
            AppropriationMotifyExport.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationMotifyExport)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationMotifyExport();
                if (object.storeCode != null)
                    message.storeCode = String(object.storeCode);
                if (object.registerName != null)
                    message.registerName = String(object.registerName);
                if (object.date != null)
                    message.date = String(object.date);
                if (object.reimbursementDate != null)
                    message.reimbursementDate = String(object.reimbursementDate);
                if (object.batchNo != null)
                    message.batchNo = String(object.batchNo);
                if (object.motifyAmount != null)
                    message.motifyAmount = String(object.motifyAmount);
                if (object.motifyCharge != null)
                    message.motifyCharge = String(object.motifyCharge);
                if (object.description != null)
                    message.description = String(object.description);
                return message;
            };

            /**
             * Creates a plain object from an AppropriationMotifyExport message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyExport
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationMotifyExport} message AppropriationMotifyExport
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationMotifyExport.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.storeCode = "";
                    object.registerName = "";
                    object.date = "";
                    object.reimbursementDate = "";
                    object.batchNo = "";
                    object.motifyAmount = "";
                    object.motifyCharge = "";
                    object.description = "";
                }
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    object.storeCode = message.storeCode;
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    object.registerName = message.registerName;
                if (message.date != null && message.hasOwnProperty("date"))
                    object.date = message.date;
                if (message.reimbursementDate != null && message.hasOwnProperty("reimbursementDate"))
                    object.reimbursementDate = message.reimbursementDate;
                if (message.batchNo != null && message.hasOwnProperty("batchNo"))
                    object.batchNo = message.batchNo;
                if (message.motifyAmount != null && message.hasOwnProperty("motifyAmount"))
                    object.motifyAmount = message.motifyAmount;
                if (message.motifyCharge != null && message.hasOwnProperty("motifyCharge"))
                    object.motifyCharge = message.motifyCharge;
                if (message.description != null && message.hasOwnProperty("description"))
                    object.description = message.description;
                return object;
            };

            /**
             * Converts this AppropriationMotifyExport to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationMotifyExport
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationMotifyExport.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationMotifyExport;
        })();

        Protobuf.AppropriationSummaryExport = (function() {

            /**
             * Properties of an AppropriationSummaryExport.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationSummaryExport
             * @property {string|null} [storeCode] AppropriationSummaryExport storeCode
             * @property {string|null} [registerName] AppropriationSummaryExport registerName
             * @property {string|null} [terminalNo] AppropriationSummaryExport terminalNo
             * @property {string|null} [date] AppropriationSummaryExport date
             * @property {string|null} [typeFlag] AppropriationSummaryExport typeFlag
             * @property {string|null} [submitDate] AppropriationSummaryExport submitDate
             * @property {string|null} [totalCount] AppropriationSummaryExport totalCount
             * @property {string|null} [totalAmount] AppropriationSummaryExport totalAmount
             * @property {string|null} [salesCount] AppropriationSummaryExport salesCount
             * @property {string|null} [salesAmount] AppropriationSummaryExport salesAmount
             * @property {string|null} [returnCount] AppropriationSummaryExport returnCount
             * @property {string|null} [returnAmount] AppropriationSummaryExport returnAmount
             * @property {string|null} [charge] AppropriationSummaryExport charge
             * @property {string|null} [ifr] AppropriationSummaryExport ifr
             * @property {string|null} [motifyAmount] AppropriationSummaryExport motifyAmount
             * @property {string|null} [motifyCharge] AppropriationSummaryExport motifyCharge
             * @property {string|null} [installRate] AppropriationSummaryExport installRate
             * @property {string|null} [chargeRate] AppropriationSummaryExport chargeRate
             * @property {string|null} [netAmount] AppropriationSummaryExport netAmount
             */

            /**
             * Constructs a new AppropriationSummaryExport.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationSummaryExport.
             * @implements IAppropriationSummaryExport
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryExport=} [properties] Properties to set
             */
            function AppropriationSummaryExport(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationSummaryExport storeCode.
             * @member {string} storeCode
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryExport
             * @instance
             */
            AppropriationSummaryExport.prototype.storeCode = "";

            /**
             * AppropriationSummaryExport registerName.
             * @member {string} registerName
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryExport
             * @instance
             */
            AppropriationSummaryExport.prototype.registerName = "";

            /**
             * AppropriationSummaryExport terminalNo.
             * @member {string} terminalNo
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryExport
             * @instance
             */
            AppropriationSummaryExport.prototype.terminalNo = "";

            /**
             * AppropriationSummaryExport date.
             * @member {string} date
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryExport
             * @instance
             */
            AppropriationSummaryExport.prototype.date = "";

            /**
             * AppropriationSummaryExport typeFlag.
             * @member {string} typeFlag
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryExport
             * @instance
             */
            AppropriationSummaryExport.prototype.typeFlag = "";

            /**
             * AppropriationSummaryExport submitDate.
             * @member {string} submitDate
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryExport
             * @instance
             */
            AppropriationSummaryExport.prototype.submitDate = "";

            /**
             * AppropriationSummaryExport totalCount.
             * @member {string} totalCount
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryExport
             * @instance
             */
            AppropriationSummaryExport.prototype.totalCount = "";

            /**
             * AppropriationSummaryExport totalAmount.
             * @member {string} totalAmount
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryExport
             * @instance
             */
            AppropriationSummaryExport.prototype.totalAmount = "";

            /**
             * AppropriationSummaryExport salesCount.
             * @member {string} salesCount
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryExport
             * @instance
             */
            AppropriationSummaryExport.prototype.salesCount = "";

            /**
             * AppropriationSummaryExport salesAmount.
             * @member {string} salesAmount
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryExport
             * @instance
             */
            AppropriationSummaryExport.prototype.salesAmount = "";

            /**
             * AppropriationSummaryExport returnCount.
             * @member {string} returnCount
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryExport
             * @instance
             */
            AppropriationSummaryExport.prototype.returnCount = "";

            /**
             * AppropriationSummaryExport returnAmount.
             * @member {string} returnAmount
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryExport
             * @instance
             */
            AppropriationSummaryExport.prototype.returnAmount = "";

            /**
             * AppropriationSummaryExport charge.
             * @member {string} charge
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryExport
             * @instance
             */
            AppropriationSummaryExport.prototype.charge = "";

            /**
             * AppropriationSummaryExport ifr.
             * @member {string} ifr
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryExport
             * @instance
             */
            AppropriationSummaryExport.prototype.ifr = "";

            /**
             * AppropriationSummaryExport motifyAmount.
             * @member {string} motifyAmount
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryExport
             * @instance
             */
            AppropriationSummaryExport.prototype.motifyAmount = "";

            /**
             * AppropriationSummaryExport motifyCharge.
             * @member {string} motifyCharge
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryExport
             * @instance
             */
            AppropriationSummaryExport.prototype.motifyCharge = "";

            /**
             * AppropriationSummaryExport installRate.
             * @member {string} installRate
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryExport
             * @instance
             */
            AppropriationSummaryExport.prototype.installRate = "";

            /**
             * AppropriationSummaryExport chargeRate.
             * @member {string} chargeRate
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryExport
             * @instance
             */
            AppropriationSummaryExport.prototype.chargeRate = "";

            /**
             * AppropriationSummaryExport netAmount.
             * @member {string} netAmount
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryExport
             * @instance
             */
            AppropriationSummaryExport.prototype.netAmount = "";

            /**
             * Creates a new AppropriationSummaryExport instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryExport=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryExport} AppropriationSummaryExport instance
             */
            AppropriationSummaryExport.create = function create(properties) {
                return new AppropriationSummaryExport(properties);
            };

            /**
             * Encodes the specified AppropriationSummaryExport message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationSummaryExport.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryExport} message AppropriationSummaryExport message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationSummaryExport.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.storeCode != null && Object.hasOwnProperty.call(message, "storeCode"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.storeCode);
                if (message.registerName != null && Object.hasOwnProperty.call(message, "registerName"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.registerName);
                if (message.terminalNo != null && Object.hasOwnProperty.call(message, "terminalNo"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.terminalNo);
                if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.date);
                if (message.typeFlag != null && Object.hasOwnProperty.call(message, "typeFlag"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.typeFlag);
                if (message.submitDate != null && Object.hasOwnProperty.call(message, "submitDate"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.submitDate);
                if (message.totalCount != null && Object.hasOwnProperty.call(message, "totalCount"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.totalCount);
                if (message.totalAmount != null && Object.hasOwnProperty.call(message, "totalAmount"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.totalAmount);
                if (message.salesCount != null && Object.hasOwnProperty.call(message, "salesCount"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.salesCount);
                if (message.salesAmount != null && Object.hasOwnProperty.call(message, "salesAmount"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.salesAmount);
                if (message.returnCount != null && Object.hasOwnProperty.call(message, "returnCount"))
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.returnCount);
                if (message.returnAmount != null && Object.hasOwnProperty.call(message, "returnAmount"))
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.returnAmount);
                if (message.charge != null && Object.hasOwnProperty.call(message, "charge"))
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.charge);
                if (message.ifr != null && Object.hasOwnProperty.call(message, "ifr"))
                    writer.uint32(/* id 14, wireType 2 =*/114).string(message.ifr);
                if (message.motifyAmount != null && Object.hasOwnProperty.call(message, "motifyAmount"))
                    writer.uint32(/* id 15, wireType 2 =*/122).string(message.motifyAmount);
                if (message.motifyCharge != null && Object.hasOwnProperty.call(message, "motifyCharge"))
                    writer.uint32(/* id 16, wireType 2 =*/130).string(message.motifyCharge);
                if (message.installRate != null && Object.hasOwnProperty.call(message, "installRate"))
                    writer.uint32(/* id 17, wireType 2 =*/138).string(message.installRate);
                if (message.chargeRate != null && Object.hasOwnProperty.call(message, "chargeRate"))
                    writer.uint32(/* id 18, wireType 2 =*/146).string(message.chargeRate);
                if (message.netAmount != null && Object.hasOwnProperty.call(message, "netAmount"))
                    writer.uint32(/* id 19, wireType 2 =*/154).string(message.netAmount);
                return writer;
            };

            /**
             * Encodes the specified AppropriationSummaryExport message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationSummaryExport.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryExport} message AppropriationSummaryExport message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationSummaryExport.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationSummaryExport message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryExport
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryExport} AppropriationSummaryExport
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationSummaryExport.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationSummaryExport();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.storeCode = reader.string();
                        break;
                    case 2:
                        message.registerName = reader.string();
                        break;
                    case 3:
                        message.terminalNo = reader.string();
                        break;
                    case 4:
                        message.date = reader.string();
                        break;
                    case 5:
                        message.typeFlag = reader.string();
                        break;
                    case 6:
                        message.submitDate = reader.string();
                        break;
                    case 7:
                        message.totalCount = reader.string();
                        break;
                    case 8:
                        message.totalAmount = reader.string();
                        break;
                    case 9:
                        message.salesCount = reader.string();
                        break;
                    case 10:
                        message.salesAmount = reader.string();
                        break;
                    case 11:
                        message.returnCount = reader.string();
                        break;
                    case 12:
                        message.returnAmount = reader.string();
                        break;
                    case 13:
                        message.charge = reader.string();
                        break;
                    case 14:
                        message.ifr = reader.string();
                        break;
                    case 15:
                        message.motifyAmount = reader.string();
                        break;
                    case 16:
                        message.motifyCharge = reader.string();
                        break;
                    case 17:
                        message.installRate = reader.string();
                        break;
                    case 18:
                        message.chargeRate = reader.string();
                        break;
                    case 19:
                        message.netAmount = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationSummaryExport message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryExport
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryExport} AppropriationSummaryExport
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationSummaryExport.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationSummaryExport message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryExport
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationSummaryExport.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    if (!$util.isString(message.storeCode))
                        return "storeCode: string expected";
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    if (!$util.isString(message.registerName))
                        return "registerName: string expected";
                if (message.terminalNo != null && message.hasOwnProperty("terminalNo"))
                    if (!$util.isString(message.terminalNo))
                        return "terminalNo: string expected";
                if (message.date != null && message.hasOwnProperty("date"))
                    if (!$util.isString(message.date))
                        return "date: string expected";
                if (message.typeFlag != null && message.hasOwnProperty("typeFlag"))
                    if (!$util.isString(message.typeFlag))
                        return "typeFlag: string expected";
                if (message.submitDate != null && message.hasOwnProperty("submitDate"))
                    if (!$util.isString(message.submitDate))
                        return "submitDate: string expected";
                if (message.totalCount != null && message.hasOwnProperty("totalCount"))
                    if (!$util.isString(message.totalCount))
                        return "totalCount: string expected";
                if (message.totalAmount != null && message.hasOwnProperty("totalAmount"))
                    if (!$util.isString(message.totalAmount))
                        return "totalAmount: string expected";
                if (message.salesCount != null && message.hasOwnProperty("salesCount"))
                    if (!$util.isString(message.salesCount))
                        return "salesCount: string expected";
                if (message.salesAmount != null && message.hasOwnProperty("salesAmount"))
                    if (!$util.isString(message.salesAmount))
                        return "salesAmount: string expected";
                if (message.returnCount != null && message.hasOwnProperty("returnCount"))
                    if (!$util.isString(message.returnCount))
                        return "returnCount: string expected";
                if (message.returnAmount != null && message.hasOwnProperty("returnAmount"))
                    if (!$util.isString(message.returnAmount))
                        return "returnAmount: string expected";
                if (message.charge != null && message.hasOwnProperty("charge"))
                    if (!$util.isString(message.charge))
                        return "charge: string expected";
                if (message.ifr != null && message.hasOwnProperty("ifr"))
                    if (!$util.isString(message.ifr))
                        return "ifr: string expected";
                if (message.motifyAmount != null && message.hasOwnProperty("motifyAmount"))
                    if (!$util.isString(message.motifyAmount))
                        return "motifyAmount: string expected";
                if (message.motifyCharge != null && message.hasOwnProperty("motifyCharge"))
                    if (!$util.isString(message.motifyCharge))
                        return "motifyCharge: string expected";
                if (message.installRate != null && message.hasOwnProperty("installRate"))
                    if (!$util.isString(message.installRate))
                        return "installRate: string expected";
                if (message.chargeRate != null && message.hasOwnProperty("chargeRate"))
                    if (!$util.isString(message.chargeRate))
                        return "chargeRate: string expected";
                if (message.netAmount != null && message.hasOwnProperty("netAmount"))
                    if (!$util.isString(message.netAmount))
                        return "netAmount: string expected";
                return null;
            };

            /**
             * Creates an AppropriationSummaryExport message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryExport
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryExport} AppropriationSummaryExport
             */
            AppropriationSummaryExport.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationSummaryExport)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationSummaryExport();
                if (object.storeCode != null)
                    message.storeCode = String(object.storeCode);
                if (object.registerName != null)
                    message.registerName = String(object.registerName);
                if (object.terminalNo != null)
                    message.terminalNo = String(object.terminalNo);
                if (object.date != null)
                    message.date = String(object.date);
                if (object.typeFlag != null)
                    message.typeFlag = String(object.typeFlag);
                if (object.submitDate != null)
                    message.submitDate = String(object.submitDate);
                if (object.totalCount != null)
                    message.totalCount = String(object.totalCount);
                if (object.totalAmount != null)
                    message.totalAmount = String(object.totalAmount);
                if (object.salesCount != null)
                    message.salesCount = String(object.salesCount);
                if (object.salesAmount != null)
                    message.salesAmount = String(object.salesAmount);
                if (object.returnCount != null)
                    message.returnCount = String(object.returnCount);
                if (object.returnAmount != null)
                    message.returnAmount = String(object.returnAmount);
                if (object.charge != null)
                    message.charge = String(object.charge);
                if (object.ifr != null)
                    message.ifr = String(object.ifr);
                if (object.motifyAmount != null)
                    message.motifyAmount = String(object.motifyAmount);
                if (object.motifyCharge != null)
                    message.motifyCharge = String(object.motifyCharge);
                if (object.installRate != null)
                    message.installRate = String(object.installRate);
                if (object.chargeRate != null)
                    message.chargeRate = String(object.chargeRate);
                if (object.netAmount != null)
                    message.netAmount = String(object.netAmount);
                return message;
            };

            /**
             * Creates a plain object from an AppropriationSummaryExport message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryExport
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationSummaryExport} message AppropriationSummaryExport
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationSummaryExport.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.storeCode = "";
                    object.registerName = "";
                    object.terminalNo = "";
                    object.date = "";
                    object.typeFlag = "";
                    object.submitDate = "";
                    object.totalCount = "";
                    object.totalAmount = "";
                    object.salesCount = "";
                    object.salesAmount = "";
                    object.returnCount = "";
                    object.returnAmount = "";
                    object.charge = "";
                    object.ifr = "";
                    object.motifyAmount = "";
                    object.motifyCharge = "";
                    object.installRate = "";
                    object.chargeRate = "";
                    object.netAmount = "";
                }
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    object.storeCode = message.storeCode;
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    object.registerName = message.registerName;
                if (message.terminalNo != null && message.hasOwnProperty("terminalNo"))
                    object.terminalNo = message.terminalNo;
                if (message.date != null && message.hasOwnProperty("date"))
                    object.date = message.date;
                if (message.typeFlag != null && message.hasOwnProperty("typeFlag"))
                    object.typeFlag = message.typeFlag;
                if (message.submitDate != null && message.hasOwnProperty("submitDate"))
                    object.submitDate = message.submitDate;
                if (message.totalCount != null && message.hasOwnProperty("totalCount"))
                    object.totalCount = message.totalCount;
                if (message.totalAmount != null && message.hasOwnProperty("totalAmount"))
                    object.totalAmount = message.totalAmount;
                if (message.salesCount != null && message.hasOwnProperty("salesCount"))
                    object.salesCount = message.salesCount;
                if (message.salesAmount != null && message.hasOwnProperty("salesAmount"))
                    object.salesAmount = message.salesAmount;
                if (message.returnCount != null && message.hasOwnProperty("returnCount"))
                    object.returnCount = message.returnCount;
                if (message.returnAmount != null && message.hasOwnProperty("returnAmount"))
                    object.returnAmount = message.returnAmount;
                if (message.charge != null && message.hasOwnProperty("charge"))
                    object.charge = message.charge;
                if (message.ifr != null && message.hasOwnProperty("ifr"))
                    object.ifr = message.ifr;
                if (message.motifyAmount != null && message.hasOwnProperty("motifyAmount"))
                    object.motifyAmount = message.motifyAmount;
                if (message.motifyCharge != null && message.hasOwnProperty("motifyCharge"))
                    object.motifyCharge = message.motifyCharge;
                if (message.installRate != null && message.hasOwnProperty("installRate"))
                    object.installRate = message.installRate;
                if (message.chargeRate != null && message.hasOwnProperty("chargeRate"))
                    object.chargeRate = message.chargeRate;
                if (message.netAmount != null && message.hasOwnProperty("netAmount"))
                    object.netAmount = message.netAmount;
                return object;
            };

            /**
             * Converts this AppropriationSummaryExport to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryExport
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationSummaryExport.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationSummaryExport;
        })();

        Protobuf.AppropriationSummaryByCardTypeExport = (function() {

            /**
             * Properties of an AppropriationSummaryByCardTypeExport.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationSummaryByCardTypeExport
             * @property {string|null} [storeCode] AppropriationSummaryByCardTypeExport storeCode
             * @property {string|null} [registerName] AppropriationSummaryByCardTypeExport registerName
             * @property {string|null} [cardType] AppropriationSummaryByCardTypeExport cardType
             * @property {string|null} [ourBankCount] AppropriationSummaryByCardTypeExport ourBankCount
             * @property {string|null} [ourBankAmount] AppropriationSummaryByCardTypeExport ourBankAmount
             * @property {string|null} [notOurBankCount] AppropriationSummaryByCardTypeExport notOurBankCount
             * @property {string|null} [notOurBankAmount] AppropriationSummaryByCardTypeExport notOurBankAmount
             * @property {string|null} [totalCount] AppropriationSummaryByCardTypeExport totalCount
             * @property {string|null} [totalAmount] AppropriationSummaryByCardTypeExport totalAmount
             */

            /**
             * Constructs a new AppropriationSummaryByCardTypeExport.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationSummaryByCardTypeExport.
             * @implements IAppropriationSummaryByCardTypeExport
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryByCardTypeExport=} [properties] Properties to set
             */
            function AppropriationSummaryByCardTypeExport(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationSummaryByCardTypeExport storeCode.
             * @member {string} storeCode
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeExport
             * @instance
             */
            AppropriationSummaryByCardTypeExport.prototype.storeCode = "";

            /**
             * AppropriationSummaryByCardTypeExport registerName.
             * @member {string} registerName
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeExport
             * @instance
             */
            AppropriationSummaryByCardTypeExport.prototype.registerName = "";

            /**
             * AppropriationSummaryByCardTypeExport cardType.
             * @member {string} cardType
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeExport
             * @instance
             */
            AppropriationSummaryByCardTypeExport.prototype.cardType = "";

            /**
             * AppropriationSummaryByCardTypeExport ourBankCount.
             * @member {string} ourBankCount
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeExport
             * @instance
             */
            AppropriationSummaryByCardTypeExport.prototype.ourBankCount = "";

            /**
             * AppropriationSummaryByCardTypeExport ourBankAmount.
             * @member {string} ourBankAmount
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeExport
             * @instance
             */
            AppropriationSummaryByCardTypeExport.prototype.ourBankAmount = "";

            /**
             * AppropriationSummaryByCardTypeExport notOurBankCount.
             * @member {string} notOurBankCount
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeExport
             * @instance
             */
            AppropriationSummaryByCardTypeExport.prototype.notOurBankCount = "";

            /**
             * AppropriationSummaryByCardTypeExport notOurBankAmount.
             * @member {string} notOurBankAmount
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeExport
             * @instance
             */
            AppropriationSummaryByCardTypeExport.prototype.notOurBankAmount = "";

            /**
             * AppropriationSummaryByCardTypeExport totalCount.
             * @member {string} totalCount
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeExport
             * @instance
             */
            AppropriationSummaryByCardTypeExport.prototype.totalCount = "";

            /**
             * AppropriationSummaryByCardTypeExport totalAmount.
             * @member {string} totalAmount
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeExport
             * @instance
             */
            AppropriationSummaryByCardTypeExport.prototype.totalAmount = "";

            /**
             * Creates a new AppropriationSummaryByCardTypeExport instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryByCardTypeExport=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeExport} AppropriationSummaryByCardTypeExport instance
             */
            AppropriationSummaryByCardTypeExport.create = function create(properties) {
                return new AppropriationSummaryByCardTypeExport(properties);
            };

            /**
             * Encodes the specified AppropriationSummaryByCardTypeExport message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeExport.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryByCardTypeExport} message AppropriationSummaryByCardTypeExport message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationSummaryByCardTypeExport.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.storeCode != null && Object.hasOwnProperty.call(message, "storeCode"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.storeCode);
                if (message.registerName != null && Object.hasOwnProperty.call(message, "registerName"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.registerName);
                if (message.cardType != null && Object.hasOwnProperty.call(message, "cardType"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.cardType);
                if (message.ourBankCount != null && Object.hasOwnProperty.call(message, "ourBankCount"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.ourBankCount);
                if (message.ourBankAmount != null && Object.hasOwnProperty.call(message, "ourBankAmount"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.ourBankAmount);
                if (message.notOurBankCount != null && Object.hasOwnProperty.call(message, "notOurBankCount"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.notOurBankCount);
                if (message.notOurBankAmount != null && Object.hasOwnProperty.call(message, "notOurBankAmount"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.notOurBankAmount);
                if (message.totalCount != null && Object.hasOwnProperty.call(message, "totalCount"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.totalCount);
                if (message.totalAmount != null && Object.hasOwnProperty.call(message, "totalAmount"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.totalAmount);
                return writer;
            };

            /**
             * Encodes the specified AppropriationSummaryByCardTypeExport message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeExport.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryByCardTypeExport} message AppropriationSummaryByCardTypeExport message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationSummaryByCardTypeExport.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationSummaryByCardTypeExport message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeExport
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeExport} AppropriationSummaryByCardTypeExport
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationSummaryByCardTypeExport.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeExport();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.storeCode = reader.string();
                        break;
                    case 2:
                        message.registerName = reader.string();
                        break;
                    case 3:
                        message.cardType = reader.string();
                        break;
                    case 4:
                        message.ourBankCount = reader.string();
                        break;
                    case 5:
                        message.ourBankAmount = reader.string();
                        break;
                    case 6:
                        message.notOurBankCount = reader.string();
                        break;
                    case 7:
                        message.notOurBankAmount = reader.string();
                        break;
                    case 8:
                        message.totalCount = reader.string();
                        break;
                    case 9:
                        message.totalAmount = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationSummaryByCardTypeExport message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeExport
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeExport} AppropriationSummaryByCardTypeExport
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationSummaryByCardTypeExport.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationSummaryByCardTypeExport message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeExport
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationSummaryByCardTypeExport.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    if (!$util.isString(message.storeCode))
                        return "storeCode: string expected";
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    if (!$util.isString(message.registerName))
                        return "registerName: string expected";
                if (message.cardType != null && message.hasOwnProperty("cardType"))
                    if (!$util.isString(message.cardType))
                        return "cardType: string expected";
                if (message.ourBankCount != null && message.hasOwnProperty("ourBankCount"))
                    if (!$util.isString(message.ourBankCount))
                        return "ourBankCount: string expected";
                if (message.ourBankAmount != null && message.hasOwnProperty("ourBankAmount"))
                    if (!$util.isString(message.ourBankAmount))
                        return "ourBankAmount: string expected";
                if (message.notOurBankCount != null && message.hasOwnProperty("notOurBankCount"))
                    if (!$util.isString(message.notOurBankCount))
                        return "notOurBankCount: string expected";
                if (message.notOurBankAmount != null && message.hasOwnProperty("notOurBankAmount"))
                    if (!$util.isString(message.notOurBankAmount))
                        return "notOurBankAmount: string expected";
                if (message.totalCount != null && message.hasOwnProperty("totalCount"))
                    if (!$util.isString(message.totalCount))
                        return "totalCount: string expected";
                if (message.totalAmount != null && message.hasOwnProperty("totalAmount"))
                    if (!$util.isString(message.totalAmount))
                        return "totalAmount: string expected";
                return null;
            };

            /**
             * Creates an AppropriationSummaryByCardTypeExport message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeExport
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeExport} AppropriationSummaryByCardTypeExport
             */
            AppropriationSummaryByCardTypeExport.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeExport)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeExport();
                if (object.storeCode != null)
                    message.storeCode = String(object.storeCode);
                if (object.registerName != null)
                    message.registerName = String(object.registerName);
                if (object.cardType != null)
                    message.cardType = String(object.cardType);
                if (object.ourBankCount != null)
                    message.ourBankCount = String(object.ourBankCount);
                if (object.ourBankAmount != null)
                    message.ourBankAmount = String(object.ourBankAmount);
                if (object.notOurBankCount != null)
                    message.notOurBankCount = String(object.notOurBankCount);
                if (object.notOurBankAmount != null)
                    message.notOurBankAmount = String(object.notOurBankAmount);
                if (object.totalCount != null)
                    message.totalCount = String(object.totalCount);
                if (object.totalAmount != null)
                    message.totalAmount = String(object.totalAmount);
                return message;
            };

            /**
             * Creates a plain object from an AppropriationSummaryByCardTypeExport message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeExport
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeExport} message AppropriationSummaryByCardTypeExport
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationSummaryByCardTypeExport.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.storeCode = "";
                    object.registerName = "";
                    object.cardType = "";
                    object.ourBankCount = "";
                    object.ourBankAmount = "";
                    object.notOurBankCount = "";
                    object.notOurBankAmount = "";
                    object.totalCount = "";
                    object.totalAmount = "";
                }
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    object.storeCode = message.storeCode;
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    object.registerName = message.registerName;
                if (message.cardType != null && message.hasOwnProperty("cardType"))
                    object.cardType = message.cardType;
                if (message.ourBankCount != null && message.hasOwnProperty("ourBankCount"))
                    object.ourBankCount = message.ourBankCount;
                if (message.ourBankAmount != null && message.hasOwnProperty("ourBankAmount"))
                    object.ourBankAmount = message.ourBankAmount;
                if (message.notOurBankCount != null && message.hasOwnProperty("notOurBankCount"))
                    object.notOurBankCount = message.notOurBankCount;
                if (message.notOurBankAmount != null && message.hasOwnProperty("notOurBankAmount"))
                    object.notOurBankAmount = message.notOurBankAmount;
                if (message.totalCount != null && message.hasOwnProperty("totalCount"))
                    object.totalCount = message.totalCount;
                if (message.totalAmount != null && message.hasOwnProperty("totalAmount"))
                    object.totalAmount = message.totalAmount;
                return object;
            };

            /**
             * Converts this AppropriationSummaryByCardTypeExport to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeExport
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationSummaryByCardTypeExport.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationSummaryByCardTypeExport;
        })();

        Protobuf.AppropriationSummaryByIssuerExport = (function() {

            /**
             * Properties of an AppropriationSummaryByIssuerExport.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAppropriationSummaryByIssuerExport
             * @property {string|null} [storeCode] AppropriationSummaryByIssuerExport storeCode
             * @property {string|null} [registerName] AppropriationSummaryByIssuerExport registerName
             * @property {string|null} [issuer] AppropriationSummaryByIssuerExport issuer
             * @property {string|null} [issuerName] AppropriationSummaryByIssuerExport issuerName
             * @property {string|null} [count] AppropriationSummaryByIssuerExport count
             * @property {string|null} [amount] AppropriationSummaryByIssuerExport amount
             */

            /**
             * Constructs a new AppropriationSummaryByIssuerExport.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AppropriationSummaryByIssuerExport.
             * @implements IAppropriationSummaryByIssuerExport
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryByIssuerExport=} [properties] Properties to set
             */
            function AppropriationSummaryByIssuerExport(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AppropriationSummaryByIssuerExport storeCode.
             * @member {string} storeCode
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByIssuerExport
             * @instance
             */
            AppropriationSummaryByIssuerExport.prototype.storeCode = "";

            /**
             * AppropriationSummaryByIssuerExport registerName.
             * @member {string} registerName
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByIssuerExport
             * @instance
             */
            AppropriationSummaryByIssuerExport.prototype.registerName = "";

            /**
             * AppropriationSummaryByIssuerExport issuer.
             * @member {string} issuer
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByIssuerExport
             * @instance
             */
            AppropriationSummaryByIssuerExport.prototype.issuer = "";

            /**
             * AppropriationSummaryByIssuerExport issuerName.
             * @member {string} issuerName
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByIssuerExport
             * @instance
             */
            AppropriationSummaryByIssuerExport.prototype.issuerName = "";

            /**
             * AppropriationSummaryByIssuerExport count.
             * @member {string} count
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByIssuerExport
             * @instance
             */
            AppropriationSummaryByIssuerExport.prototype.count = "";

            /**
             * AppropriationSummaryByIssuerExport amount.
             * @member {string} amount
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByIssuerExport
             * @instance
             */
            AppropriationSummaryByIssuerExport.prototype.amount = "";

            /**
             * Creates a new AppropriationSummaryByIssuerExport instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByIssuerExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryByIssuerExport=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryByIssuerExport} AppropriationSummaryByIssuerExport instance
             */
            AppropriationSummaryByIssuerExport.create = function create(properties) {
                return new AppropriationSummaryByIssuerExport(properties);
            };

            /**
             * Encodes the specified AppropriationSummaryByIssuerExport message. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationSummaryByIssuerExport.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByIssuerExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryByIssuerExport} message AppropriationSummaryByIssuerExport message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationSummaryByIssuerExport.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.storeCode != null && Object.hasOwnProperty.call(message, "storeCode"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.storeCode);
                if (message.registerName != null && Object.hasOwnProperty.call(message, "registerName"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.registerName);
                if (message.issuer != null && Object.hasOwnProperty.call(message, "issuer"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.issuer);
                if (message.issuerName != null && Object.hasOwnProperty.call(message, "issuerName"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.issuerName);
                if (message.count != null && Object.hasOwnProperty.call(message, "count"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.count);
                if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.amount);
                return writer;
            };

            /**
             * Encodes the specified AppropriationSummaryByIssuerExport message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AppropriationSummaryByIssuerExport.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByIssuerExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IAppropriationSummaryByIssuerExport} message AppropriationSummaryByIssuerExport message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppropriationSummaryByIssuerExport.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppropriationSummaryByIssuerExport message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByIssuerExport
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryByIssuerExport} AppropriationSummaryByIssuerExport
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationSummaryByIssuerExport.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AppropriationSummaryByIssuerExport();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.storeCode = reader.string();
                        break;
                    case 2:
                        message.registerName = reader.string();
                        break;
                    case 3:
                        message.issuer = reader.string();
                        break;
                    case 4:
                        message.issuerName = reader.string();
                        break;
                    case 5:
                        message.count = reader.string();
                        break;
                    case 6:
                        message.amount = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppropriationSummaryByIssuerExport message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByIssuerExport
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryByIssuerExport} AppropriationSummaryByIssuerExport
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppropriationSummaryByIssuerExport.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppropriationSummaryByIssuerExport message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByIssuerExport
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppropriationSummaryByIssuerExport.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    if (!$util.isString(message.storeCode))
                        return "storeCode: string expected";
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    if (!$util.isString(message.registerName))
                        return "registerName: string expected";
                if (message.issuer != null && message.hasOwnProperty("issuer"))
                    if (!$util.isString(message.issuer))
                        return "issuer: string expected";
                if (message.issuerName != null && message.hasOwnProperty("issuerName"))
                    if (!$util.isString(message.issuerName))
                        return "issuerName: string expected";
                if (message.count != null && message.hasOwnProperty("count"))
                    if (!$util.isString(message.count))
                        return "count: string expected";
                if (message.amount != null && message.hasOwnProperty("amount"))
                    if (!$util.isString(message.amount))
                        return "amount: string expected";
                return null;
            };

            /**
             * Creates an AppropriationSummaryByIssuerExport message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByIssuerExport
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AppropriationSummaryByIssuerExport} AppropriationSummaryByIssuerExport
             */
            AppropriationSummaryByIssuerExport.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AppropriationSummaryByIssuerExport)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AppropriationSummaryByIssuerExport();
                if (object.storeCode != null)
                    message.storeCode = String(object.storeCode);
                if (object.registerName != null)
                    message.registerName = String(object.registerName);
                if (object.issuer != null)
                    message.issuer = String(object.issuer);
                if (object.issuerName != null)
                    message.issuerName = String(object.issuerName);
                if (object.count != null)
                    message.count = String(object.count);
                if (object.amount != null)
                    message.amount = String(object.amount);
                return message;
            };

            /**
             * Creates a plain object from an AppropriationSummaryByIssuerExport message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByIssuerExport
             * @static
             * @param {TCBReceiptApi.Protobuf.AppropriationSummaryByIssuerExport} message AppropriationSummaryByIssuerExport
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppropriationSummaryByIssuerExport.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.storeCode = "";
                    object.registerName = "";
                    object.issuer = "";
                    object.issuerName = "";
                    object.count = "";
                    object.amount = "";
                }
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    object.storeCode = message.storeCode;
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    object.registerName = message.registerName;
                if (message.issuer != null && message.hasOwnProperty("issuer"))
                    object.issuer = message.issuer;
                if (message.issuerName != null && message.hasOwnProperty("issuerName"))
                    object.issuerName = message.issuerName;
                if (message.count != null && message.hasOwnProperty("count"))
                    object.count = message.count;
                if (message.amount != null && message.hasOwnProperty("amount"))
                    object.amount = message.amount;
                return object;
            };

            /**
             * Converts this AppropriationSummaryByIssuerExport to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AppropriationSummaryByIssuerExport
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppropriationSummaryByIssuerExport.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppropriationSummaryByIssuerExport;
        })();

        Protobuf.DepositInfo = (function() {

            /**
             * Properties of a DepositInfo.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IDepositInfo
             * @property {number|null} [depositId] DepositInfo depositId
             * @property {string|null} [branchBankCode] DepositInfo branchBankCode
             * @property {string|null} [branchBankName] DepositInfo branchBankName
             * @property {string|null} [account] DepositInfo account
             * @property {string|null} [date] DepositInfo date
             * @property {string|null} [bankCode] DepositInfo bankCode
             * @property {string|null} [tidNumber] DepositInfo tidNumber
             * @property {string|null} [terminalNo] DepositInfo terminalNo
             * @property {string|null} [storeCode] DepositInfo storeCode
             * @property {string|null} [storeCodeMapping] DepositInfo storeCodeMapping
             * @property {string|null} [storeName] DepositInfo storeName
             * @property {number|null} [amount] DepositInfo amount
             * @property {number|null} [charge] DepositInfo charge
             * @property {number|null} [ifr] DepositInfo ifr
             * @property {number|null} [internalIfr] DepositInfo internalIfr
             * @property {number|null} [externalIfr] DepositInfo externalIfr
             * @property {number|null} [type] DepositInfo type
             * @property {string|null} [remarksCode] DepositInfo remarksCode
             * @property {string|null} [remarks] DepositInfo remarks
             * @property {number|null} [chargeTotal] DepositInfo chargeTotal
             * @property {number|null} [netAmount] DepositInfo netAmount
             * @property {number|null} [infoType] DepositInfo infoType
             */

            /**
             * Constructs a new DepositInfo.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a DepositInfo.
             * @implements IDepositInfo
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IDepositInfo=} [properties] Properties to set
             */
            function DepositInfo(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DepositInfo depositId.
             * @member {number} depositId
             * @memberof TCBReceiptApi.Protobuf.DepositInfo
             * @instance
             */
            DepositInfo.prototype.depositId = 0;

            /**
             * DepositInfo branchBankCode.
             * @member {string} branchBankCode
             * @memberof TCBReceiptApi.Protobuf.DepositInfo
             * @instance
             */
            DepositInfo.prototype.branchBankCode = "";

            /**
             * DepositInfo branchBankName.
             * @member {string} branchBankName
             * @memberof TCBReceiptApi.Protobuf.DepositInfo
             * @instance
             */
            DepositInfo.prototype.branchBankName = "";

            /**
             * DepositInfo account.
             * @member {string} account
             * @memberof TCBReceiptApi.Protobuf.DepositInfo
             * @instance
             */
            DepositInfo.prototype.account = "";

            /**
             * DepositInfo date.
             * @member {string} date
             * @memberof TCBReceiptApi.Protobuf.DepositInfo
             * @instance
             */
            DepositInfo.prototype.date = "";

            /**
             * DepositInfo bankCode.
             * @member {string} bankCode
             * @memberof TCBReceiptApi.Protobuf.DepositInfo
             * @instance
             */
            DepositInfo.prototype.bankCode = "";

            /**
             * DepositInfo tidNumber.
             * @member {string} tidNumber
             * @memberof TCBReceiptApi.Protobuf.DepositInfo
             * @instance
             */
            DepositInfo.prototype.tidNumber = "";

            /**
             * DepositInfo terminalNo.
             * @member {string} terminalNo
             * @memberof TCBReceiptApi.Protobuf.DepositInfo
             * @instance
             */
            DepositInfo.prototype.terminalNo = "";

            /**
             * DepositInfo storeCode.
             * @member {string} storeCode
             * @memberof TCBReceiptApi.Protobuf.DepositInfo
             * @instance
             */
            DepositInfo.prototype.storeCode = "";

            /**
             * DepositInfo storeCodeMapping.
             * @member {string} storeCodeMapping
             * @memberof TCBReceiptApi.Protobuf.DepositInfo
             * @instance
             */
            DepositInfo.prototype.storeCodeMapping = "";

            /**
             * DepositInfo storeName.
             * @member {string} storeName
             * @memberof TCBReceiptApi.Protobuf.DepositInfo
             * @instance
             */
            DepositInfo.prototype.storeName = "";

            /**
             * DepositInfo amount.
             * @member {number} amount
             * @memberof TCBReceiptApi.Protobuf.DepositInfo
             * @instance
             */
            DepositInfo.prototype.amount = 0;

            /**
             * DepositInfo charge.
             * @member {number} charge
             * @memberof TCBReceiptApi.Protobuf.DepositInfo
             * @instance
             */
            DepositInfo.prototype.charge = 0;

            /**
             * DepositInfo ifr.
             * @member {number} ifr
             * @memberof TCBReceiptApi.Protobuf.DepositInfo
             * @instance
             */
            DepositInfo.prototype.ifr = 0;

            /**
             * DepositInfo internalIfr.
             * @member {number} internalIfr
             * @memberof TCBReceiptApi.Protobuf.DepositInfo
             * @instance
             */
            DepositInfo.prototype.internalIfr = 0;

            /**
             * DepositInfo externalIfr.
             * @member {number} externalIfr
             * @memberof TCBReceiptApi.Protobuf.DepositInfo
             * @instance
             */
            DepositInfo.prototype.externalIfr = 0;

            /**
             * DepositInfo type.
             * @member {number} type
             * @memberof TCBReceiptApi.Protobuf.DepositInfo
             * @instance
             */
            DepositInfo.prototype.type = 0;

            /**
             * DepositInfo remarksCode.
             * @member {string} remarksCode
             * @memberof TCBReceiptApi.Protobuf.DepositInfo
             * @instance
             */
            DepositInfo.prototype.remarksCode = "";

            /**
             * DepositInfo remarks.
             * @member {string} remarks
             * @memberof TCBReceiptApi.Protobuf.DepositInfo
             * @instance
             */
            DepositInfo.prototype.remarks = "";

            /**
             * DepositInfo chargeTotal.
             * @member {number} chargeTotal
             * @memberof TCBReceiptApi.Protobuf.DepositInfo
             * @instance
             */
            DepositInfo.prototype.chargeTotal = 0;

            /**
             * DepositInfo netAmount.
             * @member {number} netAmount
             * @memberof TCBReceiptApi.Protobuf.DepositInfo
             * @instance
             */
            DepositInfo.prototype.netAmount = 0;

            /**
             * DepositInfo infoType.
             * @member {number} infoType
             * @memberof TCBReceiptApi.Protobuf.DepositInfo
             * @instance
             */
            DepositInfo.prototype.infoType = 0;

            /**
             * Creates a new DepositInfo instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.DepositInfo
             * @static
             * @param {TCBReceiptApi.Protobuf.IDepositInfo=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.DepositInfo} DepositInfo instance
             */
            DepositInfo.create = function create(properties) {
                return new DepositInfo(properties);
            };

            /**
             * Encodes the specified DepositInfo message. Does not implicitly {@link TCBReceiptApi.Protobuf.DepositInfo.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.DepositInfo
             * @static
             * @param {TCBReceiptApi.Protobuf.IDepositInfo} message DepositInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DepositInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.depositId != null && Object.hasOwnProperty.call(message, "depositId"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.depositId);
                if (message.branchBankCode != null && Object.hasOwnProperty.call(message, "branchBankCode"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.branchBankCode);
                if (message.branchBankName != null && Object.hasOwnProperty.call(message, "branchBankName"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.branchBankName);
                if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.account);
                if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.date);
                if (message.bankCode != null && Object.hasOwnProperty.call(message, "bankCode"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.bankCode);
                if (message.tidNumber != null && Object.hasOwnProperty.call(message, "tidNumber"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.tidNumber);
                if (message.terminalNo != null && Object.hasOwnProperty.call(message, "terminalNo"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.terminalNo);
                if (message.storeCode != null && Object.hasOwnProperty.call(message, "storeCode"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.storeCode);
                if (message.storeCodeMapping != null && Object.hasOwnProperty.call(message, "storeCodeMapping"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.storeCodeMapping);
                if (message.storeName != null && Object.hasOwnProperty.call(message, "storeName"))
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.storeName);
                if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                    writer.uint32(/* id 12, wireType 1 =*/97).double(message.amount);
                if (message.charge != null && Object.hasOwnProperty.call(message, "charge"))
                    writer.uint32(/* id 13, wireType 1 =*/105).double(message.charge);
                if (message.ifr != null && Object.hasOwnProperty.call(message, "ifr"))
                    writer.uint32(/* id 14, wireType 1 =*/113).double(message.ifr);
                if (message.internalIfr != null && Object.hasOwnProperty.call(message, "internalIfr"))
                    writer.uint32(/* id 15, wireType 1 =*/121).double(message.internalIfr);
                if (message.externalIfr != null && Object.hasOwnProperty.call(message, "externalIfr"))
                    writer.uint32(/* id 16, wireType 1 =*/129).double(message.externalIfr);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 17, wireType 0 =*/136).int32(message.type);
                if (message.remarksCode != null && Object.hasOwnProperty.call(message, "remarksCode"))
                    writer.uint32(/* id 18, wireType 2 =*/146).string(message.remarksCode);
                if (message.remarks != null && Object.hasOwnProperty.call(message, "remarks"))
                    writer.uint32(/* id 19, wireType 2 =*/154).string(message.remarks);
                if (message.chargeTotal != null && Object.hasOwnProperty.call(message, "chargeTotal"))
                    writer.uint32(/* id 20, wireType 1 =*/161).double(message.chargeTotal);
                if (message.netAmount != null && Object.hasOwnProperty.call(message, "netAmount"))
                    writer.uint32(/* id 21, wireType 1 =*/169).double(message.netAmount);
                if (message.infoType != null && Object.hasOwnProperty.call(message, "infoType"))
                    writer.uint32(/* id 22, wireType 0 =*/176).int32(message.infoType);
                return writer;
            };

            /**
             * Encodes the specified DepositInfo message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.DepositInfo.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.DepositInfo
             * @static
             * @param {TCBReceiptApi.Protobuf.IDepositInfo} message DepositInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DepositInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DepositInfo message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.DepositInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.DepositInfo} DepositInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DepositInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.DepositInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.depositId = reader.int32();
                        break;
                    case 2:
                        message.branchBankCode = reader.string();
                        break;
                    case 3:
                        message.branchBankName = reader.string();
                        break;
                    case 4:
                        message.account = reader.string();
                        break;
                    case 5:
                        message.date = reader.string();
                        break;
                    case 6:
                        message.bankCode = reader.string();
                        break;
                    case 7:
                        message.tidNumber = reader.string();
                        break;
                    case 8:
                        message.terminalNo = reader.string();
                        break;
                    case 9:
                        message.storeCode = reader.string();
                        break;
                    case 10:
                        message.storeCodeMapping = reader.string();
                        break;
                    case 11:
                        message.storeName = reader.string();
                        break;
                    case 12:
                        message.amount = reader.double();
                        break;
                    case 13:
                        message.charge = reader.double();
                        break;
                    case 14:
                        message.ifr = reader.double();
                        break;
                    case 15:
                        message.internalIfr = reader.double();
                        break;
                    case 16:
                        message.externalIfr = reader.double();
                        break;
                    case 17:
                        message.type = reader.int32();
                        break;
                    case 18:
                        message.remarksCode = reader.string();
                        break;
                    case 19:
                        message.remarks = reader.string();
                        break;
                    case 20:
                        message.chargeTotal = reader.double();
                        break;
                    case 21:
                        message.netAmount = reader.double();
                        break;
                    case 22:
                        message.infoType = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DepositInfo message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.DepositInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.DepositInfo} DepositInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DepositInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DepositInfo message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.DepositInfo
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DepositInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.depositId != null && message.hasOwnProperty("depositId"))
                    if (!$util.isInteger(message.depositId))
                        return "depositId: integer expected";
                if (message.branchBankCode != null && message.hasOwnProperty("branchBankCode"))
                    if (!$util.isString(message.branchBankCode))
                        return "branchBankCode: string expected";
                if (message.branchBankName != null && message.hasOwnProperty("branchBankName"))
                    if (!$util.isString(message.branchBankName))
                        return "branchBankName: string expected";
                if (message.account != null && message.hasOwnProperty("account"))
                    if (!$util.isString(message.account))
                        return "account: string expected";
                if (message.date != null && message.hasOwnProperty("date"))
                    if (!$util.isString(message.date))
                        return "date: string expected";
                if (message.bankCode != null && message.hasOwnProperty("bankCode"))
                    if (!$util.isString(message.bankCode))
                        return "bankCode: string expected";
                if (message.tidNumber != null && message.hasOwnProperty("tidNumber"))
                    if (!$util.isString(message.tidNumber))
                        return "tidNumber: string expected";
                if (message.terminalNo != null && message.hasOwnProperty("terminalNo"))
                    if (!$util.isString(message.terminalNo))
                        return "terminalNo: string expected";
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    if (!$util.isString(message.storeCode))
                        return "storeCode: string expected";
                if (message.storeCodeMapping != null && message.hasOwnProperty("storeCodeMapping"))
                    if (!$util.isString(message.storeCodeMapping))
                        return "storeCodeMapping: string expected";
                if (message.storeName != null && message.hasOwnProperty("storeName"))
                    if (!$util.isString(message.storeName))
                        return "storeName: string expected";
                if (message.amount != null && message.hasOwnProperty("amount"))
                    if (typeof message.amount !== "number")
                        return "amount: number expected";
                if (message.charge != null && message.hasOwnProperty("charge"))
                    if (typeof message.charge !== "number")
                        return "charge: number expected";
                if (message.ifr != null && message.hasOwnProperty("ifr"))
                    if (typeof message.ifr !== "number")
                        return "ifr: number expected";
                if (message.internalIfr != null && message.hasOwnProperty("internalIfr"))
                    if (typeof message.internalIfr !== "number")
                        return "internalIfr: number expected";
                if (message.externalIfr != null && message.hasOwnProperty("externalIfr"))
                    if (typeof message.externalIfr !== "number")
                        return "externalIfr: number expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isInteger(message.type))
                        return "type: integer expected";
                if (message.remarksCode != null && message.hasOwnProperty("remarksCode"))
                    if (!$util.isString(message.remarksCode))
                        return "remarksCode: string expected";
                if (message.remarks != null && message.hasOwnProperty("remarks"))
                    if (!$util.isString(message.remarks))
                        return "remarks: string expected";
                if (message.chargeTotal != null && message.hasOwnProperty("chargeTotal"))
                    if (typeof message.chargeTotal !== "number")
                        return "chargeTotal: number expected";
                if (message.netAmount != null && message.hasOwnProperty("netAmount"))
                    if (typeof message.netAmount !== "number")
                        return "netAmount: number expected";
                if (message.infoType != null && message.hasOwnProperty("infoType"))
                    if (!$util.isInteger(message.infoType))
                        return "infoType: integer expected";
                return null;
            };

            /**
             * Creates a DepositInfo message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.DepositInfo
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.DepositInfo} DepositInfo
             */
            DepositInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.DepositInfo)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.DepositInfo();
                if (object.depositId != null)
                    message.depositId = object.depositId | 0;
                if (object.branchBankCode != null)
                    message.branchBankCode = String(object.branchBankCode);
                if (object.branchBankName != null)
                    message.branchBankName = String(object.branchBankName);
                if (object.account != null)
                    message.account = String(object.account);
                if (object.date != null)
                    message.date = String(object.date);
                if (object.bankCode != null)
                    message.bankCode = String(object.bankCode);
                if (object.tidNumber != null)
                    message.tidNumber = String(object.tidNumber);
                if (object.terminalNo != null)
                    message.terminalNo = String(object.terminalNo);
                if (object.storeCode != null)
                    message.storeCode = String(object.storeCode);
                if (object.storeCodeMapping != null)
                    message.storeCodeMapping = String(object.storeCodeMapping);
                if (object.storeName != null)
                    message.storeName = String(object.storeName);
                if (object.amount != null)
                    message.amount = Number(object.amount);
                if (object.charge != null)
                    message.charge = Number(object.charge);
                if (object.ifr != null)
                    message.ifr = Number(object.ifr);
                if (object.internalIfr != null)
                    message.internalIfr = Number(object.internalIfr);
                if (object.externalIfr != null)
                    message.externalIfr = Number(object.externalIfr);
                if (object.type != null)
                    message.type = object.type | 0;
                if (object.remarksCode != null)
                    message.remarksCode = String(object.remarksCode);
                if (object.remarks != null)
                    message.remarks = String(object.remarks);
                if (object.chargeTotal != null)
                    message.chargeTotal = Number(object.chargeTotal);
                if (object.netAmount != null)
                    message.netAmount = Number(object.netAmount);
                if (object.infoType != null)
                    message.infoType = object.infoType | 0;
                return message;
            };

            /**
             * Creates a plain object from a DepositInfo message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.DepositInfo
             * @static
             * @param {TCBReceiptApi.Protobuf.DepositInfo} message DepositInfo
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DepositInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.depositId = 0;
                    object.branchBankCode = "";
                    object.branchBankName = "";
                    object.account = "";
                    object.date = "";
                    object.bankCode = "";
                    object.tidNumber = "";
                    object.terminalNo = "";
                    object.storeCode = "";
                    object.storeCodeMapping = "";
                    object.storeName = "";
                    object.amount = 0;
                    object.charge = 0;
                    object.ifr = 0;
                    object.internalIfr = 0;
                    object.externalIfr = 0;
                    object.type = 0;
                    object.remarksCode = "";
                    object.remarks = "";
                    object.chargeTotal = 0;
                    object.netAmount = 0;
                    object.infoType = 0;
                }
                if (message.depositId != null && message.hasOwnProperty("depositId"))
                    object.depositId = message.depositId;
                if (message.branchBankCode != null && message.hasOwnProperty("branchBankCode"))
                    object.branchBankCode = message.branchBankCode;
                if (message.branchBankName != null && message.hasOwnProperty("branchBankName"))
                    object.branchBankName = message.branchBankName;
                if (message.account != null && message.hasOwnProperty("account"))
                    object.account = message.account;
                if (message.date != null && message.hasOwnProperty("date"))
                    object.date = message.date;
                if (message.bankCode != null && message.hasOwnProperty("bankCode"))
                    object.bankCode = message.bankCode;
                if (message.tidNumber != null && message.hasOwnProperty("tidNumber"))
                    object.tidNumber = message.tidNumber;
                if (message.terminalNo != null && message.hasOwnProperty("terminalNo"))
                    object.terminalNo = message.terminalNo;
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    object.storeCode = message.storeCode;
                if (message.storeCodeMapping != null && message.hasOwnProperty("storeCodeMapping"))
                    object.storeCodeMapping = message.storeCodeMapping;
                if (message.storeName != null && message.hasOwnProperty("storeName"))
                    object.storeName = message.storeName;
                if (message.amount != null && message.hasOwnProperty("amount"))
                    object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
                if (message.charge != null && message.hasOwnProperty("charge"))
                    object.charge = options.json && !isFinite(message.charge) ? String(message.charge) : message.charge;
                if (message.ifr != null && message.hasOwnProperty("ifr"))
                    object.ifr = options.json && !isFinite(message.ifr) ? String(message.ifr) : message.ifr;
                if (message.internalIfr != null && message.hasOwnProperty("internalIfr"))
                    object.internalIfr = options.json && !isFinite(message.internalIfr) ? String(message.internalIfr) : message.internalIfr;
                if (message.externalIfr != null && message.hasOwnProperty("externalIfr"))
                    object.externalIfr = options.json && !isFinite(message.externalIfr) ? String(message.externalIfr) : message.externalIfr;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.remarksCode != null && message.hasOwnProperty("remarksCode"))
                    object.remarksCode = message.remarksCode;
                if (message.remarks != null && message.hasOwnProperty("remarks"))
                    object.remarks = message.remarks;
                if (message.chargeTotal != null && message.hasOwnProperty("chargeTotal"))
                    object.chargeTotal = options.json && !isFinite(message.chargeTotal) ? String(message.chargeTotal) : message.chargeTotal;
                if (message.netAmount != null && message.hasOwnProperty("netAmount"))
                    object.netAmount = options.json && !isFinite(message.netAmount) ? String(message.netAmount) : message.netAmount;
                if (message.infoType != null && message.hasOwnProperty("infoType"))
                    object.infoType = message.infoType;
                return object;
            };

            /**
             * Converts this DepositInfo to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.DepositInfo
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DepositInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return DepositInfo;
        })();

        Protobuf.Deposit = (function() {

            /**
             * Properties of a Deposit.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IDeposit
             * @property {Array.<TCBReceiptApi.Protobuf.IDepositInfo>|null} [list] Deposit list
             */

            /**
             * Constructs a new Deposit.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a Deposit.
             * @implements IDeposit
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IDeposit=} [properties] Properties to set
             */
            function Deposit(properties) {
                this.list = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Deposit list.
             * @member {Array.<TCBReceiptApi.Protobuf.IDepositInfo>} list
             * @memberof TCBReceiptApi.Protobuf.Deposit
             * @instance
             */
            Deposit.prototype.list = $util.emptyArray;

            /**
             * Creates a new Deposit instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.Deposit
             * @static
             * @param {TCBReceiptApi.Protobuf.IDeposit=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.Deposit} Deposit instance
             */
            Deposit.create = function create(properties) {
                return new Deposit(properties);
            };

            /**
             * Encodes the specified Deposit message. Does not implicitly {@link TCBReceiptApi.Protobuf.Deposit.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.Deposit
             * @static
             * @param {TCBReceiptApi.Protobuf.IDeposit} message Deposit message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Deposit.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.list != null && message.list.length)
                    for (var i = 0; i < message.list.length; ++i)
                        $root.TCBReceiptApi.Protobuf.DepositInfo.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Deposit message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.Deposit.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.Deposit
             * @static
             * @param {TCBReceiptApi.Protobuf.IDeposit} message Deposit message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Deposit.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Deposit message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.Deposit
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.Deposit} Deposit
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Deposit.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.Deposit();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.TCBReceiptApi.Protobuf.DepositInfo.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Deposit message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.Deposit
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.Deposit} Deposit
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Deposit.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Deposit message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.Deposit
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Deposit.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.list != null && message.hasOwnProperty("list")) {
                    if (!Array.isArray(message.list))
                        return "list: array expected";
                    for (var i = 0; i < message.list.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.DepositInfo.verify(message.list[i]);
                        if (error)
                            return "list." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a Deposit message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.Deposit
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.Deposit} Deposit
             */
            Deposit.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.Deposit)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.Deposit();
                if (object.list) {
                    if (!Array.isArray(object.list))
                        throw TypeError(".TCBReceiptApi.Protobuf.Deposit.list: array expected");
                    message.list = [];
                    for (var i = 0; i < object.list.length; ++i) {
                        if (typeof object.list[i] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.Deposit.list: object expected");
                        message.list[i] = $root.TCBReceiptApi.Protobuf.DepositInfo.fromObject(object.list[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a Deposit message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.Deposit
             * @static
             * @param {TCBReceiptApi.Protobuf.Deposit} message Deposit
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Deposit.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.list = [];
                if (message.list && message.list.length) {
                    object.list = [];
                    for (var j = 0; j < message.list.length; ++j)
                        object.list[j] = $root.TCBReceiptApi.Protobuf.DepositInfo.toObject(message.list[j], options);
                }
                return object;
            };

            /**
             * Converts this Deposit to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.Deposit
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Deposit.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Deposit;
        })();

        Protobuf.DepositDateMap = (function() {

            /**
             * Properties of a DepositDateMap.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IDepositDateMap
             * @property {Object.<string,TCBReceiptApi.Protobuf.IDeposit>|null} [byDate] DepositDateMap byDate
             */

            /**
             * Constructs a new DepositDateMap.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a DepositDateMap.
             * @implements IDepositDateMap
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IDepositDateMap=} [properties] Properties to set
             */
            function DepositDateMap(properties) {
                this.byDate = {};
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DepositDateMap byDate.
             * @member {Object.<string,TCBReceiptApi.Protobuf.IDeposit>} byDate
             * @memberof TCBReceiptApi.Protobuf.DepositDateMap
             * @instance
             */
            DepositDateMap.prototype.byDate = $util.emptyObject;

            /**
             * Creates a new DepositDateMap instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.DepositDateMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IDepositDateMap=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.DepositDateMap} DepositDateMap instance
             */
            DepositDateMap.create = function create(properties) {
                return new DepositDateMap(properties);
            };

            /**
             * Encodes the specified DepositDateMap message. Does not implicitly {@link TCBReceiptApi.Protobuf.DepositDateMap.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.DepositDateMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IDepositDateMap} message DepositDateMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DepositDateMap.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.byDate != null && Object.hasOwnProperty.call(message, "byDate"))
                    for (var keys = Object.keys(message.byDate), i = 0; i < keys.length; ++i) {
                        writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                        $root.TCBReceiptApi.Protobuf.Deposit.encode(message.byDate[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                    }
                return writer;
            };

            /**
             * Encodes the specified DepositDateMap message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.DepositDateMap.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.DepositDateMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IDepositDateMap} message DepositDateMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DepositDateMap.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DepositDateMap message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.DepositDateMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.DepositDateMap} DepositDateMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DepositDateMap.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.DepositDateMap(), key, value;
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (message.byDate === $util.emptyObject)
                            message.byDate = {};
                        var end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = null;
                        while (reader.pos < end2) {
                            var tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = $root.TCBReceiptApi.Protobuf.Deposit.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.byDate[key] = value;
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DepositDateMap message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.DepositDateMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.DepositDateMap} DepositDateMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DepositDateMap.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DepositDateMap message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.DepositDateMap
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DepositDateMap.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.byDate != null && message.hasOwnProperty("byDate")) {
                    if (!$util.isObject(message.byDate))
                        return "byDate: object expected";
                    var key = Object.keys(message.byDate);
                    for (var i = 0; i < key.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.Deposit.verify(message.byDate[key[i]]);
                        if (error)
                            return "byDate." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a DepositDateMap message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.DepositDateMap
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.DepositDateMap} DepositDateMap
             */
            DepositDateMap.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.DepositDateMap)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.DepositDateMap();
                if (object.byDate) {
                    if (typeof object.byDate !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.DepositDateMap.byDate: object expected");
                    message.byDate = {};
                    for (var keys = Object.keys(object.byDate), i = 0; i < keys.length; ++i) {
                        if (typeof object.byDate[keys[i]] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.DepositDateMap.byDate: object expected");
                        message.byDate[keys[i]] = $root.TCBReceiptApi.Protobuf.Deposit.fromObject(object.byDate[keys[i]]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a DepositDateMap message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.DepositDateMap
             * @static
             * @param {TCBReceiptApi.Protobuf.DepositDateMap} message DepositDateMap
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DepositDateMap.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.objects || options.defaults)
                    object.byDate = {};
                var keys2;
                if (message.byDate && (keys2 = Object.keys(message.byDate)).length) {
                    object.byDate = {};
                    for (var j = 0; j < keys2.length; ++j)
                        object.byDate[keys2[j]] = $root.TCBReceiptApi.Protobuf.Deposit.toObject(message.byDate[keys2[j]], options);
                }
                return object;
            };

            /**
             * Converts this DepositDateMap to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.DepositDateMap
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DepositDateMap.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return DepositDateMap;
        })();

        Protobuf.DepositCollection = (function() {

            /**
             * Properties of a DepositCollection.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IDepositCollection
             * @property {TCBReceiptApi.Protobuf.IDepositDateMap|null} [byStore] DepositCollection byStore
             * @property {TCBReceiptApi.Protobuf.IDepositDateMap|null} [byAccount] DepositCollection byAccount
             * @property {Object.<string,TCBReceiptApi.Protobuf.IDepositDateMap>|null} [byDiffAccount] DepositCollection byDiffAccount
             */

            /**
             * Constructs a new DepositCollection.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a DepositCollection.
             * @implements IDepositCollection
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IDepositCollection=} [properties] Properties to set
             */
            function DepositCollection(properties) {
                this.byDiffAccount = {};
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DepositCollection byStore.
             * @member {TCBReceiptApi.Protobuf.IDepositDateMap|null|undefined} byStore
             * @memberof TCBReceiptApi.Protobuf.DepositCollection
             * @instance
             */
            DepositCollection.prototype.byStore = null;

            /**
             * DepositCollection byAccount.
             * @member {TCBReceiptApi.Protobuf.IDepositDateMap|null|undefined} byAccount
             * @memberof TCBReceiptApi.Protobuf.DepositCollection
             * @instance
             */
            DepositCollection.prototype.byAccount = null;

            /**
             * DepositCollection byDiffAccount.
             * @member {Object.<string,TCBReceiptApi.Protobuf.IDepositDateMap>} byDiffAccount
             * @memberof TCBReceiptApi.Protobuf.DepositCollection
             * @instance
             */
            DepositCollection.prototype.byDiffAccount = $util.emptyObject;

            /**
             * Creates a new DepositCollection instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.DepositCollection
             * @static
             * @param {TCBReceiptApi.Protobuf.IDepositCollection=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.DepositCollection} DepositCollection instance
             */
            DepositCollection.create = function create(properties) {
                return new DepositCollection(properties);
            };

            /**
             * Encodes the specified DepositCollection message. Does not implicitly {@link TCBReceiptApi.Protobuf.DepositCollection.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.DepositCollection
             * @static
             * @param {TCBReceiptApi.Protobuf.IDepositCollection} message DepositCollection message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DepositCollection.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.byStore != null && Object.hasOwnProperty.call(message, "byStore"))
                    $root.TCBReceiptApi.Protobuf.DepositDateMap.encode(message.byStore, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.byAccount != null && Object.hasOwnProperty.call(message, "byAccount"))
                    $root.TCBReceiptApi.Protobuf.DepositDateMap.encode(message.byAccount, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.byDiffAccount != null && Object.hasOwnProperty.call(message, "byDiffAccount"))
                    for (var keys = Object.keys(message.byDiffAccount), i = 0; i < keys.length; ++i) {
                        writer.uint32(/* id 3, wireType 2 =*/26).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                        $root.TCBReceiptApi.Protobuf.DepositDateMap.encode(message.byDiffAccount[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                    }
                return writer;
            };

            /**
             * Encodes the specified DepositCollection message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.DepositCollection.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.DepositCollection
             * @static
             * @param {TCBReceiptApi.Protobuf.IDepositCollection} message DepositCollection message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DepositCollection.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DepositCollection message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.DepositCollection
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.DepositCollection} DepositCollection
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DepositCollection.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.DepositCollection(), key, value;
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.byStore = $root.TCBReceiptApi.Protobuf.DepositDateMap.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.byAccount = $root.TCBReceiptApi.Protobuf.DepositDateMap.decode(reader, reader.uint32());
                        break;
                    case 3:
                        if (message.byDiffAccount === $util.emptyObject)
                            message.byDiffAccount = {};
                        var end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = null;
                        while (reader.pos < end2) {
                            var tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = $root.TCBReceiptApi.Protobuf.DepositDateMap.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.byDiffAccount[key] = value;
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DepositCollection message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.DepositCollection
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.DepositCollection} DepositCollection
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DepositCollection.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DepositCollection message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.DepositCollection
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DepositCollection.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.byStore != null && message.hasOwnProperty("byStore")) {
                    var error = $root.TCBReceiptApi.Protobuf.DepositDateMap.verify(message.byStore);
                    if (error)
                        return "byStore." + error;
                }
                if (message.byAccount != null && message.hasOwnProperty("byAccount")) {
                    var error = $root.TCBReceiptApi.Protobuf.DepositDateMap.verify(message.byAccount);
                    if (error)
                        return "byAccount." + error;
                }
                if (message.byDiffAccount != null && message.hasOwnProperty("byDiffAccount")) {
                    if (!$util.isObject(message.byDiffAccount))
                        return "byDiffAccount: object expected";
                    var key = Object.keys(message.byDiffAccount);
                    for (var i = 0; i < key.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.DepositDateMap.verify(message.byDiffAccount[key[i]]);
                        if (error)
                            return "byDiffAccount." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a DepositCollection message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.DepositCollection
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.DepositCollection} DepositCollection
             */
            DepositCollection.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.DepositCollection)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.DepositCollection();
                if (object.byStore != null) {
                    if (typeof object.byStore !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.DepositCollection.byStore: object expected");
                    message.byStore = $root.TCBReceiptApi.Protobuf.DepositDateMap.fromObject(object.byStore);
                }
                if (object.byAccount != null) {
                    if (typeof object.byAccount !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.DepositCollection.byAccount: object expected");
                    message.byAccount = $root.TCBReceiptApi.Protobuf.DepositDateMap.fromObject(object.byAccount);
                }
                if (object.byDiffAccount) {
                    if (typeof object.byDiffAccount !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.DepositCollection.byDiffAccount: object expected");
                    message.byDiffAccount = {};
                    for (var keys = Object.keys(object.byDiffAccount), i = 0; i < keys.length; ++i) {
                        if (typeof object.byDiffAccount[keys[i]] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.DepositCollection.byDiffAccount: object expected");
                        message.byDiffAccount[keys[i]] = $root.TCBReceiptApi.Protobuf.DepositDateMap.fromObject(object.byDiffAccount[keys[i]]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a DepositCollection message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.DepositCollection
             * @static
             * @param {TCBReceiptApi.Protobuf.DepositCollection} message DepositCollection
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DepositCollection.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.objects || options.defaults)
                    object.byDiffAccount = {};
                if (options.defaults) {
                    object.byStore = null;
                    object.byAccount = null;
                }
                if (message.byStore != null && message.hasOwnProperty("byStore"))
                    object.byStore = $root.TCBReceiptApi.Protobuf.DepositDateMap.toObject(message.byStore, options);
                if (message.byAccount != null && message.hasOwnProperty("byAccount"))
                    object.byAccount = $root.TCBReceiptApi.Protobuf.DepositDateMap.toObject(message.byAccount, options);
                var keys2;
                if (message.byDiffAccount && (keys2 = Object.keys(message.byDiffAccount)).length) {
                    object.byDiffAccount = {};
                    for (var j = 0; j < keys2.length; ++j)
                        object.byDiffAccount[keys2[j]] = $root.TCBReceiptApi.Protobuf.DepositDateMap.toObject(message.byDiffAccount[keys2[j]], options);
                }
                return object;
            };

            /**
             * Converts this DepositCollection to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.DepositCollection
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DepositCollection.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return DepositCollection;
        })();

        Protobuf.DepositCollectionMap = (function() {

            /**
             * Properties of a DepositCollectionMap.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IDepositCollectionMap
             * @property {Object.<string,TCBReceiptApi.Protobuf.IDepositCollection>|null} [map] DepositCollectionMap map
             */

            /**
             * Constructs a new DepositCollectionMap.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a DepositCollectionMap.
             * @implements IDepositCollectionMap
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IDepositCollectionMap=} [properties] Properties to set
             */
            function DepositCollectionMap(properties) {
                this.map = {};
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DepositCollectionMap map.
             * @member {Object.<string,TCBReceiptApi.Protobuf.IDepositCollection>} map
             * @memberof TCBReceiptApi.Protobuf.DepositCollectionMap
             * @instance
             */
            DepositCollectionMap.prototype.map = $util.emptyObject;

            /**
             * Creates a new DepositCollectionMap instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.DepositCollectionMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IDepositCollectionMap=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.DepositCollectionMap} DepositCollectionMap instance
             */
            DepositCollectionMap.create = function create(properties) {
                return new DepositCollectionMap(properties);
            };

            /**
             * Encodes the specified DepositCollectionMap message. Does not implicitly {@link TCBReceiptApi.Protobuf.DepositCollectionMap.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.DepositCollectionMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IDepositCollectionMap} message DepositCollectionMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DepositCollectionMap.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.map != null && Object.hasOwnProperty.call(message, "map"))
                    for (var keys = Object.keys(message.map), i = 0; i < keys.length; ++i) {
                        writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                        $root.TCBReceiptApi.Protobuf.DepositCollection.encode(message.map[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                    }
                return writer;
            };

            /**
             * Encodes the specified DepositCollectionMap message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.DepositCollectionMap.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.DepositCollectionMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IDepositCollectionMap} message DepositCollectionMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DepositCollectionMap.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DepositCollectionMap message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.DepositCollectionMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.DepositCollectionMap} DepositCollectionMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DepositCollectionMap.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.DepositCollectionMap(), key, value;
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (message.map === $util.emptyObject)
                            message.map = {};
                        var end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = null;
                        while (reader.pos < end2) {
                            var tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = $root.TCBReceiptApi.Protobuf.DepositCollection.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.map[key] = value;
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DepositCollectionMap message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.DepositCollectionMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.DepositCollectionMap} DepositCollectionMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DepositCollectionMap.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DepositCollectionMap message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.DepositCollectionMap
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DepositCollectionMap.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.map != null && message.hasOwnProperty("map")) {
                    if (!$util.isObject(message.map))
                        return "map: object expected";
                    var key = Object.keys(message.map);
                    for (var i = 0; i < key.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.DepositCollection.verify(message.map[key[i]]);
                        if (error)
                            return "map." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a DepositCollectionMap message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.DepositCollectionMap
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.DepositCollectionMap} DepositCollectionMap
             */
            DepositCollectionMap.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.DepositCollectionMap)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.DepositCollectionMap();
                if (object.map) {
                    if (typeof object.map !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.DepositCollectionMap.map: object expected");
                    message.map = {};
                    for (var keys = Object.keys(object.map), i = 0; i < keys.length; ++i) {
                        if (typeof object.map[keys[i]] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.DepositCollectionMap.map: object expected");
                        message.map[keys[i]] = $root.TCBReceiptApi.Protobuf.DepositCollection.fromObject(object.map[keys[i]]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a DepositCollectionMap message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.DepositCollectionMap
             * @static
             * @param {TCBReceiptApi.Protobuf.DepositCollectionMap} message DepositCollectionMap
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DepositCollectionMap.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.objects || options.defaults)
                    object.map = {};
                var keys2;
                if (message.map && (keys2 = Object.keys(message.map)).length) {
                    object.map = {};
                    for (var j = 0; j < keys2.length; ++j)
                        object.map[keys2[j]] = $root.TCBReceiptApi.Protobuf.DepositCollection.toObject(message.map[keys2[j]], options);
                }
                return object;
            };

            /**
             * Converts this DepositCollectionMap to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.DepositCollectionMap
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DepositCollectionMap.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return DepositCollectionMap;
        })();

        Protobuf.DepositTotal = (function() {

            /**
             * Properties of a DepositTotal.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IDepositTotal
             * @property {number|null} [count] DepositTotal count
             * @property {number|null} [total] DepositTotal total
             */

            /**
             * Constructs a new DepositTotal.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a DepositTotal.
             * @implements IDepositTotal
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IDepositTotal=} [properties] Properties to set
             */
            function DepositTotal(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DepositTotal count.
             * @member {number} count
             * @memberof TCBReceiptApi.Protobuf.DepositTotal
             * @instance
             */
            DepositTotal.prototype.count = 0;

            /**
             * DepositTotal total.
             * @member {number} total
             * @memberof TCBReceiptApi.Protobuf.DepositTotal
             * @instance
             */
            DepositTotal.prototype.total = 0;

            /**
             * Creates a new DepositTotal instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.DepositTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.IDepositTotal=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.DepositTotal} DepositTotal instance
             */
            DepositTotal.create = function create(properties) {
                return new DepositTotal(properties);
            };

            /**
             * Encodes the specified DepositTotal message. Does not implicitly {@link TCBReceiptApi.Protobuf.DepositTotal.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.DepositTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.IDepositTotal} message DepositTotal message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DepositTotal.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.count != null && Object.hasOwnProperty.call(message, "count"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.count);
                if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                    writer.uint32(/* id 2, wireType 1 =*/17).double(message.total);
                return writer;
            };

            /**
             * Encodes the specified DepositTotal message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.DepositTotal.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.DepositTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.IDepositTotal} message DepositTotal message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DepositTotal.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DepositTotal message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.DepositTotal
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.DepositTotal} DepositTotal
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DepositTotal.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.DepositTotal();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.count = reader.int32();
                        break;
                    case 2:
                        message.total = reader.double();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DepositTotal message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.DepositTotal
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.DepositTotal} DepositTotal
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DepositTotal.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DepositTotal message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.DepositTotal
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DepositTotal.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.count != null && message.hasOwnProperty("count"))
                    if (!$util.isInteger(message.count))
                        return "count: integer expected";
                if (message.total != null && message.hasOwnProperty("total"))
                    if (typeof message.total !== "number")
                        return "total: number expected";
                return null;
            };

            /**
             * Creates a DepositTotal message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.DepositTotal
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.DepositTotal} DepositTotal
             */
            DepositTotal.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.DepositTotal)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.DepositTotal();
                if (object.count != null)
                    message.count = object.count | 0;
                if (object.total != null)
                    message.total = Number(object.total);
                return message;
            };

            /**
             * Creates a plain object from a DepositTotal message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.DepositTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.DepositTotal} message DepositTotal
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DepositTotal.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.count = 0;
                    object.total = 0;
                }
                if (message.count != null && message.hasOwnProperty("count"))
                    object.count = message.count;
                if (message.total != null && message.hasOwnProperty("total"))
                    object.total = options.json && !isFinite(message.total) ? String(message.total) : message.total;
                return object;
            };

            /**
             * Converts this DepositTotal to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.DepositTotal
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DepositTotal.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return DepositTotal;
        })();

        Protobuf.DepositQuery = (function() {

            /**
             * Properties of a DepositQuery.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IDepositQuery
             * @property {Array.<string>|null} [storeList] DepositQuery storeList
             * @property {string|null} [tidNumber] DepositQuery tidNumber
             * @property {string|null} [account] DepositQuery account
             * @property {number|null} [type] DepositQuery type
             * @property {string|null} [dateStart] DepositQuery dateStart
             * @property {string|null} [dateEnd] DepositQuery dateEnd
             * @property {string|null} [specificStore] DepositQuery specificStore
             * @property {string|null} [branchBankCode] DepositQuery branchBankCode
             */

            /**
             * Constructs a new DepositQuery.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a DepositQuery.
             * @implements IDepositQuery
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IDepositQuery=} [properties] Properties to set
             */
            function DepositQuery(properties) {
                this.storeList = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DepositQuery storeList.
             * @member {Array.<string>} storeList
             * @memberof TCBReceiptApi.Protobuf.DepositQuery
             * @instance
             */
            DepositQuery.prototype.storeList = $util.emptyArray;

            /**
             * DepositQuery tidNumber.
             * @member {string} tidNumber
             * @memberof TCBReceiptApi.Protobuf.DepositQuery
             * @instance
             */
            DepositQuery.prototype.tidNumber = "";

            /**
             * DepositQuery account.
             * @member {string} account
             * @memberof TCBReceiptApi.Protobuf.DepositQuery
             * @instance
             */
            DepositQuery.prototype.account = "";

            /**
             * DepositQuery type.
             * @member {number} type
             * @memberof TCBReceiptApi.Protobuf.DepositQuery
             * @instance
             */
            DepositQuery.prototype.type = 0;

            /**
             * DepositQuery dateStart.
             * @member {string} dateStart
             * @memberof TCBReceiptApi.Protobuf.DepositQuery
             * @instance
             */
            DepositQuery.prototype.dateStart = "";

            /**
             * DepositQuery dateEnd.
             * @member {string} dateEnd
             * @memberof TCBReceiptApi.Protobuf.DepositQuery
             * @instance
             */
            DepositQuery.prototype.dateEnd = "";

            /**
             * DepositQuery specificStore.
             * @member {string} specificStore
             * @memberof TCBReceiptApi.Protobuf.DepositQuery
             * @instance
             */
            DepositQuery.prototype.specificStore = "";

            /**
             * DepositQuery branchBankCode.
             * @member {string} branchBankCode
             * @memberof TCBReceiptApi.Protobuf.DepositQuery
             * @instance
             */
            DepositQuery.prototype.branchBankCode = "";

            /**
             * Creates a new DepositQuery instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.DepositQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.IDepositQuery=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.DepositQuery} DepositQuery instance
             */
            DepositQuery.create = function create(properties) {
                return new DepositQuery(properties);
            };

            /**
             * Encodes the specified DepositQuery message. Does not implicitly {@link TCBReceiptApi.Protobuf.DepositQuery.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.DepositQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.IDepositQuery} message DepositQuery message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DepositQuery.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.storeList != null && message.storeList.length)
                    for (var i = 0; i < message.storeList.length; ++i)
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.storeList[i]);
                if (message.tidNumber != null && Object.hasOwnProperty.call(message, "tidNumber"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.tidNumber);
                if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.account);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.type);
                if (message.dateStart != null && Object.hasOwnProperty.call(message, "dateStart"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.dateStart);
                if (message.dateEnd != null && Object.hasOwnProperty.call(message, "dateEnd"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.dateEnd);
                if (message.specificStore != null && Object.hasOwnProperty.call(message, "specificStore"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.specificStore);
                if (message.branchBankCode != null && Object.hasOwnProperty.call(message, "branchBankCode"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.branchBankCode);
                return writer;
            };

            /**
             * Encodes the specified DepositQuery message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.DepositQuery.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.DepositQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.IDepositQuery} message DepositQuery message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DepositQuery.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DepositQuery message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.DepositQuery
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.DepositQuery} DepositQuery
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DepositQuery.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.DepositQuery();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.storeList && message.storeList.length))
                            message.storeList = [];
                        message.storeList.push(reader.string());
                        break;
                    case 2:
                        message.tidNumber = reader.string();
                        break;
                    case 3:
                        message.account = reader.string();
                        break;
                    case 4:
                        message.type = reader.int32();
                        break;
                    case 5:
                        message.dateStart = reader.string();
                        break;
                    case 6:
                        message.dateEnd = reader.string();
                        break;
                    case 7:
                        message.specificStore = reader.string();
                        break;
                    case 8:
                        message.branchBankCode = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DepositQuery message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.DepositQuery
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.DepositQuery} DepositQuery
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DepositQuery.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DepositQuery message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.DepositQuery
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DepositQuery.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.storeList != null && message.hasOwnProperty("storeList")) {
                    if (!Array.isArray(message.storeList))
                        return "storeList: array expected";
                    for (var i = 0; i < message.storeList.length; ++i)
                        if (!$util.isString(message.storeList[i]))
                            return "storeList: string[] expected";
                }
                if (message.tidNumber != null && message.hasOwnProperty("tidNumber"))
                    if (!$util.isString(message.tidNumber))
                        return "tidNumber: string expected";
                if (message.account != null && message.hasOwnProperty("account"))
                    if (!$util.isString(message.account))
                        return "account: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isInteger(message.type))
                        return "type: integer expected";
                if (message.dateStart != null && message.hasOwnProperty("dateStart"))
                    if (!$util.isString(message.dateStart))
                        return "dateStart: string expected";
                if (message.dateEnd != null && message.hasOwnProperty("dateEnd"))
                    if (!$util.isString(message.dateEnd))
                        return "dateEnd: string expected";
                if (message.specificStore != null && message.hasOwnProperty("specificStore"))
                    if (!$util.isString(message.specificStore))
                        return "specificStore: string expected";
                if (message.branchBankCode != null && message.hasOwnProperty("branchBankCode"))
                    if (!$util.isString(message.branchBankCode))
                        return "branchBankCode: string expected";
                return null;
            };

            /**
             * Creates a DepositQuery message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.DepositQuery
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.DepositQuery} DepositQuery
             */
            DepositQuery.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.DepositQuery)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.DepositQuery();
                if (object.storeList) {
                    if (!Array.isArray(object.storeList))
                        throw TypeError(".TCBReceiptApi.Protobuf.DepositQuery.storeList: array expected");
                    message.storeList = [];
                    for (var i = 0; i < object.storeList.length; ++i)
                        message.storeList[i] = String(object.storeList[i]);
                }
                if (object.tidNumber != null)
                    message.tidNumber = String(object.tidNumber);
                if (object.account != null)
                    message.account = String(object.account);
                if (object.type != null)
                    message.type = object.type | 0;
                if (object.dateStart != null)
                    message.dateStart = String(object.dateStart);
                if (object.dateEnd != null)
                    message.dateEnd = String(object.dateEnd);
                if (object.specificStore != null)
                    message.specificStore = String(object.specificStore);
                if (object.branchBankCode != null)
                    message.branchBankCode = String(object.branchBankCode);
                return message;
            };

            /**
             * Creates a plain object from a DepositQuery message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.DepositQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.DepositQuery} message DepositQuery
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DepositQuery.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.storeList = [];
                if (options.defaults) {
                    object.tidNumber = "";
                    object.account = "";
                    object.type = 0;
                    object.dateStart = "";
                    object.dateEnd = "";
                    object.specificStore = "";
                    object.branchBankCode = "";
                }
                if (message.storeList && message.storeList.length) {
                    object.storeList = [];
                    for (var j = 0; j < message.storeList.length; ++j)
                        object.storeList[j] = message.storeList[j];
                }
                if (message.tidNumber != null && message.hasOwnProperty("tidNumber"))
                    object.tidNumber = message.tidNumber;
                if (message.account != null && message.hasOwnProperty("account"))
                    object.account = message.account;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.dateStart != null && message.hasOwnProperty("dateStart"))
                    object.dateStart = message.dateStart;
                if (message.dateEnd != null && message.hasOwnProperty("dateEnd"))
                    object.dateEnd = message.dateEnd;
                if (message.specificStore != null && message.hasOwnProperty("specificStore"))
                    object.specificStore = message.specificStore;
                if (message.branchBankCode != null && message.hasOwnProperty("branchBankCode"))
                    object.branchBankCode = message.branchBankCode;
                return object;
            };

            /**
             * Converts this DepositQuery to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.DepositQuery
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DepositQuery.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return DepositQuery;
        })();

        Protobuf.DepositSummaryByStoreExport = (function() {

            /**
             * Properties of a DepositSummaryByStoreExport.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IDepositSummaryByStoreExport
             * @property {string|null} [storeCode] DepositSummaryByStoreExport storeCode
             * @property {string|null} [registerName] DepositSummaryByStoreExport registerName
             * @property {string|null} [account] DepositSummaryByStoreExport account
             * @property {string|null} [date] DepositSummaryByStoreExport date
             * @property {string|null} [amount] DepositSummaryByStoreExport amount
             * @property {string|null} [charge] DepositSummaryByStoreExport charge
             * @property {string|null} [internalIfr] DepositSummaryByStoreExport internalIfr
             * @property {string|null} [externalIfr] DepositSummaryByStoreExport externalIfr
             * @property {string|null} [chargeTotal] DepositSummaryByStoreExport chargeTotal
             * @property {string|null} [netAmount] DepositSummaryByStoreExport netAmount
             * @property {string|null} [type] DepositSummaryByStoreExport type
             * @property {string|null} [remarksCode] DepositSummaryByStoreExport remarksCode
             * @property {string|null} [remarks] DepositSummaryByStoreExport remarks
             */

            /**
             * Constructs a new DepositSummaryByStoreExport.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a DepositSummaryByStoreExport.
             * @implements IDepositSummaryByStoreExport
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IDepositSummaryByStoreExport=} [properties] Properties to set
             */
            function DepositSummaryByStoreExport(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DepositSummaryByStoreExport storeCode.
             * @member {string} storeCode
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByStoreExport
             * @instance
             */
            DepositSummaryByStoreExport.prototype.storeCode = "";

            /**
             * DepositSummaryByStoreExport registerName.
             * @member {string} registerName
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByStoreExport
             * @instance
             */
            DepositSummaryByStoreExport.prototype.registerName = "";

            /**
             * DepositSummaryByStoreExport account.
             * @member {string} account
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByStoreExport
             * @instance
             */
            DepositSummaryByStoreExport.prototype.account = "";

            /**
             * DepositSummaryByStoreExport date.
             * @member {string} date
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByStoreExport
             * @instance
             */
            DepositSummaryByStoreExport.prototype.date = "";

            /**
             * DepositSummaryByStoreExport amount.
             * @member {string} amount
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByStoreExport
             * @instance
             */
            DepositSummaryByStoreExport.prototype.amount = "";

            /**
             * DepositSummaryByStoreExport charge.
             * @member {string} charge
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByStoreExport
             * @instance
             */
            DepositSummaryByStoreExport.prototype.charge = "";

            /**
             * DepositSummaryByStoreExport internalIfr.
             * @member {string} internalIfr
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByStoreExport
             * @instance
             */
            DepositSummaryByStoreExport.prototype.internalIfr = "";

            /**
             * DepositSummaryByStoreExport externalIfr.
             * @member {string} externalIfr
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByStoreExport
             * @instance
             */
            DepositSummaryByStoreExport.prototype.externalIfr = "";

            /**
             * DepositSummaryByStoreExport chargeTotal.
             * @member {string} chargeTotal
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByStoreExport
             * @instance
             */
            DepositSummaryByStoreExport.prototype.chargeTotal = "";

            /**
             * DepositSummaryByStoreExport netAmount.
             * @member {string} netAmount
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByStoreExport
             * @instance
             */
            DepositSummaryByStoreExport.prototype.netAmount = "";

            /**
             * DepositSummaryByStoreExport type.
             * @member {string} type
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByStoreExport
             * @instance
             */
            DepositSummaryByStoreExport.prototype.type = "";

            /**
             * DepositSummaryByStoreExport remarksCode.
             * @member {string} remarksCode
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByStoreExport
             * @instance
             */
            DepositSummaryByStoreExport.prototype.remarksCode = "";

            /**
             * DepositSummaryByStoreExport remarks.
             * @member {string} remarks
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByStoreExport
             * @instance
             */
            DepositSummaryByStoreExport.prototype.remarks = "";

            /**
             * Creates a new DepositSummaryByStoreExport instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByStoreExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IDepositSummaryByStoreExport=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.DepositSummaryByStoreExport} DepositSummaryByStoreExport instance
             */
            DepositSummaryByStoreExport.create = function create(properties) {
                return new DepositSummaryByStoreExport(properties);
            };

            /**
             * Encodes the specified DepositSummaryByStoreExport message. Does not implicitly {@link TCBReceiptApi.Protobuf.DepositSummaryByStoreExport.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByStoreExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IDepositSummaryByStoreExport} message DepositSummaryByStoreExport message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DepositSummaryByStoreExport.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.storeCode != null && Object.hasOwnProperty.call(message, "storeCode"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.storeCode);
                if (message.registerName != null && Object.hasOwnProperty.call(message, "registerName"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.registerName);
                if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.account);
                if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.date);
                if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.amount);
                if (message.charge != null && Object.hasOwnProperty.call(message, "charge"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.charge);
                if (message.internalIfr != null && Object.hasOwnProperty.call(message, "internalIfr"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.internalIfr);
                if (message.externalIfr != null && Object.hasOwnProperty.call(message, "externalIfr"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.externalIfr);
                if (message.chargeTotal != null && Object.hasOwnProperty.call(message, "chargeTotal"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.chargeTotal);
                if (message.netAmount != null && Object.hasOwnProperty.call(message, "netAmount"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.netAmount);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.type);
                if (message.remarksCode != null && Object.hasOwnProperty.call(message, "remarksCode"))
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.remarksCode);
                if (message.remarks != null && Object.hasOwnProperty.call(message, "remarks"))
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.remarks);
                return writer;
            };

            /**
             * Encodes the specified DepositSummaryByStoreExport message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.DepositSummaryByStoreExport.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByStoreExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IDepositSummaryByStoreExport} message DepositSummaryByStoreExport message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DepositSummaryByStoreExport.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DepositSummaryByStoreExport message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByStoreExport
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.DepositSummaryByStoreExport} DepositSummaryByStoreExport
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DepositSummaryByStoreExport.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.DepositSummaryByStoreExport();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.storeCode = reader.string();
                        break;
                    case 2:
                        message.registerName = reader.string();
                        break;
                    case 3:
                        message.account = reader.string();
                        break;
                    case 4:
                        message.date = reader.string();
                        break;
                    case 5:
                        message.amount = reader.string();
                        break;
                    case 6:
                        message.charge = reader.string();
                        break;
                    case 7:
                        message.internalIfr = reader.string();
                        break;
                    case 8:
                        message.externalIfr = reader.string();
                        break;
                    case 9:
                        message.chargeTotal = reader.string();
                        break;
                    case 10:
                        message.netAmount = reader.string();
                        break;
                    case 11:
                        message.type = reader.string();
                        break;
                    case 12:
                        message.remarksCode = reader.string();
                        break;
                    case 13:
                        message.remarks = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DepositSummaryByStoreExport message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByStoreExport
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.DepositSummaryByStoreExport} DepositSummaryByStoreExport
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DepositSummaryByStoreExport.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DepositSummaryByStoreExport message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByStoreExport
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DepositSummaryByStoreExport.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    if (!$util.isString(message.storeCode))
                        return "storeCode: string expected";
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    if (!$util.isString(message.registerName))
                        return "registerName: string expected";
                if (message.account != null && message.hasOwnProperty("account"))
                    if (!$util.isString(message.account))
                        return "account: string expected";
                if (message.date != null && message.hasOwnProperty("date"))
                    if (!$util.isString(message.date))
                        return "date: string expected";
                if (message.amount != null && message.hasOwnProperty("amount"))
                    if (!$util.isString(message.amount))
                        return "amount: string expected";
                if (message.charge != null && message.hasOwnProperty("charge"))
                    if (!$util.isString(message.charge))
                        return "charge: string expected";
                if (message.internalIfr != null && message.hasOwnProperty("internalIfr"))
                    if (!$util.isString(message.internalIfr))
                        return "internalIfr: string expected";
                if (message.externalIfr != null && message.hasOwnProperty("externalIfr"))
                    if (!$util.isString(message.externalIfr))
                        return "externalIfr: string expected";
                if (message.chargeTotal != null && message.hasOwnProperty("chargeTotal"))
                    if (!$util.isString(message.chargeTotal))
                        return "chargeTotal: string expected";
                if (message.netAmount != null && message.hasOwnProperty("netAmount"))
                    if (!$util.isString(message.netAmount))
                        return "netAmount: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                if (message.remarksCode != null && message.hasOwnProperty("remarksCode"))
                    if (!$util.isString(message.remarksCode))
                        return "remarksCode: string expected";
                if (message.remarks != null && message.hasOwnProperty("remarks"))
                    if (!$util.isString(message.remarks))
                        return "remarks: string expected";
                return null;
            };

            /**
             * Creates a DepositSummaryByStoreExport message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByStoreExport
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.DepositSummaryByStoreExport} DepositSummaryByStoreExport
             */
            DepositSummaryByStoreExport.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.DepositSummaryByStoreExport)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.DepositSummaryByStoreExport();
                if (object.storeCode != null)
                    message.storeCode = String(object.storeCode);
                if (object.registerName != null)
                    message.registerName = String(object.registerName);
                if (object.account != null)
                    message.account = String(object.account);
                if (object.date != null)
                    message.date = String(object.date);
                if (object.amount != null)
                    message.amount = String(object.amount);
                if (object.charge != null)
                    message.charge = String(object.charge);
                if (object.internalIfr != null)
                    message.internalIfr = String(object.internalIfr);
                if (object.externalIfr != null)
                    message.externalIfr = String(object.externalIfr);
                if (object.chargeTotal != null)
                    message.chargeTotal = String(object.chargeTotal);
                if (object.netAmount != null)
                    message.netAmount = String(object.netAmount);
                if (object.type != null)
                    message.type = String(object.type);
                if (object.remarksCode != null)
                    message.remarksCode = String(object.remarksCode);
                if (object.remarks != null)
                    message.remarks = String(object.remarks);
                return message;
            };

            /**
             * Creates a plain object from a DepositSummaryByStoreExport message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByStoreExport
             * @static
             * @param {TCBReceiptApi.Protobuf.DepositSummaryByStoreExport} message DepositSummaryByStoreExport
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DepositSummaryByStoreExport.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.storeCode = "";
                    object.registerName = "";
                    object.account = "";
                    object.date = "";
                    object.amount = "";
                    object.charge = "";
                    object.internalIfr = "";
                    object.externalIfr = "";
                    object.chargeTotal = "";
                    object.netAmount = "";
                    object.type = "";
                    object.remarksCode = "";
                    object.remarks = "";
                }
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    object.storeCode = message.storeCode;
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    object.registerName = message.registerName;
                if (message.account != null && message.hasOwnProperty("account"))
                    object.account = message.account;
                if (message.date != null && message.hasOwnProperty("date"))
                    object.date = message.date;
                if (message.amount != null && message.hasOwnProperty("amount"))
                    object.amount = message.amount;
                if (message.charge != null && message.hasOwnProperty("charge"))
                    object.charge = message.charge;
                if (message.internalIfr != null && message.hasOwnProperty("internalIfr"))
                    object.internalIfr = message.internalIfr;
                if (message.externalIfr != null && message.hasOwnProperty("externalIfr"))
                    object.externalIfr = message.externalIfr;
                if (message.chargeTotal != null && message.hasOwnProperty("chargeTotal"))
                    object.chargeTotal = message.chargeTotal;
                if (message.netAmount != null && message.hasOwnProperty("netAmount"))
                    object.netAmount = message.netAmount;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.remarksCode != null && message.hasOwnProperty("remarksCode"))
                    object.remarksCode = message.remarksCode;
                if (message.remarks != null && message.hasOwnProperty("remarks"))
                    object.remarks = message.remarks;
                return object;
            };

            /**
             * Converts this DepositSummaryByStoreExport to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByStoreExport
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DepositSummaryByStoreExport.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return DepositSummaryByStoreExport;
        })();

        Protobuf.DepositSummaryByAccountExport = (function() {

            /**
             * Properties of a DepositSummaryByAccountExport.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IDepositSummaryByAccountExport
             * @property {string|null} [account] DepositSummaryByAccountExport account
             * @property {string|null} [date] DepositSummaryByAccountExport date
             * @property {string|null} [storeCode] DepositSummaryByAccountExport storeCode
             * @property {string|null} [registerName] DepositSummaryByAccountExport registerName
             * @property {string|null} [amount] DepositSummaryByAccountExport amount
             * @property {string|null} [charge] DepositSummaryByAccountExport charge
             * @property {string|null} [internalIfr] DepositSummaryByAccountExport internalIfr
             * @property {string|null} [externalIfr] DepositSummaryByAccountExport externalIfr
             * @property {string|null} [chargeTotal] DepositSummaryByAccountExport chargeTotal
             * @property {string|null} [netAmount] DepositSummaryByAccountExport netAmount
             * @property {string|null} [type] DepositSummaryByAccountExport type
             * @property {string|null} [remarksCode] DepositSummaryByAccountExport remarksCode
             * @property {string|null} [remarks] DepositSummaryByAccountExport remarks
             */

            /**
             * Constructs a new DepositSummaryByAccountExport.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a DepositSummaryByAccountExport.
             * @implements IDepositSummaryByAccountExport
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IDepositSummaryByAccountExport=} [properties] Properties to set
             */
            function DepositSummaryByAccountExport(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DepositSummaryByAccountExport account.
             * @member {string} account
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByAccountExport
             * @instance
             */
            DepositSummaryByAccountExport.prototype.account = "";

            /**
             * DepositSummaryByAccountExport date.
             * @member {string} date
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByAccountExport
             * @instance
             */
            DepositSummaryByAccountExport.prototype.date = "";

            /**
             * DepositSummaryByAccountExport storeCode.
             * @member {string} storeCode
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByAccountExport
             * @instance
             */
            DepositSummaryByAccountExport.prototype.storeCode = "";

            /**
             * DepositSummaryByAccountExport registerName.
             * @member {string} registerName
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByAccountExport
             * @instance
             */
            DepositSummaryByAccountExport.prototype.registerName = "";

            /**
             * DepositSummaryByAccountExport amount.
             * @member {string} amount
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByAccountExport
             * @instance
             */
            DepositSummaryByAccountExport.prototype.amount = "";

            /**
             * DepositSummaryByAccountExport charge.
             * @member {string} charge
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByAccountExport
             * @instance
             */
            DepositSummaryByAccountExport.prototype.charge = "";

            /**
             * DepositSummaryByAccountExport internalIfr.
             * @member {string} internalIfr
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByAccountExport
             * @instance
             */
            DepositSummaryByAccountExport.prototype.internalIfr = "";

            /**
             * DepositSummaryByAccountExport externalIfr.
             * @member {string} externalIfr
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByAccountExport
             * @instance
             */
            DepositSummaryByAccountExport.prototype.externalIfr = "";

            /**
             * DepositSummaryByAccountExport chargeTotal.
             * @member {string} chargeTotal
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByAccountExport
             * @instance
             */
            DepositSummaryByAccountExport.prototype.chargeTotal = "";

            /**
             * DepositSummaryByAccountExport netAmount.
             * @member {string} netAmount
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByAccountExport
             * @instance
             */
            DepositSummaryByAccountExport.prototype.netAmount = "";

            /**
             * DepositSummaryByAccountExport type.
             * @member {string} type
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByAccountExport
             * @instance
             */
            DepositSummaryByAccountExport.prototype.type = "";

            /**
             * DepositSummaryByAccountExport remarksCode.
             * @member {string} remarksCode
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByAccountExport
             * @instance
             */
            DepositSummaryByAccountExport.prototype.remarksCode = "";

            /**
             * DepositSummaryByAccountExport remarks.
             * @member {string} remarks
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByAccountExport
             * @instance
             */
            DepositSummaryByAccountExport.prototype.remarks = "";

            /**
             * Creates a new DepositSummaryByAccountExport instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByAccountExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IDepositSummaryByAccountExport=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.DepositSummaryByAccountExport} DepositSummaryByAccountExport instance
             */
            DepositSummaryByAccountExport.create = function create(properties) {
                return new DepositSummaryByAccountExport(properties);
            };

            /**
             * Encodes the specified DepositSummaryByAccountExport message. Does not implicitly {@link TCBReceiptApi.Protobuf.DepositSummaryByAccountExport.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByAccountExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IDepositSummaryByAccountExport} message DepositSummaryByAccountExport message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DepositSummaryByAccountExport.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.account);
                if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.date);
                if (message.storeCode != null && Object.hasOwnProperty.call(message, "storeCode"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.storeCode);
                if (message.registerName != null && Object.hasOwnProperty.call(message, "registerName"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.registerName);
                if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.amount);
                if (message.charge != null && Object.hasOwnProperty.call(message, "charge"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.charge);
                if (message.internalIfr != null && Object.hasOwnProperty.call(message, "internalIfr"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.internalIfr);
                if (message.externalIfr != null && Object.hasOwnProperty.call(message, "externalIfr"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.externalIfr);
                if (message.chargeTotal != null && Object.hasOwnProperty.call(message, "chargeTotal"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.chargeTotal);
                if (message.netAmount != null && Object.hasOwnProperty.call(message, "netAmount"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.netAmount);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.type);
                if (message.remarksCode != null && Object.hasOwnProperty.call(message, "remarksCode"))
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.remarksCode);
                if (message.remarks != null && Object.hasOwnProperty.call(message, "remarks"))
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.remarks);
                return writer;
            };

            /**
             * Encodes the specified DepositSummaryByAccountExport message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.DepositSummaryByAccountExport.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByAccountExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IDepositSummaryByAccountExport} message DepositSummaryByAccountExport message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DepositSummaryByAccountExport.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DepositSummaryByAccountExport message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByAccountExport
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.DepositSummaryByAccountExport} DepositSummaryByAccountExport
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DepositSummaryByAccountExport.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.DepositSummaryByAccountExport();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.account = reader.string();
                        break;
                    case 2:
                        message.date = reader.string();
                        break;
                    case 3:
                        message.storeCode = reader.string();
                        break;
                    case 4:
                        message.registerName = reader.string();
                        break;
                    case 5:
                        message.amount = reader.string();
                        break;
                    case 6:
                        message.charge = reader.string();
                        break;
                    case 7:
                        message.internalIfr = reader.string();
                        break;
                    case 8:
                        message.externalIfr = reader.string();
                        break;
                    case 9:
                        message.chargeTotal = reader.string();
                        break;
                    case 10:
                        message.netAmount = reader.string();
                        break;
                    case 11:
                        message.type = reader.string();
                        break;
                    case 12:
                        message.remarksCode = reader.string();
                        break;
                    case 13:
                        message.remarks = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DepositSummaryByAccountExport message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByAccountExport
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.DepositSummaryByAccountExport} DepositSummaryByAccountExport
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DepositSummaryByAccountExport.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DepositSummaryByAccountExport message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByAccountExport
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DepositSummaryByAccountExport.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.account != null && message.hasOwnProperty("account"))
                    if (!$util.isString(message.account))
                        return "account: string expected";
                if (message.date != null && message.hasOwnProperty("date"))
                    if (!$util.isString(message.date))
                        return "date: string expected";
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    if (!$util.isString(message.storeCode))
                        return "storeCode: string expected";
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    if (!$util.isString(message.registerName))
                        return "registerName: string expected";
                if (message.amount != null && message.hasOwnProperty("amount"))
                    if (!$util.isString(message.amount))
                        return "amount: string expected";
                if (message.charge != null && message.hasOwnProperty("charge"))
                    if (!$util.isString(message.charge))
                        return "charge: string expected";
                if (message.internalIfr != null && message.hasOwnProperty("internalIfr"))
                    if (!$util.isString(message.internalIfr))
                        return "internalIfr: string expected";
                if (message.externalIfr != null && message.hasOwnProperty("externalIfr"))
                    if (!$util.isString(message.externalIfr))
                        return "externalIfr: string expected";
                if (message.chargeTotal != null && message.hasOwnProperty("chargeTotal"))
                    if (!$util.isString(message.chargeTotal))
                        return "chargeTotal: string expected";
                if (message.netAmount != null && message.hasOwnProperty("netAmount"))
                    if (!$util.isString(message.netAmount))
                        return "netAmount: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                if (message.remarksCode != null && message.hasOwnProperty("remarksCode"))
                    if (!$util.isString(message.remarksCode))
                        return "remarksCode: string expected";
                if (message.remarks != null && message.hasOwnProperty("remarks"))
                    if (!$util.isString(message.remarks))
                        return "remarks: string expected";
                return null;
            };

            /**
             * Creates a DepositSummaryByAccountExport message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByAccountExport
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.DepositSummaryByAccountExport} DepositSummaryByAccountExport
             */
            DepositSummaryByAccountExport.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.DepositSummaryByAccountExport)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.DepositSummaryByAccountExport();
                if (object.account != null)
                    message.account = String(object.account);
                if (object.date != null)
                    message.date = String(object.date);
                if (object.storeCode != null)
                    message.storeCode = String(object.storeCode);
                if (object.registerName != null)
                    message.registerName = String(object.registerName);
                if (object.amount != null)
                    message.amount = String(object.amount);
                if (object.charge != null)
                    message.charge = String(object.charge);
                if (object.internalIfr != null)
                    message.internalIfr = String(object.internalIfr);
                if (object.externalIfr != null)
                    message.externalIfr = String(object.externalIfr);
                if (object.chargeTotal != null)
                    message.chargeTotal = String(object.chargeTotal);
                if (object.netAmount != null)
                    message.netAmount = String(object.netAmount);
                if (object.type != null)
                    message.type = String(object.type);
                if (object.remarksCode != null)
                    message.remarksCode = String(object.remarksCode);
                if (object.remarks != null)
                    message.remarks = String(object.remarks);
                return message;
            };

            /**
             * Creates a plain object from a DepositSummaryByAccountExport message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByAccountExport
             * @static
             * @param {TCBReceiptApi.Protobuf.DepositSummaryByAccountExport} message DepositSummaryByAccountExport
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DepositSummaryByAccountExport.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.account = "";
                    object.date = "";
                    object.storeCode = "";
                    object.registerName = "";
                    object.amount = "";
                    object.charge = "";
                    object.internalIfr = "";
                    object.externalIfr = "";
                    object.chargeTotal = "";
                    object.netAmount = "";
                    object.type = "";
                    object.remarksCode = "";
                    object.remarks = "";
                }
                if (message.account != null && message.hasOwnProperty("account"))
                    object.account = message.account;
                if (message.date != null && message.hasOwnProperty("date"))
                    object.date = message.date;
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    object.storeCode = message.storeCode;
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    object.registerName = message.registerName;
                if (message.amount != null && message.hasOwnProperty("amount"))
                    object.amount = message.amount;
                if (message.charge != null && message.hasOwnProperty("charge"))
                    object.charge = message.charge;
                if (message.internalIfr != null && message.hasOwnProperty("internalIfr"))
                    object.internalIfr = message.internalIfr;
                if (message.externalIfr != null && message.hasOwnProperty("externalIfr"))
                    object.externalIfr = message.externalIfr;
                if (message.chargeTotal != null && message.hasOwnProperty("chargeTotal"))
                    object.chargeTotal = message.chargeTotal;
                if (message.netAmount != null && message.hasOwnProperty("netAmount"))
                    object.netAmount = message.netAmount;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.remarksCode != null && message.hasOwnProperty("remarksCode"))
                    object.remarksCode = message.remarksCode;
                if (message.remarks != null && message.hasOwnProperty("remarks"))
                    object.remarks = message.remarks;
                return object;
            };

            /**
             * Converts this DepositSummaryByAccountExport to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.DepositSummaryByAccountExport
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DepositSummaryByAccountExport.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return DepositSummaryByAccountExport;
        })();

        /**
         * CreatedMethod enum.
         * @name TCBReceiptApi.Protobuf.CreatedMethod
         * @enum {number}
         * @property {number} CM_NONE=0 CM_NONE value
         * @property {number} CM_SCHEDULE=1 CM_SCHEDULE value
         * @property {number} CM_MANUAL_CRD=2 CM_MANUAL_CRD value
         * @property {number} CM_MANUAL_CRD_FORCE=3 CM_MANUAL_CRD_FORCE value
         * @property {number} CM_MANUAL_NOT_CRD_FORCE=4 CM_MANUAL_NOT_CRD_FORCE value
         * @property {number} CM_EBILLING=5 CM_EBILLING value
         * @property {number} CM_ALIPAY=6 CM_ALIPAY value
         */
        Protobuf.CreatedMethod = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "CM_NONE"] = 0;
            values[valuesById[1] = "CM_SCHEDULE"] = 1;
            values[valuesById[2] = "CM_MANUAL_CRD"] = 2;
            values[valuesById[3] = "CM_MANUAL_CRD_FORCE"] = 3;
            values[valuesById[4] = "CM_MANUAL_NOT_CRD_FORCE"] = 4;
            values[valuesById[5] = "CM_EBILLING"] = 5;
            values[valuesById[6] = "CM_ALIPAY"] = 6;
            return values;
        })();

        /**
         * ReceiptCheckPoint enum.
         * @name TCBReceiptApi.Protobuf.ReceiptCheckPoint
         * @enum {number}
         * @property {number} RCP_NONE=0 RCP_NONE value
         * @property {number} RCP_GENERATE_FILE=1 RCP_GENERATE_FILE value
         * @property {number} RCP_UPDATE_LAST_TIME=2 RCP_UPDATE_LAST_TIME value
         * @property {number} RCP_INSERT_INTO_MEMORANDUMBOOK=3 RCP_INSERT_INTO_MEMORANDUMBOOK value
         * @property {number} RCP_FAILED_RETRY=99 RCP_FAILED_RETRY value
         */
        Protobuf.ReceiptCheckPoint = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "RCP_NONE"] = 0;
            values[valuesById[1] = "RCP_GENERATE_FILE"] = 1;
            values[valuesById[2] = "RCP_UPDATE_LAST_TIME"] = 2;
            values[valuesById[3] = "RCP_INSERT_INTO_MEMORANDUMBOOK"] = 3;
            values[valuesById[99] = "RCP_FAILED_RETRY"] = 99;
            return values;
        })();

        Protobuf.Sup = (function() {

            /**
             * Properties of a Sup.
             * @memberof TCBReceiptApi.Protobuf
             * @interface ISup
             * @property {string|null} [dataStatus] Sup dataStatus
             * @property {string|null} [retailerId] Sup retailerId
             * @property {string|null} [supplierCode] Sup supplierCode
             * @property {string|null} [supplierName] Sup supplierName
             * @property {string|null} [ban] Sup ban
             * @property {string|null} [invoiceTitle] Sup invoiceTitle
             * @property {string|null} [invoiceAddress] Sup invoiceAddress
             */

            /**
             * Constructs a new Sup.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a Sup.
             * @implements ISup
             * @constructor
             * @param {TCBReceiptApi.Protobuf.ISup=} [properties] Properties to set
             */
            function Sup(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Sup dataStatus.
             * @member {string} dataStatus
             * @memberof TCBReceiptApi.Protobuf.Sup
             * @instance
             */
            Sup.prototype.dataStatus = "";

            /**
             * Sup retailerId.
             * @member {string} retailerId
             * @memberof TCBReceiptApi.Protobuf.Sup
             * @instance
             */
            Sup.prototype.retailerId = "";

            /**
             * Sup supplierCode.
             * @member {string} supplierCode
             * @memberof TCBReceiptApi.Protobuf.Sup
             * @instance
             */
            Sup.prototype.supplierCode = "";

            /**
             * Sup supplierName.
             * @member {string} supplierName
             * @memberof TCBReceiptApi.Protobuf.Sup
             * @instance
             */
            Sup.prototype.supplierName = "";

            /**
             * Sup ban.
             * @member {string} ban
             * @memberof TCBReceiptApi.Protobuf.Sup
             * @instance
             */
            Sup.prototype.ban = "";

            /**
             * Sup invoiceTitle.
             * @member {string} invoiceTitle
             * @memberof TCBReceiptApi.Protobuf.Sup
             * @instance
             */
            Sup.prototype.invoiceTitle = "";

            /**
             * Sup invoiceAddress.
             * @member {string} invoiceAddress
             * @memberof TCBReceiptApi.Protobuf.Sup
             * @instance
             */
            Sup.prototype.invoiceAddress = "";

            /**
             * Creates a new Sup instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.Sup
             * @static
             * @param {TCBReceiptApi.Protobuf.ISup=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.Sup} Sup instance
             */
            Sup.create = function create(properties) {
                return new Sup(properties);
            };

            /**
             * Encodes the specified Sup message. Does not implicitly {@link TCBReceiptApi.Protobuf.Sup.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.Sup
             * @static
             * @param {TCBReceiptApi.Protobuf.ISup} message Sup message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Sup.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.dataStatus != null && Object.hasOwnProperty.call(message, "dataStatus"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.dataStatus);
                if (message.retailerId != null && Object.hasOwnProperty.call(message, "retailerId"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.retailerId);
                if (message.supplierCode != null && Object.hasOwnProperty.call(message, "supplierCode"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.supplierCode);
                if (message.supplierName != null && Object.hasOwnProperty.call(message, "supplierName"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.supplierName);
                if (message.ban != null && Object.hasOwnProperty.call(message, "ban"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.ban);
                if (message.invoiceTitle != null && Object.hasOwnProperty.call(message, "invoiceTitle"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.invoiceTitle);
                if (message.invoiceAddress != null && Object.hasOwnProperty.call(message, "invoiceAddress"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.invoiceAddress);
                return writer;
            };

            /**
             * Encodes the specified Sup message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.Sup.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.Sup
             * @static
             * @param {TCBReceiptApi.Protobuf.ISup} message Sup message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Sup.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Sup message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.Sup
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.Sup} Sup
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Sup.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.Sup();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.dataStatus = reader.string();
                        break;
                    case 2:
                        message.retailerId = reader.string();
                        break;
                    case 3:
                        message.supplierCode = reader.string();
                        break;
                    case 4:
                        message.supplierName = reader.string();
                        break;
                    case 5:
                        message.ban = reader.string();
                        break;
                    case 6:
                        message.invoiceTitle = reader.string();
                        break;
                    case 7:
                        message.invoiceAddress = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Sup message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.Sup
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.Sup} Sup
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Sup.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Sup message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.Sup
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Sup.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.dataStatus != null && message.hasOwnProperty("dataStatus"))
                    if (!$util.isString(message.dataStatus))
                        return "dataStatus: string expected";
                if (message.retailerId != null && message.hasOwnProperty("retailerId"))
                    if (!$util.isString(message.retailerId))
                        return "retailerId: string expected";
                if (message.supplierCode != null && message.hasOwnProperty("supplierCode"))
                    if (!$util.isString(message.supplierCode))
                        return "supplierCode: string expected";
                if (message.supplierName != null && message.hasOwnProperty("supplierName"))
                    if (!$util.isString(message.supplierName))
                        return "supplierName: string expected";
                if (message.ban != null && message.hasOwnProperty("ban"))
                    if (!$util.isString(message.ban))
                        return "ban: string expected";
                if (message.invoiceTitle != null && message.hasOwnProperty("invoiceTitle"))
                    if (!$util.isString(message.invoiceTitle))
                        return "invoiceTitle: string expected";
                if (message.invoiceAddress != null && message.hasOwnProperty("invoiceAddress"))
                    if (!$util.isString(message.invoiceAddress))
                        return "invoiceAddress: string expected";
                return null;
            };

            /**
             * Creates a Sup message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.Sup
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.Sup} Sup
             */
            Sup.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.Sup)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.Sup();
                if (object.dataStatus != null)
                    message.dataStatus = String(object.dataStatus);
                if (object.retailerId != null)
                    message.retailerId = String(object.retailerId);
                if (object.supplierCode != null)
                    message.supplierCode = String(object.supplierCode);
                if (object.supplierName != null)
                    message.supplierName = String(object.supplierName);
                if (object.ban != null)
                    message.ban = String(object.ban);
                if (object.invoiceTitle != null)
                    message.invoiceTitle = String(object.invoiceTitle);
                if (object.invoiceAddress != null)
                    message.invoiceAddress = String(object.invoiceAddress);
                return message;
            };

            /**
             * Creates a plain object from a Sup message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.Sup
             * @static
             * @param {TCBReceiptApi.Protobuf.Sup} message Sup
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Sup.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.dataStatus = "";
                    object.retailerId = "";
                    object.supplierCode = "";
                    object.supplierName = "";
                    object.ban = "";
                    object.invoiceTitle = "";
                    object.invoiceAddress = "";
                }
                if (message.dataStatus != null && message.hasOwnProperty("dataStatus"))
                    object.dataStatus = message.dataStatus;
                if (message.retailerId != null && message.hasOwnProperty("retailerId"))
                    object.retailerId = message.retailerId;
                if (message.supplierCode != null && message.hasOwnProperty("supplierCode"))
                    object.supplierCode = message.supplierCode;
                if (message.supplierName != null && message.hasOwnProperty("supplierName"))
                    object.supplierName = message.supplierName;
                if (message.ban != null && message.hasOwnProperty("ban"))
                    object.ban = message.ban;
                if (message.invoiceTitle != null && message.hasOwnProperty("invoiceTitle"))
                    object.invoiceTitle = message.invoiceTitle;
                if (message.invoiceAddress != null && message.hasOwnProperty("invoiceAddress"))
                    object.invoiceAddress = message.invoiceAddress;
                return object;
            };

            /**
             * Converts this Sup to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.Sup
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Sup.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Sup;
        })();

        Protobuf.User = (function() {

            /**
             * Properties of a User.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IUser
             * @property {string|null} [dataStatus] User dataStatus
             * @property {string|null} [retailerId] User retailerId
             * @property {string|null} [userCode] User userCode
             * @property {string|null} [userName] User userName
             * @property {string|null} [ban] User ban
             */

            /**
             * Constructs a new User.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a User.
             * @implements IUser
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IUser=} [properties] Properties to set
             */
            function User(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * User dataStatus.
             * @member {string} dataStatus
             * @memberof TCBReceiptApi.Protobuf.User
             * @instance
             */
            User.prototype.dataStatus = "";

            /**
             * User retailerId.
             * @member {string} retailerId
             * @memberof TCBReceiptApi.Protobuf.User
             * @instance
             */
            User.prototype.retailerId = "";

            /**
             * User userCode.
             * @member {string} userCode
             * @memberof TCBReceiptApi.Protobuf.User
             * @instance
             */
            User.prototype.userCode = "";

            /**
             * User userName.
             * @member {string} userName
             * @memberof TCBReceiptApi.Protobuf.User
             * @instance
             */
            User.prototype.userName = "";

            /**
             * User ban.
             * @member {string} ban
             * @memberof TCBReceiptApi.Protobuf.User
             * @instance
             */
            User.prototype.ban = "";

            /**
             * Creates a new User instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.User
             * @static
             * @param {TCBReceiptApi.Protobuf.IUser=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.User} User instance
             */
            User.create = function create(properties) {
                return new User(properties);
            };

            /**
             * Encodes the specified User message. Does not implicitly {@link TCBReceiptApi.Protobuf.User.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.User
             * @static
             * @param {TCBReceiptApi.Protobuf.IUser} message User message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            User.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.dataStatus != null && Object.hasOwnProperty.call(message, "dataStatus"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.dataStatus);
                if (message.retailerId != null && Object.hasOwnProperty.call(message, "retailerId"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.retailerId);
                if (message.userCode != null && Object.hasOwnProperty.call(message, "userCode"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.userCode);
                if (message.userName != null && Object.hasOwnProperty.call(message, "userName"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.userName);
                if (message.ban != null && Object.hasOwnProperty.call(message, "ban"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.ban);
                return writer;
            };

            /**
             * Encodes the specified User message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.User.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.User
             * @static
             * @param {TCBReceiptApi.Protobuf.IUser} message User message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            User.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a User message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.User
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.User} User
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            User.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.User();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.dataStatus = reader.string();
                        break;
                    case 2:
                        message.retailerId = reader.string();
                        break;
                    case 3:
                        message.userCode = reader.string();
                        break;
                    case 4:
                        message.userName = reader.string();
                        break;
                    case 5:
                        message.ban = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a User message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.User
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.User} User
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            User.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a User message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.User
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            User.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.dataStatus != null && message.hasOwnProperty("dataStatus"))
                    if (!$util.isString(message.dataStatus))
                        return "dataStatus: string expected";
                if (message.retailerId != null && message.hasOwnProperty("retailerId"))
                    if (!$util.isString(message.retailerId))
                        return "retailerId: string expected";
                if (message.userCode != null && message.hasOwnProperty("userCode"))
                    if (!$util.isString(message.userCode))
                        return "userCode: string expected";
                if (message.userName != null && message.hasOwnProperty("userName"))
                    if (!$util.isString(message.userName))
                        return "userName: string expected";
                if (message.ban != null && message.hasOwnProperty("ban"))
                    if (!$util.isString(message.ban))
                        return "ban: string expected";
                return null;
            };

            /**
             * Creates a User message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.User
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.User} User
             */
            User.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.User)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.User();
                if (object.dataStatus != null)
                    message.dataStatus = String(object.dataStatus);
                if (object.retailerId != null)
                    message.retailerId = String(object.retailerId);
                if (object.userCode != null)
                    message.userCode = String(object.userCode);
                if (object.userName != null)
                    message.userName = String(object.userName);
                if (object.ban != null)
                    message.ban = String(object.ban);
                return message;
            };

            /**
             * Creates a plain object from a User message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.User
             * @static
             * @param {TCBReceiptApi.Protobuf.User} message User
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            User.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.dataStatus = "";
                    object.retailerId = "";
                    object.userCode = "";
                    object.userName = "";
                    object.ban = "";
                }
                if (message.dataStatus != null && message.hasOwnProperty("dataStatus"))
                    object.dataStatus = message.dataStatus;
                if (message.retailerId != null && message.hasOwnProperty("retailerId"))
                    object.retailerId = message.retailerId;
                if (message.userCode != null && message.hasOwnProperty("userCode"))
                    object.userCode = message.userCode;
                if (message.userName != null && message.hasOwnProperty("userName"))
                    object.userName = message.userName;
                if (message.ban != null && message.hasOwnProperty("ban"))
                    object.ban = message.ban;
                return object;
            };

            /**
             * Converts this User to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.User
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            User.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return User;
        })();

        Protobuf.Access = (function() {

            /**
             * Properties of an Access.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAccess
             * @property {string|null} [dataStatus] Access dataStatus
             * @property {string|null} [retailerId] Access retailerId
             * @property {string|null} [userCode] Access userCode
             * @property {string|null} [supplierCode] Access supplierCode
             */

            /**
             * Constructs a new Access.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an Access.
             * @implements IAccess
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAccess=} [properties] Properties to set
             */
            function Access(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Access dataStatus.
             * @member {string} dataStatus
             * @memberof TCBReceiptApi.Protobuf.Access
             * @instance
             */
            Access.prototype.dataStatus = "";

            /**
             * Access retailerId.
             * @member {string} retailerId
             * @memberof TCBReceiptApi.Protobuf.Access
             * @instance
             */
            Access.prototype.retailerId = "";

            /**
             * Access userCode.
             * @member {string} userCode
             * @memberof TCBReceiptApi.Protobuf.Access
             * @instance
             */
            Access.prototype.userCode = "";

            /**
             * Access supplierCode.
             * @member {string} supplierCode
             * @memberof TCBReceiptApi.Protobuf.Access
             * @instance
             */
            Access.prototype.supplierCode = "";

            /**
             * Creates a new Access instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.Access
             * @static
             * @param {TCBReceiptApi.Protobuf.IAccess=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.Access} Access instance
             */
            Access.create = function create(properties) {
                return new Access(properties);
            };

            /**
             * Encodes the specified Access message. Does not implicitly {@link TCBReceiptApi.Protobuf.Access.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.Access
             * @static
             * @param {TCBReceiptApi.Protobuf.IAccess} message Access message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Access.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.dataStatus != null && Object.hasOwnProperty.call(message, "dataStatus"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.dataStatus);
                if (message.retailerId != null && Object.hasOwnProperty.call(message, "retailerId"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.retailerId);
                if (message.userCode != null && Object.hasOwnProperty.call(message, "userCode"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.userCode);
                if (message.supplierCode != null && Object.hasOwnProperty.call(message, "supplierCode"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.supplierCode);
                return writer;
            };

            /**
             * Encodes the specified Access message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.Access.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.Access
             * @static
             * @param {TCBReceiptApi.Protobuf.IAccess} message Access message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Access.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Access message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.Access
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.Access} Access
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Access.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.Access();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.dataStatus = reader.string();
                        break;
                    case 2:
                        message.retailerId = reader.string();
                        break;
                    case 3:
                        message.userCode = reader.string();
                        break;
                    case 4:
                        message.supplierCode = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Access message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.Access
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.Access} Access
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Access.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Access message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.Access
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Access.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.dataStatus != null && message.hasOwnProperty("dataStatus"))
                    if (!$util.isString(message.dataStatus))
                        return "dataStatus: string expected";
                if (message.retailerId != null && message.hasOwnProperty("retailerId"))
                    if (!$util.isString(message.retailerId))
                        return "retailerId: string expected";
                if (message.userCode != null && message.hasOwnProperty("userCode"))
                    if (!$util.isString(message.userCode))
                        return "userCode: string expected";
                if (message.supplierCode != null && message.hasOwnProperty("supplierCode"))
                    if (!$util.isString(message.supplierCode))
                        return "supplierCode: string expected";
                return null;
            };

            /**
             * Creates an Access message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.Access
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.Access} Access
             */
            Access.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.Access)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.Access();
                if (object.dataStatus != null)
                    message.dataStatus = String(object.dataStatus);
                if (object.retailerId != null)
                    message.retailerId = String(object.retailerId);
                if (object.userCode != null)
                    message.userCode = String(object.userCode);
                if (object.supplierCode != null)
                    message.supplierCode = String(object.supplierCode);
                return message;
            };

            /**
             * Creates a plain object from an Access message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.Access
             * @static
             * @param {TCBReceiptApi.Protobuf.Access} message Access
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Access.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.dataStatus = "";
                    object.retailerId = "";
                    object.userCode = "";
                    object.supplierCode = "";
                }
                if (message.dataStatus != null && message.hasOwnProperty("dataStatus"))
                    object.dataStatus = message.dataStatus;
                if (message.retailerId != null && message.hasOwnProperty("retailerId"))
                    object.retailerId = message.retailerId;
                if (message.userCode != null && message.hasOwnProperty("userCode"))
                    object.userCode = message.userCode;
                if (message.supplierCode != null && message.hasOwnProperty("supplierCode"))
                    object.supplierCode = message.supplierCode;
                return object;
            };

            /**
             * Converts this Access to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.Access
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Access.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Access;
        })();

        Protobuf.OBanT1 = (function() {

            /**
             * Properties of a OBanT1.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IOBanT1
             * @property {string|null} [recordType] OBanT1 recordType
             * @property {string|null} [formCode] OBanT1 formCode
             * @property {string|null} [deductType] OBanT1 deductType
             * @property {string|null} [invoiceType] OBanT1 invoiceType
             * @property {string|null} [invoiceStat] OBanT1 invoiceStat
             * @property {string|null} [invoiceNo] OBanT1 invoiceNo
             * @property {string|null} [checkDigit] OBanT1 checkDigit
             * @property {string|null} [invoiceDate] OBanT1 invoiceDate
             * @property {string|null} [salesAmout] OBanT1 salesAmout
             * @property {string|null} [vatType] OBanT1 vatType
             * @property {string|null} [vatAmount] OBanT1 vatAmount
             * @property {string|null} [invoiceAmout] OBanT1 invoiceAmout
             * @property {string|null} [invoiceBan] OBanT1 invoiceBan
             * @property {string|null} [storeCode] OBanT1 storeCode
             * @property {string|null} [invoiceName] OBanT1 invoiceName
             * @property {string|null} [invoiceAddress] OBanT1 invoiceAddress
             * @property {string|null} [referenceQualifier_1] OBanT1 referenceQualifier_1
             * @property {string|null} [reference_1] OBanT1 reference_1
             * @property {string|null} [referenceQualifier_2] OBanT1 referenceQualifier_2
             * @property {string|null} [reference_2] OBanT1 reference_2
             * @property {string|null} [reserved] OBanT1 reserved
             * @property {string|null} [sellerBan] OBanT1 sellerBan
             * @property {string|null} [sellerCode] OBanT1 sellerCode
             * @property {string|null} [sellerName] OBanT1 sellerName
             * @property {string|null} [sellerAddress] OBanT1 sellerAddress
             * @property {string|null} [sellerTel] OBanT1 sellerTel
             * @property {string|null} [sellerRep] OBanT1 sellerRep
             * @property {string|null} [invTransType] OBanT1 invTransType
             * @property {string|null} [isPaperInv] OBanT1 isPaperInv
             * @property {string|null} [invoiceTime] OBanT1 invoiceTime
             */

            /**
             * Constructs a new OBanT1.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a OBanT1.
             * @implements IOBanT1
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IOBanT1=} [properties] Properties to set
             */
            function OBanT1(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * OBanT1 recordType.
             * @member {string} recordType
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @instance
             */
            OBanT1.prototype.recordType = "";

            /**
             * OBanT1 formCode.
             * @member {string} formCode
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @instance
             */
            OBanT1.prototype.formCode = "";

            /**
             * OBanT1 deductType.
             * @member {string} deductType
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @instance
             */
            OBanT1.prototype.deductType = "";

            /**
             * OBanT1 invoiceType.
             * @member {string} invoiceType
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @instance
             */
            OBanT1.prototype.invoiceType = "";

            /**
             * OBanT1 invoiceStat.
             * @member {string} invoiceStat
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @instance
             */
            OBanT1.prototype.invoiceStat = "";

            /**
             * OBanT1 invoiceNo.
             * @member {string} invoiceNo
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @instance
             */
            OBanT1.prototype.invoiceNo = "";

            /**
             * OBanT1 checkDigit.
             * @member {string} checkDigit
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @instance
             */
            OBanT1.prototype.checkDigit = "";

            /**
             * OBanT1 invoiceDate.
             * @member {string} invoiceDate
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @instance
             */
            OBanT1.prototype.invoiceDate = "";

            /**
             * OBanT1 salesAmout.
             * @member {string} salesAmout
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @instance
             */
            OBanT1.prototype.salesAmout = "";

            /**
             * OBanT1 vatType.
             * @member {string} vatType
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @instance
             */
            OBanT1.prototype.vatType = "";

            /**
             * OBanT1 vatAmount.
             * @member {string} vatAmount
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @instance
             */
            OBanT1.prototype.vatAmount = "";

            /**
             * OBanT1 invoiceAmout.
             * @member {string} invoiceAmout
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @instance
             */
            OBanT1.prototype.invoiceAmout = "";

            /**
             * OBanT1 invoiceBan.
             * @member {string} invoiceBan
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @instance
             */
            OBanT1.prototype.invoiceBan = "";

            /**
             * OBanT1 storeCode.
             * @member {string} storeCode
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @instance
             */
            OBanT1.prototype.storeCode = "";

            /**
             * OBanT1 invoiceName.
             * @member {string} invoiceName
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @instance
             */
            OBanT1.prototype.invoiceName = "";

            /**
             * OBanT1 invoiceAddress.
             * @member {string} invoiceAddress
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @instance
             */
            OBanT1.prototype.invoiceAddress = "";

            /**
             * OBanT1 referenceQualifier_1.
             * @member {string} referenceQualifier_1
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @instance
             */
            OBanT1.prototype.referenceQualifier_1 = "";

            /**
             * OBanT1 reference_1.
             * @member {string} reference_1
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @instance
             */
            OBanT1.prototype.reference_1 = "";

            /**
             * OBanT1 referenceQualifier_2.
             * @member {string} referenceQualifier_2
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @instance
             */
            OBanT1.prototype.referenceQualifier_2 = "";

            /**
             * OBanT1 reference_2.
             * @member {string} reference_2
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @instance
             */
            OBanT1.prototype.reference_2 = "";

            /**
             * OBanT1 reserved.
             * @member {string} reserved
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @instance
             */
            OBanT1.prototype.reserved = "";

            /**
             * OBanT1 sellerBan.
             * @member {string} sellerBan
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @instance
             */
            OBanT1.prototype.sellerBan = "";

            /**
             * OBanT1 sellerCode.
             * @member {string} sellerCode
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @instance
             */
            OBanT1.prototype.sellerCode = "";

            /**
             * OBanT1 sellerName.
             * @member {string} sellerName
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @instance
             */
            OBanT1.prototype.sellerName = "";

            /**
             * OBanT1 sellerAddress.
             * @member {string} sellerAddress
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @instance
             */
            OBanT1.prototype.sellerAddress = "";

            /**
             * OBanT1 sellerTel.
             * @member {string} sellerTel
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @instance
             */
            OBanT1.prototype.sellerTel = "";

            /**
             * OBanT1 sellerRep.
             * @member {string} sellerRep
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @instance
             */
            OBanT1.prototype.sellerRep = "";

            /**
             * OBanT1 invTransType.
             * @member {string} invTransType
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @instance
             */
            OBanT1.prototype.invTransType = "";

            /**
             * OBanT1 isPaperInv.
             * @member {string} isPaperInv
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @instance
             */
            OBanT1.prototype.isPaperInv = "";

            /**
             * OBanT1 invoiceTime.
             * @member {string} invoiceTime
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @instance
             */
            OBanT1.prototype.invoiceTime = "";

            /**
             * Creates a new OBanT1 instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @static
             * @param {TCBReceiptApi.Protobuf.IOBanT1=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.OBanT1} OBanT1 instance
             */
            OBanT1.create = function create(properties) {
                return new OBanT1(properties);
            };

            /**
             * Encodes the specified OBanT1 message. Does not implicitly {@link TCBReceiptApi.Protobuf.OBanT1.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @static
             * @param {TCBReceiptApi.Protobuf.IOBanT1} message OBanT1 message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OBanT1.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.recordType != null && Object.hasOwnProperty.call(message, "recordType"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.recordType);
                if (message.formCode != null && Object.hasOwnProperty.call(message, "formCode"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.formCode);
                if (message.deductType != null && Object.hasOwnProperty.call(message, "deductType"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.deductType);
                if (message.invoiceType != null && Object.hasOwnProperty.call(message, "invoiceType"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.invoiceType);
                if (message.invoiceStat != null && Object.hasOwnProperty.call(message, "invoiceStat"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.invoiceStat);
                if (message.invoiceNo != null && Object.hasOwnProperty.call(message, "invoiceNo"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.invoiceNo);
                if (message.checkDigit != null && Object.hasOwnProperty.call(message, "checkDigit"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.checkDigit);
                if (message.invoiceDate != null && Object.hasOwnProperty.call(message, "invoiceDate"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.invoiceDate);
                if (message.salesAmout != null && Object.hasOwnProperty.call(message, "salesAmout"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.salesAmout);
                if (message.vatType != null && Object.hasOwnProperty.call(message, "vatType"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.vatType);
                if (message.vatAmount != null && Object.hasOwnProperty.call(message, "vatAmount"))
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.vatAmount);
                if (message.invoiceAmout != null && Object.hasOwnProperty.call(message, "invoiceAmout"))
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.invoiceAmout);
                if (message.invoiceBan != null && Object.hasOwnProperty.call(message, "invoiceBan"))
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.invoiceBan);
                if (message.storeCode != null && Object.hasOwnProperty.call(message, "storeCode"))
                    writer.uint32(/* id 14, wireType 2 =*/114).string(message.storeCode);
                if (message.invoiceName != null && Object.hasOwnProperty.call(message, "invoiceName"))
                    writer.uint32(/* id 15, wireType 2 =*/122).string(message.invoiceName);
                if (message.invoiceAddress != null && Object.hasOwnProperty.call(message, "invoiceAddress"))
                    writer.uint32(/* id 16, wireType 2 =*/130).string(message.invoiceAddress);
                if (message.referenceQualifier_1 != null && Object.hasOwnProperty.call(message, "referenceQualifier_1"))
                    writer.uint32(/* id 17, wireType 2 =*/138).string(message.referenceQualifier_1);
                if (message.reference_1 != null && Object.hasOwnProperty.call(message, "reference_1"))
                    writer.uint32(/* id 18, wireType 2 =*/146).string(message.reference_1);
                if (message.referenceQualifier_2 != null && Object.hasOwnProperty.call(message, "referenceQualifier_2"))
                    writer.uint32(/* id 19, wireType 2 =*/154).string(message.referenceQualifier_2);
                if (message.reference_2 != null && Object.hasOwnProperty.call(message, "reference_2"))
                    writer.uint32(/* id 20, wireType 2 =*/162).string(message.reference_2);
                if (message.reserved != null && Object.hasOwnProperty.call(message, "reserved"))
                    writer.uint32(/* id 21, wireType 2 =*/170).string(message.reserved);
                if (message.sellerBan != null && Object.hasOwnProperty.call(message, "sellerBan"))
                    writer.uint32(/* id 22, wireType 2 =*/178).string(message.sellerBan);
                if (message.sellerCode != null && Object.hasOwnProperty.call(message, "sellerCode"))
                    writer.uint32(/* id 23, wireType 2 =*/186).string(message.sellerCode);
                if (message.sellerName != null && Object.hasOwnProperty.call(message, "sellerName"))
                    writer.uint32(/* id 24, wireType 2 =*/194).string(message.sellerName);
                if (message.sellerAddress != null && Object.hasOwnProperty.call(message, "sellerAddress"))
                    writer.uint32(/* id 25, wireType 2 =*/202).string(message.sellerAddress);
                if (message.sellerTel != null && Object.hasOwnProperty.call(message, "sellerTel"))
                    writer.uint32(/* id 26, wireType 2 =*/210).string(message.sellerTel);
                if (message.sellerRep != null && Object.hasOwnProperty.call(message, "sellerRep"))
                    writer.uint32(/* id 27, wireType 2 =*/218).string(message.sellerRep);
                if (message.invTransType != null && Object.hasOwnProperty.call(message, "invTransType"))
                    writer.uint32(/* id 28, wireType 2 =*/226).string(message.invTransType);
                if (message.isPaperInv != null && Object.hasOwnProperty.call(message, "isPaperInv"))
                    writer.uint32(/* id 29, wireType 2 =*/234).string(message.isPaperInv);
                if (message.invoiceTime != null && Object.hasOwnProperty.call(message, "invoiceTime"))
                    writer.uint32(/* id 30, wireType 2 =*/242).string(message.invoiceTime);
                return writer;
            };

            /**
             * Encodes the specified OBanT1 message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.OBanT1.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @static
             * @param {TCBReceiptApi.Protobuf.IOBanT1} message OBanT1 message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OBanT1.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a OBanT1 message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.OBanT1} OBanT1
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OBanT1.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.OBanT1();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.recordType = reader.string();
                        break;
                    case 2:
                        message.formCode = reader.string();
                        break;
                    case 3:
                        message.deductType = reader.string();
                        break;
                    case 4:
                        message.invoiceType = reader.string();
                        break;
                    case 5:
                        message.invoiceStat = reader.string();
                        break;
                    case 6:
                        message.invoiceNo = reader.string();
                        break;
                    case 7:
                        message.checkDigit = reader.string();
                        break;
                    case 8:
                        message.invoiceDate = reader.string();
                        break;
                    case 9:
                        message.salesAmout = reader.string();
                        break;
                    case 10:
                        message.vatType = reader.string();
                        break;
                    case 11:
                        message.vatAmount = reader.string();
                        break;
                    case 12:
                        message.invoiceAmout = reader.string();
                        break;
                    case 13:
                        message.invoiceBan = reader.string();
                        break;
                    case 14:
                        message.storeCode = reader.string();
                        break;
                    case 15:
                        message.invoiceName = reader.string();
                        break;
                    case 16:
                        message.invoiceAddress = reader.string();
                        break;
                    case 17:
                        message.referenceQualifier_1 = reader.string();
                        break;
                    case 18:
                        message.reference_1 = reader.string();
                        break;
                    case 19:
                        message.referenceQualifier_2 = reader.string();
                        break;
                    case 20:
                        message.reference_2 = reader.string();
                        break;
                    case 21:
                        message.reserved = reader.string();
                        break;
                    case 22:
                        message.sellerBan = reader.string();
                        break;
                    case 23:
                        message.sellerCode = reader.string();
                        break;
                    case 24:
                        message.sellerName = reader.string();
                        break;
                    case 25:
                        message.sellerAddress = reader.string();
                        break;
                    case 26:
                        message.sellerTel = reader.string();
                        break;
                    case 27:
                        message.sellerRep = reader.string();
                        break;
                    case 28:
                        message.invTransType = reader.string();
                        break;
                    case 29:
                        message.isPaperInv = reader.string();
                        break;
                    case 30:
                        message.invoiceTime = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a OBanT1 message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.OBanT1} OBanT1
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OBanT1.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a OBanT1 message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            OBanT1.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.recordType != null && message.hasOwnProperty("recordType"))
                    if (!$util.isString(message.recordType))
                        return "recordType: string expected";
                if (message.formCode != null && message.hasOwnProperty("formCode"))
                    if (!$util.isString(message.formCode))
                        return "formCode: string expected";
                if (message.deductType != null && message.hasOwnProperty("deductType"))
                    if (!$util.isString(message.deductType))
                        return "deductType: string expected";
                if (message.invoiceType != null && message.hasOwnProperty("invoiceType"))
                    if (!$util.isString(message.invoiceType))
                        return "invoiceType: string expected";
                if (message.invoiceStat != null && message.hasOwnProperty("invoiceStat"))
                    if (!$util.isString(message.invoiceStat))
                        return "invoiceStat: string expected";
                if (message.invoiceNo != null && message.hasOwnProperty("invoiceNo"))
                    if (!$util.isString(message.invoiceNo))
                        return "invoiceNo: string expected";
                if (message.checkDigit != null && message.hasOwnProperty("checkDigit"))
                    if (!$util.isString(message.checkDigit))
                        return "checkDigit: string expected";
                if (message.invoiceDate != null && message.hasOwnProperty("invoiceDate"))
                    if (!$util.isString(message.invoiceDate))
                        return "invoiceDate: string expected";
                if (message.salesAmout != null && message.hasOwnProperty("salesAmout"))
                    if (!$util.isString(message.salesAmout))
                        return "salesAmout: string expected";
                if (message.vatType != null && message.hasOwnProperty("vatType"))
                    if (!$util.isString(message.vatType))
                        return "vatType: string expected";
                if (message.vatAmount != null && message.hasOwnProperty("vatAmount"))
                    if (!$util.isString(message.vatAmount))
                        return "vatAmount: string expected";
                if (message.invoiceAmout != null && message.hasOwnProperty("invoiceAmout"))
                    if (!$util.isString(message.invoiceAmout))
                        return "invoiceAmout: string expected";
                if (message.invoiceBan != null && message.hasOwnProperty("invoiceBan"))
                    if (!$util.isString(message.invoiceBan))
                        return "invoiceBan: string expected";
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    if (!$util.isString(message.storeCode))
                        return "storeCode: string expected";
                if (message.invoiceName != null && message.hasOwnProperty("invoiceName"))
                    if (!$util.isString(message.invoiceName))
                        return "invoiceName: string expected";
                if (message.invoiceAddress != null && message.hasOwnProperty("invoiceAddress"))
                    if (!$util.isString(message.invoiceAddress))
                        return "invoiceAddress: string expected";
                if (message.referenceQualifier_1 != null && message.hasOwnProperty("referenceQualifier_1"))
                    if (!$util.isString(message.referenceQualifier_1))
                        return "referenceQualifier_1: string expected";
                if (message.reference_1 != null && message.hasOwnProperty("reference_1"))
                    if (!$util.isString(message.reference_1))
                        return "reference_1: string expected";
                if (message.referenceQualifier_2 != null && message.hasOwnProperty("referenceQualifier_2"))
                    if (!$util.isString(message.referenceQualifier_2))
                        return "referenceQualifier_2: string expected";
                if (message.reference_2 != null && message.hasOwnProperty("reference_2"))
                    if (!$util.isString(message.reference_2))
                        return "reference_2: string expected";
                if (message.reserved != null && message.hasOwnProperty("reserved"))
                    if (!$util.isString(message.reserved))
                        return "reserved: string expected";
                if (message.sellerBan != null && message.hasOwnProperty("sellerBan"))
                    if (!$util.isString(message.sellerBan))
                        return "sellerBan: string expected";
                if (message.sellerCode != null && message.hasOwnProperty("sellerCode"))
                    if (!$util.isString(message.sellerCode))
                        return "sellerCode: string expected";
                if (message.sellerName != null && message.hasOwnProperty("sellerName"))
                    if (!$util.isString(message.sellerName))
                        return "sellerName: string expected";
                if (message.sellerAddress != null && message.hasOwnProperty("sellerAddress"))
                    if (!$util.isString(message.sellerAddress))
                        return "sellerAddress: string expected";
                if (message.sellerTel != null && message.hasOwnProperty("sellerTel"))
                    if (!$util.isString(message.sellerTel))
                        return "sellerTel: string expected";
                if (message.sellerRep != null && message.hasOwnProperty("sellerRep"))
                    if (!$util.isString(message.sellerRep))
                        return "sellerRep: string expected";
                if (message.invTransType != null && message.hasOwnProperty("invTransType"))
                    if (!$util.isString(message.invTransType))
                        return "invTransType: string expected";
                if (message.isPaperInv != null && message.hasOwnProperty("isPaperInv"))
                    if (!$util.isString(message.isPaperInv))
                        return "isPaperInv: string expected";
                if (message.invoiceTime != null && message.hasOwnProperty("invoiceTime"))
                    if (!$util.isString(message.invoiceTime))
                        return "invoiceTime: string expected";
                return null;
            };

            /**
             * Creates a OBanT1 message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.OBanT1} OBanT1
             */
            OBanT1.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.OBanT1)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.OBanT1();
                if (object.recordType != null)
                    message.recordType = String(object.recordType);
                if (object.formCode != null)
                    message.formCode = String(object.formCode);
                if (object.deductType != null)
                    message.deductType = String(object.deductType);
                if (object.invoiceType != null)
                    message.invoiceType = String(object.invoiceType);
                if (object.invoiceStat != null)
                    message.invoiceStat = String(object.invoiceStat);
                if (object.invoiceNo != null)
                    message.invoiceNo = String(object.invoiceNo);
                if (object.checkDigit != null)
                    message.checkDigit = String(object.checkDigit);
                if (object.invoiceDate != null)
                    message.invoiceDate = String(object.invoiceDate);
                if (object.salesAmout != null)
                    message.salesAmout = String(object.salesAmout);
                if (object.vatType != null)
                    message.vatType = String(object.vatType);
                if (object.vatAmount != null)
                    message.vatAmount = String(object.vatAmount);
                if (object.invoiceAmout != null)
                    message.invoiceAmout = String(object.invoiceAmout);
                if (object.invoiceBan != null)
                    message.invoiceBan = String(object.invoiceBan);
                if (object.storeCode != null)
                    message.storeCode = String(object.storeCode);
                if (object.invoiceName != null)
                    message.invoiceName = String(object.invoiceName);
                if (object.invoiceAddress != null)
                    message.invoiceAddress = String(object.invoiceAddress);
                if (object.referenceQualifier_1 != null)
                    message.referenceQualifier_1 = String(object.referenceQualifier_1);
                if (object.reference_1 != null)
                    message.reference_1 = String(object.reference_1);
                if (object.referenceQualifier_2 != null)
                    message.referenceQualifier_2 = String(object.referenceQualifier_2);
                if (object.reference_2 != null)
                    message.reference_2 = String(object.reference_2);
                if (object.reserved != null)
                    message.reserved = String(object.reserved);
                if (object.sellerBan != null)
                    message.sellerBan = String(object.sellerBan);
                if (object.sellerCode != null)
                    message.sellerCode = String(object.sellerCode);
                if (object.sellerName != null)
                    message.sellerName = String(object.sellerName);
                if (object.sellerAddress != null)
                    message.sellerAddress = String(object.sellerAddress);
                if (object.sellerTel != null)
                    message.sellerTel = String(object.sellerTel);
                if (object.sellerRep != null)
                    message.sellerRep = String(object.sellerRep);
                if (object.invTransType != null)
                    message.invTransType = String(object.invTransType);
                if (object.isPaperInv != null)
                    message.isPaperInv = String(object.isPaperInv);
                if (object.invoiceTime != null)
                    message.invoiceTime = String(object.invoiceTime);
                return message;
            };

            /**
             * Creates a plain object from a OBanT1 message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @static
             * @param {TCBReceiptApi.Protobuf.OBanT1} message OBanT1
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            OBanT1.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.recordType = "";
                    object.formCode = "";
                    object.deductType = "";
                    object.invoiceType = "";
                    object.invoiceStat = "";
                    object.invoiceNo = "";
                    object.checkDigit = "";
                    object.invoiceDate = "";
                    object.salesAmout = "";
                    object.vatType = "";
                    object.vatAmount = "";
                    object.invoiceAmout = "";
                    object.invoiceBan = "";
                    object.storeCode = "";
                    object.invoiceName = "";
                    object.invoiceAddress = "";
                    object.referenceQualifier_1 = "";
                    object.reference_1 = "";
                    object.referenceQualifier_2 = "";
                    object.reference_2 = "";
                    object.reserved = "";
                    object.sellerBan = "";
                    object.sellerCode = "";
                    object.sellerName = "";
                    object.sellerAddress = "";
                    object.sellerTel = "";
                    object.sellerRep = "";
                    object.invTransType = "";
                    object.isPaperInv = "";
                    object.invoiceTime = "";
                }
                if (message.recordType != null && message.hasOwnProperty("recordType"))
                    object.recordType = message.recordType;
                if (message.formCode != null && message.hasOwnProperty("formCode"))
                    object.formCode = message.formCode;
                if (message.deductType != null && message.hasOwnProperty("deductType"))
                    object.deductType = message.deductType;
                if (message.invoiceType != null && message.hasOwnProperty("invoiceType"))
                    object.invoiceType = message.invoiceType;
                if (message.invoiceStat != null && message.hasOwnProperty("invoiceStat"))
                    object.invoiceStat = message.invoiceStat;
                if (message.invoiceNo != null && message.hasOwnProperty("invoiceNo"))
                    object.invoiceNo = message.invoiceNo;
                if (message.checkDigit != null && message.hasOwnProperty("checkDigit"))
                    object.checkDigit = message.checkDigit;
                if (message.invoiceDate != null && message.hasOwnProperty("invoiceDate"))
                    object.invoiceDate = message.invoiceDate;
                if (message.salesAmout != null && message.hasOwnProperty("salesAmout"))
                    object.salesAmout = message.salesAmout;
                if (message.vatType != null && message.hasOwnProperty("vatType"))
                    object.vatType = message.vatType;
                if (message.vatAmount != null && message.hasOwnProperty("vatAmount"))
                    object.vatAmount = message.vatAmount;
                if (message.invoiceAmout != null && message.hasOwnProperty("invoiceAmout"))
                    object.invoiceAmout = message.invoiceAmout;
                if (message.invoiceBan != null && message.hasOwnProperty("invoiceBan"))
                    object.invoiceBan = message.invoiceBan;
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    object.storeCode = message.storeCode;
                if (message.invoiceName != null && message.hasOwnProperty("invoiceName"))
                    object.invoiceName = message.invoiceName;
                if (message.invoiceAddress != null && message.hasOwnProperty("invoiceAddress"))
                    object.invoiceAddress = message.invoiceAddress;
                if (message.referenceQualifier_1 != null && message.hasOwnProperty("referenceQualifier_1"))
                    object.referenceQualifier_1 = message.referenceQualifier_1;
                if (message.reference_1 != null && message.hasOwnProperty("reference_1"))
                    object.reference_1 = message.reference_1;
                if (message.referenceQualifier_2 != null && message.hasOwnProperty("referenceQualifier_2"))
                    object.referenceQualifier_2 = message.referenceQualifier_2;
                if (message.reference_2 != null && message.hasOwnProperty("reference_2"))
                    object.reference_2 = message.reference_2;
                if (message.reserved != null && message.hasOwnProperty("reserved"))
                    object.reserved = message.reserved;
                if (message.sellerBan != null && message.hasOwnProperty("sellerBan"))
                    object.sellerBan = message.sellerBan;
                if (message.sellerCode != null && message.hasOwnProperty("sellerCode"))
                    object.sellerCode = message.sellerCode;
                if (message.sellerName != null && message.hasOwnProperty("sellerName"))
                    object.sellerName = message.sellerName;
                if (message.sellerAddress != null && message.hasOwnProperty("sellerAddress"))
                    object.sellerAddress = message.sellerAddress;
                if (message.sellerTel != null && message.hasOwnProperty("sellerTel"))
                    object.sellerTel = message.sellerTel;
                if (message.sellerRep != null && message.hasOwnProperty("sellerRep"))
                    object.sellerRep = message.sellerRep;
                if (message.invTransType != null && message.hasOwnProperty("invTransType"))
                    object.invTransType = message.invTransType;
                if (message.isPaperInv != null && message.hasOwnProperty("isPaperInv"))
                    object.isPaperInv = message.isPaperInv;
                if (message.invoiceTime != null && message.hasOwnProperty("invoiceTime"))
                    object.invoiceTime = message.invoiceTime;
                return object;
            };

            /**
             * Converts this OBanT1 to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.OBanT1
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            OBanT1.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return OBanT1;
        })();

        Protobuf.OBanT2 = (function() {

            /**
             * Properties of a OBanT2.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IOBanT2
             * @property {string|null} [recordType] OBanT2 recordType
             * @property {string|null} [seqNo] OBanT2 seqNo
             * @property {string|null} [productName] OBanT2 productName
             * @property {string|null} [qty] OBanT2 qty
             * @property {string|null} [unitPrice] OBanT2 unitPrice
             * @property {string|null} [netAmout] OBanT2 netAmout
             * @property {string|null} [amout] OBanT2 amout
             * @property {string|null} [tax] OBanT2 tax
             * @property {string|null} [barCode] OBanT2 barCode
             */

            /**
             * Constructs a new OBanT2.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a OBanT2.
             * @implements IOBanT2
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IOBanT2=} [properties] Properties to set
             */
            function OBanT2(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * OBanT2 recordType.
             * @member {string} recordType
             * @memberof TCBReceiptApi.Protobuf.OBanT2
             * @instance
             */
            OBanT2.prototype.recordType = "";

            /**
             * OBanT2 seqNo.
             * @member {string} seqNo
             * @memberof TCBReceiptApi.Protobuf.OBanT2
             * @instance
             */
            OBanT2.prototype.seqNo = "";

            /**
             * OBanT2 productName.
             * @member {string} productName
             * @memberof TCBReceiptApi.Protobuf.OBanT2
             * @instance
             */
            OBanT2.prototype.productName = "";

            /**
             * OBanT2 qty.
             * @member {string} qty
             * @memberof TCBReceiptApi.Protobuf.OBanT2
             * @instance
             */
            OBanT2.prototype.qty = "";

            /**
             * OBanT2 unitPrice.
             * @member {string} unitPrice
             * @memberof TCBReceiptApi.Protobuf.OBanT2
             * @instance
             */
            OBanT2.prototype.unitPrice = "";

            /**
             * OBanT2 netAmout.
             * @member {string} netAmout
             * @memberof TCBReceiptApi.Protobuf.OBanT2
             * @instance
             */
            OBanT2.prototype.netAmout = "";

            /**
             * OBanT2 amout.
             * @member {string} amout
             * @memberof TCBReceiptApi.Protobuf.OBanT2
             * @instance
             */
            OBanT2.prototype.amout = "";

            /**
             * OBanT2 tax.
             * @member {string} tax
             * @memberof TCBReceiptApi.Protobuf.OBanT2
             * @instance
             */
            OBanT2.prototype.tax = "";

            /**
             * OBanT2 barCode.
             * @member {string} barCode
             * @memberof TCBReceiptApi.Protobuf.OBanT2
             * @instance
             */
            OBanT2.prototype.barCode = "";

            /**
             * Creates a new OBanT2 instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.OBanT2
             * @static
             * @param {TCBReceiptApi.Protobuf.IOBanT2=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.OBanT2} OBanT2 instance
             */
            OBanT2.create = function create(properties) {
                return new OBanT2(properties);
            };

            /**
             * Encodes the specified OBanT2 message. Does not implicitly {@link TCBReceiptApi.Protobuf.OBanT2.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.OBanT2
             * @static
             * @param {TCBReceiptApi.Protobuf.IOBanT2} message OBanT2 message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OBanT2.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.recordType != null && Object.hasOwnProperty.call(message, "recordType"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.recordType);
                if (message.seqNo != null && Object.hasOwnProperty.call(message, "seqNo"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.seqNo);
                if (message.productName != null && Object.hasOwnProperty.call(message, "productName"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.productName);
                if (message.qty != null && Object.hasOwnProperty.call(message, "qty"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.qty);
                if (message.unitPrice != null && Object.hasOwnProperty.call(message, "unitPrice"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.unitPrice);
                if (message.netAmout != null && Object.hasOwnProperty.call(message, "netAmout"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.netAmout);
                if (message.amout != null && Object.hasOwnProperty.call(message, "amout"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.amout);
                if (message.tax != null && Object.hasOwnProperty.call(message, "tax"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.tax);
                if (message.barCode != null && Object.hasOwnProperty.call(message, "barCode"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.barCode);
                return writer;
            };

            /**
             * Encodes the specified OBanT2 message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.OBanT2.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.OBanT2
             * @static
             * @param {TCBReceiptApi.Protobuf.IOBanT2} message OBanT2 message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OBanT2.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a OBanT2 message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.OBanT2
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.OBanT2} OBanT2
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OBanT2.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.OBanT2();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.recordType = reader.string();
                        break;
                    case 2:
                        message.seqNo = reader.string();
                        break;
                    case 3:
                        message.productName = reader.string();
                        break;
                    case 4:
                        message.qty = reader.string();
                        break;
                    case 5:
                        message.unitPrice = reader.string();
                        break;
                    case 6:
                        message.netAmout = reader.string();
                        break;
                    case 7:
                        message.amout = reader.string();
                        break;
                    case 8:
                        message.tax = reader.string();
                        break;
                    case 9:
                        message.barCode = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a OBanT2 message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.OBanT2
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.OBanT2} OBanT2
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OBanT2.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a OBanT2 message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.OBanT2
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            OBanT2.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.recordType != null && message.hasOwnProperty("recordType"))
                    if (!$util.isString(message.recordType))
                        return "recordType: string expected";
                if (message.seqNo != null && message.hasOwnProperty("seqNo"))
                    if (!$util.isString(message.seqNo))
                        return "seqNo: string expected";
                if (message.productName != null && message.hasOwnProperty("productName"))
                    if (!$util.isString(message.productName))
                        return "productName: string expected";
                if (message.qty != null && message.hasOwnProperty("qty"))
                    if (!$util.isString(message.qty))
                        return "qty: string expected";
                if (message.unitPrice != null && message.hasOwnProperty("unitPrice"))
                    if (!$util.isString(message.unitPrice))
                        return "unitPrice: string expected";
                if (message.netAmout != null && message.hasOwnProperty("netAmout"))
                    if (!$util.isString(message.netAmout))
                        return "netAmout: string expected";
                if (message.amout != null && message.hasOwnProperty("amout"))
                    if (!$util.isString(message.amout))
                        return "amout: string expected";
                if (message.tax != null && message.hasOwnProperty("tax"))
                    if (!$util.isString(message.tax))
                        return "tax: string expected";
                if (message.barCode != null && message.hasOwnProperty("barCode"))
                    if (!$util.isString(message.barCode))
                        return "barCode: string expected";
                return null;
            };

            /**
             * Creates a OBanT2 message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.OBanT2
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.OBanT2} OBanT2
             */
            OBanT2.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.OBanT2)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.OBanT2();
                if (object.recordType != null)
                    message.recordType = String(object.recordType);
                if (object.seqNo != null)
                    message.seqNo = String(object.seqNo);
                if (object.productName != null)
                    message.productName = String(object.productName);
                if (object.qty != null)
                    message.qty = String(object.qty);
                if (object.unitPrice != null)
                    message.unitPrice = String(object.unitPrice);
                if (object.netAmout != null)
                    message.netAmout = String(object.netAmout);
                if (object.amout != null)
                    message.amout = String(object.amout);
                if (object.tax != null)
                    message.tax = String(object.tax);
                if (object.barCode != null)
                    message.barCode = String(object.barCode);
                return message;
            };

            /**
             * Creates a plain object from a OBanT2 message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.OBanT2
             * @static
             * @param {TCBReceiptApi.Protobuf.OBanT2} message OBanT2
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            OBanT2.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.recordType = "";
                    object.seqNo = "";
                    object.productName = "";
                    object.qty = "";
                    object.unitPrice = "";
                    object.netAmout = "";
                    object.amout = "";
                    object.tax = "";
                    object.barCode = "";
                }
                if (message.recordType != null && message.hasOwnProperty("recordType"))
                    object.recordType = message.recordType;
                if (message.seqNo != null && message.hasOwnProperty("seqNo"))
                    object.seqNo = message.seqNo;
                if (message.productName != null && message.hasOwnProperty("productName"))
                    object.productName = message.productName;
                if (message.qty != null && message.hasOwnProperty("qty"))
                    object.qty = message.qty;
                if (message.unitPrice != null && message.hasOwnProperty("unitPrice"))
                    object.unitPrice = message.unitPrice;
                if (message.netAmout != null && message.hasOwnProperty("netAmout"))
                    object.netAmout = message.netAmout;
                if (message.amout != null && message.hasOwnProperty("amout"))
                    object.amout = message.amout;
                if (message.tax != null && message.hasOwnProperty("tax"))
                    object.tax = message.tax;
                if (message.barCode != null && message.hasOwnProperty("barCode"))
                    object.barCode = message.barCode;
                return object;
            };

            /**
             * Converts this OBanT2 to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.OBanT2
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            OBanT2.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return OBanT2;
        })();

        Protobuf.OBan = (function() {

            /**
             * Properties of a OBan.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IOBan
             * @property {TCBReceiptApi.Protobuf.IOBanT1|null} [t1] OBan t1
             * @property {TCBReceiptApi.Protobuf.IOBanT2|null} [t2] OBan t2
             */

            /**
             * Constructs a new OBan.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a OBan.
             * @implements IOBan
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IOBan=} [properties] Properties to set
             */
            function OBan(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * OBan t1.
             * @member {TCBReceiptApi.Protobuf.IOBanT1|null|undefined} t1
             * @memberof TCBReceiptApi.Protobuf.OBan
             * @instance
             */
            OBan.prototype.t1 = null;

            /**
             * OBan t2.
             * @member {TCBReceiptApi.Protobuf.IOBanT2|null|undefined} t2
             * @memberof TCBReceiptApi.Protobuf.OBan
             * @instance
             */
            OBan.prototype.t2 = null;

            /**
             * Creates a new OBan instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.OBan
             * @static
             * @param {TCBReceiptApi.Protobuf.IOBan=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.OBan} OBan instance
             */
            OBan.create = function create(properties) {
                return new OBan(properties);
            };

            /**
             * Encodes the specified OBan message. Does not implicitly {@link TCBReceiptApi.Protobuf.OBan.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.OBan
             * @static
             * @param {TCBReceiptApi.Protobuf.IOBan} message OBan message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OBan.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.t1 != null && Object.hasOwnProperty.call(message, "t1"))
                    $root.TCBReceiptApi.Protobuf.OBanT1.encode(message.t1, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.t2 != null && Object.hasOwnProperty.call(message, "t2"))
                    $root.TCBReceiptApi.Protobuf.OBanT2.encode(message.t2, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified OBan message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.OBan.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.OBan
             * @static
             * @param {TCBReceiptApi.Protobuf.IOBan} message OBan message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OBan.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a OBan message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.OBan
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.OBan} OBan
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OBan.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.OBan();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.t1 = $root.TCBReceiptApi.Protobuf.OBanT1.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.t2 = $root.TCBReceiptApi.Protobuf.OBanT2.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a OBan message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.OBan
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.OBan} OBan
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OBan.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a OBan message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.OBan
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            OBan.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.t1 != null && message.hasOwnProperty("t1")) {
                    var error = $root.TCBReceiptApi.Protobuf.OBanT1.verify(message.t1);
                    if (error)
                        return "t1." + error;
                }
                if (message.t2 != null && message.hasOwnProperty("t2")) {
                    var error = $root.TCBReceiptApi.Protobuf.OBanT2.verify(message.t2);
                    if (error)
                        return "t2." + error;
                }
                return null;
            };

            /**
             * Creates a OBan message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.OBan
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.OBan} OBan
             */
            OBan.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.OBan)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.OBan();
                if (object.t1 != null) {
                    if (typeof object.t1 !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.OBan.t1: object expected");
                    message.t1 = $root.TCBReceiptApi.Protobuf.OBanT1.fromObject(object.t1);
                }
                if (object.t2 != null) {
                    if (typeof object.t2 !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.OBan.t2: object expected");
                    message.t2 = $root.TCBReceiptApi.Protobuf.OBanT2.fromObject(object.t2);
                }
                return message;
            };

            /**
             * Creates a plain object from a OBan message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.OBan
             * @static
             * @param {TCBReceiptApi.Protobuf.OBan} message OBan
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            OBan.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.t1 = null;
                    object.t2 = null;
                }
                if (message.t1 != null && message.hasOwnProperty("t1"))
                    object.t1 = $root.TCBReceiptApi.Protobuf.OBanT1.toObject(message.t1, options);
                if (message.t2 != null && message.hasOwnProperty("t2"))
                    object.t2 = $root.TCBReceiptApi.Protobuf.OBanT2.toObject(message.t2, options);
                return object;
            };

            /**
             * Converts this OBan to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.OBan
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            OBan.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return OBan;
        })();

        Protobuf.ABanT1 = (function() {

            /**
             * Properties of a ABanT1.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IABanT1
             * @property {string|null} [recordType] ABanT1 recordType
             * @property {string|null} [formCode] ABanT1 formCode
             * @property {string|null} [allowanceType] ABanT1 allowanceType
             * @property {string|null} [allowanceStat] ABanT1 allowanceStat
             * @property {string|null} [allowanceNo] ABanT1 allowanceNo
             * @property {string|null} [allowanceDate] ABanT1 allowanceDate
             * @property {string|null} [salesAmout] ABanT1 salesAmout
             * @property {string|null} [vatType] ABanT1 vatType
             * @property {string|null} [vatAmount] ABanT1 vatAmount
             * @property {string|null} [totalAmout] ABanT1 totalAmout
             * @property {string|null} [buyerBan] ABanT1 buyerBan
             * @property {string|null} [buyerName] ABanT1 buyerName
             * @property {string|null} [referenceQualifier_2] ABanT1 referenceQualifier_2
             * @property {string|null} [reference_2] ABanT1 reference_2
             * @property {string|null} [reserved] ABanT1 reserved
             * @property {string|null} [sellerBan] ABanT1 sellerBan
             * @property {string|null} [sellerCode] ABanT1 sellerCode
             * @property {string|null} [alwTransType] ABanT1 alwTransType
             * @property {string|null} [isPaperAlw] ABanT1 isPaperAlw
             */

            /**
             * Constructs a new ABanT1.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a ABanT1.
             * @implements IABanT1
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IABanT1=} [properties] Properties to set
             */
            function ABanT1(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ABanT1 recordType.
             * @member {string} recordType
             * @memberof TCBReceiptApi.Protobuf.ABanT1
             * @instance
             */
            ABanT1.prototype.recordType = "";

            /**
             * ABanT1 formCode.
             * @member {string} formCode
             * @memberof TCBReceiptApi.Protobuf.ABanT1
             * @instance
             */
            ABanT1.prototype.formCode = "";

            /**
             * ABanT1 allowanceType.
             * @member {string} allowanceType
             * @memberof TCBReceiptApi.Protobuf.ABanT1
             * @instance
             */
            ABanT1.prototype.allowanceType = "";

            /**
             * ABanT1 allowanceStat.
             * @member {string} allowanceStat
             * @memberof TCBReceiptApi.Protobuf.ABanT1
             * @instance
             */
            ABanT1.prototype.allowanceStat = "";

            /**
             * ABanT1 allowanceNo.
             * @member {string} allowanceNo
             * @memberof TCBReceiptApi.Protobuf.ABanT1
             * @instance
             */
            ABanT1.prototype.allowanceNo = "";

            /**
             * ABanT1 allowanceDate.
             * @member {string} allowanceDate
             * @memberof TCBReceiptApi.Protobuf.ABanT1
             * @instance
             */
            ABanT1.prototype.allowanceDate = "";

            /**
             * ABanT1 salesAmout.
             * @member {string} salesAmout
             * @memberof TCBReceiptApi.Protobuf.ABanT1
             * @instance
             */
            ABanT1.prototype.salesAmout = "";

            /**
             * ABanT1 vatType.
             * @member {string} vatType
             * @memberof TCBReceiptApi.Protobuf.ABanT1
             * @instance
             */
            ABanT1.prototype.vatType = "";

            /**
             * ABanT1 vatAmount.
             * @member {string} vatAmount
             * @memberof TCBReceiptApi.Protobuf.ABanT1
             * @instance
             */
            ABanT1.prototype.vatAmount = "";

            /**
             * ABanT1 totalAmout.
             * @member {string} totalAmout
             * @memberof TCBReceiptApi.Protobuf.ABanT1
             * @instance
             */
            ABanT1.prototype.totalAmout = "";

            /**
             * ABanT1 buyerBan.
             * @member {string} buyerBan
             * @memberof TCBReceiptApi.Protobuf.ABanT1
             * @instance
             */
            ABanT1.prototype.buyerBan = "";

            /**
             * ABanT1 buyerName.
             * @member {string} buyerName
             * @memberof TCBReceiptApi.Protobuf.ABanT1
             * @instance
             */
            ABanT1.prototype.buyerName = "";

            /**
             * ABanT1 referenceQualifier_2.
             * @member {string} referenceQualifier_2
             * @memberof TCBReceiptApi.Protobuf.ABanT1
             * @instance
             */
            ABanT1.prototype.referenceQualifier_2 = "";

            /**
             * ABanT1 reference_2.
             * @member {string} reference_2
             * @memberof TCBReceiptApi.Protobuf.ABanT1
             * @instance
             */
            ABanT1.prototype.reference_2 = "";

            /**
             * ABanT1 reserved.
             * @member {string} reserved
             * @memberof TCBReceiptApi.Protobuf.ABanT1
             * @instance
             */
            ABanT1.prototype.reserved = "";

            /**
             * ABanT1 sellerBan.
             * @member {string} sellerBan
             * @memberof TCBReceiptApi.Protobuf.ABanT1
             * @instance
             */
            ABanT1.prototype.sellerBan = "";

            /**
             * ABanT1 sellerCode.
             * @member {string} sellerCode
             * @memberof TCBReceiptApi.Protobuf.ABanT1
             * @instance
             */
            ABanT1.prototype.sellerCode = "";

            /**
             * ABanT1 alwTransType.
             * @member {string} alwTransType
             * @memberof TCBReceiptApi.Protobuf.ABanT1
             * @instance
             */
            ABanT1.prototype.alwTransType = "";

            /**
             * ABanT1 isPaperAlw.
             * @member {string} isPaperAlw
             * @memberof TCBReceiptApi.Protobuf.ABanT1
             * @instance
             */
            ABanT1.prototype.isPaperAlw = "";

            /**
             * Creates a new ABanT1 instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.ABanT1
             * @static
             * @param {TCBReceiptApi.Protobuf.IABanT1=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.ABanT1} ABanT1 instance
             */
            ABanT1.create = function create(properties) {
                return new ABanT1(properties);
            };

            /**
             * Encodes the specified ABanT1 message. Does not implicitly {@link TCBReceiptApi.Protobuf.ABanT1.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.ABanT1
             * @static
             * @param {TCBReceiptApi.Protobuf.IABanT1} message ABanT1 message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ABanT1.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.recordType != null && Object.hasOwnProperty.call(message, "recordType"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.recordType);
                if (message.formCode != null && Object.hasOwnProperty.call(message, "formCode"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.formCode);
                if (message.allowanceType != null && Object.hasOwnProperty.call(message, "allowanceType"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.allowanceType);
                if (message.allowanceStat != null && Object.hasOwnProperty.call(message, "allowanceStat"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.allowanceStat);
                if (message.allowanceNo != null && Object.hasOwnProperty.call(message, "allowanceNo"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.allowanceNo);
                if (message.allowanceDate != null && Object.hasOwnProperty.call(message, "allowanceDate"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.allowanceDate);
                if (message.salesAmout != null && Object.hasOwnProperty.call(message, "salesAmout"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.salesAmout);
                if (message.vatType != null && Object.hasOwnProperty.call(message, "vatType"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.vatType);
                if (message.vatAmount != null && Object.hasOwnProperty.call(message, "vatAmount"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.vatAmount);
                if (message.totalAmout != null && Object.hasOwnProperty.call(message, "totalAmout"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.totalAmout);
                if (message.buyerBan != null && Object.hasOwnProperty.call(message, "buyerBan"))
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.buyerBan);
                if (message.buyerName != null && Object.hasOwnProperty.call(message, "buyerName"))
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.buyerName);
                if (message.referenceQualifier_2 != null && Object.hasOwnProperty.call(message, "referenceQualifier_2"))
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.referenceQualifier_2);
                if (message.reference_2 != null && Object.hasOwnProperty.call(message, "reference_2"))
                    writer.uint32(/* id 14, wireType 2 =*/114).string(message.reference_2);
                if (message.reserved != null && Object.hasOwnProperty.call(message, "reserved"))
                    writer.uint32(/* id 15, wireType 2 =*/122).string(message.reserved);
                if (message.sellerBan != null && Object.hasOwnProperty.call(message, "sellerBan"))
                    writer.uint32(/* id 16, wireType 2 =*/130).string(message.sellerBan);
                if (message.sellerCode != null && Object.hasOwnProperty.call(message, "sellerCode"))
                    writer.uint32(/* id 17, wireType 2 =*/138).string(message.sellerCode);
                if (message.alwTransType != null && Object.hasOwnProperty.call(message, "alwTransType"))
                    writer.uint32(/* id 18, wireType 2 =*/146).string(message.alwTransType);
                if (message.isPaperAlw != null && Object.hasOwnProperty.call(message, "isPaperAlw"))
                    writer.uint32(/* id 19, wireType 2 =*/154).string(message.isPaperAlw);
                return writer;
            };

            /**
             * Encodes the specified ABanT1 message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.ABanT1.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ABanT1
             * @static
             * @param {TCBReceiptApi.Protobuf.IABanT1} message ABanT1 message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ABanT1.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ABanT1 message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.ABanT1
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.ABanT1} ABanT1
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ABanT1.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.ABanT1();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.recordType = reader.string();
                        break;
                    case 2:
                        message.formCode = reader.string();
                        break;
                    case 3:
                        message.allowanceType = reader.string();
                        break;
                    case 4:
                        message.allowanceStat = reader.string();
                        break;
                    case 5:
                        message.allowanceNo = reader.string();
                        break;
                    case 6:
                        message.allowanceDate = reader.string();
                        break;
                    case 7:
                        message.salesAmout = reader.string();
                        break;
                    case 8:
                        message.vatType = reader.string();
                        break;
                    case 9:
                        message.vatAmount = reader.string();
                        break;
                    case 10:
                        message.totalAmout = reader.string();
                        break;
                    case 11:
                        message.buyerBan = reader.string();
                        break;
                    case 12:
                        message.buyerName = reader.string();
                        break;
                    case 13:
                        message.referenceQualifier_2 = reader.string();
                        break;
                    case 14:
                        message.reference_2 = reader.string();
                        break;
                    case 15:
                        message.reserved = reader.string();
                        break;
                    case 16:
                        message.sellerBan = reader.string();
                        break;
                    case 17:
                        message.sellerCode = reader.string();
                        break;
                    case 18:
                        message.alwTransType = reader.string();
                        break;
                    case 19:
                        message.isPaperAlw = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ABanT1 message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ABanT1
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.ABanT1} ABanT1
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ABanT1.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ABanT1 message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.ABanT1
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ABanT1.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.recordType != null && message.hasOwnProperty("recordType"))
                    if (!$util.isString(message.recordType))
                        return "recordType: string expected";
                if (message.formCode != null && message.hasOwnProperty("formCode"))
                    if (!$util.isString(message.formCode))
                        return "formCode: string expected";
                if (message.allowanceType != null && message.hasOwnProperty("allowanceType"))
                    if (!$util.isString(message.allowanceType))
                        return "allowanceType: string expected";
                if (message.allowanceStat != null && message.hasOwnProperty("allowanceStat"))
                    if (!$util.isString(message.allowanceStat))
                        return "allowanceStat: string expected";
                if (message.allowanceNo != null && message.hasOwnProperty("allowanceNo"))
                    if (!$util.isString(message.allowanceNo))
                        return "allowanceNo: string expected";
                if (message.allowanceDate != null && message.hasOwnProperty("allowanceDate"))
                    if (!$util.isString(message.allowanceDate))
                        return "allowanceDate: string expected";
                if (message.salesAmout != null && message.hasOwnProperty("salesAmout"))
                    if (!$util.isString(message.salesAmout))
                        return "salesAmout: string expected";
                if (message.vatType != null && message.hasOwnProperty("vatType"))
                    if (!$util.isString(message.vatType))
                        return "vatType: string expected";
                if (message.vatAmount != null && message.hasOwnProperty("vatAmount"))
                    if (!$util.isString(message.vatAmount))
                        return "vatAmount: string expected";
                if (message.totalAmout != null && message.hasOwnProperty("totalAmout"))
                    if (!$util.isString(message.totalAmout))
                        return "totalAmout: string expected";
                if (message.buyerBan != null && message.hasOwnProperty("buyerBan"))
                    if (!$util.isString(message.buyerBan))
                        return "buyerBan: string expected";
                if (message.buyerName != null && message.hasOwnProperty("buyerName"))
                    if (!$util.isString(message.buyerName))
                        return "buyerName: string expected";
                if (message.referenceQualifier_2 != null && message.hasOwnProperty("referenceQualifier_2"))
                    if (!$util.isString(message.referenceQualifier_2))
                        return "referenceQualifier_2: string expected";
                if (message.reference_2 != null && message.hasOwnProperty("reference_2"))
                    if (!$util.isString(message.reference_2))
                        return "reference_2: string expected";
                if (message.reserved != null && message.hasOwnProperty("reserved"))
                    if (!$util.isString(message.reserved))
                        return "reserved: string expected";
                if (message.sellerBan != null && message.hasOwnProperty("sellerBan"))
                    if (!$util.isString(message.sellerBan))
                        return "sellerBan: string expected";
                if (message.sellerCode != null && message.hasOwnProperty("sellerCode"))
                    if (!$util.isString(message.sellerCode))
                        return "sellerCode: string expected";
                if (message.alwTransType != null && message.hasOwnProperty("alwTransType"))
                    if (!$util.isString(message.alwTransType))
                        return "alwTransType: string expected";
                if (message.isPaperAlw != null && message.hasOwnProperty("isPaperAlw"))
                    if (!$util.isString(message.isPaperAlw))
                        return "isPaperAlw: string expected";
                return null;
            };

            /**
             * Creates a ABanT1 message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.ABanT1
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.ABanT1} ABanT1
             */
            ABanT1.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.ABanT1)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.ABanT1();
                if (object.recordType != null)
                    message.recordType = String(object.recordType);
                if (object.formCode != null)
                    message.formCode = String(object.formCode);
                if (object.allowanceType != null)
                    message.allowanceType = String(object.allowanceType);
                if (object.allowanceStat != null)
                    message.allowanceStat = String(object.allowanceStat);
                if (object.allowanceNo != null)
                    message.allowanceNo = String(object.allowanceNo);
                if (object.allowanceDate != null)
                    message.allowanceDate = String(object.allowanceDate);
                if (object.salesAmout != null)
                    message.salesAmout = String(object.salesAmout);
                if (object.vatType != null)
                    message.vatType = String(object.vatType);
                if (object.vatAmount != null)
                    message.vatAmount = String(object.vatAmount);
                if (object.totalAmout != null)
                    message.totalAmout = String(object.totalAmout);
                if (object.buyerBan != null)
                    message.buyerBan = String(object.buyerBan);
                if (object.buyerName != null)
                    message.buyerName = String(object.buyerName);
                if (object.referenceQualifier_2 != null)
                    message.referenceQualifier_2 = String(object.referenceQualifier_2);
                if (object.reference_2 != null)
                    message.reference_2 = String(object.reference_2);
                if (object.reserved != null)
                    message.reserved = String(object.reserved);
                if (object.sellerBan != null)
                    message.sellerBan = String(object.sellerBan);
                if (object.sellerCode != null)
                    message.sellerCode = String(object.sellerCode);
                if (object.alwTransType != null)
                    message.alwTransType = String(object.alwTransType);
                if (object.isPaperAlw != null)
                    message.isPaperAlw = String(object.isPaperAlw);
                return message;
            };

            /**
             * Creates a plain object from a ABanT1 message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.ABanT1
             * @static
             * @param {TCBReceiptApi.Protobuf.ABanT1} message ABanT1
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ABanT1.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.recordType = "";
                    object.formCode = "";
                    object.allowanceType = "";
                    object.allowanceStat = "";
                    object.allowanceNo = "";
                    object.allowanceDate = "";
                    object.salesAmout = "";
                    object.vatType = "";
                    object.vatAmount = "";
                    object.totalAmout = "";
                    object.buyerBan = "";
                    object.buyerName = "";
                    object.referenceQualifier_2 = "";
                    object.reference_2 = "";
                    object.reserved = "";
                    object.sellerBan = "";
                    object.sellerCode = "";
                    object.alwTransType = "";
                    object.isPaperAlw = "";
                }
                if (message.recordType != null && message.hasOwnProperty("recordType"))
                    object.recordType = message.recordType;
                if (message.formCode != null && message.hasOwnProperty("formCode"))
                    object.formCode = message.formCode;
                if (message.allowanceType != null && message.hasOwnProperty("allowanceType"))
                    object.allowanceType = message.allowanceType;
                if (message.allowanceStat != null && message.hasOwnProperty("allowanceStat"))
                    object.allowanceStat = message.allowanceStat;
                if (message.allowanceNo != null && message.hasOwnProperty("allowanceNo"))
                    object.allowanceNo = message.allowanceNo;
                if (message.allowanceDate != null && message.hasOwnProperty("allowanceDate"))
                    object.allowanceDate = message.allowanceDate;
                if (message.salesAmout != null && message.hasOwnProperty("salesAmout"))
                    object.salesAmout = message.salesAmout;
                if (message.vatType != null && message.hasOwnProperty("vatType"))
                    object.vatType = message.vatType;
                if (message.vatAmount != null && message.hasOwnProperty("vatAmount"))
                    object.vatAmount = message.vatAmount;
                if (message.totalAmout != null && message.hasOwnProperty("totalAmout"))
                    object.totalAmout = message.totalAmout;
                if (message.buyerBan != null && message.hasOwnProperty("buyerBan"))
                    object.buyerBan = message.buyerBan;
                if (message.buyerName != null && message.hasOwnProperty("buyerName"))
                    object.buyerName = message.buyerName;
                if (message.referenceQualifier_2 != null && message.hasOwnProperty("referenceQualifier_2"))
                    object.referenceQualifier_2 = message.referenceQualifier_2;
                if (message.reference_2 != null && message.hasOwnProperty("reference_2"))
                    object.reference_2 = message.reference_2;
                if (message.reserved != null && message.hasOwnProperty("reserved"))
                    object.reserved = message.reserved;
                if (message.sellerBan != null && message.hasOwnProperty("sellerBan"))
                    object.sellerBan = message.sellerBan;
                if (message.sellerCode != null && message.hasOwnProperty("sellerCode"))
                    object.sellerCode = message.sellerCode;
                if (message.alwTransType != null && message.hasOwnProperty("alwTransType"))
                    object.alwTransType = message.alwTransType;
                if (message.isPaperAlw != null && message.hasOwnProperty("isPaperAlw"))
                    object.isPaperAlw = message.isPaperAlw;
                return object;
            };

            /**
             * Converts this ABanT1 to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.ABanT1
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ABanT1.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ABanT1;
        })();

        Protobuf.ABanT2 = (function() {

            /**
             * Properties of a ABanT2.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IABanT2
             * @property {string|null} [recordType] ABanT2 recordType
             * @property {string|null} [seqNo] ABanT2 seqNo
             * @property {string|null} [invoiceNo] ABanT2 invoiceNo
             * @property {string|null} [invoiceDate] ABanT2 invoiceDate
             * @property {string|null} [productName] ABanT2 productName
             * @property {string|null} [qty] ABanT2 qty
             * @property {string|null} [unitPrice] ABanT2 unitPrice
             * @property {string|null} [amout] ABanT2 amout
             * @property {string|null} [taxType] ABanT2 taxType
             * @property {string|null} [taxAmount] ABanT2 taxAmount
             * @property {string|null} [totalAmount] ABanT2 totalAmount
             * @property {string|null} [migProductName] ABanT2 migProductName
             */

            /**
             * Constructs a new ABanT2.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a ABanT2.
             * @implements IABanT2
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IABanT2=} [properties] Properties to set
             */
            function ABanT2(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ABanT2 recordType.
             * @member {string} recordType
             * @memberof TCBReceiptApi.Protobuf.ABanT2
             * @instance
             */
            ABanT2.prototype.recordType = "";

            /**
             * ABanT2 seqNo.
             * @member {string} seqNo
             * @memberof TCBReceiptApi.Protobuf.ABanT2
             * @instance
             */
            ABanT2.prototype.seqNo = "";

            /**
             * ABanT2 invoiceNo.
             * @member {string} invoiceNo
             * @memberof TCBReceiptApi.Protobuf.ABanT2
             * @instance
             */
            ABanT2.prototype.invoiceNo = "";

            /**
             * ABanT2 invoiceDate.
             * @member {string} invoiceDate
             * @memberof TCBReceiptApi.Protobuf.ABanT2
             * @instance
             */
            ABanT2.prototype.invoiceDate = "";

            /**
             * ABanT2 productName.
             * @member {string} productName
             * @memberof TCBReceiptApi.Protobuf.ABanT2
             * @instance
             */
            ABanT2.prototype.productName = "";

            /**
             * ABanT2 qty.
             * @member {string} qty
             * @memberof TCBReceiptApi.Protobuf.ABanT2
             * @instance
             */
            ABanT2.prototype.qty = "";

            /**
             * ABanT2 unitPrice.
             * @member {string} unitPrice
             * @memberof TCBReceiptApi.Protobuf.ABanT2
             * @instance
             */
            ABanT2.prototype.unitPrice = "";

            /**
             * ABanT2 amout.
             * @member {string} amout
             * @memberof TCBReceiptApi.Protobuf.ABanT2
             * @instance
             */
            ABanT2.prototype.amout = "";

            /**
             * ABanT2 taxType.
             * @member {string} taxType
             * @memberof TCBReceiptApi.Protobuf.ABanT2
             * @instance
             */
            ABanT2.prototype.taxType = "";

            /**
             * ABanT2 taxAmount.
             * @member {string} taxAmount
             * @memberof TCBReceiptApi.Protobuf.ABanT2
             * @instance
             */
            ABanT2.prototype.taxAmount = "";

            /**
             * ABanT2 totalAmount.
             * @member {string} totalAmount
             * @memberof TCBReceiptApi.Protobuf.ABanT2
             * @instance
             */
            ABanT2.prototype.totalAmount = "";

            /**
             * ABanT2 migProductName.
             * @member {string} migProductName
             * @memberof TCBReceiptApi.Protobuf.ABanT2
             * @instance
             */
            ABanT2.prototype.migProductName = "";

            /**
             * Creates a new ABanT2 instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.ABanT2
             * @static
             * @param {TCBReceiptApi.Protobuf.IABanT2=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.ABanT2} ABanT2 instance
             */
            ABanT2.create = function create(properties) {
                return new ABanT2(properties);
            };

            /**
             * Encodes the specified ABanT2 message. Does not implicitly {@link TCBReceiptApi.Protobuf.ABanT2.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.ABanT2
             * @static
             * @param {TCBReceiptApi.Protobuf.IABanT2} message ABanT2 message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ABanT2.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.recordType != null && Object.hasOwnProperty.call(message, "recordType"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.recordType);
                if (message.seqNo != null && Object.hasOwnProperty.call(message, "seqNo"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.seqNo);
                if (message.invoiceNo != null && Object.hasOwnProperty.call(message, "invoiceNo"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.invoiceNo);
                if (message.invoiceDate != null && Object.hasOwnProperty.call(message, "invoiceDate"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.invoiceDate);
                if (message.productName != null && Object.hasOwnProperty.call(message, "productName"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.productName);
                if (message.qty != null && Object.hasOwnProperty.call(message, "qty"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.qty);
                if (message.unitPrice != null && Object.hasOwnProperty.call(message, "unitPrice"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.unitPrice);
                if (message.amout != null && Object.hasOwnProperty.call(message, "amout"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.amout);
                if (message.taxType != null && Object.hasOwnProperty.call(message, "taxType"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.taxType);
                if (message.taxAmount != null && Object.hasOwnProperty.call(message, "taxAmount"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.taxAmount);
                if (message.totalAmount != null && Object.hasOwnProperty.call(message, "totalAmount"))
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.totalAmount);
                if (message.migProductName != null && Object.hasOwnProperty.call(message, "migProductName"))
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.migProductName);
                return writer;
            };

            /**
             * Encodes the specified ABanT2 message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.ABanT2.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ABanT2
             * @static
             * @param {TCBReceiptApi.Protobuf.IABanT2} message ABanT2 message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ABanT2.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ABanT2 message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.ABanT2
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.ABanT2} ABanT2
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ABanT2.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.ABanT2();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.recordType = reader.string();
                        break;
                    case 2:
                        message.seqNo = reader.string();
                        break;
                    case 3:
                        message.invoiceNo = reader.string();
                        break;
                    case 4:
                        message.invoiceDate = reader.string();
                        break;
                    case 5:
                        message.productName = reader.string();
                        break;
                    case 6:
                        message.qty = reader.string();
                        break;
                    case 7:
                        message.unitPrice = reader.string();
                        break;
                    case 8:
                        message.amout = reader.string();
                        break;
                    case 9:
                        message.taxType = reader.string();
                        break;
                    case 10:
                        message.taxAmount = reader.string();
                        break;
                    case 11:
                        message.totalAmount = reader.string();
                        break;
                    case 12:
                        message.migProductName = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ABanT2 message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ABanT2
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.ABanT2} ABanT2
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ABanT2.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ABanT2 message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.ABanT2
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ABanT2.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.recordType != null && message.hasOwnProperty("recordType"))
                    if (!$util.isString(message.recordType))
                        return "recordType: string expected";
                if (message.seqNo != null && message.hasOwnProperty("seqNo"))
                    if (!$util.isString(message.seqNo))
                        return "seqNo: string expected";
                if (message.invoiceNo != null && message.hasOwnProperty("invoiceNo"))
                    if (!$util.isString(message.invoiceNo))
                        return "invoiceNo: string expected";
                if (message.invoiceDate != null && message.hasOwnProperty("invoiceDate"))
                    if (!$util.isString(message.invoiceDate))
                        return "invoiceDate: string expected";
                if (message.productName != null && message.hasOwnProperty("productName"))
                    if (!$util.isString(message.productName))
                        return "productName: string expected";
                if (message.qty != null && message.hasOwnProperty("qty"))
                    if (!$util.isString(message.qty))
                        return "qty: string expected";
                if (message.unitPrice != null && message.hasOwnProperty("unitPrice"))
                    if (!$util.isString(message.unitPrice))
                        return "unitPrice: string expected";
                if (message.amout != null && message.hasOwnProperty("amout"))
                    if (!$util.isString(message.amout))
                        return "amout: string expected";
                if (message.taxType != null && message.hasOwnProperty("taxType"))
                    if (!$util.isString(message.taxType))
                        return "taxType: string expected";
                if (message.taxAmount != null && message.hasOwnProperty("taxAmount"))
                    if (!$util.isString(message.taxAmount))
                        return "taxAmount: string expected";
                if (message.totalAmount != null && message.hasOwnProperty("totalAmount"))
                    if (!$util.isString(message.totalAmount))
                        return "totalAmount: string expected";
                if (message.migProductName != null && message.hasOwnProperty("migProductName"))
                    if (!$util.isString(message.migProductName))
                        return "migProductName: string expected";
                return null;
            };

            /**
             * Creates a ABanT2 message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.ABanT2
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.ABanT2} ABanT2
             */
            ABanT2.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.ABanT2)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.ABanT2();
                if (object.recordType != null)
                    message.recordType = String(object.recordType);
                if (object.seqNo != null)
                    message.seqNo = String(object.seqNo);
                if (object.invoiceNo != null)
                    message.invoiceNo = String(object.invoiceNo);
                if (object.invoiceDate != null)
                    message.invoiceDate = String(object.invoiceDate);
                if (object.productName != null)
                    message.productName = String(object.productName);
                if (object.qty != null)
                    message.qty = String(object.qty);
                if (object.unitPrice != null)
                    message.unitPrice = String(object.unitPrice);
                if (object.amout != null)
                    message.amout = String(object.amout);
                if (object.taxType != null)
                    message.taxType = String(object.taxType);
                if (object.taxAmount != null)
                    message.taxAmount = String(object.taxAmount);
                if (object.totalAmount != null)
                    message.totalAmount = String(object.totalAmount);
                if (object.migProductName != null)
                    message.migProductName = String(object.migProductName);
                return message;
            };

            /**
             * Creates a plain object from a ABanT2 message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.ABanT2
             * @static
             * @param {TCBReceiptApi.Protobuf.ABanT2} message ABanT2
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ABanT2.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.recordType = "";
                    object.seqNo = "";
                    object.invoiceNo = "";
                    object.invoiceDate = "";
                    object.productName = "";
                    object.qty = "";
                    object.unitPrice = "";
                    object.amout = "";
                    object.taxType = "";
                    object.taxAmount = "";
                    object.totalAmount = "";
                    object.migProductName = "";
                }
                if (message.recordType != null && message.hasOwnProperty("recordType"))
                    object.recordType = message.recordType;
                if (message.seqNo != null && message.hasOwnProperty("seqNo"))
                    object.seqNo = message.seqNo;
                if (message.invoiceNo != null && message.hasOwnProperty("invoiceNo"))
                    object.invoiceNo = message.invoiceNo;
                if (message.invoiceDate != null && message.hasOwnProperty("invoiceDate"))
                    object.invoiceDate = message.invoiceDate;
                if (message.productName != null && message.hasOwnProperty("productName"))
                    object.productName = message.productName;
                if (message.qty != null && message.hasOwnProperty("qty"))
                    object.qty = message.qty;
                if (message.unitPrice != null && message.hasOwnProperty("unitPrice"))
                    object.unitPrice = message.unitPrice;
                if (message.amout != null && message.hasOwnProperty("amout"))
                    object.amout = message.amout;
                if (message.taxType != null && message.hasOwnProperty("taxType"))
                    object.taxType = message.taxType;
                if (message.taxAmount != null && message.hasOwnProperty("taxAmount"))
                    object.taxAmount = message.taxAmount;
                if (message.totalAmount != null && message.hasOwnProperty("totalAmount"))
                    object.totalAmount = message.totalAmount;
                if (message.migProductName != null && message.hasOwnProperty("migProductName"))
                    object.migProductName = message.migProductName;
                return object;
            };

            /**
             * Converts this ABanT2 to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.ABanT2
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ABanT2.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ABanT2;
        })();

        Protobuf.ABan = (function() {

            /**
             * Properties of a ABan.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IABan
             * @property {TCBReceiptApi.Protobuf.IABanT1|null} [a1] ABan a1
             * @property {Array.<TCBReceiptApi.Protobuf.IABanT2>|null} [a2List] ABan a2List
             */

            /**
             * Constructs a new ABan.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a ABan.
             * @implements IABan
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IABan=} [properties] Properties to set
             */
            function ABan(properties) {
                this.a2List = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ABan a1.
             * @member {TCBReceiptApi.Protobuf.IABanT1|null|undefined} a1
             * @memberof TCBReceiptApi.Protobuf.ABan
             * @instance
             */
            ABan.prototype.a1 = null;

            /**
             * ABan a2List.
             * @member {Array.<TCBReceiptApi.Protobuf.IABanT2>} a2List
             * @memberof TCBReceiptApi.Protobuf.ABan
             * @instance
             */
            ABan.prototype.a2List = $util.emptyArray;

            /**
             * Creates a new ABan instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.ABan
             * @static
             * @param {TCBReceiptApi.Protobuf.IABan=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.ABan} ABan instance
             */
            ABan.create = function create(properties) {
                return new ABan(properties);
            };

            /**
             * Encodes the specified ABan message. Does not implicitly {@link TCBReceiptApi.Protobuf.ABan.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.ABan
             * @static
             * @param {TCBReceiptApi.Protobuf.IABan} message ABan message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ABan.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.a1 != null && Object.hasOwnProperty.call(message, "a1"))
                    $root.TCBReceiptApi.Protobuf.ABanT1.encode(message.a1, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.a2List != null && message.a2List.length)
                    for (var i = 0; i < message.a2List.length; ++i)
                        $root.TCBReceiptApi.Protobuf.ABanT2.encode(message.a2List[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ABan message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.ABan.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ABan
             * @static
             * @param {TCBReceiptApi.Protobuf.IABan} message ABan message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ABan.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ABan message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.ABan
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.ABan} ABan
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ABan.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.ABan();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.a1 = $root.TCBReceiptApi.Protobuf.ABanT1.decode(reader, reader.uint32());
                        break;
                    case 2:
                        if (!(message.a2List && message.a2List.length))
                            message.a2List = [];
                        message.a2List.push($root.TCBReceiptApi.Protobuf.ABanT2.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ABan message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ABan
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.ABan} ABan
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ABan.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ABan message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.ABan
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ABan.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.a1 != null && message.hasOwnProperty("a1")) {
                    var error = $root.TCBReceiptApi.Protobuf.ABanT1.verify(message.a1);
                    if (error)
                        return "a1." + error;
                }
                if (message.a2List != null && message.hasOwnProperty("a2List")) {
                    if (!Array.isArray(message.a2List))
                        return "a2List: array expected";
                    for (var i = 0; i < message.a2List.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.ABanT2.verify(message.a2List[i]);
                        if (error)
                            return "a2List." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a ABan message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.ABan
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.ABan} ABan
             */
            ABan.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.ABan)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.ABan();
                if (object.a1 != null) {
                    if (typeof object.a1 !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.ABan.a1: object expected");
                    message.a1 = $root.TCBReceiptApi.Protobuf.ABanT1.fromObject(object.a1);
                }
                if (object.a2List) {
                    if (!Array.isArray(object.a2List))
                        throw TypeError(".TCBReceiptApi.Protobuf.ABan.a2List: array expected");
                    message.a2List = [];
                    for (var i = 0; i < object.a2List.length; ++i) {
                        if (typeof object.a2List[i] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.ABan.a2List: object expected");
                        message.a2List[i] = $root.TCBReceiptApi.Protobuf.ABanT2.fromObject(object.a2List[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a ABan message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.ABan
             * @static
             * @param {TCBReceiptApi.Protobuf.ABan} message ABan
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ABan.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.a2List = [];
                if (options.defaults)
                    object.a1 = null;
                if (message.a1 != null && message.hasOwnProperty("a1"))
                    object.a1 = $root.TCBReceiptApi.Protobuf.ABanT1.toObject(message.a1, options);
                if (message.a2List && message.a2List.length) {
                    object.a2List = [];
                    for (var j = 0; j < message.a2List.length; ++j)
                        object.a2List[j] = $root.TCBReceiptApi.Protobuf.ABanT2.toObject(message.a2List[j], options);
                }
                return object;
            };

            /**
             * Converts this ABan to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.ABan
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ABan.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ABan;
        })();

        Protobuf.RPT = (function() {

            /**
             * Properties of a RPT.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IRPT
             * @property {string|null} [dataStatus] RPT dataStatus
             * @property {string|null} [retailerId] RPT retailerId
             * @property {string|null} [supplierCode] RPT supplierCode
             * @property {string|null} [receiptDate] RPT receiptDate
             * @property {string|null} [receiptNo] RPT receiptNo
             * @property {string|null} [invoiceNo] RPT invoiceNo
             * @property {string|null} [invoiceStatus] RPT invoiceStatus
             * @property {string|null} [totalAmount] RPT totalAmount
             * @property {string|null} [storeCode] RPT storeCode
             * @property {string|null} [sellerPerson] RPT sellerPerson
             * @property {string|null} [amountNative] RPT amountNative
             * @property {string|null} [amountForeign] RPT amountForeign
             */

            /**
             * Constructs a new RPT.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a RPT.
             * @implements IRPT
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IRPT=} [properties] Properties to set
             */
            function RPT(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * RPT dataStatus.
             * @member {string} dataStatus
             * @memberof TCBReceiptApi.Protobuf.RPT
             * @instance
             */
            RPT.prototype.dataStatus = "";

            /**
             * RPT retailerId.
             * @member {string} retailerId
             * @memberof TCBReceiptApi.Protobuf.RPT
             * @instance
             */
            RPT.prototype.retailerId = "";

            /**
             * RPT supplierCode.
             * @member {string} supplierCode
             * @memberof TCBReceiptApi.Protobuf.RPT
             * @instance
             */
            RPT.prototype.supplierCode = "";

            /**
             * RPT receiptDate.
             * @member {string} receiptDate
             * @memberof TCBReceiptApi.Protobuf.RPT
             * @instance
             */
            RPT.prototype.receiptDate = "";

            /**
             * RPT receiptNo.
             * @member {string} receiptNo
             * @memberof TCBReceiptApi.Protobuf.RPT
             * @instance
             */
            RPT.prototype.receiptNo = "";

            /**
             * RPT invoiceNo.
             * @member {string} invoiceNo
             * @memberof TCBReceiptApi.Protobuf.RPT
             * @instance
             */
            RPT.prototype.invoiceNo = "";

            /**
             * RPT invoiceStatus.
             * @member {string} invoiceStatus
             * @memberof TCBReceiptApi.Protobuf.RPT
             * @instance
             */
            RPT.prototype.invoiceStatus = "";

            /**
             * RPT totalAmount.
             * @member {string} totalAmount
             * @memberof TCBReceiptApi.Protobuf.RPT
             * @instance
             */
            RPT.prototype.totalAmount = "";

            /**
             * RPT storeCode.
             * @member {string} storeCode
             * @memberof TCBReceiptApi.Protobuf.RPT
             * @instance
             */
            RPT.prototype.storeCode = "";

            /**
             * RPT sellerPerson.
             * @member {string} sellerPerson
             * @memberof TCBReceiptApi.Protobuf.RPT
             * @instance
             */
            RPT.prototype.sellerPerson = "";

            /**
             * RPT amountNative.
             * @member {string} amountNative
             * @memberof TCBReceiptApi.Protobuf.RPT
             * @instance
             */
            RPT.prototype.amountNative = "";

            /**
             * RPT amountForeign.
             * @member {string} amountForeign
             * @memberof TCBReceiptApi.Protobuf.RPT
             * @instance
             */
            RPT.prototype.amountForeign = "";

            /**
             * Creates a new RPT instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.RPT
             * @static
             * @param {TCBReceiptApi.Protobuf.IRPT=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.RPT} RPT instance
             */
            RPT.create = function create(properties) {
                return new RPT(properties);
            };

            /**
             * Encodes the specified RPT message. Does not implicitly {@link TCBReceiptApi.Protobuf.RPT.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.RPT
             * @static
             * @param {TCBReceiptApi.Protobuf.IRPT} message RPT message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RPT.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.dataStatus != null && Object.hasOwnProperty.call(message, "dataStatus"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.dataStatus);
                if (message.retailerId != null && Object.hasOwnProperty.call(message, "retailerId"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.retailerId);
                if (message.supplierCode != null && Object.hasOwnProperty.call(message, "supplierCode"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.supplierCode);
                if (message.receiptDate != null && Object.hasOwnProperty.call(message, "receiptDate"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.receiptDate);
                if (message.receiptNo != null && Object.hasOwnProperty.call(message, "receiptNo"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.receiptNo);
                if (message.invoiceNo != null && Object.hasOwnProperty.call(message, "invoiceNo"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.invoiceNo);
                if (message.invoiceStatus != null && Object.hasOwnProperty.call(message, "invoiceStatus"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.invoiceStatus);
                if (message.totalAmount != null && Object.hasOwnProperty.call(message, "totalAmount"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.totalAmount);
                if (message.storeCode != null && Object.hasOwnProperty.call(message, "storeCode"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.storeCode);
                if (message.sellerPerson != null && Object.hasOwnProperty.call(message, "sellerPerson"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.sellerPerson);
                if (message.amountNative != null && Object.hasOwnProperty.call(message, "amountNative"))
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.amountNative);
                if (message.amountForeign != null && Object.hasOwnProperty.call(message, "amountForeign"))
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.amountForeign);
                return writer;
            };

            /**
             * Encodes the specified RPT message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.RPT.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.RPT
             * @static
             * @param {TCBReceiptApi.Protobuf.IRPT} message RPT message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RPT.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RPT message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.RPT
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.RPT} RPT
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RPT.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.RPT();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.dataStatus = reader.string();
                        break;
                    case 2:
                        message.retailerId = reader.string();
                        break;
                    case 3:
                        message.supplierCode = reader.string();
                        break;
                    case 4:
                        message.receiptDate = reader.string();
                        break;
                    case 5:
                        message.receiptNo = reader.string();
                        break;
                    case 6:
                        message.invoiceNo = reader.string();
                        break;
                    case 7:
                        message.invoiceStatus = reader.string();
                        break;
                    case 8:
                        message.totalAmount = reader.string();
                        break;
                    case 9:
                        message.storeCode = reader.string();
                        break;
                    case 10:
                        message.sellerPerson = reader.string();
                        break;
                    case 11:
                        message.amountNative = reader.string();
                        break;
                    case 12:
                        message.amountForeign = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RPT message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.RPT
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.RPT} RPT
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RPT.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RPT message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.RPT
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RPT.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.dataStatus != null && message.hasOwnProperty("dataStatus"))
                    if (!$util.isString(message.dataStatus))
                        return "dataStatus: string expected";
                if (message.retailerId != null && message.hasOwnProperty("retailerId"))
                    if (!$util.isString(message.retailerId))
                        return "retailerId: string expected";
                if (message.supplierCode != null && message.hasOwnProperty("supplierCode"))
                    if (!$util.isString(message.supplierCode))
                        return "supplierCode: string expected";
                if (message.receiptDate != null && message.hasOwnProperty("receiptDate"))
                    if (!$util.isString(message.receiptDate))
                        return "receiptDate: string expected";
                if (message.receiptNo != null && message.hasOwnProperty("receiptNo"))
                    if (!$util.isString(message.receiptNo))
                        return "receiptNo: string expected";
                if (message.invoiceNo != null && message.hasOwnProperty("invoiceNo"))
                    if (!$util.isString(message.invoiceNo))
                        return "invoiceNo: string expected";
                if (message.invoiceStatus != null && message.hasOwnProperty("invoiceStatus"))
                    if (!$util.isString(message.invoiceStatus))
                        return "invoiceStatus: string expected";
                if (message.totalAmount != null && message.hasOwnProperty("totalAmount"))
                    if (!$util.isString(message.totalAmount))
                        return "totalAmount: string expected";
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    if (!$util.isString(message.storeCode))
                        return "storeCode: string expected";
                if (message.sellerPerson != null && message.hasOwnProperty("sellerPerson"))
                    if (!$util.isString(message.sellerPerson))
                        return "sellerPerson: string expected";
                if (message.amountNative != null && message.hasOwnProperty("amountNative"))
                    if (!$util.isString(message.amountNative))
                        return "amountNative: string expected";
                if (message.amountForeign != null && message.hasOwnProperty("amountForeign"))
                    if (!$util.isString(message.amountForeign))
                        return "amountForeign: string expected";
                return null;
            };

            /**
             * Creates a RPT message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.RPT
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.RPT} RPT
             */
            RPT.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.RPT)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.RPT();
                if (object.dataStatus != null)
                    message.dataStatus = String(object.dataStatus);
                if (object.retailerId != null)
                    message.retailerId = String(object.retailerId);
                if (object.supplierCode != null)
                    message.supplierCode = String(object.supplierCode);
                if (object.receiptDate != null)
                    message.receiptDate = String(object.receiptDate);
                if (object.receiptNo != null)
                    message.receiptNo = String(object.receiptNo);
                if (object.invoiceNo != null)
                    message.invoiceNo = String(object.invoiceNo);
                if (object.invoiceStatus != null)
                    message.invoiceStatus = String(object.invoiceStatus);
                if (object.totalAmount != null)
                    message.totalAmount = String(object.totalAmount);
                if (object.storeCode != null)
                    message.storeCode = String(object.storeCode);
                if (object.sellerPerson != null)
                    message.sellerPerson = String(object.sellerPerson);
                if (object.amountNative != null)
                    message.amountNative = String(object.amountNative);
                if (object.amountForeign != null)
                    message.amountForeign = String(object.amountForeign);
                return message;
            };

            /**
             * Creates a plain object from a RPT message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.RPT
             * @static
             * @param {TCBReceiptApi.Protobuf.RPT} message RPT
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RPT.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.dataStatus = "";
                    object.retailerId = "";
                    object.supplierCode = "";
                    object.receiptDate = "";
                    object.receiptNo = "";
                    object.invoiceNo = "";
                    object.invoiceStatus = "";
                    object.totalAmount = "";
                    object.storeCode = "";
                    object.sellerPerson = "";
                    object.amountNative = "";
                    object.amountForeign = "";
                }
                if (message.dataStatus != null && message.hasOwnProperty("dataStatus"))
                    object.dataStatus = message.dataStatus;
                if (message.retailerId != null && message.hasOwnProperty("retailerId"))
                    object.retailerId = message.retailerId;
                if (message.supplierCode != null && message.hasOwnProperty("supplierCode"))
                    object.supplierCode = message.supplierCode;
                if (message.receiptDate != null && message.hasOwnProperty("receiptDate"))
                    object.receiptDate = message.receiptDate;
                if (message.receiptNo != null && message.hasOwnProperty("receiptNo"))
                    object.receiptNo = message.receiptNo;
                if (message.invoiceNo != null && message.hasOwnProperty("invoiceNo"))
                    object.invoiceNo = message.invoiceNo;
                if (message.invoiceStatus != null && message.hasOwnProperty("invoiceStatus"))
                    object.invoiceStatus = message.invoiceStatus;
                if (message.totalAmount != null && message.hasOwnProperty("totalAmount"))
                    object.totalAmount = message.totalAmount;
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    object.storeCode = message.storeCode;
                if (message.sellerPerson != null && message.hasOwnProperty("sellerPerson"))
                    object.sellerPerson = message.sellerPerson;
                if (message.amountNative != null && message.hasOwnProperty("amountNative"))
                    object.amountNative = message.amountNative;
                if (message.amountForeign != null && message.hasOwnProperty("amountForeign"))
                    object.amountForeign = message.amountForeign;
                return object;
            };

            /**
             * Converts this RPT to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.RPT
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RPT.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return RPT;
        })();

        Protobuf.AckRaw = (function() {

            /**
             * Properties of an AckRaw.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAckRaw
             * @property {string|null} [invoiceNo] AckRaw invoiceNo
             * @property {string|null} [invoiceDate] AckRaw invoiceDate
             * @property {string|null} [status] AckRaw status
             * @property {string|null} [buyerBan] AckRaw buyerBan
             * @property {string|null} [sellerBan] AckRaw sellerBan
             * @property {string|null} [reason] AckRaw reason
             */

            /**
             * Constructs a new AckRaw.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an AckRaw.
             * @implements IAckRaw
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAckRaw=} [properties] Properties to set
             */
            function AckRaw(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * AckRaw invoiceNo.
             * @member {string} invoiceNo
             * @memberof TCBReceiptApi.Protobuf.AckRaw
             * @instance
             */
            AckRaw.prototype.invoiceNo = "";

            /**
             * AckRaw invoiceDate.
             * @member {string} invoiceDate
             * @memberof TCBReceiptApi.Protobuf.AckRaw
             * @instance
             */
            AckRaw.prototype.invoiceDate = "";

            /**
             * AckRaw status.
             * @member {string} status
             * @memberof TCBReceiptApi.Protobuf.AckRaw
             * @instance
             */
            AckRaw.prototype.status = "";

            /**
             * AckRaw buyerBan.
             * @member {string} buyerBan
             * @memberof TCBReceiptApi.Protobuf.AckRaw
             * @instance
             */
            AckRaw.prototype.buyerBan = "";

            /**
             * AckRaw sellerBan.
             * @member {string} sellerBan
             * @memberof TCBReceiptApi.Protobuf.AckRaw
             * @instance
             */
            AckRaw.prototype.sellerBan = "";

            /**
             * AckRaw reason.
             * @member {string} reason
             * @memberof TCBReceiptApi.Protobuf.AckRaw
             * @instance
             */
            AckRaw.prototype.reason = "";

            /**
             * Creates a new AckRaw instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.AckRaw
             * @static
             * @param {TCBReceiptApi.Protobuf.IAckRaw=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.AckRaw} AckRaw instance
             */
            AckRaw.create = function create(properties) {
                return new AckRaw(properties);
            };

            /**
             * Encodes the specified AckRaw message. Does not implicitly {@link TCBReceiptApi.Protobuf.AckRaw.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.AckRaw
             * @static
             * @param {TCBReceiptApi.Protobuf.IAckRaw} message AckRaw message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AckRaw.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.invoiceNo != null && Object.hasOwnProperty.call(message, "invoiceNo"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.invoiceNo);
                if (message.invoiceDate != null && Object.hasOwnProperty.call(message, "invoiceDate"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.invoiceDate);
                if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.status);
                if (message.buyerBan != null && Object.hasOwnProperty.call(message, "buyerBan"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.buyerBan);
                if (message.sellerBan != null && Object.hasOwnProperty.call(message, "sellerBan"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.sellerBan);
                if (message.reason != null && Object.hasOwnProperty.call(message, "reason"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.reason);
                return writer;
            };

            /**
             * Encodes the specified AckRaw message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.AckRaw.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AckRaw
             * @static
             * @param {TCBReceiptApi.Protobuf.IAckRaw} message AckRaw message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AckRaw.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AckRaw message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.AckRaw
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.AckRaw} AckRaw
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AckRaw.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.AckRaw();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.invoiceNo = reader.string();
                        break;
                    case 2:
                        message.invoiceDate = reader.string();
                        break;
                    case 3:
                        message.status = reader.string();
                        break;
                    case 4:
                        message.buyerBan = reader.string();
                        break;
                    case 5:
                        message.sellerBan = reader.string();
                        break;
                    case 6:
                        message.reason = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AckRaw message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.AckRaw
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.AckRaw} AckRaw
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AckRaw.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AckRaw message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.AckRaw
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AckRaw.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.invoiceNo != null && message.hasOwnProperty("invoiceNo"))
                    if (!$util.isString(message.invoiceNo))
                        return "invoiceNo: string expected";
                if (message.invoiceDate != null && message.hasOwnProperty("invoiceDate"))
                    if (!$util.isString(message.invoiceDate))
                        return "invoiceDate: string expected";
                if (message.status != null && message.hasOwnProperty("status"))
                    if (!$util.isString(message.status))
                        return "status: string expected";
                if (message.buyerBan != null && message.hasOwnProperty("buyerBan"))
                    if (!$util.isString(message.buyerBan))
                        return "buyerBan: string expected";
                if (message.sellerBan != null && message.hasOwnProperty("sellerBan"))
                    if (!$util.isString(message.sellerBan))
                        return "sellerBan: string expected";
                if (message.reason != null && message.hasOwnProperty("reason"))
                    if (!$util.isString(message.reason))
                        return "reason: string expected";
                return null;
            };

            /**
             * Creates an AckRaw message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.AckRaw
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.AckRaw} AckRaw
             */
            AckRaw.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.AckRaw)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.AckRaw();
                if (object.invoiceNo != null)
                    message.invoiceNo = String(object.invoiceNo);
                if (object.invoiceDate != null)
                    message.invoiceDate = String(object.invoiceDate);
                if (object.status != null)
                    message.status = String(object.status);
                if (object.buyerBan != null)
                    message.buyerBan = String(object.buyerBan);
                if (object.sellerBan != null)
                    message.sellerBan = String(object.sellerBan);
                if (object.reason != null)
                    message.reason = String(object.reason);
                return message;
            };

            /**
             * Creates a plain object from an AckRaw message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.AckRaw
             * @static
             * @param {TCBReceiptApi.Protobuf.AckRaw} message AckRaw
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AckRaw.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.invoiceNo = "";
                    object.invoiceDate = "";
                    object.status = "";
                    object.buyerBan = "";
                    object.sellerBan = "";
                    object.reason = "";
                }
                if (message.invoiceNo != null && message.hasOwnProperty("invoiceNo"))
                    object.invoiceNo = message.invoiceNo;
                if (message.invoiceDate != null && message.hasOwnProperty("invoiceDate"))
                    object.invoiceDate = message.invoiceDate;
                if (message.status != null && message.hasOwnProperty("status"))
                    object.status = message.status;
                if (message.buyerBan != null && message.hasOwnProperty("buyerBan"))
                    object.buyerBan = message.buyerBan;
                if (message.sellerBan != null && message.hasOwnProperty("sellerBan"))
                    object.sellerBan = message.sellerBan;
                if (message.reason != null && message.hasOwnProperty("reason"))
                    object.reason = message.reason;
                return object;
            };

            /**
             * Converts this AckRaw to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.AckRaw
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AckRaw.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AckRaw;
        })();

        Protobuf.Ack = (function() {

            /**
             * Properties of an Ack.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IAck
             * @property {number|null} [receiptAckId] Ack receiptAckId
             * @property {number|null} [type] Ack type
             * @property {string|null} [number] Ack number
             * @property {string|null} [date] Ack date
             * @property {string|null} [tidNumber] Ack tidNumber
             * @property {string|null} [sellerNumber] Ack sellerNumber
             * @property {number|null} [generateMethod] Ack generateMethod
             * @property {string|null} [fileName] Ack fileName
             * @property {number|null} [state] Ack state
             * @property {string|null} [returnReason] Ack returnReason
             * @property {string|null} [recordDate] Ack recordDate
             * @property {string|null} [hash] Ack hash
             */

            /**
             * Constructs a new Ack.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents an Ack.
             * @implements IAck
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IAck=} [properties] Properties to set
             */
            function Ack(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Ack receiptAckId.
             * @member {number} receiptAckId
             * @memberof TCBReceiptApi.Protobuf.Ack
             * @instance
             */
            Ack.prototype.receiptAckId = 0;

            /**
             * Ack type.
             * @member {number} type
             * @memberof TCBReceiptApi.Protobuf.Ack
             * @instance
             */
            Ack.prototype.type = 0;

            /**
             * Ack number.
             * @member {string} number
             * @memberof TCBReceiptApi.Protobuf.Ack
             * @instance
             */
            Ack.prototype.number = "";

            /**
             * Ack date.
             * @member {string} date
             * @memberof TCBReceiptApi.Protobuf.Ack
             * @instance
             */
            Ack.prototype.date = "";

            /**
             * Ack tidNumber.
             * @member {string} tidNumber
             * @memberof TCBReceiptApi.Protobuf.Ack
             * @instance
             */
            Ack.prototype.tidNumber = "";

            /**
             * Ack sellerNumber.
             * @member {string} sellerNumber
             * @memberof TCBReceiptApi.Protobuf.Ack
             * @instance
             */
            Ack.prototype.sellerNumber = "";

            /**
             * Ack generateMethod.
             * @member {number} generateMethod
             * @memberof TCBReceiptApi.Protobuf.Ack
             * @instance
             */
            Ack.prototype.generateMethod = 0;

            /**
             * Ack fileName.
             * @member {string} fileName
             * @memberof TCBReceiptApi.Protobuf.Ack
             * @instance
             */
            Ack.prototype.fileName = "";

            /**
             * Ack state.
             * @member {number} state
             * @memberof TCBReceiptApi.Protobuf.Ack
             * @instance
             */
            Ack.prototype.state = 0;

            /**
             * Ack returnReason.
             * @member {string} returnReason
             * @memberof TCBReceiptApi.Protobuf.Ack
             * @instance
             */
            Ack.prototype.returnReason = "";

            /**
             * Ack recordDate.
             * @member {string} recordDate
             * @memberof TCBReceiptApi.Protobuf.Ack
             * @instance
             */
            Ack.prototype.recordDate = "";

            /**
             * Ack hash.
             * @member {string} hash
             * @memberof TCBReceiptApi.Protobuf.Ack
             * @instance
             */
            Ack.prototype.hash = "";

            /**
             * Creates a new Ack instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.Ack
             * @static
             * @param {TCBReceiptApi.Protobuf.IAck=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.Ack} Ack instance
             */
            Ack.create = function create(properties) {
                return new Ack(properties);
            };

            /**
             * Encodes the specified Ack message. Does not implicitly {@link TCBReceiptApi.Protobuf.Ack.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.Ack
             * @static
             * @param {TCBReceiptApi.Protobuf.IAck} message Ack message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Ack.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.receiptAckId != null && Object.hasOwnProperty.call(message, "receiptAckId"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.receiptAckId);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.type);
                if (message.number != null && Object.hasOwnProperty.call(message, "number"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.number);
                if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.date);
                if (message.tidNumber != null && Object.hasOwnProperty.call(message, "tidNumber"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.tidNumber);
                if (message.sellerNumber != null && Object.hasOwnProperty.call(message, "sellerNumber"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.sellerNumber);
                if (message.generateMethod != null && Object.hasOwnProperty.call(message, "generateMethod"))
                    writer.uint32(/* id 7, wireType 0 =*/56).int32(message.generateMethod);
                if (message.fileName != null && Object.hasOwnProperty.call(message, "fileName"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.fileName);
                if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                    writer.uint32(/* id 9, wireType 0 =*/72).int32(message.state);
                if (message.returnReason != null && Object.hasOwnProperty.call(message, "returnReason"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.returnReason);
                if (message.recordDate != null && Object.hasOwnProperty.call(message, "recordDate"))
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.recordDate);
                if (message.hash != null && Object.hasOwnProperty.call(message, "hash"))
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.hash);
                return writer;
            };

            /**
             * Encodes the specified Ack message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.Ack.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.Ack
             * @static
             * @param {TCBReceiptApi.Protobuf.IAck} message Ack message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Ack.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Ack message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.Ack
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.Ack} Ack
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Ack.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.Ack();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.receiptAckId = reader.int32();
                        break;
                    case 2:
                        message.type = reader.int32();
                        break;
                    case 3:
                        message.number = reader.string();
                        break;
                    case 4:
                        message.date = reader.string();
                        break;
                    case 5:
                        message.tidNumber = reader.string();
                        break;
                    case 6:
                        message.sellerNumber = reader.string();
                        break;
                    case 7:
                        message.generateMethod = reader.int32();
                        break;
                    case 8:
                        message.fileName = reader.string();
                        break;
                    case 9:
                        message.state = reader.int32();
                        break;
                    case 10:
                        message.returnReason = reader.string();
                        break;
                    case 11:
                        message.recordDate = reader.string();
                        break;
                    case 12:
                        message.hash = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Ack message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.Ack
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.Ack} Ack
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Ack.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Ack message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.Ack
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Ack.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.receiptAckId != null && message.hasOwnProperty("receiptAckId"))
                    if (!$util.isInteger(message.receiptAckId))
                        return "receiptAckId: integer expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isInteger(message.type))
                        return "type: integer expected";
                if (message.number != null && message.hasOwnProperty("number"))
                    if (!$util.isString(message.number))
                        return "number: string expected";
                if (message.date != null && message.hasOwnProperty("date"))
                    if (!$util.isString(message.date))
                        return "date: string expected";
                if (message.tidNumber != null && message.hasOwnProperty("tidNumber"))
                    if (!$util.isString(message.tidNumber))
                        return "tidNumber: string expected";
                if (message.sellerNumber != null && message.hasOwnProperty("sellerNumber"))
                    if (!$util.isString(message.sellerNumber))
                        return "sellerNumber: string expected";
                if (message.generateMethod != null && message.hasOwnProperty("generateMethod"))
                    if (!$util.isInteger(message.generateMethod))
                        return "generateMethod: integer expected";
                if (message.fileName != null && message.hasOwnProperty("fileName"))
                    if (!$util.isString(message.fileName))
                        return "fileName: string expected";
                if (message.state != null && message.hasOwnProperty("state"))
                    if (!$util.isInteger(message.state))
                        return "state: integer expected";
                if (message.returnReason != null && message.hasOwnProperty("returnReason"))
                    if (!$util.isString(message.returnReason))
                        return "returnReason: string expected";
                if (message.recordDate != null && message.hasOwnProperty("recordDate"))
                    if (!$util.isString(message.recordDate))
                        return "recordDate: string expected";
                if (message.hash != null && message.hasOwnProperty("hash"))
                    if (!$util.isString(message.hash))
                        return "hash: string expected";
                return null;
            };

            /**
             * Creates an Ack message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.Ack
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.Ack} Ack
             */
            Ack.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.Ack)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.Ack();
                if (object.receiptAckId != null)
                    message.receiptAckId = object.receiptAckId | 0;
                if (object.type != null)
                    message.type = object.type | 0;
                if (object.number != null)
                    message.number = String(object.number);
                if (object.date != null)
                    message.date = String(object.date);
                if (object.tidNumber != null)
                    message.tidNumber = String(object.tidNumber);
                if (object.sellerNumber != null)
                    message.sellerNumber = String(object.sellerNumber);
                if (object.generateMethod != null)
                    message.generateMethod = object.generateMethod | 0;
                if (object.fileName != null)
                    message.fileName = String(object.fileName);
                if (object.state != null)
                    message.state = object.state | 0;
                if (object.returnReason != null)
                    message.returnReason = String(object.returnReason);
                if (object.recordDate != null)
                    message.recordDate = String(object.recordDate);
                if (object.hash != null)
                    message.hash = String(object.hash);
                return message;
            };

            /**
             * Creates a plain object from an Ack message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.Ack
             * @static
             * @param {TCBReceiptApi.Protobuf.Ack} message Ack
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Ack.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.receiptAckId = 0;
                    object.type = 0;
                    object.number = "";
                    object.date = "";
                    object.tidNumber = "";
                    object.sellerNumber = "";
                    object.generateMethod = 0;
                    object.fileName = "";
                    object.state = 0;
                    object.returnReason = "";
                    object.recordDate = "";
                    object.hash = "";
                }
                if (message.receiptAckId != null && message.hasOwnProperty("receiptAckId"))
                    object.receiptAckId = message.receiptAckId;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.number != null && message.hasOwnProperty("number"))
                    object.number = message.number;
                if (message.date != null && message.hasOwnProperty("date"))
                    object.date = message.date;
                if (message.tidNumber != null && message.hasOwnProperty("tidNumber"))
                    object.tidNumber = message.tidNumber;
                if (message.sellerNumber != null && message.hasOwnProperty("sellerNumber"))
                    object.sellerNumber = message.sellerNumber;
                if (message.generateMethod != null && message.hasOwnProperty("generateMethod"))
                    object.generateMethod = message.generateMethod;
                if (message.fileName != null && message.hasOwnProperty("fileName"))
                    object.fileName = message.fileName;
                if (message.state != null && message.hasOwnProperty("state"))
                    object.state = message.state;
                if (message.returnReason != null && message.hasOwnProperty("returnReason"))
                    object.returnReason = message.returnReason;
                if (message.recordDate != null && message.hasOwnProperty("recordDate"))
                    object.recordDate = message.recordDate;
                if (message.hash != null && message.hasOwnProperty("hash"))
                    object.hash = message.hash;
                return object;
            };

            /**
             * Converts this Ack to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.Ack
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Ack.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Ack;
        })();

        /**
         * PermissionType enum.
         * @name TCBReceiptApi.Protobuf.PermissionType
         * @enum {number}
         * @property {number} PT_NONE=0 PT_NONE value
         * @property {number} PT_GET=1 PT_GET value
         * @property {number} PT_ADD=2 PT_ADD value
         * @property {number} PT_EDIT=3 PT_EDIT value
         * @property {number} PT_DELETE=4 PT_DELETE value
         * @property {number} PT_RELEASE=5 PT_RELEASE value
         */
        Protobuf.PermissionType = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "PT_NONE"] = 0;
            values[valuesById[1] = "PT_GET"] = 1;
            values[valuesById[2] = "PT_ADD"] = 2;
            values[valuesById[3] = "PT_EDIT"] = 3;
            values[valuesById[4] = "PT_DELETE"] = 4;
            values[valuesById[5] = "PT_RELEASE"] = 5;
            return values;
        })();

        /**
         * StoreGroupType enum.
         * @name TCBReceiptApi.Protobuf.StoreGroupType
         * @enum {number}
         * @property {number} SGT_NONE_1=0 SGT_NONE_1 value
         * @property {number} SGT_STORE=1 SGT_STORE value
         * @property {number} SGT_RECONCILIATION=2 SGT_RECONCILIATION value
         */
        Protobuf.StoreGroupType = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "SGT_NONE_1"] = 0;
            values[valuesById[1] = "SGT_STORE"] = 1;
            values[valuesById[2] = "SGT_RECONCILIATION"] = 2;
            return values;
        })();

        /**
         * StoreUserGroupType enum.
         * @name TCBReceiptApi.Protobuf.StoreUserGroupType
         * @enum {number}
         * @property {number} SUGT_NONE=0 SUGT_NONE value
         * @property {number} SUGT_STORE_USER=1 SUGT_STORE_USER value
         */
        Protobuf.StoreUserGroupType = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "SUGT_NONE"] = 0;
            values[valuesById[1] = "SUGT_STORE_USER"] = 1;
            return values;
        })();

        /**
         * EReceiptUserGroupType enum.
         * @name TCBReceiptApi.Protobuf.EReceiptUserGroupType
         * @enum {number}
         * @property {number} ERUGT_NONE=0 ERUGT_NONE value
         * @property {number} ERUGT_E_RECEIPT_USER=1 ERUGT_E_RECEIPT_USER value
         */
        Protobuf.EReceiptUserGroupType = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "ERUGT_NONE"] = 0;
            values[valuesById[1] = "ERUGT_E_RECEIPT_USER"] = 1;
            return values;
        })();

        /**
         * ScheduleGroupType enum.
         * @name TCBReceiptApi.Protobuf.ScheduleGroupType
         * @enum {number}
         * @property {number} SGT_NONE_4=0 SGT_NONE_4 value
         * @property {number} SGT_SCHEDULE=1 SGT_SCHEDULE value
         * @property {number} SGT_FILE_IMPORT=2 SGT_FILE_IMPORT value
         */
        Protobuf.ScheduleGroupType = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "SGT_NONE_4"] = 0;
            values[valuesById[1] = "SGT_SCHEDULE"] = 1;
            values[valuesById[2] = "SGT_FILE_IMPORT"] = 2;
            return values;
        })();

        /**
         * EReceiptGroupType enum.
         * @name TCBReceiptApi.Protobuf.EReceiptGroupType
         * @enum {number}
         * @property {number} EGT_NONE=0 EGT_NONE value
         * @property {number} EGT_PREFIX=1 EGT_PREFIX value
         * @property {number} EGT_DATA=2 EGT_DATA value
         * @property {number} EGT_MANUAL=3 EGT_MANUAL value
         * @property {number} EGT_VOID=4 EGT_VOID value
         * @property {number} EGT_RETURN=5 EGT_RETURN value
         * @property {number} EGT_MEDIA_FILE=6 EGT_MEDIA_FILE value
         * @property {number} EGT_EXPORT=7 EGT_EXPORT value
         * @property {number} EGT_ACK=8 EGT_ACK value
         * @property {number} EGT_MEMORANDUM_BOOK=9 EGT_MEMORANDUM_BOOK value
         * @property {number} EGT_REPORT=10 EGT_REPORT value
         * @property {number} EGT_PRODUCT_NAME=11 EGT_PRODUCT_NAME value
         * @property {number} EGT_NO_STORE_VENDEE=12 EGT_NO_STORE_VENDEE value
         * @property {number} EGT_STAMP=13 EGT_STAMP value
         */
        Protobuf.EReceiptGroupType = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "EGT_NONE"] = 0;
            values[valuesById[1] = "EGT_PREFIX"] = 1;
            values[valuesById[2] = "EGT_DATA"] = 2;
            values[valuesById[3] = "EGT_MANUAL"] = 3;
            values[valuesById[4] = "EGT_VOID"] = 4;
            values[valuesById[5] = "EGT_RETURN"] = 5;
            values[valuesById[6] = "EGT_MEDIA_FILE"] = 6;
            values[valuesById[7] = "EGT_EXPORT"] = 7;
            values[valuesById[8] = "EGT_ACK"] = 8;
            values[valuesById[9] = "EGT_MEMORANDUM_BOOK"] = 9;
            values[valuesById[10] = "EGT_REPORT"] = 10;
            values[valuesById[11] = "EGT_PRODUCT_NAME"] = 11;
            values[valuesById[12] = "EGT_NO_STORE_VENDEE"] = 12;
            values[valuesById[13] = "EGT_STAMP"] = 13;
            return values;
        })();

        /**
         * SystemGroupType enum.
         * @name TCBReceiptApi.Protobuf.SystemGroupType
         * @enum {number}
         * @property {number} SGT_NONE_6=0 SGT_NONE_6 value
         * @property {number} SGT_DASHBOARD=1 SGT_DASHBOARD value
         */
        Protobuf.SystemGroupType = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "SGT_NONE_6"] = 0;
            values[valuesById[1] = "SGT_DASHBOARD"] = 1;
            return values;
        })();

        /**
         * GroupPermissionGroupType enum.
         * @name TCBReceiptApi.Protobuf.GroupPermissionGroupType
         * @enum {number}
         * @property {number} GPGT_NONE=0 GPGT_NONE value
         * @property {number} GPGT_BACK=1 GPGT_BACK value
         * @property {number} GPGT_FRONT=2 GPGT_FRONT value
         */
        Protobuf.GroupPermissionGroupType = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "GPGT_NONE"] = 0;
            values[valuesById[1] = "GPGT_BACK"] = 1;
            values[valuesById[2] = "GPGT_FRONT"] = 2;
            return values;
        })();

        /**
         * LogGroupType enum.
         * @name TCBReceiptApi.Protobuf.LogGroupType
         * @enum {number}
         * @property {number} LGT_NONE=0 LGT_NONE value
         * @property {number} LGT_BACK=1 LGT_BACK value
         * @property {number} LGT_FRONT=2 LGT_FRONT value
         */
        Protobuf.LogGroupType = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "LGT_NONE"] = 0;
            values[valuesById[1] = "LGT_BACK"] = 1;
            values[valuesById[2] = "LGT_FRONT"] = 2;
            return values;
        })();

        /**
         * AnnouncementGroupType enum.
         * @name TCBReceiptApi.Protobuf.AnnouncementGroupType
         * @enum {number}
         * @property {number} AGT_NONE=0 AGT_NONE value
         * @property {number} AGT_ANNOUNCEMENT=1 AGT_ANNOUNCEMENT value
         */
        Protobuf.AnnouncementGroupType = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "AGT_NONE"] = 0;
            values[valuesById[1] = "AGT_ANNOUNCEMENT"] = 1;
            return values;
        })();

        /**
         * ItemType enum.
         * @name TCBReceiptApi.Protobuf.ItemType
         * @enum {number}
         * @property {number} IT_NONE=0 IT_NONE value
         * @property {number} IT_STORE=1 IT_STORE value
         * @property {number} IT_STORE_USER=2 IT_STORE_USER value
         * @property {number} IT_E_RECEIPT_USER=3 IT_E_RECEIPT_USER value
         * @property {number} IT_SCHEDULE=4 IT_SCHEDULE value
         * @property {number} IT_E_RECEIPT=5 IT_E_RECEIPT value
         * @property {number} IT_SYSTEM_USER=6 IT_SYSTEM_USER value
         * @property {number} IT_GROUP_PERMISSION=7 IT_GROUP_PERMISSION value
         * @property {number} IT_LOG=8 IT_LOG value
         * @property {number} IT_ANNOUNCEMENT=9 IT_ANNOUNCEMENT value
         */
        Protobuf.ItemType = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "IT_NONE"] = 0;
            values[valuesById[1] = "IT_STORE"] = 1;
            values[valuesById[2] = "IT_STORE_USER"] = 2;
            values[valuesById[3] = "IT_E_RECEIPT_USER"] = 3;
            values[valuesById[4] = "IT_SCHEDULE"] = 4;
            values[valuesById[5] = "IT_E_RECEIPT"] = 5;
            values[valuesById[6] = "IT_SYSTEM_USER"] = 6;
            values[valuesById[7] = "IT_GROUP_PERMISSION"] = 7;
            values[valuesById[8] = "IT_LOG"] = 8;
            values[valuesById[9] = "IT_ANNOUNCEMENT"] = 9;
            return values;
        })();

        Protobuf.Permission = (function() {

            /**
             * Properties of a Permission.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IPermission
             * @property {number|null} [get] Permission get
             * @property {number|null} [add] Permission add
             * @property {number|null} [edit] Permission edit
             * @property {number|null} ["delete"] Permission delete
             * @property {number|null} [release] Permission release
             */

            /**
             * Constructs a new Permission.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a Permission.
             * @implements IPermission
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IPermission=} [properties] Properties to set
             */
            function Permission(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Permission get.
             * @member {number} get
             * @memberof TCBReceiptApi.Protobuf.Permission
             * @instance
             */
            Permission.prototype.get = 0;

            /**
             * Permission add.
             * @member {number} add
             * @memberof TCBReceiptApi.Protobuf.Permission
             * @instance
             */
            Permission.prototype.add = 0;

            /**
             * Permission edit.
             * @member {number} edit
             * @memberof TCBReceiptApi.Protobuf.Permission
             * @instance
             */
            Permission.prototype.edit = 0;

            /**
             * Permission delete.
             * @member {number} delete
             * @memberof TCBReceiptApi.Protobuf.Permission
             * @instance
             */
            Permission.prototype["delete"] = 0;

            /**
             * Permission release.
             * @member {number} release
             * @memberof TCBReceiptApi.Protobuf.Permission
             * @instance
             */
            Permission.prototype.release = 0;

            /**
             * Creates a new Permission instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.Permission
             * @static
             * @param {TCBReceiptApi.Protobuf.IPermission=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.Permission} Permission instance
             */
            Permission.create = function create(properties) {
                return new Permission(properties);
            };

            /**
             * Encodes the specified Permission message. Does not implicitly {@link TCBReceiptApi.Protobuf.Permission.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.Permission
             * @static
             * @param {TCBReceiptApi.Protobuf.IPermission} message Permission message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Permission.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.get != null && Object.hasOwnProperty.call(message, "get"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.get);
                if (message.add != null && Object.hasOwnProperty.call(message, "add"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.add);
                if (message.edit != null && Object.hasOwnProperty.call(message, "edit"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.edit);
                if (message["delete"] != null && Object.hasOwnProperty.call(message, "delete"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message["delete"]);
                if (message.release != null && Object.hasOwnProperty.call(message, "release"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int32(message.release);
                return writer;
            };

            /**
             * Encodes the specified Permission message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.Permission.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.Permission
             * @static
             * @param {TCBReceiptApi.Protobuf.IPermission} message Permission message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Permission.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Permission message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.Permission
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.Permission} Permission
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Permission.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.Permission();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.get = reader.int32();
                        break;
                    case 2:
                        message.add = reader.int32();
                        break;
                    case 3:
                        message.edit = reader.int32();
                        break;
                    case 4:
                        message["delete"] = reader.int32();
                        break;
                    case 5:
                        message.release = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Permission message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.Permission
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.Permission} Permission
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Permission.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Permission message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.Permission
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Permission.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.get != null && message.hasOwnProperty("get"))
                    if (!$util.isInteger(message.get))
                        return "get: integer expected";
                if (message.add != null && message.hasOwnProperty("add"))
                    if (!$util.isInteger(message.add))
                        return "add: integer expected";
                if (message.edit != null && message.hasOwnProperty("edit"))
                    if (!$util.isInteger(message.edit))
                        return "edit: integer expected";
                if (message["delete"] != null && message.hasOwnProperty("delete"))
                    if (!$util.isInteger(message["delete"]))
                        return "delete: integer expected";
                if (message.release != null && message.hasOwnProperty("release"))
                    if (!$util.isInteger(message.release))
                        return "release: integer expected";
                return null;
            };

            /**
             * Creates a Permission message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.Permission
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.Permission} Permission
             */
            Permission.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.Permission)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.Permission();
                if (object.get != null)
                    message.get = object.get | 0;
                if (object.add != null)
                    message.add = object.add | 0;
                if (object.edit != null)
                    message.edit = object.edit | 0;
                if (object["delete"] != null)
                    message["delete"] = object["delete"] | 0;
                if (object.release != null)
                    message.release = object.release | 0;
                return message;
            };

            /**
             * Creates a plain object from a Permission message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.Permission
             * @static
             * @param {TCBReceiptApi.Protobuf.Permission} message Permission
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Permission.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.get = 0;
                    object.add = 0;
                    object.edit = 0;
                    object["delete"] = 0;
                    object.release = 0;
                }
                if (message.get != null && message.hasOwnProperty("get"))
                    object.get = message.get;
                if (message.add != null && message.hasOwnProperty("add"))
                    object.add = message.add;
                if (message.edit != null && message.hasOwnProperty("edit"))
                    object.edit = message.edit;
                if (message["delete"] != null && message.hasOwnProperty("delete"))
                    object["delete"] = message["delete"];
                if (message.release != null && message.hasOwnProperty("release"))
                    object.release = message.release;
                return object;
            };

            /**
             * Converts this Permission to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.Permission
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Permission.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Permission;
        })();

        Protobuf.GroupMap = (function() {

            /**
             * Properties of a GroupMap.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IGroupMap
             * @property {Object.<string,TCBReceiptApi.Protobuf.IPermission>|null} [map] GroupMap map
             */

            /**
             * Constructs a new GroupMap.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a GroupMap.
             * @implements IGroupMap
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IGroupMap=} [properties] Properties to set
             */
            function GroupMap(properties) {
                this.map = {};
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GroupMap map.
             * @member {Object.<string,TCBReceiptApi.Protobuf.IPermission>} map
             * @memberof TCBReceiptApi.Protobuf.GroupMap
             * @instance
             */
            GroupMap.prototype.map = $util.emptyObject;

            /**
             * Creates a new GroupMap instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.GroupMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IGroupMap=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.GroupMap} GroupMap instance
             */
            GroupMap.create = function create(properties) {
                return new GroupMap(properties);
            };

            /**
             * Encodes the specified GroupMap message. Does not implicitly {@link TCBReceiptApi.Protobuf.GroupMap.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.GroupMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IGroupMap} message GroupMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GroupMap.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.map != null && Object.hasOwnProperty.call(message, "map"))
                    for (var keys = Object.keys(message.map), i = 0; i < keys.length; ++i) {
                        writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                        $root.TCBReceiptApi.Protobuf.Permission.encode(message.map[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                    }
                return writer;
            };

            /**
             * Encodes the specified GroupMap message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.GroupMap.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.GroupMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IGroupMap} message GroupMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GroupMap.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GroupMap message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.GroupMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.GroupMap} GroupMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GroupMap.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.GroupMap(), key, value;
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (message.map === $util.emptyObject)
                            message.map = {};
                        var end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = null;
                        while (reader.pos < end2) {
                            var tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = $root.TCBReceiptApi.Protobuf.Permission.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.map[key] = value;
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GroupMap message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.GroupMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.GroupMap} GroupMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GroupMap.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GroupMap message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.GroupMap
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GroupMap.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.map != null && message.hasOwnProperty("map")) {
                    if (!$util.isObject(message.map))
                        return "map: object expected";
                    var key = Object.keys(message.map);
                    for (var i = 0; i < key.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.Permission.verify(message.map[key[i]]);
                        if (error)
                            return "map." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a GroupMap message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.GroupMap
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.GroupMap} GroupMap
             */
            GroupMap.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.GroupMap)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.GroupMap();
                if (object.map) {
                    if (typeof object.map !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.GroupMap.map: object expected");
                    message.map = {};
                    for (var keys = Object.keys(object.map), i = 0; i < keys.length; ++i) {
                        if (typeof object.map[keys[i]] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.GroupMap.map: object expected");
                        message.map[keys[i]] = $root.TCBReceiptApi.Protobuf.Permission.fromObject(object.map[keys[i]]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a GroupMap message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.GroupMap
             * @static
             * @param {TCBReceiptApi.Protobuf.GroupMap} message GroupMap
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GroupMap.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.objects || options.defaults)
                    object.map = {};
                var keys2;
                if (message.map && (keys2 = Object.keys(message.map)).length) {
                    object.map = {};
                    for (var j = 0; j < keys2.length; ++j)
                        object.map[keys2[j]] = $root.TCBReceiptApi.Protobuf.Permission.toObject(message.map[keys2[j]], options);
                }
                return object;
            };

            /**
             * Converts this GroupMap to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.GroupMap
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GroupMap.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GroupMap;
        })();

        Protobuf.GroupPermission = (function() {

            /**
             * Properties of a GroupPermission.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IGroupPermission
             * @property {number|null} [groupPermissionId] GroupPermission groupPermissionId
             * @property {string|null} [code] GroupPermission code
             * @property {string|null} [name] GroupPermission name
             * @property {number|null} [state] GroupPermission state
             * @property {Object.<string,TCBReceiptApi.Protobuf.IGroupMap>|null} [permission] GroupPermission permission
             */

            /**
             * Constructs a new GroupPermission.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a GroupPermission.
             * @implements IGroupPermission
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IGroupPermission=} [properties] Properties to set
             */
            function GroupPermission(properties) {
                this.permission = {};
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GroupPermission groupPermissionId.
             * @member {number} groupPermissionId
             * @memberof TCBReceiptApi.Protobuf.GroupPermission
             * @instance
             */
            GroupPermission.prototype.groupPermissionId = 0;

            /**
             * GroupPermission code.
             * @member {string} code
             * @memberof TCBReceiptApi.Protobuf.GroupPermission
             * @instance
             */
            GroupPermission.prototype.code = "";

            /**
             * GroupPermission name.
             * @member {string} name
             * @memberof TCBReceiptApi.Protobuf.GroupPermission
             * @instance
             */
            GroupPermission.prototype.name = "";

            /**
             * GroupPermission state.
             * @member {number} state
             * @memberof TCBReceiptApi.Protobuf.GroupPermission
             * @instance
             */
            GroupPermission.prototype.state = 0;

            /**
             * GroupPermission permission.
             * @member {Object.<string,TCBReceiptApi.Protobuf.IGroupMap>} permission
             * @memberof TCBReceiptApi.Protobuf.GroupPermission
             * @instance
             */
            GroupPermission.prototype.permission = $util.emptyObject;

            /**
             * Creates a new GroupPermission instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.GroupPermission
             * @static
             * @param {TCBReceiptApi.Protobuf.IGroupPermission=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.GroupPermission} GroupPermission instance
             */
            GroupPermission.create = function create(properties) {
                return new GroupPermission(properties);
            };

            /**
             * Encodes the specified GroupPermission message. Does not implicitly {@link TCBReceiptApi.Protobuf.GroupPermission.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.GroupPermission
             * @static
             * @param {TCBReceiptApi.Protobuf.IGroupPermission} message GroupPermission message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GroupPermission.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.groupPermissionId != null && Object.hasOwnProperty.call(message, "groupPermissionId"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupPermissionId);
                if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.code);
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
                if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.state);
                if (message.permission != null && Object.hasOwnProperty.call(message, "permission"))
                    for (var keys = Object.keys(message.permission), i = 0; i < keys.length; ++i) {
                        writer.uint32(/* id 5, wireType 2 =*/42).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                        $root.TCBReceiptApi.Protobuf.GroupMap.encode(message.permission[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                    }
                return writer;
            };

            /**
             * Encodes the specified GroupPermission message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.GroupPermission.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.GroupPermission
             * @static
             * @param {TCBReceiptApi.Protobuf.IGroupPermission} message GroupPermission message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GroupPermission.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GroupPermission message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.GroupPermission
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.GroupPermission} GroupPermission
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GroupPermission.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.GroupPermission(), key, value;
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.groupPermissionId = reader.int32();
                        break;
                    case 2:
                        message.code = reader.string();
                        break;
                    case 3:
                        message.name = reader.string();
                        break;
                    case 4:
                        message.state = reader.int32();
                        break;
                    case 5:
                        if (message.permission === $util.emptyObject)
                            message.permission = {};
                        var end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = null;
                        while (reader.pos < end2) {
                            var tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = $root.TCBReceiptApi.Protobuf.GroupMap.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.permission[key] = value;
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GroupPermission message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.GroupPermission
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.GroupPermission} GroupPermission
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GroupPermission.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GroupPermission message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.GroupPermission
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GroupPermission.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.groupPermissionId != null && message.hasOwnProperty("groupPermissionId"))
                    if (!$util.isInteger(message.groupPermissionId))
                        return "groupPermissionId: integer expected";
                if (message.code != null && message.hasOwnProperty("code"))
                    if (!$util.isString(message.code))
                        return "code: string expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.state != null && message.hasOwnProperty("state"))
                    if (!$util.isInteger(message.state))
                        return "state: integer expected";
                if (message.permission != null && message.hasOwnProperty("permission")) {
                    if (!$util.isObject(message.permission))
                        return "permission: object expected";
                    var key = Object.keys(message.permission);
                    for (var i = 0; i < key.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.GroupMap.verify(message.permission[key[i]]);
                        if (error)
                            return "permission." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a GroupPermission message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.GroupPermission
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.GroupPermission} GroupPermission
             */
            GroupPermission.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.GroupPermission)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.GroupPermission();
                if (object.groupPermissionId != null)
                    message.groupPermissionId = object.groupPermissionId | 0;
                if (object.code != null)
                    message.code = String(object.code);
                if (object.name != null)
                    message.name = String(object.name);
                if (object.state != null)
                    message.state = object.state | 0;
                if (object.permission) {
                    if (typeof object.permission !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.GroupPermission.permission: object expected");
                    message.permission = {};
                    for (var keys = Object.keys(object.permission), i = 0; i < keys.length; ++i) {
                        if (typeof object.permission[keys[i]] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.GroupPermission.permission: object expected");
                        message.permission[keys[i]] = $root.TCBReceiptApi.Protobuf.GroupMap.fromObject(object.permission[keys[i]]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a GroupPermission message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.GroupPermission
             * @static
             * @param {TCBReceiptApi.Protobuf.GroupPermission} message GroupPermission
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GroupPermission.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.objects || options.defaults)
                    object.permission = {};
                if (options.defaults) {
                    object.groupPermissionId = 0;
                    object.code = "";
                    object.name = "";
                    object.state = 0;
                }
                if (message.groupPermissionId != null && message.hasOwnProperty("groupPermissionId"))
                    object.groupPermissionId = message.groupPermissionId;
                if (message.code != null && message.hasOwnProperty("code"))
                    object.code = message.code;
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.state != null && message.hasOwnProperty("state"))
                    object.state = message.state;
                var keys2;
                if (message.permission && (keys2 = Object.keys(message.permission)).length) {
                    object.permission = {};
                    for (var j = 0; j < keys2.length; ++j)
                        object.permission[keys2[j]] = $root.TCBReceiptApi.Protobuf.GroupMap.toObject(message.permission[keys2[j]], options);
                }
                return object;
            };

            /**
             * Converts this GroupPermission to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.GroupPermission
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GroupPermission.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GroupPermission;
        })();

        Protobuf.GroupPermissionList = (function() {

            /**
             * Properties of a GroupPermissionList.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IGroupPermissionList
             * @property {Array.<TCBReceiptApi.Protobuf.IGroupPermission>|null} [list] GroupPermissionList list
             * @property {number|null} [total] GroupPermissionList total
             */

            /**
             * Constructs a new GroupPermissionList.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a GroupPermissionList.
             * @implements IGroupPermissionList
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IGroupPermissionList=} [properties] Properties to set
             */
            function GroupPermissionList(properties) {
                this.list = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GroupPermissionList list.
             * @member {Array.<TCBReceiptApi.Protobuf.IGroupPermission>} list
             * @memberof TCBReceiptApi.Protobuf.GroupPermissionList
             * @instance
             */
            GroupPermissionList.prototype.list = $util.emptyArray;

            /**
             * GroupPermissionList total.
             * @member {number} total
             * @memberof TCBReceiptApi.Protobuf.GroupPermissionList
             * @instance
             */
            GroupPermissionList.prototype.total = 0;

            /**
             * Creates a new GroupPermissionList instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.GroupPermissionList
             * @static
             * @param {TCBReceiptApi.Protobuf.IGroupPermissionList=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.GroupPermissionList} GroupPermissionList instance
             */
            GroupPermissionList.create = function create(properties) {
                return new GroupPermissionList(properties);
            };

            /**
             * Encodes the specified GroupPermissionList message. Does not implicitly {@link TCBReceiptApi.Protobuf.GroupPermissionList.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.GroupPermissionList
             * @static
             * @param {TCBReceiptApi.Protobuf.IGroupPermissionList} message GroupPermissionList message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GroupPermissionList.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.list != null && message.list.length)
                    for (var i = 0; i < message.list.length; ++i)
                        $root.TCBReceiptApi.Protobuf.GroupPermission.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.total);
                return writer;
            };

            /**
             * Encodes the specified GroupPermissionList message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.GroupPermissionList.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.GroupPermissionList
             * @static
             * @param {TCBReceiptApi.Protobuf.IGroupPermissionList} message GroupPermissionList message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GroupPermissionList.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GroupPermissionList message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.GroupPermissionList
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.GroupPermissionList} GroupPermissionList
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GroupPermissionList.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.GroupPermissionList();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.TCBReceiptApi.Protobuf.GroupPermission.decode(reader, reader.uint32()));
                        break;
                    case 2:
                        message.total = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GroupPermissionList message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.GroupPermissionList
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.GroupPermissionList} GroupPermissionList
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GroupPermissionList.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GroupPermissionList message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.GroupPermissionList
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GroupPermissionList.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.list != null && message.hasOwnProperty("list")) {
                    if (!Array.isArray(message.list))
                        return "list: array expected";
                    for (var i = 0; i < message.list.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.GroupPermission.verify(message.list[i]);
                        if (error)
                            return "list." + error;
                    }
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    if (!$util.isInteger(message.total))
                        return "total: integer expected";
                return null;
            };

            /**
             * Creates a GroupPermissionList message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.GroupPermissionList
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.GroupPermissionList} GroupPermissionList
             */
            GroupPermissionList.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.GroupPermissionList)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.GroupPermissionList();
                if (object.list) {
                    if (!Array.isArray(object.list))
                        throw TypeError(".TCBReceiptApi.Protobuf.GroupPermissionList.list: array expected");
                    message.list = [];
                    for (var i = 0; i < object.list.length; ++i) {
                        if (typeof object.list[i] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.GroupPermissionList.list: object expected");
                        message.list[i] = $root.TCBReceiptApi.Protobuf.GroupPermission.fromObject(object.list[i]);
                    }
                }
                if (object.total != null)
                    message.total = object.total | 0;
                return message;
            };

            /**
             * Creates a plain object from a GroupPermissionList message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.GroupPermissionList
             * @static
             * @param {TCBReceiptApi.Protobuf.GroupPermissionList} message GroupPermissionList
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GroupPermissionList.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.list = [];
                if (options.defaults)
                    object.total = 0;
                if (message.list && message.list.length) {
                    object.list = [];
                    for (var j = 0; j < message.list.length; ++j)
                        object.list[j] = $root.TCBReceiptApi.Protobuf.GroupPermission.toObject(message.list[j], options);
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    object.total = message.total;
                return object;
            };

            /**
             * Converts this GroupPermissionList to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.GroupPermissionList
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GroupPermissionList.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GroupPermissionList;
        })();

        Protobuf.Reconciliation = (function() {

            /**
             * Properties of a Reconciliation.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IReconciliation
             * @property {string|null} [storeCode] Reconciliation storeCode
             * @property {string|null} [storeName] Reconciliation storeName
             * @property {string|null} [branchBank] Reconciliation branchBank
             * @property {string|null} [account] Reconciliation account
             * @property {string|null} [submitDateStart] Reconciliation submitDateStart
             * @property {string|null} [submitDateEnd] Reconciliation submitDateEnd
             * @property {string|null} [transDateStart] Reconciliation transDateStart
             * @property {string|null} [transDateEnd] Reconciliation transDateEnd
             * @property {string|null} [dateStart] Reconciliation dateStart
             * @property {string|null} [dateEnd] Reconciliation dateEnd
             * @property {number|null} [isQuota] Reconciliation isQuota
             */

            /**
             * Constructs a new Reconciliation.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a Reconciliation.
             * @implements IReconciliation
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IReconciliation=} [properties] Properties to set
             */
            function Reconciliation(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Reconciliation storeCode.
             * @member {string} storeCode
             * @memberof TCBReceiptApi.Protobuf.Reconciliation
             * @instance
             */
            Reconciliation.prototype.storeCode = "";

            /**
             * Reconciliation storeName.
             * @member {string} storeName
             * @memberof TCBReceiptApi.Protobuf.Reconciliation
             * @instance
             */
            Reconciliation.prototype.storeName = "";

            /**
             * Reconciliation branchBank.
             * @member {string} branchBank
             * @memberof TCBReceiptApi.Protobuf.Reconciliation
             * @instance
             */
            Reconciliation.prototype.branchBank = "";

            /**
             * Reconciliation account.
             * @member {string} account
             * @memberof TCBReceiptApi.Protobuf.Reconciliation
             * @instance
             */
            Reconciliation.prototype.account = "";

            /**
             * Reconciliation submitDateStart.
             * @member {string} submitDateStart
             * @memberof TCBReceiptApi.Protobuf.Reconciliation
             * @instance
             */
            Reconciliation.prototype.submitDateStart = "";

            /**
             * Reconciliation submitDateEnd.
             * @member {string} submitDateEnd
             * @memberof TCBReceiptApi.Protobuf.Reconciliation
             * @instance
             */
            Reconciliation.prototype.submitDateEnd = "";

            /**
             * Reconciliation transDateStart.
             * @member {string} transDateStart
             * @memberof TCBReceiptApi.Protobuf.Reconciliation
             * @instance
             */
            Reconciliation.prototype.transDateStart = "";

            /**
             * Reconciliation transDateEnd.
             * @member {string} transDateEnd
             * @memberof TCBReceiptApi.Protobuf.Reconciliation
             * @instance
             */
            Reconciliation.prototype.transDateEnd = "";

            /**
             * Reconciliation dateStart.
             * @member {string} dateStart
             * @memberof TCBReceiptApi.Protobuf.Reconciliation
             * @instance
             */
            Reconciliation.prototype.dateStart = "";

            /**
             * Reconciliation dateEnd.
             * @member {string} dateEnd
             * @memberof TCBReceiptApi.Protobuf.Reconciliation
             * @instance
             */
            Reconciliation.prototype.dateEnd = "";

            /**
             * Reconciliation isQuota.
             * @member {number} isQuota
             * @memberof TCBReceiptApi.Protobuf.Reconciliation
             * @instance
             */
            Reconciliation.prototype.isQuota = 0;

            /**
             * Creates a new Reconciliation instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.Reconciliation
             * @static
             * @param {TCBReceiptApi.Protobuf.IReconciliation=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.Reconciliation} Reconciliation instance
             */
            Reconciliation.create = function create(properties) {
                return new Reconciliation(properties);
            };

            /**
             * Encodes the specified Reconciliation message. Does not implicitly {@link TCBReceiptApi.Protobuf.Reconciliation.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.Reconciliation
             * @static
             * @param {TCBReceiptApi.Protobuf.IReconciliation} message Reconciliation message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Reconciliation.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.storeCode != null && Object.hasOwnProperty.call(message, "storeCode"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.storeCode);
                if (message.storeName != null && Object.hasOwnProperty.call(message, "storeName"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.storeName);
                if (message.branchBank != null && Object.hasOwnProperty.call(message, "branchBank"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.branchBank);
                if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.account);
                if (message.submitDateStart != null && Object.hasOwnProperty.call(message, "submitDateStart"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.submitDateStart);
                if (message.submitDateEnd != null && Object.hasOwnProperty.call(message, "submitDateEnd"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.submitDateEnd);
                if (message.transDateStart != null && Object.hasOwnProperty.call(message, "transDateStart"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.transDateStart);
                if (message.transDateEnd != null && Object.hasOwnProperty.call(message, "transDateEnd"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.transDateEnd);
                if (message.dateStart != null && Object.hasOwnProperty.call(message, "dateStart"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.dateStart);
                if (message.dateEnd != null && Object.hasOwnProperty.call(message, "dateEnd"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.dateEnd);
                if (message.isQuota != null && Object.hasOwnProperty.call(message, "isQuota"))
                    writer.uint32(/* id 11, wireType 0 =*/88).int32(message.isQuota);
                return writer;
            };

            /**
             * Encodes the specified Reconciliation message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.Reconciliation.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.Reconciliation
             * @static
             * @param {TCBReceiptApi.Protobuf.IReconciliation} message Reconciliation message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Reconciliation.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Reconciliation message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.Reconciliation
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.Reconciliation} Reconciliation
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Reconciliation.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.Reconciliation();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.storeCode = reader.string();
                        break;
                    case 2:
                        message.storeName = reader.string();
                        break;
                    case 3:
                        message.branchBank = reader.string();
                        break;
                    case 4:
                        message.account = reader.string();
                        break;
                    case 5:
                        message.submitDateStart = reader.string();
                        break;
                    case 6:
                        message.submitDateEnd = reader.string();
                        break;
                    case 7:
                        message.transDateStart = reader.string();
                        break;
                    case 8:
                        message.transDateEnd = reader.string();
                        break;
                    case 9:
                        message.dateStart = reader.string();
                        break;
                    case 10:
                        message.dateEnd = reader.string();
                        break;
                    case 11:
                        message.isQuota = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Reconciliation message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.Reconciliation
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.Reconciliation} Reconciliation
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Reconciliation.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Reconciliation message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.Reconciliation
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Reconciliation.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    if (!$util.isString(message.storeCode))
                        return "storeCode: string expected";
                if (message.storeName != null && message.hasOwnProperty("storeName"))
                    if (!$util.isString(message.storeName))
                        return "storeName: string expected";
                if (message.branchBank != null && message.hasOwnProperty("branchBank"))
                    if (!$util.isString(message.branchBank))
                        return "branchBank: string expected";
                if (message.account != null && message.hasOwnProperty("account"))
                    if (!$util.isString(message.account))
                        return "account: string expected";
                if (message.submitDateStart != null && message.hasOwnProperty("submitDateStart"))
                    if (!$util.isString(message.submitDateStart))
                        return "submitDateStart: string expected";
                if (message.submitDateEnd != null && message.hasOwnProperty("submitDateEnd"))
                    if (!$util.isString(message.submitDateEnd))
                        return "submitDateEnd: string expected";
                if (message.transDateStart != null && message.hasOwnProperty("transDateStart"))
                    if (!$util.isString(message.transDateStart))
                        return "transDateStart: string expected";
                if (message.transDateEnd != null && message.hasOwnProperty("transDateEnd"))
                    if (!$util.isString(message.transDateEnd))
                        return "transDateEnd: string expected";
                if (message.dateStart != null && message.hasOwnProperty("dateStart"))
                    if (!$util.isString(message.dateStart))
                        return "dateStart: string expected";
                if (message.dateEnd != null && message.hasOwnProperty("dateEnd"))
                    if (!$util.isString(message.dateEnd))
                        return "dateEnd: string expected";
                if (message.isQuota != null && message.hasOwnProperty("isQuota"))
                    if (!$util.isInteger(message.isQuota))
                        return "isQuota: integer expected";
                return null;
            };

            /**
             * Creates a Reconciliation message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.Reconciliation
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.Reconciliation} Reconciliation
             */
            Reconciliation.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.Reconciliation)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.Reconciliation();
                if (object.storeCode != null)
                    message.storeCode = String(object.storeCode);
                if (object.storeName != null)
                    message.storeName = String(object.storeName);
                if (object.branchBank != null)
                    message.branchBank = String(object.branchBank);
                if (object.account != null)
                    message.account = String(object.account);
                if (object.submitDateStart != null)
                    message.submitDateStart = String(object.submitDateStart);
                if (object.submitDateEnd != null)
                    message.submitDateEnd = String(object.submitDateEnd);
                if (object.transDateStart != null)
                    message.transDateStart = String(object.transDateStart);
                if (object.transDateEnd != null)
                    message.transDateEnd = String(object.transDateEnd);
                if (object.dateStart != null)
                    message.dateStart = String(object.dateStart);
                if (object.dateEnd != null)
                    message.dateEnd = String(object.dateEnd);
                if (object.isQuota != null)
                    message.isQuota = object.isQuota | 0;
                return message;
            };

            /**
             * Creates a plain object from a Reconciliation message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.Reconciliation
             * @static
             * @param {TCBReceiptApi.Protobuf.Reconciliation} message Reconciliation
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Reconciliation.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.storeCode = "";
                    object.storeName = "";
                    object.branchBank = "";
                    object.account = "";
                    object.submitDateStart = "";
                    object.submitDateEnd = "";
                    object.transDateStart = "";
                    object.transDateEnd = "";
                    object.dateStart = "";
                    object.dateEnd = "";
                    object.isQuota = 0;
                }
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    object.storeCode = message.storeCode;
                if (message.storeName != null && message.hasOwnProperty("storeName"))
                    object.storeName = message.storeName;
                if (message.branchBank != null && message.hasOwnProperty("branchBank"))
                    object.branchBank = message.branchBank;
                if (message.account != null && message.hasOwnProperty("account"))
                    object.account = message.account;
                if (message.submitDateStart != null && message.hasOwnProperty("submitDateStart"))
                    object.submitDateStart = message.submitDateStart;
                if (message.submitDateEnd != null && message.hasOwnProperty("submitDateEnd"))
                    object.submitDateEnd = message.submitDateEnd;
                if (message.transDateStart != null && message.hasOwnProperty("transDateStart"))
                    object.transDateStart = message.transDateStart;
                if (message.transDateEnd != null && message.hasOwnProperty("transDateEnd"))
                    object.transDateEnd = message.transDateEnd;
                if (message.dateStart != null && message.hasOwnProperty("dateStart"))
                    object.dateStart = message.dateStart;
                if (message.dateEnd != null && message.hasOwnProperty("dateEnd"))
                    object.dateEnd = message.dateEnd;
                if (message.isQuota != null && message.hasOwnProperty("isQuota"))
                    object.isQuota = message.isQuota;
                return object;
            };

            /**
             * Converts this Reconciliation to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.Reconciliation
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Reconciliation.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Reconciliation;
        })();

        Protobuf.ReconciliationList = (function() {

            /**
             * Properties of a ReconciliationList.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IReconciliationList
             * @property {Array.<TCBReceiptApi.Protobuf.IReconciliation>|null} [list] ReconciliationList list
             */

            /**
             * Constructs a new ReconciliationList.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a ReconciliationList.
             * @implements IReconciliationList
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IReconciliationList=} [properties] Properties to set
             */
            function ReconciliationList(properties) {
                this.list = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ReconciliationList list.
             * @member {Array.<TCBReceiptApi.Protobuf.IReconciliation>} list
             * @memberof TCBReceiptApi.Protobuf.ReconciliationList
             * @instance
             */
            ReconciliationList.prototype.list = $util.emptyArray;

            /**
             * Creates a new ReconciliationList instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.ReconciliationList
             * @static
             * @param {TCBReceiptApi.Protobuf.IReconciliationList=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.ReconciliationList} ReconciliationList instance
             */
            ReconciliationList.create = function create(properties) {
                return new ReconciliationList(properties);
            };

            /**
             * Encodes the specified ReconciliationList message. Does not implicitly {@link TCBReceiptApi.Protobuf.ReconciliationList.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.ReconciliationList
             * @static
             * @param {TCBReceiptApi.Protobuf.IReconciliationList} message ReconciliationList message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReconciliationList.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.list != null && message.list.length)
                    for (var i = 0; i < message.list.length; ++i)
                        $root.TCBReceiptApi.Protobuf.Reconciliation.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ReconciliationList message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.ReconciliationList.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ReconciliationList
             * @static
             * @param {TCBReceiptApi.Protobuf.IReconciliationList} message ReconciliationList message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReconciliationList.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ReconciliationList message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.ReconciliationList
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.ReconciliationList} ReconciliationList
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReconciliationList.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.ReconciliationList();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.TCBReceiptApi.Protobuf.Reconciliation.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ReconciliationList message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ReconciliationList
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.ReconciliationList} ReconciliationList
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReconciliationList.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ReconciliationList message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.ReconciliationList
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ReconciliationList.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.list != null && message.hasOwnProperty("list")) {
                    if (!Array.isArray(message.list))
                        return "list: array expected";
                    for (var i = 0; i < message.list.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.Reconciliation.verify(message.list[i]);
                        if (error)
                            return "list." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a ReconciliationList message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.ReconciliationList
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.ReconciliationList} ReconciliationList
             */
            ReconciliationList.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.ReconciliationList)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.ReconciliationList();
                if (object.list) {
                    if (!Array.isArray(object.list))
                        throw TypeError(".TCBReceiptApi.Protobuf.ReconciliationList.list: array expected");
                    message.list = [];
                    for (var i = 0; i < object.list.length; ++i) {
                        if (typeof object.list[i] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.ReconciliationList.list: object expected");
                        message.list[i] = $root.TCBReceiptApi.Protobuf.Reconciliation.fromObject(object.list[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a ReconciliationList message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.ReconciliationList
             * @static
             * @param {TCBReceiptApi.Protobuf.ReconciliationList} message ReconciliationList
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ReconciliationList.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.list = [];
                if (message.list && message.list.length) {
                    object.list = [];
                    for (var j = 0; j < message.list.length; ++j)
                        object.list[j] = $root.TCBReceiptApi.Protobuf.Reconciliation.toObject(message.list[j], options);
                }
                return object;
            };

            /**
             * Converts this ReconciliationList to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.ReconciliationList
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ReconciliationList.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ReconciliationList;
        })();

        Protobuf.ReimbursementInfo = (function() {

            /**
             * Properties of a ReimbursementInfo.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IReimbursementInfo
             * @property {number|null} [reimbursementId] ReimbursementInfo reimbursementId
             * @property {number|null} [sourceId] ReimbursementInfo sourceId
             * @property {string|null} [batchNo] ReimbursementInfo batchNo
             * @property {string|null} [batchNoOrigin] ReimbursementInfo batchNoOrigin
             * @property {string|null} [date] ReimbursementInfo date
             * @property {string|null} [time] ReimbursementInfo time
             * @property {string|null} [submitDate] ReimbursementInfo submitDate
             * @property {string|null} [paydueDate] ReimbursementInfo paydueDate
             * @property {string|null} [cardNo] ReimbursementInfo cardNo
             * @property {string|null} [authCode] ReimbursementInfo authCode
             * @property {number|null} [amount] ReimbursementInfo amount
             * @property {number|null} [code] ReimbursementInfo code
             * @property {string|null} [codeOrigin] ReimbursementInfo codeOrigin
             * @property {number|null} [type] ReimbursementInfo type
             * @property {number|null} [settleCode] ReimbursementInfo settleCode
             * @property {string|null} [orderNo] ReimbursementInfo orderNo
             * @property {number|null} [isCreditCard] ReimbursementInfo isCreditCard
             * @property {number|null} [cardType] ReimbursementInfo cardType
             * @property {string|null} [cardTypeOrigin] ReimbursementInfo cardTypeOrigin
             * @property {number|null} [installCode] ReimbursementInfo installCode
             * @property {string|null} [installCodeOrigin] ReimbursementInfo installCodeOrigin
             * @property {number|null} [payFlag] ReimbursementInfo payFlag
             * @property {string|null} [payFlagOrigin] ReimbursementInfo payFlagOrigin
             * @property {number|null} [installTimes] ReimbursementInfo installTimes
             * @property {number|null} [installAverageAmount] ReimbursementInfo installAverageAmount
             * @property {string|null} [storeCode] ReimbursementInfo storeCode
             * @property {string|null} [terminalNo] ReimbursementInfo terminalNo
             * @property {number|null} [feeFlag] ReimbursementInfo feeFlag
             * @property {string|null} [feeFlagOrigin] ReimbursementInfo feeFlagOrigin
             * @property {string|null} [stan] ReimbursementInfo stan
             * @property {string|null} [issuer] ReimbursementInfo issuer
             * @property {number|null} [isOurBank] ReimbursementInfo isOurBank
             * @property {number|null} [taiwanPayQrFlag] ReimbursementInfo taiwanPayQrFlag
             * @property {number|null} [infoType] ReimbursementInfo infoType
             * @property {string|null} [tidNumber] ReimbursementInfo tidNumber
             * @property {string|null} [storeCodeMapping] ReimbursementInfo storeCodeMapping
             * @property {string|null} [subStoreCode] ReimbursementInfo subStoreCode
             * @property {string|null} [stanOrigin] ReimbursementInfo stanOrigin
             * @property {string|null} [tpan] ReimbursementInfo tpan
             * @property {string|null} [issuerOrigin] ReimbursementInfo issuerOrigin
             */

            /**
             * Constructs a new ReimbursementInfo.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a ReimbursementInfo.
             * @implements IReimbursementInfo
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IReimbursementInfo=} [properties] Properties to set
             */
            function ReimbursementInfo(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ReimbursementInfo reimbursementId.
             * @member {number} reimbursementId
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.reimbursementId = 0;

            /**
             * ReimbursementInfo sourceId.
             * @member {number} sourceId
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.sourceId = 0;

            /**
             * ReimbursementInfo batchNo.
             * @member {string} batchNo
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.batchNo = "";

            /**
             * ReimbursementInfo batchNoOrigin.
             * @member {string} batchNoOrigin
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.batchNoOrigin = "";

            /**
             * ReimbursementInfo date.
             * @member {string} date
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.date = "";

            /**
             * ReimbursementInfo time.
             * @member {string} time
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.time = "";

            /**
             * ReimbursementInfo submitDate.
             * @member {string} submitDate
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.submitDate = "";

            /**
             * ReimbursementInfo paydueDate.
             * @member {string} paydueDate
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.paydueDate = "";

            /**
             * ReimbursementInfo cardNo.
             * @member {string} cardNo
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.cardNo = "";

            /**
             * ReimbursementInfo authCode.
             * @member {string} authCode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.authCode = "";

            /**
             * ReimbursementInfo amount.
             * @member {number} amount
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.amount = 0;

            /**
             * ReimbursementInfo code.
             * @member {number} code
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.code = 0;

            /**
             * ReimbursementInfo codeOrigin.
             * @member {string} codeOrigin
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.codeOrigin = "";

            /**
             * ReimbursementInfo type.
             * @member {number} type
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.type = 0;

            /**
             * ReimbursementInfo settleCode.
             * @member {number} settleCode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.settleCode = 0;

            /**
             * ReimbursementInfo orderNo.
             * @member {string} orderNo
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.orderNo = "";

            /**
             * ReimbursementInfo isCreditCard.
             * @member {number} isCreditCard
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.isCreditCard = 0;

            /**
             * ReimbursementInfo cardType.
             * @member {number} cardType
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.cardType = 0;

            /**
             * ReimbursementInfo cardTypeOrigin.
             * @member {string} cardTypeOrigin
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.cardTypeOrigin = "";

            /**
             * ReimbursementInfo installCode.
             * @member {number} installCode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.installCode = 0;

            /**
             * ReimbursementInfo installCodeOrigin.
             * @member {string} installCodeOrigin
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.installCodeOrigin = "";

            /**
             * ReimbursementInfo payFlag.
             * @member {number} payFlag
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.payFlag = 0;

            /**
             * ReimbursementInfo payFlagOrigin.
             * @member {string} payFlagOrigin
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.payFlagOrigin = "";

            /**
             * ReimbursementInfo installTimes.
             * @member {number} installTimes
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.installTimes = 0;

            /**
             * ReimbursementInfo installAverageAmount.
             * @member {number} installAverageAmount
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.installAverageAmount = 0;

            /**
             * ReimbursementInfo storeCode.
             * @member {string} storeCode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.storeCode = "";

            /**
             * ReimbursementInfo terminalNo.
             * @member {string} terminalNo
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.terminalNo = "";

            /**
             * ReimbursementInfo feeFlag.
             * @member {number} feeFlag
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.feeFlag = 0;

            /**
             * ReimbursementInfo feeFlagOrigin.
             * @member {string} feeFlagOrigin
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.feeFlagOrigin = "";

            /**
             * ReimbursementInfo stan.
             * @member {string} stan
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.stan = "";

            /**
             * ReimbursementInfo issuer.
             * @member {string} issuer
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.issuer = "";

            /**
             * ReimbursementInfo isOurBank.
             * @member {number} isOurBank
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.isOurBank = 0;

            /**
             * ReimbursementInfo taiwanPayQrFlag.
             * @member {number} taiwanPayQrFlag
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.taiwanPayQrFlag = 0;

            /**
             * ReimbursementInfo infoType.
             * @member {number} infoType
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.infoType = 0;

            /**
             * ReimbursementInfo tidNumber.
             * @member {string} tidNumber
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.tidNumber = "";

            /**
             * ReimbursementInfo storeCodeMapping.
             * @member {string} storeCodeMapping
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.storeCodeMapping = "";

            /**
             * ReimbursementInfo subStoreCode.
             * @member {string} subStoreCode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.subStoreCode = "";

            /**
             * ReimbursementInfo stanOrigin.
             * @member {string} stanOrigin
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.stanOrigin = "";

            /**
             * ReimbursementInfo tpan.
             * @member {string} tpan
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.tpan = "";

            /**
             * ReimbursementInfo issuerOrigin.
             * @member {string} issuerOrigin
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             */
            ReimbursementInfo.prototype.issuerOrigin = "";

            /**
             * Creates a new ReimbursementInfo instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementInfo=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.ReimbursementInfo} ReimbursementInfo instance
             */
            ReimbursementInfo.create = function create(properties) {
                return new ReimbursementInfo(properties);
            };

            /**
             * Encodes the specified ReimbursementInfo message. Does not implicitly {@link TCBReceiptApi.Protobuf.ReimbursementInfo.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementInfo} message ReimbursementInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReimbursementInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.reimbursementId != null && Object.hasOwnProperty.call(message, "reimbursementId"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.reimbursementId);
                if (message.sourceId != null && Object.hasOwnProperty.call(message, "sourceId"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.sourceId);
                if (message.batchNo != null && Object.hasOwnProperty.call(message, "batchNo"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.batchNo);
                if (message.batchNoOrigin != null && Object.hasOwnProperty.call(message, "batchNoOrigin"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.batchNoOrigin);
                if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.date);
                if (message.time != null && Object.hasOwnProperty.call(message, "time"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.time);
                if (message.submitDate != null && Object.hasOwnProperty.call(message, "submitDate"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.submitDate);
                if (message.paydueDate != null && Object.hasOwnProperty.call(message, "paydueDate"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.paydueDate);
                if (message.cardNo != null && Object.hasOwnProperty.call(message, "cardNo"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.cardNo);
                if (message.authCode != null && Object.hasOwnProperty.call(message, "authCode"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.authCode);
                if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                    writer.uint32(/* id 11, wireType 1 =*/89).double(message.amount);
                if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                    writer.uint32(/* id 12, wireType 0 =*/96).int32(message.code);
                if (message.codeOrigin != null && Object.hasOwnProperty.call(message, "codeOrigin"))
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.codeOrigin);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 14, wireType 0 =*/112).int32(message.type);
                if (message.settleCode != null && Object.hasOwnProperty.call(message, "settleCode"))
                    writer.uint32(/* id 15, wireType 0 =*/120).int32(message.settleCode);
                if (message.orderNo != null && Object.hasOwnProperty.call(message, "orderNo"))
                    writer.uint32(/* id 16, wireType 2 =*/130).string(message.orderNo);
                if (message.isCreditCard != null && Object.hasOwnProperty.call(message, "isCreditCard"))
                    writer.uint32(/* id 17, wireType 0 =*/136).int32(message.isCreditCard);
                if (message.cardType != null && Object.hasOwnProperty.call(message, "cardType"))
                    writer.uint32(/* id 18, wireType 0 =*/144).int32(message.cardType);
                if (message.cardTypeOrigin != null && Object.hasOwnProperty.call(message, "cardTypeOrigin"))
                    writer.uint32(/* id 19, wireType 2 =*/154).string(message.cardTypeOrigin);
                if (message.installCode != null && Object.hasOwnProperty.call(message, "installCode"))
                    writer.uint32(/* id 20, wireType 0 =*/160).int32(message.installCode);
                if (message.installCodeOrigin != null && Object.hasOwnProperty.call(message, "installCodeOrigin"))
                    writer.uint32(/* id 21, wireType 2 =*/170).string(message.installCodeOrigin);
                if (message.payFlag != null && Object.hasOwnProperty.call(message, "payFlag"))
                    writer.uint32(/* id 22, wireType 0 =*/176).int32(message.payFlag);
                if (message.payFlagOrigin != null && Object.hasOwnProperty.call(message, "payFlagOrigin"))
                    writer.uint32(/* id 23, wireType 2 =*/186).string(message.payFlagOrigin);
                if (message.installTimes != null && Object.hasOwnProperty.call(message, "installTimes"))
                    writer.uint32(/* id 24, wireType 0 =*/192).int32(message.installTimes);
                if (message.installAverageAmount != null && Object.hasOwnProperty.call(message, "installAverageAmount"))
                    writer.uint32(/* id 25, wireType 1 =*/201).double(message.installAverageAmount);
                if (message.storeCode != null && Object.hasOwnProperty.call(message, "storeCode"))
                    writer.uint32(/* id 26, wireType 2 =*/210).string(message.storeCode);
                if (message.terminalNo != null && Object.hasOwnProperty.call(message, "terminalNo"))
                    writer.uint32(/* id 27, wireType 2 =*/218).string(message.terminalNo);
                if (message.feeFlag != null && Object.hasOwnProperty.call(message, "feeFlag"))
                    writer.uint32(/* id 28, wireType 0 =*/224).int32(message.feeFlag);
                if (message.feeFlagOrigin != null && Object.hasOwnProperty.call(message, "feeFlagOrigin"))
                    writer.uint32(/* id 29, wireType 2 =*/234).string(message.feeFlagOrigin);
                if (message.stan != null && Object.hasOwnProperty.call(message, "stan"))
                    writer.uint32(/* id 30, wireType 2 =*/242).string(message.stan);
                if (message.issuer != null && Object.hasOwnProperty.call(message, "issuer"))
                    writer.uint32(/* id 31, wireType 2 =*/250).string(message.issuer);
                if (message.isOurBank != null && Object.hasOwnProperty.call(message, "isOurBank"))
                    writer.uint32(/* id 32, wireType 0 =*/256).int32(message.isOurBank);
                if (message.taiwanPayQrFlag != null && Object.hasOwnProperty.call(message, "taiwanPayQrFlag"))
                    writer.uint32(/* id 33, wireType 0 =*/264).int32(message.taiwanPayQrFlag);
                if (message.infoType != null && Object.hasOwnProperty.call(message, "infoType"))
                    writer.uint32(/* id 34, wireType 0 =*/272).int32(message.infoType);
                if (message.tidNumber != null && Object.hasOwnProperty.call(message, "tidNumber"))
                    writer.uint32(/* id 35, wireType 2 =*/282).string(message.tidNumber);
                if (message.storeCodeMapping != null && Object.hasOwnProperty.call(message, "storeCodeMapping"))
                    writer.uint32(/* id 36, wireType 2 =*/290).string(message.storeCodeMapping);
                if (message.subStoreCode != null && Object.hasOwnProperty.call(message, "subStoreCode"))
                    writer.uint32(/* id 37, wireType 2 =*/298).string(message.subStoreCode);
                if (message.stanOrigin != null && Object.hasOwnProperty.call(message, "stanOrigin"))
                    writer.uint32(/* id 38, wireType 2 =*/306).string(message.stanOrigin);
                if (message.tpan != null && Object.hasOwnProperty.call(message, "tpan"))
                    writer.uint32(/* id 39, wireType 2 =*/314).string(message.tpan);
                if (message.issuerOrigin != null && Object.hasOwnProperty.call(message, "issuerOrigin"))
                    writer.uint32(/* id 40, wireType 2 =*/322).string(message.issuerOrigin);
                return writer;
            };

            /**
             * Encodes the specified ReimbursementInfo message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.ReimbursementInfo.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementInfo} message ReimbursementInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReimbursementInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ReimbursementInfo message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.ReimbursementInfo} ReimbursementInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReimbursementInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.ReimbursementInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.reimbursementId = reader.int32();
                        break;
                    case 2:
                        message.sourceId = reader.int32();
                        break;
                    case 3:
                        message.batchNo = reader.string();
                        break;
                    case 4:
                        message.batchNoOrigin = reader.string();
                        break;
                    case 5:
                        message.date = reader.string();
                        break;
                    case 6:
                        message.time = reader.string();
                        break;
                    case 7:
                        message.submitDate = reader.string();
                        break;
                    case 8:
                        message.paydueDate = reader.string();
                        break;
                    case 9:
                        message.cardNo = reader.string();
                        break;
                    case 10:
                        message.authCode = reader.string();
                        break;
                    case 11:
                        message.amount = reader.double();
                        break;
                    case 12:
                        message.code = reader.int32();
                        break;
                    case 13:
                        message.codeOrigin = reader.string();
                        break;
                    case 14:
                        message.type = reader.int32();
                        break;
                    case 15:
                        message.settleCode = reader.int32();
                        break;
                    case 16:
                        message.orderNo = reader.string();
                        break;
                    case 17:
                        message.isCreditCard = reader.int32();
                        break;
                    case 18:
                        message.cardType = reader.int32();
                        break;
                    case 19:
                        message.cardTypeOrigin = reader.string();
                        break;
                    case 20:
                        message.installCode = reader.int32();
                        break;
                    case 21:
                        message.installCodeOrigin = reader.string();
                        break;
                    case 22:
                        message.payFlag = reader.int32();
                        break;
                    case 23:
                        message.payFlagOrigin = reader.string();
                        break;
                    case 24:
                        message.installTimes = reader.int32();
                        break;
                    case 25:
                        message.installAverageAmount = reader.double();
                        break;
                    case 26:
                        message.storeCode = reader.string();
                        break;
                    case 27:
                        message.terminalNo = reader.string();
                        break;
                    case 28:
                        message.feeFlag = reader.int32();
                        break;
                    case 29:
                        message.feeFlagOrigin = reader.string();
                        break;
                    case 30:
                        message.stan = reader.string();
                        break;
                    case 31:
                        message.issuer = reader.string();
                        break;
                    case 32:
                        message.isOurBank = reader.int32();
                        break;
                    case 33:
                        message.taiwanPayQrFlag = reader.int32();
                        break;
                    case 34:
                        message.infoType = reader.int32();
                        break;
                    case 35:
                        message.tidNumber = reader.string();
                        break;
                    case 36:
                        message.storeCodeMapping = reader.string();
                        break;
                    case 37:
                        message.subStoreCode = reader.string();
                        break;
                    case 38:
                        message.stanOrigin = reader.string();
                        break;
                    case 39:
                        message.tpan = reader.string();
                        break;
                    case 40:
                        message.issuerOrigin = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ReimbursementInfo message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.ReimbursementInfo} ReimbursementInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReimbursementInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ReimbursementInfo message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ReimbursementInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.reimbursementId != null && message.hasOwnProperty("reimbursementId"))
                    if (!$util.isInteger(message.reimbursementId))
                        return "reimbursementId: integer expected";
                if (message.sourceId != null && message.hasOwnProperty("sourceId"))
                    if (!$util.isInteger(message.sourceId))
                        return "sourceId: integer expected";
                if (message.batchNo != null && message.hasOwnProperty("batchNo"))
                    if (!$util.isString(message.batchNo))
                        return "batchNo: string expected";
                if (message.batchNoOrigin != null && message.hasOwnProperty("batchNoOrigin"))
                    if (!$util.isString(message.batchNoOrigin))
                        return "batchNoOrigin: string expected";
                if (message.date != null && message.hasOwnProperty("date"))
                    if (!$util.isString(message.date))
                        return "date: string expected";
                if (message.time != null && message.hasOwnProperty("time"))
                    if (!$util.isString(message.time))
                        return "time: string expected";
                if (message.submitDate != null && message.hasOwnProperty("submitDate"))
                    if (!$util.isString(message.submitDate))
                        return "submitDate: string expected";
                if (message.paydueDate != null && message.hasOwnProperty("paydueDate"))
                    if (!$util.isString(message.paydueDate))
                        return "paydueDate: string expected";
                if (message.cardNo != null && message.hasOwnProperty("cardNo"))
                    if (!$util.isString(message.cardNo))
                        return "cardNo: string expected";
                if (message.authCode != null && message.hasOwnProperty("authCode"))
                    if (!$util.isString(message.authCode))
                        return "authCode: string expected";
                if (message.amount != null && message.hasOwnProperty("amount"))
                    if (typeof message.amount !== "number")
                        return "amount: number expected";
                if (message.code != null && message.hasOwnProperty("code"))
                    if (!$util.isInteger(message.code))
                        return "code: integer expected";
                if (message.codeOrigin != null && message.hasOwnProperty("codeOrigin"))
                    if (!$util.isString(message.codeOrigin))
                        return "codeOrigin: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isInteger(message.type))
                        return "type: integer expected";
                if (message.settleCode != null && message.hasOwnProperty("settleCode"))
                    if (!$util.isInteger(message.settleCode))
                        return "settleCode: integer expected";
                if (message.orderNo != null && message.hasOwnProperty("orderNo"))
                    if (!$util.isString(message.orderNo))
                        return "orderNo: string expected";
                if (message.isCreditCard != null && message.hasOwnProperty("isCreditCard"))
                    if (!$util.isInteger(message.isCreditCard))
                        return "isCreditCard: integer expected";
                if (message.cardType != null && message.hasOwnProperty("cardType"))
                    if (!$util.isInteger(message.cardType))
                        return "cardType: integer expected";
                if (message.cardTypeOrigin != null && message.hasOwnProperty("cardTypeOrigin"))
                    if (!$util.isString(message.cardTypeOrigin))
                        return "cardTypeOrigin: string expected";
                if (message.installCode != null && message.hasOwnProperty("installCode"))
                    if (!$util.isInteger(message.installCode))
                        return "installCode: integer expected";
                if (message.installCodeOrigin != null && message.hasOwnProperty("installCodeOrigin"))
                    if (!$util.isString(message.installCodeOrigin))
                        return "installCodeOrigin: string expected";
                if (message.payFlag != null && message.hasOwnProperty("payFlag"))
                    if (!$util.isInteger(message.payFlag))
                        return "payFlag: integer expected";
                if (message.payFlagOrigin != null && message.hasOwnProperty("payFlagOrigin"))
                    if (!$util.isString(message.payFlagOrigin))
                        return "payFlagOrigin: string expected";
                if (message.installTimes != null && message.hasOwnProperty("installTimes"))
                    if (!$util.isInteger(message.installTimes))
                        return "installTimes: integer expected";
                if (message.installAverageAmount != null && message.hasOwnProperty("installAverageAmount"))
                    if (typeof message.installAverageAmount !== "number")
                        return "installAverageAmount: number expected";
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    if (!$util.isString(message.storeCode))
                        return "storeCode: string expected";
                if (message.terminalNo != null && message.hasOwnProperty("terminalNo"))
                    if (!$util.isString(message.terminalNo))
                        return "terminalNo: string expected";
                if (message.feeFlag != null && message.hasOwnProperty("feeFlag"))
                    if (!$util.isInteger(message.feeFlag))
                        return "feeFlag: integer expected";
                if (message.feeFlagOrigin != null && message.hasOwnProperty("feeFlagOrigin"))
                    if (!$util.isString(message.feeFlagOrigin))
                        return "feeFlagOrigin: string expected";
                if (message.stan != null && message.hasOwnProperty("stan"))
                    if (!$util.isString(message.stan))
                        return "stan: string expected";
                if (message.issuer != null && message.hasOwnProperty("issuer"))
                    if (!$util.isString(message.issuer))
                        return "issuer: string expected";
                if (message.isOurBank != null && message.hasOwnProperty("isOurBank"))
                    if (!$util.isInteger(message.isOurBank))
                        return "isOurBank: integer expected";
                if (message.taiwanPayQrFlag != null && message.hasOwnProperty("taiwanPayQrFlag"))
                    if (!$util.isInteger(message.taiwanPayQrFlag))
                        return "taiwanPayQrFlag: integer expected";
                if (message.infoType != null && message.hasOwnProperty("infoType"))
                    if (!$util.isInteger(message.infoType))
                        return "infoType: integer expected";
                if (message.tidNumber != null && message.hasOwnProperty("tidNumber"))
                    if (!$util.isString(message.tidNumber))
                        return "tidNumber: string expected";
                if (message.storeCodeMapping != null && message.hasOwnProperty("storeCodeMapping"))
                    if (!$util.isString(message.storeCodeMapping))
                        return "storeCodeMapping: string expected";
                if (message.subStoreCode != null && message.hasOwnProperty("subStoreCode"))
                    if (!$util.isString(message.subStoreCode))
                        return "subStoreCode: string expected";
                if (message.stanOrigin != null && message.hasOwnProperty("stanOrigin"))
                    if (!$util.isString(message.stanOrigin))
                        return "stanOrigin: string expected";
                if (message.tpan != null && message.hasOwnProperty("tpan"))
                    if (!$util.isString(message.tpan))
                        return "tpan: string expected";
                if (message.issuerOrigin != null && message.hasOwnProperty("issuerOrigin"))
                    if (!$util.isString(message.issuerOrigin))
                        return "issuerOrigin: string expected";
                return null;
            };

            /**
             * Creates a ReimbursementInfo message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.ReimbursementInfo} ReimbursementInfo
             */
            ReimbursementInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.ReimbursementInfo)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.ReimbursementInfo();
                if (object.reimbursementId != null)
                    message.reimbursementId = object.reimbursementId | 0;
                if (object.sourceId != null)
                    message.sourceId = object.sourceId | 0;
                if (object.batchNo != null)
                    message.batchNo = String(object.batchNo);
                if (object.batchNoOrigin != null)
                    message.batchNoOrigin = String(object.batchNoOrigin);
                if (object.date != null)
                    message.date = String(object.date);
                if (object.time != null)
                    message.time = String(object.time);
                if (object.submitDate != null)
                    message.submitDate = String(object.submitDate);
                if (object.paydueDate != null)
                    message.paydueDate = String(object.paydueDate);
                if (object.cardNo != null)
                    message.cardNo = String(object.cardNo);
                if (object.authCode != null)
                    message.authCode = String(object.authCode);
                if (object.amount != null)
                    message.amount = Number(object.amount);
                if (object.code != null)
                    message.code = object.code | 0;
                if (object.codeOrigin != null)
                    message.codeOrigin = String(object.codeOrigin);
                if (object.type != null)
                    message.type = object.type | 0;
                if (object.settleCode != null)
                    message.settleCode = object.settleCode | 0;
                if (object.orderNo != null)
                    message.orderNo = String(object.orderNo);
                if (object.isCreditCard != null)
                    message.isCreditCard = object.isCreditCard | 0;
                if (object.cardType != null)
                    message.cardType = object.cardType | 0;
                if (object.cardTypeOrigin != null)
                    message.cardTypeOrigin = String(object.cardTypeOrigin);
                if (object.installCode != null)
                    message.installCode = object.installCode | 0;
                if (object.installCodeOrigin != null)
                    message.installCodeOrigin = String(object.installCodeOrigin);
                if (object.payFlag != null)
                    message.payFlag = object.payFlag | 0;
                if (object.payFlagOrigin != null)
                    message.payFlagOrigin = String(object.payFlagOrigin);
                if (object.installTimes != null)
                    message.installTimes = object.installTimes | 0;
                if (object.installAverageAmount != null)
                    message.installAverageAmount = Number(object.installAverageAmount);
                if (object.storeCode != null)
                    message.storeCode = String(object.storeCode);
                if (object.terminalNo != null)
                    message.terminalNo = String(object.terminalNo);
                if (object.feeFlag != null)
                    message.feeFlag = object.feeFlag | 0;
                if (object.feeFlagOrigin != null)
                    message.feeFlagOrigin = String(object.feeFlagOrigin);
                if (object.stan != null)
                    message.stan = String(object.stan);
                if (object.issuer != null)
                    message.issuer = String(object.issuer);
                if (object.isOurBank != null)
                    message.isOurBank = object.isOurBank | 0;
                if (object.taiwanPayQrFlag != null)
                    message.taiwanPayQrFlag = object.taiwanPayQrFlag | 0;
                if (object.infoType != null)
                    message.infoType = object.infoType | 0;
                if (object.tidNumber != null)
                    message.tidNumber = String(object.tidNumber);
                if (object.storeCodeMapping != null)
                    message.storeCodeMapping = String(object.storeCodeMapping);
                if (object.subStoreCode != null)
                    message.subStoreCode = String(object.subStoreCode);
                if (object.stanOrigin != null)
                    message.stanOrigin = String(object.stanOrigin);
                if (object.tpan != null)
                    message.tpan = String(object.tpan);
                if (object.issuerOrigin != null)
                    message.issuerOrigin = String(object.issuerOrigin);
                return message;
            };

            /**
             * Creates a plain object from a ReimbursementInfo message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @static
             * @param {TCBReceiptApi.Protobuf.ReimbursementInfo} message ReimbursementInfo
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ReimbursementInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.reimbursementId = 0;
                    object.sourceId = 0;
                    object.batchNo = "";
                    object.batchNoOrigin = "";
                    object.date = "";
                    object.time = "";
                    object.submitDate = "";
                    object.paydueDate = "";
                    object.cardNo = "";
                    object.authCode = "";
                    object.amount = 0;
                    object.code = 0;
                    object.codeOrigin = "";
                    object.type = 0;
                    object.settleCode = 0;
                    object.orderNo = "";
                    object.isCreditCard = 0;
                    object.cardType = 0;
                    object.cardTypeOrigin = "";
                    object.installCode = 0;
                    object.installCodeOrigin = "";
                    object.payFlag = 0;
                    object.payFlagOrigin = "";
                    object.installTimes = 0;
                    object.installAverageAmount = 0;
                    object.storeCode = "";
                    object.terminalNo = "";
                    object.feeFlag = 0;
                    object.feeFlagOrigin = "";
                    object.stan = "";
                    object.issuer = "";
                    object.isOurBank = 0;
                    object.taiwanPayQrFlag = 0;
                    object.infoType = 0;
                    object.tidNumber = "";
                    object.storeCodeMapping = "";
                    object.subStoreCode = "";
                    object.stanOrigin = "";
                    object.tpan = "";
                    object.issuerOrigin = "";
                }
                if (message.reimbursementId != null && message.hasOwnProperty("reimbursementId"))
                    object.reimbursementId = message.reimbursementId;
                if (message.sourceId != null && message.hasOwnProperty("sourceId"))
                    object.sourceId = message.sourceId;
                if (message.batchNo != null && message.hasOwnProperty("batchNo"))
                    object.batchNo = message.batchNo;
                if (message.batchNoOrigin != null && message.hasOwnProperty("batchNoOrigin"))
                    object.batchNoOrigin = message.batchNoOrigin;
                if (message.date != null && message.hasOwnProperty("date"))
                    object.date = message.date;
                if (message.time != null && message.hasOwnProperty("time"))
                    object.time = message.time;
                if (message.submitDate != null && message.hasOwnProperty("submitDate"))
                    object.submitDate = message.submitDate;
                if (message.paydueDate != null && message.hasOwnProperty("paydueDate"))
                    object.paydueDate = message.paydueDate;
                if (message.cardNo != null && message.hasOwnProperty("cardNo"))
                    object.cardNo = message.cardNo;
                if (message.authCode != null && message.hasOwnProperty("authCode"))
                    object.authCode = message.authCode;
                if (message.amount != null && message.hasOwnProperty("amount"))
                    object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
                if (message.code != null && message.hasOwnProperty("code"))
                    object.code = message.code;
                if (message.codeOrigin != null && message.hasOwnProperty("codeOrigin"))
                    object.codeOrigin = message.codeOrigin;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.settleCode != null && message.hasOwnProperty("settleCode"))
                    object.settleCode = message.settleCode;
                if (message.orderNo != null && message.hasOwnProperty("orderNo"))
                    object.orderNo = message.orderNo;
                if (message.isCreditCard != null && message.hasOwnProperty("isCreditCard"))
                    object.isCreditCard = message.isCreditCard;
                if (message.cardType != null && message.hasOwnProperty("cardType"))
                    object.cardType = message.cardType;
                if (message.cardTypeOrigin != null && message.hasOwnProperty("cardTypeOrigin"))
                    object.cardTypeOrigin = message.cardTypeOrigin;
                if (message.installCode != null && message.hasOwnProperty("installCode"))
                    object.installCode = message.installCode;
                if (message.installCodeOrigin != null && message.hasOwnProperty("installCodeOrigin"))
                    object.installCodeOrigin = message.installCodeOrigin;
                if (message.payFlag != null && message.hasOwnProperty("payFlag"))
                    object.payFlag = message.payFlag;
                if (message.payFlagOrigin != null && message.hasOwnProperty("payFlagOrigin"))
                    object.payFlagOrigin = message.payFlagOrigin;
                if (message.installTimes != null && message.hasOwnProperty("installTimes"))
                    object.installTimes = message.installTimes;
                if (message.installAverageAmount != null && message.hasOwnProperty("installAverageAmount"))
                    object.installAverageAmount = options.json && !isFinite(message.installAverageAmount) ? String(message.installAverageAmount) : message.installAverageAmount;
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    object.storeCode = message.storeCode;
                if (message.terminalNo != null && message.hasOwnProperty("terminalNo"))
                    object.terminalNo = message.terminalNo;
                if (message.feeFlag != null && message.hasOwnProperty("feeFlag"))
                    object.feeFlag = message.feeFlag;
                if (message.feeFlagOrigin != null && message.hasOwnProperty("feeFlagOrigin"))
                    object.feeFlagOrigin = message.feeFlagOrigin;
                if (message.stan != null && message.hasOwnProperty("stan"))
                    object.stan = message.stan;
                if (message.issuer != null && message.hasOwnProperty("issuer"))
                    object.issuer = message.issuer;
                if (message.isOurBank != null && message.hasOwnProperty("isOurBank"))
                    object.isOurBank = message.isOurBank;
                if (message.taiwanPayQrFlag != null && message.hasOwnProperty("taiwanPayQrFlag"))
                    object.taiwanPayQrFlag = message.taiwanPayQrFlag;
                if (message.infoType != null && message.hasOwnProperty("infoType"))
                    object.infoType = message.infoType;
                if (message.tidNumber != null && message.hasOwnProperty("tidNumber"))
                    object.tidNumber = message.tidNumber;
                if (message.storeCodeMapping != null && message.hasOwnProperty("storeCodeMapping"))
                    object.storeCodeMapping = message.storeCodeMapping;
                if (message.subStoreCode != null && message.hasOwnProperty("subStoreCode"))
                    object.subStoreCode = message.subStoreCode;
                if (message.stanOrigin != null && message.hasOwnProperty("stanOrigin"))
                    object.stanOrigin = message.stanOrigin;
                if (message.tpan != null && message.hasOwnProperty("tpan"))
                    object.tpan = message.tpan;
                if (message.issuerOrigin != null && message.hasOwnProperty("issuerOrigin"))
                    object.issuerOrigin = message.issuerOrigin;
                return object;
            };

            /**
             * Converts this ReimbursementInfo to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.ReimbursementInfo
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ReimbursementInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ReimbursementInfo;
        })();

        Protobuf.Reimbursement = (function() {

            /**
             * Properties of a Reimbursement.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IReimbursement
             * @property {Array.<TCBReceiptApi.Protobuf.IReimbursementInfo>|null} [list] Reimbursement list
             */

            /**
             * Constructs a new Reimbursement.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a Reimbursement.
             * @implements IReimbursement
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IReimbursement=} [properties] Properties to set
             */
            function Reimbursement(properties) {
                this.list = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Reimbursement list.
             * @member {Array.<TCBReceiptApi.Protobuf.IReimbursementInfo>} list
             * @memberof TCBReceiptApi.Protobuf.Reimbursement
             * @instance
             */
            Reimbursement.prototype.list = $util.emptyArray;

            /**
             * Creates a new Reimbursement instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.Reimbursement
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursement=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.Reimbursement} Reimbursement instance
             */
            Reimbursement.create = function create(properties) {
                return new Reimbursement(properties);
            };

            /**
             * Encodes the specified Reimbursement message. Does not implicitly {@link TCBReceiptApi.Protobuf.Reimbursement.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.Reimbursement
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursement} message Reimbursement message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Reimbursement.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.list != null && message.list.length)
                    for (var i = 0; i < message.list.length; ++i)
                        $root.TCBReceiptApi.Protobuf.ReimbursementInfo.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Reimbursement message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.Reimbursement.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.Reimbursement
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursement} message Reimbursement message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Reimbursement.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Reimbursement message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.Reimbursement
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.Reimbursement} Reimbursement
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Reimbursement.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.Reimbursement();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.TCBReceiptApi.Protobuf.ReimbursementInfo.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Reimbursement message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.Reimbursement
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.Reimbursement} Reimbursement
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Reimbursement.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Reimbursement message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.Reimbursement
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Reimbursement.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.list != null && message.hasOwnProperty("list")) {
                    if (!Array.isArray(message.list))
                        return "list: array expected";
                    for (var i = 0; i < message.list.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.ReimbursementInfo.verify(message.list[i]);
                        if (error)
                            return "list." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a Reimbursement message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.Reimbursement
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.Reimbursement} Reimbursement
             */
            Reimbursement.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.Reimbursement)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.Reimbursement();
                if (object.list) {
                    if (!Array.isArray(object.list))
                        throw TypeError(".TCBReceiptApi.Protobuf.Reimbursement.list: array expected");
                    message.list = [];
                    for (var i = 0; i < object.list.length; ++i) {
                        if (typeof object.list[i] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.Reimbursement.list: object expected");
                        message.list[i] = $root.TCBReceiptApi.Protobuf.ReimbursementInfo.fromObject(object.list[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a Reimbursement message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.Reimbursement
             * @static
             * @param {TCBReceiptApi.Protobuf.Reimbursement} message Reimbursement
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Reimbursement.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.list = [];
                if (message.list && message.list.length) {
                    object.list = [];
                    for (var j = 0; j < message.list.length; ++j)
                        object.list[j] = $root.TCBReceiptApi.Protobuf.ReimbursementInfo.toObject(message.list[j], options);
                }
                return object;
            };

            /**
             * Converts this Reimbursement to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.Reimbursement
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Reimbursement.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Reimbursement;
        })();

        Protobuf.ReimbursementBatchNoMap = (function() {

            /**
             * Properties of a ReimbursementBatchNoMap.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IReimbursementBatchNoMap
             * @property {Object.<string,TCBReceiptApi.Protobuf.IReimbursement>|null} [byBatchNo] ReimbursementBatchNoMap byBatchNo
             */

            /**
             * Constructs a new ReimbursementBatchNoMap.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a ReimbursementBatchNoMap.
             * @implements IReimbursementBatchNoMap
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IReimbursementBatchNoMap=} [properties] Properties to set
             */
            function ReimbursementBatchNoMap(properties) {
                this.byBatchNo = {};
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ReimbursementBatchNoMap byBatchNo.
             * @member {Object.<string,TCBReceiptApi.Protobuf.IReimbursement>} byBatchNo
             * @memberof TCBReceiptApi.Protobuf.ReimbursementBatchNoMap
             * @instance
             */
            ReimbursementBatchNoMap.prototype.byBatchNo = $util.emptyObject;

            /**
             * Creates a new ReimbursementBatchNoMap instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.ReimbursementBatchNoMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementBatchNoMap=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.ReimbursementBatchNoMap} ReimbursementBatchNoMap instance
             */
            ReimbursementBatchNoMap.create = function create(properties) {
                return new ReimbursementBatchNoMap(properties);
            };

            /**
             * Encodes the specified ReimbursementBatchNoMap message. Does not implicitly {@link TCBReceiptApi.Protobuf.ReimbursementBatchNoMap.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementBatchNoMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementBatchNoMap} message ReimbursementBatchNoMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReimbursementBatchNoMap.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.byBatchNo != null && Object.hasOwnProperty.call(message, "byBatchNo"))
                    for (var keys = Object.keys(message.byBatchNo), i = 0; i < keys.length; ++i) {
                        writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                        $root.TCBReceiptApi.Protobuf.Reimbursement.encode(message.byBatchNo[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                    }
                return writer;
            };

            /**
             * Encodes the specified ReimbursementBatchNoMap message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.ReimbursementBatchNoMap.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ReimbursementBatchNoMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementBatchNoMap} message ReimbursementBatchNoMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReimbursementBatchNoMap.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ReimbursementBatchNoMap message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementBatchNoMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.ReimbursementBatchNoMap} ReimbursementBatchNoMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReimbursementBatchNoMap.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.ReimbursementBatchNoMap(), key, value;
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (message.byBatchNo === $util.emptyObject)
                            message.byBatchNo = {};
                        var end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = null;
                        while (reader.pos < end2) {
                            var tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = $root.TCBReceiptApi.Protobuf.Reimbursement.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.byBatchNo[key] = value;
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ReimbursementBatchNoMap message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ReimbursementBatchNoMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.ReimbursementBatchNoMap} ReimbursementBatchNoMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReimbursementBatchNoMap.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ReimbursementBatchNoMap message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.ReimbursementBatchNoMap
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ReimbursementBatchNoMap.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.byBatchNo != null && message.hasOwnProperty("byBatchNo")) {
                    if (!$util.isObject(message.byBatchNo))
                        return "byBatchNo: object expected";
                    var key = Object.keys(message.byBatchNo);
                    for (var i = 0; i < key.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.Reimbursement.verify(message.byBatchNo[key[i]]);
                        if (error)
                            return "byBatchNo." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a ReimbursementBatchNoMap message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.ReimbursementBatchNoMap
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.ReimbursementBatchNoMap} ReimbursementBatchNoMap
             */
            ReimbursementBatchNoMap.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.ReimbursementBatchNoMap)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.ReimbursementBatchNoMap();
                if (object.byBatchNo) {
                    if (typeof object.byBatchNo !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.ReimbursementBatchNoMap.byBatchNo: object expected");
                    message.byBatchNo = {};
                    for (var keys = Object.keys(object.byBatchNo), i = 0; i < keys.length; ++i) {
                        if (typeof object.byBatchNo[keys[i]] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.ReimbursementBatchNoMap.byBatchNo: object expected");
                        message.byBatchNo[keys[i]] = $root.TCBReceiptApi.Protobuf.Reimbursement.fromObject(object.byBatchNo[keys[i]]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a ReimbursementBatchNoMap message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.ReimbursementBatchNoMap
             * @static
             * @param {TCBReceiptApi.Protobuf.ReimbursementBatchNoMap} message ReimbursementBatchNoMap
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ReimbursementBatchNoMap.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.objects || options.defaults)
                    object.byBatchNo = {};
                var keys2;
                if (message.byBatchNo && (keys2 = Object.keys(message.byBatchNo)).length) {
                    object.byBatchNo = {};
                    for (var j = 0; j < keys2.length; ++j)
                        object.byBatchNo[keys2[j]] = $root.TCBReceiptApi.Protobuf.Reimbursement.toObject(message.byBatchNo[keys2[j]], options);
                }
                return object;
            };

            /**
             * Converts this ReimbursementBatchNoMap to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.ReimbursementBatchNoMap
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ReimbursementBatchNoMap.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ReimbursementBatchNoMap;
        })();

        Protobuf.ReimbursementSecondMap = (function() {

            /**
             * Properties of a ReimbursementSecondMap.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IReimbursementSecondMap
             * @property {Object.<string,TCBReceiptApi.Protobuf.IReimbursementBatchNoMap>|null} [bySecondColumn] ReimbursementSecondMap bySecondColumn
             */

            /**
             * Constructs a new ReimbursementSecondMap.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a ReimbursementSecondMap.
             * @implements IReimbursementSecondMap
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IReimbursementSecondMap=} [properties] Properties to set
             */
            function ReimbursementSecondMap(properties) {
                this.bySecondColumn = {};
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ReimbursementSecondMap bySecondColumn.
             * @member {Object.<string,TCBReceiptApi.Protobuf.IReimbursementBatchNoMap>} bySecondColumn
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSecondMap
             * @instance
             */
            ReimbursementSecondMap.prototype.bySecondColumn = $util.emptyObject;

            /**
             * Creates a new ReimbursementSecondMap instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSecondMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementSecondMap=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.ReimbursementSecondMap} ReimbursementSecondMap instance
             */
            ReimbursementSecondMap.create = function create(properties) {
                return new ReimbursementSecondMap(properties);
            };

            /**
             * Encodes the specified ReimbursementSecondMap message. Does not implicitly {@link TCBReceiptApi.Protobuf.ReimbursementSecondMap.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSecondMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementSecondMap} message ReimbursementSecondMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReimbursementSecondMap.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.bySecondColumn != null && Object.hasOwnProperty.call(message, "bySecondColumn"))
                    for (var keys = Object.keys(message.bySecondColumn), i = 0; i < keys.length; ++i) {
                        writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                        $root.TCBReceiptApi.Protobuf.ReimbursementBatchNoMap.encode(message.bySecondColumn[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                    }
                return writer;
            };

            /**
             * Encodes the specified ReimbursementSecondMap message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.ReimbursementSecondMap.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSecondMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementSecondMap} message ReimbursementSecondMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReimbursementSecondMap.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ReimbursementSecondMap message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSecondMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.ReimbursementSecondMap} ReimbursementSecondMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReimbursementSecondMap.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.ReimbursementSecondMap(), key, value;
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (message.bySecondColumn === $util.emptyObject)
                            message.bySecondColumn = {};
                        var end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = null;
                        while (reader.pos < end2) {
                            var tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = $root.TCBReceiptApi.Protobuf.ReimbursementBatchNoMap.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.bySecondColumn[key] = value;
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ReimbursementSecondMap message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSecondMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.ReimbursementSecondMap} ReimbursementSecondMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReimbursementSecondMap.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ReimbursementSecondMap message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSecondMap
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ReimbursementSecondMap.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.bySecondColumn != null && message.hasOwnProperty("bySecondColumn")) {
                    if (!$util.isObject(message.bySecondColumn))
                        return "bySecondColumn: object expected";
                    var key = Object.keys(message.bySecondColumn);
                    for (var i = 0; i < key.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.ReimbursementBatchNoMap.verify(message.bySecondColumn[key[i]]);
                        if (error)
                            return "bySecondColumn." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a ReimbursementSecondMap message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSecondMap
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.ReimbursementSecondMap} ReimbursementSecondMap
             */
            ReimbursementSecondMap.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.ReimbursementSecondMap)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.ReimbursementSecondMap();
                if (object.bySecondColumn) {
                    if (typeof object.bySecondColumn !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.ReimbursementSecondMap.bySecondColumn: object expected");
                    message.bySecondColumn = {};
                    for (var keys = Object.keys(object.bySecondColumn), i = 0; i < keys.length; ++i) {
                        if (typeof object.bySecondColumn[keys[i]] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.ReimbursementSecondMap.bySecondColumn: object expected");
                        message.bySecondColumn[keys[i]] = $root.TCBReceiptApi.Protobuf.ReimbursementBatchNoMap.fromObject(object.bySecondColumn[keys[i]]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a ReimbursementSecondMap message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSecondMap
             * @static
             * @param {TCBReceiptApi.Protobuf.ReimbursementSecondMap} message ReimbursementSecondMap
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ReimbursementSecondMap.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.objects || options.defaults)
                    object.bySecondColumn = {};
                var keys2;
                if (message.bySecondColumn && (keys2 = Object.keys(message.bySecondColumn)).length) {
                    object.bySecondColumn = {};
                    for (var j = 0; j < keys2.length; ++j)
                        object.bySecondColumn[keys2[j]] = $root.TCBReceiptApi.Protobuf.ReimbursementBatchNoMap.toObject(message.bySecondColumn[keys2[j]], options);
                }
                return object;
            };

            /**
             * Converts this ReimbursementSecondMap to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSecondMap
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ReimbursementSecondMap.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ReimbursementSecondMap;
        })();

        Protobuf.ReimbursementFirstMap = (function() {

            /**
             * Properties of a ReimbursementFirstMap.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IReimbursementFirstMap
             * @property {Object.<string,TCBReceiptApi.Protobuf.IReimbursementSecondMap>|null} [byFirstColumn] ReimbursementFirstMap byFirstColumn
             */

            /**
             * Constructs a new ReimbursementFirstMap.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a ReimbursementFirstMap.
             * @implements IReimbursementFirstMap
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IReimbursementFirstMap=} [properties] Properties to set
             */
            function ReimbursementFirstMap(properties) {
                this.byFirstColumn = {};
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ReimbursementFirstMap byFirstColumn.
             * @member {Object.<string,TCBReceiptApi.Protobuf.IReimbursementSecondMap>} byFirstColumn
             * @memberof TCBReceiptApi.Protobuf.ReimbursementFirstMap
             * @instance
             */
            ReimbursementFirstMap.prototype.byFirstColumn = $util.emptyObject;

            /**
             * Creates a new ReimbursementFirstMap instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.ReimbursementFirstMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementFirstMap=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.ReimbursementFirstMap} ReimbursementFirstMap instance
             */
            ReimbursementFirstMap.create = function create(properties) {
                return new ReimbursementFirstMap(properties);
            };

            /**
             * Encodes the specified ReimbursementFirstMap message. Does not implicitly {@link TCBReceiptApi.Protobuf.ReimbursementFirstMap.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementFirstMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementFirstMap} message ReimbursementFirstMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReimbursementFirstMap.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.byFirstColumn != null && Object.hasOwnProperty.call(message, "byFirstColumn"))
                    for (var keys = Object.keys(message.byFirstColumn), i = 0; i < keys.length; ++i) {
                        writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                        $root.TCBReceiptApi.Protobuf.ReimbursementSecondMap.encode(message.byFirstColumn[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                    }
                return writer;
            };

            /**
             * Encodes the specified ReimbursementFirstMap message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.ReimbursementFirstMap.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ReimbursementFirstMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementFirstMap} message ReimbursementFirstMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReimbursementFirstMap.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ReimbursementFirstMap message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementFirstMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.ReimbursementFirstMap} ReimbursementFirstMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReimbursementFirstMap.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.ReimbursementFirstMap(), key, value;
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (message.byFirstColumn === $util.emptyObject)
                            message.byFirstColumn = {};
                        var end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = null;
                        while (reader.pos < end2) {
                            var tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = $root.TCBReceiptApi.Protobuf.ReimbursementSecondMap.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.byFirstColumn[key] = value;
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ReimbursementFirstMap message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ReimbursementFirstMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.ReimbursementFirstMap} ReimbursementFirstMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReimbursementFirstMap.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ReimbursementFirstMap message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.ReimbursementFirstMap
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ReimbursementFirstMap.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.byFirstColumn != null && message.hasOwnProperty("byFirstColumn")) {
                    if (!$util.isObject(message.byFirstColumn))
                        return "byFirstColumn: object expected";
                    var key = Object.keys(message.byFirstColumn);
                    for (var i = 0; i < key.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.ReimbursementSecondMap.verify(message.byFirstColumn[key[i]]);
                        if (error)
                            return "byFirstColumn." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a ReimbursementFirstMap message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.ReimbursementFirstMap
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.ReimbursementFirstMap} ReimbursementFirstMap
             */
            ReimbursementFirstMap.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.ReimbursementFirstMap)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.ReimbursementFirstMap();
                if (object.byFirstColumn) {
                    if (typeof object.byFirstColumn !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.ReimbursementFirstMap.byFirstColumn: object expected");
                    message.byFirstColumn = {};
                    for (var keys = Object.keys(object.byFirstColumn), i = 0; i < keys.length; ++i) {
                        if (typeof object.byFirstColumn[keys[i]] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.ReimbursementFirstMap.byFirstColumn: object expected");
                        message.byFirstColumn[keys[i]] = $root.TCBReceiptApi.Protobuf.ReimbursementSecondMap.fromObject(object.byFirstColumn[keys[i]]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a ReimbursementFirstMap message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.ReimbursementFirstMap
             * @static
             * @param {TCBReceiptApi.Protobuf.ReimbursementFirstMap} message ReimbursementFirstMap
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ReimbursementFirstMap.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.objects || options.defaults)
                    object.byFirstColumn = {};
                var keys2;
                if (message.byFirstColumn && (keys2 = Object.keys(message.byFirstColumn)).length) {
                    object.byFirstColumn = {};
                    for (var j = 0; j < keys2.length; ++j)
                        object.byFirstColumn[keys2[j]] = $root.TCBReceiptApi.Protobuf.ReimbursementSecondMap.toObject(message.byFirstColumn[keys2[j]], options);
                }
                return object;
            };

            /**
             * Converts this ReimbursementFirstMap to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.ReimbursementFirstMap
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ReimbursementFirstMap.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ReimbursementFirstMap;
        })();

        Protobuf.ReimbursementCollection = (function() {

            /**
             * Properties of a ReimbursementCollection.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IReimbursementCollection
             * @property {TCBReceiptApi.Protobuf.IReimbursementFirstMap|null} [byDate] ReimbursementCollection byDate
             * @property {TCBReceiptApi.Protobuf.IReimbursementFirstMap|null} [byTerminalNo] ReimbursementCollection byTerminalNo
             */

            /**
             * Constructs a new ReimbursementCollection.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a ReimbursementCollection.
             * @implements IReimbursementCollection
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IReimbursementCollection=} [properties] Properties to set
             */
            function ReimbursementCollection(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ReimbursementCollection byDate.
             * @member {TCBReceiptApi.Protobuf.IReimbursementFirstMap|null|undefined} byDate
             * @memberof TCBReceiptApi.Protobuf.ReimbursementCollection
             * @instance
             */
            ReimbursementCollection.prototype.byDate = null;

            /**
             * ReimbursementCollection byTerminalNo.
             * @member {TCBReceiptApi.Protobuf.IReimbursementFirstMap|null|undefined} byTerminalNo
             * @memberof TCBReceiptApi.Protobuf.ReimbursementCollection
             * @instance
             */
            ReimbursementCollection.prototype.byTerminalNo = null;

            /**
             * Creates a new ReimbursementCollection instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.ReimbursementCollection
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementCollection=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.ReimbursementCollection} ReimbursementCollection instance
             */
            ReimbursementCollection.create = function create(properties) {
                return new ReimbursementCollection(properties);
            };

            /**
             * Encodes the specified ReimbursementCollection message. Does not implicitly {@link TCBReceiptApi.Protobuf.ReimbursementCollection.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementCollection
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementCollection} message ReimbursementCollection message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReimbursementCollection.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.byDate != null && Object.hasOwnProperty.call(message, "byDate"))
                    $root.TCBReceiptApi.Protobuf.ReimbursementFirstMap.encode(message.byDate, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.byTerminalNo != null && Object.hasOwnProperty.call(message, "byTerminalNo"))
                    $root.TCBReceiptApi.Protobuf.ReimbursementFirstMap.encode(message.byTerminalNo, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ReimbursementCollection message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.ReimbursementCollection.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ReimbursementCollection
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementCollection} message ReimbursementCollection message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReimbursementCollection.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ReimbursementCollection message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementCollection
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.ReimbursementCollection} ReimbursementCollection
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReimbursementCollection.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.ReimbursementCollection();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.byDate = $root.TCBReceiptApi.Protobuf.ReimbursementFirstMap.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.byTerminalNo = $root.TCBReceiptApi.Protobuf.ReimbursementFirstMap.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ReimbursementCollection message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ReimbursementCollection
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.ReimbursementCollection} ReimbursementCollection
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReimbursementCollection.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ReimbursementCollection message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.ReimbursementCollection
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ReimbursementCollection.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.byDate != null && message.hasOwnProperty("byDate")) {
                    var error = $root.TCBReceiptApi.Protobuf.ReimbursementFirstMap.verify(message.byDate);
                    if (error)
                        return "byDate." + error;
                }
                if (message.byTerminalNo != null && message.hasOwnProperty("byTerminalNo")) {
                    var error = $root.TCBReceiptApi.Protobuf.ReimbursementFirstMap.verify(message.byTerminalNo);
                    if (error)
                        return "byTerminalNo." + error;
                }
                return null;
            };

            /**
             * Creates a ReimbursementCollection message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.ReimbursementCollection
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.ReimbursementCollection} ReimbursementCollection
             */
            ReimbursementCollection.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.ReimbursementCollection)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.ReimbursementCollection();
                if (object.byDate != null) {
                    if (typeof object.byDate !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.ReimbursementCollection.byDate: object expected");
                    message.byDate = $root.TCBReceiptApi.Protobuf.ReimbursementFirstMap.fromObject(object.byDate);
                }
                if (object.byTerminalNo != null) {
                    if (typeof object.byTerminalNo !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.ReimbursementCollection.byTerminalNo: object expected");
                    message.byTerminalNo = $root.TCBReceiptApi.Protobuf.ReimbursementFirstMap.fromObject(object.byTerminalNo);
                }
                return message;
            };

            /**
             * Creates a plain object from a ReimbursementCollection message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.ReimbursementCollection
             * @static
             * @param {TCBReceiptApi.Protobuf.ReimbursementCollection} message ReimbursementCollection
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ReimbursementCollection.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.byDate = null;
                    object.byTerminalNo = null;
                }
                if (message.byDate != null && message.hasOwnProperty("byDate"))
                    object.byDate = $root.TCBReceiptApi.Protobuf.ReimbursementFirstMap.toObject(message.byDate, options);
                if (message.byTerminalNo != null && message.hasOwnProperty("byTerminalNo"))
                    object.byTerminalNo = $root.TCBReceiptApi.Protobuf.ReimbursementFirstMap.toObject(message.byTerminalNo, options);
                return object;
            };

            /**
             * Converts this ReimbursementCollection to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.ReimbursementCollection
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ReimbursementCollection.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ReimbursementCollection;
        })();

        Protobuf.ReimbursementCollectionMap = (function() {

            /**
             * Properties of a ReimbursementCollectionMap.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IReimbursementCollectionMap
             * @property {Object.<string,TCBReceiptApi.Protobuf.IReimbursementCollection>|null} [map] ReimbursementCollectionMap map
             */

            /**
             * Constructs a new ReimbursementCollectionMap.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a ReimbursementCollectionMap.
             * @implements IReimbursementCollectionMap
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IReimbursementCollectionMap=} [properties] Properties to set
             */
            function ReimbursementCollectionMap(properties) {
                this.map = {};
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ReimbursementCollectionMap map.
             * @member {Object.<string,TCBReceiptApi.Protobuf.IReimbursementCollection>} map
             * @memberof TCBReceiptApi.Protobuf.ReimbursementCollectionMap
             * @instance
             */
            ReimbursementCollectionMap.prototype.map = $util.emptyObject;

            /**
             * Creates a new ReimbursementCollectionMap instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.ReimbursementCollectionMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementCollectionMap=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.ReimbursementCollectionMap} ReimbursementCollectionMap instance
             */
            ReimbursementCollectionMap.create = function create(properties) {
                return new ReimbursementCollectionMap(properties);
            };

            /**
             * Encodes the specified ReimbursementCollectionMap message. Does not implicitly {@link TCBReceiptApi.Protobuf.ReimbursementCollectionMap.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementCollectionMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementCollectionMap} message ReimbursementCollectionMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReimbursementCollectionMap.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.map != null && Object.hasOwnProperty.call(message, "map"))
                    for (var keys = Object.keys(message.map), i = 0; i < keys.length; ++i) {
                        writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                        $root.TCBReceiptApi.Protobuf.ReimbursementCollection.encode(message.map[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                    }
                return writer;
            };

            /**
             * Encodes the specified ReimbursementCollectionMap message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.ReimbursementCollectionMap.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ReimbursementCollectionMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementCollectionMap} message ReimbursementCollectionMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReimbursementCollectionMap.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ReimbursementCollectionMap message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementCollectionMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.ReimbursementCollectionMap} ReimbursementCollectionMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReimbursementCollectionMap.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.ReimbursementCollectionMap(), key, value;
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (message.map === $util.emptyObject)
                            message.map = {};
                        var end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = null;
                        while (reader.pos < end2) {
                            var tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = $root.TCBReceiptApi.Protobuf.ReimbursementCollection.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.map[key] = value;
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ReimbursementCollectionMap message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ReimbursementCollectionMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.ReimbursementCollectionMap} ReimbursementCollectionMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReimbursementCollectionMap.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ReimbursementCollectionMap message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.ReimbursementCollectionMap
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ReimbursementCollectionMap.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.map != null && message.hasOwnProperty("map")) {
                    if (!$util.isObject(message.map))
                        return "map: object expected";
                    var key = Object.keys(message.map);
                    for (var i = 0; i < key.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.ReimbursementCollection.verify(message.map[key[i]]);
                        if (error)
                            return "map." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a ReimbursementCollectionMap message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.ReimbursementCollectionMap
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.ReimbursementCollectionMap} ReimbursementCollectionMap
             */
            ReimbursementCollectionMap.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.ReimbursementCollectionMap)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.ReimbursementCollectionMap();
                if (object.map) {
                    if (typeof object.map !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.ReimbursementCollectionMap.map: object expected");
                    message.map = {};
                    for (var keys = Object.keys(object.map), i = 0; i < keys.length; ++i) {
                        if (typeof object.map[keys[i]] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.ReimbursementCollectionMap.map: object expected");
                        message.map[keys[i]] = $root.TCBReceiptApi.Protobuf.ReimbursementCollection.fromObject(object.map[keys[i]]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a ReimbursementCollectionMap message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.ReimbursementCollectionMap
             * @static
             * @param {TCBReceiptApi.Protobuf.ReimbursementCollectionMap} message ReimbursementCollectionMap
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ReimbursementCollectionMap.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.objects || options.defaults)
                    object.map = {};
                var keys2;
                if (message.map && (keys2 = Object.keys(message.map)).length) {
                    object.map = {};
                    for (var j = 0; j < keys2.length; ++j)
                        object.map[keys2[j]] = $root.TCBReceiptApi.Protobuf.ReimbursementCollection.toObject(message.map[keys2[j]], options);
                }
                return object;
            };

            /**
             * Converts this ReimbursementCollectionMap to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.ReimbursementCollectionMap
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ReimbursementCollectionMap.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ReimbursementCollectionMap;
        })();

        Protobuf.ReimbursementTotal = (function() {

            /**
             * Properties of a ReimbursementTotal.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IReimbursementTotal
             * @property {number|null} [count] ReimbursementTotal count
             * @property {number|null} [total] ReimbursementTotal total
             */

            /**
             * Constructs a new ReimbursementTotal.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a ReimbursementTotal.
             * @implements IReimbursementTotal
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IReimbursementTotal=} [properties] Properties to set
             */
            function ReimbursementTotal(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ReimbursementTotal count.
             * @member {number} count
             * @memberof TCBReceiptApi.Protobuf.ReimbursementTotal
             * @instance
             */
            ReimbursementTotal.prototype.count = 0;

            /**
             * ReimbursementTotal total.
             * @member {number} total
             * @memberof TCBReceiptApi.Protobuf.ReimbursementTotal
             * @instance
             */
            ReimbursementTotal.prototype.total = 0;

            /**
             * Creates a new ReimbursementTotal instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.ReimbursementTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementTotal=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.ReimbursementTotal} ReimbursementTotal instance
             */
            ReimbursementTotal.create = function create(properties) {
                return new ReimbursementTotal(properties);
            };

            /**
             * Encodes the specified ReimbursementTotal message. Does not implicitly {@link TCBReceiptApi.Protobuf.ReimbursementTotal.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementTotal} message ReimbursementTotal message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReimbursementTotal.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.count != null && Object.hasOwnProperty.call(message, "count"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.count);
                if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                    writer.uint32(/* id 2, wireType 1 =*/17).double(message.total);
                return writer;
            };

            /**
             * Encodes the specified ReimbursementTotal message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.ReimbursementTotal.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ReimbursementTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementTotal} message ReimbursementTotal message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReimbursementTotal.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ReimbursementTotal message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementTotal
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.ReimbursementTotal} ReimbursementTotal
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReimbursementTotal.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.ReimbursementTotal();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.count = reader.int32();
                        break;
                    case 2:
                        message.total = reader.double();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ReimbursementTotal message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ReimbursementTotal
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.ReimbursementTotal} ReimbursementTotal
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReimbursementTotal.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ReimbursementTotal message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.ReimbursementTotal
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ReimbursementTotal.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.count != null && message.hasOwnProperty("count"))
                    if (!$util.isInteger(message.count))
                        return "count: integer expected";
                if (message.total != null && message.hasOwnProperty("total"))
                    if (typeof message.total !== "number")
                        return "total: number expected";
                return null;
            };

            /**
             * Creates a ReimbursementTotal message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.ReimbursementTotal
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.ReimbursementTotal} ReimbursementTotal
             */
            ReimbursementTotal.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.ReimbursementTotal)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.ReimbursementTotal();
                if (object.count != null)
                    message.count = object.count | 0;
                if (object.total != null)
                    message.total = Number(object.total);
                return message;
            };

            /**
             * Creates a plain object from a ReimbursementTotal message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.ReimbursementTotal
             * @static
             * @param {TCBReceiptApi.Protobuf.ReimbursementTotal} message ReimbursementTotal
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ReimbursementTotal.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.count = 0;
                    object.total = 0;
                }
                if (message.count != null && message.hasOwnProperty("count"))
                    object.count = message.count;
                if (message.total != null && message.hasOwnProperty("total"))
                    object.total = options.json && !isFinite(message.total) ? String(message.total) : message.total;
                return object;
            };

            /**
             * Converts this ReimbursementTotal to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.ReimbursementTotal
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ReimbursementTotal.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ReimbursementTotal;
        })();

        Protobuf.ReimbursementSummaryInfo = (function() {

            /**
             * Properties of a ReimbursementSummaryInfo.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IReimbursementSummaryInfo
             * @property {number|null} [ourBankCount] ReimbursementSummaryInfo ourBankCount
             * @property {number|null} [ourBankAmount] ReimbursementSummaryInfo ourBankAmount
             * @property {number|null} [notOurBankCount] ReimbursementSummaryInfo notOurBankCount
             * @property {number|null} [notOurBankAmount] ReimbursementSummaryInfo notOurBankAmount
             * @property {number|null} [totalCount] ReimbursementSummaryInfo totalCount
             * @property {number|null} [totalAmount] ReimbursementSummaryInfo totalAmount
             */

            /**
             * Constructs a new ReimbursementSummaryInfo.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a ReimbursementSummaryInfo.
             * @implements IReimbursementSummaryInfo
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo=} [properties] Properties to set
             */
            function ReimbursementSummaryInfo(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ReimbursementSummaryInfo ourBankCount.
             * @member {number} ourBankCount
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryInfo
             * @instance
             */
            ReimbursementSummaryInfo.prototype.ourBankCount = 0;

            /**
             * ReimbursementSummaryInfo ourBankAmount.
             * @member {number} ourBankAmount
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryInfo
             * @instance
             */
            ReimbursementSummaryInfo.prototype.ourBankAmount = 0;

            /**
             * ReimbursementSummaryInfo notOurBankCount.
             * @member {number} notOurBankCount
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryInfo
             * @instance
             */
            ReimbursementSummaryInfo.prototype.notOurBankCount = 0;

            /**
             * ReimbursementSummaryInfo notOurBankAmount.
             * @member {number} notOurBankAmount
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryInfo
             * @instance
             */
            ReimbursementSummaryInfo.prototype.notOurBankAmount = 0;

            /**
             * ReimbursementSummaryInfo totalCount.
             * @member {number} totalCount
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryInfo
             * @instance
             */
            ReimbursementSummaryInfo.prototype.totalCount = 0;

            /**
             * ReimbursementSummaryInfo totalAmount.
             * @member {number} totalAmount
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryInfo
             * @instance
             */
            ReimbursementSummaryInfo.prototype.totalAmount = 0;

            /**
             * Creates a new ReimbursementSummaryInfo instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryInfo
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.ReimbursementSummaryInfo} ReimbursementSummaryInfo instance
             */
            ReimbursementSummaryInfo.create = function create(properties) {
                return new ReimbursementSummaryInfo(properties);
            };

            /**
             * Encodes the specified ReimbursementSummaryInfo message. Does not implicitly {@link TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryInfo
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo} message ReimbursementSummaryInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReimbursementSummaryInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.ourBankCount != null && Object.hasOwnProperty.call(message, "ourBankCount"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.ourBankCount);
                if (message.ourBankAmount != null && Object.hasOwnProperty.call(message, "ourBankAmount"))
                    writer.uint32(/* id 2, wireType 1 =*/17).double(message.ourBankAmount);
                if (message.notOurBankCount != null && Object.hasOwnProperty.call(message, "notOurBankCount"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.notOurBankCount);
                if (message.notOurBankAmount != null && Object.hasOwnProperty.call(message, "notOurBankAmount"))
                    writer.uint32(/* id 4, wireType 1 =*/33).double(message.notOurBankAmount);
                if (message.totalCount != null && Object.hasOwnProperty.call(message, "totalCount"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int32(message.totalCount);
                if (message.totalAmount != null && Object.hasOwnProperty.call(message, "totalAmount"))
                    writer.uint32(/* id 6, wireType 1 =*/49).double(message.totalAmount);
                return writer;
            };

            /**
             * Encodes the specified ReimbursementSummaryInfo message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryInfo
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo} message ReimbursementSummaryInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReimbursementSummaryInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ReimbursementSummaryInfo message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.ReimbursementSummaryInfo} ReimbursementSummaryInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReimbursementSummaryInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.ourBankCount = reader.int32();
                        break;
                    case 2:
                        message.ourBankAmount = reader.double();
                        break;
                    case 3:
                        message.notOurBankCount = reader.int32();
                        break;
                    case 4:
                        message.notOurBankAmount = reader.double();
                        break;
                    case 5:
                        message.totalCount = reader.int32();
                        break;
                    case 6:
                        message.totalAmount = reader.double();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ReimbursementSummaryInfo message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.ReimbursementSummaryInfo} ReimbursementSummaryInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReimbursementSummaryInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ReimbursementSummaryInfo message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryInfo
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ReimbursementSummaryInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.ourBankCount != null && message.hasOwnProperty("ourBankCount"))
                    if (!$util.isInteger(message.ourBankCount))
                        return "ourBankCount: integer expected";
                if (message.ourBankAmount != null && message.hasOwnProperty("ourBankAmount"))
                    if (typeof message.ourBankAmount !== "number")
                        return "ourBankAmount: number expected";
                if (message.notOurBankCount != null && message.hasOwnProperty("notOurBankCount"))
                    if (!$util.isInteger(message.notOurBankCount))
                        return "notOurBankCount: integer expected";
                if (message.notOurBankAmount != null && message.hasOwnProperty("notOurBankAmount"))
                    if (typeof message.notOurBankAmount !== "number")
                        return "notOurBankAmount: number expected";
                if (message.totalCount != null && message.hasOwnProperty("totalCount"))
                    if (!$util.isInteger(message.totalCount))
                        return "totalCount: integer expected";
                if (message.totalAmount != null && message.hasOwnProperty("totalAmount"))
                    if (typeof message.totalAmount !== "number")
                        return "totalAmount: number expected";
                return null;
            };

            /**
             * Creates a ReimbursementSummaryInfo message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryInfo
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.ReimbursementSummaryInfo} ReimbursementSummaryInfo
             */
            ReimbursementSummaryInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo();
                if (object.ourBankCount != null)
                    message.ourBankCount = object.ourBankCount | 0;
                if (object.ourBankAmount != null)
                    message.ourBankAmount = Number(object.ourBankAmount);
                if (object.notOurBankCount != null)
                    message.notOurBankCount = object.notOurBankCount | 0;
                if (object.notOurBankAmount != null)
                    message.notOurBankAmount = Number(object.notOurBankAmount);
                if (object.totalCount != null)
                    message.totalCount = object.totalCount | 0;
                if (object.totalAmount != null)
                    message.totalAmount = Number(object.totalAmount);
                return message;
            };

            /**
             * Creates a plain object from a ReimbursementSummaryInfo message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryInfo
             * @static
             * @param {TCBReceiptApi.Protobuf.ReimbursementSummaryInfo} message ReimbursementSummaryInfo
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ReimbursementSummaryInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.ourBankCount = 0;
                    object.ourBankAmount = 0;
                    object.notOurBankCount = 0;
                    object.notOurBankAmount = 0;
                    object.totalCount = 0;
                    object.totalAmount = 0;
                }
                if (message.ourBankCount != null && message.hasOwnProperty("ourBankCount"))
                    object.ourBankCount = message.ourBankCount;
                if (message.ourBankAmount != null && message.hasOwnProperty("ourBankAmount"))
                    object.ourBankAmount = options.json && !isFinite(message.ourBankAmount) ? String(message.ourBankAmount) : message.ourBankAmount;
                if (message.notOurBankCount != null && message.hasOwnProperty("notOurBankCount"))
                    object.notOurBankCount = message.notOurBankCount;
                if (message.notOurBankAmount != null && message.hasOwnProperty("notOurBankAmount"))
                    object.notOurBankAmount = options.json && !isFinite(message.notOurBankAmount) ? String(message.notOurBankAmount) : message.notOurBankAmount;
                if (message.totalCount != null && message.hasOwnProperty("totalCount"))
                    object.totalCount = message.totalCount;
                if (message.totalAmount != null && message.hasOwnProperty("totalAmount"))
                    object.totalAmount = options.json && !isFinite(message.totalAmount) ? String(message.totalAmount) : message.totalAmount;
                return object;
            };

            /**
             * Converts this ReimbursementSummaryInfo to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryInfo
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ReimbursementSummaryInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ReimbursementSummaryInfo;
        })();

        Protobuf.ReimbursementSummary = (function() {

            /**
             * Properties of a ReimbursementSummary.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IReimbursementSummary
             * @property {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null} [visaPay] ReimbursementSummary visaPay
             * @property {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null} [visaRefund] ReimbursementSummary visaRefund
             * @property {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null} [visaTotal] ReimbursementSummary visaTotal
             * @property {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null} [mcPay] ReimbursementSummary mcPay
             * @property {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null} [mcRefund] ReimbursementSummary mcRefund
             * @property {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null} [mcTotal] ReimbursementSummary mcTotal
             * @property {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null} [jcbPay] ReimbursementSummary jcbPay
             * @property {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null} [jcbRefund] ReimbursementSummary jcbRefund
             * @property {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null} [jcbTotal] ReimbursementSummary jcbTotal
             * @property {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null} [cupPay] ReimbursementSummary cupPay
             * @property {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null} [cupRefund] ReimbursementSummary cupRefund
             * @property {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null} [cupTotal] ReimbursementSummary cupTotal
             * @property {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null} [fiscPay] ReimbursementSummary fiscPay
             * @property {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null} [fiscRefund] ReimbursementSummary fiscRefund
             * @property {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null} [fiscTotal] ReimbursementSummary fiscTotal
             * @property {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null} [allPay] ReimbursementSummary allPay
             * @property {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null} [allRefund] ReimbursementSummary allRefund
             * @property {number|null} [allTotal] ReimbursementSummary allTotal
             */

            /**
             * Constructs a new ReimbursementSummary.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a ReimbursementSummary.
             * @implements IReimbursementSummary
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IReimbursementSummary=} [properties] Properties to set
             */
            function ReimbursementSummary(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ReimbursementSummary visaPay.
             * @member {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null|undefined} visaPay
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummary
             * @instance
             */
            ReimbursementSummary.prototype.visaPay = null;

            /**
             * ReimbursementSummary visaRefund.
             * @member {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null|undefined} visaRefund
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummary
             * @instance
             */
            ReimbursementSummary.prototype.visaRefund = null;

            /**
             * ReimbursementSummary visaTotal.
             * @member {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null|undefined} visaTotal
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummary
             * @instance
             */
            ReimbursementSummary.prototype.visaTotal = null;

            /**
             * ReimbursementSummary mcPay.
             * @member {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null|undefined} mcPay
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummary
             * @instance
             */
            ReimbursementSummary.prototype.mcPay = null;

            /**
             * ReimbursementSummary mcRefund.
             * @member {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null|undefined} mcRefund
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummary
             * @instance
             */
            ReimbursementSummary.prototype.mcRefund = null;

            /**
             * ReimbursementSummary mcTotal.
             * @member {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null|undefined} mcTotal
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummary
             * @instance
             */
            ReimbursementSummary.prototype.mcTotal = null;

            /**
             * ReimbursementSummary jcbPay.
             * @member {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null|undefined} jcbPay
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummary
             * @instance
             */
            ReimbursementSummary.prototype.jcbPay = null;

            /**
             * ReimbursementSummary jcbRefund.
             * @member {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null|undefined} jcbRefund
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummary
             * @instance
             */
            ReimbursementSummary.prototype.jcbRefund = null;

            /**
             * ReimbursementSummary jcbTotal.
             * @member {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null|undefined} jcbTotal
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummary
             * @instance
             */
            ReimbursementSummary.prototype.jcbTotal = null;

            /**
             * ReimbursementSummary cupPay.
             * @member {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null|undefined} cupPay
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummary
             * @instance
             */
            ReimbursementSummary.prototype.cupPay = null;

            /**
             * ReimbursementSummary cupRefund.
             * @member {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null|undefined} cupRefund
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummary
             * @instance
             */
            ReimbursementSummary.prototype.cupRefund = null;

            /**
             * ReimbursementSummary cupTotal.
             * @member {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null|undefined} cupTotal
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummary
             * @instance
             */
            ReimbursementSummary.prototype.cupTotal = null;

            /**
             * ReimbursementSummary fiscPay.
             * @member {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null|undefined} fiscPay
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummary
             * @instance
             */
            ReimbursementSummary.prototype.fiscPay = null;

            /**
             * ReimbursementSummary fiscRefund.
             * @member {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null|undefined} fiscRefund
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummary
             * @instance
             */
            ReimbursementSummary.prototype.fiscRefund = null;

            /**
             * ReimbursementSummary fiscTotal.
             * @member {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null|undefined} fiscTotal
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummary
             * @instance
             */
            ReimbursementSummary.prototype.fiscTotal = null;

            /**
             * ReimbursementSummary allPay.
             * @member {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null|undefined} allPay
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummary
             * @instance
             */
            ReimbursementSummary.prototype.allPay = null;

            /**
             * ReimbursementSummary allRefund.
             * @member {TCBReceiptApi.Protobuf.IReimbursementSummaryInfo|null|undefined} allRefund
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummary
             * @instance
             */
            ReimbursementSummary.prototype.allRefund = null;

            /**
             * ReimbursementSummary allTotal.
             * @member {number} allTotal
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummary
             * @instance
             */
            ReimbursementSummary.prototype.allTotal = 0;

            /**
             * Creates a new ReimbursementSummary instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummary
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementSummary=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.ReimbursementSummary} ReimbursementSummary instance
             */
            ReimbursementSummary.create = function create(properties) {
                return new ReimbursementSummary(properties);
            };

            /**
             * Encodes the specified ReimbursementSummary message. Does not implicitly {@link TCBReceiptApi.Protobuf.ReimbursementSummary.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummary
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementSummary} message ReimbursementSummary message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReimbursementSummary.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.visaPay != null && Object.hasOwnProperty.call(message, "visaPay"))
                    $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.encode(message.visaPay, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.visaRefund != null && Object.hasOwnProperty.call(message, "visaRefund"))
                    $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.encode(message.visaRefund, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.visaTotal != null && Object.hasOwnProperty.call(message, "visaTotal"))
                    $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.encode(message.visaTotal, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.mcPay != null && Object.hasOwnProperty.call(message, "mcPay"))
                    $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.encode(message.mcPay, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.mcRefund != null && Object.hasOwnProperty.call(message, "mcRefund"))
                    $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.encode(message.mcRefund, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.mcTotal != null && Object.hasOwnProperty.call(message, "mcTotal"))
                    $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.encode(message.mcTotal, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.jcbPay != null && Object.hasOwnProperty.call(message, "jcbPay"))
                    $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.encode(message.jcbPay, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                if (message.jcbRefund != null && Object.hasOwnProperty.call(message, "jcbRefund"))
                    $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.encode(message.jcbRefund, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                if (message.jcbTotal != null && Object.hasOwnProperty.call(message, "jcbTotal"))
                    $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.encode(message.jcbTotal, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                if (message.cupPay != null && Object.hasOwnProperty.call(message, "cupPay"))
                    $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.encode(message.cupPay, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                if (message.cupRefund != null && Object.hasOwnProperty.call(message, "cupRefund"))
                    $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.encode(message.cupRefund, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                if (message.cupTotal != null && Object.hasOwnProperty.call(message, "cupTotal"))
                    $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.encode(message.cupTotal, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                if (message.fiscPay != null && Object.hasOwnProperty.call(message, "fiscPay"))
                    $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.encode(message.fiscPay, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                if (message.fiscRefund != null && Object.hasOwnProperty.call(message, "fiscRefund"))
                    $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.encode(message.fiscRefund, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                if (message.fiscTotal != null && Object.hasOwnProperty.call(message, "fiscTotal"))
                    $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.encode(message.fiscTotal, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                if (message.allPay != null && Object.hasOwnProperty.call(message, "allPay"))
                    $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.encode(message.allPay, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                if (message.allRefund != null && Object.hasOwnProperty.call(message, "allRefund"))
                    $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.encode(message.allRefund, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                if (message.allTotal != null && Object.hasOwnProperty.call(message, "allTotal"))
                    writer.uint32(/* id 18, wireType 1 =*/145).double(message.allTotal);
                return writer;
            };

            /**
             * Encodes the specified ReimbursementSummary message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.ReimbursementSummary.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummary
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementSummary} message ReimbursementSummary message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReimbursementSummary.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ReimbursementSummary message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummary
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.ReimbursementSummary} ReimbursementSummary
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReimbursementSummary.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.ReimbursementSummary();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.visaPay = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.visaRefund = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.visaTotal = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.decode(reader, reader.uint32());
                        break;
                    case 4:
                        message.mcPay = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.decode(reader, reader.uint32());
                        break;
                    case 5:
                        message.mcRefund = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.decode(reader, reader.uint32());
                        break;
                    case 6:
                        message.mcTotal = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.decode(reader, reader.uint32());
                        break;
                    case 7:
                        message.jcbPay = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.decode(reader, reader.uint32());
                        break;
                    case 8:
                        message.jcbRefund = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.decode(reader, reader.uint32());
                        break;
                    case 9:
                        message.jcbTotal = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.decode(reader, reader.uint32());
                        break;
                    case 10:
                        message.cupPay = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.decode(reader, reader.uint32());
                        break;
                    case 11:
                        message.cupRefund = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.decode(reader, reader.uint32());
                        break;
                    case 12:
                        message.cupTotal = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.decode(reader, reader.uint32());
                        break;
                    case 13:
                        message.fiscPay = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.decode(reader, reader.uint32());
                        break;
                    case 14:
                        message.fiscRefund = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.decode(reader, reader.uint32());
                        break;
                    case 15:
                        message.fiscTotal = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.decode(reader, reader.uint32());
                        break;
                    case 16:
                        message.allPay = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.decode(reader, reader.uint32());
                        break;
                    case 17:
                        message.allRefund = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.decode(reader, reader.uint32());
                        break;
                    case 18:
                        message.allTotal = reader.double();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ReimbursementSummary message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummary
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.ReimbursementSummary} ReimbursementSummary
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReimbursementSummary.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ReimbursementSummary message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummary
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ReimbursementSummary.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.visaPay != null && message.hasOwnProperty("visaPay")) {
                    var error = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.verify(message.visaPay);
                    if (error)
                        return "visaPay." + error;
                }
                if (message.visaRefund != null && message.hasOwnProperty("visaRefund")) {
                    var error = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.verify(message.visaRefund);
                    if (error)
                        return "visaRefund." + error;
                }
                if (message.visaTotal != null && message.hasOwnProperty("visaTotal")) {
                    var error = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.verify(message.visaTotal);
                    if (error)
                        return "visaTotal." + error;
                }
                if (message.mcPay != null && message.hasOwnProperty("mcPay")) {
                    var error = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.verify(message.mcPay);
                    if (error)
                        return "mcPay." + error;
                }
                if (message.mcRefund != null && message.hasOwnProperty("mcRefund")) {
                    var error = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.verify(message.mcRefund);
                    if (error)
                        return "mcRefund." + error;
                }
                if (message.mcTotal != null && message.hasOwnProperty("mcTotal")) {
                    var error = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.verify(message.mcTotal);
                    if (error)
                        return "mcTotal." + error;
                }
                if (message.jcbPay != null && message.hasOwnProperty("jcbPay")) {
                    var error = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.verify(message.jcbPay);
                    if (error)
                        return "jcbPay." + error;
                }
                if (message.jcbRefund != null && message.hasOwnProperty("jcbRefund")) {
                    var error = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.verify(message.jcbRefund);
                    if (error)
                        return "jcbRefund." + error;
                }
                if (message.jcbTotal != null && message.hasOwnProperty("jcbTotal")) {
                    var error = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.verify(message.jcbTotal);
                    if (error)
                        return "jcbTotal." + error;
                }
                if (message.cupPay != null && message.hasOwnProperty("cupPay")) {
                    var error = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.verify(message.cupPay);
                    if (error)
                        return "cupPay." + error;
                }
                if (message.cupRefund != null && message.hasOwnProperty("cupRefund")) {
                    var error = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.verify(message.cupRefund);
                    if (error)
                        return "cupRefund." + error;
                }
                if (message.cupTotal != null && message.hasOwnProperty("cupTotal")) {
                    var error = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.verify(message.cupTotal);
                    if (error)
                        return "cupTotal." + error;
                }
                if (message.fiscPay != null && message.hasOwnProperty("fiscPay")) {
                    var error = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.verify(message.fiscPay);
                    if (error)
                        return "fiscPay." + error;
                }
                if (message.fiscRefund != null && message.hasOwnProperty("fiscRefund")) {
                    var error = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.verify(message.fiscRefund);
                    if (error)
                        return "fiscRefund." + error;
                }
                if (message.fiscTotal != null && message.hasOwnProperty("fiscTotal")) {
                    var error = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.verify(message.fiscTotal);
                    if (error)
                        return "fiscTotal." + error;
                }
                if (message.allPay != null && message.hasOwnProperty("allPay")) {
                    var error = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.verify(message.allPay);
                    if (error)
                        return "allPay." + error;
                }
                if (message.allRefund != null && message.hasOwnProperty("allRefund")) {
                    var error = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.verify(message.allRefund);
                    if (error)
                        return "allRefund." + error;
                }
                if (message.allTotal != null && message.hasOwnProperty("allTotal"))
                    if (typeof message.allTotal !== "number")
                        return "allTotal: number expected";
                return null;
            };

            /**
             * Creates a ReimbursementSummary message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummary
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.ReimbursementSummary} ReimbursementSummary
             */
            ReimbursementSummary.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.ReimbursementSummary)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.ReimbursementSummary();
                if (object.visaPay != null) {
                    if (typeof object.visaPay !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.ReimbursementSummary.visaPay: object expected");
                    message.visaPay = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.fromObject(object.visaPay);
                }
                if (object.visaRefund != null) {
                    if (typeof object.visaRefund !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.ReimbursementSummary.visaRefund: object expected");
                    message.visaRefund = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.fromObject(object.visaRefund);
                }
                if (object.visaTotal != null) {
                    if (typeof object.visaTotal !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.ReimbursementSummary.visaTotal: object expected");
                    message.visaTotal = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.fromObject(object.visaTotal);
                }
                if (object.mcPay != null) {
                    if (typeof object.mcPay !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.ReimbursementSummary.mcPay: object expected");
                    message.mcPay = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.fromObject(object.mcPay);
                }
                if (object.mcRefund != null) {
                    if (typeof object.mcRefund !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.ReimbursementSummary.mcRefund: object expected");
                    message.mcRefund = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.fromObject(object.mcRefund);
                }
                if (object.mcTotal != null) {
                    if (typeof object.mcTotal !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.ReimbursementSummary.mcTotal: object expected");
                    message.mcTotal = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.fromObject(object.mcTotal);
                }
                if (object.jcbPay != null) {
                    if (typeof object.jcbPay !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.ReimbursementSummary.jcbPay: object expected");
                    message.jcbPay = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.fromObject(object.jcbPay);
                }
                if (object.jcbRefund != null) {
                    if (typeof object.jcbRefund !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.ReimbursementSummary.jcbRefund: object expected");
                    message.jcbRefund = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.fromObject(object.jcbRefund);
                }
                if (object.jcbTotal != null) {
                    if (typeof object.jcbTotal !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.ReimbursementSummary.jcbTotal: object expected");
                    message.jcbTotal = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.fromObject(object.jcbTotal);
                }
                if (object.cupPay != null) {
                    if (typeof object.cupPay !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.ReimbursementSummary.cupPay: object expected");
                    message.cupPay = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.fromObject(object.cupPay);
                }
                if (object.cupRefund != null) {
                    if (typeof object.cupRefund !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.ReimbursementSummary.cupRefund: object expected");
                    message.cupRefund = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.fromObject(object.cupRefund);
                }
                if (object.cupTotal != null) {
                    if (typeof object.cupTotal !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.ReimbursementSummary.cupTotal: object expected");
                    message.cupTotal = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.fromObject(object.cupTotal);
                }
                if (object.fiscPay != null) {
                    if (typeof object.fiscPay !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.ReimbursementSummary.fiscPay: object expected");
                    message.fiscPay = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.fromObject(object.fiscPay);
                }
                if (object.fiscRefund != null) {
                    if (typeof object.fiscRefund !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.ReimbursementSummary.fiscRefund: object expected");
                    message.fiscRefund = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.fromObject(object.fiscRefund);
                }
                if (object.fiscTotal != null) {
                    if (typeof object.fiscTotal !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.ReimbursementSummary.fiscTotal: object expected");
                    message.fiscTotal = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.fromObject(object.fiscTotal);
                }
                if (object.allPay != null) {
                    if (typeof object.allPay !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.ReimbursementSummary.allPay: object expected");
                    message.allPay = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.fromObject(object.allPay);
                }
                if (object.allRefund != null) {
                    if (typeof object.allRefund !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.ReimbursementSummary.allRefund: object expected");
                    message.allRefund = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.fromObject(object.allRefund);
                }
                if (object.allTotal != null)
                    message.allTotal = Number(object.allTotal);
                return message;
            };

            /**
             * Creates a plain object from a ReimbursementSummary message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummary
             * @static
             * @param {TCBReceiptApi.Protobuf.ReimbursementSummary} message ReimbursementSummary
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ReimbursementSummary.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.visaPay = null;
                    object.visaRefund = null;
                    object.visaTotal = null;
                    object.mcPay = null;
                    object.mcRefund = null;
                    object.mcTotal = null;
                    object.jcbPay = null;
                    object.jcbRefund = null;
                    object.jcbTotal = null;
                    object.cupPay = null;
                    object.cupRefund = null;
                    object.cupTotal = null;
                    object.fiscPay = null;
                    object.fiscRefund = null;
                    object.fiscTotal = null;
                    object.allPay = null;
                    object.allRefund = null;
                    object.allTotal = 0;
                }
                if (message.visaPay != null && message.hasOwnProperty("visaPay"))
                    object.visaPay = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.toObject(message.visaPay, options);
                if (message.visaRefund != null && message.hasOwnProperty("visaRefund"))
                    object.visaRefund = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.toObject(message.visaRefund, options);
                if (message.visaTotal != null && message.hasOwnProperty("visaTotal"))
                    object.visaTotal = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.toObject(message.visaTotal, options);
                if (message.mcPay != null && message.hasOwnProperty("mcPay"))
                    object.mcPay = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.toObject(message.mcPay, options);
                if (message.mcRefund != null && message.hasOwnProperty("mcRefund"))
                    object.mcRefund = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.toObject(message.mcRefund, options);
                if (message.mcTotal != null && message.hasOwnProperty("mcTotal"))
                    object.mcTotal = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.toObject(message.mcTotal, options);
                if (message.jcbPay != null && message.hasOwnProperty("jcbPay"))
                    object.jcbPay = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.toObject(message.jcbPay, options);
                if (message.jcbRefund != null && message.hasOwnProperty("jcbRefund"))
                    object.jcbRefund = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.toObject(message.jcbRefund, options);
                if (message.jcbTotal != null && message.hasOwnProperty("jcbTotal"))
                    object.jcbTotal = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.toObject(message.jcbTotal, options);
                if (message.cupPay != null && message.hasOwnProperty("cupPay"))
                    object.cupPay = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.toObject(message.cupPay, options);
                if (message.cupRefund != null && message.hasOwnProperty("cupRefund"))
                    object.cupRefund = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.toObject(message.cupRefund, options);
                if (message.cupTotal != null && message.hasOwnProperty("cupTotal"))
                    object.cupTotal = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.toObject(message.cupTotal, options);
                if (message.fiscPay != null && message.hasOwnProperty("fiscPay"))
                    object.fiscPay = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.toObject(message.fiscPay, options);
                if (message.fiscRefund != null && message.hasOwnProperty("fiscRefund"))
                    object.fiscRefund = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.toObject(message.fiscRefund, options);
                if (message.fiscTotal != null && message.hasOwnProperty("fiscTotal"))
                    object.fiscTotal = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.toObject(message.fiscTotal, options);
                if (message.allPay != null && message.hasOwnProperty("allPay"))
                    object.allPay = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.toObject(message.allPay, options);
                if (message.allRefund != null && message.hasOwnProperty("allRefund"))
                    object.allRefund = $root.TCBReceiptApi.Protobuf.ReimbursementSummaryInfo.toObject(message.allRefund, options);
                if (message.allTotal != null && message.hasOwnProperty("allTotal"))
                    object.allTotal = options.json && !isFinite(message.allTotal) ? String(message.allTotal) : message.allTotal;
                return object;
            };

            /**
             * Converts this ReimbursementSummary to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummary
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ReimbursementSummary.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ReimbursementSummary;
        })();

        Protobuf.ReimbursementQuery = (function() {

            /**
             * Properties of a ReimbursementQuery.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IReimbursementQuery
             * @property {Array.<string>|null} [storeList] ReimbursementQuery storeList
             * @property {string|null} [tidNumber] ReimbursementQuery tidNumber
             * @property {string|null} [authCode] ReimbursementQuery authCode
             * @property {string|null} [cardNo] ReimbursementQuery cardNo
             * @property {string|null} [cardType] ReimbursementQuery cardType
             * @property {number|null} [type] ReimbursementQuery type
             * @property {number|null} [flag] ReimbursementQuery flag
             * @property {string|null} [orderNo] ReimbursementQuery orderNo
             * @property {number|null} [dateType] ReimbursementQuery dateType
             * @property {string|null} [dateStart] ReimbursementQuery dateStart
             * @property {string|null} [dateEnd] ReimbursementQuery dateEnd
             * @property {string|null} [terminalNoStart] ReimbursementQuery terminalNoStart
             * @property {string|null} [terminalNoEnd] ReimbursementQuery terminalNoEnd
             * @property {string|null} [specificStore] ReimbursementQuery specificStore
             */

            /**
             * Constructs a new ReimbursementQuery.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a ReimbursementQuery.
             * @implements IReimbursementQuery
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IReimbursementQuery=} [properties] Properties to set
             */
            function ReimbursementQuery(properties) {
                this.storeList = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ReimbursementQuery storeList.
             * @member {Array.<string>} storeList
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuery
             * @instance
             */
            ReimbursementQuery.prototype.storeList = $util.emptyArray;

            /**
             * ReimbursementQuery tidNumber.
             * @member {string} tidNumber
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuery
             * @instance
             */
            ReimbursementQuery.prototype.tidNumber = "";

            /**
             * ReimbursementQuery authCode.
             * @member {string} authCode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuery
             * @instance
             */
            ReimbursementQuery.prototype.authCode = "";

            /**
             * ReimbursementQuery cardNo.
             * @member {string} cardNo
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuery
             * @instance
             */
            ReimbursementQuery.prototype.cardNo = "";

            /**
             * ReimbursementQuery cardType.
             * @member {string} cardType
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuery
             * @instance
             */
            ReimbursementQuery.prototype.cardType = "";

            /**
             * ReimbursementQuery type.
             * @member {number} type
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuery
             * @instance
             */
            ReimbursementQuery.prototype.type = 0;

            /**
             * ReimbursementQuery flag.
             * @member {number} flag
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuery
             * @instance
             */
            ReimbursementQuery.prototype.flag = 0;

            /**
             * ReimbursementQuery orderNo.
             * @member {string} orderNo
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuery
             * @instance
             */
            ReimbursementQuery.prototype.orderNo = "";

            /**
             * ReimbursementQuery dateType.
             * @member {number} dateType
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuery
             * @instance
             */
            ReimbursementQuery.prototype.dateType = 0;

            /**
             * ReimbursementQuery dateStart.
             * @member {string} dateStart
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuery
             * @instance
             */
            ReimbursementQuery.prototype.dateStart = "";

            /**
             * ReimbursementQuery dateEnd.
             * @member {string} dateEnd
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuery
             * @instance
             */
            ReimbursementQuery.prototype.dateEnd = "";

            /**
             * ReimbursementQuery terminalNoStart.
             * @member {string} terminalNoStart
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuery
             * @instance
             */
            ReimbursementQuery.prototype.terminalNoStart = "";

            /**
             * ReimbursementQuery terminalNoEnd.
             * @member {string} terminalNoEnd
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuery
             * @instance
             */
            ReimbursementQuery.prototype.terminalNoEnd = "";

            /**
             * ReimbursementQuery specificStore.
             * @member {string} specificStore
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuery
             * @instance
             */
            ReimbursementQuery.prototype.specificStore = "";

            /**
             * Creates a new ReimbursementQuery instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementQuery=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.ReimbursementQuery} ReimbursementQuery instance
             */
            ReimbursementQuery.create = function create(properties) {
                return new ReimbursementQuery(properties);
            };

            /**
             * Encodes the specified ReimbursementQuery message. Does not implicitly {@link TCBReceiptApi.Protobuf.ReimbursementQuery.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementQuery} message ReimbursementQuery message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReimbursementQuery.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.storeList != null && message.storeList.length)
                    for (var i = 0; i < message.storeList.length; ++i)
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.storeList[i]);
                if (message.tidNumber != null && Object.hasOwnProperty.call(message, "tidNumber"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.tidNumber);
                if (message.authCode != null && Object.hasOwnProperty.call(message, "authCode"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.authCode);
                if (message.cardNo != null && Object.hasOwnProperty.call(message, "cardNo"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.cardNo);
                if (message.cardType != null && Object.hasOwnProperty.call(message, "cardType"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.cardType);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int32(message.type);
                if (message.flag != null && Object.hasOwnProperty.call(message, "flag"))
                    writer.uint32(/* id 7, wireType 0 =*/56).int32(message.flag);
                if (message.orderNo != null && Object.hasOwnProperty.call(message, "orderNo"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.orderNo);
                if (message.dateType != null && Object.hasOwnProperty.call(message, "dateType"))
                    writer.uint32(/* id 9, wireType 0 =*/72).int32(message.dateType);
                if (message.dateStart != null && Object.hasOwnProperty.call(message, "dateStart"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.dateStart);
                if (message.dateEnd != null && Object.hasOwnProperty.call(message, "dateEnd"))
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.dateEnd);
                if (message.terminalNoStart != null && Object.hasOwnProperty.call(message, "terminalNoStart"))
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.terminalNoStart);
                if (message.terminalNoEnd != null && Object.hasOwnProperty.call(message, "terminalNoEnd"))
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.terminalNoEnd);
                if (message.specificStore != null && Object.hasOwnProperty.call(message, "specificStore"))
                    writer.uint32(/* id 14, wireType 2 =*/114).string(message.specificStore);
                return writer;
            };

            /**
             * Encodes the specified ReimbursementQuery message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.ReimbursementQuery.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementQuery} message ReimbursementQuery message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReimbursementQuery.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ReimbursementQuery message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuery
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.ReimbursementQuery} ReimbursementQuery
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReimbursementQuery.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.ReimbursementQuery();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.storeList && message.storeList.length))
                            message.storeList = [];
                        message.storeList.push(reader.string());
                        break;
                    case 2:
                        message.tidNumber = reader.string();
                        break;
                    case 3:
                        message.authCode = reader.string();
                        break;
                    case 4:
                        message.cardNo = reader.string();
                        break;
                    case 5:
                        message.cardType = reader.string();
                        break;
                    case 6:
                        message.type = reader.int32();
                        break;
                    case 7:
                        message.flag = reader.int32();
                        break;
                    case 8:
                        message.orderNo = reader.string();
                        break;
                    case 9:
                        message.dateType = reader.int32();
                        break;
                    case 10:
                        message.dateStart = reader.string();
                        break;
                    case 11:
                        message.dateEnd = reader.string();
                        break;
                    case 12:
                        message.terminalNoStart = reader.string();
                        break;
                    case 13:
                        message.terminalNoEnd = reader.string();
                        break;
                    case 14:
                        message.specificStore = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ReimbursementQuery message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuery
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.ReimbursementQuery} ReimbursementQuery
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReimbursementQuery.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ReimbursementQuery message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuery
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ReimbursementQuery.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.storeList != null && message.hasOwnProperty("storeList")) {
                    if (!Array.isArray(message.storeList))
                        return "storeList: array expected";
                    for (var i = 0; i < message.storeList.length; ++i)
                        if (!$util.isString(message.storeList[i]))
                            return "storeList: string[] expected";
                }
                if (message.tidNumber != null && message.hasOwnProperty("tidNumber"))
                    if (!$util.isString(message.tidNumber))
                        return "tidNumber: string expected";
                if (message.authCode != null && message.hasOwnProperty("authCode"))
                    if (!$util.isString(message.authCode))
                        return "authCode: string expected";
                if (message.cardNo != null && message.hasOwnProperty("cardNo"))
                    if (!$util.isString(message.cardNo))
                        return "cardNo: string expected";
                if (message.cardType != null && message.hasOwnProperty("cardType"))
                    if (!$util.isString(message.cardType))
                        return "cardType: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isInteger(message.type))
                        return "type: integer expected";
                if (message.flag != null && message.hasOwnProperty("flag"))
                    if (!$util.isInteger(message.flag))
                        return "flag: integer expected";
                if (message.orderNo != null && message.hasOwnProperty("orderNo"))
                    if (!$util.isString(message.orderNo))
                        return "orderNo: string expected";
                if (message.dateType != null && message.hasOwnProperty("dateType"))
                    if (!$util.isInteger(message.dateType))
                        return "dateType: integer expected";
                if (message.dateStart != null && message.hasOwnProperty("dateStart"))
                    if (!$util.isString(message.dateStart))
                        return "dateStart: string expected";
                if (message.dateEnd != null && message.hasOwnProperty("dateEnd"))
                    if (!$util.isString(message.dateEnd))
                        return "dateEnd: string expected";
                if (message.terminalNoStart != null && message.hasOwnProperty("terminalNoStart"))
                    if (!$util.isString(message.terminalNoStart))
                        return "terminalNoStart: string expected";
                if (message.terminalNoEnd != null && message.hasOwnProperty("terminalNoEnd"))
                    if (!$util.isString(message.terminalNoEnd))
                        return "terminalNoEnd: string expected";
                if (message.specificStore != null && message.hasOwnProperty("specificStore"))
                    if (!$util.isString(message.specificStore))
                        return "specificStore: string expected";
                return null;
            };

            /**
             * Creates a ReimbursementQuery message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuery
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.ReimbursementQuery} ReimbursementQuery
             */
            ReimbursementQuery.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.ReimbursementQuery)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.ReimbursementQuery();
                if (object.storeList) {
                    if (!Array.isArray(object.storeList))
                        throw TypeError(".TCBReceiptApi.Protobuf.ReimbursementQuery.storeList: array expected");
                    message.storeList = [];
                    for (var i = 0; i < object.storeList.length; ++i)
                        message.storeList[i] = String(object.storeList[i]);
                }
                if (object.tidNumber != null)
                    message.tidNumber = String(object.tidNumber);
                if (object.authCode != null)
                    message.authCode = String(object.authCode);
                if (object.cardNo != null)
                    message.cardNo = String(object.cardNo);
                if (object.cardType != null)
                    message.cardType = String(object.cardType);
                if (object.type != null)
                    message.type = object.type | 0;
                if (object.flag != null)
                    message.flag = object.flag | 0;
                if (object.orderNo != null)
                    message.orderNo = String(object.orderNo);
                if (object.dateType != null)
                    message.dateType = object.dateType | 0;
                if (object.dateStart != null)
                    message.dateStart = String(object.dateStart);
                if (object.dateEnd != null)
                    message.dateEnd = String(object.dateEnd);
                if (object.terminalNoStart != null)
                    message.terminalNoStart = String(object.terminalNoStart);
                if (object.terminalNoEnd != null)
                    message.terminalNoEnd = String(object.terminalNoEnd);
                if (object.specificStore != null)
                    message.specificStore = String(object.specificStore);
                return message;
            };

            /**
             * Creates a plain object from a ReimbursementQuery message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.ReimbursementQuery} message ReimbursementQuery
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ReimbursementQuery.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.storeList = [];
                if (options.defaults) {
                    object.tidNumber = "";
                    object.authCode = "";
                    object.cardNo = "";
                    object.cardType = "";
                    object.type = 0;
                    object.flag = 0;
                    object.orderNo = "";
                    object.dateType = 0;
                    object.dateStart = "";
                    object.dateEnd = "";
                    object.terminalNoStart = "";
                    object.terminalNoEnd = "";
                    object.specificStore = "";
                }
                if (message.storeList && message.storeList.length) {
                    object.storeList = [];
                    for (var j = 0; j < message.storeList.length; ++j)
                        object.storeList[j] = message.storeList[j];
                }
                if (message.tidNumber != null && message.hasOwnProperty("tidNumber"))
                    object.tidNumber = message.tidNumber;
                if (message.authCode != null && message.hasOwnProperty("authCode"))
                    object.authCode = message.authCode;
                if (message.cardNo != null && message.hasOwnProperty("cardNo"))
                    object.cardNo = message.cardNo;
                if (message.cardType != null && message.hasOwnProperty("cardType"))
                    object.cardType = message.cardType;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.flag != null && message.hasOwnProperty("flag"))
                    object.flag = message.flag;
                if (message.orderNo != null && message.hasOwnProperty("orderNo"))
                    object.orderNo = message.orderNo;
                if (message.dateType != null && message.hasOwnProperty("dateType"))
                    object.dateType = message.dateType;
                if (message.dateStart != null && message.hasOwnProperty("dateStart"))
                    object.dateStart = message.dateStart;
                if (message.dateEnd != null && message.hasOwnProperty("dateEnd"))
                    object.dateEnd = message.dateEnd;
                if (message.terminalNoStart != null && message.hasOwnProperty("terminalNoStart"))
                    object.terminalNoStart = message.terminalNoStart;
                if (message.terminalNoEnd != null && message.hasOwnProperty("terminalNoEnd"))
                    object.terminalNoEnd = message.terminalNoEnd;
                if (message.specificStore != null && message.hasOwnProperty("specificStore"))
                    object.specificStore = message.specificStore;
                return object;
            };

            /**
             * Converts this ReimbursementQuery to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuery
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ReimbursementQuery.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ReimbursementQuery;
        })();

        Protobuf.ReimbursementQuerySpecificStore = (function() {

            /**
             * Properties of a ReimbursementQuerySpecificStore.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IReimbursementQuerySpecificStore
             * @property {string|null} [specificStore] ReimbursementQuerySpecificStore specificStore
             * @property {string|null} [authCode] ReimbursementQuerySpecificStore authCode
             * @property {string|null} [cardNo] ReimbursementQuerySpecificStore cardNo
             * @property {string|null} [cardType] ReimbursementQuerySpecificStore cardType
             * @property {number|null} [type] ReimbursementQuerySpecificStore type
             * @property {number|null} [flag] ReimbursementQuerySpecificStore flag
             * @property {string|null} [orderNo] ReimbursementQuerySpecificStore orderNo
             * @property {number|null} [dateType] ReimbursementQuerySpecificStore dateType
             * @property {string|null} [terminalNoStart] ReimbursementQuerySpecificStore terminalNoStart
             * @property {string|null} [terminalNoEnd] ReimbursementQuerySpecificStore terminalNoEnd
             * @property {string|null} [submitDateStart] ReimbursementQuerySpecificStore submitDateStart
             * @property {string|null} [submitDateEnd] ReimbursementQuerySpecificStore submitDateEnd
             * @property {string|null} [dateStart] ReimbursementQuerySpecificStore dateStart
             * @property {string|null} [dateEnd] ReimbursementQuerySpecificStore dateEnd
             */

            /**
             * Constructs a new ReimbursementQuerySpecificStore.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a ReimbursementQuerySpecificStore.
             * @implements IReimbursementQuerySpecificStore
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IReimbursementQuerySpecificStore=} [properties] Properties to set
             */
            function ReimbursementQuerySpecificStore(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ReimbursementQuerySpecificStore specificStore.
             * @member {string} specificStore
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore
             * @instance
             */
            ReimbursementQuerySpecificStore.prototype.specificStore = "";

            /**
             * ReimbursementQuerySpecificStore authCode.
             * @member {string} authCode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore
             * @instance
             */
            ReimbursementQuerySpecificStore.prototype.authCode = "";

            /**
             * ReimbursementQuerySpecificStore cardNo.
             * @member {string} cardNo
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore
             * @instance
             */
            ReimbursementQuerySpecificStore.prototype.cardNo = "";

            /**
             * ReimbursementQuerySpecificStore cardType.
             * @member {string} cardType
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore
             * @instance
             */
            ReimbursementQuerySpecificStore.prototype.cardType = "";

            /**
             * ReimbursementQuerySpecificStore type.
             * @member {number} type
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore
             * @instance
             */
            ReimbursementQuerySpecificStore.prototype.type = 0;

            /**
             * ReimbursementQuerySpecificStore flag.
             * @member {number} flag
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore
             * @instance
             */
            ReimbursementQuerySpecificStore.prototype.flag = 0;

            /**
             * ReimbursementQuerySpecificStore orderNo.
             * @member {string} orderNo
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore
             * @instance
             */
            ReimbursementQuerySpecificStore.prototype.orderNo = "";

            /**
             * ReimbursementQuerySpecificStore dateType.
             * @member {number} dateType
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore
             * @instance
             */
            ReimbursementQuerySpecificStore.prototype.dateType = 0;

            /**
             * ReimbursementQuerySpecificStore terminalNoStart.
             * @member {string} terminalNoStart
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore
             * @instance
             */
            ReimbursementQuerySpecificStore.prototype.terminalNoStart = "";

            /**
             * ReimbursementQuerySpecificStore terminalNoEnd.
             * @member {string} terminalNoEnd
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore
             * @instance
             */
            ReimbursementQuerySpecificStore.prototype.terminalNoEnd = "";

            /**
             * ReimbursementQuerySpecificStore submitDateStart.
             * @member {string} submitDateStart
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore
             * @instance
             */
            ReimbursementQuerySpecificStore.prototype.submitDateStart = "";

            /**
             * ReimbursementQuerySpecificStore submitDateEnd.
             * @member {string} submitDateEnd
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore
             * @instance
             */
            ReimbursementQuerySpecificStore.prototype.submitDateEnd = "";

            /**
             * ReimbursementQuerySpecificStore dateStart.
             * @member {string} dateStart
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore
             * @instance
             */
            ReimbursementQuerySpecificStore.prototype.dateStart = "";

            /**
             * ReimbursementQuerySpecificStore dateEnd.
             * @member {string} dateEnd
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore
             * @instance
             */
            ReimbursementQuerySpecificStore.prototype.dateEnd = "";

            /**
             * Creates a new ReimbursementQuerySpecificStore instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementQuerySpecificStore=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore} ReimbursementQuerySpecificStore instance
             */
            ReimbursementQuerySpecificStore.create = function create(properties) {
                return new ReimbursementQuerySpecificStore(properties);
            };

            /**
             * Encodes the specified ReimbursementQuerySpecificStore message. Does not implicitly {@link TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementQuerySpecificStore} message ReimbursementQuerySpecificStore message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReimbursementQuerySpecificStore.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.specificStore != null && Object.hasOwnProperty.call(message, "specificStore"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.specificStore);
                if (message.authCode != null && Object.hasOwnProperty.call(message, "authCode"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.authCode);
                if (message.cardNo != null && Object.hasOwnProperty.call(message, "cardNo"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.cardNo);
                if (message.cardType != null && Object.hasOwnProperty.call(message, "cardType"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.cardType);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int32(message.type);
                if (message.flag != null && Object.hasOwnProperty.call(message, "flag"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int32(message.flag);
                if (message.orderNo != null && Object.hasOwnProperty.call(message, "orderNo"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.orderNo);
                if (message.dateType != null && Object.hasOwnProperty.call(message, "dateType"))
                    writer.uint32(/* id 8, wireType 0 =*/64).int32(message.dateType);
                if (message.terminalNoStart != null && Object.hasOwnProperty.call(message, "terminalNoStart"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.terminalNoStart);
                if (message.terminalNoEnd != null && Object.hasOwnProperty.call(message, "terminalNoEnd"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.terminalNoEnd);
                if (message.submitDateStart != null && Object.hasOwnProperty.call(message, "submitDateStart"))
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.submitDateStart);
                if (message.submitDateEnd != null && Object.hasOwnProperty.call(message, "submitDateEnd"))
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.submitDateEnd);
                if (message.dateStart != null && Object.hasOwnProperty.call(message, "dateStart"))
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.dateStart);
                if (message.dateEnd != null && Object.hasOwnProperty.call(message, "dateEnd"))
                    writer.uint32(/* id 14, wireType 2 =*/114).string(message.dateEnd);
                return writer;
            };

            /**
             * Encodes the specified ReimbursementQuerySpecificStore message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementQuerySpecificStore} message ReimbursementQuerySpecificStore message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReimbursementQuerySpecificStore.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ReimbursementQuerySpecificStore message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore} ReimbursementQuerySpecificStore
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReimbursementQuerySpecificStore.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.specificStore = reader.string();
                        break;
                    case 2:
                        message.authCode = reader.string();
                        break;
                    case 3:
                        message.cardNo = reader.string();
                        break;
                    case 4:
                        message.cardType = reader.string();
                        break;
                    case 5:
                        message.type = reader.int32();
                        break;
                    case 6:
                        message.flag = reader.int32();
                        break;
                    case 7:
                        message.orderNo = reader.string();
                        break;
                    case 8:
                        message.dateType = reader.int32();
                        break;
                    case 9:
                        message.terminalNoStart = reader.string();
                        break;
                    case 10:
                        message.terminalNoEnd = reader.string();
                        break;
                    case 11:
                        message.submitDateStart = reader.string();
                        break;
                    case 12:
                        message.submitDateEnd = reader.string();
                        break;
                    case 13:
                        message.dateStart = reader.string();
                        break;
                    case 14:
                        message.dateEnd = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ReimbursementQuerySpecificStore message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore} ReimbursementQuerySpecificStore
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReimbursementQuerySpecificStore.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ReimbursementQuerySpecificStore message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ReimbursementQuerySpecificStore.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.specificStore != null && message.hasOwnProperty("specificStore"))
                    if (!$util.isString(message.specificStore))
                        return "specificStore: string expected";
                if (message.authCode != null && message.hasOwnProperty("authCode"))
                    if (!$util.isString(message.authCode))
                        return "authCode: string expected";
                if (message.cardNo != null && message.hasOwnProperty("cardNo"))
                    if (!$util.isString(message.cardNo))
                        return "cardNo: string expected";
                if (message.cardType != null && message.hasOwnProperty("cardType"))
                    if (!$util.isString(message.cardType))
                        return "cardType: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isInteger(message.type))
                        return "type: integer expected";
                if (message.flag != null && message.hasOwnProperty("flag"))
                    if (!$util.isInteger(message.flag))
                        return "flag: integer expected";
                if (message.orderNo != null && message.hasOwnProperty("orderNo"))
                    if (!$util.isString(message.orderNo))
                        return "orderNo: string expected";
                if (message.dateType != null && message.hasOwnProperty("dateType"))
                    if (!$util.isInteger(message.dateType))
                        return "dateType: integer expected";
                if (message.terminalNoStart != null && message.hasOwnProperty("terminalNoStart"))
                    if (!$util.isString(message.terminalNoStart))
                        return "terminalNoStart: string expected";
                if (message.terminalNoEnd != null && message.hasOwnProperty("terminalNoEnd"))
                    if (!$util.isString(message.terminalNoEnd))
                        return "terminalNoEnd: string expected";
                if (message.submitDateStart != null && message.hasOwnProperty("submitDateStart"))
                    if (!$util.isString(message.submitDateStart))
                        return "submitDateStart: string expected";
                if (message.submitDateEnd != null && message.hasOwnProperty("submitDateEnd"))
                    if (!$util.isString(message.submitDateEnd))
                        return "submitDateEnd: string expected";
                if (message.dateStart != null && message.hasOwnProperty("dateStart"))
                    if (!$util.isString(message.dateStart))
                        return "dateStart: string expected";
                if (message.dateEnd != null && message.hasOwnProperty("dateEnd"))
                    if (!$util.isString(message.dateEnd))
                        return "dateEnd: string expected";
                return null;
            };

            /**
             * Creates a ReimbursementQuerySpecificStore message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore} ReimbursementQuerySpecificStore
             */
            ReimbursementQuerySpecificStore.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore();
                if (object.specificStore != null)
                    message.specificStore = String(object.specificStore);
                if (object.authCode != null)
                    message.authCode = String(object.authCode);
                if (object.cardNo != null)
                    message.cardNo = String(object.cardNo);
                if (object.cardType != null)
                    message.cardType = String(object.cardType);
                if (object.type != null)
                    message.type = object.type | 0;
                if (object.flag != null)
                    message.flag = object.flag | 0;
                if (object.orderNo != null)
                    message.orderNo = String(object.orderNo);
                if (object.dateType != null)
                    message.dateType = object.dateType | 0;
                if (object.terminalNoStart != null)
                    message.terminalNoStart = String(object.terminalNoStart);
                if (object.terminalNoEnd != null)
                    message.terminalNoEnd = String(object.terminalNoEnd);
                if (object.submitDateStart != null)
                    message.submitDateStart = String(object.submitDateStart);
                if (object.submitDateEnd != null)
                    message.submitDateEnd = String(object.submitDateEnd);
                if (object.dateStart != null)
                    message.dateStart = String(object.dateStart);
                if (object.dateEnd != null)
                    message.dateEnd = String(object.dateEnd);
                return message;
            };

            /**
             * Creates a plain object from a ReimbursementQuerySpecificStore message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore
             * @static
             * @param {TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore} message ReimbursementQuerySpecificStore
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ReimbursementQuerySpecificStore.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.specificStore = "";
                    object.authCode = "";
                    object.cardNo = "";
                    object.cardType = "";
                    object.type = 0;
                    object.flag = 0;
                    object.orderNo = "";
                    object.dateType = 0;
                    object.terminalNoStart = "";
                    object.terminalNoEnd = "";
                    object.submitDateStart = "";
                    object.submitDateEnd = "";
                    object.dateStart = "";
                    object.dateEnd = "";
                }
                if (message.specificStore != null && message.hasOwnProperty("specificStore"))
                    object.specificStore = message.specificStore;
                if (message.authCode != null && message.hasOwnProperty("authCode"))
                    object.authCode = message.authCode;
                if (message.cardNo != null && message.hasOwnProperty("cardNo"))
                    object.cardNo = message.cardNo;
                if (message.cardType != null && message.hasOwnProperty("cardType"))
                    object.cardType = message.cardType;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.flag != null && message.hasOwnProperty("flag"))
                    object.flag = message.flag;
                if (message.orderNo != null && message.hasOwnProperty("orderNo"))
                    object.orderNo = message.orderNo;
                if (message.dateType != null && message.hasOwnProperty("dateType"))
                    object.dateType = message.dateType;
                if (message.terminalNoStart != null && message.hasOwnProperty("terminalNoStart"))
                    object.terminalNoStart = message.terminalNoStart;
                if (message.terminalNoEnd != null && message.hasOwnProperty("terminalNoEnd"))
                    object.terminalNoEnd = message.terminalNoEnd;
                if (message.submitDateStart != null && message.hasOwnProperty("submitDateStart"))
                    object.submitDateStart = message.submitDateStart;
                if (message.submitDateEnd != null && message.hasOwnProperty("submitDateEnd"))
                    object.submitDateEnd = message.submitDateEnd;
                if (message.dateStart != null && message.hasOwnProperty("dateStart"))
                    object.dateStart = message.dateStart;
                if (message.dateEnd != null && message.hasOwnProperty("dateEnd"))
                    object.dateEnd = message.dateEnd;
                return object;
            };

            /**
             * Converts this ReimbursementQuerySpecificStore to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.ReimbursementQuerySpecificStore
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ReimbursementQuerySpecificStore.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ReimbursementQuerySpecificStore;
        })();

        Protobuf.ReimbursementDetailExport = (function() {

            /**
             * Properties of a ReimbursementDetailExport.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IReimbursementDetailExport
             * @property {string|null} [storeCode] ReimbursementDetailExport storeCode
             * @property {string|null} [registerName] ReimbursementDetailExport registerName
             * @property {string|null} [terminalNo] ReimbursementDetailExport terminalNo
             * @property {string|null} [submitDate] ReimbursementDetailExport submitDate
             * @property {string|null} [batchNoOrigin] ReimbursementDetailExport batchNoOrigin
             * @property {string|null} [date] ReimbursementDetailExport date
             * @property {string|null} [time] ReimbursementDetailExport time
             * @property {string|null} [code] ReimbursementDetailExport code
             * @property {string|null} [authCode] ReimbursementDetailExport authCode
             * @property {string|null} [amount] ReimbursementDetailExport amount
             * @property {string|null} [cardNo] ReimbursementDetailExport cardNo
             * @property {string|null} [cardTypeOrigin] ReimbursementDetailExport cardTypeOrigin
             * @property {string|null} [orderNo] ReimbursementDetailExport orderNo
             * @property {string|null} [issuer] ReimbursementDetailExport issuer
             * @property {string|null} [installCodeOrigin] ReimbursementDetailExport installCodeOrigin
             * @property {string|null} [installTimes] ReimbursementDetailExport installTimes
             * @property {string|null} [settleCode] ReimbursementDetailExport settleCode
             * @property {string|null} [taiwanPayQrFlag] ReimbursementDetailExport taiwanPayQrFlag
             * @property {string|null} [stan] ReimbursementDetailExport stan
             * @property {string|null} [feeFlagOrigin] ReimbursementDetailExport feeFlagOrigin
             */

            /**
             * Constructs a new ReimbursementDetailExport.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a ReimbursementDetailExport.
             * @implements IReimbursementDetailExport
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IReimbursementDetailExport=} [properties] Properties to set
             */
            function ReimbursementDetailExport(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ReimbursementDetailExport storeCode.
             * @member {string} storeCode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementDetailExport
             * @instance
             */
            ReimbursementDetailExport.prototype.storeCode = "";

            /**
             * ReimbursementDetailExport registerName.
             * @member {string} registerName
             * @memberof TCBReceiptApi.Protobuf.ReimbursementDetailExport
             * @instance
             */
            ReimbursementDetailExport.prototype.registerName = "";

            /**
             * ReimbursementDetailExport terminalNo.
             * @member {string} terminalNo
             * @memberof TCBReceiptApi.Protobuf.ReimbursementDetailExport
             * @instance
             */
            ReimbursementDetailExport.prototype.terminalNo = "";

            /**
             * ReimbursementDetailExport submitDate.
             * @member {string} submitDate
             * @memberof TCBReceiptApi.Protobuf.ReimbursementDetailExport
             * @instance
             */
            ReimbursementDetailExport.prototype.submitDate = "";

            /**
             * ReimbursementDetailExport batchNoOrigin.
             * @member {string} batchNoOrigin
             * @memberof TCBReceiptApi.Protobuf.ReimbursementDetailExport
             * @instance
             */
            ReimbursementDetailExport.prototype.batchNoOrigin = "";

            /**
             * ReimbursementDetailExport date.
             * @member {string} date
             * @memberof TCBReceiptApi.Protobuf.ReimbursementDetailExport
             * @instance
             */
            ReimbursementDetailExport.prototype.date = "";

            /**
             * ReimbursementDetailExport time.
             * @member {string} time
             * @memberof TCBReceiptApi.Protobuf.ReimbursementDetailExport
             * @instance
             */
            ReimbursementDetailExport.prototype.time = "";

            /**
             * ReimbursementDetailExport code.
             * @member {string} code
             * @memberof TCBReceiptApi.Protobuf.ReimbursementDetailExport
             * @instance
             */
            ReimbursementDetailExport.prototype.code = "";

            /**
             * ReimbursementDetailExport authCode.
             * @member {string} authCode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementDetailExport
             * @instance
             */
            ReimbursementDetailExport.prototype.authCode = "";

            /**
             * ReimbursementDetailExport amount.
             * @member {string} amount
             * @memberof TCBReceiptApi.Protobuf.ReimbursementDetailExport
             * @instance
             */
            ReimbursementDetailExport.prototype.amount = "";

            /**
             * ReimbursementDetailExport cardNo.
             * @member {string} cardNo
             * @memberof TCBReceiptApi.Protobuf.ReimbursementDetailExport
             * @instance
             */
            ReimbursementDetailExport.prototype.cardNo = "";

            /**
             * ReimbursementDetailExport cardTypeOrigin.
             * @member {string} cardTypeOrigin
             * @memberof TCBReceiptApi.Protobuf.ReimbursementDetailExport
             * @instance
             */
            ReimbursementDetailExport.prototype.cardTypeOrigin = "";

            /**
             * ReimbursementDetailExport orderNo.
             * @member {string} orderNo
             * @memberof TCBReceiptApi.Protobuf.ReimbursementDetailExport
             * @instance
             */
            ReimbursementDetailExport.prototype.orderNo = "";

            /**
             * ReimbursementDetailExport issuer.
             * @member {string} issuer
             * @memberof TCBReceiptApi.Protobuf.ReimbursementDetailExport
             * @instance
             */
            ReimbursementDetailExport.prototype.issuer = "";

            /**
             * ReimbursementDetailExport installCodeOrigin.
             * @member {string} installCodeOrigin
             * @memberof TCBReceiptApi.Protobuf.ReimbursementDetailExport
             * @instance
             */
            ReimbursementDetailExport.prototype.installCodeOrigin = "";

            /**
             * ReimbursementDetailExport installTimes.
             * @member {string} installTimes
             * @memberof TCBReceiptApi.Protobuf.ReimbursementDetailExport
             * @instance
             */
            ReimbursementDetailExport.prototype.installTimes = "";

            /**
             * ReimbursementDetailExport settleCode.
             * @member {string} settleCode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementDetailExport
             * @instance
             */
            ReimbursementDetailExport.prototype.settleCode = "";

            /**
             * ReimbursementDetailExport taiwanPayQrFlag.
             * @member {string} taiwanPayQrFlag
             * @memberof TCBReceiptApi.Protobuf.ReimbursementDetailExport
             * @instance
             */
            ReimbursementDetailExport.prototype.taiwanPayQrFlag = "";

            /**
             * ReimbursementDetailExport stan.
             * @member {string} stan
             * @memberof TCBReceiptApi.Protobuf.ReimbursementDetailExport
             * @instance
             */
            ReimbursementDetailExport.prototype.stan = "";

            /**
             * ReimbursementDetailExport feeFlagOrigin.
             * @member {string} feeFlagOrigin
             * @memberof TCBReceiptApi.Protobuf.ReimbursementDetailExport
             * @instance
             */
            ReimbursementDetailExport.prototype.feeFlagOrigin = "";

            /**
             * Creates a new ReimbursementDetailExport instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.ReimbursementDetailExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementDetailExport=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.ReimbursementDetailExport} ReimbursementDetailExport instance
             */
            ReimbursementDetailExport.create = function create(properties) {
                return new ReimbursementDetailExport(properties);
            };

            /**
             * Encodes the specified ReimbursementDetailExport message. Does not implicitly {@link TCBReceiptApi.Protobuf.ReimbursementDetailExport.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementDetailExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementDetailExport} message ReimbursementDetailExport message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReimbursementDetailExport.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.storeCode != null && Object.hasOwnProperty.call(message, "storeCode"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.storeCode);
                if (message.registerName != null && Object.hasOwnProperty.call(message, "registerName"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.registerName);
                if (message.terminalNo != null && Object.hasOwnProperty.call(message, "terminalNo"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.terminalNo);
                if (message.submitDate != null && Object.hasOwnProperty.call(message, "submitDate"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.submitDate);
                if (message.batchNoOrigin != null && Object.hasOwnProperty.call(message, "batchNoOrigin"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.batchNoOrigin);
                if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.date);
                if (message.time != null && Object.hasOwnProperty.call(message, "time"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.time);
                if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.code);
                if (message.authCode != null && Object.hasOwnProperty.call(message, "authCode"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.authCode);
                if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.amount);
                if (message.cardNo != null && Object.hasOwnProperty.call(message, "cardNo"))
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.cardNo);
                if (message.cardTypeOrigin != null && Object.hasOwnProperty.call(message, "cardTypeOrigin"))
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.cardTypeOrigin);
                if (message.orderNo != null && Object.hasOwnProperty.call(message, "orderNo"))
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.orderNo);
                if (message.issuer != null && Object.hasOwnProperty.call(message, "issuer"))
                    writer.uint32(/* id 14, wireType 2 =*/114).string(message.issuer);
                if (message.installCodeOrigin != null && Object.hasOwnProperty.call(message, "installCodeOrigin"))
                    writer.uint32(/* id 15, wireType 2 =*/122).string(message.installCodeOrigin);
                if (message.installTimes != null && Object.hasOwnProperty.call(message, "installTimes"))
                    writer.uint32(/* id 16, wireType 2 =*/130).string(message.installTimes);
                if (message.settleCode != null && Object.hasOwnProperty.call(message, "settleCode"))
                    writer.uint32(/* id 17, wireType 2 =*/138).string(message.settleCode);
                if (message.taiwanPayQrFlag != null && Object.hasOwnProperty.call(message, "taiwanPayQrFlag"))
                    writer.uint32(/* id 18, wireType 2 =*/146).string(message.taiwanPayQrFlag);
                if (message.stan != null && Object.hasOwnProperty.call(message, "stan"))
                    writer.uint32(/* id 19, wireType 2 =*/154).string(message.stan);
                if (message.feeFlagOrigin != null && Object.hasOwnProperty.call(message, "feeFlagOrigin"))
                    writer.uint32(/* id 20, wireType 2 =*/162).string(message.feeFlagOrigin);
                return writer;
            };

            /**
             * Encodes the specified ReimbursementDetailExport message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.ReimbursementDetailExport.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ReimbursementDetailExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementDetailExport} message ReimbursementDetailExport message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReimbursementDetailExport.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ReimbursementDetailExport message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementDetailExport
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.ReimbursementDetailExport} ReimbursementDetailExport
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReimbursementDetailExport.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.ReimbursementDetailExport();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.storeCode = reader.string();
                        break;
                    case 2:
                        message.registerName = reader.string();
                        break;
                    case 3:
                        message.terminalNo = reader.string();
                        break;
                    case 4:
                        message.submitDate = reader.string();
                        break;
                    case 5:
                        message.batchNoOrigin = reader.string();
                        break;
                    case 6:
                        message.date = reader.string();
                        break;
                    case 7:
                        message.time = reader.string();
                        break;
                    case 8:
                        message.code = reader.string();
                        break;
                    case 9:
                        message.authCode = reader.string();
                        break;
                    case 10:
                        message.amount = reader.string();
                        break;
                    case 11:
                        message.cardNo = reader.string();
                        break;
                    case 12:
                        message.cardTypeOrigin = reader.string();
                        break;
                    case 13:
                        message.orderNo = reader.string();
                        break;
                    case 14:
                        message.issuer = reader.string();
                        break;
                    case 15:
                        message.installCodeOrigin = reader.string();
                        break;
                    case 16:
                        message.installTimes = reader.string();
                        break;
                    case 17:
                        message.settleCode = reader.string();
                        break;
                    case 18:
                        message.taiwanPayQrFlag = reader.string();
                        break;
                    case 19:
                        message.stan = reader.string();
                        break;
                    case 20:
                        message.feeFlagOrigin = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ReimbursementDetailExport message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ReimbursementDetailExport
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.ReimbursementDetailExport} ReimbursementDetailExport
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReimbursementDetailExport.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ReimbursementDetailExport message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.ReimbursementDetailExport
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ReimbursementDetailExport.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    if (!$util.isString(message.storeCode))
                        return "storeCode: string expected";
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    if (!$util.isString(message.registerName))
                        return "registerName: string expected";
                if (message.terminalNo != null && message.hasOwnProperty("terminalNo"))
                    if (!$util.isString(message.terminalNo))
                        return "terminalNo: string expected";
                if (message.submitDate != null && message.hasOwnProperty("submitDate"))
                    if (!$util.isString(message.submitDate))
                        return "submitDate: string expected";
                if (message.batchNoOrigin != null && message.hasOwnProperty("batchNoOrigin"))
                    if (!$util.isString(message.batchNoOrigin))
                        return "batchNoOrigin: string expected";
                if (message.date != null && message.hasOwnProperty("date"))
                    if (!$util.isString(message.date))
                        return "date: string expected";
                if (message.time != null && message.hasOwnProperty("time"))
                    if (!$util.isString(message.time))
                        return "time: string expected";
                if (message.code != null && message.hasOwnProperty("code"))
                    if (!$util.isString(message.code))
                        return "code: string expected";
                if (message.authCode != null && message.hasOwnProperty("authCode"))
                    if (!$util.isString(message.authCode))
                        return "authCode: string expected";
                if (message.amount != null && message.hasOwnProperty("amount"))
                    if (!$util.isString(message.amount))
                        return "amount: string expected";
                if (message.cardNo != null && message.hasOwnProperty("cardNo"))
                    if (!$util.isString(message.cardNo))
                        return "cardNo: string expected";
                if (message.cardTypeOrigin != null && message.hasOwnProperty("cardTypeOrigin"))
                    if (!$util.isString(message.cardTypeOrigin))
                        return "cardTypeOrigin: string expected";
                if (message.orderNo != null && message.hasOwnProperty("orderNo"))
                    if (!$util.isString(message.orderNo))
                        return "orderNo: string expected";
                if (message.issuer != null && message.hasOwnProperty("issuer"))
                    if (!$util.isString(message.issuer))
                        return "issuer: string expected";
                if (message.installCodeOrigin != null && message.hasOwnProperty("installCodeOrigin"))
                    if (!$util.isString(message.installCodeOrigin))
                        return "installCodeOrigin: string expected";
                if (message.installTimes != null && message.hasOwnProperty("installTimes"))
                    if (!$util.isString(message.installTimes))
                        return "installTimes: string expected";
                if (message.settleCode != null && message.hasOwnProperty("settleCode"))
                    if (!$util.isString(message.settleCode))
                        return "settleCode: string expected";
                if (message.taiwanPayQrFlag != null && message.hasOwnProperty("taiwanPayQrFlag"))
                    if (!$util.isString(message.taiwanPayQrFlag))
                        return "taiwanPayQrFlag: string expected";
                if (message.stan != null && message.hasOwnProperty("stan"))
                    if (!$util.isString(message.stan))
                        return "stan: string expected";
                if (message.feeFlagOrigin != null && message.hasOwnProperty("feeFlagOrigin"))
                    if (!$util.isString(message.feeFlagOrigin))
                        return "feeFlagOrigin: string expected";
                return null;
            };

            /**
             * Creates a ReimbursementDetailExport message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.ReimbursementDetailExport
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.ReimbursementDetailExport} ReimbursementDetailExport
             */
            ReimbursementDetailExport.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.ReimbursementDetailExport)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.ReimbursementDetailExport();
                if (object.storeCode != null)
                    message.storeCode = String(object.storeCode);
                if (object.registerName != null)
                    message.registerName = String(object.registerName);
                if (object.terminalNo != null)
                    message.terminalNo = String(object.terminalNo);
                if (object.submitDate != null)
                    message.submitDate = String(object.submitDate);
                if (object.batchNoOrigin != null)
                    message.batchNoOrigin = String(object.batchNoOrigin);
                if (object.date != null)
                    message.date = String(object.date);
                if (object.time != null)
                    message.time = String(object.time);
                if (object.code != null)
                    message.code = String(object.code);
                if (object.authCode != null)
                    message.authCode = String(object.authCode);
                if (object.amount != null)
                    message.amount = String(object.amount);
                if (object.cardNo != null)
                    message.cardNo = String(object.cardNo);
                if (object.cardTypeOrigin != null)
                    message.cardTypeOrigin = String(object.cardTypeOrigin);
                if (object.orderNo != null)
                    message.orderNo = String(object.orderNo);
                if (object.issuer != null)
                    message.issuer = String(object.issuer);
                if (object.installCodeOrigin != null)
                    message.installCodeOrigin = String(object.installCodeOrigin);
                if (object.installTimes != null)
                    message.installTimes = String(object.installTimes);
                if (object.settleCode != null)
                    message.settleCode = String(object.settleCode);
                if (object.taiwanPayQrFlag != null)
                    message.taiwanPayQrFlag = String(object.taiwanPayQrFlag);
                if (object.stan != null)
                    message.stan = String(object.stan);
                if (object.feeFlagOrigin != null)
                    message.feeFlagOrigin = String(object.feeFlagOrigin);
                return message;
            };

            /**
             * Creates a plain object from a ReimbursementDetailExport message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.ReimbursementDetailExport
             * @static
             * @param {TCBReceiptApi.Protobuf.ReimbursementDetailExport} message ReimbursementDetailExport
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ReimbursementDetailExport.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.storeCode = "";
                    object.registerName = "";
                    object.terminalNo = "";
                    object.submitDate = "";
                    object.batchNoOrigin = "";
                    object.date = "";
                    object.time = "";
                    object.code = "";
                    object.authCode = "";
                    object.amount = "";
                    object.cardNo = "";
                    object.cardTypeOrigin = "";
                    object.orderNo = "";
                    object.issuer = "";
                    object.installCodeOrigin = "";
                    object.installTimes = "";
                    object.settleCode = "";
                    object.taiwanPayQrFlag = "";
                    object.stan = "";
                    object.feeFlagOrigin = "";
                }
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    object.storeCode = message.storeCode;
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    object.registerName = message.registerName;
                if (message.terminalNo != null && message.hasOwnProperty("terminalNo"))
                    object.terminalNo = message.terminalNo;
                if (message.submitDate != null && message.hasOwnProperty("submitDate"))
                    object.submitDate = message.submitDate;
                if (message.batchNoOrigin != null && message.hasOwnProperty("batchNoOrigin"))
                    object.batchNoOrigin = message.batchNoOrigin;
                if (message.date != null && message.hasOwnProperty("date"))
                    object.date = message.date;
                if (message.time != null && message.hasOwnProperty("time"))
                    object.time = message.time;
                if (message.code != null && message.hasOwnProperty("code"))
                    object.code = message.code;
                if (message.authCode != null && message.hasOwnProperty("authCode"))
                    object.authCode = message.authCode;
                if (message.amount != null && message.hasOwnProperty("amount"))
                    object.amount = message.amount;
                if (message.cardNo != null && message.hasOwnProperty("cardNo"))
                    object.cardNo = message.cardNo;
                if (message.cardTypeOrigin != null && message.hasOwnProperty("cardTypeOrigin"))
                    object.cardTypeOrigin = message.cardTypeOrigin;
                if (message.orderNo != null && message.hasOwnProperty("orderNo"))
                    object.orderNo = message.orderNo;
                if (message.issuer != null && message.hasOwnProperty("issuer"))
                    object.issuer = message.issuer;
                if (message.installCodeOrigin != null && message.hasOwnProperty("installCodeOrigin"))
                    object.installCodeOrigin = message.installCodeOrigin;
                if (message.installTimes != null && message.hasOwnProperty("installTimes"))
                    object.installTimes = message.installTimes;
                if (message.settleCode != null && message.hasOwnProperty("settleCode"))
                    object.settleCode = message.settleCode;
                if (message.taiwanPayQrFlag != null && message.hasOwnProperty("taiwanPayQrFlag"))
                    object.taiwanPayQrFlag = message.taiwanPayQrFlag;
                if (message.stan != null && message.hasOwnProperty("stan"))
                    object.stan = message.stan;
                if (message.feeFlagOrigin != null && message.hasOwnProperty("feeFlagOrigin"))
                    object.feeFlagOrigin = message.feeFlagOrigin;
                return object;
            };

            /**
             * Converts this ReimbursementDetailExport to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.ReimbursementDetailExport
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ReimbursementDetailExport.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ReimbursementDetailExport;
        })();

        Protobuf.ReimbursementSummaryExport = (function() {

            /**
             * Properties of a ReimbursementSummaryExport.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IReimbursementSummaryExport
             * @property {string|null} [item] ReimbursementSummaryExport item
             * @property {string|null} [ourBankCount] ReimbursementSummaryExport ourBankCount
             * @property {string|null} [ourBankAmount] ReimbursementSummaryExport ourBankAmount
             * @property {string|null} [notOurBankCount] ReimbursementSummaryExport notOurBankCount
             * @property {string|null} [notOurBankAmount] ReimbursementSummaryExport notOurBankAmount
             * @property {string|null} [totalCount] ReimbursementSummaryExport totalCount
             * @property {string|null} [totalAmount] ReimbursementSummaryExport totalAmount
             */

            /**
             * Constructs a new ReimbursementSummaryExport.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a ReimbursementSummaryExport.
             * @implements IReimbursementSummaryExport
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IReimbursementSummaryExport=} [properties] Properties to set
             */
            function ReimbursementSummaryExport(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ReimbursementSummaryExport item.
             * @member {string} item
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryExport
             * @instance
             */
            ReimbursementSummaryExport.prototype.item = "";

            /**
             * ReimbursementSummaryExport ourBankCount.
             * @member {string} ourBankCount
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryExport
             * @instance
             */
            ReimbursementSummaryExport.prototype.ourBankCount = "";

            /**
             * ReimbursementSummaryExport ourBankAmount.
             * @member {string} ourBankAmount
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryExport
             * @instance
             */
            ReimbursementSummaryExport.prototype.ourBankAmount = "";

            /**
             * ReimbursementSummaryExport notOurBankCount.
             * @member {string} notOurBankCount
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryExport
             * @instance
             */
            ReimbursementSummaryExport.prototype.notOurBankCount = "";

            /**
             * ReimbursementSummaryExport notOurBankAmount.
             * @member {string} notOurBankAmount
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryExport
             * @instance
             */
            ReimbursementSummaryExport.prototype.notOurBankAmount = "";

            /**
             * ReimbursementSummaryExport totalCount.
             * @member {string} totalCount
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryExport
             * @instance
             */
            ReimbursementSummaryExport.prototype.totalCount = "";

            /**
             * ReimbursementSummaryExport totalAmount.
             * @member {string} totalAmount
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryExport
             * @instance
             */
            ReimbursementSummaryExport.prototype.totalAmount = "";

            /**
             * Creates a new ReimbursementSummaryExport instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementSummaryExport=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.ReimbursementSummaryExport} ReimbursementSummaryExport instance
             */
            ReimbursementSummaryExport.create = function create(properties) {
                return new ReimbursementSummaryExport(properties);
            };

            /**
             * Encodes the specified ReimbursementSummaryExport message. Does not implicitly {@link TCBReceiptApi.Protobuf.ReimbursementSummaryExport.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementSummaryExport} message ReimbursementSummaryExport message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReimbursementSummaryExport.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.item != null && Object.hasOwnProperty.call(message, "item"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.item);
                if (message.ourBankCount != null && Object.hasOwnProperty.call(message, "ourBankCount"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.ourBankCount);
                if (message.ourBankAmount != null && Object.hasOwnProperty.call(message, "ourBankAmount"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.ourBankAmount);
                if (message.notOurBankCount != null && Object.hasOwnProperty.call(message, "notOurBankCount"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.notOurBankCount);
                if (message.notOurBankAmount != null && Object.hasOwnProperty.call(message, "notOurBankAmount"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.notOurBankAmount);
                if (message.totalCount != null && Object.hasOwnProperty.call(message, "totalCount"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.totalCount);
                if (message.totalAmount != null && Object.hasOwnProperty.call(message, "totalAmount"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.totalAmount);
                return writer;
            };

            /**
             * Encodes the specified ReimbursementSummaryExport message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.ReimbursementSummaryExport.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementSummaryExport} message ReimbursementSummaryExport message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReimbursementSummaryExport.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ReimbursementSummaryExport message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryExport
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.ReimbursementSummaryExport} ReimbursementSummaryExport
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReimbursementSummaryExport.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.ReimbursementSummaryExport();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.item = reader.string();
                        break;
                    case 2:
                        message.ourBankCount = reader.string();
                        break;
                    case 3:
                        message.ourBankAmount = reader.string();
                        break;
                    case 4:
                        message.notOurBankCount = reader.string();
                        break;
                    case 5:
                        message.notOurBankAmount = reader.string();
                        break;
                    case 6:
                        message.totalCount = reader.string();
                        break;
                    case 7:
                        message.totalAmount = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ReimbursementSummaryExport message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryExport
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.ReimbursementSummaryExport} ReimbursementSummaryExport
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReimbursementSummaryExport.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ReimbursementSummaryExport message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryExport
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ReimbursementSummaryExport.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.item != null && message.hasOwnProperty("item"))
                    if (!$util.isString(message.item))
                        return "item: string expected";
                if (message.ourBankCount != null && message.hasOwnProperty("ourBankCount"))
                    if (!$util.isString(message.ourBankCount))
                        return "ourBankCount: string expected";
                if (message.ourBankAmount != null && message.hasOwnProperty("ourBankAmount"))
                    if (!$util.isString(message.ourBankAmount))
                        return "ourBankAmount: string expected";
                if (message.notOurBankCount != null && message.hasOwnProperty("notOurBankCount"))
                    if (!$util.isString(message.notOurBankCount))
                        return "notOurBankCount: string expected";
                if (message.notOurBankAmount != null && message.hasOwnProperty("notOurBankAmount"))
                    if (!$util.isString(message.notOurBankAmount))
                        return "notOurBankAmount: string expected";
                if (message.totalCount != null && message.hasOwnProperty("totalCount"))
                    if (!$util.isString(message.totalCount))
                        return "totalCount: string expected";
                if (message.totalAmount != null && message.hasOwnProperty("totalAmount"))
                    if (!$util.isString(message.totalAmount))
                        return "totalAmount: string expected";
                return null;
            };

            /**
             * Creates a ReimbursementSummaryExport message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryExport
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.ReimbursementSummaryExport} ReimbursementSummaryExport
             */
            ReimbursementSummaryExport.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.ReimbursementSummaryExport)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.ReimbursementSummaryExport();
                if (object.item != null)
                    message.item = String(object.item);
                if (object.ourBankCount != null)
                    message.ourBankCount = String(object.ourBankCount);
                if (object.ourBankAmount != null)
                    message.ourBankAmount = String(object.ourBankAmount);
                if (object.notOurBankCount != null)
                    message.notOurBankCount = String(object.notOurBankCount);
                if (object.notOurBankAmount != null)
                    message.notOurBankAmount = String(object.notOurBankAmount);
                if (object.totalCount != null)
                    message.totalCount = String(object.totalCount);
                if (object.totalAmount != null)
                    message.totalAmount = String(object.totalAmount);
                return message;
            };

            /**
             * Creates a plain object from a ReimbursementSummaryExport message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryExport
             * @static
             * @param {TCBReceiptApi.Protobuf.ReimbursementSummaryExport} message ReimbursementSummaryExport
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ReimbursementSummaryExport.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.item = "";
                    object.ourBankCount = "";
                    object.ourBankAmount = "";
                    object.notOurBankCount = "";
                    object.notOurBankAmount = "";
                    object.totalCount = "";
                    object.totalAmount = "";
                }
                if (message.item != null && message.hasOwnProperty("item"))
                    object.item = message.item;
                if (message.ourBankCount != null && message.hasOwnProperty("ourBankCount"))
                    object.ourBankCount = message.ourBankCount;
                if (message.ourBankAmount != null && message.hasOwnProperty("ourBankAmount"))
                    object.ourBankAmount = message.ourBankAmount;
                if (message.notOurBankCount != null && message.hasOwnProperty("notOurBankCount"))
                    object.notOurBankCount = message.notOurBankCount;
                if (message.notOurBankAmount != null && message.hasOwnProperty("notOurBankAmount"))
                    object.notOurBankAmount = message.notOurBankAmount;
                if (message.totalCount != null && message.hasOwnProperty("totalCount"))
                    object.totalCount = message.totalCount;
                if (message.totalAmount != null && message.hasOwnProperty("totalAmount"))
                    object.totalAmount = message.totalAmount;
                return object;
            };

            /**
             * Converts this ReimbursementSummaryExport to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryExport
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ReimbursementSummaryExport.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ReimbursementSummaryExport;
        })();

        Protobuf.ReimbursementSummaryByColumnExport = (function() {

            /**
             * Properties of a ReimbursementSummaryByColumnExport.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IReimbursementSummaryByColumnExport
             * @property {string|null} [storeCode] ReimbursementSummaryByColumnExport storeCode
             * @property {string|null} [registerName] ReimbursementSummaryByColumnExport registerName
             * @property {string|null} [terminalNo] ReimbursementSummaryByColumnExport terminalNo
             * @property {string|null} [date] ReimbursementSummaryByColumnExport date
             * @property {string|null} [batchNo] ReimbursementSummaryByColumnExport batchNo
             * @property {string|null} [count] ReimbursementSummaryByColumnExport count
             * @property {string|null} [amount] ReimbursementSummaryByColumnExport amount
             */

            /**
             * Constructs a new ReimbursementSummaryByColumnExport.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a ReimbursementSummaryByColumnExport.
             * @implements IReimbursementSummaryByColumnExport
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IReimbursementSummaryByColumnExport=} [properties] Properties to set
             */
            function ReimbursementSummaryByColumnExport(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ReimbursementSummaryByColumnExport storeCode.
             * @member {string} storeCode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryByColumnExport
             * @instance
             */
            ReimbursementSummaryByColumnExport.prototype.storeCode = "";

            /**
             * ReimbursementSummaryByColumnExport registerName.
             * @member {string} registerName
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryByColumnExport
             * @instance
             */
            ReimbursementSummaryByColumnExport.prototype.registerName = "";

            /**
             * ReimbursementSummaryByColumnExport terminalNo.
             * @member {string} terminalNo
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryByColumnExport
             * @instance
             */
            ReimbursementSummaryByColumnExport.prototype.terminalNo = "";

            /**
             * ReimbursementSummaryByColumnExport date.
             * @member {string} date
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryByColumnExport
             * @instance
             */
            ReimbursementSummaryByColumnExport.prototype.date = "";

            /**
             * ReimbursementSummaryByColumnExport batchNo.
             * @member {string} batchNo
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryByColumnExport
             * @instance
             */
            ReimbursementSummaryByColumnExport.prototype.batchNo = "";

            /**
             * ReimbursementSummaryByColumnExport count.
             * @member {string} count
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryByColumnExport
             * @instance
             */
            ReimbursementSummaryByColumnExport.prototype.count = "";

            /**
             * ReimbursementSummaryByColumnExport amount.
             * @member {string} amount
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryByColumnExport
             * @instance
             */
            ReimbursementSummaryByColumnExport.prototype.amount = "";

            /**
             * Creates a new ReimbursementSummaryByColumnExport instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryByColumnExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementSummaryByColumnExport=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.ReimbursementSummaryByColumnExport} ReimbursementSummaryByColumnExport instance
             */
            ReimbursementSummaryByColumnExport.create = function create(properties) {
                return new ReimbursementSummaryByColumnExport(properties);
            };

            /**
             * Encodes the specified ReimbursementSummaryByColumnExport message. Does not implicitly {@link TCBReceiptApi.Protobuf.ReimbursementSummaryByColumnExport.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryByColumnExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementSummaryByColumnExport} message ReimbursementSummaryByColumnExport message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReimbursementSummaryByColumnExport.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.storeCode != null && Object.hasOwnProperty.call(message, "storeCode"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.storeCode);
                if (message.registerName != null && Object.hasOwnProperty.call(message, "registerName"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.registerName);
                if (message.terminalNo != null && Object.hasOwnProperty.call(message, "terminalNo"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.terminalNo);
                if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.date);
                if (message.batchNo != null && Object.hasOwnProperty.call(message, "batchNo"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.batchNo);
                if (message.count != null && Object.hasOwnProperty.call(message, "count"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.count);
                if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.amount);
                return writer;
            };

            /**
             * Encodes the specified ReimbursementSummaryByColumnExport message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.ReimbursementSummaryByColumnExport.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryByColumnExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IReimbursementSummaryByColumnExport} message ReimbursementSummaryByColumnExport message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ReimbursementSummaryByColumnExport.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ReimbursementSummaryByColumnExport message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryByColumnExport
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.ReimbursementSummaryByColumnExport} ReimbursementSummaryByColumnExport
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReimbursementSummaryByColumnExport.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.ReimbursementSummaryByColumnExport();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.storeCode = reader.string();
                        break;
                    case 2:
                        message.registerName = reader.string();
                        break;
                    case 3:
                        message.terminalNo = reader.string();
                        break;
                    case 4:
                        message.date = reader.string();
                        break;
                    case 5:
                        message.batchNo = reader.string();
                        break;
                    case 6:
                        message.count = reader.string();
                        break;
                    case 7:
                        message.amount = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ReimbursementSummaryByColumnExport message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryByColumnExport
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.ReimbursementSummaryByColumnExport} ReimbursementSummaryByColumnExport
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ReimbursementSummaryByColumnExport.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ReimbursementSummaryByColumnExport message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryByColumnExport
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ReimbursementSummaryByColumnExport.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    if (!$util.isString(message.storeCode))
                        return "storeCode: string expected";
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    if (!$util.isString(message.registerName))
                        return "registerName: string expected";
                if (message.terminalNo != null && message.hasOwnProperty("terminalNo"))
                    if (!$util.isString(message.terminalNo))
                        return "terminalNo: string expected";
                if (message.date != null && message.hasOwnProperty("date"))
                    if (!$util.isString(message.date))
                        return "date: string expected";
                if (message.batchNo != null && message.hasOwnProperty("batchNo"))
                    if (!$util.isString(message.batchNo))
                        return "batchNo: string expected";
                if (message.count != null && message.hasOwnProperty("count"))
                    if (!$util.isString(message.count))
                        return "count: string expected";
                if (message.amount != null && message.hasOwnProperty("amount"))
                    if (!$util.isString(message.amount))
                        return "amount: string expected";
                return null;
            };

            /**
             * Creates a ReimbursementSummaryByColumnExport message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryByColumnExport
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.ReimbursementSummaryByColumnExport} ReimbursementSummaryByColumnExport
             */
            ReimbursementSummaryByColumnExport.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.ReimbursementSummaryByColumnExport)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.ReimbursementSummaryByColumnExport();
                if (object.storeCode != null)
                    message.storeCode = String(object.storeCode);
                if (object.registerName != null)
                    message.registerName = String(object.registerName);
                if (object.terminalNo != null)
                    message.terminalNo = String(object.terminalNo);
                if (object.date != null)
                    message.date = String(object.date);
                if (object.batchNo != null)
                    message.batchNo = String(object.batchNo);
                if (object.count != null)
                    message.count = String(object.count);
                if (object.amount != null)
                    message.amount = String(object.amount);
                return message;
            };

            /**
             * Creates a plain object from a ReimbursementSummaryByColumnExport message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryByColumnExport
             * @static
             * @param {TCBReceiptApi.Protobuf.ReimbursementSummaryByColumnExport} message ReimbursementSummaryByColumnExport
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ReimbursementSummaryByColumnExport.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.storeCode = "";
                    object.registerName = "";
                    object.terminalNo = "";
                    object.date = "";
                    object.batchNo = "";
                    object.count = "";
                    object.amount = "";
                }
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    object.storeCode = message.storeCode;
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    object.registerName = message.registerName;
                if (message.terminalNo != null && message.hasOwnProperty("terminalNo"))
                    object.terminalNo = message.terminalNo;
                if (message.date != null && message.hasOwnProperty("date"))
                    object.date = message.date;
                if (message.batchNo != null && message.hasOwnProperty("batchNo"))
                    object.batchNo = message.batchNo;
                if (message.count != null && message.hasOwnProperty("count"))
                    object.count = message.count;
                if (message.amount != null && message.hasOwnProperty("amount"))
                    object.amount = message.amount;
                return object;
            };

            /**
             * Converts this ReimbursementSummaryByColumnExport to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.ReimbursementSummaryByColumnExport
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ReimbursementSummaryByColumnExport.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ReimbursementSummaryByColumnExport;
        })();

        /**
         * ErrorCode enum.
         * @name TCBReceiptApi.Protobuf.ErrorCode
         * @enum {number}
         * @property {number} EC_NONE=0 EC_NONE value
         * @property {number} EC_SUCESS=1 EC_SUCESS value
         * @property {number} EC_FAILED=2 EC_FAILED value
         * @property {number} EC_DB_EXCEPTION=3 EC_DB_EXCEPTION value
         * @property {number} EC_NOT_HAS_PERMISSION=4 EC_NOT_HAS_PERMISSION value
         * @property {number} EC_OLD_PASSWORD_ERROR=101 EC_OLD_PASSWORD_ERROR value
         * @property {number} EC_SAME_PASSWORD_ERROR=102 EC_SAME_PASSWORD_ERROR value
         * @property {number} EC_USER_IS_NOT_EXISTS=103 EC_USER_IS_NOT_EXISTS value
         * @property {number} EC_USER_IS_LOCK=104 EC_USER_IS_LOCK value
         * @property {number} EC_USER_LOGIN_ERROR=105 EC_USER_LOGIN_ERROR value
         * @property {number} EC_RESET_PASSWORD_EXPIRED=106 EC_RESET_PASSWORD_EXPIRED value
         * @property {number} EC_CAPTCHA_ERROR=107 EC_CAPTCHA_ERROR value
         * @property {number} EC_PASSWORD_LENGTH_ERROR=108 EC_PASSWORD_LENGTH_ERROR value
         * @property {number} EC_PASSWORD_FORMAT_ERROR=109 EC_PASSWORD_FORMAT_ERROR value
         * @property {number} EC_USER_IS_DISABLE=110 EC_USER_IS_DISABLE value
         * @property {number} EC_USER_REPEAT_LOGIN=111 EC_USER_REPEAT_LOGIN value
         * @property {number} EC_USER_TOKEN_EXPIRES=112 EC_USER_TOKEN_EXPIRES value
         * @property {number} EC_TID_NUMBER_INVALID=113 EC_TID_NUMBER_INVALID value
         * @property {number} EC_OVER_ONLINE_UPPER_LIMIT=114 EC_OVER_ONLINE_UPPER_LIMIT value
         * @property {number} EC_CONNET_TO_DB_FAILED=1001 EC_CONNET_TO_DB_FAILED value
         * @property {number} EC_DATA_INVALID=1007 EC_DATA_INVALID value
         * @property {number} EC_CONDITION_INVALID=1101 EC_CONDITION_INVALID value
         * @property {number} EC_GET_DATA_ERROR=1301 EC_GET_DATA_ERROR value
         * @property {number} EC_GET_LIST_TOTAL_ERROR=1302 EC_GET_LIST_TOTAL_ERROR value
         * @property {number} EC_INSERT_ERROR=1401 EC_INSERT_ERROR value
         * @property {number} EC_UPDATE_ERROR=1402 EC_UPDATE_ERROR value
         * @property {number} EC_DELETE_ERROR=1403 EC_DELETE_ERROR value
         * @property {number} EC_DATA_IS_EXISTS=1404 EC_DATA_IS_EXISTS value
         * @property {number} EC_DATA_IS_NOT_EXISTS=1405 EC_DATA_IS_NOT_EXISTS value
         * @property {number} EC_SCHEDULE_IS_PROCESSING=1501 EC_SCHEDULE_IS_PROCESSING value
         * @property {number} EC_STAMP_RELEASE_ORDER_ERROR=1601 EC_STAMP_RELEASE_ORDER_ERROR value
         * @property {number} EC_RECEIPT_PREFIX_EXCEED_END=1701 EC_RECEIPT_PREFIX_EXCEED_END value
         * @property {number} EC_RECEIPT_PREFIX_REPEAT=1702 EC_RECEIPT_PREFIX_REPEAT value
         */
        Protobuf.ErrorCode = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "EC_NONE"] = 0;
            values[valuesById[1] = "EC_SUCESS"] = 1;
            values[valuesById[2] = "EC_FAILED"] = 2;
            values[valuesById[3] = "EC_DB_EXCEPTION"] = 3;
            values[valuesById[4] = "EC_NOT_HAS_PERMISSION"] = 4;
            values[valuesById[101] = "EC_OLD_PASSWORD_ERROR"] = 101;
            values[valuesById[102] = "EC_SAME_PASSWORD_ERROR"] = 102;
            values[valuesById[103] = "EC_USER_IS_NOT_EXISTS"] = 103;
            values[valuesById[104] = "EC_USER_IS_LOCK"] = 104;
            values[valuesById[105] = "EC_USER_LOGIN_ERROR"] = 105;
            values[valuesById[106] = "EC_RESET_PASSWORD_EXPIRED"] = 106;
            values[valuesById[107] = "EC_CAPTCHA_ERROR"] = 107;
            values[valuesById[108] = "EC_PASSWORD_LENGTH_ERROR"] = 108;
            values[valuesById[109] = "EC_PASSWORD_FORMAT_ERROR"] = 109;
            values[valuesById[110] = "EC_USER_IS_DISABLE"] = 110;
            values[valuesById[111] = "EC_USER_REPEAT_LOGIN"] = 111;
            values[valuesById[112] = "EC_USER_TOKEN_EXPIRES"] = 112;
            values[valuesById[113] = "EC_TID_NUMBER_INVALID"] = 113;
            values[valuesById[114] = "EC_OVER_ONLINE_UPPER_LIMIT"] = 114;
            values[valuesById[1001] = "EC_CONNET_TO_DB_FAILED"] = 1001;
            values[valuesById[1007] = "EC_DATA_INVALID"] = 1007;
            values[valuesById[1101] = "EC_CONDITION_INVALID"] = 1101;
            values[valuesById[1301] = "EC_GET_DATA_ERROR"] = 1301;
            values[valuesById[1302] = "EC_GET_LIST_TOTAL_ERROR"] = 1302;
            values[valuesById[1401] = "EC_INSERT_ERROR"] = 1401;
            values[valuesById[1402] = "EC_UPDATE_ERROR"] = 1402;
            values[valuesById[1403] = "EC_DELETE_ERROR"] = 1403;
            values[valuesById[1404] = "EC_DATA_IS_EXISTS"] = 1404;
            values[valuesById[1405] = "EC_DATA_IS_NOT_EXISTS"] = 1405;
            values[valuesById[1501] = "EC_SCHEDULE_IS_PROCESSING"] = 1501;
            values[valuesById[1601] = "EC_STAMP_RELEASE_ORDER_ERROR"] = 1601;
            values[valuesById[1701] = "EC_RECEIPT_PREFIX_EXCEED_END"] = 1701;
            values[valuesById[1702] = "EC_RECEIPT_PREFIX_REPEAT"] = 1702;
            return values;
        })();

        Protobuf.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IResponse
             * @property {TCBReceiptApi.Protobuf.ErrorCode|null} [errorCode] Response errorCode
             * @property {Uint8Array|null} [item] Response item
             */

            /**
             * Constructs a new Response.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response errorCode.
             * @member {TCBReceiptApi.Protobuf.ErrorCode} errorCode
             * @memberof TCBReceiptApi.Protobuf.Response
             * @instance
             */
            Response.prototype.errorCode = 0;

            /**
             * Response item.
             * @member {Uint8Array} item
             * @memberof TCBReceiptApi.Protobuf.Response
             * @instance
             */
            Response.prototype.item = $util.newBuffer([]);

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.Response
             * @static
             * @param {TCBReceiptApi.Protobuf.IResponse=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link TCBReceiptApi.Protobuf.Response.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.Response
             * @static
             * @param {TCBReceiptApi.Protobuf.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.errorCode != null && Object.hasOwnProperty.call(message, "errorCode"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.errorCode);
                if (message.item != null && Object.hasOwnProperty.call(message, "item"))
                    writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.item);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.Response
             * @static
             * @param {TCBReceiptApi.Protobuf.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.errorCode = reader.int32();
                        break;
                    case 2:
                        message.item = reader.bytes();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.errorCode != null && message.hasOwnProperty("errorCode"))
                    switch (message.errorCode) {
                    default:
                        return "errorCode: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 101:
                    case 102:
                    case 103:
                    case 104:
                    case 105:
                    case 106:
                    case 107:
                    case 108:
                    case 109:
                    case 110:
                    case 111:
                    case 112:
                    case 113:
                    case 114:
                    case 1001:
                    case 1007:
                    case 1101:
                    case 1301:
                    case 1302:
                    case 1401:
                    case 1402:
                    case 1403:
                    case 1404:
                    case 1405:
                    case 1501:
                    case 1601:
                    case 1701:
                    case 1702:
                        break;
                    }
                if (message.item != null && message.hasOwnProperty("item"))
                    if (!(message.item && typeof message.item.length === "number" || $util.isString(message.item)))
                        return "item: buffer expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.Response)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.Response();
                switch (object.errorCode) {
                case "EC_NONE":
                case 0:
                    message.errorCode = 0;
                    break;
                case "EC_SUCESS":
                case 1:
                    message.errorCode = 1;
                    break;
                case "EC_FAILED":
                case 2:
                    message.errorCode = 2;
                    break;
                case "EC_DB_EXCEPTION":
                case 3:
                    message.errorCode = 3;
                    break;
                case "EC_NOT_HAS_PERMISSION":
                case 4:
                    message.errorCode = 4;
                    break;
                case "EC_OLD_PASSWORD_ERROR":
                case 101:
                    message.errorCode = 101;
                    break;
                case "EC_SAME_PASSWORD_ERROR":
                case 102:
                    message.errorCode = 102;
                    break;
                case "EC_USER_IS_NOT_EXISTS":
                case 103:
                    message.errorCode = 103;
                    break;
                case "EC_USER_IS_LOCK":
                case 104:
                    message.errorCode = 104;
                    break;
                case "EC_USER_LOGIN_ERROR":
                case 105:
                    message.errorCode = 105;
                    break;
                case "EC_RESET_PASSWORD_EXPIRED":
                case 106:
                    message.errorCode = 106;
                    break;
                case "EC_CAPTCHA_ERROR":
                case 107:
                    message.errorCode = 107;
                    break;
                case "EC_PASSWORD_LENGTH_ERROR":
                case 108:
                    message.errorCode = 108;
                    break;
                case "EC_PASSWORD_FORMAT_ERROR":
                case 109:
                    message.errorCode = 109;
                    break;
                case "EC_USER_IS_DISABLE":
                case 110:
                    message.errorCode = 110;
                    break;
                case "EC_USER_REPEAT_LOGIN":
                case 111:
                    message.errorCode = 111;
                    break;
                case "EC_USER_TOKEN_EXPIRES":
                case 112:
                    message.errorCode = 112;
                    break;
                case "EC_TID_NUMBER_INVALID":
                case 113:
                    message.errorCode = 113;
                    break;
                case "EC_OVER_ONLINE_UPPER_LIMIT":
                case 114:
                    message.errorCode = 114;
                    break;
                case "EC_CONNET_TO_DB_FAILED":
                case 1001:
                    message.errorCode = 1001;
                    break;
                case "EC_DATA_INVALID":
                case 1007:
                    message.errorCode = 1007;
                    break;
                case "EC_CONDITION_INVALID":
                case 1101:
                    message.errorCode = 1101;
                    break;
                case "EC_GET_DATA_ERROR":
                case 1301:
                    message.errorCode = 1301;
                    break;
                case "EC_GET_LIST_TOTAL_ERROR":
                case 1302:
                    message.errorCode = 1302;
                    break;
                case "EC_INSERT_ERROR":
                case 1401:
                    message.errorCode = 1401;
                    break;
                case "EC_UPDATE_ERROR":
                case 1402:
                    message.errorCode = 1402;
                    break;
                case "EC_DELETE_ERROR":
                case 1403:
                    message.errorCode = 1403;
                    break;
                case "EC_DATA_IS_EXISTS":
                case 1404:
                    message.errorCode = 1404;
                    break;
                case "EC_DATA_IS_NOT_EXISTS":
                case 1405:
                    message.errorCode = 1405;
                    break;
                case "EC_SCHEDULE_IS_PROCESSING":
                case 1501:
                    message.errorCode = 1501;
                    break;
                case "EC_STAMP_RELEASE_ORDER_ERROR":
                case 1601:
                    message.errorCode = 1601;
                    break;
                case "EC_RECEIPT_PREFIX_EXCEED_END":
                case 1701:
                    message.errorCode = 1701;
                    break;
                case "EC_RECEIPT_PREFIX_REPEAT":
                case 1702:
                    message.errorCode = 1702;
                    break;
                }
                if (object.item != null)
                    if (typeof object.item === "string")
                        $util.base64.decode(object.item, message.item = $util.newBuffer($util.base64.length(object.item)), 0);
                    else if (object.item.length)
                        message.item = object.item;
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.Response
             * @static
             * @param {TCBReceiptApi.Protobuf.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.errorCode = options.enums === String ? "EC_NONE" : 0;
                    if (options.bytes === String)
                        object.item = "";
                    else {
                        object.item = [];
                        if (options.bytes !== Array)
                            object.item = $util.newBuffer(object.item);
                    }
                }
                if (message.errorCode != null && message.hasOwnProperty("errorCode"))
                    object.errorCode = options.enums === String ? $root.TCBReceiptApi.Protobuf.ErrorCode[message.errorCode] : message.errorCode;
                if (message.item != null && message.hasOwnProperty("item"))
                    object.item = options.bytes === String ? $util.base64.encode(message.item, 0, message.item.length) : options.bytes === Array ? Array.prototype.slice.call(message.item) : message.item;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        /**
         * ScheduleReportCheckPoint enum.
         * @name TCBReceiptApi.Protobuf.ScheduleReportCheckPoint
         * @enum {number}
         * @property {number} RCP_NONE=0 RCP_NONE value
         * @property {number} RCP_CHECK_SETTING=1 RCP_CHECK_SETTING value
         * @property {number} RCP_NEW_FOLDER=2 RCP_NEW_FOLDER value
         * @property {number} RCP_SELECT_DATA=3 RCP_SELECT_DATA value
         * @property {number} RCP_EXPORT_FILE=4 RCP_EXPORT_FILE value
         * @property {number} RCP_ZIP_FOLDER=5 RCP_ZIP_FOLDER value
         * @property {number} RCP_DELETE_FOLDER=6 RCP_DELETE_FOLDER value
         */
        Protobuf.ScheduleReportCheckPoint = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "RCP_NONE"] = 0;
            values[valuesById[1] = "RCP_CHECK_SETTING"] = 1;
            values[valuesById[2] = "RCP_NEW_FOLDER"] = 2;
            values[valuesById[3] = "RCP_SELECT_DATA"] = 3;
            values[valuesById[4] = "RCP_EXPORT_FILE"] = 4;
            values[valuesById[5] = "RCP_ZIP_FOLDER"] = 5;
            values[valuesById[6] = "RCP_DELETE_FOLDER"] = 6;
            return values;
        })();

        Protobuf.ScheduleReportQuery = (function() {

            /**
             * Properties of a ScheduleReportQuery.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IScheduleReportQuery
             * @property {number|null} [type] ScheduleReportQuery type
             * @property {string|null} [account] ScheduleReportQuery account
             */

            /**
             * Constructs a new ScheduleReportQuery.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a ScheduleReportQuery.
             * @implements IScheduleReportQuery
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IScheduleReportQuery=} [properties] Properties to set
             */
            function ScheduleReportQuery(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ScheduleReportQuery type.
             * @member {number} type
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportQuery
             * @instance
             */
            ScheduleReportQuery.prototype.type = 0;

            /**
             * ScheduleReportQuery account.
             * @member {string} account
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportQuery
             * @instance
             */
            ScheduleReportQuery.prototype.account = "";

            /**
             * Creates a new ScheduleReportQuery instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.IScheduleReportQuery=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.ScheduleReportQuery} ScheduleReportQuery instance
             */
            ScheduleReportQuery.create = function create(properties) {
                return new ScheduleReportQuery(properties);
            };

            /**
             * Encodes the specified ScheduleReportQuery message. Does not implicitly {@link TCBReceiptApi.Protobuf.ScheduleReportQuery.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.IScheduleReportQuery} message ScheduleReportQuery message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ScheduleReportQuery.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
                if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.account);
                return writer;
            };

            /**
             * Encodes the specified ScheduleReportQuery message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.ScheduleReportQuery.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.IScheduleReportQuery} message ScheduleReportQuery message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ScheduleReportQuery.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ScheduleReportQuery message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportQuery
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.ScheduleReportQuery} ScheduleReportQuery
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ScheduleReportQuery.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.ScheduleReportQuery();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.type = reader.int32();
                        break;
                    case 2:
                        message.account = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ScheduleReportQuery message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportQuery
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.ScheduleReportQuery} ScheduleReportQuery
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ScheduleReportQuery.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ScheduleReportQuery message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportQuery
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ScheduleReportQuery.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isInteger(message.type))
                        return "type: integer expected";
                if (message.account != null && message.hasOwnProperty("account"))
                    if (!$util.isString(message.account))
                        return "account: string expected";
                return null;
            };

            /**
             * Creates a ScheduleReportQuery message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportQuery
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.ScheduleReportQuery} ScheduleReportQuery
             */
            ScheduleReportQuery.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.ScheduleReportQuery)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.ScheduleReportQuery();
                if (object.type != null)
                    message.type = object.type | 0;
                if (object.account != null)
                    message.account = String(object.account);
                return message;
            };

            /**
             * Creates a plain object from a ScheduleReportQuery message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.ScheduleReportQuery} message ScheduleReportQuery
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ScheduleReportQuery.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.type = 0;
                    object.account = "";
                }
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.account != null && message.hasOwnProperty("account"))
                    object.account = message.account;
                return object;
            };

            /**
             * Converts this ScheduleReportQuery to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportQuery
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ScheduleReportQuery.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ScheduleReportQuery;
        })();

        Protobuf.ScheduleReportInfo = (function() {

            /**
             * Properties of a ScheduleReportInfo.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IScheduleReportInfo
             * @property {number|null} [scheduleReportId] ScheduleReportInfo scheduleReportId
             * @property {number|null} [type] ScheduleReportInfo type
             * @property {string|null} [bankCode] ScheduleReportInfo bankCode
             * @property {string|null} [bankName] ScheduleReportInfo bankName
             * @property {string|null} [adminName] ScheduleReportInfo adminName
             * @property {number|null} [userId] ScheduleReportInfo userId
             * @property {string|null} [storeName] ScheduleReportInfo storeName
             * @property {number|null} [fromWhere] ScheduleReportInfo fromWhere
             * @property {string|null} [params] ScheduleReportInfo params
             * @property {number|null} [count] ScheduleReportInfo count
             * @property {string|null} [date] ScheduleReportInfo date
             * @property {string|null} [expectedStartTime] ScheduleReportInfo expectedStartTime
             * @property {string|null} [startDate] ScheduleReportInfo startDate
             * @property {number|null} [startTime] ScheduleReportInfo startTime
             * @property {string|null} [endDate] ScheduleReportInfo endDate
             * @property {number|null} [endTime] ScheduleReportInfo endTime
             * @property {string|null} [fileName] ScheduleReportInfo fileName
             * @property {string|null} [filePath] ScheduleReportInfo filePath
             * @property {number|null} [status] ScheduleReportInfo status
             * @property {number|null} [checkPoint] ScheduleReportInfo checkPoint
             * @property {string|null} [record] ScheduleReportInfo record
             * @property {string|null} [error] ScheduleReportInfo error
             * @property {TCBReceiptApi.Protobuf.IScheduleReportReimbursementQuery|null} [reimbursementQuery] ScheduleReportInfo reimbursementQuery
             * @property {TCBReceiptApi.Protobuf.IScheduleReportAppropriationQuery|null} [appropriationQuery] ScheduleReportInfo appropriationQuery
             * @property {TCBReceiptApi.Protobuf.IScheduleReportReimbursementQuerySpecificStore|null} [reimbursementQuerySpecificStore] ScheduleReportInfo reimbursementQuerySpecificStore
             * @property {TCBReceiptApi.Protobuf.IScheduleReportAppropriationQuerySpecificStore|null} [appropriationQuerySpecificStore] ScheduleReportInfo appropriationQuerySpecificStore
             * @property {string|null} [fromTxt] ScheduleReportInfo fromTxt
             * @property {string|null} [datePeriod] ScheduleReportInfo datePeriod
             */

            /**
             * Constructs a new ScheduleReportInfo.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a ScheduleReportInfo.
             * @implements IScheduleReportInfo
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IScheduleReportInfo=} [properties] Properties to set
             */
            function ScheduleReportInfo(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ScheduleReportInfo scheduleReportId.
             * @member {number} scheduleReportId
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @instance
             */
            ScheduleReportInfo.prototype.scheduleReportId = 0;

            /**
             * ScheduleReportInfo type.
             * @member {number} type
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @instance
             */
            ScheduleReportInfo.prototype.type = 0;

            /**
             * ScheduleReportInfo bankCode.
             * @member {string} bankCode
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @instance
             */
            ScheduleReportInfo.prototype.bankCode = "";

            /**
             * ScheduleReportInfo bankName.
             * @member {string} bankName
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @instance
             */
            ScheduleReportInfo.prototype.bankName = "";

            /**
             * ScheduleReportInfo adminName.
             * @member {string} adminName
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @instance
             */
            ScheduleReportInfo.prototype.adminName = "";

            /**
             * ScheduleReportInfo userId.
             * @member {number} userId
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @instance
             */
            ScheduleReportInfo.prototype.userId = 0;

            /**
             * ScheduleReportInfo storeName.
             * @member {string} storeName
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @instance
             */
            ScheduleReportInfo.prototype.storeName = "";

            /**
             * ScheduleReportInfo fromWhere.
             * @member {number} fromWhere
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @instance
             */
            ScheduleReportInfo.prototype.fromWhere = 0;

            /**
             * ScheduleReportInfo params.
             * @member {string} params
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @instance
             */
            ScheduleReportInfo.prototype.params = "";

            /**
             * ScheduleReportInfo count.
             * @member {number} count
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @instance
             */
            ScheduleReportInfo.prototype.count = 0;

            /**
             * ScheduleReportInfo date.
             * @member {string} date
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @instance
             */
            ScheduleReportInfo.prototype.date = "";

            /**
             * ScheduleReportInfo expectedStartTime.
             * @member {string} expectedStartTime
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @instance
             */
            ScheduleReportInfo.prototype.expectedStartTime = "";

            /**
             * ScheduleReportInfo startDate.
             * @member {string} startDate
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @instance
             */
            ScheduleReportInfo.prototype.startDate = "";

            /**
             * ScheduleReportInfo startTime.
             * @member {number} startTime
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @instance
             */
            ScheduleReportInfo.prototype.startTime = 0;

            /**
             * ScheduleReportInfo endDate.
             * @member {string} endDate
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @instance
             */
            ScheduleReportInfo.prototype.endDate = "";

            /**
             * ScheduleReportInfo endTime.
             * @member {number} endTime
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @instance
             */
            ScheduleReportInfo.prototype.endTime = 0;

            /**
             * ScheduleReportInfo fileName.
             * @member {string} fileName
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @instance
             */
            ScheduleReportInfo.prototype.fileName = "";

            /**
             * ScheduleReportInfo filePath.
             * @member {string} filePath
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @instance
             */
            ScheduleReportInfo.prototype.filePath = "";

            /**
             * ScheduleReportInfo status.
             * @member {number} status
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @instance
             */
            ScheduleReportInfo.prototype.status = 0;

            /**
             * ScheduleReportInfo checkPoint.
             * @member {number} checkPoint
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @instance
             */
            ScheduleReportInfo.prototype.checkPoint = 0;

            /**
             * ScheduleReportInfo record.
             * @member {string} record
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @instance
             */
            ScheduleReportInfo.prototype.record = "";

            /**
             * ScheduleReportInfo error.
             * @member {string} error
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @instance
             */
            ScheduleReportInfo.prototype.error = "";

            /**
             * ScheduleReportInfo reimbursementQuery.
             * @member {TCBReceiptApi.Protobuf.IScheduleReportReimbursementQuery|null|undefined} reimbursementQuery
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @instance
             */
            ScheduleReportInfo.prototype.reimbursementQuery = null;

            /**
             * ScheduleReportInfo appropriationQuery.
             * @member {TCBReceiptApi.Protobuf.IScheduleReportAppropriationQuery|null|undefined} appropriationQuery
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @instance
             */
            ScheduleReportInfo.prototype.appropriationQuery = null;

            /**
             * ScheduleReportInfo reimbursementQuerySpecificStore.
             * @member {TCBReceiptApi.Protobuf.IScheduleReportReimbursementQuerySpecificStore|null|undefined} reimbursementQuerySpecificStore
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @instance
             */
            ScheduleReportInfo.prototype.reimbursementQuerySpecificStore = null;

            /**
             * ScheduleReportInfo appropriationQuerySpecificStore.
             * @member {TCBReceiptApi.Protobuf.IScheduleReportAppropriationQuerySpecificStore|null|undefined} appropriationQuerySpecificStore
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @instance
             */
            ScheduleReportInfo.prototype.appropriationQuerySpecificStore = null;

            /**
             * ScheduleReportInfo fromTxt.
             * @member {string} fromTxt
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @instance
             */
            ScheduleReportInfo.prototype.fromTxt = "";

            /**
             * ScheduleReportInfo datePeriod.
             * @member {string} datePeriod
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @instance
             */
            ScheduleReportInfo.prototype.datePeriod = "";

            /**
             * Creates a new ScheduleReportInfo instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @static
             * @param {TCBReceiptApi.Protobuf.IScheduleReportInfo=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.ScheduleReportInfo} ScheduleReportInfo instance
             */
            ScheduleReportInfo.create = function create(properties) {
                return new ScheduleReportInfo(properties);
            };

            /**
             * Encodes the specified ScheduleReportInfo message. Does not implicitly {@link TCBReceiptApi.Protobuf.ScheduleReportInfo.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @static
             * @param {TCBReceiptApi.Protobuf.IScheduleReportInfo} message ScheduleReportInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ScheduleReportInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.scheduleReportId != null && Object.hasOwnProperty.call(message, "scheduleReportId"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.scheduleReportId);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.type);
                if (message.bankCode != null && Object.hasOwnProperty.call(message, "bankCode"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.bankCode);
                if (message.bankName != null && Object.hasOwnProperty.call(message, "bankName"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.bankName);
                if (message.adminName != null && Object.hasOwnProperty.call(message, "adminName"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.adminName);
                if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int32(message.userId);
                if (message.storeName != null && Object.hasOwnProperty.call(message, "storeName"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.storeName);
                if (message.fromWhere != null && Object.hasOwnProperty.call(message, "fromWhere"))
                    writer.uint32(/* id 8, wireType 0 =*/64).int32(message.fromWhere);
                if (message.params != null && Object.hasOwnProperty.call(message, "params"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.params);
                if (message.count != null && Object.hasOwnProperty.call(message, "count"))
                    writer.uint32(/* id 10, wireType 0 =*/80).int32(message.count);
                if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.date);
                if (message.expectedStartTime != null && Object.hasOwnProperty.call(message, "expectedStartTime"))
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.expectedStartTime);
                if (message.startDate != null && Object.hasOwnProperty.call(message, "startDate"))
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.startDate);
                if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                    writer.uint32(/* id 14, wireType 0 =*/112).int32(message.startTime);
                if (message.endDate != null && Object.hasOwnProperty.call(message, "endDate"))
                    writer.uint32(/* id 15, wireType 2 =*/122).string(message.endDate);
                if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                    writer.uint32(/* id 16, wireType 0 =*/128).int32(message.endTime);
                if (message.fileName != null && Object.hasOwnProperty.call(message, "fileName"))
                    writer.uint32(/* id 17, wireType 2 =*/138).string(message.fileName);
                if (message.filePath != null && Object.hasOwnProperty.call(message, "filePath"))
                    writer.uint32(/* id 18, wireType 2 =*/146).string(message.filePath);
                if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                    writer.uint32(/* id 19, wireType 0 =*/152).int32(message.status);
                if (message.checkPoint != null && Object.hasOwnProperty.call(message, "checkPoint"))
                    writer.uint32(/* id 20, wireType 0 =*/160).int32(message.checkPoint);
                if (message.record != null && Object.hasOwnProperty.call(message, "record"))
                    writer.uint32(/* id 21, wireType 2 =*/170).string(message.record);
                if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                    writer.uint32(/* id 22, wireType 2 =*/178).string(message.error);
                if (message.reimbursementQuery != null && Object.hasOwnProperty.call(message, "reimbursementQuery"))
                    $root.TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery.encode(message.reimbursementQuery, writer.uint32(/* id 23, wireType 2 =*/186).fork()).ldelim();
                if (message.appropriationQuery != null && Object.hasOwnProperty.call(message, "appropriationQuery"))
                    $root.TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery.encode(message.appropriationQuery, writer.uint32(/* id 24, wireType 2 =*/194).fork()).ldelim();
                if (message.reimbursementQuerySpecificStore != null && Object.hasOwnProperty.call(message, "reimbursementQuerySpecificStore"))
                    $root.TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore.encode(message.reimbursementQuerySpecificStore, writer.uint32(/* id 25, wireType 2 =*/202).fork()).ldelim();
                if (message.appropriationQuerySpecificStore != null && Object.hasOwnProperty.call(message, "appropriationQuerySpecificStore"))
                    $root.TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore.encode(message.appropriationQuerySpecificStore, writer.uint32(/* id 26, wireType 2 =*/210).fork()).ldelim();
                if (message.fromTxt != null && Object.hasOwnProperty.call(message, "fromTxt"))
                    writer.uint32(/* id 27, wireType 2 =*/218).string(message.fromTxt);
                if (message.datePeriod != null && Object.hasOwnProperty.call(message, "datePeriod"))
                    writer.uint32(/* id 28, wireType 2 =*/226).string(message.datePeriod);
                return writer;
            };

            /**
             * Encodes the specified ScheduleReportInfo message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.ScheduleReportInfo.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @static
             * @param {TCBReceiptApi.Protobuf.IScheduleReportInfo} message ScheduleReportInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ScheduleReportInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ScheduleReportInfo message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.ScheduleReportInfo} ScheduleReportInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ScheduleReportInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.ScheduleReportInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.scheduleReportId = reader.int32();
                        break;
                    case 2:
                        message.type = reader.int32();
                        break;
                    case 3:
                        message.bankCode = reader.string();
                        break;
                    case 4:
                        message.bankName = reader.string();
                        break;
                    case 5:
                        message.adminName = reader.string();
                        break;
                    case 6:
                        message.userId = reader.int32();
                        break;
                    case 7:
                        message.storeName = reader.string();
                        break;
                    case 8:
                        message.fromWhere = reader.int32();
                        break;
                    case 9:
                        message.params = reader.string();
                        break;
                    case 10:
                        message.count = reader.int32();
                        break;
                    case 11:
                        message.date = reader.string();
                        break;
                    case 12:
                        message.expectedStartTime = reader.string();
                        break;
                    case 13:
                        message.startDate = reader.string();
                        break;
                    case 14:
                        message.startTime = reader.int32();
                        break;
                    case 15:
                        message.endDate = reader.string();
                        break;
                    case 16:
                        message.endTime = reader.int32();
                        break;
                    case 17:
                        message.fileName = reader.string();
                        break;
                    case 18:
                        message.filePath = reader.string();
                        break;
                    case 19:
                        message.status = reader.int32();
                        break;
                    case 20:
                        message.checkPoint = reader.int32();
                        break;
                    case 21:
                        message.record = reader.string();
                        break;
                    case 22:
                        message.error = reader.string();
                        break;
                    case 23:
                        message.reimbursementQuery = $root.TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery.decode(reader, reader.uint32());
                        break;
                    case 24:
                        message.appropriationQuery = $root.TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery.decode(reader, reader.uint32());
                        break;
                    case 25:
                        message.reimbursementQuerySpecificStore = $root.TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore.decode(reader, reader.uint32());
                        break;
                    case 26:
                        message.appropriationQuerySpecificStore = $root.TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore.decode(reader, reader.uint32());
                        break;
                    case 27:
                        message.fromTxt = reader.string();
                        break;
                    case 28:
                        message.datePeriod = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ScheduleReportInfo message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.ScheduleReportInfo} ScheduleReportInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ScheduleReportInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ScheduleReportInfo message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ScheduleReportInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.scheduleReportId != null && message.hasOwnProperty("scheduleReportId"))
                    if (!$util.isInteger(message.scheduleReportId))
                        return "scheduleReportId: integer expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isInteger(message.type))
                        return "type: integer expected";
                if (message.bankCode != null && message.hasOwnProperty("bankCode"))
                    if (!$util.isString(message.bankCode))
                        return "bankCode: string expected";
                if (message.bankName != null && message.hasOwnProperty("bankName"))
                    if (!$util.isString(message.bankName))
                        return "bankName: string expected";
                if (message.adminName != null && message.hasOwnProperty("adminName"))
                    if (!$util.isString(message.adminName))
                        return "adminName: string expected";
                if (message.userId != null && message.hasOwnProperty("userId"))
                    if (!$util.isInteger(message.userId))
                        return "userId: integer expected";
                if (message.storeName != null && message.hasOwnProperty("storeName"))
                    if (!$util.isString(message.storeName))
                        return "storeName: string expected";
                if (message.fromWhere != null && message.hasOwnProperty("fromWhere"))
                    if (!$util.isInteger(message.fromWhere))
                        return "fromWhere: integer expected";
                if (message.params != null && message.hasOwnProperty("params"))
                    if (!$util.isString(message.params))
                        return "params: string expected";
                if (message.count != null && message.hasOwnProperty("count"))
                    if (!$util.isInteger(message.count))
                        return "count: integer expected";
                if (message.date != null && message.hasOwnProperty("date"))
                    if (!$util.isString(message.date))
                        return "date: string expected";
                if (message.expectedStartTime != null && message.hasOwnProperty("expectedStartTime"))
                    if (!$util.isString(message.expectedStartTime))
                        return "expectedStartTime: string expected";
                if (message.startDate != null && message.hasOwnProperty("startDate"))
                    if (!$util.isString(message.startDate))
                        return "startDate: string expected";
                if (message.startTime != null && message.hasOwnProperty("startTime"))
                    if (!$util.isInteger(message.startTime))
                        return "startTime: integer expected";
                if (message.endDate != null && message.hasOwnProperty("endDate"))
                    if (!$util.isString(message.endDate))
                        return "endDate: string expected";
                if (message.endTime != null && message.hasOwnProperty("endTime"))
                    if (!$util.isInteger(message.endTime))
                        return "endTime: integer expected";
                if (message.fileName != null && message.hasOwnProperty("fileName"))
                    if (!$util.isString(message.fileName))
                        return "fileName: string expected";
                if (message.filePath != null && message.hasOwnProperty("filePath"))
                    if (!$util.isString(message.filePath))
                        return "filePath: string expected";
                if (message.status != null && message.hasOwnProperty("status"))
                    if (!$util.isInteger(message.status))
                        return "status: integer expected";
                if (message.checkPoint != null && message.hasOwnProperty("checkPoint"))
                    if (!$util.isInteger(message.checkPoint))
                        return "checkPoint: integer expected";
                if (message.record != null && message.hasOwnProperty("record"))
                    if (!$util.isString(message.record))
                        return "record: string expected";
                if (message.error != null && message.hasOwnProperty("error"))
                    if (!$util.isString(message.error))
                        return "error: string expected";
                if (message.reimbursementQuery != null && message.hasOwnProperty("reimbursementQuery")) {
                    var error = $root.TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery.verify(message.reimbursementQuery);
                    if (error)
                        return "reimbursementQuery." + error;
                }
                if (message.appropriationQuery != null && message.hasOwnProperty("appropriationQuery")) {
                    var error = $root.TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery.verify(message.appropriationQuery);
                    if (error)
                        return "appropriationQuery." + error;
                }
                if (message.reimbursementQuerySpecificStore != null && message.hasOwnProperty("reimbursementQuerySpecificStore")) {
                    var error = $root.TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore.verify(message.reimbursementQuerySpecificStore);
                    if (error)
                        return "reimbursementQuerySpecificStore." + error;
                }
                if (message.appropriationQuerySpecificStore != null && message.hasOwnProperty("appropriationQuerySpecificStore")) {
                    var error = $root.TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore.verify(message.appropriationQuerySpecificStore);
                    if (error)
                        return "appropriationQuerySpecificStore." + error;
                }
                if (message.fromTxt != null && message.hasOwnProperty("fromTxt"))
                    if (!$util.isString(message.fromTxt))
                        return "fromTxt: string expected";
                if (message.datePeriod != null && message.hasOwnProperty("datePeriod"))
                    if (!$util.isString(message.datePeriod))
                        return "datePeriod: string expected";
                return null;
            };

            /**
             * Creates a ScheduleReportInfo message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.ScheduleReportInfo} ScheduleReportInfo
             */
            ScheduleReportInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.ScheduleReportInfo)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.ScheduleReportInfo();
                if (object.scheduleReportId != null)
                    message.scheduleReportId = object.scheduleReportId | 0;
                if (object.type != null)
                    message.type = object.type | 0;
                if (object.bankCode != null)
                    message.bankCode = String(object.bankCode);
                if (object.bankName != null)
                    message.bankName = String(object.bankName);
                if (object.adminName != null)
                    message.adminName = String(object.adminName);
                if (object.userId != null)
                    message.userId = object.userId | 0;
                if (object.storeName != null)
                    message.storeName = String(object.storeName);
                if (object.fromWhere != null)
                    message.fromWhere = object.fromWhere | 0;
                if (object.params != null)
                    message.params = String(object.params);
                if (object.count != null)
                    message.count = object.count | 0;
                if (object.date != null)
                    message.date = String(object.date);
                if (object.expectedStartTime != null)
                    message.expectedStartTime = String(object.expectedStartTime);
                if (object.startDate != null)
                    message.startDate = String(object.startDate);
                if (object.startTime != null)
                    message.startTime = object.startTime | 0;
                if (object.endDate != null)
                    message.endDate = String(object.endDate);
                if (object.endTime != null)
                    message.endTime = object.endTime | 0;
                if (object.fileName != null)
                    message.fileName = String(object.fileName);
                if (object.filePath != null)
                    message.filePath = String(object.filePath);
                if (object.status != null)
                    message.status = object.status | 0;
                if (object.checkPoint != null)
                    message.checkPoint = object.checkPoint | 0;
                if (object.record != null)
                    message.record = String(object.record);
                if (object.error != null)
                    message.error = String(object.error);
                if (object.reimbursementQuery != null) {
                    if (typeof object.reimbursementQuery !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.ScheduleReportInfo.reimbursementQuery: object expected");
                    message.reimbursementQuery = $root.TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery.fromObject(object.reimbursementQuery);
                }
                if (object.appropriationQuery != null) {
                    if (typeof object.appropriationQuery !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.ScheduleReportInfo.appropriationQuery: object expected");
                    message.appropriationQuery = $root.TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery.fromObject(object.appropriationQuery);
                }
                if (object.reimbursementQuerySpecificStore != null) {
                    if (typeof object.reimbursementQuerySpecificStore !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.ScheduleReportInfo.reimbursementQuerySpecificStore: object expected");
                    message.reimbursementQuerySpecificStore = $root.TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore.fromObject(object.reimbursementQuerySpecificStore);
                }
                if (object.appropriationQuerySpecificStore != null) {
                    if (typeof object.appropriationQuerySpecificStore !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.ScheduleReportInfo.appropriationQuerySpecificStore: object expected");
                    message.appropriationQuerySpecificStore = $root.TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore.fromObject(object.appropriationQuerySpecificStore);
                }
                if (object.fromTxt != null)
                    message.fromTxt = String(object.fromTxt);
                if (object.datePeriod != null)
                    message.datePeriod = String(object.datePeriod);
                return message;
            };

            /**
             * Creates a plain object from a ScheduleReportInfo message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @static
             * @param {TCBReceiptApi.Protobuf.ScheduleReportInfo} message ScheduleReportInfo
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ScheduleReportInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.scheduleReportId = 0;
                    object.type = 0;
                    object.bankCode = "";
                    object.bankName = "";
                    object.adminName = "";
                    object.userId = 0;
                    object.storeName = "";
                    object.fromWhere = 0;
                    object.params = "";
                    object.count = 0;
                    object.date = "";
                    object.expectedStartTime = "";
                    object.startDate = "";
                    object.startTime = 0;
                    object.endDate = "";
                    object.endTime = 0;
                    object.fileName = "";
                    object.filePath = "";
                    object.status = 0;
                    object.checkPoint = 0;
                    object.record = "";
                    object.error = "";
                    object.reimbursementQuery = null;
                    object.appropriationQuery = null;
                    object.reimbursementQuerySpecificStore = null;
                    object.appropriationQuerySpecificStore = null;
                    object.fromTxt = "";
                    object.datePeriod = "";
                }
                if (message.scheduleReportId != null && message.hasOwnProperty("scheduleReportId"))
                    object.scheduleReportId = message.scheduleReportId;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.bankCode != null && message.hasOwnProperty("bankCode"))
                    object.bankCode = message.bankCode;
                if (message.bankName != null && message.hasOwnProperty("bankName"))
                    object.bankName = message.bankName;
                if (message.adminName != null && message.hasOwnProperty("adminName"))
                    object.adminName = message.adminName;
                if (message.userId != null && message.hasOwnProperty("userId"))
                    object.userId = message.userId;
                if (message.storeName != null && message.hasOwnProperty("storeName"))
                    object.storeName = message.storeName;
                if (message.fromWhere != null && message.hasOwnProperty("fromWhere"))
                    object.fromWhere = message.fromWhere;
                if (message.params != null && message.hasOwnProperty("params"))
                    object.params = message.params;
                if (message.count != null && message.hasOwnProperty("count"))
                    object.count = message.count;
                if (message.date != null && message.hasOwnProperty("date"))
                    object.date = message.date;
                if (message.expectedStartTime != null && message.hasOwnProperty("expectedStartTime"))
                    object.expectedStartTime = message.expectedStartTime;
                if (message.startDate != null && message.hasOwnProperty("startDate"))
                    object.startDate = message.startDate;
                if (message.startTime != null && message.hasOwnProperty("startTime"))
                    object.startTime = message.startTime;
                if (message.endDate != null && message.hasOwnProperty("endDate"))
                    object.endDate = message.endDate;
                if (message.endTime != null && message.hasOwnProperty("endTime"))
                    object.endTime = message.endTime;
                if (message.fileName != null && message.hasOwnProperty("fileName"))
                    object.fileName = message.fileName;
                if (message.filePath != null && message.hasOwnProperty("filePath"))
                    object.filePath = message.filePath;
                if (message.status != null && message.hasOwnProperty("status"))
                    object.status = message.status;
                if (message.checkPoint != null && message.hasOwnProperty("checkPoint"))
                    object.checkPoint = message.checkPoint;
                if (message.record != null && message.hasOwnProperty("record"))
                    object.record = message.record;
                if (message.error != null && message.hasOwnProperty("error"))
                    object.error = message.error;
                if (message.reimbursementQuery != null && message.hasOwnProperty("reimbursementQuery"))
                    object.reimbursementQuery = $root.TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery.toObject(message.reimbursementQuery, options);
                if (message.appropriationQuery != null && message.hasOwnProperty("appropriationQuery"))
                    object.appropriationQuery = $root.TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery.toObject(message.appropriationQuery, options);
                if (message.reimbursementQuerySpecificStore != null && message.hasOwnProperty("reimbursementQuerySpecificStore"))
                    object.reimbursementQuerySpecificStore = $root.TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore.toObject(message.reimbursementQuerySpecificStore, options);
                if (message.appropriationQuerySpecificStore != null && message.hasOwnProperty("appropriationQuerySpecificStore"))
                    object.appropriationQuerySpecificStore = $root.TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore.toObject(message.appropriationQuerySpecificStore, options);
                if (message.fromTxt != null && message.hasOwnProperty("fromTxt"))
                    object.fromTxt = message.fromTxt;
                if (message.datePeriod != null && message.hasOwnProperty("datePeriod"))
                    object.datePeriod = message.datePeriod;
                return object;
            };

            /**
             * Converts this ScheduleReportInfo to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportInfo
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ScheduleReportInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ScheduleReportInfo;
        })();

        Protobuf.ScheduleReportList = (function() {

            /**
             * Properties of a ScheduleReportList.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IScheduleReportList
             * @property {Array.<TCBReceiptApi.Protobuf.IScheduleReportInfo>|null} [list] ScheduleReportList list
             * @property {number|null} [total] ScheduleReportList total
             */

            /**
             * Constructs a new ScheduleReportList.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a ScheduleReportList.
             * @implements IScheduleReportList
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IScheduleReportList=} [properties] Properties to set
             */
            function ScheduleReportList(properties) {
                this.list = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ScheduleReportList list.
             * @member {Array.<TCBReceiptApi.Protobuf.IScheduleReportInfo>} list
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportList
             * @instance
             */
            ScheduleReportList.prototype.list = $util.emptyArray;

            /**
             * ScheduleReportList total.
             * @member {number} total
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportList
             * @instance
             */
            ScheduleReportList.prototype.total = 0;

            /**
             * Creates a new ScheduleReportList instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportList
             * @static
             * @param {TCBReceiptApi.Protobuf.IScheduleReportList=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.ScheduleReportList} ScheduleReportList instance
             */
            ScheduleReportList.create = function create(properties) {
                return new ScheduleReportList(properties);
            };

            /**
             * Encodes the specified ScheduleReportList message. Does not implicitly {@link TCBReceiptApi.Protobuf.ScheduleReportList.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportList
             * @static
             * @param {TCBReceiptApi.Protobuf.IScheduleReportList} message ScheduleReportList message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ScheduleReportList.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.list != null && message.list.length)
                    for (var i = 0; i < message.list.length; ++i)
                        $root.TCBReceiptApi.Protobuf.ScheduleReportInfo.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.total);
                return writer;
            };

            /**
             * Encodes the specified ScheduleReportList message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.ScheduleReportList.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportList
             * @static
             * @param {TCBReceiptApi.Protobuf.IScheduleReportList} message ScheduleReportList message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ScheduleReportList.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ScheduleReportList message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportList
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.ScheduleReportList} ScheduleReportList
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ScheduleReportList.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.ScheduleReportList();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.TCBReceiptApi.Protobuf.ScheduleReportInfo.decode(reader, reader.uint32()));
                        break;
                    case 2:
                        message.total = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ScheduleReportList message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportList
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.ScheduleReportList} ScheduleReportList
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ScheduleReportList.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ScheduleReportList message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportList
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ScheduleReportList.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.list != null && message.hasOwnProperty("list")) {
                    if (!Array.isArray(message.list))
                        return "list: array expected";
                    for (var i = 0; i < message.list.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.ScheduleReportInfo.verify(message.list[i]);
                        if (error)
                            return "list." + error;
                    }
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    if (!$util.isInteger(message.total))
                        return "total: integer expected";
                return null;
            };

            /**
             * Creates a ScheduleReportList message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportList
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.ScheduleReportList} ScheduleReportList
             */
            ScheduleReportList.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.ScheduleReportList)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.ScheduleReportList();
                if (object.list) {
                    if (!Array.isArray(object.list))
                        throw TypeError(".TCBReceiptApi.Protobuf.ScheduleReportList.list: array expected");
                    message.list = [];
                    for (var i = 0; i < object.list.length; ++i) {
                        if (typeof object.list[i] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.ScheduleReportList.list: object expected");
                        message.list[i] = $root.TCBReceiptApi.Protobuf.ScheduleReportInfo.fromObject(object.list[i]);
                    }
                }
                if (object.total != null)
                    message.total = object.total | 0;
                return message;
            };

            /**
             * Creates a plain object from a ScheduleReportList message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportList
             * @static
             * @param {TCBReceiptApi.Protobuf.ScheduleReportList} message ScheduleReportList
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ScheduleReportList.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.list = [];
                if (options.defaults)
                    object.total = 0;
                if (message.list && message.list.length) {
                    object.list = [];
                    for (var j = 0; j < message.list.length; ++j)
                        object.list[j] = $root.TCBReceiptApi.Protobuf.ScheduleReportInfo.toObject(message.list[j], options);
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    object.total = message.total;
                return object;
            };

            /**
             * Converts this ScheduleReportList to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportList
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ScheduleReportList.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ScheduleReportList;
        })();

        Protobuf.ScheduleReportReimbursementQuery = (function() {

            /**
             * Properties of a ScheduleReportReimbursementQuery.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IScheduleReportReimbursementQuery
             * @property {Array.<string>|null} [storeList] ScheduleReportReimbursementQuery storeList
             * @property {string|null} [tidNumber] ScheduleReportReimbursementQuery tidNumber
             * @property {string|null} [authCode] ScheduleReportReimbursementQuery authCode
             * @property {string|null} [cardNo] ScheduleReportReimbursementQuery cardNo
             * @property {string|null} [cardType] ScheduleReportReimbursementQuery cardType
             * @property {number|null} [type] ScheduleReportReimbursementQuery type
             * @property {number|null} [flag] ScheduleReportReimbursementQuery flag
             * @property {string|null} [orderNo] ScheduleReportReimbursementQuery orderNo
             * @property {number|null} [dateType] ScheduleReportReimbursementQuery dateType
             * @property {string|null} [dateStart] ScheduleReportReimbursementQuery dateStart
             * @property {string|null} [dateEnd] ScheduleReportReimbursementQuery dateEnd
             * @property {string|null} [terminalNoStart] ScheduleReportReimbursementQuery terminalNoStart
             * @property {string|null} [terminalNoEnd] ScheduleReportReimbursementQuery terminalNoEnd
             * @property {string|null} [specificStore] ScheduleReportReimbursementQuery specificStore
             * @property {number|null} [hide] ScheduleReportReimbursementQuery hide
             */

            /**
             * Constructs a new ScheduleReportReimbursementQuery.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a ScheduleReportReimbursementQuery.
             * @implements IScheduleReportReimbursementQuery
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IScheduleReportReimbursementQuery=} [properties] Properties to set
             */
            function ScheduleReportReimbursementQuery(properties) {
                this.storeList = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ScheduleReportReimbursementQuery storeList.
             * @member {Array.<string>} storeList
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery
             * @instance
             */
            ScheduleReportReimbursementQuery.prototype.storeList = $util.emptyArray;

            /**
             * ScheduleReportReimbursementQuery tidNumber.
             * @member {string} tidNumber
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery
             * @instance
             */
            ScheduleReportReimbursementQuery.prototype.tidNumber = "";

            /**
             * ScheduleReportReimbursementQuery authCode.
             * @member {string} authCode
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery
             * @instance
             */
            ScheduleReportReimbursementQuery.prototype.authCode = "";

            /**
             * ScheduleReportReimbursementQuery cardNo.
             * @member {string} cardNo
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery
             * @instance
             */
            ScheduleReportReimbursementQuery.prototype.cardNo = "";

            /**
             * ScheduleReportReimbursementQuery cardType.
             * @member {string} cardType
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery
             * @instance
             */
            ScheduleReportReimbursementQuery.prototype.cardType = "";

            /**
             * ScheduleReportReimbursementQuery type.
             * @member {number} type
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery
             * @instance
             */
            ScheduleReportReimbursementQuery.prototype.type = 0;

            /**
             * ScheduleReportReimbursementQuery flag.
             * @member {number} flag
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery
             * @instance
             */
            ScheduleReportReimbursementQuery.prototype.flag = 0;

            /**
             * ScheduleReportReimbursementQuery orderNo.
             * @member {string} orderNo
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery
             * @instance
             */
            ScheduleReportReimbursementQuery.prototype.orderNo = "";

            /**
             * ScheduleReportReimbursementQuery dateType.
             * @member {number} dateType
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery
             * @instance
             */
            ScheduleReportReimbursementQuery.prototype.dateType = 0;

            /**
             * ScheduleReportReimbursementQuery dateStart.
             * @member {string} dateStart
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery
             * @instance
             */
            ScheduleReportReimbursementQuery.prototype.dateStart = "";

            /**
             * ScheduleReportReimbursementQuery dateEnd.
             * @member {string} dateEnd
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery
             * @instance
             */
            ScheduleReportReimbursementQuery.prototype.dateEnd = "";

            /**
             * ScheduleReportReimbursementQuery terminalNoStart.
             * @member {string} terminalNoStart
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery
             * @instance
             */
            ScheduleReportReimbursementQuery.prototype.terminalNoStart = "";

            /**
             * ScheduleReportReimbursementQuery terminalNoEnd.
             * @member {string} terminalNoEnd
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery
             * @instance
             */
            ScheduleReportReimbursementQuery.prototype.terminalNoEnd = "";

            /**
             * ScheduleReportReimbursementQuery specificStore.
             * @member {string} specificStore
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery
             * @instance
             */
            ScheduleReportReimbursementQuery.prototype.specificStore = "";

            /**
             * ScheduleReportReimbursementQuery hide.
             * @member {number} hide
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery
             * @instance
             */
            ScheduleReportReimbursementQuery.prototype.hide = 0;

            /**
             * Creates a new ScheduleReportReimbursementQuery instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.IScheduleReportReimbursementQuery=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery} ScheduleReportReimbursementQuery instance
             */
            ScheduleReportReimbursementQuery.create = function create(properties) {
                return new ScheduleReportReimbursementQuery(properties);
            };

            /**
             * Encodes the specified ScheduleReportReimbursementQuery message. Does not implicitly {@link TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.IScheduleReportReimbursementQuery} message ScheduleReportReimbursementQuery message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ScheduleReportReimbursementQuery.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.storeList != null && message.storeList.length)
                    for (var i = 0; i < message.storeList.length; ++i)
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.storeList[i]);
                if (message.tidNumber != null && Object.hasOwnProperty.call(message, "tidNumber"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.tidNumber);
                if (message.authCode != null && Object.hasOwnProperty.call(message, "authCode"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.authCode);
                if (message.cardNo != null && Object.hasOwnProperty.call(message, "cardNo"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.cardNo);
                if (message.cardType != null && Object.hasOwnProperty.call(message, "cardType"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.cardType);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int32(message.type);
                if (message.flag != null && Object.hasOwnProperty.call(message, "flag"))
                    writer.uint32(/* id 7, wireType 0 =*/56).int32(message.flag);
                if (message.orderNo != null && Object.hasOwnProperty.call(message, "orderNo"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.orderNo);
                if (message.dateType != null && Object.hasOwnProperty.call(message, "dateType"))
                    writer.uint32(/* id 9, wireType 0 =*/72).int32(message.dateType);
                if (message.dateStart != null && Object.hasOwnProperty.call(message, "dateStart"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.dateStart);
                if (message.dateEnd != null && Object.hasOwnProperty.call(message, "dateEnd"))
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.dateEnd);
                if (message.terminalNoStart != null && Object.hasOwnProperty.call(message, "terminalNoStart"))
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.terminalNoStart);
                if (message.terminalNoEnd != null && Object.hasOwnProperty.call(message, "terminalNoEnd"))
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.terminalNoEnd);
                if (message.specificStore != null && Object.hasOwnProperty.call(message, "specificStore"))
                    writer.uint32(/* id 14, wireType 2 =*/114).string(message.specificStore);
                if (message.hide != null && Object.hasOwnProperty.call(message, "hide"))
                    writer.uint32(/* id 15, wireType 0 =*/120).int32(message.hide);
                return writer;
            };

            /**
             * Encodes the specified ScheduleReportReimbursementQuery message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.IScheduleReportReimbursementQuery} message ScheduleReportReimbursementQuery message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ScheduleReportReimbursementQuery.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ScheduleReportReimbursementQuery message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery} ScheduleReportReimbursementQuery
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ScheduleReportReimbursementQuery.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.storeList && message.storeList.length))
                            message.storeList = [];
                        message.storeList.push(reader.string());
                        break;
                    case 2:
                        message.tidNumber = reader.string();
                        break;
                    case 3:
                        message.authCode = reader.string();
                        break;
                    case 4:
                        message.cardNo = reader.string();
                        break;
                    case 5:
                        message.cardType = reader.string();
                        break;
                    case 6:
                        message.type = reader.int32();
                        break;
                    case 7:
                        message.flag = reader.int32();
                        break;
                    case 8:
                        message.orderNo = reader.string();
                        break;
                    case 9:
                        message.dateType = reader.int32();
                        break;
                    case 10:
                        message.dateStart = reader.string();
                        break;
                    case 11:
                        message.dateEnd = reader.string();
                        break;
                    case 12:
                        message.terminalNoStart = reader.string();
                        break;
                    case 13:
                        message.terminalNoEnd = reader.string();
                        break;
                    case 14:
                        message.specificStore = reader.string();
                        break;
                    case 15:
                        message.hide = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ScheduleReportReimbursementQuery message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery} ScheduleReportReimbursementQuery
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ScheduleReportReimbursementQuery.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ScheduleReportReimbursementQuery message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ScheduleReportReimbursementQuery.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.storeList != null && message.hasOwnProperty("storeList")) {
                    if (!Array.isArray(message.storeList))
                        return "storeList: array expected";
                    for (var i = 0; i < message.storeList.length; ++i)
                        if (!$util.isString(message.storeList[i]))
                            return "storeList: string[] expected";
                }
                if (message.tidNumber != null && message.hasOwnProperty("tidNumber"))
                    if (!$util.isString(message.tidNumber))
                        return "tidNumber: string expected";
                if (message.authCode != null && message.hasOwnProperty("authCode"))
                    if (!$util.isString(message.authCode))
                        return "authCode: string expected";
                if (message.cardNo != null && message.hasOwnProperty("cardNo"))
                    if (!$util.isString(message.cardNo))
                        return "cardNo: string expected";
                if (message.cardType != null && message.hasOwnProperty("cardType"))
                    if (!$util.isString(message.cardType))
                        return "cardType: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isInteger(message.type))
                        return "type: integer expected";
                if (message.flag != null && message.hasOwnProperty("flag"))
                    if (!$util.isInteger(message.flag))
                        return "flag: integer expected";
                if (message.orderNo != null && message.hasOwnProperty("orderNo"))
                    if (!$util.isString(message.orderNo))
                        return "orderNo: string expected";
                if (message.dateType != null && message.hasOwnProperty("dateType"))
                    if (!$util.isInteger(message.dateType))
                        return "dateType: integer expected";
                if (message.dateStart != null && message.hasOwnProperty("dateStart"))
                    if (!$util.isString(message.dateStart))
                        return "dateStart: string expected";
                if (message.dateEnd != null && message.hasOwnProperty("dateEnd"))
                    if (!$util.isString(message.dateEnd))
                        return "dateEnd: string expected";
                if (message.terminalNoStart != null && message.hasOwnProperty("terminalNoStart"))
                    if (!$util.isString(message.terminalNoStart))
                        return "terminalNoStart: string expected";
                if (message.terminalNoEnd != null && message.hasOwnProperty("terminalNoEnd"))
                    if (!$util.isString(message.terminalNoEnd))
                        return "terminalNoEnd: string expected";
                if (message.specificStore != null && message.hasOwnProperty("specificStore"))
                    if (!$util.isString(message.specificStore))
                        return "specificStore: string expected";
                if (message.hide != null && message.hasOwnProperty("hide"))
                    if (!$util.isInteger(message.hide))
                        return "hide: integer expected";
                return null;
            };

            /**
             * Creates a ScheduleReportReimbursementQuery message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery} ScheduleReportReimbursementQuery
             */
            ScheduleReportReimbursementQuery.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery();
                if (object.storeList) {
                    if (!Array.isArray(object.storeList))
                        throw TypeError(".TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery.storeList: array expected");
                    message.storeList = [];
                    for (var i = 0; i < object.storeList.length; ++i)
                        message.storeList[i] = String(object.storeList[i]);
                }
                if (object.tidNumber != null)
                    message.tidNumber = String(object.tidNumber);
                if (object.authCode != null)
                    message.authCode = String(object.authCode);
                if (object.cardNo != null)
                    message.cardNo = String(object.cardNo);
                if (object.cardType != null)
                    message.cardType = String(object.cardType);
                if (object.type != null)
                    message.type = object.type | 0;
                if (object.flag != null)
                    message.flag = object.flag | 0;
                if (object.orderNo != null)
                    message.orderNo = String(object.orderNo);
                if (object.dateType != null)
                    message.dateType = object.dateType | 0;
                if (object.dateStart != null)
                    message.dateStart = String(object.dateStart);
                if (object.dateEnd != null)
                    message.dateEnd = String(object.dateEnd);
                if (object.terminalNoStart != null)
                    message.terminalNoStart = String(object.terminalNoStart);
                if (object.terminalNoEnd != null)
                    message.terminalNoEnd = String(object.terminalNoEnd);
                if (object.specificStore != null)
                    message.specificStore = String(object.specificStore);
                if (object.hide != null)
                    message.hide = object.hide | 0;
                return message;
            };

            /**
             * Creates a plain object from a ScheduleReportReimbursementQuery message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery} message ScheduleReportReimbursementQuery
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ScheduleReportReimbursementQuery.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.storeList = [];
                if (options.defaults) {
                    object.tidNumber = "";
                    object.authCode = "";
                    object.cardNo = "";
                    object.cardType = "";
                    object.type = 0;
                    object.flag = 0;
                    object.orderNo = "";
                    object.dateType = 0;
                    object.dateStart = "";
                    object.dateEnd = "";
                    object.terminalNoStart = "";
                    object.terminalNoEnd = "";
                    object.specificStore = "";
                    object.hide = 0;
                }
                if (message.storeList && message.storeList.length) {
                    object.storeList = [];
                    for (var j = 0; j < message.storeList.length; ++j)
                        object.storeList[j] = message.storeList[j];
                }
                if (message.tidNumber != null && message.hasOwnProperty("tidNumber"))
                    object.tidNumber = message.tidNumber;
                if (message.authCode != null && message.hasOwnProperty("authCode"))
                    object.authCode = message.authCode;
                if (message.cardNo != null && message.hasOwnProperty("cardNo"))
                    object.cardNo = message.cardNo;
                if (message.cardType != null && message.hasOwnProperty("cardType"))
                    object.cardType = message.cardType;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.flag != null && message.hasOwnProperty("flag"))
                    object.flag = message.flag;
                if (message.orderNo != null && message.hasOwnProperty("orderNo"))
                    object.orderNo = message.orderNo;
                if (message.dateType != null && message.hasOwnProperty("dateType"))
                    object.dateType = message.dateType;
                if (message.dateStart != null && message.hasOwnProperty("dateStart"))
                    object.dateStart = message.dateStart;
                if (message.dateEnd != null && message.hasOwnProperty("dateEnd"))
                    object.dateEnd = message.dateEnd;
                if (message.terminalNoStart != null && message.hasOwnProperty("terminalNoStart"))
                    object.terminalNoStart = message.terminalNoStart;
                if (message.terminalNoEnd != null && message.hasOwnProperty("terminalNoEnd"))
                    object.terminalNoEnd = message.terminalNoEnd;
                if (message.specificStore != null && message.hasOwnProperty("specificStore"))
                    object.specificStore = message.specificStore;
                if (message.hide != null && message.hasOwnProperty("hide"))
                    object.hide = message.hide;
                return object;
            };

            /**
             * Converts this ScheduleReportReimbursementQuery to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuery
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ScheduleReportReimbursementQuery.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ScheduleReportReimbursementQuery;
        })();

        Protobuf.ScheduleReportAppropriationQuery = (function() {

            /**
             * Properties of a ScheduleReportAppropriationQuery.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IScheduleReportAppropriationQuery
             * @property {Array.<string>|null} [storeList] ScheduleReportAppropriationQuery storeList
             * @property {string|null} [tidNumber] ScheduleReportAppropriationQuery tidNumber
             * @property {string|null} [authCode] ScheduleReportAppropriationQuery authCode
             * @property {string|null} [cardNo] ScheduleReportAppropriationQuery cardNo
             * @property {string|null} [cardType] ScheduleReportAppropriationQuery cardType
             * @property {number|null} [type] ScheduleReportAppropriationQuery type
             * @property {number|null} [flag] ScheduleReportAppropriationQuery flag
             * @property {string|null} [orderNo] ScheduleReportAppropriationQuery orderNo
             * @property {number|null} [dateType] ScheduleReportAppropriationQuery dateType
             * @property {string|null} [dateStart] ScheduleReportAppropriationQuery dateStart
             * @property {string|null} [dateEnd] ScheduleReportAppropriationQuery dateEnd
             * @property {string|null} [terminalNoStart] ScheduleReportAppropriationQuery terminalNoStart
             * @property {string|null} [terminalNoEnd] ScheduleReportAppropriationQuery terminalNoEnd
             * @property {string|null} [specificStore] ScheduleReportAppropriationQuery specificStore
             * @property {number|null} [hide] ScheduleReportAppropriationQuery hide
             */

            /**
             * Constructs a new ScheduleReportAppropriationQuery.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a ScheduleReportAppropriationQuery.
             * @implements IScheduleReportAppropriationQuery
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IScheduleReportAppropriationQuery=} [properties] Properties to set
             */
            function ScheduleReportAppropriationQuery(properties) {
                this.storeList = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ScheduleReportAppropriationQuery storeList.
             * @member {Array.<string>} storeList
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery
             * @instance
             */
            ScheduleReportAppropriationQuery.prototype.storeList = $util.emptyArray;

            /**
             * ScheduleReportAppropriationQuery tidNumber.
             * @member {string} tidNumber
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery
             * @instance
             */
            ScheduleReportAppropriationQuery.prototype.tidNumber = "";

            /**
             * ScheduleReportAppropriationQuery authCode.
             * @member {string} authCode
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery
             * @instance
             */
            ScheduleReportAppropriationQuery.prototype.authCode = "";

            /**
             * ScheduleReportAppropriationQuery cardNo.
             * @member {string} cardNo
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery
             * @instance
             */
            ScheduleReportAppropriationQuery.prototype.cardNo = "";

            /**
             * ScheduleReportAppropriationQuery cardType.
             * @member {string} cardType
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery
             * @instance
             */
            ScheduleReportAppropriationQuery.prototype.cardType = "";

            /**
             * ScheduleReportAppropriationQuery type.
             * @member {number} type
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery
             * @instance
             */
            ScheduleReportAppropriationQuery.prototype.type = 0;

            /**
             * ScheduleReportAppropriationQuery flag.
             * @member {number} flag
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery
             * @instance
             */
            ScheduleReportAppropriationQuery.prototype.flag = 0;

            /**
             * ScheduleReportAppropriationQuery orderNo.
             * @member {string} orderNo
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery
             * @instance
             */
            ScheduleReportAppropriationQuery.prototype.orderNo = "";

            /**
             * ScheduleReportAppropriationQuery dateType.
             * @member {number} dateType
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery
             * @instance
             */
            ScheduleReportAppropriationQuery.prototype.dateType = 0;

            /**
             * ScheduleReportAppropriationQuery dateStart.
             * @member {string} dateStart
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery
             * @instance
             */
            ScheduleReportAppropriationQuery.prototype.dateStart = "";

            /**
             * ScheduleReportAppropriationQuery dateEnd.
             * @member {string} dateEnd
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery
             * @instance
             */
            ScheduleReportAppropriationQuery.prototype.dateEnd = "";

            /**
             * ScheduleReportAppropriationQuery terminalNoStart.
             * @member {string} terminalNoStart
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery
             * @instance
             */
            ScheduleReportAppropriationQuery.prototype.terminalNoStart = "";

            /**
             * ScheduleReportAppropriationQuery terminalNoEnd.
             * @member {string} terminalNoEnd
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery
             * @instance
             */
            ScheduleReportAppropriationQuery.prototype.terminalNoEnd = "";

            /**
             * ScheduleReportAppropriationQuery specificStore.
             * @member {string} specificStore
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery
             * @instance
             */
            ScheduleReportAppropriationQuery.prototype.specificStore = "";

            /**
             * ScheduleReportAppropriationQuery hide.
             * @member {number} hide
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery
             * @instance
             */
            ScheduleReportAppropriationQuery.prototype.hide = 0;

            /**
             * Creates a new ScheduleReportAppropriationQuery instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.IScheduleReportAppropriationQuery=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery} ScheduleReportAppropriationQuery instance
             */
            ScheduleReportAppropriationQuery.create = function create(properties) {
                return new ScheduleReportAppropriationQuery(properties);
            };

            /**
             * Encodes the specified ScheduleReportAppropriationQuery message. Does not implicitly {@link TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.IScheduleReportAppropriationQuery} message ScheduleReportAppropriationQuery message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ScheduleReportAppropriationQuery.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.storeList != null && message.storeList.length)
                    for (var i = 0; i < message.storeList.length; ++i)
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.storeList[i]);
                if (message.tidNumber != null && Object.hasOwnProperty.call(message, "tidNumber"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.tidNumber);
                if (message.authCode != null && Object.hasOwnProperty.call(message, "authCode"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.authCode);
                if (message.cardNo != null && Object.hasOwnProperty.call(message, "cardNo"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.cardNo);
                if (message.cardType != null && Object.hasOwnProperty.call(message, "cardType"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.cardType);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int32(message.type);
                if (message.flag != null && Object.hasOwnProperty.call(message, "flag"))
                    writer.uint32(/* id 7, wireType 0 =*/56).int32(message.flag);
                if (message.orderNo != null && Object.hasOwnProperty.call(message, "orderNo"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.orderNo);
                if (message.dateType != null && Object.hasOwnProperty.call(message, "dateType"))
                    writer.uint32(/* id 9, wireType 0 =*/72).int32(message.dateType);
                if (message.dateStart != null && Object.hasOwnProperty.call(message, "dateStart"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.dateStart);
                if (message.dateEnd != null && Object.hasOwnProperty.call(message, "dateEnd"))
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.dateEnd);
                if (message.terminalNoStart != null && Object.hasOwnProperty.call(message, "terminalNoStart"))
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.terminalNoStart);
                if (message.terminalNoEnd != null && Object.hasOwnProperty.call(message, "terminalNoEnd"))
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.terminalNoEnd);
                if (message.specificStore != null && Object.hasOwnProperty.call(message, "specificStore"))
                    writer.uint32(/* id 14, wireType 2 =*/114).string(message.specificStore);
                if (message.hide != null && Object.hasOwnProperty.call(message, "hide"))
                    writer.uint32(/* id 15, wireType 0 =*/120).int32(message.hide);
                return writer;
            };

            /**
             * Encodes the specified ScheduleReportAppropriationQuery message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.IScheduleReportAppropriationQuery} message ScheduleReportAppropriationQuery message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ScheduleReportAppropriationQuery.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ScheduleReportAppropriationQuery message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery} ScheduleReportAppropriationQuery
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ScheduleReportAppropriationQuery.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.storeList && message.storeList.length))
                            message.storeList = [];
                        message.storeList.push(reader.string());
                        break;
                    case 2:
                        message.tidNumber = reader.string();
                        break;
                    case 3:
                        message.authCode = reader.string();
                        break;
                    case 4:
                        message.cardNo = reader.string();
                        break;
                    case 5:
                        message.cardType = reader.string();
                        break;
                    case 6:
                        message.type = reader.int32();
                        break;
                    case 7:
                        message.flag = reader.int32();
                        break;
                    case 8:
                        message.orderNo = reader.string();
                        break;
                    case 9:
                        message.dateType = reader.int32();
                        break;
                    case 10:
                        message.dateStart = reader.string();
                        break;
                    case 11:
                        message.dateEnd = reader.string();
                        break;
                    case 12:
                        message.terminalNoStart = reader.string();
                        break;
                    case 13:
                        message.terminalNoEnd = reader.string();
                        break;
                    case 14:
                        message.specificStore = reader.string();
                        break;
                    case 15:
                        message.hide = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ScheduleReportAppropriationQuery message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery} ScheduleReportAppropriationQuery
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ScheduleReportAppropriationQuery.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ScheduleReportAppropriationQuery message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ScheduleReportAppropriationQuery.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.storeList != null && message.hasOwnProperty("storeList")) {
                    if (!Array.isArray(message.storeList))
                        return "storeList: array expected";
                    for (var i = 0; i < message.storeList.length; ++i)
                        if (!$util.isString(message.storeList[i]))
                            return "storeList: string[] expected";
                }
                if (message.tidNumber != null && message.hasOwnProperty("tidNumber"))
                    if (!$util.isString(message.tidNumber))
                        return "tidNumber: string expected";
                if (message.authCode != null && message.hasOwnProperty("authCode"))
                    if (!$util.isString(message.authCode))
                        return "authCode: string expected";
                if (message.cardNo != null && message.hasOwnProperty("cardNo"))
                    if (!$util.isString(message.cardNo))
                        return "cardNo: string expected";
                if (message.cardType != null && message.hasOwnProperty("cardType"))
                    if (!$util.isString(message.cardType))
                        return "cardType: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isInteger(message.type))
                        return "type: integer expected";
                if (message.flag != null && message.hasOwnProperty("flag"))
                    if (!$util.isInteger(message.flag))
                        return "flag: integer expected";
                if (message.orderNo != null && message.hasOwnProperty("orderNo"))
                    if (!$util.isString(message.orderNo))
                        return "orderNo: string expected";
                if (message.dateType != null && message.hasOwnProperty("dateType"))
                    if (!$util.isInteger(message.dateType))
                        return "dateType: integer expected";
                if (message.dateStart != null && message.hasOwnProperty("dateStart"))
                    if (!$util.isString(message.dateStart))
                        return "dateStart: string expected";
                if (message.dateEnd != null && message.hasOwnProperty("dateEnd"))
                    if (!$util.isString(message.dateEnd))
                        return "dateEnd: string expected";
                if (message.terminalNoStart != null && message.hasOwnProperty("terminalNoStart"))
                    if (!$util.isString(message.terminalNoStart))
                        return "terminalNoStart: string expected";
                if (message.terminalNoEnd != null && message.hasOwnProperty("terminalNoEnd"))
                    if (!$util.isString(message.terminalNoEnd))
                        return "terminalNoEnd: string expected";
                if (message.specificStore != null && message.hasOwnProperty("specificStore"))
                    if (!$util.isString(message.specificStore))
                        return "specificStore: string expected";
                if (message.hide != null && message.hasOwnProperty("hide"))
                    if (!$util.isInteger(message.hide))
                        return "hide: integer expected";
                return null;
            };

            /**
             * Creates a ScheduleReportAppropriationQuery message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery} ScheduleReportAppropriationQuery
             */
            ScheduleReportAppropriationQuery.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery();
                if (object.storeList) {
                    if (!Array.isArray(object.storeList))
                        throw TypeError(".TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery.storeList: array expected");
                    message.storeList = [];
                    for (var i = 0; i < object.storeList.length; ++i)
                        message.storeList[i] = String(object.storeList[i]);
                }
                if (object.tidNumber != null)
                    message.tidNumber = String(object.tidNumber);
                if (object.authCode != null)
                    message.authCode = String(object.authCode);
                if (object.cardNo != null)
                    message.cardNo = String(object.cardNo);
                if (object.cardType != null)
                    message.cardType = String(object.cardType);
                if (object.type != null)
                    message.type = object.type | 0;
                if (object.flag != null)
                    message.flag = object.flag | 0;
                if (object.orderNo != null)
                    message.orderNo = String(object.orderNo);
                if (object.dateType != null)
                    message.dateType = object.dateType | 0;
                if (object.dateStart != null)
                    message.dateStart = String(object.dateStart);
                if (object.dateEnd != null)
                    message.dateEnd = String(object.dateEnd);
                if (object.terminalNoStart != null)
                    message.terminalNoStart = String(object.terminalNoStart);
                if (object.terminalNoEnd != null)
                    message.terminalNoEnd = String(object.terminalNoEnd);
                if (object.specificStore != null)
                    message.specificStore = String(object.specificStore);
                if (object.hide != null)
                    message.hide = object.hide | 0;
                return message;
            };

            /**
             * Creates a plain object from a ScheduleReportAppropriationQuery message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery} message ScheduleReportAppropriationQuery
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ScheduleReportAppropriationQuery.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.storeList = [];
                if (options.defaults) {
                    object.tidNumber = "";
                    object.authCode = "";
                    object.cardNo = "";
                    object.cardType = "";
                    object.type = 0;
                    object.flag = 0;
                    object.orderNo = "";
                    object.dateType = 0;
                    object.dateStart = "";
                    object.dateEnd = "";
                    object.terminalNoStart = "";
                    object.terminalNoEnd = "";
                    object.specificStore = "";
                    object.hide = 0;
                }
                if (message.storeList && message.storeList.length) {
                    object.storeList = [];
                    for (var j = 0; j < message.storeList.length; ++j)
                        object.storeList[j] = message.storeList[j];
                }
                if (message.tidNumber != null && message.hasOwnProperty("tidNumber"))
                    object.tidNumber = message.tidNumber;
                if (message.authCode != null && message.hasOwnProperty("authCode"))
                    object.authCode = message.authCode;
                if (message.cardNo != null && message.hasOwnProperty("cardNo"))
                    object.cardNo = message.cardNo;
                if (message.cardType != null && message.hasOwnProperty("cardType"))
                    object.cardType = message.cardType;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.flag != null && message.hasOwnProperty("flag"))
                    object.flag = message.flag;
                if (message.orderNo != null && message.hasOwnProperty("orderNo"))
                    object.orderNo = message.orderNo;
                if (message.dateType != null && message.hasOwnProperty("dateType"))
                    object.dateType = message.dateType;
                if (message.dateStart != null && message.hasOwnProperty("dateStart"))
                    object.dateStart = message.dateStart;
                if (message.dateEnd != null && message.hasOwnProperty("dateEnd"))
                    object.dateEnd = message.dateEnd;
                if (message.terminalNoStart != null && message.hasOwnProperty("terminalNoStart"))
                    object.terminalNoStart = message.terminalNoStart;
                if (message.terminalNoEnd != null && message.hasOwnProperty("terminalNoEnd"))
                    object.terminalNoEnd = message.terminalNoEnd;
                if (message.specificStore != null && message.hasOwnProperty("specificStore"))
                    object.specificStore = message.specificStore;
                if (message.hide != null && message.hasOwnProperty("hide"))
                    object.hide = message.hide;
                return object;
            };

            /**
             * Converts this ScheduleReportAppropriationQuery to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuery
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ScheduleReportAppropriationQuery.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ScheduleReportAppropriationQuery;
        })();

        Protobuf.ScheduleReportReimbursementQuerySpecificStore = (function() {

            /**
             * Properties of a ScheduleReportReimbursementQuerySpecificStore.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IScheduleReportReimbursementQuerySpecificStore
             * @property {string|null} [specificStore] ScheduleReportReimbursementQuerySpecificStore specificStore
             * @property {string|null} [authCode] ScheduleReportReimbursementQuerySpecificStore authCode
             * @property {string|null} [cardNo] ScheduleReportReimbursementQuerySpecificStore cardNo
             * @property {string|null} [cardType] ScheduleReportReimbursementQuerySpecificStore cardType
             * @property {number|null} [type] ScheduleReportReimbursementQuerySpecificStore type
             * @property {number|null} [flag] ScheduleReportReimbursementQuerySpecificStore flag
             * @property {string|null} [orderNo] ScheduleReportReimbursementQuerySpecificStore orderNo
             * @property {number|null} [dateType] ScheduleReportReimbursementQuerySpecificStore dateType
             * @property {string|null} [terminalNoStart] ScheduleReportReimbursementQuerySpecificStore terminalNoStart
             * @property {string|null} [terminalNoEnd] ScheduleReportReimbursementQuerySpecificStore terminalNoEnd
             * @property {string|null} [submitDateStart] ScheduleReportReimbursementQuerySpecificStore submitDateStart
             * @property {string|null} [submitDateEnd] ScheduleReportReimbursementQuerySpecificStore submitDateEnd
             * @property {string|null} [dateStart] ScheduleReportReimbursementQuerySpecificStore dateStart
             * @property {string|null} [dateEnd] ScheduleReportReimbursementQuerySpecificStore dateEnd
             * @property {number|null} [hide] ScheduleReportReimbursementQuerySpecificStore hide
             */

            /**
             * Constructs a new ScheduleReportReimbursementQuerySpecificStore.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a ScheduleReportReimbursementQuerySpecificStore.
             * @implements IScheduleReportReimbursementQuerySpecificStore
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IScheduleReportReimbursementQuerySpecificStore=} [properties] Properties to set
             */
            function ScheduleReportReimbursementQuerySpecificStore(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ScheduleReportReimbursementQuerySpecificStore specificStore.
             * @member {string} specificStore
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore
             * @instance
             */
            ScheduleReportReimbursementQuerySpecificStore.prototype.specificStore = "";

            /**
             * ScheduleReportReimbursementQuerySpecificStore authCode.
             * @member {string} authCode
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore
             * @instance
             */
            ScheduleReportReimbursementQuerySpecificStore.prototype.authCode = "";

            /**
             * ScheduleReportReimbursementQuerySpecificStore cardNo.
             * @member {string} cardNo
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore
             * @instance
             */
            ScheduleReportReimbursementQuerySpecificStore.prototype.cardNo = "";

            /**
             * ScheduleReportReimbursementQuerySpecificStore cardType.
             * @member {string} cardType
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore
             * @instance
             */
            ScheduleReportReimbursementQuerySpecificStore.prototype.cardType = "";

            /**
             * ScheduleReportReimbursementQuerySpecificStore type.
             * @member {number} type
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore
             * @instance
             */
            ScheduleReportReimbursementQuerySpecificStore.prototype.type = 0;

            /**
             * ScheduleReportReimbursementQuerySpecificStore flag.
             * @member {number} flag
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore
             * @instance
             */
            ScheduleReportReimbursementQuerySpecificStore.prototype.flag = 0;

            /**
             * ScheduleReportReimbursementQuerySpecificStore orderNo.
             * @member {string} orderNo
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore
             * @instance
             */
            ScheduleReportReimbursementQuerySpecificStore.prototype.orderNo = "";

            /**
             * ScheduleReportReimbursementQuerySpecificStore dateType.
             * @member {number} dateType
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore
             * @instance
             */
            ScheduleReportReimbursementQuerySpecificStore.prototype.dateType = 0;

            /**
             * ScheduleReportReimbursementQuerySpecificStore terminalNoStart.
             * @member {string} terminalNoStart
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore
             * @instance
             */
            ScheduleReportReimbursementQuerySpecificStore.prototype.terminalNoStart = "";

            /**
             * ScheduleReportReimbursementQuerySpecificStore terminalNoEnd.
             * @member {string} terminalNoEnd
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore
             * @instance
             */
            ScheduleReportReimbursementQuerySpecificStore.prototype.terminalNoEnd = "";

            /**
             * ScheduleReportReimbursementQuerySpecificStore submitDateStart.
             * @member {string} submitDateStart
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore
             * @instance
             */
            ScheduleReportReimbursementQuerySpecificStore.prototype.submitDateStart = "";

            /**
             * ScheduleReportReimbursementQuerySpecificStore submitDateEnd.
             * @member {string} submitDateEnd
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore
             * @instance
             */
            ScheduleReportReimbursementQuerySpecificStore.prototype.submitDateEnd = "";

            /**
             * ScheduleReportReimbursementQuerySpecificStore dateStart.
             * @member {string} dateStart
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore
             * @instance
             */
            ScheduleReportReimbursementQuerySpecificStore.prototype.dateStart = "";

            /**
             * ScheduleReportReimbursementQuerySpecificStore dateEnd.
             * @member {string} dateEnd
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore
             * @instance
             */
            ScheduleReportReimbursementQuerySpecificStore.prototype.dateEnd = "";

            /**
             * ScheduleReportReimbursementQuerySpecificStore hide.
             * @member {number} hide
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore
             * @instance
             */
            ScheduleReportReimbursementQuerySpecificStore.prototype.hide = 0;

            /**
             * Creates a new ScheduleReportReimbursementQuerySpecificStore instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore
             * @static
             * @param {TCBReceiptApi.Protobuf.IScheduleReportReimbursementQuerySpecificStore=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore} ScheduleReportReimbursementQuerySpecificStore instance
             */
            ScheduleReportReimbursementQuerySpecificStore.create = function create(properties) {
                return new ScheduleReportReimbursementQuerySpecificStore(properties);
            };

            /**
             * Encodes the specified ScheduleReportReimbursementQuerySpecificStore message. Does not implicitly {@link TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore
             * @static
             * @param {TCBReceiptApi.Protobuf.IScheduleReportReimbursementQuerySpecificStore} message ScheduleReportReimbursementQuerySpecificStore message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ScheduleReportReimbursementQuerySpecificStore.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.specificStore != null && Object.hasOwnProperty.call(message, "specificStore"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.specificStore);
                if (message.authCode != null && Object.hasOwnProperty.call(message, "authCode"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.authCode);
                if (message.cardNo != null && Object.hasOwnProperty.call(message, "cardNo"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.cardNo);
                if (message.cardType != null && Object.hasOwnProperty.call(message, "cardType"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.cardType);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int32(message.type);
                if (message.flag != null && Object.hasOwnProperty.call(message, "flag"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int32(message.flag);
                if (message.orderNo != null && Object.hasOwnProperty.call(message, "orderNo"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.orderNo);
                if (message.dateType != null && Object.hasOwnProperty.call(message, "dateType"))
                    writer.uint32(/* id 8, wireType 0 =*/64).int32(message.dateType);
                if (message.terminalNoStart != null && Object.hasOwnProperty.call(message, "terminalNoStart"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.terminalNoStart);
                if (message.terminalNoEnd != null && Object.hasOwnProperty.call(message, "terminalNoEnd"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.terminalNoEnd);
                if (message.submitDateStart != null && Object.hasOwnProperty.call(message, "submitDateStart"))
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.submitDateStart);
                if (message.submitDateEnd != null && Object.hasOwnProperty.call(message, "submitDateEnd"))
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.submitDateEnd);
                if (message.dateStart != null && Object.hasOwnProperty.call(message, "dateStart"))
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.dateStart);
                if (message.dateEnd != null && Object.hasOwnProperty.call(message, "dateEnd"))
                    writer.uint32(/* id 14, wireType 2 =*/114).string(message.dateEnd);
                if (message.hide != null && Object.hasOwnProperty.call(message, "hide"))
                    writer.uint32(/* id 15, wireType 0 =*/120).int32(message.hide);
                return writer;
            };

            /**
             * Encodes the specified ScheduleReportReimbursementQuerySpecificStore message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore
             * @static
             * @param {TCBReceiptApi.Protobuf.IScheduleReportReimbursementQuerySpecificStore} message ScheduleReportReimbursementQuerySpecificStore message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ScheduleReportReimbursementQuerySpecificStore.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ScheduleReportReimbursementQuerySpecificStore message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore} ScheduleReportReimbursementQuerySpecificStore
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ScheduleReportReimbursementQuerySpecificStore.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.specificStore = reader.string();
                        break;
                    case 2:
                        message.authCode = reader.string();
                        break;
                    case 3:
                        message.cardNo = reader.string();
                        break;
                    case 4:
                        message.cardType = reader.string();
                        break;
                    case 5:
                        message.type = reader.int32();
                        break;
                    case 6:
                        message.flag = reader.int32();
                        break;
                    case 7:
                        message.orderNo = reader.string();
                        break;
                    case 8:
                        message.dateType = reader.int32();
                        break;
                    case 9:
                        message.terminalNoStart = reader.string();
                        break;
                    case 10:
                        message.terminalNoEnd = reader.string();
                        break;
                    case 11:
                        message.submitDateStart = reader.string();
                        break;
                    case 12:
                        message.submitDateEnd = reader.string();
                        break;
                    case 13:
                        message.dateStart = reader.string();
                        break;
                    case 14:
                        message.dateEnd = reader.string();
                        break;
                    case 15:
                        message.hide = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ScheduleReportReimbursementQuerySpecificStore message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore} ScheduleReportReimbursementQuerySpecificStore
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ScheduleReportReimbursementQuerySpecificStore.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ScheduleReportReimbursementQuerySpecificStore message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ScheduleReportReimbursementQuerySpecificStore.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.specificStore != null && message.hasOwnProperty("specificStore"))
                    if (!$util.isString(message.specificStore))
                        return "specificStore: string expected";
                if (message.authCode != null && message.hasOwnProperty("authCode"))
                    if (!$util.isString(message.authCode))
                        return "authCode: string expected";
                if (message.cardNo != null && message.hasOwnProperty("cardNo"))
                    if (!$util.isString(message.cardNo))
                        return "cardNo: string expected";
                if (message.cardType != null && message.hasOwnProperty("cardType"))
                    if (!$util.isString(message.cardType))
                        return "cardType: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isInteger(message.type))
                        return "type: integer expected";
                if (message.flag != null && message.hasOwnProperty("flag"))
                    if (!$util.isInteger(message.flag))
                        return "flag: integer expected";
                if (message.orderNo != null && message.hasOwnProperty("orderNo"))
                    if (!$util.isString(message.orderNo))
                        return "orderNo: string expected";
                if (message.dateType != null && message.hasOwnProperty("dateType"))
                    if (!$util.isInteger(message.dateType))
                        return "dateType: integer expected";
                if (message.terminalNoStart != null && message.hasOwnProperty("terminalNoStart"))
                    if (!$util.isString(message.terminalNoStart))
                        return "terminalNoStart: string expected";
                if (message.terminalNoEnd != null && message.hasOwnProperty("terminalNoEnd"))
                    if (!$util.isString(message.terminalNoEnd))
                        return "terminalNoEnd: string expected";
                if (message.submitDateStart != null && message.hasOwnProperty("submitDateStart"))
                    if (!$util.isString(message.submitDateStart))
                        return "submitDateStart: string expected";
                if (message.submitDateEnd != null && message.hasOwnProperty("submitDateEnd"))
                    if (!$util.isString(message.submitDateEnd))
                        return "submitDateEnd: string expected";
                if (message.dateStart != null && message.hasOwnProperty("dateStart"))
                    if (!$util.isString(message.dateStart))
                        return "dateStart: string expected";
                if (message.dateEnd != null && message.hasOwnProperty("dateEnd"))
                    if (!$util.isString(message.dateEnd))
                        return "dateEnd: string expected";
                if (message.hide != null && message.hasOwnProperty("hide"))
                    if (!$util.isInteger(message.hide))
                        return "hide: integer expected";
                return null;
            };

            /**
             * Creates a ScheduleReportReimbursementQuerySpecificStore message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore} ScheduleReportReimbursementQuerySpecificStore
             */
            ScheduleReportReimbursementQuerySpecificStore.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore();
                if (object.specificStore != null)
                    message.specificStore = String(object.specificStore);
                if (object.authCode != null)
                    message.authCode = String(object.authCode);
                if (object.cardNo != null)
                    message.cardNo = String(object.cardNo);
                if (object.cardType != null)
                    message.cardType = String(object.cardType);
                if (object.type != null)
                    message.type = object.type | 0;
                if (object.flag != null)
                    message.flag = object.flag | 0;
                if (object.orderNo != null)
                    message.orderNo = String(object.orderNo);
                if (object.dateType != null)
                    message.dateType = object.dateType | 0;
                if (object.terminalNoStart != null)
                    message.terminalNoStart = String(object.terminalNoStart);
                if (object.terminalNoEnd != null)
                    message.terminalNoEnd = String(object.terminalNoEnd);
                if (object.submitDateStart != null)
                    message.submitDateStart = String(object.submitDateStart);
                if (object.submitDateEnd != null)
                    message.submitDateEnd = String(object.submitDateEnd);
                if (object.dateStart != null)
                    message.dateStart = String(object.dateStart);
                if (object.dateEnd != null)
                    message.dateEnd = String(object.dateEnd);
                if (object.hide != null)
                    message.hide = object.hide | 0;
                return message;
            };

            /**
             * Creates a plain object from a ScheduleReportReimbursementQuerySpecificStore message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore
             * @static
             * @param {TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore} message ScheduleReportReimbursementQuerySpecificStore
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ScheduleReportReimbursementQuerySpecificStore.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.specificStore = "";
                    object.authCode = "";
                    object.cardNo = "";
                    object.cardType = "";
                    object.type = 0;
                    object.flag = 0;
                    object.orderNo = "";
                    object.dateType = 0;
                    object.terminalNoStart = "";
                    object.terminalNoEnd = "";
                    object.submitDateStart = "";
                    object.submitDateEnd = "";
                    object.dateStart = "";
                    object.dateEnd = "";
                    object.hide = 0;
                }
                if (message.specificStore != null && message.hasOwnProperty("specificStore"))
                    object.specificStore = message.specificStore;
                if (message.authCode != null && message.hasOwnProperty("authCode"))
                    object.authCode = message.authCode;
                if (message.cardNo != null && message.hasOwnProperty("cardNo"))
                    object.cardNo = message.cardNo;
                if (message.cardType != null && message.hasOwnProperty("cardType"))
                    object.cardType = message.cardType;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.flag != null && message.hasOwnProperty("flag"))
                    object.flag = message.flag;
                if (message.orderNo != null && message.hasOwnProperty("orderNo"))
                    object.orderNo = message.orderNo;
                if (message.dateType != null && message.hasOwnProperty("dateType"))
                    object.dateType = message.dateType;
                if (message.terminalNoStart != null && message.hasOwnProperty("terminalNoStart"))
                    object.terminalNoStart = message.terminalNoStart;
                if (message.terminalNoEnd != null && message.hasOwnProperty("terminalNoEnd"))
                    object.terminalNoEnd = message.terminalNoEnd;
                if (message.submitDateStart != null && message.hasOwnProperty("submitDateStart"))
                    object.submitDateStart = message.submitDateStart;
                if (message.submitDateEnd != null && message.hasOwnProperty("submitDateEnd"))
                    object.submitDateEnd = message.submitDateEnd;
                if (message.dateStart != null && message.hasOwnProperty("dateStart"))
                    object.dateStart = message.dateStart;
                if (message.dateEnd != null && message.hasOwnProperty("dateEnd"))
                    object.dateEnd = message.dateEnd;
                if (message.hide != null && message.hasOwnProperty("hide"))
                    object.hide = message.hide;
                return object;
            };

            /**
             * Converts this ScheduleReportReimbursementQuerySpecificStore to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportReimbursementQuerySpecificStore
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ScheduleReportReimbursementQuerySpecificStore.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ScheduleReportReimbursementQuerySpecificStore;
        })();

        Protobuf.ScheduleReportAppropriationQuerySpecificStore = (function() {

            /**
             * Properties of a ScheduleReportAppropriationQuerySpecificStore.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IScheduleReportAppropriationQuerySpecificStore
             * @property {string|null} [specificStore] ScheduleReportAppropriationQuerySpecificStore specificStore
             * @property {string|null} [authCode] ScheduleReportAppropriationQuerySpecificStore authCode
             * @property {string|null} [cardNo] ScheduleReportAppropriationQuerySpecificStore cardNo
             * @property {string|null} [cardType] ScheduleReportAppropriationQuerySpecificStore cardType
             * @property {number|null} [type] ScheduleReportAppropriationQuerySpecificStore type
             * @property {number|null} [flag] ScheduleReportAppropriationQuerySpecificStore flag
             * @property {string|null} [orderNo] ScheduleReportAppropriationQuerySpecificStore orderNo
             * @property {string|null} [terminalNoStart] ScheduleReportAppropriationQuerySpecificStore terminalNoStart
             * @property {string|null} [terminalNoEnd] ScheduleReportAppropriationQuerySpecificStore terminalNoEnd
             * @property {string|null} [submitDateStart] ScheduleReportAppropriationQuerySpecificStore submitDateStart
             * @property {string|null} [submitDateEnd] ScheduleReportAppropriationQuerySpecificStore submitDateEnd
             * @property {string|null} [transDateStart] ScheduleReportAppropriationQuerySpecificStore transDateStart
             * @property {string|null} [transDateEnd] ScheduleReportAppropriationQuerySpecificStore transDateEnd
             * @property {string|null} [dateStart] ScheduleReportAppropriationQuerySpecificStore dateStart
             * @property {string|null} [dateEnd] ScheduleReportAppropriationQuerySpecificStore dateEnd
             * @property {number|null} [hide] ScheduleReportAppropriationQuerySpecificStore hide
             */

            /**
             * Constructs a new ScheduleReportAppropriationQuerySpecificStore.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a ScheduleReportAppropriationQuerySpecificStore.
             * @implements IScheduleReportAppropriationQuerySpecificStore
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IScheduleReportAppropriationQuerySpecificStore=} [properties] Properties to set
             */
            function ScheduleReportAppropriationQuerySpecificStore(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ScheduleReportAppropriationQuerySpecificStore specificStore.
             * @member {string} specificStore
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore
             * @instance
             */
            ScheduleReportAppropriationQuerySpecificStore.prototype.specificStore = "";

            /**
             * ScheduleReportAppropriationQuerySpecificStore authCode.
             * @member {string} authCode
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore
             * @instance
             */
            ScheduleReportAppropriationQuerySpecificStore.prototype.authCode = "";

            /**
             * ScheduleReportAppropriationQuerySpecificStore cardNo.
             * @member {string} cardNo
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore
             * @instance
             */
            ScheduleReportAppropriationQuerySpecificStore.prototype.cardNo = "";

            /**
             * ScheduleReportAppropriationQuerySpecificStore cardType.
             * @member {string} cardType
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore
             * @instance
             */
            ScheduleReportAppropriationQuerySpecificStore.prototype.cardType = "";

            /**
             * ScheduleReportAppropriationQuerySpecificStore type.
             * @member {number} type
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore
             * @instance
             */
            ScheduleReportAppropriationQuerySpecificStore.prototype.type = 0;

            /**
             * ScheduleReportAppropriationQuerySpecificStore flag.
             * @member {number} flag
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore
             * @instance
             */
            ScheduleReportAppropriationQuerySpecificStore.prototype.flag = 0;

            /**
             * ScheduleReportAppropriationQuerySpecificStore orderNo.
             * @member {string} orderNo
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore
             * @instance
             */
            ScheduleReportAppropriationQuerySpecificStore.prototype.orderNo = "";

            /**
             * ScheduleReportAppropriationQuerySpecificStore terminalNoStart.
             * @member {string} terminalNoStart
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore
             * @instance
             */
            ScheduleReportAppropriationQuerySpecificStore.prototype.terminalNoStart = "";

            /**
             * ScheduleReportAppropriationQuerySpecificStore terminalNoEnd.
             * @member {string} terminalNoEnd
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore
             * @instance
             */
            ScheduleReportAppropriationQuerySpecificStore.prototype.terminalNoEnd = "";

            /**
             * ScheduleReportAppropriationQuerySpecificStore submitDateStart.
             * @member {string} submitDateStart
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore
             * @instance
             */
            ScheduleReportAppropriationQuerySpecificStore.prototype.submitDateStart = "";

            /**
             * ScheduleReportAppropriationQuerySpecificStore submitDateEnd.
             * @member {string} submitDateEnd
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore
             * @instance
             */
            ScheduleReportAppropriationQuerySpecificStore.prototype.submitDateEnd = "";

            /**
             * ScheduleReportAppropriationQuerySpecificStore transDateStart.
             * @member {string} transDateStart
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore
             * @instance
             */
            ScheduleReportAppropriationQuerySpecificStore.prototype.transDateStart = "";

            /**
             * ScheduleReportAppropriationQuerySpecificStore transDateEnd.
             * @member {string} transDateEnd
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore
             * @instance
             */
            ScheduleReportAppropriationQuerySpecificStore.prototype.transDateEnd = "";

            /**
             * ScheduleReportAppropriationQuerySpecificStore dateStart.
             * @member {string} dateStart
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore
             * @instance
             */
            ScheduleReportAppropriationQuerySpecificStore.prototype.dateStart = "";

            /**
             * ScheduleReportAppropriationQuerySpecificStore dateEnd.
             * @member {string} dateEnd
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore
             * @instance
             */
            ScheduleReportAppropriationQuerySpecificStore.prototype.dateEnd = "";

            /**
             * ScheduleReportAppropriationQuerySpecificStore hide.
             * @member {number} hide
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore
             * @instance
             */
            ScheduleReportAppropriationQuerySpecificStore.prototype.hide = 0;

            /**
             * Creates a new ScheduleReportAppropriationQuerySpecificStore instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore
             * @static
             * @param {TCBReceiptApi.Protobuf.IScheduleReportAppropriationQuerySpecificStore=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore} ScheduleReportAppropriationQuerySpecificStore instance
             */
            ScheduleReportAppropriationQuerySpecificStore.create = function create(properties) {
                return new ScheduleReportAppropriationQuerySpecificStore(properties);
            };

            /**
             * Encodes the specified ScheduleReportAppropriationQuerySpecificStore message. Does not implicitly {@link TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore
             * @static
             * @param {TCBReceiptApi.Protobuf.IScheduleReportAppropriationQuerySpecificStore} message ScheduleReportAppropriationQuerySpecificStore message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ScheduleReportAppropriationQuerySpecificStore.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.specificStore != null && Object.hasOwnProperty.call(message, "specificStore"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.specificStore);
                if (message.authCode != null && Object.hasOwnProperty.call(message, "authCode"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.authCode);
                if (message.cardNo != null && Object.hasOwnProperty.call(message, "cardNo"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.cardNo);
                if (message.cardType != null && Object.hasOwnProperty.call(message, "cardType"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.cardType);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int32(message.type);
                if (message.flag != null && Object.hasOwnProperty.call(message, "flag"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int32(message.flag);
                if (message.orderNo != null && Object.hasOwnProperty.call(message, "orderNo"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.orderNo);
                if (message.terminalNoStart != null && Object.hasOwnProperty.call(message, "terminalNoStart"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.terminalNoStart);
                if (message.terminalNoEnd != null && Object.hasOwnProperty.call(message, "terminalNoEnd"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.terminalNoEnd);
                if (message.submitDateStart != null && Object.hasOwnProperty.call(message, "submitDateStart"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.submitDateStart);
                if (message.submitDateEnd != null && Object.hasOwnProperty.call(message, "submitDateEnd"))
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.submitDateEnd);
                if (message.transDateStart != null && Object.hasOwnProperty.call(message, "transDateStart"))
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.transDateStart);
                if (message.transDateEnd != null && Object.hasOwnProperty.call(message, "transDateEnd"))
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.transDateEnd);
                if (message.dateStart != null && Object.hasOwnProperty.call(message, "dateStart"))
                    writer.uint32(/* id 14, wireType 2 =*/114).string(message.dateStart);
                if (message.dateEnd != null && Object.hasOwnProperty.call(message, "dateEnd"))
                    writer.uint32(/* id 15, wireType 2 =*/122).string(message.dateEnd);
                if (message.hide != null && Object.hasOwnProperty.call(message, "hide"))
                    writer.uint32(/* id 16, wireType 0 =*/128).int32(message.hide);
                return writer;
            };

            /**
             * Encodes the specified ScheduleReportAppropriationQuerySpecificStore message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore
             * @static
             * @param {TCBReceiptApi.Protobuf.IScheduleReportAppropriationQuerySpecificStore} message ScheduleReportAppropriationQuerySpecificStore message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ScheduleReportAppropriationQuerySpecificStore.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ScheduleReportAppropriationQuerySpecificStore message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore} ScheduleReportAppropriationQuerySpecificStore
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ScheduleReportAppropriationQuerySpecificStore.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.specificStore = reader.string();
                        break;
                    case 2:
                        message.authCode = reader.string();
                        break;
                    case 3:
                        message.cardNo = reader.string();
                        break;
                    case 4:
                        message.cardType = reader.string();
                        break;
                    case 5:
                        message.type = reader.int32();
                        break;
                    case 6:
                        message.flag = reader.int32();
                        break;
                    case 7:
                        message.orderNo = reader.string();
                        break;
                    case 8:
                        message.terminalNoStart = reader.string();
                        break;
                    case 9:
                        message.terminalNoEnd = reader.string();
                        break;
                    case 10:
                        message.submitDateStart = reader.string();
                        break;
                    case 11:
                        message.submitDateEnd = reader.string();
                        break;
                    case 12:
                        message.transDateStart = reader.string();
                        break;
                    case 13:
                        message.transDateEnd = reader.string();
                        break;
                    case 14:
                        message.dateStart = reader.string();
                        break;
                    case 15:
                        message.dateEnd = reader.string();
                        break;
                    case 16:
                        message.hide = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ScheduleReportAppropriationQuerySpecificStore message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore} ScheduleReportAppropriationQuerySpecificStore
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ScheduleReportAppropriationQuerySpecificStore.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ScheduleReportAppropriationQuerySpecificStore message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ScheduleReportAppropriationQuerySpecificStore.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.specificStore != null && message.hasOwnProperty("specificStore"))
                    if (!$util.isString(message.specificStore))
                        return "specificStore: string expected";
                if (message.authCode != null && message.hasOwnProperty("authCode"))
                    if (!$util.isString(message.authCode))
                        return "authCode: string expected";
                if (message.cardNo != null && message.hasOwnProperty("cardNo"))
                    if (!$util.isString(message.cardNo))
                        return "cardNo: string expected";
                if (message.cardType != null && message.hasOwnProperty("cardType"))
                    if (!$util.isString(message.cardType))
                        return "cardType: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isInteger(message.type))
                        return "type: integer expected";
                if (message.flag != null && message.hasOwnProperty("flag"))
                    if (!$util.isInteger(message.flag))
                        return "flag: integer expected";
                if (message.orderNo != null && message.hasOwnProperty("orderNo"))
                    if (!$util.isString(message.orderNo))
                        return "orderNo: string expected";
                if (message.terminalNoStart != null && message.hasOwnProperty("terminalNoStart"))
                    if (!$util.isString(message.terminalNoStart))
                        return "terminalNoStart: string expected";
                if (message.terminalNoEnd != null && message.hasOwnProperty("terminalNoEnd"))
                    if (!$util.isString(message.terminalNoEnd))
                        return "terminalNoEnd: string expected";
                if (message.submitDateStart != null && message.hasOwnProperty("submitDateStart"))
                    if (!$util.isString(message.submitDateStart))
                        return "submitDateStart: string expected";
                if (message.submitDateEnd != null && message.hasOwnProperty("submitDateEnd"))
                    if (!$util.isString(message.submitDateEnd))
                        return "submitDateEnd: string expected";
                if (message.transDateStart != null && message.hasOwnProperty("transDateStart"))
                    if (!$util.isString(message.transDateStart))
                        return "transDateStart: string expected";
                if (message.transDateEnd != null && message.hasOwnProperty("transDateEnd"))
                    if (!$util.isString(message.transDateEnd))
                        return "transDateEnd: string expected";
                if (message.dateStart != null && message.hasOwnProperty("dateStart"))
                    if (!$util.isString(message.dateStart))
                        return "dateStart: string expected";
                if (message.dateEnd != null && message.hasOwnProperty("dateEnd"))
                    if (!$util.isString(message.dateEnd))
                        return "dateEnd: string expected";
                if (message.hide != null && message.hasOwnProperty("hide"))
                    if (!$util.isInteger(message.hide))
                        return "hide: integer expected";
                return null;
            };

            /**
             * Creates a ScheduleReportAppropriationQuerySpecificStore message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore} ScheduleReportAppropriationQuerySpecificStore
             */
            ScheduleReportAppropriationQuerySpecificStore.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore();
                if (object.specificStore != null)
                    message.specificStore = String(object.specificStore);
                if (object.authCode != null)
                    message.authCode = String(object.authCode);
                if (object.cardNo != null)
                    message.cardNo = String(object.cardNo);
                if (object.cardType != null)
                    message.cardType = String(object.cardType);
                if (object.type != null)
                    message.type = object.type | 0;
                if (object.flag != null)
                    message.flag = object.flag | 0;
                if (object.orderNo != null)
                    message.orderNo = String(object.orderNo);
                if (object.terminalNoStart != null)
                    message.terminalNoStart = String(object.terminalNoStart);
                if (object.terminalNoEnd != null)
                    message.terminalNoEnd = String(object.terminalNoEnd);
                if (object.submitDateStart != null)
                    message.submitDateStart = String(object.submitDateStart);
                if (object.submitDateEnd != null)
                    message.submitDateEnd = String(object.submitDateEnd);
                if (object.transDateStart != null)
                    message.transDateStart = String(object.transDateStart);
                if (object.transDateEnd != null)
                    message.transDateEnd = String(object.transDateEnd);
                if (object.dateStart != null)
                    message.dateStart = String(object.dateStart);
                if (object.dateEnd != null)
                    message.dateEnd = String(object.dateEnd);
                if (object.hide != null)
                    message.hide = object.hide | 0;
                return message;
            };

            /**
             * Creates a plain object from a ScheduleReportAppropriationQuerySpecificStore message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore
             * @static
             * @param {TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore} message ScheduleReportAppropriationQuerySpecificStore
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ScheduleReportAppropriationQuerySpecificStore.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.specificStore = "";
                    object.authCode = "";
                    object.cardNo = "";
                    object.cardType = "";
                    object.type = 0;
                    object.flag = 0;
                    object.orderNo = "";
                    object.terminalNoStart = "";
                    object.terminalNoEnd = "";
                    object.submitDateStart = "";
                    object.submitDateEnd = "";
                    object.transDateStart = "";
                    object.transDateEnd = "";
                    object.dateStart = "";
                    object.dateEnd = "";
                    object.hide = 0;
                }
                if (message.specificStore != null && message.hasOwnProperty("specificStore"))
                    object.specificStore = message.specificStore;
                if (message.authCode != null && message.hasOwnProperty("authCode"))
                    object.authCode = message.authCode;
                if (message.cardNo != null && message.hasOwnProperty("cardNo"))
                    object.cardNo = message.cardNo;
                if (message.cardType != null && message.hasOwnProperty("cardType"))
                    object.cardType = message.cardType;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.flag != null && message.hasOwnProperty("flag"))
                    object.flag = message.flag;
                if (message.orderNo != null && message.hasOwnProperty("orderNo"))
                    object.orderNo = message.orderNo;
                if (message.terminalNoStart != null && message.hasOwnProperty("terminalNoStart"))
                    object.terminalNoStart = message.terminalNoStart;
                if (message.terminalNoEnd != null && message.hasOwnProperty("terminalNoEnd"))
                    object.terminalNoEnd = message.terminalNoEnd;
                if (message.submitDateStart != null && message.hasOwnProperty("submitDateStart"))
                    object.submitDateStart = message.submitDateStart;
                if (message.submitDateEnd != null && message.hasOwnProperty("submitDateEnd"))
                    object.submitDateEnd = message.submitDateEnd;
                if (message.transDateStart != null && message.hasOwnProperty("transDateStart"))
                    object.transDateStart = message.transDateStart;
                if (message.transDateEnd != null && message.hasOwnProperty("transDateEnd"))
                    object.transDateEnd = message.transDateEnd;
                if (message.dateStart != null && message.hasOwnProperty("dateStart"))
                    object.dateStart = message.dateStart;
                if (message.dateEnd != null && message.hasOwnProperty("dateEnd"))
                    object.dateEnd = message.dateEnd;
                if (message.hide != null && message.hasOwnProperty("hide"))
                    object.hide = message.hide;
                return object;
            };

            /**
             * Converts this ScheduleReportAppropriationQuerySpecificStore to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.ScheduleReportAppropriationQuerySpecificStore
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ScheduleReportAppropriationQuerySpecificStore.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ScheduleReportAppropriationQuerySpecificStore;
        })();

        Protobuf.Store = (function() {

            /**
             * Properties of a Store.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IStore
             * @property {number|null} [storeTempId] Store storeTempId
             * @property {number|null} [storeId] Store storeId
             * @property {string|null} [code] Store code
             * @property {number|null} [isQuota] Store isQuota
             * @property {string|null} [tidNumber] Store tidNumber
             * @property {string|null} [type] Store type
             * @property {string|null} [typeDescription] Store typeDescription
             * @property {string|null} [headId] Store headId
             * @property {string|null} [headDescription] Store headDescription
             * @property {string|null} [registerName] Store registerName
             * @property {string|null} [engName] Store engName
             * @property {string|null} [signTitle] Store signTitle
             * @property {string|null} [nickName] Store nickName
             * @property {string|null} [mccCode] Store mccCode
             * @property {string|null} [mccDescription] Store mccDescription
             * @property {string|null} [guiNumber] Store guiNumber
             * @property {string|null} [registerPostalCode1] Store registerPostalCode1
             * @property {string|null} [registerPostalCode2] Store registerPostalCode2
             * @property {string|null} [registerAddress] Store registerAddress
             * @property {string|null} [businessPostalCode1] Store businessPostalCode1
             * @property {string|null} [businessPostalCode2] Store businessPostalCode2
             * @property {string|null} [businessAddress] Store businessAddress
             * @property {string|null} [bankCode] Store bankCode
             * @property {string|null} [bankName] Store bankName
             * @property {number|null} [isPaper] Store isPaper
             * @property {string|null} [receiptName] Store receiptName
             * @property {string|null} [receiptPostalCode1] Store receiptPostalCode1
             * @property {string|null} [receiptPostalCode2] Store receiptPostalCode2
             * @property {string|null} [receiptAddress] Store receiptAddress
             * @property {number|null} [receiptGenerateType] Store receiptGenerateType
             * @property {number|null} [receiptGenerateCycle] Store receiptGenerateCycle
             * @property {number|null} [receiptGenerateBasis] Store receiptGenerateBasis
             * @property {number|null} [smartPay] Store smartPay
             * @property {number|null} [commonQrCode] Store commonQrCode
             * @property {number|null} [vmjQrCode] Store vmjQrCode
             * @property {number|null} [cupQrCode] Store cupQrCode
             * @property {number|null} [naturalPerson] Store naturalPerson
             * @property {number|null} [organizationType] Store organizationType
             * @property {number|null} [state] Store state
             * @property {string|null} [cancelDate] Store cancelDate
             * @property {number|null} [lastUpdateTime] Store lastUpdateTime
             * @property {number|null} [lastUploadTime] Store lastUploadTime
             * @property {number|null} [releaseState] Store releaseState
             * @property {string|null} [rejectReason] Store rejectReason
             */

            /**
             * Constructs a new Store.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a Store.
             * @implements IStore
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IStore=} [properties] Properties to set
             */
            function Store(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Store storeTempId.
             * @member {number} storeTempId
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.storeTempId = 0;

            /**
             * Store storeId.
             * @member {number} storeId
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.storeId = 0;

            /**
             * Store code.
             * @member {string} code
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.code = "";

            /**
             * Store isQuota.
             * @member {number} isQuota
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.isQuota = 0;

            /**
             * Store tidNumber.
             * @member {string} tidNumber
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.tidNumber = "";

            /**
             * Store type.
             * @member {string} type
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.type = "";

            /**
             * Store typeDescription.
             * @member {string} typeDescription
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.typeDescription = "";

            /**
             * Store headId.
             * @member {string} headId
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.headId = "";

            /**
             * Store headDescription.
             * @member {string} headDescription
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.headDescription = "";

            /**
             * Store registerName.
             * @member {string} registerName
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.registerName = "";

            /**
             * Store engName.
             * @member {string} engName
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.engName = "";

            /**
             * Store signTitle.
             * @member {string} signTitle
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.signTitle = "";

            /**
             * Store nickName.
             * @member {string} nickName
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.nickName = "";

            /**
             * Store mccCode.
             * @member {string} mccCode
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.mccCode = "";

            /**
             * Store mccDescription.
             * @member {string} mccDescription
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.mccDescription = "";

            /**
             * Store guiNumber.
             * @member {string} guiNumber
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.guiNumber = "";

            /**
             * Store registerPostalCode1.
             * @member {string} registerPostalCode1
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.registerPostalCode1 = "";

            /**
             * Store registerPostalCode2.
             * @member {string} registerPostalCode2
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.registerPostalCode2 = "";

            /**
             * Store registerAddress.
             * @member {string} registerAddress
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.registerAddress = "";

            /**
             * Store businessPostalCode1.
             * @member {string} businessPostalCode1
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.businessPostalCode1 = "";

            /**
             * Store businessPostalCode2.
             * @member {string} businessPostalCode2
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.businessPostalCode2 = "";

            /**
             * Store businessAddress.
             * @member {string} businessAddress
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.businessAddress = "";

            /**
             * Store bankCode.
             * @member {string} bankCode
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.bankCode = "";

            /**
             * Store bankName.
             * @member {string} bankName
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.bankName = "";

            /**
             * Store isPaper.
             * @member {number} isPaper
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.isPaper = 0;

            /**
             * Store receiptName.
             * @member {string} receiptName
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.receiptName = "";

            /**
             * Store receiptPostalCode1.
             * @member {string} receiptPostalCode1
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.receiptPostalCode1 = "";

            /**
             * Store receiptPostalCode2.
             * @member {string} receiptPostalCode2
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.receiptPostalCode2 = "";

            /**
             * Store receiptAddress.
             * @member {string} receiptAddress
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.receiptAddress = "";

            /**
             * Store receiptGenerateType.
             * @member {number} receiptGenerateType
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.receiptGenerateType = 0;

            /**
             * Store receiptGenerateCycle.
             * @member {number} receiptGenerateCycle
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.receiptGenerateCycle = 0;

            /**
             * Store receiptGenerateBasis.
             * @member {number} receiptGenerateBasis
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.receiptGenerateBasis = 0;

            /**
             * Store smartPay.
             * @member {number} smartPay
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.smartPay = 0;

            /**
             * Store commonQrCode.
             * @member {number} commonQrCode
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.commonQrCode = 0;

            /**
             * Store vmjQrCode.
             * @member {number} vmjQrCode
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.vmjQrCode = 0;

            /**
             * Store cupQrCode.
             * @member {number} cupQrCode
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.cupQrCode = 0;

            /**
             * Store naturalPerson.
             * @member {number} naturalPerson
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.naturalPerson = 0;

            /**
             * Store organizationType.
             * @member {number} organizationType
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.organizationType = 0;

            /**
             * Store state.
             * @member {number} state
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.state = 0;

            /**
             * Store cancelDate.
             * @member {string} cancelDate
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.cancelDate = "";

            /**
             * Store lastUpdateTime.
             * @member {number} lastUpdateTime
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.lastUpdateTime = 0;

            /**
             * Store lastUploadTime.
             * @member {number} lastUploadTime
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.lastUploadTime = 0;

            /**
             * Store releaseState.
             * @member {number} releaseState
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.releaseState = 0;

            /**
             * Store rejectReason.
             * @member {string} rejectReason
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             */
            Store.prototype.rejectReason = "";

            /**
             * Creates a new Store instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.Store
             * @static
             * @param {TCBReceiptApi.Protobuf.IStore=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.Store} Store instance
             */
            Store.create = function create(properties) {
                return new Store(properties);
            };

            /**
             * Encodes the specified Store message. Does not implicitly {@link TCBReceiptApi.Protobuf.Store.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.Store
             * @static
             * @param {TCBReceiptApi.Protobuf.IStore} message Store message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Store.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.storeTempId != null && Object.hasOwnProperty.call(message, "storeTempId"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.storeTempId);
                if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.storeId);
                if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.code);
                if (message.isQuota != null && Object.hasOwnProperty.call(message, "isQuota"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.isQuota);
                if (message.tidNumber != null && Object.hasOwnProperty.call(message, "tidNumber"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.tidNumber);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.type);
                if (message.typeDescription != null && Object.hasOwnProperty.call(message, "typeDescription"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.typeDescription);
                if (message.headId != null && Object.hasOwnProperty.call(message, "headId"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.headId);
                if (message.headDescription != null && Object.hasOwnProperty.call(message, "headDescription"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.headDescription);
                if (message.registerName != null && Object.hasOwnProperty.call(message, "registerName"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.registerName);
                if (message.engName != null && Object.hasOwnProperty.call(message, "engName"))
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.engName);
                if (message.signTitle != null && Object.hasOwnProperty.call(message, "signTitle"))
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.signTitle);
                if (message.nickName != null && Object.hasOwnProperty.call(message, "nickName"))
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.nickName);
                if (message.mccCode != null && Object.hasOwnProperty.call(message, "mccCode"))
                    writer.uint32(/* id 14, wireType 2 =*/114).string(message.mccCode);
                if (message.mccDescription != null && Object.hasOwnProperty.call(message, "mccDescription"))
                    writer.uint32(/* id 15, wireType 2 =*/122).string(message.mccDescription);
                if (message.guiNumber != null && Object.hasOwnProperty.call(message, "guiNumber"))
                    writer.uint32(/* id 16, wireType 2 =*/130).string(message.guiNumber);
                if (message.registerPostalCode1 != null && Object.hasOwnProperty.call(message, "registerPostalCode1"))
                    writer.uint32(/* id 17, wireType 2 =*/138).string(message.registerPostalCode1);
                if (message.registerPostalCode2 != null && Object.hasOwnProperty.call(message, "registerPostalCode2"))
                    writer.uint32(/* id 18, wireType 2 =*/146).string(message.registerPostalCode2);
                if (message.registerAddress != null && Object.hasOwnProperty.call(message, "registerAddress"))
                    writer.uint32(/* id 19, wireType 2 =*/154).string(message.registerAddress);
                if (message.businessPostalCode1 != null && Object.hasOwnProperty.call(message, "businessPostalCode1"))
                    writer.uint32(/* id 20, wireType 2 =*/162).string(message.businessPostalCode1);
                if (message.businessPostalCode2 != null && Object.hasOwnProperty.call(message, "businessPostalCode2"))
                    writer.uint32(/* id 21, wireType 2 =*/170).string(message.businessPostalCode2);
                if (message.businessAddress != null && Object.hasOwnProperty.call(message, "businessAddress"))
                    writer.uint32(/* id 22, wireType 2 =*/178).string(message.businessAddress);
                if (message.bankCode != null && Object.hasOwnProperty.call(message, "bankCode"))
                    writer.uint32(/* id 23, wireType 2 =*/186).string(message.bankCode);
                if (message.bankName != null && Object.hasOwnProperty.call(message, "bankName"))
                    writer.uint32(/* id 24, wireType 2 =*/194).string(message.bankName);
                if (message.isPaper != null && Object.hasOwnProperty.call(message, "isPaper"))
                    writer.uint32(/* id 25, wireType 0 =*/200).int32(message.isPaper);
                if (message.receiptName != null && Object.hasOwnProperty.call(message, "receiptName"))
                    writer.uint32(/* id 26, wireType 2 =*/210).string(message.receiptName);
                if (message.receiptPostalCode1 != null && Object.hasOwnProperty.call(message, "receiptPostalCode1"))
                    writer.uint32(/* id 27, wireType 2 =*/218).string(message.receiptPostalCode1);
                if (message.receiptPostalCode2 != null && Object.hasOwnProperty.call(message, "receiptPostalCode2"))
                    writer.uint32(/* id 28, wireType 2 =*/226).string(message.receiptPostalCode2);
                if (message.receiptAddress != null && Object.hasOwnProperty.call(message, "receiptAddress"))
                    writer.uint32(/* id 29, wireType 2 =*/234).string(message.receiptAddress);
                if (message.receiptGenerateType != null && Object.hasOwnProperty.call(message, "receiptGenerateType"))
                    writer.uint32(/* id 30, wireType 0 =*/240).int32(message.receiptGenerateType);
                if (message.receiptGenerateCycle != null && Object.hasOwnProperty.call(message, "receiptGenerateCycle"))
                    writer.uint32(/* id 31, wireType 0 =*/248).int32(message.receiptGenerateCycle);
                if (message.receiptGenerateBasis != null && Object.hasOwnProperty.call(message, "receiptGenerateBasis"))
                    writer.uint32(/* id 32, wireType 0 =*/256).int32(message.receiptGenerateBasis);
                if (message.smartPay != null && Object.hasOwnProperty.call(message, "smartPay"))
                    writer.uint32(/* id 33, wireType 0 =*/264).int32(message.smartPay);
                if (message.commonQrCode != null && Object.hasOwnProperty.call(message, "commonQrCode"))
                    writer.uint32(/* id 34, wireType 0 =*/272).int32(message.commonQrCode);
                if (message.vmjQrCode != null && Object.hasOwnProperty.call(message, "vmjQrCode"))
                    writer.uint32(/* id 35, wireType 0 =*/280).int32(message.vmjQrCode);
                if (message.cupQrCode != null && Object.hasOwnProperty.call(message, "cupQrCode"))
                    writer.uint32(/* id 36, wireType 0 =*/288).int32(message.cupQrCode);
                if (message.naturalPerson != null && Object.hasOwnProperty.call(message, "naturalPerson"))
                    writer.uint32(/* id 37, wireType 0 =*/296).int32(message.naturalPerson);
                if (message.organizationType != null && Object.hasOwnProperty.call(message, "organizationType"))
                    writer.uint32(/* id 38, wireType 0 =*/304).int32(message.organizationType);
                if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                    writer.uint32(/* id 39, wireType 0 =*/312).int32(message.state);
                if (message.cancelDate != null && Object.hasOwnProperty.call(message, "cancelDate"))
                    writer.uint32(/* id 40, wireType 2 =*/322).string(message.cancelDate);
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    writer.uint32(/* id 41, wireType 0 =*/328).int32(message.lastUpdateTime);
                if (message.lastUploadTime != null && Object.hasOwnProperty.call(message, "lastUploadTime"))
                    writer.uint32(/* id 42, wireType 0 =*/336).int32(message.lastUploadTime);
                if (message.releaseState != null && Object.hasOwnProperty.call(message, "releaseState"))
                    writer.uint32(/* id 43, wireType 0 =*/344).int32(message.releaseState);
                if (message.rejectReason != null && Object.hasOwnProperty.call(message, "rejectReason"))
                    writer.uint32(/* id 44, wireType 2 =*/354).string(message.rejectReason);
                return writer;
            };

            /**
             * Encodes the specified Store message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.Store.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.Store
             * @static
             * @param {TCBReceiptApi.Protobuf.IStore} message Store message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Store.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Store message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.Store
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.Store} Store
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Store.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.Store();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.storeTempId = reader.int32();
                        break;
                    case 2:
                        message.storeId = reader.int32();
                        break;
                    case 3:
                        message.code = reader.string();
                        break;
                    case 4:
                        message.isQuota = reader.int32();
                        break;
                    case 5:
                        message.tidNumber = reader.string();
                        break;
                    case 6:
                        message.type = reader.string();
                        break;
                    case 7:
                        message.typeDescription = reader.string();
                        break;
                    case 8:
                        message.headId = reader.string();
                        break;
                    case 9:
                        message.headDescription = reader.string();
                        break;
                    case 10:
                        message.registerName = reader.string();
                        break;
                    case 11:
                        message.engName = reader.string();
                        break;
                    case 12:
                        message.signTitle = reader.string();
                        break;
                    case 13:
                        message.nickName = reader.string();
                        break;
                    case 14:
                        message.mccCode = reader.string();
                        break;
                    case 15:
                        message.mccDescription = reader.string();
                        break;
                    case 16:
                        message.guiNumber = reader.string();
                        break;
                    case 17:
                        message.registerPostalCode1 = reader.string();
                        break;
                    case 18:
                        message.registerPostalCode2 = reader.string();
                        break;
                    case 19:
                        message.registerAddress = reader.string();
                        break;
                    case 20:
                        message.businessPostalCode1 = reader.string();
                        break;
                    case 21:
                        message.businessPostalCode2 = reader.string();
                        break;
                    case 22:
                        message.businessAddress = reader.string();
                        break;
                    case 23:
                        message.bankCode = reader.string();
                        break;
                    case 24:
                        message.bankName = reader.string();
                        break;
                    case 25:
                        message.isPaper = reader.int32();
                        break;
                    case 26:
                        message.receiptName = reader.string();
                        break;
                    case 27:
                        message.receiptPostalCode1 = reader.string();
                        break;
                    case 28:
                        message.receiptPostalCode2 = reader.string();
                        break;
                    case 29:
                        message.receiptAddress = reader.string();
                        break;
                    case 30:
                        message.receiptGenerateType = reader.int32();
                        break;
                    case 31:
                        message.receiptGenerateCycle = reader.int32();
                        break;
                    case 32:
                        message.receiptGenerateBasis = reader.int32();
                        break;
                    case 33:
                        message.smartPay = reader.int32();
                        break;
                    case 34:
                        message.commonQrCode = reader.int32();
                        break;
                    case 35:
                        message.vmjQrCode = reader.int32();
                        break;
                    case 36:
                        message.cupQrCode = reader.int32();
                        break;
                    case 37:
                        message.naturalPerson = reader.int32();
                        break;
                    case 38:
                        message.organizationType = reader.int32();
                        break;
                    case 39:
                        message.state = reader.int32();
                        break;
                    case 40:
                        message.cancelDate = reader.string();
                        break;
                    case 41:
                        message.lastUpdateTime = reader.int32();
                        break;
                    case 42:
                        message.lastUploadTime = reader.int32();
                        break;
                    case 43:
                        message.releaseState = reader.int32();
                        break;
                    case 44:
                        message.rejectReason = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Store message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.Store
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.Store} Store
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Store.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Store message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.Store
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Store.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.storeTempId != null && message.hasOwnProperty("storeTempId"))
                    if (!$util.isInteger(message.storeTempId))
                        return "storeTempId: integer expected";
                if (message.storeId != null && message.hasOwnProperty("storeId"))
                    if (!$util.isInteger(message.storeId))
                        return "storeId: integer expected";
                if (message.code != null && message.hasOwnProperty("code"))
                    if (!$util.isString(message.code))
                        return "code: string expected";
                if (message.isQuota != null && message.hasOwnProperty("isQuota"))
                    if (!$util.isInteger(message.isQuota))
                        return "isQuota: integer expected";
                if (message.tidNumber != null && message.hasOwnProperty("tidNumber"))
                    if (!$util.isString(message.tidNumber))
                        return "tidNumber: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                if (message.typeDescription != null && message.hasOwnProperty("typeDescription"))
                    if (!$util.isString(message.typeDescription))
                        return "typeDescription: string expected";
                if (message.headId != null && message.hasOwnProperty("headId"))
                    if (!$util.isString(message.headId))
                        return "headId: string expected";
                if (message.headDescription != null && message.hasOwnProperty("headDescription"))
                    if (!$util.isString(message.headDescription))
                        return "headDescription: string expected";
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    if (!$util.isString(message.registerName))
                        return "registerName: string expected";
                if (message.engName != null && message.hasOwnProperty("engName"))
                    if (!$util.isString(message.engName))
                        return "engName: string expected";
                if (message.signTitle != null && message.hasOwnProperty("signTitle"))
                    if (!$util.isString(message.signTitle))
                        return "signTitle: string expected";
                if (message.nickName != null && message.hasOwnProperty("nickName"))
                    if (!$util.isString(message.nickName))
                        return "nickName: string expected";
                if (message.mccCode != null && message.hasOwnProperty("mccCode"))
                    if (!$util.isString(message.mccCode))
                        return "mccCode: string expected";
                if (message.mccDescription != null && message.hasOwnProperty("mccDescription"))
                    if (!$util.isString(message.mccDescription))
                        return "mccDescription: string expected";
                if (message.guiNumber != null && message.hasOwnProperty("guiNumber"))
                    if (!$util.isString(message.guiNumber))
                        return "guiNumber: string expected";
                if (message.registerPostalCode1 != null && message.hasOwnProperty("registerPostalCode1"))
                    if (!$util.isString(message.registerPostalCode1))
                        return "registerPostalCode1: string expected";
                if (message.registerPostalCode2 != null && message.hasOwnProperty("registerPostalCode2"))
                    if (!$util.isString(message.registerPostalCode2))
                        return "registerPostalCode2: string expected";
                if (message.registerAddress != null && message.hasOwnProperty("registerAddress"))
                    if (!$util.isString(message.registerAddress))
                        return "registerAddress: string expected";
                if (message.businessPostalCode1 != null && message.hasOwnProperty("businessPostalCode1"))
                    if (!$util.isString(message.businessPostalCode1))
                        return "businessPostalCode1: string expected";
                if (message.businessPostalCode2 != null && message.hasOwnProperty("businessPostalCode2"))
                    if (!$util.isString(message.businessPostalCode2))
                        return "businessPostalCode2: string expected";
                if (message.businessAddress != null && message.hasOwnProperty("businessAddress"))
                    if (!$util.isString(message.businessAddress))
                        return "businessAddress: string expected";
                if (message.bankCode != null && message.hasOwnProperty("bankCode"))
                    if (!$util.isString(message.bankCode))
                        return "bankCode: string expected";
                if (message.bankName != null && message.hasOwnProperty("bankName"))
                    if (!$util.isString(message.bankName))
                        return "bankName: string expected";
                if (message.isPaper != null && message.hasOwnProperty("isPaper"))
                    if (!$util.isInteger(message.isPaper))
                        return "isPaper: integer expected";
                if (message.receiptName != null && message.hasOwnProperty("receiptName"))
                    if (!$util.isString(message.receiptName))
                        return "receiptName: string expected";
                if (message.receiptPostalCode1 != null && message.hasOwnProperty("receiptPostalCode1"))
                    if (!$util.isString(message.receiptPostalCode1))
                        return "receiptPostalCode1: string expected";
                if (message.receiptPostalCode2 != null && message.hasOwnProperty("receiptPostalCode2"))
                    if (!$util.isString(message.receiptPostalCode2))
                        return "receiptPostalCode2: string expected";
                if (message.receiptAddress != null && message.hasOwnProperty("receiptAddress"))
                    if (!$util.isString(message.receiptAddress))
                        return "receiptAddress: string expected";
                if (message.receiptGenerateType != null && message.hasOwnProperty("receiptGenerateType"))
                    if (!$util.isInteger(message.receiptGenerateType))
                        return "receiptGenerateType: integer expected";
                if (message.receiptGenerateCycle != null && message.hasOwnProperty("receiptGenerateCycle"))
                    if (!$util.isInteger(message.receiptGenerateCycle))
                        return "receiptGenerateCycle: integer expected";
                if (message.receiptGenerateBasis != null && message.hasOwnProperty("receiptGenerateBasis"))
                    if (!$util.isInteger(message.receiptGenerateBasis))
                        return "receiptGenerateBasis: integer expected";
                if (message.smartPay != null && message.hasOwnProperty("smartPay"))
                    if (!$util.isInteger(message.smartPay))
                        return "smartPay: integer expected";
                if (message.commonQrCode != null && message.hasOwnProperty("commonQrCode"))
                    if (!$util.isInteger(message.commonQrCode))
                        return "commonQrCode: integer expected";
                if (message.vmjQrCode != null && message.hasOwnProperty("vmjQrCode"))
                    if (!$util.isInteger(message.vmjQrCode))
                        return "vmjQrCode: integer expected";
                if (message.cupQrCode != null && message.hasOwnProperty("cupQrCode"))
                    if (!$util.isInteger(message.cupQrCode))
                        return "cupQrCode: integer expected";
                if (message.naturalPerson != null && message.hasOwnProperty("naturalPerson"))
                    if (!$util.isInteger(message.naturalPerson))
                        return "naturalPerson: integer expected";
                if (message.organizationType != null && message.hasOwnProperty("organizationType"))
                    if (!$util.isInteger(message.organizationType))
                        return "organizationType: integer expected";
                if (message.state != null && message.hasOwnProperty("state"))
                    if (!$util.isInteger(message.state))
                        return "state: integer expected";
                if (message.cancelDate != null && message.hasOwnProperty("cancelDate"))
                    if (!$util.isString(message.cancelDate))
                        return "cancelDate: string expected";
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    if (!$util.isInteger(message.lastUpdateTime))
                        return "lastUpdateTime: integer expected";
                if (message.lastUploadTime != null && message.hasOwnProperty("lastUploadTime"))
                    if (!$util.isInteger(message.lastUploadTime))
                        return "lastUploadTime: integer expected";
                if (message.releaseState != null && message.hasOwnProperty("releaseState"))
                    if (!$util.isInteger(message.releaseState))
                        return "releaseState: integer expected";
                if (message.rejectReason != null && message.hasOwnProperty("rejectReason"))
                    if (!$util.isString(message.rejectReason))
                        return "rejectReason: string expected";
                return null;
            };

            /**
             * Creates a Store message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.Store
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.Store} Store
             */
            Store.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.Store)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.Store();
                if (object.storeTempId != null)
                    message.storeTempId = object.storeTempId | 0;
                if (object.storeId != null)
                    message.storeId = object.storeId | 0;
                if (object.code != null)
                    message.code = String(object.code);
                if (object.isQuota != null)
                    message.isQuota = object.isQuota | 0;
                if (object.tidNumber != null)
                    message.tidNumber = String(object.tidNumber);
                if (object.type != null)
                    message.type = String(object.type);
                if (object.typeDescription != null)
                    message.typeDescription = String(object.typeDescription);
                if (object.headId != null)
                    message.headId = String(object.headId);
                if (object.headDescription != null)
                    message.headDescription = String(object.headDescription);
                if (object.registerName != null)
                    message.registerName = String(object.registerName);
                if (object.engName != null)
                    message.engName = String(object.engName);
                if (object.signTitle != null)
                    message.signTitle = String(object.signTitle);
                if (object.nickName != null)
                    message.nickName = String(object.nickName);
                if (object.mccCode != null)
                    message.mccCode = String(object.mccCode);
                if (object.mccDescription != null)
                    message.mccDescription = String(object.mccDescription);
                if (object.guiNumber != null)
                    message.guiNumber = String(object.guiNumber);
                if (object.registerPostalCode1 != null)
                    message.registerPostalCode1 = String(object.registerPostalCode1);
                if (object.registerPostalCode2 != null)
                    message.registerPostalCode2 = String(object.registerPostalCode2);
                if (object.registerAddress != null)
                    message.registerAddress = String(object.registerAddress);
                if (object.businessPostalCode1 != null)
                    message.businessPostalCode1 = String(object.businessPostalCode1);
                if (object.businessPostalCode2 != null)
                    message.businessPostalCode2 = String(object.businessPostalCode2);
                if (object.businessAddress != null)
                    message.businessAddress = String(object.businessAddress);
                if (object.bankCode != null)
                    message.bankCode = String(object.bankCode);
                if (object.bankName != null)
                    message.bankName = String(object.bankName);
                if (object.isPaper != null)
                    message.isPaper = object.isPaper | 0;
                if (object.receiptName != null)
                    message.receiptName = String(object.receiptName);
                if (object.receiptPostalCode1 != null)
                    message.receiptPostalCode1 = String(object.receiptPostalCode1);
                if (object.receiptPostalCode2 != null)
                    message.receiptPostalCode2 = String(object.receiptPostalCode2);
                if (object.receiptAddress != null)
                    message.receiptAddress = String(object.receiptAddress);
                if (object.receiptGenerateType != null)
                    message.receiptGenerateType = object.receiptGenerateType | 0;
                if (object.receiptGenerateCycle != null)
                    message.receiptGenerateCycle = object.receiptGenerateCycle | 0;
                if (object.receiptGenerateBasis != null)
                    message.receiptGenerateBasis = object.receiptGenerateBasis | 0;
                if (object.smartPay != null)
                    message.smartPay = object.smartPay | 0;
                if (object.commonQrCode != null)
                    message.commonQrCode = object.commonQrCode | 0;
                if (object.vmjQrCode != null)
                    message.vmjQrCode = object.vmjQrCode | 0;
                if (object.cupQrCode != null)
                    message.cupQrCode = object.cupQrCode | 0;
                if (object.naturalPerson != null)
                    message.naturalPerson = object.naturalPerson | 0;
                if (object.organizationType != null)
                    message.organizationType = object.organizationType | 0;
                if (object.state != null)
                    message.state = object.state | 0;
                if (object.cancelDate != null)
                    message.cancelDate = String(object.cancelDate);
                if (object.lastUpdateTime != null)
                    message.lastUpdateTime = object.lastUpdateTime | 0;
                if (object.lastUploadTime != null)
                    message.lastUploadTime = object.lastUploadTime | 0;
                if (object.releaseState != null)
                    message.releaseState = object.releaseState | 0;
                if (object.rejectReason != null)
                    message.rejectReason = String(object.rejectReason);
                return message;
            };

            /**
             * Creates a plain object from a Store message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.Store
             * @static
             * @param {TCBReceiptApi.Protobuf.Store} message Store
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Store.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.storeTempId = 0;
                    object.storeId = 0;
                    object.code = "";
                    object.isQuota = 0;
                    object.tidNumber = "";
                    object.type = "";
                    object.typeDescription = "";
                    object.headId = "";
                    object.headDescription = "";
                    object.registerName = "";
                    object.engName = "";
                    object.signTitle = "";
                    object.nickName = "";
                    object.mccCode = "";
                    object.mccDescription = "";
                    object.guiNumber = "";
                    object.registerPostalCode1 = "";
                    object.registerPostalCode2 = "";
                    object.registerAddress = "";
                    object.businessPostalCode1 = "";
                    object.businessPostalCode2 = "";
                    object.businessAddress = "";
                    object.bankCode = "";
                    object.bankName = "";
                    object.isPaper = 0;
                    object.receiptName = "";
                    object.receiptPostalCode1 = "";
                    object.receiptPostalCode2 = "";
                    object.receiptAddress = "";
                    object.receiptGenerateType = 0;
                    object.receiptGenerateCycle = 0;
                    object.receiptGenerateBasis = 0;
                    object.smartPay = 0;
                    object.commonQrCode = 0;
                    object.vmjQrCode = 0;
                    object.cupQrCode = 0;
                    object.naturalPerson = 0;
                    object.organizationType = 0;
                    object.state = 0;
                    object.cancelDate = "";
                    object.lastUpdateTime = 0;
                    object.lastUploadTime = 0;
                    object.releaseState = 0;
                    object.rejectReason = "";
                }
                if (message.storeTempId != null && message.hasOwnProperty("storeTempId"))
                    object.storeTempId = message.storeTempId;
                if (message.storeId != null && message.hasOwnProperty("storeId"))
                    object.storeId = message.storeId;
                if (message.code != null && message.hasOwnProperty("code"))
                    object.code = message.code;
                if (message.isQuota != null && message.hasOwnProperty("isQuota"))
                    object.isQuota = message.isQuota;
                if (message.tidNumber != null && message.hasOwnProperty("tidNumber"))
                    object.tidNumber = message.tidNumber;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.typeDescription != null && message.hasOwnProperty("typeDescription"))
                    object.typeDescription = message.typeDescription;
                if (message.headId != null && message.hasOwnProperty("headId"))
                    object.headId = message.headId;
                if (message.headDescription != null && message.hasOwnProperty("headDescription"))
                    object.headDescription = message.headDescription;
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    object.registerName = message.registerName;
                if (message.engName != null && message.hasOwnProperty("engName"))
                    object.engName = message.engName;
                if (message.signTitle != null && message.hasOwnProperty("signTitle"))
                    object.signTitle = message.signTitle;
                if (message.nickName != null && message.hasOwnProperty("nickName"))
                    object.nickName = message.nickName;
                if (message.mccCode != null && message.hasOwnProperty("mccCode"))
                    object.mccCode = message.mccCode;
                if (message.mccDescription != null && message.hasOwnProperty("mccDescription"))
                    object.mccDescription = message.mccDescription;
                if (message.guiNumber != null && message.hasOwnProperty("guiNumber"))
                    object.guiNumber = message.guiNumber;
                if (message.registerPostalCode1 != null && message.hasOwnProperty("registerPostalCode1"))
                    object.registerPostalCode1 = message.registerPostalCode1;
                if (message.registerPostalCode2 != null && message.hasOwnProperty("registerPostalCode2"))
                    object.registerPostalCode2 = message.registerPostalCode2;
                if (message.registerAddress != null && message.hasOwnProperty("registerAddress"))
                    object.registerAddress = message.registerAddress;
                if (message.businessPostalCode1 != null && message.hasOwnProperty("businessPostalCode1"))
                    object.businessPostalCode1 = message.businessPostalCode1;
                if (message.businessPostalCode2 != null && message.hasOwnProperty("businessPostalCode2"))
                    object.businessPostalCode2 = message.businessPostalCode2;
                if (message.businessAddress != null && message.hasOwnProperty("businessAddress"))
                    object.businessAddress = message.businessAddress;
                if (message.bankCode != null && message.hasOwnProperty("bankCode"))
                    object.bankCode = message.bankCode;
                if (message.bankName != null && message.hasOwnProperty("bankName"))
                    object.bankName = message.bankName;
                if (message.isPaper != null && message.hasOwnProperty("isPaper"))
                    object.isPaper = message.isPaper;
                if (message.receiptName != null && message.hasOwnProperty("receiptName"))
                    object.receiptName = message.receiptName;
                if (message.receiptPostalCode1 != null && message.hasOwnProperty("receiptPostalCode1"))
                    object.receiptPostalCode1 = message.receiptPostalCode1;
                if (message.receiptPostalCode2 != null && message.hasOwnProperty("receiptPostalCode2"))
                    object.receiptPostalCode2 = message.receiptPostalCode2;
                if (message.receiptAddress != null && message.hasOwnProperty("receiptAddress"))
                    object.receiptAddress = message.receiptAddress;
                if (message.receiptGenerateType != null && message.hasOwnProperty("receiptGenerateType"))
                    object.receiptGenerateType = message.receiptGenerateType;
                if (message.receiptGenerateCycle != null && message.hasOwnProperty("receiptGenerateCycle"))
                    object.receiptGenerateCycle = message.receiptGenerateCycle;
                if (message.receiptGenerateBasis != null && message.hasOwnProperty("receiptGenerateBasis"))
                    object.receiptGenerateBasis = message.receiptGenerateBasis;
                if (message.smartPay != null && message.hasOwnProperty("smartPay"))
                    object.smartPay = message.smartPay;
                if (message.commonQrCode != null && message.hasOwnProperty("commonQrCode"))
                    object.commonQrCode = message.commonQrCode;
                if (message.vmjQrCode != null && message.hasOwnProperty("vmjQrCode"))
                    object.vmjQrCode = message.vmjQrCode;
                if (message.cupQrCode != null && message.hasOwnProperty("cupQrCode"))
                    object.cupQrCode = message.cupQrCode;
                if (message.naturalPerson != null && message.hasOwnProperty("naturalPerson"))
                    object.naturalPerson = message.naturalPerson;
                if (message.organizationType != null && message.hasOwnProperty("organizationType"))
                    object.organizationType = message.organizationType;
                if (message.state != null && message.hasOwnProperty("state"))
                    object.state = message.state;
                if (message.cancelDate != null && message.hasOwnProperty("cancelDate"))
                    object.cancelDate = message.cancelDate;
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    object.lastUpdateTime = message.lastUpdateTime;
                if (message.lastUploadTime != null && message.hasOwnProperty("lastUploadTime"))
                    object.lastUploadTime = message.lastUploadTime;
                if (message.releaseState != null && message.hasOwnProperty("releaseState"))
                    object.releaseState = message.releaseState;
                if (message.rejectReason != null && message.hasOwnProperty("rejectReason"))
                    object.rejectReason = message.rejectReason;
                return object;
            };

            /**
             * Converts this Store to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.Store
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Store.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Store;
        })();

        Protobuf.StoreList = (function() {

            /**
             * Properties of a StoreList.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IStoreList
             * @property {Array.<TCBReceiptApi.Protobuf.IStore>|null} [list] StoreList list
             * @property {number|null} [total] StoreList total
             */

            /**
             * Constructs a new StoreList.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a StoreList.
             * @implements IStoreList
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IStoreList=} [properties] Properties to set
             */
            function StoreList(properties) {
                this.list = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * StoreList list.
             * @member {Array.<TCBReceiptApi.Protobuf.IStore>} list
             * @memberof TCBReceiptApi.Protobuf.StoreList
             * @instance
             */
            StoreList.prototype.list = $util.emptyArray;

            /**
             * StoreList total.
             * @member {number} total
             * @memberof TCBReceiptApi.Protobuf.StoreList
             * @instance
             */
            StoreList.prototype.total = 0;

            /**
             * Creates a new StoreList instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.StoreList
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreList=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.StoreList} StoreList instance
             */
            StoreList.create = function create(properties) {
                return new StoreList(properties);
            };

            /**
             * Encodes the specified StoreList message. Does not implicitly {@link TCBReceiptApi.Protobuf.StoreList.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.StoreList
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreList} message StoreList message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StoreList.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.list != null && message.list.length)
                    for (var i = 0; i < message.list.length; ++i)
                        $root.TCBReceiptApi.Protobuf.Store.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.total);
                return writer;
            };

            /**
             * Encodes the specified StoreList message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.StoreList.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.StoreList
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreList} message StoreList message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StoreList.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a StoreList message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.StoreList
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.StoreList} StoreList
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StoreList.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.StoreList();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.TCBReceiptApi.Protobuf.Store.decode(reader, reader.uint32()));
                        break;
                    case 2:
                        message.total = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a StoreList message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.StoreList
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.StoreList} StoreList
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StoreList.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a StoreList message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.StoreList
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            StoreList.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.list != null && message.hasOwnProperty("list")) {
                    if (!Array.isArray(message.list))
                        return "list: array expected";
                    for (var i = 0; i < message.list.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.Store.verify(message.list[i]);
                        if (error)
                            return "list." + error;
                    }
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    if (!$util.isInteger(message.total))
                        return "total: integer expected";
                return null;
            };

            /**
             * Creates a StoreList message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.StoreList
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.StoreList} StoreList
             */
            StoreList.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.StoreList)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.StoreList();
                if (object.list) {
                    if (!Array.isArray(object.list))
                        throw TypeError(".TCBReceiptApi.Protobuf.StoreList.list: array expected");
                    message.list = [];
                    for (var i = 0; i < object.list.length; ++i) {
                        if (typeof object.list[i] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.StoreList.list: object expected");
                        message.list[i] = $root.TCBReceiptApi.Protobuf.Store.fromObject(object.list[i]);
                    }
                }
                if (object.total != null)
                    message.total = object.total | 0;
                return message;
            };

            /**
             * Creates a plain object from a StoreList message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.StoreList
             * @static
             * @param {TCBReceiptApi.Protobuf.StoreList} message StoreList
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            StoreList.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.list = [];
                if (options.defaults)
                    object.total = 0;
                if (message.list && message.list.length) {
                    object.list = [];
                    for (var j = 0; j < message.list.length; ++j)
                        object.list[j] = $root.TCBReceiptApi.Protobuf.Store.toObject(message.list[j], options);
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    object.total = message.total;
                return object;
            };

            /**
             * Converts this StoreList to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.StoreList
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            StoreList.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return StoreList;
        })();

        Protobuf.StoreQuery = (function() {

            /**
             * Properties of a StoreQuery.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IStoreQuery
             * @property {number|null} [state] StoreQuery state
             * @property {string|null} [registerName] StoreQuery registerName
             * @property {string|null} [code] StoreQuery code
             * @property {string|null} [tidNumber] StoreQuery tidNumber
             * @property {TCBReceiptApi.Protobuf.IPagination|null} [pagination] StoreQuery pagination
             * @property {number|null} [releaseState] StoreQuery releaseState
             */

            /**
             * Constructs a new StoreQuery.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a StoreQuery.
             * @implements IStoreQuery
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IStoreQuery=} [properties] Properties to set
             */
            function StoreQuery(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * StoreQuery state.
             * @member {number} state
             * @memberof TCBReceiptApi.Protobuf.StoreQuery
             * @instance
             */
            StoreQuery.prototype.state = 0;

            /**
             * StoreQuery registerName.
             * @member {string} registerName
             * @memberof TCBReceiptApi.Protobuf.StoreQuery
             * @instance
             */
            StoreQuery.prototype.registerName = "";

            /**
             * StoreQuery code.
             * @member {string} code
             * @memberof TCBReceiptApi.Protobuf.StoreQuery
             * @instance
             */
            StoreQuery.prototype.code = "";

            /**
             * StoreQuery tidNumber.
             * @member {string} tidNumber
             * @memberof TCBReceiptApi.Protobuf.StoreQuery
             * @instance
             */
            StoreQuery.prototype.tidNumber = "";

            /**
             * StoreQuery pagination.
             * @member {TCBReceiptApi.Protobuf.IPagination|null|undefined} pagination
             * @memberof TCBReceiptApi.Protobuf.StoreQuery
             * @instance
             */
            StoreQuery.prototype.pagination = null;

            /**
             * StoreQuery releaseState.
             * @member {number} releaseState
             * @memberof TCBReceiptApi.Protobuf.StoreQuery
             * @instance
             */
            StoreQuery.prototype.releaseState = 0;

            /**
             * Creates a new StoreQuery instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.StoreQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreQuery=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.StoreQuery} StoreQuery instance
             */
            StoreQuery.create = function create(properties) {
                return new StoreQuery(properties);
            };

            /**
             * Encodes the specified StoreQuery message. Does not implicitly {@link TCBReceiptApi.Protobuf.StoreQuery.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.StoreQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreQuery} message StoreQuery message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StoreQuery.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.state);
                if (message.registerName != null && Object.hasOwnProperty.call(message, "registerName"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.registerName);
                if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.code);
                if (message.tidNumber != null && Object.hasOwnProperty.call(message, "tidNumber"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.tidNumber);
                if (message.pagination != null && Object.hasOwnProperty.call(message, "pagination"))
                    $root.TCBReceiptApi.Protobuf.Pagination.encode(message.pagination, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.releaseState != null && Object.hasOwnProperty.call(message, "releaseState"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int32(message.releaseState);
                return writer;
            };

            /**
             * Encodes the specified StoreQuery message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.StoreQuery.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.StoreQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreQuery} message StoreQuery message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StoreQuery.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a StoreQuery message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.StoreQuery
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.StoreQuery} StoreQuery
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StoreQuery.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.StoreQuery();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.state = reader.int32();
                        break;
                    case 2:
                        message.registerName = reader.string();
                        break;
                    case 3:
                        message.code = reader.string();
                        break;
                    case 4:
                        message.tidNumber = reader.string();
                        break;
                    case 5:
                        message.pagination = $root.TCBReceiptApi.Protobuf.Pagination.decode(reader, reader.uint32());
                        break;
                    case 6:
                        message.releaseState = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a StoreQuery message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.StoreQuery
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.StoreQuery} StoreQuery
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StoreQuery.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a StoreQuery message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.StoreQuery
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            StoreQuery.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.state != null && message.hasOwnProperty("state"))
                    if (!$util.isInteger(message.state))
                        return "state: integer expected";
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    if (!$util.isString(message.registerName))
                        return "registerName: string expected";
                if (message.code != null && message.hasOwnProperty("code"))
                    if (!$util.isString(message.code))
                        return "code: string expected";
                if (message.tidNumber != null && message.hasOwnProperty("tidNumber"))
                    if (!$util.isString(message.tidNumber))
                        return "tidNumber: string expected";
                if (message.pagination != null && message.hasOwnProperty("pagination")) {
                    var error = $root.TCBReceiptApi.Protobuf.Pagination.verify(message.pagination);
                    if (error)
                        return "pagination." + error;
                }
                if (message.releaseState != null && message.hasOwnProperty("releaseState"))
                    if (!$util.isInteger(message.releaseState))
                        return "releaseState: integer expected";
                return null;
            };

            /**
             * Creates a StoreQuery message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.StoreQuery
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.StoreQuery} StoreQuery
             */
            StoreQuery.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.StoreQuery)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.StoreQuery();
                if (object.state != null)
                    message.state = object.state | 0;
                if (object.registerName != null)
                    message.registerName = String(object.registerName);
                if (object.code != null)
                    message.code = String(object.code);
                if (object.tidNumber != null)
                    message.tidNumber = String(object.tidNumber);
                if (object.pagination != null) {
                    if (typeof object.pagination !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.StoreQuery.pagination: object expected");
                    message.pagination = $root.TCBReceiptApi.Protobuf.Pagination.fromObject(object.pagination);
                }
                if (object.releaseState != null)
                    message.releaseState = object.releaseState | 0;
                return message;
            };

            /**
             * Creates a plain object from a StoreQuery message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.StoreQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.StoreQuery} message StoreQuery
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            StoreQuery.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.state = 0;
                    object.registerName = "";
                    object.code = "";
                    object.tidNumber = "";
                    object.pagination = null;
                    object.releaseState = 0;
                }
                if (message.state != null && message.hasOwnProperty("state"))
                    object.state = message.state;
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    object.registerName = message.registerName;
                if (message.code != null && message.hasOwnProperty("code"))
                    object.code = message.code;
                if (message.tidNumber != null && message.hasOwnProperty("tidNumber"))
                    object.tidNumber = message.tidNumber;
                if (message.pagination != null && message.hasOwnProperty("pagination"))
                    object.pagination = $root.TCBReceiptApi.Protobuf.Pagination.toObject(message.pagination, options);
                if (message.releaseState != null && message.hasOwnProperty("releaseState"))
                    object.releaseState = message.releaseState;
                return object;
            };

            /**
             * Converts this StoreQuery to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.StoreQuery
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            StoreQuery.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return StoreQuery;
        })();

        /**
         * StoreInsertQueryType enum.
         * @name TCBReceiptApi.Protobuf.StoreInsertQueryType
         * @enum {number}
         * @property {number} SIQT_NONE=0 SIQT_NONE value
         * @property {number} SIQT_CODE=1 SIQT_CODE value
         * @property {number} SIQT_TID_NUMBER=2 SIQT_TID_NUMBER value
         */
        Protobuf.StoreInsertQueryType = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "SIQT_NONE"] = 0;
            values[valuesById[1] = "SIQT_CODE"] = 1;
            values[valuesById[2] = "SIQT_TID_NUMBER"] = 2;
            return values;
        })();

        Protobuf.StoreInsertQuery = (function() {

            /**
             * Properties of a StoreInsertQuery.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IStoreInsertQuery
             * @property {TCBReceiptApi.Protobuf.StoreInsertQueryType|null} [type] StoreInsertQuery type
             * @property {string|null} [identification] StoreInsertQuery identification
             */

            /**
             * Constructs a new StoreInsertQuery.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a StoreInsertQuery.
             * @implements IStoreInsertQuery
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IStoreInsertQuery=} [properties] Properties to set
             */
            function StoreInsertQuery(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * StoreInsertQuery type.
             * @member {TCBReceiptApi.Protobuf.StoreInsertQueryType} type
             * @memberof TCBReceiptApi.Protobuf.StoreInsertQuery
             * @instance
             */
            StoreInsertQuery.prototype.type = 0;

            /**
             * StoreInsertQuery identification.
             * @member {string} identification
             * @memberof TCBReceiptApi.Protobuf.StoreInsertQuery
             * @instance
             */
            StoreInsertQuery.prototype.identification = "";

            /**
             * Creates a new StoreInsertQuery instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.StoreInsertQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreInsertQuery=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.StoreInsertQuery} StoreInsertQuery instance
             */
            StoreInsertQuery.create = function create(properties) {
                return new StoreInsertQuery(properties);
            };

            /**
             * Encodes the specified StoreInsertQuery message. Does not implicitly {@link TCBReceiptApi.Protobuf.StoreInsertQuery.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.StoreInsertQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreInsertQuery} message StoreInsertQuery message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StoreInsertQuery.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
                if (message.identification != null && Object.hasOwnProperty.call(message, "identification"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.identification);
                return writer;
            };

            /**
             * Encodes the specified StoreInsertQuery message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.StoreInsertQuery.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.StoreInsertQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreInsertQuery} message StoreInsertQuery message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StoreInsertQuery.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a StoreInsertQuery message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.StoreInsertQuery
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.StoreInsertQuery} StoreInsertQuery
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StoreInsertQuery.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.StoreInsertQuery();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.type = reader.int32();
                        break;
                    case 2:
                        message.identification = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a StoreInsertQuery message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.StoreInsertQuery
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.StoreInsertQuery} StoreInsertQuery
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StoreInsertQuery.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a StoreInsertQuery message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.StoreInsertQuery
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            StoreInsertQuery.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    switch (message.type) {
                    default:
                        return "type: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.identification != null && message.hasOwnProperty("identification"))
                    if (!$util.isString(message.identification))
                        return "identification: string expected";
                return null;
            };

            /**
             * Creates a StoreInsertQuery message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.StoreInsertQuery
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.StoreInsertQuery} StoreInsertQuery
             */
            StoreInsertQuery.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.StoreInsertQuery)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.StoreInsertQuery();
                switch (object.type) {
                case "SIQT_NONE":
                case 0:
                    message.type = 0;
                    break;
                case "SIQT_CODE":
                case 1:
                    message.type = 1;
                    break;
                case "SIQT_TID_NUMBER":
                case 2:
                    message.type = 2;
                    break;
                }
                if (object.identification != null)
                    message.identification = String(object.identification);
                return message;
            };

            /**
             * Creates a plain object from a StoreInsertQuery message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.StoreInsertQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.StoreInsertQuery} message StoreInsertQuery
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            StoreInsertQuery.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.type = options.enums === String ? "SIQT_NONE" : 0;
                    object.identification = "";
                }
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = options.enums === String ? $root.TCBReceiptApi.Protobuf.StoreInsertQueryType[message.type] : message.type;
                if (message.identification != null && message.hasOwnProperty("identification"))
                    object.identification = message.identification;
                return object;
            };

            /**
             * Converts this StoreInsertQuery to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.StoreInsertQuery
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            StoreInsertQuery.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return StoreInsertQuery;
        })();

        Protobuf.StoreExport = (function() {

            /**
             * Properties of a StoreExport.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IStoreExport
             * @property {string|null} [code] StoreExport code
             * @property {string|null} [isQuota] StoreExport isQuota
             * @property {string|null} [tidNumber] StoreExport tidNumber
             * @property {string|null} [type] StoreExport type
             * @property {string|null} [typeDescription] StoreExport typeDescription
             * @property {string|null} [headId] StoreExport headId
             * @property {string|null} [headDescription] StoreExport headDescription
             * @property {string|null} [registerName] StoreExport registerName
             * @property {string|null} [engName] StoreExport engName
             * @property {string|null} [signTitle] StoreExport signTitle
             * @property {string|null} [nickName] StoreExport nickName
             * @property {string|null} [mccCode] StoreExport mccCode
             * @property {string|null} [mccDescription] StoreExport mccDescription
             * @property {string|null} [guiNumber] StoreExport guiNumber
             * @property {string|null} [registerPostalCode1] StoreExport registerPostalCode1
             * @property {string|null} [registerPostalCode2] StoreExport registerPostalCode2
             * @property {string|null} [registerAddress] StoreExport registerAddress
             * @property {string|null} [businessPostalCode1] StoreExport businessPostalCode1
             * @property {string|null} [businessPostalCode2] StoreExport businessPostalCode2
             * @property {string|null} [businessAddress] StoreExport businessAddress
             * @property {string|null} [bankCode] StoreExport bankCode
             * @property {string|null} [bankName] StoreExport bankName
             * @property {string|null} [isPaper] StoreExport isPaper
             * @property {string|null} [receiptName] StoreExport receiptName
             * @property {string|null} [receiptPostalCode1] StoreExport receiptPostalCode1
             * @property {string|null} [receiptPostalCode2] StoreExport receiptPostalCode2
             * @property {string|null} [receiptAddress] StoreExport receiptAddress
             * @property {string|null} [receiptGenerateType] StoreExport receiptGenerateType
             * @property {string|null} [receiptGenerateCycle] StoreExport receiptGenerateCycle
             * @property {string|null} [receiptGenerateBasis] StoreExport receiptGenerateBasis
             * @property {string|null} [smartPay] StoreExport smartPay
             * @property {string|null} [commonQrCode] StoreExport commonQrCode
             * @property {string|null} [vmjQrCode] StoreExport vmjQrCode
             * @property {string|null} [cupQrCode] StoreExport cupQrCode
             * @property {string|null} [naturalPerson] StoreExport naturalPerson
             * @property {number|null} [organizationType] StoreExport organizationType
             * @property {string|null} [state] StoreExport state
             * @property {string|null} [cancelDate] StoreExport cancelDate
             * @property {string|null} [lastUpdateTime] StoreExport lastUpdateTime
             * @property {string|null} [lastUploadTime] StoreExport lastUploadTime
             */

            /**
             * Constructs a new StoreExport.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a StoreExport.
             * @implements IStoreExport
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IStoreExport=} [properties] Properties to set
             */
            function StoreExport(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * StoreExport code.
             * @member {string} code
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.code = "";

            /**
             * StoreExport isQuota.
             * @member {string} isQuota
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.isQuota = "";

            /**
             * StoreExport tidNumber.
             * @member {string} tidNumber
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.tidNumber = "";

            /**
             * StoreExport type.
             * @member {string} type
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.type = "";

            /**
             * StoreExport typeDescription.
             * @member {string} typeDescription
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.typeDescription = "";

            /**
             * StoreExport headId.
             * @member {string} headId
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.headId = "";

            /**
             * StoreExport headDescription.
             * @member {string} headDescription
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.headDescription = "";

            /**
             * StoreExport registerName.
             * @member {string} registerName
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.registerName = "";

            /**
             * StoreExport engName.
             * @member {string} engName
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.engName = "";

            /**
             * StoreExport signTitle.
             * @member {string} signTitle
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.signTitle = "";

            /**
             * StoreExport nickName.
             * @member {string} nickName
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.nickName = "";

            /**
             * StoreExport mccCode.
             * @member {string} mccCode
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.mccCode = "";

            /**
             * StoreExport mccDescription.
             * @member {string} mccDescription
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.mccDescription = "";

            /**
             * StoreExport guiNumber.
             * @member {string} guiNumber
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.guiNumber = "";

            /**
             * StoreExport registerPostalCode1.
             * @member {string} registerPostalCode1
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.registerPostalCode1 = "";

            /**
             * StoreExport registerPostalCode2.
             * @member {string} registerPostalCode2
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.registerPostalCode2 = "";

            /**
             * StoreExport registerAddress.
             * @member {string} registerAddress
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.registerAddress = "";

            /**
             * StoreExport businessPostalCode1.
             * @member {string} businessPostalCode1
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.businessPostalCode1 = "";

            /**
             * StoreExport businessPostalCode2.
             * @member {string} businessPostalCode2
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.businessPostalCode2 = "";

            /**
             * StoreExport businessAddress.
             * @member {string} businessAddress
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.businessAddress = "";

            /**
             * StoreExport bankCode.
             * @member {string} bankCode
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.bankCode = "";

            /**
             * StoreExport bankName.
             * @member {string} bankName
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.bankName = "";

            /**
             * StoreExport isPaper.
             * @member {string} isPaper
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.isPaper = "";

            /**
             * StoreExport receiptName.
             * @member {string} receiptName
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.receiptName = "";

            /**
             * StoreExport receiptPostalCode1.
             * @member {string} receiptPostalCode1
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.receiptPostalCode1 = "";

            /**
             * StoreExport receiptPostalCode2.
             * @member {string} receiptPostalCode2
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.receiptPostalCode2 = "";

            /**
             * StoreExport receiptAddress.
             * @member {string} receiptAddress
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.receiptAddress = "";

            /**
             * StoreExport receiptGenerateType.
             * @member {string} receiptGenerateType
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.receiptGenerateType = "";

            /**
             * StoreExport receiptGenerateCycle.
             * @member {string} receiptGenerateCycle
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.receiptGenerateCycle = "";

            /**
             * StoreExport receiptGenerateBasis.
             * @member {string} receiptGenerateBasis
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.receiptGenerateBasis = "";

            /**
             * StoreExport smartPay.
             * @member {string} smartPay
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.smartPay = "";

            /**
             * StoreExport commonQrCode.
             * @member {string} commonQrCode
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.commonQrCode = "";

            /**
             * StoreExport vmjQrCode.
             * @member {string} vmjQrCode
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.vmjQrCode = "";

            /**
             * StoreExport cupQrCode.
             * @member {string} cupQrCode
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.cupQrCode = "";

            /**
             * StoreExport naturalPerson.
             * @member {string} naturalPerson
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.naturalPerson = "";

            /**
             * StoreExport organizationType.
             * @member {number} organizationType
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.organizationType = 0;

            /**
             * StoreExport state.
             * @member {string} state
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.state = "";

            /**
             * StoreExport cancelDate.
             * @member {string} cancelDate
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.cancelDate = "";

            /**
             * StoreExport lastUpdateTime.
             * @member {string} lastUpdateTime
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.lastUpdateTime = "";

            /**
             * StoreExport lastUploadTime.
             * @member {string} lastUploadTime
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             */
            StoreExport.prototype.lastUploadTime = "";

            /**
             * Creates a new StoreExport instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreExport=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.StoreExport} StoreExport instance
             */
            StoreExport.create = function create(properties) {
                return new StoreExport(properties);
            };

            /**
             * Encodes the specified StoreExport message. Does not implicitly {@link TCBReceiptApi.Protobuf.StoreExport.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreExport} message StoreExport message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StoreExport.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.code);
                if (message.isQuota != null && Object.hasOwnProperty.call(message, "isQuota"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.isQuota);
                if (message.tidNumber != null && Object.hasOwnProperty.call(message, "tidNumber"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.tidNumber);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.type);
                if (message.typeDescription != null && Object.hasOwnProperty.call(message, "typeDescription"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.typeDescription);
                if (message.headId != null && Object.hasOwnProperty.call(message, "headId"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.headId);
                if (message.headDescription != null && Object.hasOwnProperty.call(message, "headDescription"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.headDescription);
                if (message.registerName != null && Object.hasOwnProperty.call(message, "registerName"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.registerName);
                if (message.engName != null && Object.hasOwnProperty.call(message, "engName"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.engName);
                if (message.signTitle != null && Object.hasOwnProperty.call(message, "signTitle"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.signTitle);
                if (message.nickName != null && Object.hasOwnProperty.call(message, "nickName"))
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.nickName);
                if (message.mccCode != null && Object.hasOwnProperty.call(message, "mccCode"))
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.mccCode);
                if (message.mccDescription != null && Object.hasOwnProperty.call(message, "mccDescription"))
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.mccDescription);
                if (message.guiNumber != null && Object.hasOwnProperty.call(message, "guiNumber"))
                    writer.uint32(/* id 14, wireType 2 =*/114).string(message.guiNumber);
                if (message.registerPostalCode1 != null && Object.hasOwnProperty.call(message, "registerPostalCode1"))
                    writer.uint32(/* id 15, wireType 2 =*/122).string(message.registerPostalCode1);
                if (message.registerPostalCode2 != null && Object.hasOwnProperty.call(message, "registerPostalCode2"))
                    writer.uint32(/* id 16, wireType 2 =*/130).string(message.registerPostalCode2);
                if (message.registerAddress != null && Object.hasOwnProperty.call(message, "registerAddress"))
                    writer.uint32(/* id 17, wireType 2 =*/138).string(message.registerAddress);
                if (message.businessPostalCode1 != null && Object.hasOwnProperty.call(message, "businessPostalCode1"))
                    writer.uint32(/* id 18, wireType 2 =*/146).string(message.businessPostalCode1);
                if (message.businessPostalCode2 != null && Object.hasOwnProperty.call(message, "businessPostalCode2"))
                    writer.uint32(/* id 19, wireType 2 =*/154).string(message.businessPostalCode2);
                if (message.businessAddress != null && Object.hasOwnProperty.call(message, "businessAddress"))
                    writer.uint32(/* id 20, wireType 2 =*/162).string(message.businessAddress);
                if (message.bankCode != null && Object.hasOwnProperty.call(message, "bankCode"))
                    writer.uint32(/* id 21, wireType 2 =*/170).string(message.bankCode);
                if (message.bankName != null && Object.hasOwnProperty.call(message, "bankName"))
                    writer.uint32(/* id 22, wireType 2 =*/178).string(message.bankName);
                if (message.isPaper != null && Object.hasOwnProperty.call(message, "isPaper"))
                    writer.uint32(/* id 23, wireType 2 =*/186).string(message.isPaper);
                if (message.receiptName != null && Object.hasOwnProperty.call(message, "receiptName"))
                    writer.uint32(/* id 24, wireType 2 =*/194).string(message.receiptName);
                if (message.receiptPostalCode1 != null && Object.hasOwnProperty.call(message, "receiptPostalCode1"))
                    writer.uint32(/* id 25, wireType 2 =*/202).string(message.receiptPostalCode1);
                if (message.receiptPostalCode2 != null && Object.hasOwnProperty.call(message, "receiptPostalCode2"))
                    writer.uint32(/* id 26, wireType 2 =*/210).string(message.receiptPostalCode2);
                if (message.receiptAddress != null && Object.hasOwnProperty.call(message, "receiptAddress"))
                    writer.uint32(/* id 27, wireType 2 =*/218).string(message.receiptAddress);
                if (message.receiptGenerateType != null && Object.hasOwnProperty.call(message, "receiptGenerateType"))
                    writer.uint32(/* id 28, wireType 2 =*/226).string(message.receiptGenerateType);
                if (message.receiptGenerateCycle != null && Object.hasOwnProperty.call(message, "receiptGenerateCycle"))
                    writer.uint32(/* id 29, wireType 2 =*/234).string(message.receiptGenerateCycle);
                if (message.receiptGenerateBasis != null && Object.hasOwnProperty.call(message, "receiptGenerateBasis"))
                    writer.uint32(/* id 30, wireType 2 =*/242).string(message.receiptGenerateBasis);
                if (message.smartPay != null && Object.hasOwnProperty.call(message, "smartPay"))
                    writer.uint32(/* id 31, wireType 2 =*/250).string(message.smartPay);
                if (message.commonQrCode != null && Object.hasOwnProperty.call(message, "commonQrCode"))
                    writer.uint32(/* id 32, wireType 2 =*/258).string(message.commonQrCode);
                if (message.vmjQrCode != null && Object.hasOwnProperty.call(message, "vmjQrCode"))
                    writer.uint32(/* id 33, wireType 2 =*/266).string(message.vmjQrCode);
                if (message.cupQrCode != null && Object.hasOwnProperty.call(message, "cupQrCode"))
                    writer.uint32(/* id 34, wireType 2 =*/274).string(message.cupQrCode);
                if (message.naturalPerson != null && Object.hasOwnProperty.call(message, "naturalPerson"))
                    writer.uint32(/* id 35, wireType 2 =*/282).string(message.naturalPerson);
                if (message.organizationType != null && Object.hasOwnProperty.call(message, "organizationType"))
                    writer.uint32(/* id 36, wireType 0 =*/288).int32(message.organizationType);
                if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                    writer.uint32(/* id 37, wireType 2 =*/298).string(message.state);
                if (message.cancelDate != null && Object.hasOwnProperty.call(message, "cancelDate"))
                    writer.uint32(/* id 38, wireType 2 =*/306).string(message.cancelDate);
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    writer.uint32(/* id 39, wireType 2 =*/314).string(message.lastUpdateTime);
                if (message.lastUploadTime != null && Object.hasOwnProperty.call(message, "lastUploadTime"))
                    writer.uint32(/* id 40, wireType 2 =*/322).string(message.lastUploadTime);
                return writer;
            };

            /**
             * Encodes the specified StoreExport message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.StoreExport.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreExport} message StoreExport message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StoreExport.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a StoreExport message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.StoreExport} StoreExport
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StoreExport.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.StoreExport();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.code = reader.string();
                        break;
                    case 2:
                        message.isQuota = reader.string();
                        break;
                    case 3:
                        message.tidNumber = reader.string();
                        break;
                    case 4:
                        message.type = reader.string();
                        break;
                    case 5:
                        message.typeDescription = reader.string();
                        break;
                    case 6:
                        message.headId = reader.string();
                        break;
                    case 7:
                        message.headDescription = reader.string();
                        break;
                    case 8:
                        message.registerName = reader.string();
                        break;
                    case 9:
                        message.engName = reader.string();
                        break;
                    case 10:
                        message.signTitle = reader.string();
                        break;
                    case 11:
                        message.nickName = reader.string();
                        break;
                    case 12:
                        message.mccCode = reader.string();
                        break;
                    case 13:
                        message.mccDescription = reader.string();
                        break;
                    case 14:
                        message.guiNumber = reader.string();
                        break;
                    case 15:
                        message.registerPostalCode1 = reader.string();
                        break;
                    case 16:
                        message.registerPostalCode2 = reader.string();
                        break;
                    case 17:
                        message.registerAddress = reader.string();
                        break;
                    case 18:
                        message.businessPostalCode1 = reader.string();
                        break;
                    case 19:
                        message.businessPostalCode2 = reader.string();
                        break;
                    case 20:
                        message.businessAddress = reader.string();
                        break;
                    case 21:
                        message.bankCode = reader.string();
                        break;
                    case 22:
                        message.bankName = reader.string();
                        break;
                    case 23:
                        message.isPaper = reader.string();
                        break;
                    case 24:
                        message.receiptName = reader.string();
                        break;
                    case 25:
                        message.receiptPostalCode1 = reader.string();
                        break;
                    case 26:
                        message.receiptPostalCode2 = reader.string();
                        break;
                    case 27:
                        message.receiptAddress = reader.string();
                        break;
                    case 28:
                        message.receiptGenerateType = reader.string();
                        break;
                    case 29:
                        message.receiptGenerateCycle = reader.string();
                        break;
                    case 30:
                        message.receiptGenerateBasis = reader.string();
                        break;
                    case 31:
                        message.smartPay = reader.string();
                        break;
                    case 32:
                        message.commonQrCode = reader.string();
                        break;
                    case 33:
                        message.vmjQrCode = reader.string();
                        break;
                    case 34:
                        message.cupQrCode = reader.string();
                        break;
                    case 35:
                        message.naturalPerson = reader.string();
                        break;
                    case 36:
                        message.organizationType = reader.int32();
                        break;
                    case 37:
                        message.state = reader.string();
                        break;
                    case 38:
                        message.cancelDate = reader.string();
                        break;
                    case 39:
                        message.lastUpdateTime = reader.string();
                        break;
                    case 40:
                        message.lastUploadTime = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a StoreExport message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.StoreExport} StoreExport
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StoreExport.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a StoreExport message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            StoreExport.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.code != null && message.hasOwnProperty("code"))
                    if (!$util.isString(message.code))
                        return "code: string expected";
                if (message.isQuota != null && message.hasOwnProperty("isQuota"))
                    if (!$util.isString(message.isQuota))
                        return "isQuota: string expected";
                if (message.tidNumber != null && message.hasOwnProperty("tidNumber"))
                    if (!$util.isString(message.tidNumber))
                        return "tidNumber: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                if (message.typeDescription != null && message.hasOwnProperty("typeDescription"))
                    if (!$util.isString(message.typeDescription))
                        return "typeDescription: string expected";
                if (message.headId != null && message.hasOwnProperty("headId"))
                    if (!$util.isString(message.headId))
                        return "headId: string expected";
                if (message.headDescription != null && message.hasOwnProperty("headDescription"))
                    if (!$util.isString(message.headDescription))
                        return "headDescription: string expected";
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    if (!$util.isString(message.registerName))
                        return "registerName: string expected";
                if (message.engName != null && message.hasOwnProperty("engName"))
                    if (!$util.isString(message.engName))
                        return "engName: string expected";
                if (message.signTitle != null && message.hasOwnProperty("signTitle"))
                    if (!$util.isString(message.signTitle))
                        return "signTitle: string expected";
                if (message.nickName != null && message.hasOwnProperty("nickName"))
                    if (!$util.isString(message.nickName))
                        return "nickName: string expected";
                if (message.mccCode != null && message.hasOwnProperty("mccCode"))
                    if (!$util.isString(message.mccCode))
                        return "mccCode: string expected";
                if (message.mccDescription != null && message.hasOwnProperty("mccDescription"))
                    if (!$util.isString(message.mccDescription))
                        return "mccDescription: string expected";
                if (message.guiNumber != null && message.hasOwnProperty("guiNumber"))
                    if (!$util.isString(message.guiNumber))
                        return "guiNumber: string expected";
                if (message.registerPostalCode1 != null && message.hasOwnProperty("registerPostalCode1"))
                    if (!$util.isString(message.registerPostalCode1))
                        return "registerPostalCode1: string expected";
                if (message.registerPostalCode2 != null && message.hasOwnProperty("registerPostalCode2"))
                    if (!$util.isString(message.registerPostalCode2))
                        return "registerPostalCode2: string expected";
                if (message.registerAddress != null && message.hasOwnProperty("registerAddress"))
                    if (!$util.isString(message.registerAddress))
                        return "registerAddress: string expected";
                if (message.businessPostalCode1 != null && message.hasOwnProperty("businessPostalCode1"))
                    if (!$util.isString(message.businessPostalCode1))
                        return "businessPostalCode1: string expected";
                if (message.businessPostalCode2 != null && message.hasOwnProperty("businessPostalCode2"))
                    if (!$util.isString(message.businessPostalCode2))
                        return "businessPostalCode2: string expected";
                if (message.businessAddress != null && message.hasOwnProperty("businessAddress"))
                    if (!$util.isString(message.businessAddress))
                        return "businessAddress: string expected";
                if (message.bankCode != null && message.hasOwnProperty("bankCode"))
                    if (!$util.isString(message.bankCode))
                        return "bankCode: string expected";
                if (message.bankName != null && message.hasOwnProperty("bankName"))
                    if (!$util.isString(message.bankName))
                        return "bankName: string expected";
                if (message.isPaper != null && message.hasOwnProperty("isPaper"))
                    if (!$util.isString(message.isPaper))
                        return "isPaper: string expected";
                if (message.receiptName != null && message.hasOwnProperty("receiptName"))
                    if (!$util.isString(message.receiptName))
                        return "receiptName: string expected";
                if (message.receiptPostalCode1 != null && message.hasOwnProperty("receiptPostalCode1"))
                    if (!$util.isString(message.receiptPostalCode1))
                        return "receiptPostalCode1: string expected";
                if (message.receiptPostalCode2 != null && message.hasOwnProperty("receiptPostalCode2"))
                    if (!$util.isString(message.receiptPostalCode2))
                        return "receiptPostalCode2: string expected";
                if (message.receiptAddress != null && message.hasOwnProperty("receiptAddress"))
                    if (!$util.isString(message.receiptAddress))
                        return "receiptAddress: string expected";
                if (message.receiptGenerateType != null && message.hasOwnProperty("receiptGenerateType"))
                    if (!$util.isString(message.receiptGenerateType))
                        return "receiptGenerateType: string expected";
                if (message.receiptGenerateCycle != null && message.hasOwnProperty("receiptGenerateCycle"))
                    if (!$util.isString(message.receiptGenerateCycle))
                        return "receiptGenerateCycle: string expected";
                if (message.receiptGenerateBasis != null && message.hasOwnProperty("receiptGenerateBasis"))
                    if (!$util.isString(message.receiptGenerateBasis))
                        return "receiptGenerateBasis: string expected";
                if (message.smartPay != null && message.hasOwnProperty("smartPay"))
                    if (!$util.isString(message.smartPay))
                        return "smartPay: string expected";
                if (message.commonQrCode != null && message.hasOwnProperty("commonQrCode"))
                    if (!$util.isString(message.commonQrCode))
                        return "commonQrCode: string expected";
                if (message.vmjQrCode != null && message.hasOwnProperty("vmjQrCode"))
                    if (!$util.isString(message.vmjQrCode))
                        return "vmjQrCode: string expected";
                if (message.cupQrCode != null && message.hasOwnProperty("cupQrCode"))
                    if (!$util.isString(message.cupQrCode))
                        return "cupQrCode: string expected";
                if (message.naturalPerson != null && message.hasOwnProperty("naturalPerson"))
                    if (!$util.isString(message.naturalPerson))
                        return "naturalPerson: string expected";
                if (message.organizationType != null && message.hasOwnProperty("organizationType"))
                    if (!$util.isInteger(message.organizationType))
                        return "organizationType: integer expected";
                if (message.state != null && message.hasOwnProperty("state"))
                    if (!$util.isString(message.state))
                        return "state: string expected";
                if (message.cancelDate != null && message.hasOwnProperty("cancelDate"))
                    if (!$util.isString(message.cancelDate))
                        return "cancelDate: string expected";
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    if (!$util.isString(message.lastUpdateTime))
                        return "lastUpdateTime: string expected";
                if (message.lastUploadTime != null && message.hasOwnProperty("lastUploadTime"))
                    if (!$util.isString(message.lastUploadTime))
                        return "lastUploadTime: string expected";
                return null;
            };

            /**
             * Creates a StoreExport message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.StoreExport} StoreExport
             */
            StoreExport.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.StoreExport)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.StoreExport();
                if (object.code != null)
                    message.code = String(object.code);
                if (object.isQuota != null)
                    message.isQuota = String(object.isQuota);
                if (object.tidNumber != null)
                    message.tidNumber = String(object.tidNumber);
                if (object.type != null)
                    message.type = String(object.type);
                if (object.typeDescription != null)
                    message.typeDescription = String(object.typeDescription);
                if (object.headId != null)
                    message.headId = String(object.headId);
                if (object.headDescription != null)
                    message.headDescription = String(object.headDescription);
                if (object.registerName != null)
                    message.registerName = String(object.registerName);
                if (object.engName != null)
                    message.engName = String(object.engName);
                if (object.signTitle != null)
                    message.signTitle = String(object.signTitle);
                if (object.nickName != null)
                    message.nickName = String(object.nickName);
                if (object.mccCode != null)
                    message.mccCode = String(object.mccCode);
                if (object.mccDescription != null)
                    message.mccDescription = String(object.mccDescription);
                if (object.guiNumber != null)
                    message.guiNumber = String(object.guiNumber);
                if (object.registerPostalCode1 != null)
                    message.registerPostalCode1 = String(object.registerPostalCode1);
                if (object.registerPostalCode2 != null)
                    message.registerPostalCode2 = String(object.registerPostalCode2);
                if (object.registerAddress != null)
                    message.registerAddress = String(object.registerAddress);
                if (object.businessPostalCode1 != null)
                    message.businessPostalCode1 = String(object.businessPostalCode1);
                if (object.businessPostalCode2 != null)
                    message.businessPostalCode2 = String(object.businessPostalCode2);
                if (object.businessAddress != null)
                    message.businessAddress = String(object.businessAddress);
                if (object.bankCode != null)
                    message.bankCode = String(object.bankCode);
                if (object.bankName != null)
                    message.bankName = String(object.bankName);
                if (object.isPaper != null)
                    message.isPaper = String(object.isPaper);
                if (object.receiptName != null)
                    message.receiptName = String(object.receiptName);
                if (object.receiptPostalCode1 != null)
                    message.receiptPostalCode1 = String(object.receiptPostalCode1);
                if (object.receiptPostalCode2 != null)
                    message.receiptPostalCode2 = String(object.receiptPostalCode2);
                if (object.receiptAddress != null)
                    message.receiptAddress = String(object.receiptAddress);
                if (object.receiptGenerateType != null)
                    message.receiptGenerateType = String(object.receiptGenerateType);
                if (object.receiptGenerateCycle != null)
                    message.receiptGenerateCycle = String(object.receiptGenerateCycle);
                if (object.receiptGenerateBasis != null)
                    message.receiptGenerateBasis = String(object.receiptGenerateBasis);
                if (object.smartPay != null)
                    message.smartPay = String(object.smartPay);
                if (object.commonQrCode != null)
                    message.commonQrCode = String(object.commonQrCode);
                if (object.vmjQrCode != null)
                    message.vmjQrCode = String(object.vmjQrCode);
                if (object.cupQrCode != null)
                    message.cupQrCode = String(object.cupQrCode);
                if (object.naturalPerson != null)
                    message.naturalPerson = String(object.naturalPerson);
                if (object.organizationType != null)
                    message.organizationType = object.organizationType | 0;
                if (object.state != null)
                    message.state = String(object.state);
                if (object.cancelDate != null)
                    message.cancelDate = String(object.cancelDate);
                if (object.lastUpdateTime != null)
                    message.lastUpdateTime = String(object.lastUpdateTime);
                if (object.lastUploadTime != null)
                    message.lastUploadTime = String(object.lastUploadTime);
                return message;
            };

            /**
             * Creates a plain object from a StoreExport message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @static
             * @param {TCBReceiptApi.Protobuf.StoreExport} message StoreExport
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            StoreExport.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.code = "";
                    object.isQuota = "";
                    object.tidNumber = "";
                    object.type = "";
                    object.typeDescription = "";
                    object.headId = "";
                    object.headDescription = "";
                    object.registerName = "";
                    object.engName = "";
                    object.signTitle = "";
                    object.nickName = "";
                    object.mccCode = "";
                    object.mccDescription = "";
                    object.guiNumber = "";
                    object.registerPostalCode1 = "";
                    object.registerPostalCode2 = "";
                    object.registerAddress = "";
                    object.businessPostalCode1 = "";
                    object.businessPostalCode2 = "";
                    object.businessAddress = "";
                    object.bankCode = "";
                    object.bankName = "";
                    object.isPaper = "";
                    object.receiptName = "";
                    object.receiptPostalCode1 = "";
                    object.receiptPostalCode2 = "";
                    object.receiptAddress = "";
                    object.receiptGenerateType = "";
                    object.receiptGenerateCycle = "";
                    object.receiptGenerateBasis = "";
                    object.smartPay = "";
                    object.commonQrCode = "";
                    object.vmjQrCode = "";
                    object.cupQrCode = "";
                    object.naturalPerson = "";
                    object.organizationType = 0;
                    object.state = "";
                    object.cancelDate = "";
                    object.lastUpdateTime = "";
                    object.lastUploadTime = "";
                }
                if (message.code != null && message.hasOwnProperty("code"))
                    object.code = message.code;
                if (message.isQuota != null && message.hasOwnProperty("isQuota"))
                    object.isQuota = message.isQuota;
                if (message.tidNumber != null && message.hasOwnProperty("tidNumber"))
                    object.tidNumber = message.tidNumber;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.typeDescription != null && message.hasOwnProperty("typeDescription"))
                    object.typeDescription = message.typeDescription;
                if (message.headId != null && message.hasOwnProperty("headId"))
                    object.headId = message.headId;
                if (message.headDescription != null && message.hasOwnProperty("headDescription"))
                    object.headDescription = message.headDescription;
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    object.registerName = message.registerName;
                if (message.engName != null && message.hasOwnProperty("engName"))
                    object.engName = message.engName;
                if (message.signTitle != null && message.hasOwnProperty("signTitle"))
                    object.signTitle = message.signTitle;
                if (message.nickName != null && message.hasOwnProperty("nickName"))
                    object.nickName = message.nickName;
                if (message.mccCode != null && message.hasOwnProperty("mccCode"))
                    object.mccCode = message.mccCode;
                if (message.mccDescription != null && message.hasOwnProperty("mccDescription"))
                    object.mccDescription = message.mccDescription;
                if (message.guiNumber != null && message.hasOwnProperty("guiNumber"))
                    object.guiNumber = message.guiNumber;
                if (message.registerPostalCode1 != null && message.hasOwnProperty("registerPostalCode1"))
                    object.registerPostalCode1 = message.registerPostalCode1;
                if (message.registerPostalCode2 != null && message.hasOwnProperty("registerPostalCode2"))
                    object.registerPostalCode2 = message.registerPostalCode2;
                if (message.registerAddress != null && message.hasOwnProperty("registerAddress"))
                    object.registerAddress = message.registerAddress;
                if (message.businessPostalCode1 != null && message.hasOwnProperty("businessPostalCode1"))
                    object.businessPostalCode1 = message.businessPostalCode1;
                if (message.businessPostalCode2 != null && message.hasOwnProperty("businessPostalCode2"))
                    object.businessPostalCode2 = message.businessPostalCode2;
                if (message.businessAddress != null && message.hasOwnProperty("businessAddress"))
                    object.businessAddress = message.businessAddress;
                if (message.bankCode != null && message.hasOwnProperty("bankCode"))
                    object.bankCode = message.bankCode;
                if (message.bankName != null && message.hasOwnProperty("bankName"))
                    object.bankName = message.bankName;
                if (message.isPaper != null && message.hasOwnProperty("isPaper"))
                    object.isPaper = message.isPaper;
                if (message.receiptName != null && message.hasOwnProperty("receiptName"))
                    object.receiptName = message.receiptName;
                if (message.receiptPostalCode1 != null && message.hasOwnProperty("receiptPostalCode1"))
                    object.receiptPostalCode1 = message.receiptPostalCode1;
                if (message.receiptPostalCode2 != null && message.hasOwnProperty("receiptPostalCode2"))
                    object.receiptPostalCode2 = message.receiptPostalCode2;
                if (message.receiptAddress != null && message.hasOwnProperty("receiptAddress"))
                    object.receiptAddress = message.receiptAddress;
                if (message.receiptGenerateType != null && message.hasOwnProperty("receiptGenerateType"))
                    object.receiptGenerateType = message.receiptGenerateType;
                if (message.receiptGenerateCycle != null && message.hasOwnProperty("receiptGenerateCycle"))
                    object.receiptGenerateCycle = message.receiptGenerateCycle;
                if (message.receiptGenerateBasis != null && message.hasOwnProperty("receiptGenerateBasis"))
                    object.receiptGenerateBasis = message.receiptGenerateBasis;
                if (message.smartPay != null && message.hasOwnProperty("smartPay"))
                    object.smartPay = message.smartPay;
                if (message.commonQrCode != null && message.hasOwnProperty("commonQrCode"))
                    object.commonQrCode = message.commonQrCode;
                if (message.vmjQrCode != null && message.hasOwnProperty("vmjQrCode"))
                    object.vmjQrCode = message.vmjQrCode;
                if (message.cupQrCode != null && message.hasOwnProperty("cupQrCode"))
                    object.cupQrCode = message.cupQrCode;
                if (message.naturalPerson != null && message.hasOwnProperty("naturalPerson"))
                    object.naturalPerson = message.naturalPerson;
                if (message.organizationType != null && message.hasOwnProperty("organizationType"))
                    object.organizationType = message.organizationType;
                if (message.state != null && message.hasOwnProperty("state"))
                    object.state = message.state;
                if (message.cancelDate != null && message.hasOwnProperty("cancelDate"))
                    object.cancelDate = message.cancelDate;
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    object.lastUpdateTime = message.lastUpdateTime;
                if (message.lastUploadTime != null && message.hasOwnProperty("lastUploadTime"))
                    object.lastUploadTime = message.lastUploadTime;
                return object;
            };

            /**
             * Converts this StoreExport to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.StoreExport
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            StoreExport.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return StoreExport;
        })();

        Protobuf.StoreUserPermission = (function() {

            /**
             * Properties of a StoreUserPermission.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IStoreUserPermission
             * @property {number|null} [storeId] StoreUserPermission storeId
             * @property {string|null} [storeCode] StoreUserPermission storeCode
             * @property {string|null} [tidNumber] StoreUserPermission tidNumber
             * @property {string|null} [registerName] StoreUserPermission registerName
             */

            /**
             * Constructs a new StoreUserPermission.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a StoreUserPermission.
             * @implements IStoreUserPermission
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IStoreUserPermission=} [properties] Properties to set
             */
            function StoreUserPermission(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * StoreUserPermission storeId.
             * @member {number} storeId
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermission
             * @instance
             */
            StoreUserPermission.prototype.storeId = 0;

            /**
             * StoreUserPermission storeCode.
             * @member {string} storeCode
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermission
             * @instance
             */
            StoreUserPermission.prototype.storeCode = "";

            /**
             * StoreUserPermission tidNumber.
             * @member {string} tidNumber
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermission
             * @instance
             */
            StoreUserPermission.prototype.tidNumber = "";

            /**
             * StoreUserPermission registerName.
             * @member {string} registerName
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermission
             * @instance
             */
            StoreUserPermission.prototype.registerName = "";

            /**
             * Creates a new StoreUserPermission instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermission
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreUserPermission=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.StoreUserPermission} StoreUserPermission instance
             */
            StoreUserPermission.create = function create(properties) {
                return new StoreUserPermission(properties);
            };

            /**
             * Encodes the specified StoreUserPermission message. Does not implicitly {@link TCBReceiptApi.Protobuf.StoreUserPermission.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermission
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreUserPermission} message StoreUserPermission message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StoreUserPermission.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.storeId);
                if (message.storeCode != null && Object.hasOwnProperty.call(message, "storeCode"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.storeCode);
                if (message.tidNumber != null && Object.hasOwnProperty.call(message, "tidNumber"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.tidNumber);
                if (message.registerName != null && Object.hasOwnProperty.call(message, "registerName"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.registerName);
                return writer;
            };

            /**
             * Encodes the specified StoreUserPermission message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.StoreUserPermission.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermission
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreUserPermission} message StoreUserPermission message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StoreUserPermission.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a StoreUserPermission message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermission
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.StoreUserPermission} StoreUserPermission
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StoreUserPermission.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.StoreUserPermission();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.storeId = reader.int32();
                        break;
                    case 2:
                        message.storeCode = reader.string();
                        break;
                    case 3:
                        message.tidNumber = reader.string();
                        break;
                    case 4:
                        message.registerName = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a StoreUserPermission message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermission
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.StoreUserPermission} StoreUserPermission
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StoreUserPermission.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a StoreUserPermission message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermission
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            StoreUserPermission.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.storeId != null && message.hasOwnProperty("storeId"))
                    if (!$util.isInteger(message.storeId))
                        return "storeId: integer expected";
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    if (!$util.isString(message.storeCode))
                        return "storeCode: string expected";
                if (message.tidNumber != null && message.hasOwnProperty("tidNumber"))
                    if (!$util.isString(message.tidNumber))
                        return "tidNumber: string expected";
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    if (!$util.isString(message.registerName))
                        return "registerName: string expected";
                return null;
            };

            /**
             * Creates a StoreUserPermission message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermission
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.StoreUserPermission} StoreUserPermission
             */
            StoreUserPermission.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.StoreUserPermission)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.StoreUserPermission();
                if (object.storeId != null)
                    message.storeId = object.storeId | 0;
                if (object.storeCode != null)
                    message.storeCode = String(object.storeCode);
                if (object.tidNumber != null)
                    message.tidNumber = String(object.tidNumber);
                if (object.registerName != null)
                    message.registerName = String(object.registerName);
                return message;
            };

            /**
             * Creates a plain object from a StoreUserPermission message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermission
             * @static
             * @param {TCBReceiptApi.Protobuf.StoreUserPermission} message StoreUserPermission
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            StoreUserPermission.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.storeId = 0;
                    object.storeCode = "";
                    object.tidNumber = "";
                    object.registerName = "";
                }
                if (message.storeId != null && message.hasOwnProperty("storeId"))
                    object.storeId = message.storeId;
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    object.storeCode = message.storeCode;
                if (message.tidNumber != null && message.hasOwnProperty("tidNumber"))
                    object.tidNumber = message.tidNumber;
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    object.registerName = message.registerName;
                return object;
            };

            /**
             * Converts this StoreUserPermission to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermission
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            StoreUserPermission.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return StoreUserPermission;
        })();

        Protobuf.StoreUserPermissionList = (function() {

            /**
             * Properties of a StoreUserPermissionList.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IStoreUserPermissionList
             * @property {Array.<TCBReceiptApi.Protobuf.IStoreUserPermission>|null} [list] StoreUserPermissionList list
             */

            /**
             * Constructs a new StoreUserPermissionList.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a StoreUserPermissionList.
             * @implements IStoreUserPermissionList
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IStoreUserPermissionList=} [properties] Properties to set
             */
            function StoreUserPermissionList(properties) {
                this.list = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * StoreUserPermissionList list.
             * @member {Array.<TCBReceiptApi.Protobuf.IStoreUserPermission>} list
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermissionList
             * @instance
             */
            StoreUserPermissionList.prototype.list = $util.emptyArray;

            /**
             * Creates a new StoreUserPermissionList instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermissionList
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreUserPermissionList=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.StoreUserPermissionList} StoreUserPermissionList instance
             */
            StoreUserPermissionList.create = function create(properties) {
                return new StoreUserPermissionList(properties);
            };

            /**
             * Encodes the specified StoreUserPermissionList message. Does not implicitly {@link TCBReceiptApi.Protobuf.StoreUserPermissionList.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermissionList
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreUserPermissionList} message StoreUserPermissionList message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StoreUserPermissionList.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.list != null && message.list.length)
                    for (var i = 0; i < message.list.length; ++i)
                        $root.TCBReceiptApi.Protobuf.StoreUserPermission.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified StoreUserPermissionList message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.StoreUserPermissionList.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermissionList
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreUserPermissionList} message StoreUserPermissionList message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StoreUserPermissionList.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a StoreUserPermissionList message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermissionList
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.StoreUserPermissionList} StoreUserPermissionList
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StoreUserPermissionList.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.StoreUserPermissionList();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.TCBReceiptApi.Protobuf.StoreUserPermission.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a StoreUserPermissionList message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermissionList
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.StoreUserPermissionList} StoreUserPermissionList
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StoreUserPermissionList.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a StoreUserPermissionList message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermissionList
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            StoreUserPermissionList.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.list != null && message.hasOwnProperty("list")) {
                    if (!Array.isArray(message.list))
                        return "list: array expected";
                    for (var i = 0; i < message.list.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.StoreUserPermission.verify(message.list[i]);
                        if (error)
                            return "list." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a StoreUserPermissionList message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermissionList
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.StoreUserPermissionList} StoreUserPermissionList
             */
            StoreUserPermissionList.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.StoreUserPermissionList)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.StoreUserPermissionList();
                if (object.list) {
                    if (!Array.isArray(object.list))
                        throw TypeError(".TCBReceiptApi.Protobuf.StoreUserPermissionList.list: array expected");
                    message.list = [];
                    for (var i = 0; i < object.list.length; ++i) {
                        if (typeof object.list[i] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.StoreUserPermissionList.list: object expected");
                        message.list[i] = $root.TCBReceiptApi.Protobuf.StoreUserPermission.fromObject(object.list[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a StoreUserPermissionList message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermissionList
             * @static
             * @param {TCBReceiptApi.Protobuf.StoreUserPermissionList} message StoreUserPermissionList
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            StoreUserPermissionList.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.list = [];
                if (message.list && message.list.length) {
                    object.list = [];
                    for (var j = 0; j < message.list.length; ++j)
                        object.list[j] = $root.TCBReceiptApi.Protobuf.StoreUserPermission.toObject(message.list[j], options);
                }
                return object;
            };

            /**
             * Converts this StoreUserPermissionList to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermissionList
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            StoreUserPermissionList.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return StoreUserPermissionList;
        })();

        Protobuf.StoreUserPermissionMap = (function() {

            /**
             * Properties of a StoreUserPermissionMap.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IStoreUserPermissionMap
             * @property {Object.<string,TCBReceiptApi.Protobuf.IStoreUserPermissionList>|null} [map] StoreUserPermissionMap map
             */

            /**
             * Constructs a new StoreUserPermissionMap.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a StoreUserPermissionMap.
             * @implements IStoreUserPermissionMap
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IStoreUserPermissionMap=} [properties] Properties to set
             */
            function StoreUserPermissionMap(properties) {
                this.map = {};
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * StoreUserPermissionMap map.
             * @member {Object.<string,TCBReceiptApi.Protobuf.IStoreUserPermissionList>} map
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermissionMap
             * @instance
             */
            StoreUserPermissionMap.prototype.map = $util.emptyObject;

            /**
             * Creates a new StoreUserPermissionMap instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermissionMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreUserPermissionMap=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.StoreUserPermissionMap} StoreUserPermissionMap instance
             */
            StoreUserPermissionMap.create = function create(properties) {
                return new StoreUserPermissionMap(properties);
            };

            /**
             * Encodes the specified StoreUserPermissionMap message. Does not implicitly {@link TCBReceiptApi.Protobuf.StoreUserPermissionMap.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermissionMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreUserPermissionMap} message StoreUserPermissionMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StoreUserPermissionMap.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.map != null && Object.hasOwnProperty.call(message, "map"))
                    for (var keys = Object.keys(message.map), i = 0; i < keys.length; ++i) {
                        writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                        $root.TCBReceiptApi.Protobuf.StoreUserPermissionList.encode(message.map[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                    }
                return writer;
            };

            /**
             * Encodes the specified StoreUserPermissionMap message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.StoreUserPermissionMap.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermissionMap
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreUserPermissionMap} message StoreUserPermissionMap message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StoreUserPermissionMap.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a StoreUserPermissionMap message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermissionMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.StoreUserPermissionMap} StoreUserPermissionMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StoreUserPermissionMap.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.StoreUserPermissionMap(), key, value;
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (message.map === $util.emptyObject)
                            message.map = {};
                        var end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = null;
                        while (reader.pos < end2) {
                            var tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = $root.TCBReceiptApi.Protobuf.StoreUserPermissionList.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.map[key] = value;
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a StoreUserPermissionMap message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermissionMap
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.StoreUserPermissionMap} StoreUserPermissionMap
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StoreUserPermissionMap.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a StoreUserPermissionMap message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermissionMap
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            StoreUserPermissionMap.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.map != null && message.hasOwnProperty("map")) {
                    if (!$util.isObject(message.map))
                        return "map: object expected";
                    var key = Object.keys(message.map);
                    for (var i = 0; i < key.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.StoreUserPermissionList.verify(message.map[key[i]]);
                        if (error)
                            return "map." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a StoreUserPermissionMap message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermissionMap
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.StoreUserPermissionMap} StoreUserPermissionMap
             */
            StoreUserPermissionMap.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.StoreUserPermissionMap)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.StoreUserPermissionMap();
                if (object.map) {
                    if (typeof object.map !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.StoreUserPermissionMap.map: object expected");
                    message.map = {};
                    for (var keys = Object.keys(object.map), i = 0; i < keys.length; ++i) {
                        if (typeof object.map[keys[i]] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.StoreUserPermissionMap.map: object expected");
                        message.map[keys[i]] = $root.TCBReceiptApi.Protobuf.StoreUserPermissionList.fromObject(object.map[keys[i]]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a StoreUserPermissionMap message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermissionMap
             * @static
             * @param {TCBReceiptApi.Protobuf.StoreUserPermissionMap} message StoreUserPermissionMap
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            StoreUserPermissionMap.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.objects || options.defaults)
                    object.map = {};
                var keys2;
                if (message.map && (keys2 = Object.keys(message.map)).length) {
                    object.map = {};
                    for (var j = 0; j < keys2.length; ++j)
                        object.map[keys2[j]] = $root.TCBReceiptApi.Protobuf.StoreUserPermissionList.toObject(message.map[keys2[j]], options);
                }
                return object;
            };

            /**
             * Converts this StoreUserPermissionMap to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.StoreUserPermissionMap
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            StoreUserPermissionMap.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return StoreUserPermissionMap;
        })();

        Protobuf.StoreUserMotify = (function() {

            /**
             * Properties of a StoreUserMotify.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IStoreUserMotify
             * @property {number|null} [resetMail] StoreUserMotify resetMail
             * @property {number|null} [permission] StoreUserMotify permission
             * @property {number|null} [state] StoreUserMotify state
             */

            /**
             * Constructs a new StoreUserMotify.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a StoreUserMotify.
             * @implements IStoreUserMotify
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IStoreUserMotify=} [properties] Properties to set
             */
            function StoreUserMotify(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * StoreUserMotify resetMail.
             * @member {number} resetMail
             * @memberof TCBReceiptApi.Protobuf.StoreUserMotify
             * @instance
             */
            StoreUserMotify.prototype.resetMail = 0;

            /**
             * StoreUserMotify permission.
             * @member {number} permission
             * @memberof TCBReceiptApi.Protobuf.StoreUserMotify
             * @instance
             */
            StoreUserMotify.prototype.permission = 0;

            /**
             * StoreUserMotify state.
             * @member {number} state
             * @memberof TCBReceiptApi.Protobuf.StoreUserMotify
             * @instance
             */
            StoreUserMotify.prototype.state = 0;

            /**
             * Creates a new StoreUserMotify instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.StoreUserMotify
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreUserMotify=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.StoreUserMotify} StoreUserMotify instance
             */
            StoreUserMotify.create = function create(properties) {
                return new StoreUserMotify(properties);
            };

            /**
             * Encodes the specified StoreUserMotify message. Does not implicitly {@link TCBReceiptApi.Protobuf.StoreUserMotify.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.StoreUserMotify
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreUserMotify} message StoreUserMotify message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StoreUserMotify.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.resetMail != null && Object.hasOwnProperty.call(message, "resetMail"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.resetMail);
                if (message.permission != null && Object.hasOwnProperty.call(message, "permission"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.permission);
                if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.state);
                return writer;
            };

            /**
             * Encodes the specified StoreUserMotify message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.StoreUserMotify.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.StoreUserMotify
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreUserMotify} message StoreUserMotify message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StoreUserMotify.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a StoreUserMotify message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.StoreUserMotify
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.StoreUserMotify} StoreUserMotify
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StoreUserMotify.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.StoreUserMotify();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.resetMail = reader.int32();
                        break;
                    case 2:
                        message.permission = reader.int32();
                        break;
                    case 3:
                        message.state = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a StoreUserMotify message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.StoreUserMotify
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.StoreUserMotify} StoreUserMotify
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StoreUserMotify.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a StoreUserMotify message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.StoreUserMotify
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            StoreUserMotify.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.resetMail != null && message.hasOwnProperty("resetMail"))
                    if (!$util.isInteger(message.resetMail))
                        return "resetMail: integer expected";
                if (message.permission != null && message.hasOwnProperty("permission"))
                    if (!$util.isInteger(message.permission))
                        return "permission: integer expected";
                if (message.state != null && message.hasOwnProperty("state"))
                    if (!$util.isInteger(message.state))
                        return "state: integer expected";
                return null;
            };

            /**
             * Creates a StoreUserMotify message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.StoreUserMotify
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.StoreUserMotify} StoreUserMotify
             */
            StoreUserMotify.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.StoreUserMotify)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.StoreUserMotify();
                if (object.resetMail != null)
                    message.resetMail = object.resetMail | 0;
                if (object.permission != null)
                    message.permission = object.permission | 0;
                if (object.state != null)
                    message.state = object.state | 0;
                return message;
            };

            /**
             * Creates a plain object from a StoreUserMotify message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.StoreUserMotify
             * @static
             * @param {TCBReceiptApi.Protobuf.StoreUserMotify} message StoreUserMotify
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            StoreUserMotify.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.resetMail = 0;
                    object.permission = 0;
                    object.state = 0;
                }
                if (message.resetMail != null && message.hasOwnProperty("resetMail"))
                    object.resetMail = message.resetMail;
                if (message.permission != null && message.hasOwnProperty("permission"))
                    object.permission = message.permission;
                if (message.state != null && message.hasOwnProperty("state"))
                    object.state = message.state;
                return object;
            };

            /**
             * Converts this StoreUserMotify to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.StoreUserMotify
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            StoreUserMotify.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return StoreUserMotify;
        })();

        Protobuf.StoreUser = (function() {

            /**
             * Properties of a StoreUser.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IStoreUser
             * @property {number|null} [storeUserTempId] StoreUser storeUserTempId
             * @property {number|null} [storeUserId] StoreUser storeUserId
             * @property {number|null} [actionType] StoreUser actionType
             * @property {number|null} [type] StoreUser type
             * @property {string|null} [identification] StoreUser identification
             * @property {string|null} [account] StoreUser account
             * @property {string|null} [resetMail] StoreUser resetMail
             * @property {Object.<string,TCBReceiptApi.Protobuf.IStoreUserPermissionList>|null} [permission] StoreUser permission
             * @property {number|null} [state] StoreUser state
             * @property {number|null} [lock] StoreUser lock
             * @property {number|null} [active] StoreUser active
             * @property {number|null} [lastUpdateTime] StoreUser lastUpdateTime
             * @property {string|null} [lastUpdateUser] StoreUser lastUpdateUser
             * @property {string|null} [cancelDate] StoreUser cancelDate
             * @property {number|null} [permissionId] StoreUser permissionId
             * @property {number|null} [releaseState] StoreUser releaseState
             * @property {string|null} [tidNumber] StoreUser tidNumber
             * @property {string|null} [storeCode] StoreUser storeCode
             * @property {string|null} [registerName] StoreUser registerName
             * @property {TCBReceiptApi.Protobuf.IStoreUserMotify|null} [motify] StoreUser motify
             * @property {string|null} [rejectReason] StoreUser rejectReason
             * @property {Object.<string,TCBReceiptApi.Protobuf.IStoreUserPermissionList>|null} [selectMap] StoreUser selectMap
             * @property {number|null} [systemGenerate] StoreUser systemGenerate
             * @property {number|null} [loginFailedCount] StoreUser loginFailedCount
             * @property {number|null} [resetExpiresIn] StoreUser resetExpiresIn
             * @property {string|null} [continueDate] StoreUser continueDate
             * @property {number|null} [loginType] StoreUser loginType
             * @property {string|null} [storeCancelDate] StoreUser storeCancelDate
             * @property {number|null} [e2eeFlag] StoreUser e2eeFlag
             * @property {string|null} [e2eePd] StoreUser e2eePd
             */

            /**
             * Constructs a new StoreUser.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a StoreUser.
             * @implements IStoreUser
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IStoreUser=} [properties] Properties to set
             */
            function StoreUser(properties) {
                this.permission = {};
                this.selectMap = {};
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * StoreUser storeUserTempId.
             * @member {number} storeUserTempId
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @instance
             */
            StoreUser.prototype.storeUserTempId = 0;

            /**
             * StoreUser storeUserId.
             * @member {number} storeUserId
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @instance
             */
            StoreUser.prototype.storeUserId = 0;

            /**
             * StoreUser actionType.
             * @member {number} actionType
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @instance
             */
            StoreUser.prototype.actionType = 0;

            /**
             * StoreUser type.
             * @member {number} type
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @instance
             */
            StoreUser.prototype.type = 0;

            /**
             * StoreUser identification.
             * @member {string} identification
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @instance
             */
            StoreUser.prototype.identification = "";

            /**
             * StoreUser account.
             * @member {string} account
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @instance
             */
            StoreUser.prototype.account = "";

            /**
             * StoreUser resetMail.
             * @member {string} resetMail
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @instance
             */
            StoreUser.prototype.resetMail = "";

            /**
             * StoreUser permission.
             * @member {Object.<string,TCBReceiptApi.Protobuf.IStoreUserPermissionList>} permission
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @instance
             */
            StoreUser.prototype.permission = $util.emptyObject;

            /**
             * StoreUser state.
             * @member {number} state
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @instance
             */
            StoreUser.prototype.state = 0;

            /**
             * StoreUser lock.
             * @member {number} lock
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @instance
             */
            StoreUser.prototype.lock = 0;

            /**
             * StoreUser active.
             * @member {number} active
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @instance
             */
            StoreUser.prototype.active = 0;

            /**
             * StoreUser lastUpdateTime.
             * @member {number} lastUpdateTime
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @instance
             */
            StoreUser.prototype.lastUpdateTime = 0;

            /**
             * StoreUser lastUpdateUser.
             * @member {string} lastUpdateUser
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @instance
             */
            StoreUser.prototype.lastUpdateUser = "";

            /**
             * StoreUser cancelDate.
             * @member {string} cancelDate
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @instance
             */
            StoreUser.prototype.cancelDate = "";

            /**
             * StoreUser permissionId.
             * @member {number} permissionId
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @instance
             */
            StoreUser.prototype.permissionId = 0;

            /**
             * StoreUser releaseState.
             * @member {number} releaseState
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @instance
             */
            StoreUser.prototype.releaseState = 0;

            /**
             * StoreUser tidNumber.
             * @member {string} tidNumber
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @instance
             */
            StoreUser.prototype.tidNumber = "";

            /**
             * StoreUser storeCode.
             * @member {string} storeCode
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @instance
             */
            StoreUser.prototype.storeCode = "";

            /**
             * StoreUser registerName.
             * @member {string} registerName
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @instance
             */
            StoreUser.prototype.registerName = "";

            /**
             * StoreUser motify.
             * @member {TCBReceiptApi.Protobuf.IStoreUserMotify|null|undefined} motify
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @instance
             */
            StoreUser.prototype.motify = null;

            /**
             * StoreUser rejectReason.
             * @member {string} rejectReason
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @instance
             */
            StoreUser.prototype.rejectReason = "";

            /**
             * StoreUser selectMap.
             * @member {Object.<string,TCBReceiptApi.Protobuf.IStoreUserPermissionList>} selectMap
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @instance
             */
            StoreUser.prototype.selectMap = $util.emptyObject;

            /**
             * StoreUser systemGenerate.
             * @member {number} systemGenerate
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @instance
             */
            StoreUser.prototype.systemGenerate = 0;

            /**
             * StoreUser loginFailedCount.
             * @member {number} loginFailedCount
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @instance
             */
            StoreUser.prototype.loginFailedCount = 0;

            /**
             * StoreUser resetExpiresIn.
             * @member {number} resetExpiresIn
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @instance
             */
            StoreUser.prototype.resetExpiresIn = 0;

            /**
             * StoreUser continueDate.
             * @member {string} continueDate
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @instance
             */
            StoreUser.prototype.continueDate = "";

            /**
             * StoreUser loginType.
             * @member {number} loginType
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @instance
             */
            StoreUser.prototype.loginType = 0;

            /**
             * StoreUser storeCancelDate.
             * @member {string} storeCancelDate
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @instance
             */
            StoreUser.prototype.storeCancelDate = "";

            /**
             * StoreUser e2eeFlag.
             * @member {number} e2eeFlag
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @instance
             */
            StoreUser.prototype.e2eeFlag = 0;

            /**
             * StoreUser e2eePd.
             * @member {string} e2eePd
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @instance
             */
            StoreUser.prototype.e2eePd = "";

            /**
             * Creates a new StoreUser instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreUser=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.StoreUser} StoreUser instance
             */
            StoreUser.create = function create(properties) {
                return new StoreUser(properties);
            };

            /**
             * Encodes the specified StoreUser message. Does not implicitly {@link TCBReceiptApi.Protobuf.StoreUser.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreUser} message StoreUser message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StoreUser.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.storeUserTempId != null && Object.hasOwnProperty.call(message, "storeUserTempId"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.storeUserTempId);
                if (message.storeUserId != null && Object.hasOwnProperty.call(message, "storeUserId"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.storeUserId);
                if (message.actionType != null && Object.hasOwnProperty.call(message, "actionType"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.actionType);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.type);
                if (message.identification != null && Object.hasOwnProperty.call(message, "identification"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.identification);
                if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.account);
                if (message.resetMail != null && Object.hasOwnProperty.call(message, "resetMail"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.resetMail);
                if (message.permission != null && Object.hasOwnProperty.call(message, "permission"))
                    for (var keys = Object.keys(message.permission), i = 0; i < keys.length; ++i) {
                        writer.uint32(/* id 8, wireType 2 =*/66).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                        $root.TCBReceiptApi.Protobuf.StoreUserPermissionList.encode(message.permission[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                    }
                if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                    writer.uint32(/* id 9, wireType 0 =*/72).int32(message.state);
                if (message.lock != null && Object.hasOwnProperty.call(message, "lock"))
                    writer.uint32(/* id 10, wireType 0 =*/80).int32(message.lock);
                if (message.active != null && Object.hasOwnProperty.call(message, "active"))
                    writer.uint32(/* id 11, wireType 0 =*/88).int32(message.active);
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    writer.uint32(/* id 12, wireType 0 =*/96).int32(message.lastUpdateTime);
                if (message.lastUpdateUser != null && Object.hasOwnProperty.call(message, "lastUpdateUser"))
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.lastUpdateUser);
                if (message.cancelDate != null && Object.hasOwnProperty.call(message, "cancelDate"))
                    writer.uint32(/* id 14, wireType 2 =*/114).string(message.cancelDate);
                if (message.permissionId != null && Object.hasOwnProperty.call(message, "permissionId"))
                    writer.uint32(/* id 15, wireType 0 =*/120).int32(message.permissionId);
                if (message.releaseState != null && Object.hasOwnProperty.call(message, "releaseState"))
                    writer.uint32(/* id 16, wireType 0 =*/128).int32(message.releaseState);
                if (message.tidNumber != null && Object.hasOwnProperty.call(message, "tidNumber"))
                    writer.uint32(/* id 17, wireType 2 =*/138).string(message.tidNumber);
                if (message.storeCode != null && Object.hasOwnProperty.call(message, "storeCode"))
                    writer.uint32(/* id 18, wireType 2 =*/146).string(message.storeCode);
                if (message.registerName != null && Object.hasOwnProperty.call(message, "registerName"))
                    writer.uint32(/* id 19, wireType 2 =*/154).string(message.registerName);
                if (message.motify != null && Object.hasOwnProperty.call(message, "motify"))
                    $root.TCBReceiptApi.Protobuf.StoreUserMotify.encode(message.motify, writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
                if (message.rejectReason != null && Object.hasOwnProperty.call(message, "rejectReason"))
                    writer.uint32(/* id 21, wireType 2 =*/170).string(message.rejectReason);
                if (message.selectMap != null && Object.hasOwnProperty.call(message, "selectMap"))
                    for (var keys = Object.keys(message.selectMap), i = 0; i < keys.length; ++i) {
                        writer.uint32(/* id 22, wireType 2 =*/178).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                        $root.TCBReceiptApi.Protobuf.StoreUserPermissionList.encode(message.selectMap[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                    }
                if (message.systemGenerate != null && Object.hasOwnProperty.call(message, "systemGenerate"))
                    writer.uint32(/* id 23, wireType 0 =*/184).int32(message.systemGenerate);
                if (message.loginFailedCount != null && Object.hasOwnProperty.call(message, "loginFailedCount"))
                    writer.uint32(/* id 24, wireType 0 =*/192).int32(message.loginFailedCount);
                if (message.resetExpiresIn != null && Object.hasOwnProperty.call(message, "resetExpiresIn"))
                    writer.uint32(/* id 25, wireType 0 =*/200).int32(message.resetExpiresIn);
                if (message.continueDate != null && Object.hasOwnProperty.call(message, "continueDate"))
                    writer.uint32(/* id 26, wireType 2 =*/210).string(message.continueDate);
                if (message.loginType != null && Object.hasOwnProperty.call(message, "loginType"))
                    writer.uint32(/* id 27, wireType 0 =*/216).int32(message.loginType);
                if (message.storeCancelDate != null && Object.hasOwnProperty.call(message, "storeCancelDate"))
                    writer.uint32(/* id 28, wireType 2 =*/226).string(message.storeCancelDate);
                if (message.e2eeFlag != null && Object.hasOwnProperty.call(message, "e2eeFlag"))
                    writer.uint32(/* id 29, wireType 0 =*/232).int32(message.e2eeFlag);
                if (message.e2eePd != null && Object.hasOwnProperty.call(message, "e2eePd"))
                    writer.uint32(/* id 30, wireType 2 =*/242).string(message.e2eePd);
                return writer;
            };

            /**
             * Encodes the specified StoreUser message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.StoreUser.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreUser} message StoreUser message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StoreUser.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a StoreUser message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.StoreUser} StoreUser
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StoreUser.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.StoreUser(), key, value;
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.storeUserTempId = reader.int32();
                        break;
                    case 2:
                        message.storeUserId = reader.int32();
                        break;
                    case 3:
                        message.actionType = reader.int32();
                        break;
                    case 4:
                        message.type = reader.int32();
                        break;
                    case 5:
                        message.identification = reader.string();
                        break;
                    case 6:
                        message.account = reader.string();
                        break;
                    case 7:
                        message.resetMail = reader.string();
                        break;
                    case 8:
                        if (message.permission === $util.emptyObject)
                            message.permission = {};
                        var end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = null;
                        while (reader.pos < end2) {
                            var tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = $root.TCBReceiptApi.Protobuf.StoreUserPermissionList.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.permission[key] = value;
                        break;
                    case 9:
                        message.state = reader.int32();
                        break;
                    case 10:
                        message.lock = reader.int32();
                        break;
                    case 11:
                        message.active = reader.int32();
                        break;
                    case 12:
                        message.lastUpdateTime = reader.int32();
                        break;
                    case 13:
                        message.lastUpdateUser = reader.string();
                        break;
                    case 14:
                        message.cancelDate = reader.string();
                        break;
                    case 15:
                        message.permissionId = reader.int32();
                        break;
                    case 16:
                        message.releaseState = reader.int32();
                        break;
                    case 17:
                        message.tidNumber = reader.string();
                        break;
                    case 18:
                        message.storeCode = reader.string();
                        break;
                    case 19:
                        message.registerName = reader.string();
                        break;
                    case 20:
                        message.motify = $root.TCBReceiptApi.Protobuf.StoreUserMotify.decode(reader, reader.uint32());
                        break;
                    case 21:
                        message.rejectReason = reader.string();
                        break;
                    case 22:
                        if (message.selectMap === $util.emptyObject)
                            message.selectMap = {};
                        var end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = null;
                        while (reader.pos < end2) {
                            var tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = $root.TCBReceiptApi.Protobuf.StoreUserPermissionList.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.selectMap[key] = value;
                        break;
                    case 23:
                        message.systemGenerate = reader.int32();
                        break;
                    case 24:
                        message.loginFailedCount = reader.int32();
                        break;
                    case 25:
                        message.resetExpiresIn = reader.int32();
                        break;
                    case 26:
                        message.continueDate = reader.string();
                        break;
                    case 27:
                        message.loginType = reader.int32();
                        break;
                    case 28:
                        message.storeCancelDate = reader.string();
                        break;
                    case 29:
                        message.e2eeFlag = reader.int32();
                        break;
                    case 30:
                        message.e2eePd = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a StoreUser message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.StoreUser} StoreUser
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StoreUser.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a StoreUser message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            StoreUser.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.storeUserTempId != null && message.hasOwnProperty("storeUserTempId"))
                    if (!$util.isInteger(message.storeUserTempId))
                        return "storeUserTempId: integer expected";
                if (message.storeUserId != null && message.hasOwnProperty("storeUserId"))
                    if (!$util.isInteger(message.storeUserId))
                        return "storeUserId: integer expected";
                if (message.actionType != null && message.hasOwnProperty("actionType"))
                    if (!$util.isInteger(message.actionType))
                        return "actionType: integer expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isInteger(message.type))
                        return "type: integer expected";
                if (message.identification != null && message.hasOwnProperty("identification"))
                    if (!$util.isString(message.identification))
                        return "identification: string expected";
                if (message.account != null && message.hasOwnProperty("account"))
                    if (!$util.isString(message.account))
                        return "account: string expected";
                if (message.resetMail != null && message.hasOwnProperty("resetMail"))
                    if (!$util.isString(message.resetMail))
                        return "resetMail: string expected";
                if (message.permission != null && message.hasOwnProperty("permission")) {
                    if (!$util.isObject(message.permission))
                        return "permission: object expected";
                    var key = Object.keys(message.permission);
                    for (var i = 0; i < key.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.StoreUserPermissionList.verify(message.permission[key[i]]);
                        if (error)
                            return "permission." + error;
                    }
                }
                if (message.state != null && message.hasOwnProperty("state"))
                    if (!$util.isInteger(message.state))
                        return "state: integer expected";
                if (message.lock != null && message.hasOwnProperty("lock"))
                    if (!$util.isInteger(message.lock))
                        return "lock: integer expected";
                if (message.active != null && message.hasOwnProperty("active"))
                    if (!$util.isInteger(message.active))
                        return "active: integer expected";
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    if (!$util.isInteger(message.lastUpdateTime))
                        return "lastUpdateTime: integer expected";
                if (message.lastUpdateUser != null && message.hasOwnProperty("lastUpdateUser"))
                    if (!$util.isString(message.lastUpdateUser))
                        return "lastUpdateUser: string expected";
                if (message.cancelDate != null && message.hasOwnProperty("cancelDate"))
                    if (!$util.isString(message.cancelDate))
                        return "cancelDate: string expected";
                if (message.permissionId != null && message.hasOwnProperty("permissionId"))
                    if (!$util.isInteger(message.permissionId))
                        return "permissionId: integer expected";
                if (message.releaseState != null && message.hasOwnProperty("releaseState"))
                    if (!$util.isInteger(message.releaseState))
                        return "releaseState: integer expected";
                if (message.tidNumber != null && message.hasOwnProperty("tidNumber"))
                    if (!$util.isString(message.tidNumber))
                        return "tidNumber: string expected";
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    if (!$util.isString(message.storeCode))
                        return "storeCode: string expected";
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    if (!$util.isString(message.registerName))
                        return "registerName: string expected";
                if (message.motify != null && message.hasOwnProperty("motify")) {
                    var error = $root.TCBReceiptApi.Protobuf.StoreUserMotify.verify(message.motify);
                    if (error)
                        return "motify." + error;
                }
                if (message.rejectReason != null && message.hasOwnProperty("rejectReason"))
                    if (!$util.isString(message.rejectReason))
                        return "rejectReason: string expected";
                if (message.selectMap != null && message.hasOwnProperty("selectMap")) {
                    if (!$util.isObject(message.selectMap))
                        return "selectMap: object expected";
                    var key = Object.keys(message.selectMap);
                    for (var i = 0; i < key.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.StoreUserPermissionList.verify(message.selectMap[key[i]]);
                        if (error)
                            return "selectMap." + error;
                    }
                }
                if (message.systemGenerate != null && message.hasOwnProperty("systemGenerate"))
                    if (!$util.isInteger(message.systemGenerate))
                        return "systemGenerate: integer expected";
                if (message.loginFailedCount != null && message.hasOwnProperty("loginFailedCount"))
                    if (!$util.isInteger(message.loginFailedCount))
                        return "loginFailedCount: integer expected";
                if (message.resetExpiresIn != null && message.hasOwnProperty("resetExpiresIn"))
                    if (!$util.isInteger(message.resetExpiresIn))
                        return "resetExpiresIn: integer expected";
                if (message.continueDate != null && message.hasOwnProperty("continueDate"))
                    if (!$util.isString(message.continueDate))
                        return "continueDate: string expected";
                if (message.loginType != null && message.hasOwnProperty("loginType"))
                    if (!$util.isInteger(message.loginType))
                        return "loginType: integer expected";
                if (message.storeCancelDate != null && message.hasOwnProperty("storeCancelDate"))
                    if (!$util.isString(message.storeCancelDate))
                        return "storeCancelDate: string expected";
                if (message.e2eeFlag != null && message.hasOwnProperty("e2eeFlag"))
                    if (!$util.isInteger(message.e2eeFlag))
                        return "e2eeFlag: integer expected";
                if (message.e2eePd != null && message.hasOwnProperty("e2eePd"))
                    if (!$util.isString(message.e2eePd))
                        return "e2eePd: string expected";
                return null;
            };

            /**
             * Creates a StoreUser message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.StoreUser} StoreUser
             */
            StoreUser.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.StoreUser)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.StoreUser();
                if (object.storeUserTempId != null)
                    message.storeUserTempId = object.storeUserTempId | 0;
                if (object.storeUserId != null)
                    message.storeUserId = object.storeUserId | 0;
                if (object.actionType != null)
                    message.actionType = object.actionType | 0;
                if (object.type != null)
                    message.type = object.type | 0;
                if (object.identification != null)
                    message.identification = String(object.identification);
                if (object.account != null)
                    message.account = String(object.account);
                if (object.resetMail != null)
                    message.resetMail = String(object.resetMail);
                if (object.permission) {
                    if (typeof object.permission !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.StoreUser.permission: object expected");
                    message.permission = {};
                    for (var keys = Object.keys(object.permission), i = 0; i < keys.length; ++i) {
                        if (typeof object.permission[keys[i]] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.StoreUser.permission: object expected");
                        message.permission[keys[i]] = $root.TCBReceiptApi.Protobuf.StoreUserPermissionList.fromObject(object.permission[keys[i]]);
                    }
                }
                if (object.state != null)
                    message.state = object.state | 0;
                if (object.lock != null)
                    message.lock = object.lock | 0;
                if (object.active != null)
                    message.active = object.active | 0;
                if (object.lastUpdateTime != null)
                    message.lastUpdateTime = object.lastUpdateTime | 0;
                if (object.lastUpdateUser != null)
                    message.lastUpdateUser = String(object.lastUpdateUser);
                if (object.cancelDate != null)
                    message.cancelDate = String(object.cancelDate);
                if (object.permissionId != null)
                    message.permissionId = object.permissionId | 0;
                if (object.releaseState != null)
                    message.releaseState = object.releaseState | 0;
                if (object.tidNumber != null)
                    message.tidNumber = String(object.tidNumber);
                if (object.storeCode != null)
                    message.storeCode = String(object.storeCode);
                if (object.registerName != null)
                    message.registerName = String(object.registerName);
                if (object.motify != null) {
                    if (typeof object.motify !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.StoreUser.motify: object expected");
                    message.motify = $root.TCBReceiptApi.Protobuf.StoreUserMotify.fromObject(object.motify);
                }
                if (object.rejectReason != null)
                    message.rejectReason = String(object.rejectReason);
                if (object.selectMap) {
                    if (typeof object.selectMap !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.StoreUser.selectMap: object expected");
                    message.selectMap = {};
                    for (var keys = Object.keys(object.selectMap), i = 0; i < keys.length; ++i) {
                        if (typeof object.selectMap[keys[i]] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.StoreUser.selectMap: object expected");
                        message.selectMap[keys[i]] = $root.TCBReceiptApi.Protobuf.StoreUserPermissionList.fromObject(object.selectMap[keys[i]]);
                    }
                }
                if (object.systemGenerate != null)
                    message.systemGenerate = object.systemGenerate | 0;
                if (object.loginFailedCount != null)
                    message.loginFailedCount = object.loginFailedCount | 0;
                if (object.resetExpiresIn != null)
                    message.resetExpiresIn = object.resetExpiresIn | 0;
                if (object.continueDate != null)
                    message.continueDate = String(object.continueDate);
                if (object.loginType != null)
                    message.loginType = object.loginType | 0;
                if (object.storeCancelDate != null)
                    message.storeCancelDate = String(object.storeCancelDate);
                if (object.e2eeFlag != null)
                    message.e2eeFlag = object.e2eeFlag | 0;
                if (object.e2eePd != null)
                    message.e2eePd = String(object.e2eePd);
                return message;
            };

            /**
             * Creates a plain object from a StoreUser message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @static
             * @param {TCBReceiptApi.Protobuf.StoreUser} message StoreUser
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            StoreUser.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.objects || options.defaults) {
                    object.permission = {};
                    object.selectMap = {};
                }
                if (options.defaults) {
                    object.storeUserTempId = 0;
                    object.storeUserId = 0;
                    object.actionType = 0;
                    object.type = 0;
                    object.identification = "";
                    object.account = "";
                    object.resetMail = "";
                    object.state = 0;
                    object.lock = 0;
                    object.active = 0;
                    object.lastUpdateTime = 0;
                    object.lastUpdateUser = "";
                    object.cancelDate = "";
                    object.permissionId = 0;
                    object.releaseState = 0;
                    object.tidNumber = "";
                    object.storeCode = "";
                    object.registerName = "";
                    object.motify = null;
                    object.rejectReason = "";
                    object.systemGenerate = 0;
                    object.loginFailedCount = 0;
                    object.resetExpiresIn = 0;
                    object.continueDate = "";
                    object.loginType = 0;
                    object.storeCancelDate = "";
                    object.e2eeFlag = 0;
                    object.e2eePd = "";
                }
                if (message.storeUserTempId != null && message.hasOwnProperty("storeUserTempId"))
                    object.storeUserTempId = message.storeUserTempId;
                if (message.storeUserId != null && message.hasOwnProperty("storeUserId"))
                    object.storeUserId = message.storeUserId;
                if (message.actionType != null && message.hasOwnProperty("actionType"))
                    object.actionType = message.actionType;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.identification != null && message.hasOwnProperty("identification"))
                    object.identification = message.identification;
                if (message.account != null && message.hasOwnProperty("account"))
                    object.account = message.account;
                if (message.resetMail != null && message.hasOwnProperty("resetMail"))
                    object.resetMail = message.resetMail;
                var keys2;
                if (message.permission && (keys2 = Object.keys(message.permission)).length) {
                    object.permission = {};
                    for (var j = 0; j < keys2.length; ++j)
                        object.permission[keys2[j]] = $root.TCBReceiptApi.Protobuf.StoreUserPermissionList.toObject(message.permission[keys2[j]], options);
                }
                if (message.state != null && message.hasOwnProperty("state"))
                    object.state = message.state;
                if (message.lock != null && message.hasOwnProperty("lock"))
                    object.lock = message.lock;
                if (message.active != null && message.hasOwnProperty("active"))
                    object.active = message.active;
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    object.lastUpdateTime = message.lastUpdateTime;
                if (message.lastUpdateUser != null && message.hasOwnProperty("lastUpdateUser"))
                    object.lastUpdateUser = message.lastUpdateUser;
                if (message.cancelDate != null && message.hasOwnProperty("cancelDate"))
                    object.cancelDate = message.cancelDate;
                if (message.permissionId != null && message.hasOwnProperty("permissionId"))
                    object.permissionId = message.permissionId;
                if (message.releaseState != null && message.hasOwnProperty("releaseState"))
                    object.releaseState = message.releaseState;
                if (message.tidNumber != null && message.hasOwnProperty("tidNumber"))
                    object.tidNumber = message.tidNumber;
                if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                    object.storeCode = message.storeCode;
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    object.registerName = message.registerName;
                if (message.motify != null && message.hasOwnProperty("motify"))
                    object.motify = $root.TCBReceiptApi.Protobuf.StoreUserMotify.toObject(message.motify, options);
                if (message.rejectReason != null && message.hasOwnProperty("rejectReason"))
                    object.rejectReason = message.rejectReason;
                if (message.selectMap && (keys2 = Object.keys(message.selectMap)).length) {
                    object.selectMap = {};
                    for (var j = 0; j < keys2.length; ++j)
                        object.selectMap[keys2[j]] = $root.TCBReceiptApi.Protobuf.StoreUserPermissionList.toObject(message.selectMap[keys2[j]], options);
                }
                if (message.systemGenerate != null && message.hasOwnProperty("systemGenerate"))
                    object.systemGenerate = message.systemGenerate;
                if (message.loginFailedCount != null && message.hasOwnProperty("loginFailedCount"))
                    object.loginFailedCount = message.loginFailedCount;
                if (message.resetExpiresIn != null && message.hasOwnProperty("resetExpiresIn"))
                    object.resetExpiresIn = message.resetExpiresIn;
                if (message.continueDate != null && message.hasOwnProperty("continueDate"))
                    object.continueDate = message.continueDate;
                if (message.loginType != null && message.hasOwnProperty("loginType"))
                    object.loginType = message.loginType;
                if (message.storeCancelDate != null && message.hasOwnProperty("storeCancelDate"))
                    object.storeCancelDate = message.storeCancelDate;
                if (message.e2eeFlag != null && message.hasOwnProperty("e2eeFlag"))
                    object.e2eeFlag = message.e2eeFlag;
                if (message.e2eePd != null && message.hasOwnProperty("e2eePd"))
                    object.e2eePd = message.e2eePd;
                return object;
            };

            /**
             * Converts this StoreUser to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.StoreUser
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            StoreUser.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return StoreUser;
        })();

        Protobuf.StoreUserList = (function() {

            /**
             * Properties of a StoreUserList.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IStoreUserList
             * @property {Array.<TCBReceiptApi.Protobuf.IStoreUser>|null} [list] StoreUserList list
             * @property {number|null} [total] StoreUserList total
             */

            /**
             * Constructs a new StoreUserList.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a StoreUserList.
             * @implements IStoreUserList
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IStoreUserList=} [properties] Properties to set
             */
            function StoreUserList(properties) {
                this.list = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * StoreUserList list.
             * @member {Array.<TCBReceiptApi.Protobuf.IStoreUser>} list
             * @memberof TCBReceiptApi.Protobuf.StoreUserList
             * @instance
             */
            StoreUserList.prototype.list = $util.emptyArray;

            /**
             * StoreUserList total.
             * @member {number} total
             * @memberof TCBReceiptApi.Protobuf.StoreUserList
             * @instance
             */
            StoreUserList.prototype.total = 0;

            /**
             * Creates a new StoreUserList instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.StoreUserList
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreUserList=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.StoreUserList} StoreUserList instance
             */
            StoreUserList.create = function create(properties) {
                return new StoreUserList(properties);
            };

            /**
             * Encodes the specified StoreUserList message. Does not implicitly {@link TCBReceiptApi.Protobuf.StoreUserList.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.StoreUserList
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreUserList} message StoreUserList message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StoreUserList.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.list != null && message.list.length)
                    for (var i = 0; i < message.list.length; ++i)
                        $root.TCBReceiptApi.Protobuf.StoreUser.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.total);
                return writer;
            };

            /**
             * Encodes the specified StoreUserList message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.StoreUserList.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.StoreUserList
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreUserList} message StoreUserList message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StoreUserList.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a StoreUserList message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.StoreUserList
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.StoreUserList} StoreUserList
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StoreUserList.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.StoreUserList();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.TCBReceiptApi.Protobuf.StoreUser.decode(reader, reader.uint32()));
                        break;
                    case 2:
                        message.total = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a StoreUserList message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.StoreUserList
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.StoreUserList} StoreUserList
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StoreUserList.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a StoreUserList message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.StoreUserList
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            StoreUserList.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.list != null && message.hasOwnProperty("list")) {
                    if (!Array.isArray(message.list))
                        return "list: array expected";
                    for (var i = 0; i < message.list.length; ++i) {
                        var error = $root.TCBReceiptApi.Protobuf.StoreUser.verify(message.list[i]);
                        if (error)
                            return "list." + error;
                    }
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    if (!$util.isInteger(message.total))
                        return "total: integer expected";
                return null;
            };

            /**
             * Creates a StoreUserList message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.StoreUserList
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.StoreUserList} StoreUserList
             */
            StoreUserList.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.StoreUserList)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.StoreUserList();
                if (object.list) {
                    if (!Array.isArray(object.list))
                        throw TypeError(".TCBReceiptApi.Protobuf.StoreUserList.list: array expected");
                    message.list = [];
                    for (var i = 0; i < object.list.length; ++i) {
                        if (typeof object.list[i] !== "object")
                            throw TypeError(".TCBReceiptApi.Protobuf.StoreUserList.list: object expected");
                        message.list[i] = $root.TCBReceiptApi.Protobuf.StoreUser.fromObject(object.list[i]);
                    }
                }
                if (object.total != null)
                    message.total = object.total | 0;
                return message;
            };

            /**
             * Creates a plain object from a StoreUserList message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.StoreUserList
             * @static
             * @param {TCBReceiptApi.Protobuf.StoreUserList} message StoreUserList
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            StoreUserList.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.list = [];
                if (options.defaults)
                    object.total = 0;
                if (message.list && message.list.length) {
                    object.list = [];
                    for (var j = 0; j < message.list.length; ++j)
                        object.list[j] = $root.TCBReceiptApi.Protobuf.StoreUser.toObject(message.list[j], options);
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    object.total = message.total;
                return object;
            };

            /**
             * Converts this StoreUserList to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.StoreUserList
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            StoreUserList.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return StoreUserList;
        })();

        Protobuf.StoreUserQuery = (function() {

            /**
             * Properties of a StoreUserQuery.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IStoreUserQuery
             * @property {number|null} [releaseState] StoreUserQuery releaseState
             * @property {number|null} [type] StoreUserQuery type
             * @property {string|null} [identification] StoreUserQuery identification
             * @property {string|null} [account] StoreUserQuery account
             * @property {number|null} [state] StoreUserQuery state
             * @property {TCBReceiptApi.Protobuf.IPagination|null} [pagination] StoreUserQuery pagination
             */

            /**
             * Constructs a new StoreUserQuery.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a StoreUserQuery.
             * @implements IStoreUserQuery
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IStoreUserQuery=} [properties] Properties to set
             */
            function StoreUserQuery(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * StoreUserQuery releaseState.
             * @member {number} releaseState
             * @memberof TCBReceiptApi.Protobuf.StoreUserQuery
             * @instance
             */
            StoreUserQuery.prototype.releaseState = 0;

            /**
             * StoreUserQuery type.
             * @member {number} type
             * @memberof TCBReceiptApi.Protobuf.StoreUserQuery
             * @instance
             */
            StoreUserQuery.prototype.type = 0;

            /**
             * StoreUserQuery identification.
             * @member {string} identification
             * @memberof TCBReceiptApi.Protobuf.StoreUserQuery
             * @instance
             */
            StoreUserQuery.prototype.identification = "";

            /**
             * StoreUserQuery account.
             * @member {string} account
             * @memberof TCBReceiptApi.Protobuf.StoreUserQuery
             * @instance
             */
            StoreUserQuery.prototype.account = "";

            /**
             * StoreUserQuery state.
             * @member {number} state
             * @memberof TCBReceiptApi.Protobuf.StoreUserQuery
             * @instance
             */
            StoreUserQuery.prototype.state = 0;

            /**
             * StoreUserQuery pagination.
             * @member {TCBReceiptApi.Protobuf.IPagination|null|undefined} pagination
             * @memberof TCBReceiptApi.Protobuf.StoreUserQuery
             * @instance
             */
            StoreUserQuery.prototype.pagination = null;

            /**
             * Creates a new StoreUserQuery instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.StoreUserQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreUserQuery=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.StoreUserQuery} StoreUserQuery instance
             */
            StoreUserQuery.create = function create(properties) {
                return new StoreUserQuery(properties);
            };

            /**
             * Encodes the specified StoreUserQuery message. Does not implicitly {@link TCBReceiptApi.Protobuf.StoreUserQuery.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.StoreUserQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreUserQuery} message StoreUserQuery message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StoreUserQuery.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.releaseState != null && Object.hasOwnProperty.call(message, "releaseState"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.releaseState);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.type);
                if (message.identification != null && Object.hasOwnProperty.call(message, "identification"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.identification);
                if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.account);
                if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int32(message.state);
                if (message.pagination != null && Object.hasOwnProperty.call(message, "pagination"))
                    $root.TCBReceiptApi.Protobuf.Pagination.encode(message.pagination, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified StoreUserQuery message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.StoreUserQuery.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.StoreUserQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreUserQuery} message StoreUserQuery message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StoreUserQuery.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a StoreUserQuery message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.StoreUserQuery
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.StoreUserQuery} StoreUserQuery
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StoreUserQuery.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.StoreUserQuery();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.releaseState = reader.int32();
                        break;
                    case 2:
                        message.type = reader.int32();
                        break;
                    case 3:
                        message.identification = reader.string();
                        break;
                    case 4:
                        message.account = reader.string();
                        break;
                    case 5:
                        message.state = reader.int32();
                        break;
                    case 6:
                        message.pagination = $root.TCBReceiptApi.Protobuf.Pagination.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a StoreUserQuery message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.StoreUserQuery
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.StoreUserQuery} StoreUserQuery
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StoreUserQuery.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a StoreUserQuery message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.StoreUserQuery
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            StoreUserQuery.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.releaseState != null && message.hasOwnProperty("releaseState"))
                    if (!$util.isInteger(message.releaseState))
                        return "releaseState: integer expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isInteger(message.type))
                        return "type: integer expected";
                if (message.identification != null && message.hasOwnProperty("identification"))
                    if (!$util.isString(message.identification))
                        return "identification: string expected";
                if (message.account != null && message.hasOwnProperty("account"))
                    if (!$util.isString(message.account))
                        return "account: string expected";
                if (message.state != null && message.hasOwnProperty("state"))
                    if (!$util.isInteger(message.state))
                        return "state: integer expected";
                if (message.pagination != null && message.hasOwnProperty("pagination")) {
                    var error = $root.TCBReceiptApi.Protobuf.Pagination.verify(message.pagination);
                    if (error)
                        return "pagination." + error;
                }
                return null;
            };

            /**
             * Creates a StoreUserQuery message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.StoreUserQuery
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.StoreUserQuery} StoreUserQuery
             */
            StoreUserQuery.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.StoreUserQuery)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.StoreUserQuery();
                if (object.releaseState != null)
                    message.releaseState = object.releaseState | 0;
                if (object.type != null)
                    message.type = object.type | 0;
                if (object.identification != null)
                    message.identification = String(object.identification);
                if (object.account != null)
                    message.account = String(object.account);
                if (object.state != null)
                    message.state = object.state | 0;
                if (object.pagination != null) {
                    if (typeof object.pagination !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.StoreUserQuery.pagination: object expected");
                    message.pagination = $root.TCBReceiptApi.Protobuf.Pagination.fromObject(object.pagination);
                }
                return message;
            };

            /**
             * Creates a plain object from a StoreUserQuery message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.StoreUserQuery
             * @static
             * @param {TCBReceiptApi.Protobuf.StoreUserQuery} message StoreUserQuery
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            StoreUserQuery.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.releaseState = 0;
                    object.type = 0;
                    object.identification = "";
                    object.account = "";
                    object.state = 0;
                    object.pagination = null;
                }
                if (message.releaseState != null && message.hasOwnProperty("releaseState"))
                    object.releaseState = message.releaseState;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.identification != null && message.hasOwnProperty("identification"))
                    object.identification = message.identification;
                if (message.account != null && message.hasOwnProperty("account"))
                    object.account = message.account;
                if (message.state != null && message.hasOwnProperty("state"))
                    object.state = message.state;
                if (message.pagination != null && message.hasOwnProperty("pagination"))
                    object.pagination = $root.TCBReceiptApi.Protobuf.Pagination.toObject(message.pagination, options);
                return object;
            };

            /**
             * Converts this StoreUserQuery to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.StoreUserQuery
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            StoreUserQuery.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return StoreUserQuery;
        })();

        Protobuf.StoreUserExport = (function() {

            /**
             * Properties of a StoreUserExport.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IStoreUserExport
             * @property {string|null} [identification] StoreUserExport identification
             * @property {string|null} [registerName] StoreUserExport registerName
             * @property {string|null} [type] StoreUserExport type
             * @property {string|null} [account] StoreUserExport account
             * @property {string|null} [resetMail] StoreUserExport resetMail
             * @property {string|null} [state] StoreUserExport state
             * @property {string|null} [lock] StoreUserExport lock
             * @property {string|null} [storeCancelDate] StoreUserExport storeCancelDate
             * @property {string|null} [accountCancelDate] StoreUserExport accountCancelDate
             * @property {string|null} [lastUpdateTime] StoreUserExport lastUpdateTime
             * @property {string|null} [lastUpdateUser] StoreUserExport lastUpdateUser
             * @property {string|null} [active] StoreUserExport active
             */

            /**
             * Constructs a new StoreUserExport.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a StoreUserExport.
             * @implements IStoreUserExport
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IStoreUserExport=} [properties] Properties to set
             */
            function StoreUserExport(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * StoreUserExport identification.
             * @member {string} identification
             * @memberof TCBReceiptApi.Protobuf.StoreUserExport
             * @instance
             */
            StoreUserExport.prototype.identification = "";

            /**
             * StoreUserExport registerName.
             * @member {string} registerName
             * @memberof TCBReceiptApi.Protobuf.StoreUserExport
             * @instance
             */
            StoreUserExport.prototype.registerName = "";

            /**
             * StoreUserExport type.
             * @member {string} type
             * @memberof TCBReceiptApi.Protobuf.StoreUserExport
             * @instance
             */
            StoreUserExport.prototype.type = "";

            /**
             * StoreUserExport account.
             * @member {string} account
             * @memberof TCBReceiptApi.Protobuf.StoreUserExport
             * @instance
             */
            StoreUserExport.prototype.account = "";

            /**
             * StoreUserExport resetMail.
             * @member {string} resetMail
             * @memberof TCBReceiptApi.Protobuf.StoreUserExport
             * @instance
             */
            StoreUserExport.prototype.resetMail = "";

            /**
             * StoreUserExport state.
             * @member {string} state
             * @memberof TCBReceiptApi.Protobuf.StoreUserExport
             * @instance
             */
            StoreUserExport.prototype.state = "";

            /**
             * StoreUserExport lock.
             * @member {string} lock
             * @memberof TCBReceiptApi.Protobuf.StoreUserExport
             * @instance
             */
            StoreUserExport.prototype.lock = "";

            /**
             * StoreUserExport storeCancelDate.
             * @member {string} storeCancelDate
             * @memberof TCBReceiptApi.Protobuf.StoreUserExport
             * @instance
             */
            StoreUserExport.prototype.storeCancelDate = "";

            /**
             * StoreUserExport accountCancelDate.
             * @member {string} accountCancelDate
             * @memberof TCBReceiptApi.Protobuf.StoreUserExport
             * @instance
             */
            StoreUserExport.prototype.accountCancelDate = "";

            /**
             * StoreUserExport lastUpdateTime.
             * @member {string} lastUpdateTime
             * @memberof TCBReceiptApi.Protobuf.StoreUserExport
             * @instance
             */
            StoreUserExport.prototype.lastUpdateTime = "";

            /**
             * StoreUserExport lastUpdateUser.
             * @member {string} lastUpdateUser
             * @memberof TCBReceiptApi.Protobuf.StoreUserExport
             * @instance
             */
            StoreUserExport.prototype.lastUpdateUser = "";

            /**
             * StoreUserExport active.
             * @member {string} active
             * @memberof TCBReceiptApi.Protobuf.StoreUserExport
             * @instance
             */
            StoreUserExport.prototype.active = "";

            /**
             * Creates a new StoreUserExport instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.StoreUserExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreUserExport=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.StoreUserExport} StoreUserExport instance
             */
            StoreUserExport.create = function create(properties) {
                return new StoreUserExport(properties);
            };

            /**
             * Encodes the specified StoreUserExport message. Does not implicitly {@link TCBReceiptApi.Protobuf.StoreUserExport.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.StoreUserExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreUserExport} message StoreUserExport message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StoreUserExport.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.identification != null && Object.hasOwnProperty.call(message, "identification"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.identification);
                if (message.registerName != null && Object.hasOwnProperty.call(message, "registerName"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.registerName);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.type);
                if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.account);
                if (message.resetMail != null && Object.hasOwnProperty.call(message, "resetMail"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.resetMail);
                if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.state);
                if (message.lock != null && Object.hasOwnProperty.call(message, "lock"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.lock);
                if (message.storeCancelDate != null && Object.hasOwnProperty.call(message, "storeCancelDate"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.storeCancelDate);
                if (message.accountCancelDate != null && Object.hasOwnProperty.call(message, "accountCancelDate"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.accountCancelDate);
                if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.lastUpdateTime);
                if (message.lastUpdateUser != null && Object.hasOwnProperty.call(message, "lastUpdateUser"))
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.lastUpdateUser);
                if (message.active != null && Object.hasOwnProperty.call(message, "active"))
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.active);
                return writer;
            };

            /**
             * Encodes the specified StoreUserExport message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.StoreUserExport.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.StoreUserExport
             * @static
             * @param {TCBReceiptApi.Protobuf.IStoreUserExport} message StoreUserExport message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StoreUserExport.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a StoreUserExport message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.StoreUserExport
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.StoreUserExport} StoreUserExport
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StoreUserExport.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.StoreUserExport();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.identification = reader.string();
                        break;
                    case 2:
                        message.registerName = reader.string();
                        break;
                    case 3:
                        message.type = reader.string();
                        break;
                    case 4:
                        message.account = reader.string();
                        break;
                    case 5:
                        message.resetMail = reader.string();
                        break;
                    case 6:
                        message.state = reader.string();
                        break;
                    case 7:
                        message.lock = reader.string();
                        break;
                    case 8:
                        message.storeCancelDate = reader.string();
                        break;
                    case 9:
                        message.accountCancelDate = reader.string();
                        break;
                    case 10:
                        message.lastUpdateTime = reader.string();
                        break;
                    case 11:
                        message.lastUpdateUser = reader.string();
                        break;
                    case 12:
                        message.active = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a StoreUserExport message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.StoreUserExport
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.StoreUserExport} StoreUserExport
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StoreUserExport.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a StoreUserExport message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.StoreUserExport
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            StoreUserExport.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.identification != null && message.hasOwnProperty("identification"))
                    if (!$util.isString(message.identification))
                        return "identification: string expected";
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    if (!$util.isString(message.registerName))
                        return "registerName: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                if (message.account != null && message.hasOwnProperty("account"))
                    if (!$util.isString(message.account))
                        return "account: string expected";
                if (message.resetMail != null && message.hasOwnProperty("resetMail"))
                    if (!$util.isString(message.resetMail))
                        return "resetMail: string expected";
                if (message.state != null && message.hasOwnProperty("state"))
                    if (!$util.isString(message.state))
                        return "state: string expected";
                if (message.lock != null && message.hasOwnProperty("lock"))
                    if (!$util.isString(message.lock))
                        return "lock: string expected";
                if (message.storeCancelDate != null && message.hasOwnProperty("storeCancelDate"))
                    if (!$util.isString(message.storeCancelDate))
                        return "storeCancelDate: string expected";
                if (message.accountCancelDate != null && message.hasOwnProperty("accountCancelDate"))
                    if (!$util.isString(message.accountCancelDate))
                        return "accountCancelDate: string expected";
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    if (!$util.isString(message.lastUpdateTime))
                        return "lastUpdateTime: string expected";
                if (message.lastUpdateUser != null && message.hasOwnProperty("lastUpdateUser"))
                    if (!$util.isString(message.lastUpdateUser))
                        return "lastUpdateUser: string expected";
                if (message.active != null && message.hasOwnProperty("active"))
                    if (!$util.isString(message.active))
                        return "active: string expected";
                return null;
            };

            /**
             * Creates a StoreUserExport message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.StoreUserExport
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.StoreUserExport} StoreUserExport
             */
            StoreUserExport.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.StoreUserExport)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.StoreUserExport();
                if (object.identification != null)
                    message.identification = String(object.identification);
                if (object.registerName != null)
                    message.registerName = String(object.registerName);
                if (object.type != null)
                    message.type = String(object.type);
                if (object.account != null)
                    message.account = String(object.account);
                if (object.resetMail != null)
                    message.resetMail = String(object.resetMail);
                if (object.state != null)
                    message.state = String(object.state);
                if (object.lock != null)
                    message.lock = String(object.lock);
                if (object.storeCancelDate != null)
                    message.storeCancelDate = String(object.storeCancelDate);
                if (object.accountCancelDate != null)
                    message.accountCancelDate = String(object.accountCancelDate);
                if (object.lastUpdateTime != null)
                    message.lastUpdateTime = String(object.lastUpdateTime);
                if (object.lastUpdateUser != null)
                    message.lastUpdateUser = String(object.lastUpdateUser);
                if (object.active != null)
                    message.active = String(object.active);
                return message;
            };

            /**
             * Creates a plain object from a StoreUserExport message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.StoreUserExport
             * @static
             * @param {TCBReceiptApi.Protobuf.StoreUserExport} message StoreUserExport
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            StoreUserExport.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.identification = "";
                    object.registerName = "";
                    object.type = "";
                    object.account = "";
                    object.resetMail = "";
                    object.state = "";
                    object.lock = "";
                    object.storeCancelDate = "";
                    object.accountCancelDate = "";
                    object.lastUpdateTime = "";
                    object.lastUpdateUser = "";
                    object.active = "";
                }
                if (message.identification != null && message.hasOwnProperty("identification"))
                    object.identification = message.identification;
                if (message.registerName != null && message.hasOwnProperty("registerName"))
                    object.registerName = message.registerName;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.account != null && message.hasOwnProperty("account"))
                    object.account = message.account;
                if (message.resetMail != null && message.hasOwnProperty("resetMail"))
                    object.resetMail = message.resetMail;
                if (message.state != null && message.hasOwnProperty("state"))
                    object.state = message.state;
                if (message.lock != null && message.hasOwnProperty("lock"))
                    object.lock = message.lock;
                if (message.storeCancelDate != null && message.hasOwnProperty("storeCancelDate"))
                    object.storeCancelDate = message.storeCancelDate;
                if (message.accountCancelDate != null && message.hasOwnProperty("accountCancelDate"))
                    object.accountCancelDate = message.accountCancelDate;
                if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                    object.lastUpdateTime = message.lastUpdateTime;
                if (message.lastUpdateUser != null && message.hasOwnProperty("lastUpdateUser"))
                    object.lastUpdateUser = message.lastUpdateUser;
                if (message.active != null && message.hasOwnProperty("active"))
                    object.active = message.active;
                return object;
            };

            /**
             * Converts this StoreUserExport to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.StoreUserExport
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            StoreUserExport.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return StoreUserExport;
        })();

        /**
         * ReleaseState enum.
         * @name TCBReceiptApi.Protobuf.ReleaseState
         * @enum {number}
         * @property {number} RS_NONE=0 RS_NONE value
         * @property {number} RS_REJECT=1 RS_REJECT value
         * @property {number} RS_PENDING=2 RS_PENDING value
         * @property {number} RS_RELEASE=3 RS_RELEASE value
         */
        Protobuf.ReleaseState = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "RS_NONE"] = 0;
            values[valuesById[1] = "RS_REJECT"] = 1;
            values[valuesById[2] = "RS_PENDING"] = 2;
            values[valuesById[3] = "RS_RELEASE"] = 3;
            return values;
        })();

        /**
         * ActionType enum.
         * @name TCBReceiptApi.Protobuf.ActionType
         * @enum {number}
         * @property {number} AT_NONE=0 AT_NONE value
         * @property {number} AT_ADD=1 AT_ADD value
         * @property {number} AT_EDIT=2 AT_EDIT value
         * @property {number} AT_DELETE=3 AT_DELETE value
         */
        Protobuf.ActionType = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "AT_NONE"] = 0;
            values[valuesById[1] = "AT_ADD"] = 1;
            values[valuesById[2] = "AT_EDIT"] = 2;
            values[valuesById[3] = "AT_DELETE"] = 3;
            return values;
        })();

        /**
         * PendingTotalType enum.
         * @name TCBReceiptApi.Protobuf.PendingTotalType
         * @enum {number}
         * @property {number} PTT_NONE=0 PTT_NONE value
         * @property {number} PTT_STORE=1 PTT_STORE value
         * @property {number} PTT_STORE_USER=2 PTT_STORE_USER value
         * @property {number} PTT_E_RECEIPT_USER=3 PTT_E_RECEIPT_USER value
         * @property {number} PTT_RECEIPT_PREFIX=4 PTT_RECEIPT_PREFIX value
         * @property {number} PTT_RECEIPT_MANUAL=5 PTT_RECEIPT_MANUAL value
         * @property {number} PTT_RECEIPT_VOID=6 PTT_RECEIPT_VOID value
         * @property {number} PTT_NO_STORE_VENDEE=7 PTT_NO_STORE_VENDEE value
         * @property {number} PTT_ANNOUNCEMENT=8 PTT_ANNOUNCEMENT value
         */
        Protobuf.PendingTotalType = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "PTT_NONE"] = 0;
            values[valuesById[1] = "PTT_STORE"] = 1;
            values[valuesById[2] = "PTT_STORE_USER"] = 2;
            values[valuesById[3] = "PTT_E_RECEIPT_USER"] = 3;
            values[valuesById[4] = "PTT_RECEIPT_PREFIX"] = 4;
            values[valuesById[5] = "PTT_RECEIPT_MANUAL"] = 5;
            values[valuesById[6] = "PTT_RECEIPT_VOID"] = 6;
            values[valuesById[7] = "PTT_NO_STORE_VENDEE"] = 7;
            values[valuesById[8] = "PTT_ANNOUNCEMENT"] = 8;
            return values;
        })();

        Protobuf.Login = (function() {

            /**
             * Properties of a Login.
             * @memberof TCBReceiptApi.Protobuf
             * @interface ILogin
             * @property {string|null} [identification] Login identification
             * @property {string|null} [account] Login account
             * @property {Uint8Array|null} [password] Login password
             * @property {string|null} [e2eePassword] Login e2eePassword
             * @property {string|null} [checkCode] Login checkCode
             * @property {number|null} [id] Login id
             */

            /**
             * Constructs a new Login.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a Login.
             * @implements ILogin
             * @constructor
             * @param {TCBReceiptApi.Protobuf.ILogin=} [properties] Properties to set
             */
            function Login(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Login identification.
             * @member {string} identification
             * @memberof TCBReceiptApi.Protobuf.Login
             * @instance
             */
            Login.prototype.identification = "";

            /**
             * Login account.
             * @member {string} account
             * @memberof TCBReceiptApi.Protobuf.Login
             * @instance
             */
            Login.prototype.account = "";

            /**
             * Login password.
             * @member {Uint8Array} password
             * @memberof TCBReceiptApi.Protobuf.Login
             * @instance
             */
            Login.prototype.password = $util.newBuffer([]);

            /**
             * Login e2eePassword.
             * @member {string} e2eePassword
             * @memberof TCBReceiptApi.Protobuf.Login
             * @instance
             */
            Login.prototype.e2eePassword = "";

            /**
             * Login checkCode.
             * @member {string} checkCode
             * @memberof TCBReceiptApi.Protobuf.Login
             * @instance
             */
            Login.prototype.checkCode = "";

            /**
             * Login id.
             * @member {number} id
             * @memberof TCBReceiptApi.Protobuf.Login
             * @instance
             */
            Login.prototype.id = 0;

            /**
             * Creates a new Login instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.Login
             * @static
             * @param {TCBReceiptApi.Protobuf.ILogin=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.Login} Login instance
             */
            Login.create = function create(properties) {
                return new Login(properties);
            };

            /**
             * Encodes the specified Login message. Does not implicitly {@link TCBReceiptApi.Protobuf.Login.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.Login
             * @static
             * @param {TCBReceiptApi.Protobuf.ILogin} message Login message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Login.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.identification != null && Object.hasOwnProperty.call(message, "identification"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.identification);
                if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.account);
                if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                    writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.password);
                if (message.e2eePassword != null && Object.hasOwnProperty.call(message, "e2eePassword"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.e2eePassword);
                if (message.checkCode != null && Object.hasOwnProperty.call(message, "checkCode"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.checkCode);
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int32(message.id);
                return writer;
            };

            /**
             * Encodes the specified Login message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.Login.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.Login
             * @static
             * @param {TCBReceiptApi.Protobuf.ILogin} message Login message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Login.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Login message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.Login
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.Login} Login
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Login.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.Login();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.identification = reader.string();
                        break;
                    case 2:
                        message.account = reader.string();
                        break;
                    case 3:
                        message.password = reader.bytes();
                        break;
                    case 4:
                        message.e2eePassword = reader.string();
                        break;
                    case 5:
                        message.checkCode = reader.string();
                        break;
                    case 6:
                        message.id = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Login message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.Login
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.Login} Login
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Login.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Login message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.Login
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Login.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.identification != null && message.hasOwnProperty("identification"))
                    if (!$util.isString(message.identification))
                        return "identification: string expected";
                if (message.account != null && message.hasOwnProperty("account"))
                    if (!$util.isString(message.account))
                        return "account: string expected";
                if (message.password != null && message.hasOwnProperty("password"))
                    if (!(message.password && typeof message.password.length === "number" || $util.isString(message.password)))
                        return "password: buffer expected";
                if (message.e2eePassword != null && message.hasOwnProperty("e2eePassword"))
                    if (!$util.isString(message.e2eePassword))
                        return "e2eePassword: string expected";
                if (message.checkCode != null && message.hasOwnProperty("checkCode"))
                    if (!$util.isString(message.checkCode))
                        return "checkCode: string expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isInteger(message.id))
                        return "id: integer expected";
                return null;
            };

            /**
             * Creates a Login message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.Login
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.Login} Login
             */
            Login.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.Login)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.Login();
                if (object.identification != null)
                    message.identification = String(object.identification);
                if (object.account != null)
                    message.account = String(object.account);
                if (object.password != null)
                    if (typeof object.password === "string")
                        $util.base64.decode(object.password, message.password = $util.newBuffer($util.base64.length(object.password)), 0);
                    else if (object.password.length)
                        message.password = object.password;
                if (object.e2eePassword != null)
                    message.e2eePassword = String(object.e2eePassword);
                if (object.checkCode != null)
                    message.checkCode = String(object.checkCode);
                if (object.id != null)
                    message.id = object.id | 0;
                return message;
            };

            /**
             * Creates a plain object from a Login message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.Login
             * @static
             * @param {TCBReceiptApi.Protobuf.Login} message Login
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Login.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.identification = "";
                    object.account = "";
                    if (options.bytes === String)
                        object.password = "";
                    else {
                        object.password = [];
                        if (options.bytes !== Array)
                            object.password = $util.newBuffer(object.password);
                    }
                    object.e2eePassword = "";
                    object.checkCode = "";
                    object.id = 0;
                }
                if (message.identification != null && message.hasOwnProperty("identification"))
                    object.identification = message.identification;
                if (message.account != null && message.hasOwnProperty("account"))
                    object.account = message.account;
                if (message.password != null && message.hasOwnProperty("password"))
                    object.password = options.bytes === String ? $util.base64.encode(message.password, 0, message.password.length) : options.bytes === Array ? Array.prototype.slice.call(message.password) : message.password;
                if (message.e2eePassword != null && message.hasOwnProperty("e2eePassword"))
                    object.e2eePassword = message.e2eePassword;
                if (message.checkCode != null && message.hasOwnProperty("checkCode"))
                    object.checkCode = message.checkCode;
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                return object;
            };

            /**
             * Converts this Login to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.Login
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Login.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Login;
        })();

        Protobuf.BackCredentials = (function() {

            /**
             * Properties of a BackCredentials.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IBackCredentials
             * @property {string|null} [code] BackCredentials code
             * @property {string|null} [userName] BackCredentials userName
             * @property {string|null} [branchBankCode] BackCredentials branchBankCode
             */

            /**
             * Constructs a new BackCredentials.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a BackCredentials.
             * @implements IBackCredentials
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IBackCredentials=} [properties] Properties to set
             */
            function BackCredentials(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * BackCredentials code.
             * @member {string} code
             * @memberof TCBReceiptApi.Protobuf.BackCredentials
             * @instance
             */
            BackCredentials.prototype.code = "";

            /**
             * BackCredentials userName.
             * @member {string} userName
             * @memberof TCBReceiptApi.Protobuf.BackCredentials
             * @instance
             */
            BackCredentials.prototype.userName = "";

            /**
             * BackCredentials branchBankCode.
             * @member {string} branchBankCode
             * @memberof TCBReceiptApi.Protobuf.BackCredentials
             * @instance
             */
            BackCredentials.prototype.branchBankCode = "";

            /**
             * Creates a new BackCredentials instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.BackCredentials
             * @static
             * @param {TCBReceiptApi.Protobuf.IBackCredentials=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.BackCredentials} BackCredentials instance
             */
            BackCredentials.create = function create(properties) {
                return new BackCredentials(properties);
            };

            /**
             * Encodes the specified BackCredentials message. Does not implicitly {@link TCBReceiptApi.Protobuf.BackCredentials.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.BackCredentials
             * @static
             * @param {TCBReceiptApi.Protobuf.IBackCredentials} message BackCredentials message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BackCredentials.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.code);
                if (message.userName != null && Object.hasOwnProperty.call(message, "userName"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.userName);
                if (message.branchBankCode != null && Object.hasOwnProperty.call(message, "branchBankCode"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.branchBankCode);
                return writer;
            };

            /**
             * Encodes the specified BackCredentials message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.BackCredentials.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.BackCredentials
             * @static
             * @param {TCBReceiptApi.Protobuf.IBackCredentials} message BackCredentials message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BackCredentials.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a BackCredentials message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.BackCredentials
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.BackCredentials} BackCredentials
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BackCredentials.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.BackCredentials();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.code = reader.string();
                        break;
                    case 2:
                        message.userName = reader.string();
                        break;
                    case 3:
                        message.branchBankCode = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a BackCredentials message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.BackCredentials
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.BackCredentials} BackCredentials
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BackCredentials.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a BackCredentials message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.BackCredentials
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            BackCredentials.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.code != null && message.hasOwnProperty("code"))
                    if (!$util.isString(message.code))
                        return "code: string expected";
                if (message.userName != null && message.hasOwnProperty("userName"))
                    if (!$util.isString(message.userName))
                        return "userName: string expected";
                if (message.branchBankCode != null && message.hasOwnProperty("branchBankCode"))
                    if (!$util.isString(message.branchBankCode))
                        return "branchBankCode: string expected";
                return null;
            };

            /**
             * Creates a BackCredentials message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.BackCredentials
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.BackCredentials} BackCredentials
             */
            BackCredentials.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.BackCredentials)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.BackCredentials();
                if (object.code != null)
                    message.code = String(object.code);
                if (object.userName != null)
                    message.userName = String(object.userName);
                if (object.branchBankCode != null)
                    message.branchBankCode = String(object.branchBankCode);
                return message;
            };

            /**
             * Creates a plain object from a BackCredentials message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.BackCredentials
             * @static
             * @param {TCBReceiptApi.Protobuf.BackCredentials} message BackCredentials
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            BackCredentials.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.code = "";
                    object.userName = "";
                    object.branchBankCode = "";
                }
                if (message.code != null && message.hasOwnProperty("code"))
                    object.code = message.code;
                if (message.userName != null && message.hasOwnProperty("userName"))
                    object.userName = message.userName;
                if (message.branchBankCode != null && message.hasOwnProperty("branchBankCode"))
                    object.branchBankCode = message.branchBankCode;
                return object;
            };

            /**
             * Converts this BackCredentials to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.BackCredentials
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            BackCredentials.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return BackCredentials;
        })();

        Protobuf.FrontCredentials = (function() {

            /**
             * Properties of a FrontCredentials.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IFrontCredentials
             * @property {string|null} [identification] FrontCredentials identification
             * @property {string|null} [account] FrontCredentials account
             * @property {string|null} [permissionId] FrontCredentials permissionId
             * @property {string|null} [storeUserId] FrontCredentials storeUserId
             * @property {string|null} [tidNumber] FrontCredentials tidNumber
             */

            /**
             * Constructs a new FrontCredentials.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a FrontCredentials.
             * @implements IFrontCredentials
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IFrontCredentials=} [properties] Properties to set
             */
            function FrontCredentials(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * FrontCredentials identification.
             * @member {string} identification
             * @memberof TCBReceiptApi.Protobuf.FrontCredentials
             * @instance
             */
            FrontCredentials.prototype.identification = "";

            /**
             * FrontCredentials account.
             * @member {string} account
             * @memberof TCBReceiptApi.Protobuf.FrontCredentials
             * @instance
             */
            FrontCredentials.prototype.account = "";

            /**
             * FrontCredentials permissionId.
             * @member {string} permissionId
             * @memberof TCBReceiptApi.Protobuf.FrontCredentials
             * @instance
             */
            FrontCredentials.prototype.permissionId = "";

            /**
             * FrontCredentials storeUserId.
             * @member {string} storeUserId
             * @memberof TCBReceiptApi.Protobuf.FrontCredentials
             * @instance
             */
            FrontCredentials.prototype.storeUserId = "";

            /**
             * FrontCredentials tidNumber.
             * @member {string} tidNumber
             * @memberof TCBReceiptApi.Protobuf.FrontCredentials
             * @instance
             */
            FrontCredentials.prototype.tidNumber = "";

            /**
             * Creates a new FrontCredentials instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.FrontCredentials
             * @static
             * @param {TCBReceiptApi.Protobuf.IFrontCredentials=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.FrontCredentials} FrontCredentials instance
             */
            FrontCredentials.create = function create(properties) {
                return new FrontCredentials(properties);
            };

            /**
             * Encodes the specified FrontCredentials message. Does not implicitly {@link TCBReceiptApi.Protobuf.FrontCredentials.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.FrontCredentials
             * @static
             * @param {TCBReceiptApi.Protobuf.IFrontCredentials} message FrontCredentials message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FrontCredentials.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.identification != null && Object.hasOwnProperty.call(message, "identification"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.identification);
                if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.account);
                if (message.permissionId != null && Object.hasOwnProperty.call(message, "permissionId"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.permissionId);
                if (message.storeUserId != null && Object.hasOwnProperty.call(message, "storeUserId"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.storeUserId);
                if (message.tidNumber != null && Object.hasOwnProperty.call(message, "tidNumber"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.tidNumber);
                return writer;
            };

            /**
             * Encodes the specified FrontCredentials message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.FrontCredentials.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.FrontCredentials
             * @static
             * @param {TCBReceiptApi.Protobuf.IFrontCredentials} message FrontCredentials message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FrontCredentials.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FrontCredentials message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.FrontCredentials
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.FrontCredentials} FrontCredentials
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FrontCredentials.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.FrontCredentials();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.identification = reader.string();
                        break;
                    case 2:
                        message.account = reader.string();
                        break;
                    case 3:
                        message.permissionId = reader.string();
                        break;
                    case 4:
                        message.storeUserId = reader.string();
                        break;
                    case 5:
                        message.tidNumber = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FrontCredentials message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.FrontCredentials
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.FrontCredentials} FrontCredentials
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FrontCredentials.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FrontCredentials message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.FrontCredentials
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FrontCredentials.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.identification != null && message.hasOwnProperty("identification"))
                    if (!$util.isString(message.identification))
                        return "identification: string expected";
                if (message.account != null && message.hasOwnProperty("account"))
                    if (!$util.isString(message.account))
                        return "account: string expected";
                if (message.permissionId != null && message.hasOwnProperty("permissionId"))
                    if (!$util.isString(message.permissionId))
                        return "permissionId: string expected";
                if (message.storeUserId != null && message.hasOwnProperty("storeUserId"))
                    if (!$util.isString(message.storeUserId))
                        return "storeUserId: string expected";
                if (message.tidNumber != null && message.hasOwnProperty("tidNumber"))
                    if (!$util.isString(message.tidNumber))
                        return "tidNumber: string expected";
                return null;
            };

            /**
             * Creates a FrontCredentials message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.FrontCredentials
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.FrontCredentials} FrontCredentials
             */
            FrontCredentials.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.FrontCredentials)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.FrontCredentials();
                if (object.identification != null)
                    message.identification = String(object.identification);
                if (object.account != null)
                    message.account = String(object.account);
                if (object.permissionId != null)
                    message.permissionId = String(object.permissionId);
                if (object.storeUserId != null)
                    message.storeUserId = String(object.storeUserId);
                if (object.tidNumber != null)
                    message.tidNumber = String(object.tidNumber);
                return message;
            };

            /**
             * Creates a plain object from a FrontCredentials message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.FrontCredentials
             * @static
             * @param {TCBReceiptApi.Protobuf.FrontCredentials} message FrontCredentials
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FrontCredentials.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.identification = "";
                    object.account = "";
                    object.permissionId = "";
                    object.storeUserId = "";
                    object.tidNumber = "";
                }
                if (message.identification != null && message.hasOwnProperty("identification"))
                    object.identification = message.identification;
                if (message.account != null && message.hasOwnProperty("account"))
                    object.account = message.account;
                if (message.permissionId != null && message.hasOwnProperty("permissionId"))
                    object.permissionId = message.permissionId;
                if (message.storeUserId != null && message.hasOwnProperty("storeUserId"))
                    object.storeUserId = message.storeUserId;
                if (message.tidNumber != null && message.hasOwnProperty("tidNumber"))
                    object.tidNumber = message.tidNumber;
                return object;
            };

            /**
             * Converts this FrontCredentials to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.FrontCredentials
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FrontCredentials.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return FrontCredentials;
        })();

        Protobuf.UserAuth = (function() {

            /**
             * Properties of a UserAuth.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IUserAuth
             * @property {string|null} [token] UserAuth token
             * @property {TCBReceiptApi.Protobuf.IGroupPermission|null} [groupPermission] UserAuth groupPermission
             * @property {number|null} [loginType] UserAuth loginType
             * @property {number|null} [loginFailedCount] UserAuth loginFailedCount
             * @property {string|null} [name] UserAuth name
             * @property {number|null} [type] UserAuth type
             * @property {number|null} [expireTime] UserAuth expireTime
             * @property {number|null} [e2eeFlag] UserAuth e2eeFlag
             */

            /**
             * Constructs a new UserAuth.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a UserAuth.
             * @implements IUserAuth
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IUserAuth=} [properties] Properties to set
             */
            function UserAuth(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * UserAuth token.
             * @member {string} token
             * @memberof TCBReceiptApi.Protobuf.UserAuth
             * @instance
             */
            UserAuth.prototype.token = "";

            /**
             * UserAuth groupPermission.
             * @member {TCBReceiptApi.Protobuf.IGroupPermission|null|undefined} groupPermission
             * @memberof TCBReceiptApi.Protobuf.UserAuth
             * @instance
             */
            UserAuth.prototype.groupPermission = null;

            /**
             * UserAuth loginType.
             * @member {number} loginType
             * @memberof TCBReceiptApi.Protobuf.UserAuth
             * @instance
             */
            UserAuth.prototype.loginType = 0;

            /**
             * UserAuth loginFailedCount.
             * @member {number} loginFailedCount
             * @memberof TCBReceiptApi.Protobuf.UserAuth
             * @instance
             */
            UserAuth.prototype.loginFailedCount = 0;

            /**
             * UserAuth name.
             * @member {string} name
             * @memberof TCBReceiptApi.Protobuf.UserAuth
             * @instance
             */
            UserAuth.prototype.name = "";

            /**
             * UserAuth type.
             * @member {number} type
             * @memberof TCBReceiptApi.Protobuf.UserAuth
             * @instance
             */
            UserAuth.prototype.type = 0;

            /**
             * UserAuth expireTime.
             * @member {number} expireTime
             * @memberof TCBReceiptApi.Protobuf.UserAuth
             * @instance
             */
            UserAuth.prototype.expireTime = 0;

            /**
             * UserAuth e2eeFlag.
             * @member {number} e2eeFlag
             * @memberof TCBReceiptApi.Protobuf.UserAuth
             * @instance
             */
            UserAuth.prototype.e2eeFlag = 0;

            /**
             * Creates a new UserAuth instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.UserAuth
             * @static
             * @param {TCBReceiptApi.Protobuf.IUserAuth=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.UserAuth} UserAuth instance
             */
            UserAuth.create = function create(properties) {
                return new UserAuth(properties);
            };

            /**
             * Encodes the specified UserAuth message. Does not implicitly {@link TCBReceiptApi.Protobuf.UserAuth.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.UserAuth
             * @static
             * @param {TCBReceiptApi.Protobuf.IUserAuth} message UserAuth message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UserAuth.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.token);
                if (message.groupPermission != null && Object.hasOwnProperty.call(message, "groupPermission"))
                    $root.TCBReceiptApi.Protobuf.GroupPermission.encode(message.groupPermission, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.loginType != null && Object.hasOwnProperty.call(message, "loginType"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.loginType);
                if (message.loginFailedCount != null && Object.hasOwnProperty.call(message, "loginFailedCount"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.loginFailedCount);
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.name);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int32(message.type);
                if (message.expireTime != null && Object.hasOwnProperty.call(message, "expireTime"))
                    writer.uint32(/* id 7, wireType 0 =*/56).int32(message.expireTime);
                if (message.e2eeFlag != null && Object.hasOwnProperty.call(message, "e2eeFlag"))
                    writer.uint32(/* id 8, wireType 0 =*/64).int32(message.e2eeFlag);
                return writer;
            };

            /**
             * Encodes the specified UserAuth message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.UserAuth.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.UserAuth
             * @static
             * @param {TCBReceiptApi.Protobuf.IUserAuth} message UserAuth message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UserAuth.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a UserAuth message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.UserAuth
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.UserAuth} UserAuth
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UserAuth.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.UserAuth();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.token = reader.string();
                        break;
                    case 2:
                        message.groupPermission = $root.TCBReceiptApi.Protobuf.GroupPermission.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.loginType = reader.int32();
                        break;
                    case 4:
                        message.loginFailedCount = reader.int32();
                        break;
                    case 5:
                        message.name = reader.string();
                        break;
                    case 6:
                        message.type = reader.int32();
                        break;
                    case 7:
                        message.expireTime = reader.int32();
                        break;
                    case 8:
                        message.e2eeFlag = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a UserAuth message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.UserAuth
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.UserAuth} UserAuth
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UserAuth.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a UserAuth message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.UserAuth
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UserAuth.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.token != null && message.hasOwnProperty("token"))
                    if (!$util.isString(message.token))
                        return "token: string expected";
                if (message.groupPermission != null && message.hasOwnProperty("groupPermission")) {
                    var error = $root.TCBReceiptApi.Protobuf.GroupPermission.verify(message.groupPermission);
                    if (error)
                        return "groupPermission." + error;
                }
                if (message.loginType != null && message.hasOwnProperty("loginType"))
                    if (!$util.isInteger(message.loginType))
                        return "loginType: integer expected";
                if (message.loginFailedCount != null && message.hasOwnProperty("loginFailedCount"))
                    if (!$util.isInteger(message.loginFailedCount))
                        return "loginFailedCount: integer expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isInteger(message.type))
                        return "type: integer expected";
                if (message.expireTime != null && message.hasOwnProperty("expireTime"))
                    if (!$util.isInteger(message.expireTime))
                        return "expireTime: integer expected";
                if (message.e2eeFlag != null && message.hasOwnProperty("e2eeFlag"))
                    if (!$util.isInteger(message.e2eeFlag))
                        return "e2eeFlag: integer expected";
                return null;
            };

            /**
             * Creates a UserAuth message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.UserAuth
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.UserAuth} UserAuth
             */
            UserAuth.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.UserAuth)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.UserAuth();
                if (object.token != null)
                    message.token = String(object.token);
                if (object.groupPermission != null) {
                    if (typeof object.groupPermission !== "object")
                        throw TypeError(".TCBReceiptApi.Protobuf.UserAuth.groupPermission: object expected");
                    message.groupPermission = $root.TCBReceiptApi.Protobuf.GroupPermission.fromObject(object.groupPermission);
                }
                if (object.loginType != null)
                    message.loginType = object.loginType | 0;
                if (object.loginFailedCount != null)
                    message.loginFailedCount = object.loginFailedCount | 0;
                if (object.name != null)
                    message.name = String(object.name);
                if (object.type != null)
                    message.type = object.type | 0;
                if (object.expireTime != null)
                    message.expireTime = object.expireTime | 0;
                if (object.e2eeFlag != null)
                    message.e2eeFlag = object.e2eeFlag | 0;
                return message;
            };

            /**
             * Creates a plain object from a UserAuth message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.UserAuth
             * @static
             * @param {TCBReceiptApi.Protobuf.UserAuth} message UserAuth
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UserAuth.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.token = "";
                    object.groupPermission = null;
                    object.loginType = 0;
                    object.loginFailedCount = 0;
                    object.name = "";
                    object.type = 0;
                    object.expireTime = 0;
                    object.e2eeFlag = 0;
                }
                if (message.token != null && message.hasOwnProperty("token"))
                    object.token = message.token;
                if (message.groupPermission != null && message.hasOwnProperty("groupPermission"))
                    object.groupPermission = $root.TCBReceiptApi.Protobuf.GroupPermission.toObject(message.groupPermission, options);
                if (message.loginType != null && message.hasOwnProperty("loginType"))
                    object.loginType = message.loginType;
                if (message.loginFailedCount != null && message.hasOwnProperty("loginFailedCount"))
                    object.loginFailedCount = message.loginFailedCount;
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.expireTime != null && message.hasOwnProperty("expireTime"))
                    object.expireTime = message.expireTime;
                if (message.e2eeFlag != null && message.hasOwnProperty("e2eeFlag"))
                    object.e2eeFlag = message.e2eeFlag;
                return object;
            };

            /**
             * Converts this UserAuth to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.UserAuth
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UserAuth.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return UserAuth;
        })();

        Protobuf.PasswordMotify = (function() {

            /**
             * Properties of a PasswordMotify.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IPasswordMotify
             * @property {number|null} [id] PasswordMotify id
             * @property {Uint8Array|null} [oldPassword] PasswordMotify oldPassword
             * @property {string|null} [oldE2eePd] PasswordMotify oldE2eePd
             * @property {Uint8Array|null} [newPassword] PasswordMotify newPassword
             * @property {string|null} [newE2eePd] PasswordMotify newE2eePd
             * @property {string|null} [resetMail] PasswordMotify resetMail
             * @property {string|null} [etoeePassword] PasswordMotify etoeePassword
             * @property {string|null} [etoeePasswordcipher] PasswordMotify etoeePasswordcipher
             */

            /**
             * Constructs a new PasswordMotify.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a PasswordMotify.
             * @implements IPasswordMotify
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IPasswordMotify=} [properties] Properties to set
             */
            function PasswordMotify(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * PasswordMotify id.
             * @member {number} id
             * @memberof TCBReceiptApi.Protobuf.PasswordMotify
             * @instance
             */
            PasswordMotify.prototype.id = 0;

            /**
             * PasswordMotify oldPassword.
             * @member {Uint8Array} oldPassword
             * @memberof TCBReceiptApi.Protobuf.PasswordMotify
             * @instance
             */
            PasswordMotify.prototype.oldPassword = $util.newBuffer([]);

            /**
             * PasswordMotify oldE2eePd.
             * @member {string} oldE2eePd
             * @memberof TCBReceiptApi.Protobuf.PasswordMotify
             * @instance
             */
            PasswordMotify.prototype.oldE2eePd = "";

            /**
             * PasswordMotify newPassword.
             * @member {Uint8Array} newPassword
             * @memberof TCBReceiptApi.Protobuf.PasswordMotify
             * @instance
             */
            PasswordMotify.prototype.newPassword = $util.newBuffer([]);

            /**
             * PasswordMotify newE2eePd.
             * @member {string} newE2eePd
             * @memberof TCBReceiptApi.Protobuf.PasswordMotify
             * @instance
             */
            PasswordMotify.prototype.newE2eePd = "";

            /**
             * PasswordMotify resetMail.
             * @member {string} resetMail
             * @memberof TCBReceiptApi.Protobuf.PasswordMotify
             * @instance
             */
            PasswordMotify.prototype.resetMail = "";

            /**
             * PasswordMotify etoeePassword.
             * @member {string} etoeePassword
             * @memberof TCBReceiptApi.Protobuf.PasswordMotify
             * @instance
             */
            PasswordMotify.prototype.etoeePassword = "";

            /**
             * PasswordMotify etoeePasswordcipher.
             * @member {string} etoeePasswordcipher
             * @memberof TCBReceiptApi.Protobuf.PasswordMotify
             * @instance
             */
            PasswordMotify.prototype.etoeePasswordcipher = "";

            /**
             * Creates a new PasswordMotify instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.PasswordMotify
             * @static
             * @param {TCBReceiptApi.Protobuf.IPasswordMotify=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.PasswordMotify} PasswordMotify instance
             */
            PasswordMotify.create = function create(properties) {
                return new PasswordMotify(properties);
            };

            /**
             * Encodes the specified PasswordMotify message. Does not implicitly {@link TCBReceiptApi.Protobuf.PasswordMotify.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.PasswordMotify
             * @static
             * @param {TCBReceiptApi.Protobuf.IPasswordMotify} message PasswordMotify message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PasswordMotify.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
                if (message.oldPassword != null && Object.hasOwnProperty.call(message, "oldPassword"))
                    writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.oldPassword);
                if (message.oldE2eePd != null && Object.hasOwnProperty.call(message, "oldE2eePd"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.oldE2eePd);
                if (message.newPassword != null && Object.hasOwnProperty.call(message, "newPassword"))
                    writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.newPassword);
                if (message.newE2eePd != null && Object.hasOwnProperty.call(message, "newE2eePd"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.newE2eePd);
                if (message.resetMail != null && Object.hasOwnProperty.call(message, "resetMail"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.resetMail);
                if (message.etoeePassword != null && Object.hasOwnProperty.call(message, "etoeePassword"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.etoeePassword);
                if (message.etoeePasswordcipher != null && Object.hasOwnProperty.call(message, "etoeePasswordcipher"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.etoeePasswordcipher);
                return writer;
            };

            /**
             * Encodes the specified PasswordMotify message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.PasswordMotify.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.PasswordMotify
             * @static
             * @param {TCBReceiptApi.Protobuf.IPasswordMotify} message PasswordMotify message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PasswordMotify.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PasswordMotify message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.PasswordMotify
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.PasswordMotify} PasswordMotify
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PasswordMotify.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.PasswordMotify();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.id = reader.int32();
                        break;
                    case 2:
                        message.oldPassword = reader.bytes();
                        break;
                    case 3:
                        message.oldE2eePd = reader.string();
                        break;
                    case 4:
                        message.newPassword = reader.bytes();
                        break;
                    case 5:
                        message.newE2eePd = reader.string();
                        break;
                    case 6:
                        message.resetMail = reader.string();
                        break;
                    case 7:
                        message.etoeePassword = reader.string();
                        break;
                    case 8:
                        message.etoeePasswordcipher = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a PasswordMotify message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.PasswordMotify
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.PasswordMotify} PasswordMotify
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PasswordMotify.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PasswordMotify message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.PasswordMotify
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PasswordMotify.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.id != null && message.hasOwnProperty("id"))
                    if (!$util.isInteger(message.id))
                        return "id: integer expected";
                if (message.oldPassword != null && message.hasOwnProperty("oldPassword"))
                    if (!(message.oldPassword && typeof message.oldPassword.length === "number" || $util.isString(message.oldPassword)))
                        return "oldPassword: buffer expected";
                if (message.oldE2eePd != null && message.hasOwnProperty("oldE2eePd"))
                    if (!$util.isString(message.oldE2eePd))
                        return "oldE2eePd: string expected";
                if (message.newPassword != null && message.hasOwnProperty("newPassword"))
                    if (!(message.newPassword && typeof message.newPassword.length === "number" || $util.isString(message.newPassword)))
                        return "newPassword: buffer expected";
                if (message.newE2eePd != null && message.hasOwnProperty("newE2eePd"))
                    if (!$util.isString(message.newE2eePd))
                        return "newE2eePd: string expected";
                if (message.resetMail != null && message.hasOwnProperty("resetMail"))
                    if (!$util.isString(message.resetMail))
                        return "resetMail: string expected";
                if (message.etoeePassword != null && message.hasOwnProperty("etoeePassword"))
                    if (!$util.isString(message.etoeePassword))
                        return "etoeePassword: string expected";
                if (message.etoeePasswordcipher != null && message.hasOwnProperty("etoeePasswordcipher"))
                    if (!$util.isString(message.etoeePasswordcipher))
                        return "etoeePasswordcipher: string expected";
                return null;
            };

            /**
             * Creates a PasswordMotify message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.PasswordMotify
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.PasswordMotify} PasswordMotify
             */
            PasswordMotify.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.PasswordMotify)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.PasswordMotify();
                if (object.id != null)
                    message.id = object.id | 0;
                if (object.oldPassword != null)
                    if (typeof object.oldPassword === "string")
                        $util.base64.decode(object.oldPassword, message.oldPassword = $util.newBuffer($util.base64.length(object.oldPassword)), 0);
                    else if (object.oldPassword.length)
                        message.oldPassword = object.oldPassword;
                if (object.oldE2eePd != null)
                    message.oldE2eePd = String(object.oldE2eePd);
                if (object.newPassword != null)
                    if (typeof object.newPassword === "string")
                        $util.base64.decode(object.newPassword, message.newPassword = $util.newBuffer($util.base64.length(object.newPassword)), 0);
                    else if (object.newPassword.length)
                        message.newPassword = object.newPassword;
                if (object.newE2eePd != null)
                    message.newE2eePd = String(object.newE2eePd);
                if (object.resetMail != null)
                    message.resetMail = String(object.resetMail);
                if (object.etoeePassword != null)
                    message.etoeePassword = String(object.etoeePassword);
                if (object.etoeePasswordcipher != null)
                    message.etoeePasswordcipher = String(object.etoeePasswordcipher);
                return message;
            };

            /**
             * Creates a plain object from a PasswordMotify message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.PasswordMotify
             * @static
             * @param {TCBReceiptApi.Protobuf.PasswordMotify} message PasswordMotify
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PasswordMotify.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = 0;
                    if (options.bytes === String)
                        object.oldPassword = "";
                    else {
                        object.oldPassword = [];
                        if (options.bytes !== Array)
                            object.oldPassword = $util.newBuffer(object.oldPassword);
                    }
                    object.oldE2eePd = "";
                    if (options.bytes === String)
                        object.newPassword = "";
                    else {
                        object.newPassword = [];
                        if (options.bytes !== Array)
                            object.newPassword = $util.newBuffer(object.newPassword);
                    }
                    object.newE2eePd = "";
                    object.resetMail = "";
                    object.etoeePassword = "";
                    object.etoeePasswordcipher = "";
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.oldPassword != null && message.hasOwnProperty("oldPassword"))
                    object.oldPassword = options.bytes === String ? $util.base64.encode(message.oldPassword, 0, message.oldPassword.length) : options.bytes === Array ? Array.prototype.slice.call(message.oldPassword) : message.oldPassword;
                if (message.oldE2eePd != null && message.hasOwnProperty("oldE2eePd"))
                    object.oldE2eePd = message.oldE2eePd;
                if (message.newPassword != null && message.hasOwnProperty("newPassword"))
                    object.newPassword = options.bytes === String ? $util.base64.encode(message.newPassword, 0, message.newPassword.length) : options.bytes === Array ? Array.prototype.slice.call(message.newPassword) : message.newPassword;
                if (message.newE2eePd != null && message.hasOwnProperty("newE2eePd"))
                    object.newE2eePd = message.newE2eePd;
                if (message.resetMail != null && message.hasOwnProperty("resetMail"))
                    object.resetMail = message.resetMail;
                if (message.etoeePassword != null && message.hasOwnProperty("etoeePassword"))
                    object.etoeePassword = message.etoeePassword;
                if (message.etoeePasswordcipher != null && message.hasOwnProperty("etoeePasswordcipher"))
                    object.etoeePasswordcipher = message.etoeePasswordcipher;
                return object;
            };

            /**
             * Converts this PasswordMotify to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.PasswordMotify
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PasswordMotify.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return PasswordMotify;
        })();

        Protobuf.E2eeResponse = (function() {

            /**
             * Properties of a E2eeResponse.
             * @memberof TCBReceiptApi.Protobuf
             * @interface IE2eeResponse
             * @property {string|null} [serverTime] E2eeResponse serverTime
             * @property {string|null} [pubKey] E2eeResponse pubKey
             */

            /**
             * Constructs a new E2eeResponse.
             * @memberof TCBReceiptApi.Protobuf
             * @classdesc Represents a E2eeResponse.
             * @implements IE2eeResponse
             * @constructor
             * @param {TCBReceiptApi.Protobuf.IE2eeResponse=} [properties] Properties to set
             */
            function E2eeResponse(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * E2eeResponse serverTime.
             * @member {string} serverTime
             * @memberof TCBReceiptApi.Protobuf.E2eeResponse
             * @instance
             */
            E2eeResponse.prototype.serverTime = "";

            /**
             * E2eeResponse pubKey.
             * @member {string} pubKey
             * @memberof TCBReceiptApi.Protobuf.E2eeResponse
             * @instance
             */
            E2eeResponse.prototype.pubKey = "";

            /**
             * Creates a new E2eeResponse instance using the specified properties.
             * @function create
             * @memberof TCBReceiptApi.Protobuf.E2eeResponse
             * @static
             * @param {TCBReceiptApi.Protobuf.IE2eeResponse=} [properties] Properties to set
             * @returns {TCBReceiptApi.Protobuf.E2eeResponse} E2eeResponse instance
             */
            E2eeResponse.create = function create(properties) {
                return new E2eeResponse(properties);
            };

            /**
             * Encodes the specified E2eeResponse message. Does not implicitly {@link TCBReceiptApi.Protobuf.E2eeResponse.verify|verify} messages.
             * @function encode
             * @memberof TCBReceiptApi.Protobuf.E2eeResponse
             * @static
             * @param {TCBReceiptApi.Protobuf.IE2eeResponse} message E2eeResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            E2eeResponse.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.serverTime != null && Object.hasOwnProperty.call(message, "serverTime"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.serverTime);
                if (message.pubKey != null && Object.hasOwnProperty.call(message, "pubKey"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.pubKey);
                return writer;
            };

            /**
             * Encodes the specified E2eeResponse message, length delimited. Does not implicitly {@link TCBReceiptApi.Protobuf.E2eeResponse.verify|verify} messages.
             * @function encodeDelimited
             * @memberof TCBReceiptApi.Protobuf.E2eeResponse
             * @static
             * @param {TCBReceiptApi.Protobuf.IE2eeResponse} message E2eeResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            E2eeResponse.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a E2eeResponse message from the specified reader or buffer.
             * @function decode
             * @memberof TCBReceiptApi.Protobuf.E2eeResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {TCBReceiptApi.Protobuf.E2eeResponse} E2eeResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            E2eeResponse.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TCBReceiptApi.Protobuf.E2eeResponse();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.serverTime = reader.string();
                        break;
                    case 2:
                        message.pubKey = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a E2eeResponse message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof TCBReceiptApi.Protobuf.E2eeResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {TCBReceiptApi.Protobuf.E2eeResponse} E2eeResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            E2eeResponse.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a E2eeResponse message.
             * @function verify
             * @memberof TCBReceiptApi.Protobuf.E2eeResponse
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            E2eeResponse.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.serverTime != null && message.hasOwnProperty("serverTime"))
                    if (!$util.isString(message.serverTime))
                        return "serverTime: string expected";
                if (message.pubKey != null && message.hasOwnProperty("pubKey"))
                    if (!$util.isString(message.pubKey))
                        return "pubKey: string expected";
                return null;
            };

            /**
             * Creates a E2eeResponse message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof TCBReceiptApi.Protobuf.E2eeResponse
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {TCBReceiptApi.Protobuf.E2eeResponse} E2eeResponse
             */
            E2eeResponse.fromObject = function fromObject(object) {
                if (object instanceof $root.TCBReceiptApi.Protobuf.E2eeResponse)
                    return object;
                var message = new $root.TCBReceiptApi.Protobuf.E2eeResponse();
                if (object.serverTime != null)
                    message.serverTime = String(object.serverTime);
                if (object.pubKey != null)
                    message.pubKey = String(object.pubKey);
                return message;
            };

            /**
             * Creates a plain object from a E2eeResponse message. Also converts values to other types if specified.
             * @function toObject
             * @memberof TCBReceiptApi.Protobuf.E2eeResponse
             * @static
             * @param {TCBReceiptApi.Protobuf.E2eeResponse} message E2eeResponse
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            E2eeResponse.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.serverTime = "";
                    object.pubKey = "";
                }
                if (message.serverTime != null && message.hasOwnProperty("serverTime"))
                    object.serverTime = message.serverTime;
                if (message.pubKey != null && message.hasOwnProperty("pubKey"))
                    object.pubKey = message.pubKey;
                return object;
            };

            /**
             * Converts this E2eeResponse to JSON.
             * @function toJSON
             * @memberof TCBReceiptApi.Protobuf.E2eeResponse
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            E2eeResponse.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return E2eeResponse;
        })();

        return Protobuf;
    })();

    return TCBReceiptApi;
})();

module.exports = $root;
